(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'css-typed-om'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('css-typed-om'));
  else {
    if (typeof CSSTypedOMPolyfill === 'undefined') {
      throw new Error("Error loading module 'falling_balls_with_web'. Its dependency 'css-typed-om' was not found. Please, check whether 'css-typed-om' is loaded prior to 'falling_balls_with_web'.");
    }root.falling_balls_with_web = factory(typeof falling_balls_with_web === 'undefined' ? {} : falling_balls_with_web, CSSTypedOMPolyfill);
  }
}(this, function (_, CSSTypedOMPolyfill) {
  'use strict';
  ListIteratorImpl.prototype = Object.create(IteratorImpl.prototype);
  ListIteratorImpl.prototype.constructor = ListIteratorImpl;
  AbstractList.prototype = Object.create(AbstractCollection.prototype);
  AbstractList.prototype.constructor = AbstractList;
  AbstractSet.prototype = Object.create(AbstractCollection.prototype);
  AbstractSet.prototype.constructor = AbstractSet;
  SequenceBuilderIterator.prototype = Object.create(SequenceScope.prototype);
  SequenceBuilderIterator.prototype.constructor = SequenceBuilderIterator;
  CoroutineSingletons.prototype = Object.create(Enum.prototype);
  CoroutineSingletons.prototype.constructor = CoroutineSingletons;
  Default.prototype = Object.create(Random.prototype);
  Default.prototype.constructor = Default;
  XorWowRandom.prototype = Object.create(Random.prototype);
  XorWowRandom.prototype.constructor = XorWowRandom;
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  ListIteratorImpl_0.prototype = Object.create(IteratorImpl_0.prototype);
  ListIteratorImpl_0.prototype.constructor = ListIteratorImpl_0;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  SubList.prototype = Object.create(AbstractMutableList.prototype);
  SubList.prototype.constructor = SubList;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  AbstractEntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  AbstractEntrySet.prototype.constructor = AbstractEntrySet;
  _no_name_provided__7.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__7.prototype.constructor = _no_name_provided__7;
  _no_name_provided__8.prototype = Object.create(AbstractMutableCollection.prototype);
  _no_name_provided__8.prototype.constructor = _no_name_provided__8;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  EntrySet.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  ChainEntry.prototype = Object.create(SimpleEntry.prototype);
  ChainEntry.prototype.constructor = ChainEntry;
  EntrySet_0.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet_0.prototype.constructor = EntrySet_0;
  LinkedHashMap.prototype = Object.create(HashMap.prototype);
  LinkedHashMap.prototype.constructor = LinkedHashMap;
  LinkedHashSet.prototype = Object.create(HashSet.prototype);
  LinkedHashSet.prototype.constructor = LinkedHashSet;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  DurationUnit.prototype = Object.create(Enum.prototype);
  DurationUnit.prototype.constructor = DurationUnit;
  _no_name_provided__33.prototype = Object.create(IntIterator.prototype);
  _no_name_provided__33.prototype.constructor = _no_name_provided__33;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  _no_name_provided__1_0.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__1_0.prototype.constructor = _no_name_provided__1_0;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  Error_0.prototype = Object.create(Error.prototype);
  Error_0.prototype.constructor = Error_0;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  ConcurrentModificationException.prototype = Object.create(RuntimeException.prototype);
  ConcurrentModificationException.prototype.constructor = ConcurrentModificationException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  ArithmeticException.prototype = Object.create(RuntimeException.prototype);
  ArithmeticException.prototype.constructor = ArithmeticException;
  AssertionError.prototype = Object.create(Error_0.prototype);
  AssertionError.prototype.constructor = AssertionError;
  NumberFormatException.prototype = Object.create(IllegalArgumentException.prototype);
  NumberFormatException.prototype.constructor = NumberFormatException;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  NoWhenBranchMatchedException.prototype = Object.create(RuntimeException.prototype);
  NoWhenBranchMatchedException.prototype.constructor = NoWhenBranchMatchedException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  None.prototype = Object.create(TraceBase.prototype);
  None.prototype.constructor = None;
  AbstractCoroutine.prototype = Object.create(JobSupport.prototype);
  AbstractCoroutine.prototype.constructor = AbstractCoroutine;
  StandaloneCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  StandaloneCoroutine.prototype.constructor = StandaloneCoroutine;
  LazyStandaloneCoroutine.prototype = Object.create(StandaloneCoroutine.prototype);
  LazyStandaloneCoroutine.prototype.constructor = LazyStandaloneCoroutine;
  ScopeCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  ScopeCoroutine.prototype.constructor = ScopeCoroutine;
  DispatchedCoroutine.prototype = Object.create(ScopeCoroutine.prototype);
  DispatchedCoroutine.prototype.constructor = DispatchedCoroutine;
  DispatchedTask.prototype = Object.create(SchedulerTask.prototype);
  DispatchedTask.prototype.constructor = DispatchedTask;
  CancellableContinuationImpl.prototype = Object.create(DispatchedTask.prototype);
  CancellableContinuationImpl.prototype.constructor = CancellableContinuationImpl;
  CancelHandler.prototype = Object.create(CancelHandlerBase.prototype);
  CancelHandler.prototype.constructor = CancelHandler;
  BeforeResumeCancelHandler.prototype = Object.create(CancelHandler.prototype);
  BeforeResumeCancelHandler.prototype.constructor = BeforeResumeCancelHandler;
  InvokeOnCancel.prototype = Object.create(CancelHandler.prototype);
  InvokeOnCancel.prototype.constructor = InvokeOnCancel;
  CancelledContinuation.prototype = Object.create(CompletedExceptionally.prototype);
  CancelledContinuation.prototype.constructor = CancelledContinuation;
  Key_1.prototype = Object.create(AbstractCoroutineContextKey.prototype);
  Key_1.prototype.constructor = Key_1;
  CoroutineDispatcher.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  CoroutineDispatcher.prototype.constructor = CoroutineDispatcher;
  CoroutineStart.prototype = Object.create(Enum.prototype);
  CoroutineStart.prototype.constructor = CoroutineStart;
  EventLoop.prototype = Object.create(CoroutineDispatcher.prototype);
  EventLoop.prototype.constructor = EventLoop;
  CompletionHandlerException.prototype = Object.create(RuntimeException.prototype);
  CompletionHandlerException.prototype.constructor = CompletionHandlerException;
  CoroutinesInternalError.prototype = Object.create(Error_0.prototype);
  CoroutinesInternalError.prototype.constructor = CoroutinesInternalError;
  LinkedListHead.prototype = Object.create(LinkedListNode.prototype);
  LinkedListHead.prototype.constructor = LinkedListHead;
  NodeList_0.prototype = Object.create(LinkedListHead.prototype);
  NodeList_0.prototype.constructor = NodeList_0;
  CompletionHandlerBase.prototype = Object.create(LinkedListNode.prototype);
  CompletionHandlerBase.prototype.constructor = CompletionHandlerBase;
  JobNode.prototype = Object.create(CompletionHandlerBase.prototype);
  JobNode.prototype.constructor = JobNode;
  ChildCompletion.prototype = Object.create(JobNode.prototype);
  ChildCompletion.prototype.constructor = ChildCompletion;
  _no_name_provided__36.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__36.prototype.constructor = _no_name_provided__36;
  JobCancellingNode.prototype = Object.create(JobNode.prototype);
  JobCancellingNode.prototype.constructor = JobCancellingNode;
  ChildHandleNode.prototype = Object.create(JobCancellingNode.prototype);
  ChildHandleNode.prototype.constructor = ChildHandleNode;
  InvokeOnCancelling.prototype = Object.create(JobCancellingNode.prototype);
  InvokeOnCancelling.prototype.constructor = InvokeOnCancelling;
  InvokeOnCompletion.prototype = Object.create(JobNode.prototype);
  InvokeOnCompletion.prototype.constructor = InvokeOnCompletion;
  ChildContinuation.prototype = Object.create(JobCancellingNode.prototype);
  ChildContinuation.prototype.constructor = ChildContinuation;
  JobImpl.prototype = Object.create(JobSupport.prototype);
  JobImpl.prototype.constructor = JobImpl;
  MainCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  MainCoroutineDispatcher.prototype.constructor = MainCoroutineDispatcher;
  SupervisorJobImpl.prototype = Object.create(JobImpl.prototype);
  SupervisorJobImpl.prototype.constructor = SupervisorJobImpl;
  CancellationException.prototype = Object.create(IllegalStateException.prototype);
  CancellationException.prototype.constructor = CancellationException;
  TimeoutCancellationException.prototype = Object.create(CancellationException.prototype);
  TimeoutCancellationException.prototype.constructor = TimeoutCancellationException;
  Unconfined.prototype = Object.create(CoroutineDispatcher.prototype);
  Unconfined.prototype.constructor = Unconfined;
  StateFlowImpl.prototype = Object.create(AbstractSharedFlow.prototype);
  StateFlowImpl.prototype.constructor = StateFlowImpl;
  DispatchedContinuation.prototype = Object.create(DispatchedTask.prototype);
  DispatchedContinuation.prototype.constructor = DispatchedContinuation;
  UndispatchedCoroutine.prototype = Object.create(ScopeCoroutine.prototype);
  UndispatchedCoroutine.prototype.constructor = UndispatchedCoroutine;
  JsMainDispatcher.prototype = Object.create(MainCoroutineDispatcher.prototype);
  JsMainDispatcher.prototype.constructor = JsMainDispatcher;
  UnconfinedEventLoop.prototype = Object.create(EventLoop.prototype);
  UnconfinedEventLoop.prototype.constructor = UnconfinedEventLoop;
  JobCancellationException.prototype = Object.create(CancellationException.prototype);
  JobCancellationException.prototype.constructor = JobCancellationException;
  SetTimeoutBasedDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  SetTimeoutBasedDispatcher.prototype.constructor = SetTimeoutBasedDispatcher;
  NodeDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  NodeDispatcher.prototype.constructor = NodeDispatcher;
  SetTimeoutDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  SetTimeoutDispatcher.prototype.constructor = SetTimeoutDispatcher;
  MessageQueue.prototype = Object.create(ArrayQueue.prototype);
  MessageQueue.prototype.constructor = MessageQueue;
  ScheduledMessageQueue.prototype = Object.create(MessageQueue.prototype);
  ScheduledMessageQueue.prototype.constructor = ScheduledMessageQueue;
  WindowDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  WindowDispatcher.prototype.constructor = WindowDispatcher;
  WindowMessageQueue.prototype = Object.create(MessageQueue.prototype);
  WindowMessageQueue.prototype.constructor = WindowMessageQueue;
  AbstractPersistentList.prototype = Object.create(AbstractList.prototype);
  AbstractPersistentList.prototype.constructor = AbstractPersistentList;
  BufferIterator.prototype = Object.create(AbstractListIterator.prototype);
  BufferIterator.prototype.constructor = BufferIterator;
  PersistentVector.prototype = Object.create(AbstractPersistentList.prototype);
  PersistentVector.prototype.constructor = PersistentVector;
  PersistentVectorIterator.prototype = Object.create(AbstractListIterator.prototype);
  PersistentVectorIterator.prototype.constructor = PersistentVectorIterator;
  SmallPersistentVector.prototype = Object.create(AbstractPersistentList.prototype);
  SmallPersistentVector.prototype.constructor = SmallPersistentVector;
  TrieIterator.prototype = Object.create(AbstractListIterator.prototype);
  TrieIterator.prototype.constructor = TrieIterator;
  PersistentHashMap.prototype = Object.create(AbstractMap.prototype);
  PersistentHashMap.prototype.constructor = PersistentHashMap;
  PersistentHashMapEntriesIterator.prototype = Object.create(PersistentHashMapBaseIterator.prototype);
  PersistentHashMapEntriesIterator.prototype.constructor = PersistentHashMapEntriesIterator;
  TrieNodeEntriesIterator.prototype = Object.create(TrieNodeBaseIterator.prototype);
  TrieNodeEntriesIterator.prototype.constructor = TrieNodeEntriesIterator;
  PersistentHashMapEntries.prototype = Object.create(AbstractSet.prototype);
  PersistentHashMapEntries.prototype.constructor = PersistentHashMapEntries;
  PersistentOrderedSet.prototype = Object.create(AbstractSet.prototype);
  PersistentOrderedSet.prototype.constructor = PersistentOrderedSet;
  InvalidationResult.prototype = Object.create(Enum.prototype);
  InvalidationResult.prototype.constructor = InvalidationResult;
  ProvidableCompositionLocal.prototype = Object.create(CompositionLocal.prototype);
  ProvidableCompositionLocal.prototype.constructor = ProvidableCompositionLocal;
  StaticProvidableCompositionLocal.prototype = Object.create(ProvidableCompositionLocal.prototype);
  StaticProvidableCompositionLocal.prototype.constructor = StaticProvidableCompositionLocal;
  _no_name_provided__72.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__72.prototype.constructor = _no_name_provided__72;
  State.prototype = Object.create(Enum.prototype);
  State.prototype.constructor = State;
  _no_name_provided__75.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__75.prototype.constructor = _no_name_provided__75;
  _no_name_provided__76.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__76.prototype.constructor = _no_name_provided__76;
  $awaitWorkAvailableCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitWorkAvailableCOROUTINE$1.prototype.constructor = $awaitWorkAvailableCOROUTINE$1;
  Recomposer.prototype = Object.create(CompositionContext.prototype);
  Recomposer.prototype.constructor = Recomposer;
  StateStateRecord.prototype = Object.create(StateRecord.prototype);
  StateStateRecord.prototype.constructor = StateStateRecord;
  MutableSnapshot.prototype = Object.create(Snapshot.prototype);
  MutableSnapshot.prototype.constructor = MutableSnapshot;
  Success.prototype = Object.create(SnapshotApplyResult.prototype);
  Success.prototype.constructor = Success;
  Failure_0.prototype = Object.create(SnapshotApplyResult.prototype);
  Failure_0.prototype.constructor = Failure_0;
  GlobalSnapshot.prototype = Object.create(MutableSnapshot.prototype);
  GlobalSnapshot.prototype.constructor = GlobalSnapshot;
  TransparentObserverMutableSnapshot.prototype = Object.create(MutableSnapshot.prototype);
  TransparentObserverMutableSnapshot.prototype.constructor = TransparentObserverMutableSnapshot;
  NestedMutableSnapshot.prototype = Object.create(MutableSnapshot.prototype);
  NestedMutableSnapshot.prototype.constructor = NestedMutableSnapshot;
  _no_name_provided__90.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__90.prototype.constructor = _no_name_provided__90;
  StateListStateRecord.prototype = Object.create(StateRecord.prototype);
  StateListStateRecord.prototype.constructor = StateListStateRecord;
  $withFrameNanosCOROUTINE$4.prototype = Object.create(CoroutineImpl_0.prototype);
  $withFrameNanosCOROUTINE$4.prototype.constructor = $withFrameNanosCOROUTINE$4;
  Companion_18.prototype = Object.create(Element_1.prototype);
  Companion_18.prototype.constructor = Companion_18;
  TextUnitType.prototype = Object.create(Enum.prototype);
  TextUnitType.prototype.constructor = TextUnitType;
  DomApplier.prototype = Object.create(AbstractApplier.prototype);
  DomApplier.prototype.constructor = DomApplier;
  _no_name_provided__127.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__127.prototype.constructor = _no_name_provided__127;
  _no_name_provided__131.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__131.prototype.constructor = _no_name_provided__131;
  AttrsBuilder.prototype = Object.create(EventsListenerBuilder.prototype);
  AttrsBuilder.prototype.constructor = AttrsBuilder;
  Range_0.prototype = Object.create(InputType.prototype);
  Range_0.prototype.constructor = Range_0;
  Text_0.prototype = Object.create(InputType.prototype);
  Text_0.prototype.constructor = Text_0;
  MouseEventListener.prototype = Object.create(WrappedEventListener.prototype);
  MouseEventListener.prototype.constructor = MouseEventListener;
  CSSRuleBuilderImpl.prototype = Object.create(StyleBuilderImpl.prototype);
  CSSRuleBuilderImpl.prototype.constructor = CSSRuleBuilderImpl;
  CSSBuilderImpl.prototype = Object.create(CSSRuleBuilderImpl.prototype);
  CSSBuilderImpl.prototype.constructor = CSSBuilderImpl;
  Position.prototype = Object.create(Enum.prototype);
  Position.prototype.constructor = Position;
  LineStyle.prototype = Object.create(Enum.prototype);
  LineStyle.prototype.constructor = LineStyle;
  DisplayStyle.prototype = Object.create(Enum.prototype);
  DisplayStyle.prototype.constructor = DisplayStyle;
  FlexDirection.prototype = Object.create(Enum.prototype);
  FlexDirection.prototype.constructor = FlexDirection;
  JustifyContent.prototype = Object.create(Enum.prototype);
  JustifyContent.prototype.constructor = JustifyContent;
  AlignItems.prototype = Object.create(Enum.prototype);
  AlignItems.prototype.constructor = AlignItems;
  CSSStyleRuleDeclaration.prototype = Object.create(CSSRuleDeclaration.prototype);
  CSSStyleRuleDeclaration.prototype.constructor = CSSStyleRuleDeclaration;
  CSSGroupingRuleDeclaration.prototype = Object.create(CSSRuleDeclaration.prototype);
  CSSGroupingRuleDeclaration.prototype.constructor = CSSGroupingRuleDeclaration;
  RGB.prototype = Object.create(Color_0.prototype);
  RGB.prototype.constructor = RGB;
  CSSClass.prototype = Object.create(CSSSelector.prototype);
  CSSClass.prototype.constructor = CSSClass;
  ElementScopeImpl.prototype = Object.create(ElementScopeBase.prototype);
  ElementScopeImpl.prototype.constructor = ElementScopeImpl;
  Styles.prototype = Object.create(StyleSheet_0.prototype);
  Styles.prototype.constructor = Styles;
  _no_name_provided__255.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__255.prototype.constructor = _no_name_provided__255;
  JsGame.prototype = Object.create(Game.prototype);
  JsGame.prototype.constructor = JsGame;
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last = _this_.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (inductionVariable <= last);
    } else {
      var inductionVariable_0 = 0;
      var last_0 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, _this_[index_0])) {
            return index_0;
          }}
         while (inductionVariable_0 <= last_0);
    }
    return -1;
  }
  function lastIndexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = _this_.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (0 <= inductionVariable);
    } else {
      var inductionVariable_0 = _this_.length - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          if (equals(element, _this_[index_0])) {
            return index_0;
          }}
         while (0 <= inductionVariable_0);
    }
    return -1;
  }
  function _get_lastIndex_(_this_) {
    return _this_.length - 1 | 0;
  }
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function contains(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$break: while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function filterNotNull(_this_) {
    return filterNotNullTo(_this_, ArrayList_init_$Create$());
  }
  function filterNotNullTo(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (!(element == null)) {
        destination.add_37(element);
        Unit_getInstance();
      }}
    return destination;
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(_this_);
  }
  function firstOrNull(_this_) {
    return _this_.isEmpty_40() ? null : _this_.get_66(0);
  }
  function toIntArray(_this_) {
    var result = new Int32Array(_this_._get_size__45());
    var index = 0;
    var tmp0_iterator = _this_.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_28();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function firstOrNull_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List)) {
      if (_this_.isEmpty_40())
        return null;
      else
        return _this_.get_66(0);
    } else {
      {
        var iterator_0 = _this_.iterator_46();
        if (!iterator_0.hasNext_27())
          return null;
        return iterator_0.next_28();
      }
    }
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var tmp0_iterator = _this_.iterator_46();
    $l$break: while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_28();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function plus(_this_, element) {
    var result = ArrayList_init_$Create$_0(_this_._get_size__45() + 1 | 0);
    result.addAll_10(_this_);
    Unit_getInstance();
    result.add_37(element);
    Unit_getInstance();
    return result;
  }
  function until(_this_, to_0) {
    if (to_0 <= IntCompanionObject_getInstance()._MIN_VALUE)
      return Companion_getInstance_4()._EMPTY;
    return numberRangeToNumber(_this_, to_0 - 1 | 0);
  }
  function step(_this_, step_0) {
    checkStepIsPositive(step_0 > 0, step_0);
    return Companion_getInstance_3().fromClosedRange(_this_._first_0, _this_._last, _this_._step_0 > 0 ? step_0 : -step_0 | 0);
  }
  function coerceAtLeast(_this_, minimumValue) {
    return _this_.compareTo_44(minimumValue) < 0 ? minimumValue : _this_;
  }
  function coerceAtLeast_0(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function random(_this_, random_1) {
    try {
      return nextInt(random_1, _this_);
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        throw NoSuchElementException_init_$Create$_0($p.message);
      } else {
        {
          throw $p;
        }
      }
    }
  }
  function coerceAtMost(_this_, maximumValue) {
    return _this_ > maximumValue ? maximumValue : _this_;
  }
  function _no_name_provided_(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided_.prototype.invoke_8 = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided_.prototype.invoke_468 = function (p1) {
    return this.invoke_8((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_37 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (equals(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_28 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (!this.contains_37(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_40 = function () {
    return this._get_size__45() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory(this$0) {
    var i = new _no_name_provided_(this$0);
    return function (p1) {
      return i.invoke_8(p1);
    };
  }
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index = 0;
  }
  IteratorImpl.prototype._set_index__8 = function (_set___) {
    this._index = _set___;
  };
  IteratorImpl.prototype._get_index__8 = function () {
    return this._index;
  };
  IteratorImpl.prototype.hasNext_27 = function () {
    return this._index < this._$this._get_size__45();
  };
  IteratorImpl.prototype.next_28 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._index;
    tmp0_this._index = tmp1 + 1 | 0;
    return this._$this.get_66(tmp1);
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [Iterator]
  };
  function ListIteratorImpl($outer, index) {
    this._$this_0 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_getInstance().checkPositionIndex_0(index, this._$this_0._get_size__45());
    this._set_index__8(index);
  }
  ListIteratorImpl.prototype.hasPrevious_8 = function () {
    return this._get_index__8() > 0;
  };
  ListIteratorImpl.prototype.nextIndex_7 = function () {
    return this._get_index__8();
  };
  ListIteratorImpl.prototype.previous_7 = function () {
    if (!this.hasPrevious_8())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    tmp0_this._set_index__8(tmp0_this._get_index__8() - 1 | 0);
    return this._$this_0.get_66(tmp0_this._get_index__8());
  };
  ListIteratorImpl.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [ListIterator]
  };
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex_0 = function (index, size_1) {
    if (index < 0 ? true : index >= size_1) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size_1);
    }};
  Companion_0.prototype.checkPositionIndex_0 = function (index, size_1) {
    if (index < 0 ? true : index > size_1) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size_1);
    }};
  Companion_0.prototype.checkRangeIndexes = function (fromIndex, toIndex, size_1) {
    if (fromIndex < 0 ? true : toIndex > size_1) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size_1);
    }if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }};
  Companion_0.prototype.orderedHashCode = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var e = tmp0_iterator.next_28();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals = function (c, other) {
    if (!(c._get_size__45() === other._get_size__45()))
      return false;
    var otherIterator = other.iterator_46();
    var tmp0_iterator = c.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var elem = tmp0_iterator.next_28();
      var elemOther = otherIterator.next_28();
      if (!equals(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function AbstractList() {
    Companion_getInstance();
    AbstractCollection.call(this);
  }
  AbstractList.prototype.iterator_46 = function () {
    return new IteratorImpl(this);
  };
  AbstractList.prototype.indexOf_5 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var index_1 = 0;
      var tmp0_iterator_2 = this.iterator_46();
      while (tmp0_iterator_2.hasNext_27()) {
        var item_3 = tmp0_iterator_2.next_28();
        if (equals(item_3, element)) {
          tmp$ret$0 = index_1;
          break l$ret$1;
        } else {
        }
        var tmp1_4 = index_1;
        index_1 = tmp1_4 + 1 | 0;
        Unit_getInstance();
      }
      tmp$ret$0 = -1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractList.prototype.lastIndexOf_9 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var iterator_1 = this.listIterator_12(this._get_size__45());
      while (iterator_1.hasPrevious_8()) {
        var tmp0__anonymous__2 = iterator_1.previous_7();
        if (equals(tmp0__anonymous__2, element)) {
          tmp$ret$0 = iterator_1.nextIndex_7();
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = -1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractList.prototype.listIterator_12 = function (index) {
    return new ListIteratorImpl(this, index);
  };
  AbstractList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractList.$metadata$ = {
    simpleName: 'AbstractList',
    kind: 'class',
    interfaces: [List]
  };
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key_0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__5();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (equals(element_2._get_key__28(), key_0)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__28();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__13();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString = function (e) {
    return '' + e._get_key__28() + '=' + e._get_value__13();
  };
  Companion_1.prototype.entryEquals = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals(e._get_key__28(), other._get_key__28()) ? equals(e._get_value__13(), other._get_value__13()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__0(this$0) {
    this._this$0_0 = this$0;
  }
  _no_name_provided__0.prototype.invoke_2 = function (it) {
    return this._this$0_0.toString_0(it);
  };
  _no_name_provided__0.prototype.invoke_468 = function (p1) {
    return this.invoke_2((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMap() {
    Companion_getInstance_0();
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_7 = function (key_0) {
    return !(implFindEntry(this, key_0) == null);
  };
  AbstractMap.prototype.containsValue_2 = function (value_0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._get_entries__5();
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (equals(element_2._get_value__13(), value_0)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.containsEntry_6 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key_0 = entry._get_key__28();
    var value_0 = entry._get_value__13();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_48(key_0);
    if (!equals(value_0, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_7(key_0);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__45() === other._get_size__45()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__5();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (!this.containsEntry_6(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_48 = function (key_0) {
    var tmp0_safe_receiver = implFindEntry(this, key_0);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__13();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__5());
  };
  AbstractMap.prototype.isEmpty_40 = function () {
    return this._get_size__45() === 0;
  };
  AbstractMap.prototype._get_size__45 = function () {
    return this._get_entries__5()._get_size__45();
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__5();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_0(this), 24, null);
  };
  AbstractMap.prototype.toString_0 = function (entry) {
    return toString(this, entry._get_key__28()) + '=' + toString(this, entry._get_value__13());
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_0(this$0) {
    var i = new _no_name_provided__0(this$0);
    return function (p1) {
      return i.invoke_2(p1);
    };
  }
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_28();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals = function (c, other) {
    if (!(c._get_size__45() === other._get_size__45()))
      return false;
    return c.containsAll_28(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function AbstractSet() {
    Companion_getInstance_1();
    AbstractCollection.call(this);
  }
  AbstractSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractSet.$metadata$ = {
    simpleName: 'AbstractSet',
    kind: 'class',
    interfaces: [Set]
  };
  function emptyList() {
    return EmptyList_getInstance();
  }
  function _get_lastIndex__0(_this_) {
    return _this_._get_size__45() - 1 | 0;
  }
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_40();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__45 = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_40 = function () {
    return true;
  };
  EmptyList.prototype.contains_7 = function (element) {
    return false;
  };
  EmptyList.prototype.contains_37 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_7(tmp);
  };
  EmptyList.prototype.containsAll_6 = function (elements) {
    return elements.isEmpty_40();
  };
  EmptyList.prototype.containsAll_28 = function (elements) {
    return this.containsAll_6(elements);
  };
  EmptyList.prototype.get_66 = function (index) {
    throw IndexOutOfBoundsException_init_$Create$('' + "Empty list doesn't contain element at index " + index + '.');
  };
  EmptyList.prototype.iterator_46 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.prototype.listIterator_12 = function (index) {
    if (!(index === 0))
      throw IndexOutOfBoundsException_init_$Create$('' + 'Index: ' + index);
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_27 = function () {
    return false;
  };
  EmptyIterator.prototype.hasPrevious_8 = function () {
    return false;
  };
  EmptyIterator.prototype.nextIndex_7 = function () {
    return 0;
  };
  EmptyIterator.prototype.next_28 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.prototype.previous_7 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function mutableListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$('Index overflow has happened.');
  }
  function ArrayAsCollection(values, isVarargs) {
    this._values = values;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__45 = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_40 = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_36 = function (element) {
    return contains(this._values, element);
  };
  ArrayAsCollection.prototype.contains_37 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_36((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayAsCollection.prototype.containsAll_27 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (!this.contains_36(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_28 = function (elements) {
    return this.containsAll_27(elements);
  };
  ArrayAsCollection.prototype.iterator_46 = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function listOfNotNull(elements) {
    return filterNotNull(elements);
  }
  function collectionSizeOrDefault(_this_, default_0) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__45();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this._serialVersionUID_0 = new Long(-888910638, 1920087921);
  }
  EmptyMap.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Map_0) : false) {
      tmp = other.isEmpty_40();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyMap.prototype.hashCode = function () {
    return 0;
  };
  EmptyMap.prototype.toString = function () {
    return '{}';
  };
  EmptyMap.prototype._get_size__45 = function () {
    return 0;
  };
  EmptyMap.prototype.isEmpty_40 = function () {
    return true;
  };
  EmptyMap.prototype.containsKey_0 = function (key_0) {
    return false;
  };
  EmptyMap.prototype.containsKey_7 = function (key_0) {
    if (!(key_0 == null ? true : isObject(key_0)))
      return false;
    else {
    }
    return this.containsKey_0((key_0 == null ? true : isObject(key_0)) ? key_0 : THROW_CCE());
  };
  EmptyMap.prototype.get_3 = function (key_0) {
    return null;
  };
  EmptyMap.prototype.get_48 = function (key_0) {
    if (!(key_0 == null ? true : isObject(key_0)))
      return null;
    else {
    }
    return this.get_3((key_0 == null ? true : isObject(key_0)) ? key_0 : THROW_CCE());
  };
  EmptyMap.prototype._get_entries__5 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.$metadata$ = {
    simpleName: 'EmptyMap',
    kind: 'object',
    interfaces: [Map_0, Serializable]
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function removeAll(_this_, predicate) {
    return filterInPlace(_this_, predicate, true);
  }
  function filterInPlace(_this_, predicate, predicateResultToRemove) {
    var result = false;
    var tmp0_with_0 = _this_.iterator_46();
    while (tmp0_with_0.hasNext_27())
      if (predicate(tmp0_with_0.next_28()) === predicateResultToRemove) {
        tmp0_with_0.remove_52();
        result = true;
      }return result;
  }
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function sequence(block) {
    return new _no_name_provided__1(block);
  }
  function SequenceScope() {
  }
  SequenceScope.$metadata$ = {
    simpleName: 'SequenceScope',
    kind: 'class',
    interfaces: []
  };
  function iterator(block) {
    var iterator_0 = new SequenceBuilderIterator();
    iterator_0._nextStep = createCoroutineUnintercepted(block, iterator_0, iterator_0);
    return iterator_0;
  }
  function nextNotReady($this) {
    if (!$this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    else
      return $this.next_28();
  }
  function exceptionalState($this) {
    var tmp0_subject = $this._state;
    switch (tmp0_subject) {
      case 4:
        return NoSuchElementException_init_$Create$();
      case 5:
        return IllegalStateException_init_$Create$('Iterator has failed.');
      default:return IllegalStateException_init_$Create$('' + 'Unexpected state of the iterator: ' + $this._state);
    }
  }
  function SequenceBuilderIterator() {
    SequenceScope.call(this);
    this._state = 0;
    this._nextValue = null;
    this._nextIterator = null;
    this._nextStep = null;
  }
  SequenceBuilderIterator.prototype.hasNext_27 = function () {
    while (true) {
      var tmp0_subject = this._state;
      switch (tmp0_subject) {
        case 0:
          break;
        case 1:
          if (ensureNotNull(this._nextIterator).hasNext_27()) {
            this._state = 2;
            return true;
          } else {
            this._nextIterator = null;
          }

          break;
        case 4:
          return false;
        case 3:
        case 2:
          return true;
        default:throw exceptionalState(this);
      }
      this._state = 5;
      var step_0 = ensureNotNull(this._nextStep);
      this._nextStep = null;
      var tmp1_resume_0 = Unit_getInstance();
      var tmp0_success_0 = Companion_getInstance_2();
      step_0.resumeWith_15(_Result___init__impl_(Unit_getInstance()));
    }
  };
  SequenceBuilderIterator.prototype.next_28 = function () {
    var tmp0_subject = this._state;
    switch (tmp0_subject) {
      case 0:
      case 1:
        return nextNotReady(this);
      case 2:
        this._state = 1;
        return ensureNotNull(this._nextIterator).next_28();
      case 3:
        this._state = 0;
        var tmp = this._nextValue;
        var result = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
        this._nextValue = null;
        return result;
      default:throw exceptionalState(this);
    }
  };
  SequenceBuilderIterator.prototype.yield_0 = function (value_0, $cont) {
    this._nextValue = value_0;
    this._state = 3;
    var tmp0__anonymous__1 = $cont;
    this._nextStep = tmp0__anonymous__1;
    return _get_COROUTINE_SUSPENDED_();
  };
  SequenceBuilderIterator.prototype.resumeWith_9 = function (result) {
    throwOnFailure(result);
    var tmp = _Result___get_value__impl_(result);
    if (tmp == null ? true : isObject(tmp))
      tmp;
    else
      THROW_CCE();
    this._state = 4;
  };
  SequenceBuilderIterator.prototype.resumeWith_15 = function (result) {
    return this.resumeWith_9(result);
  };
  SequenceBuilderIterator.prototype._get_context__22 = function () {
    return EmptyCoroutineContext_getInstance();
  };
  SequenceBuilderIterator.$metadata$ = {
    simpleName: 'SequenceBuilderIterator',
    kind: 'class',
    interfaces: [Iterator, Continuation]
  };
  function _no_name_provided__1($block) {
    this._$block = $block;
  }
  _no_name_provided__1.prototype.iterator_2_0 = function () {
    return iterator(this._$block);
  };
  _no_name_provided__1.prototype.iterator_46 = function () {
    return this.iterator_2_0();
  };
  _no_name_provided__1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function EmptySet() {
    EmptySet_instance = this;
    this._serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_40();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__45 = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_40 = function () {
    return true;
  };
  EmptySet.prototype.contains_7 = function (element) {
    return false;
  };
  EmptySet.prototype.contains_37 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_7(tmp);
  };
  EmptySet.prototype.containsAll_6 = function (elements) {
    return elements.isEmpty_40();
  };
  EmptySet.prototype.containsAll_28 = function (elements) {
    return this.containsAll_6(elements);
  };
  EmptySet.prototype.iterator_46 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function Continuation() {
  }
  Continuation.$metadata$ = {
    simpleName: 'Continuation',
    kind: 'interface',
    interfaces: []
  };
  function startCoroutine(_this_, receiver, completion) {
    var tmp0_resume_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
    var tmp1_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_2();
    tmp0_resume_0.resumeWith_15(_Result___init__impl_(Unit_getInstance()));
  }
  function Key() {
    Key_instance = this;
  }
  Key.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance;
  function Key_getInstance() {
    if (Key_instance == null)
      new Key();
    return Key_instance;
  }
  function ContinuationInterceptor() {
  }
  ContinuationInterceptor.prototype.releaseInterceptedContinuation_9 = function (continuation) {
  };
  ContinuationInterceptor.prototype.get_56 = function (key_0) {
    if (key_0 instanceof AbstractCoroutineContextKey) {
      var tmp;
      if (key_0.isSubKey_0(this._get_key__28())) {
        var tmp_0 = key_0.tryCast_0(this);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element_0) : false) ? tmp_0 : null;
      } else {
        tmp = null;
      }
      return tmp;
    } else {
    }
    var tmp_1;
    if (Key_getInstance() === key_0) {
      tmp_1 = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  ContinuationInterceptor.prototype.minusKey_25 = function (key_0) {
    if (key_0 instanceof AbstractCoroutineContextKey) {
      return (key_0.isSubKey_0(this._get_key__28()) ? !(key_0.tryCast_0(this) == null) : false) ? EmptyCoroutineContext_getInstance() : this;
    } else {
    }
    return Key_getInstance() === key_0 ? EmptyCoroutineContext_getInstance() : this;
  };
  ContinuationInterceptor.$metadata$ = {
    simpleName: 'ContinuationInterceptor',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function Key_0() {
  }
  Key_0.$metadata$ = {
    simpleName: 'Key',
    kind: 'interface',
    interfaces: []
  };
  function Element_0() {
  }
  Element_0.prototype.get_56 = function (key_0) {
    var tmp;
    if (equals(this._get_key__28(), key_0)) {
      tmp = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  Element_0.prototype.fold_24 = function (initial, operation) {
    return operation(initial, this);
  };
  Element_0.prototype.minusKey_25 = function (key_0) {
    return equals(this._get_key__28(), key_0) ? EmptyCoroutineContext_getInstance() : this;
  };
  Element_0.$metadata$ = {
    simpleName: 'Element',
    kind: 'interface',
    interfaces: [CoroutineContext]
  };
  function _no_name_provided__2() {
  }
  _no_name_provided__2.prototype.invoke_4 = function (acc, element) {
    var removed = acc.minusKey_25(element._get_key__28());
    var tmp;
    if (removed === EmptyCoroutineContext_getInstance()) {
      tmp = element;
    } else {
      var interceptor = removed.get_56(Key_getInstance());
      var tmp_0;
      if (interceptor == null) {
        tmp_0 = new CombinedContext(removed, element);
      } else {
        var left_1 = removed.minusKey_25(Key_getInstance());
        tmp_0 = left_1 === EmptyCoroutineContext_getInstance() ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left_1, element), interceptor);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  _no_name_provided__2.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineContext) : false) ? p1 : THROW_CCE();
    return this.invoke_4(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CoroutineContext() {
  }
  CoroutineContext.prototype.plus_25 = function (context) {
    var tmp;
    if (context === EmptyCoroutineContext_getInstance()) {
      tmp = this;
    } else {
      tmp = context.fold_24(this, _no_name_provided_$factory_1());
    }
    return tmp;
  };
  CoroutineContext.$metadata$ = {
    simpleName: 'CoroutineContext',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_1() {
    var i = new _no_name_provided__2();
    return function (p1, p2) {
      return i.invoke_4(p1, p2);
    };
  }
  function EmptyCoroutineContext() {
    EmptyCoroutineContext_instance = this;
    this._serialVersionUID_2 = new Long(0, 0);
  }
  EmptyCoroutineContext.prototype.get_56 = function (key_0) {
    return null;
  };
  EmptyCoroutineContext.prototype.fold_24 = function (initial, operation) {
    return initial;
  };
  EmptyCoroutineContext.prototype.plus_25 = function (context) {
    return context;
  };
  EmptyCoroutineContext.prototype.minusKey_25 = function (key_0) {
    return this;
  };
  EmptyCoroutineContext.prototype.hashCode = function () {
    return 0;
  };
  EmptyCoroutineContext.prototype.toString = function () {
    return 'EmptyCoroutineContext';
  };
  EmptyCoroutineContext.$metadata$ = {
    simpleName: 'EmptyCoroutineContext',
    kind: 'object',
    interfaces: [CoroutineContext, Serializable]
  };
  var EmptyCoroutineContext_instance;
  function EmptyCoroutineContext_getInstance() {
    if (EmptyCoroutineContext_instance == null)
      new EmptyCoroutineContext();
    return EmptyCoroutineContext_instance;
  }
  function size($this) {
    var cur = $this;
    var size_1 = 2;
    while (true) {
      var tmp = cur._left;
      var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return size_1;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      cur = tmp_0;
      var tmp1 = size_1;
      size_1 = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function contains_0($this, element) {
    return equals($this.get_56(element._get_key__28()), element);
  }
  function containsAll($this, context) {
    var cur = context;
    while (true) {
      if (!contains_0($this, cur._element))
        return false;
      var next = cur._left;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        {
          return contains_0($this, isInterface(next, Element_0) ? next : THROW_CCE());
        }
      }
    }
  }
  function _no_name_provided__3() {
  }
  _no_name_provided__3.prototype.invoke_6 = function (acc, element) {
    var tmp;
    if (charSequenceLength(acc) === 0) {
      tmp = toString_1(element);
    } else {
      {
        tmp = '' + acc + ', ' + element;
      }
    }
    return tmp;
  };
  _no_name_provided__3.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    return this.invoke_6(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CombinedContext(left_1, element) {
    this._left = left_1;
    this._element = element;
  }
  CombinedContext.prototype.get_56 = function (key_0) {
    var cur = this;
    while (true) {
      var tmp0_safe_receiver = cur._element.get_56(key_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
      var next = cur._left;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        {
          return next.get_56(key_0);
        }
      }
    }
  };
  CombinedContext.prototype.fold_24 = function (initial, operation) {
    return operation(this._left.fold_24(initial, operation), this._element);
  };
  CombinedContext.prototype.minusKey_25 = function (key_0) {
    var tmp0_safe_receiver = this._element.get_56(key_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return this._left;
    }
    Unit_getInstance();
    var newLeft = this._left.minusKey_25(key_0);
    return newLeft === this._left ? this : newLeft === EmptyCoroutineContext_getInstance() ? this._element : new CombinedContext(newLeft, this._element);
  };
  CombinedContext.prototype.equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof CombinedContext) {
        tmp_1 = size(other) === size(this);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = containsAll(other, this);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CombinedContext.prototype.hashCode = function () {
    return hashCode(this._left) + hashCode(this._element) | 0;
  };
  CombinedContext.prototype.toString = function () {
    return '[' + this.fold_24('', _no_name_provided_$factory_2()) + ']';
  };
  CombinedContext.$metadata$ = {
    simpleName: 'CombinedContext',
    kind: 'class',
    interfaces: [CoroutineContext, Serializable]
  };
  function AbstractCoroutineContextKey(baseKey, safeCast) {
    this._safeCast = safeCast;
    var tmp = this;
    var tmp_0;
    if (baseKey instanceof AbstractCoroutineContextKey) {
      tmp_0 = baseKey._topmostKey;
    } else {
      {
        tmp_0 = baseKey;
      }
    }
    tmp._topmostKey = tmp_0;
  }
  AbstractCoroutineContextKey.prototype.tryCast_0 = function (element) {
    return this._safeCast(element);
  };
  AbstractCoroutineContextKey.prototype.isSubKey_0 = function (key_0) {
    return key_0 === this ? true : this._topmostKey === key_0;
  };
  AbstractCoroutineContextKey.$metadata$ = {
    simpleName: 'AbstractCoroutineContextKey',
    kind: 'class',
    interfaces: [Key_0]
  };
  function AbstractCoroutineContextElement(key_0) {
    this._key = key_0;
  }
  AbstractCoroutineContextElement.prototype._get_key__28 = function () {
    return this._key;
  };
  AbstractCoroutineContextElement.$metadata$ = {
    simpleName: 'AbstractCoroutineContextElement',
    kind: 'class',
    interfaces: [Element_0]
  };
  function _no_name_provided_$factory_2() {
    var i = new _no_name_provided__3();
    return function (p1, p2) {
      return i.invoke_6(p1, p2);
    };
  }
  function _get_COROUTINE_SUSPENDED_() {
    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
  }
  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  var CoroutineSingletons_UNDECIDED_instance;
  var CoroutineSingletons_RESUMED_instance;
  var CoroutineSingletons_entriesInitialized;
  function CoroutineSingletons_initEntries() {
    if (CoroutineSingletons_entriesInitialized)
      return Unit_getInstance();
    CoroutineSingletons_entriesInitialized = true;
    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
  }
  function CoroutineSingletons(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineSingletons.$metadata$ = {
    simpleName: 'CoroutineSingletons',
    kind: 'class',
    interfaces: []
  };
  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  }
  function CoroutineSingletons_UNDECIDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_UNDECIDED_instance;
  }
  function CoroutineSingletons_RESUMED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_RESUMED_instance;
  }
  function ReadOnlyProperty() {
  }
  ReadOnlyProperty.$metadata$ = {
    simpleName: 'ReadOnlyProperty',
    kind: 'interface',
    interfaces: []
  };
  function Default() {
    Default_instance = this;
    Random.call(this);
    this._defaultRandom = defaultPlatformRandom();
  }
  Default.prototype.nextBits_1 = function (bitCount) {
    return this._defaultRandom.nextBits_1(bitCount);
  };
  Default.prototype.nextInt_7 = function () {
    return this._defaultRandom.nextInt_7();
  };
  Default.prototype.nextInt_4 = function (from, until_0) {
    return this._defaultRandom.nextInt_4(from, until_0);
  };
  Default.prototype.nextDouble_3 = function () {
    return this._defaultRandom.nextDouble_3();
  };
  Default.prototype.nextDouble_4 = function (from, until_0) {
    return this._defaultRandom.nextDouble_4(from, until_0);
  };
  Default.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  Random.prototype.nextInt_7 = function () {
    return this.nextBits_1(32);
  };
  Random.prototype.nextInt_4 = function (from, until_0) {
    checkRangeBounds(from, until_0);
    var n = until_0 - from | 0;
    if (n > 0 ? true : n === IntCompanionObject_getInstance()._MIN_VALUE) {
      var tmp;
      if ((n & (-n | 0)) === n) {
        var bitCount = fastLog2(n);
        tmp = this.nextBits_1(bitCount);
      } else {
        var v;
        do {
          var bits = this.nextInt_7() >>> 1;
          v = bits % n;
        }
         while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
        tmp = v;
      }
      var rnd = tmp;
      return from + rnd | 0;
    } else {
      while (true) {
        var rnd_0 = this.nextInt_7();
        if (from <= rnd_0 ? rnd_0 < until_0 : false)
          return rnd_0;
      }
    }
  };
  Random.prototype.nextDouble_3 = function () {
    return doubleFromParts(this.nextBits_1(26), this.nextBits_1(27));
  };
  Random.prototype.nextDouble_4 = function (from, until_0) {
    checkRangeBounds_0(from, until_0);
    var size_1 = until_0 - from;
    var tmp;
    if ((isInfinite(size_1) ? isFinite(from) : false) ? isFinite(until_0) : false) {
      var r1 = this.nextDouble_3() * (until_0 / 2 - from / 2);
      tmp = from + r1 + r1;
    } else {
      tmp = from + this.nextDouble_3() * size_1;
    }
    var r = tmp;
    return r >= until_0 ? nextDown(until_0) : r;
  };
  Random.$metadata$ = {
    simpleName: 'Random',
    kind: 'class',
    interfaces: []
  };
  function nextInt(_this_, range) {
    var tmp;
    if (range.isEmpty_40()) {
      throw IllegalArgumentException_init_$Create$('' + 'Cannot get random in empty range: ' + range);
    } else if (range._get_last__2() < IntCompanionObject_getInstance()._MAX_VALUE) {
      tmp = _this_.nextInt_4(range._get_first__0(), range._get_last__2() + 1 | 0);
    } else if (range._get_first__0() > IntCompanionObject_getInstance()._MIN_VALUE) {
      tmp = _this_.nextInt_4(range._get_first__0() - 1 | 0, range._get_last__2()) + 1 | 0;
    } else {
      tmp = _this_.nextInt_7();
    }
    return tmp;
  }
  function checkRangeBounds(from, until_0) {
    var tmp0_require_0 = until_0 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_0);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function fastLog2(value_0) {
    return 31 - Math.clz32(value_0) | 0;
  }
  function checkRangeBounds_0(from, until_0) {
    var tmp0_require_0 = until_0 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_0);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function boundsErrorMessage(from, until_0) {
    return '' + 'Random range is empty: [' + from + ', ' + until_0 + ').';
  }
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this_, bitCount) {
    return _this_ >>> (32 - bitCount | 0) & (-bitCount | 0) >> 31;
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ seed2 >>> 4);
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, Object.create(XorWowRandom.prototype));
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Random.call(this);
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._v = v;
    this._addend = addend;
    var tmp0_require_0 = !((this._x | this._y | this._z | this._w | this._v) === 0);
    if (!tmp0_require_0) {
      var message_2 = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_repeat_0 = 64;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_repeat_0)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nextInt_7();
        Unit_getInstance();
      }
       while (inductionVariable < tmp1_repeat_0);
  }
  XorWowRandom.prototype.nextInt_7 = function () {
    var t = this._x;
    t = t ^ t >>> 2;
    this._x = this._y;
    this._y = this._z;
    this._z = this._w;
    var v0 = this._v;
    this._w = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this._v = t;
    var tmp0_this = this;
    tmp0_this._addend = tmp0_this._addend + 362437 | 0;
    return t + this._addend | 0;
  };
  XorWowRandom.prototype.nextBits_1 = function (bitCount) {
    return takeUpperBits(this.nextInt_7(), bitCount);
  };
  XorWowRandom.$metadata$ = {
    simpleName: 'XorWowRandom',
    kind: 'class',
    interfaces: []
  };
  function checkStepIsPositive(isPositive, step_0) {
    if (!isPositive)
      throw IllegalArgumentException_init_$Create$('' + 'Step must be positive, was: ' + step_0 + '.');
  }
  function ClosedFloatingPointRange() {
  }
  ClosedFloatingPointRange.$metadata$ = {
    simpleName: 'ClosedFloatingPointRange',
    kind: 'interface',
    interfaces: [ClosedRange]
  };
  function rangeTo(_this_, that) {
    return new ClosedFloatRange(_this_, that);
  }
  function ClosedFloatRange(start_0, endInclusive) {
    this.__start = start_0;
    this.__endInclusive = endInclusive;
  }
  ClosedFloatRange.prototype._get_start__0 = function () {
    return this.__start;
  };
  ClosedFloatRange.prototype._get_endInclusive__0 = function () {
    return this.__endInclusive;
  };
  ClosedFloatRange.prototype.isEmpty_40 = function () {
    return !(this.__start <= this.__endInclusive);
  };
  ClosedFloatRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ClosedFloatRange) {
      tmp = (this.isEmpty_40() ? other.isEmpty_40() : false) ? true : this.__start === other.__start ? this.__endInclusive === other.__endInclusive : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ClosedFloatRange.prototype.hashCode = function () {
    return this.isEmpty_40() ? -1 : imul(31, getNumberHashCode(this.__start)) + getNumberHashCode(this.__endInclusive) | 0;
  };
  ClosedFloatRange.prototype.toString = function () {
    return '' + this.__start + '..' + this.__endInclusive;
  };
  ClosedFloatRange.$metadata$ = {
    simpleName: 'ClosedFloatRange',
    kind: 'class',
    interfaces: [ClosedFloatingPointRange]
  };
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$('' + "Invalid number format: '" + input + "'");
  }
  function _Duration___init__impl_(value_0) {
    return value_0;
  }
  function _Duration___get_value__impl_(this_0) {
    return this_0;
  }
  function Duration__toDouble_impl(this_0, unit) {
    var tmp = _Duration___get_value__impl_(this_0);
    return convertDurationUnit(tmp, DurationUnit_NANOSECONDS_getInstance(), unit);
  }
  function Duration__toLong_impl(this_0, unit) {
    return numberToLong(Duration__toDouble_impl(this_0, unit));
  }
  function Duration__toLongNanoseconds_impl(this_0) {
    return Duration__toLong_impl(this_0, DurationUnit_NANOSECONDS_getInstance());
  }
  function toDuration(_this_, unit) {
    return _Duration___init__impl_(convertDurationUnit(_this_, unit, DurationUnit_NANOSECONDS_getInstance()));
  }
  function Lazy() {
  }
  Lazy.$metadata$ = {
    simpleName: 'Lazy',
    kind: 'interface',
    interfaces: []
  };
  function UnsafeLazyImpl(initializer) {
    this._initializer = initializer;
    this.__value = UNINITIALIZED_VALUE_getInstance();
  }
  UnsafeLazyImpl.prototype._get_value__13 = function () {
    if (this.__value === UNINITIALIZED_VALUE_getInstance()) {
      this.__value = ensureNotNull(this._initializer)();
      this._initializer = null;
    }var tmp = this.__value;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  UnsafeLazyImpl.prototype.isInitialized = function () {
    return !(this.__value === UNINITIALIZED_VALUE_getInstance());
  };
  UnsafeLazyImpl.prototype.toString = function () {
    return this.isInitialized() ? toString_0(this._get_value__13()) : 'Lazy value not initialized yet.';
  };
  UnsafeLazyImpl.$metadata$ = {
    simpleName: 'UnsafeLazyImpl',
    kind: 'class',
    interfaces: [Lazy, Serializable]
  };
  function UNINITIALIZED_VALUE() {
    UNINITIALIZED_VALUE_instance = this;
  }
  UNINITIALIZED_VALUE.$metadata$ = {
    simpleName: 'UNINITIALIZED_VALUE',
    kind: 'object',
    interfaces: []
  };
  var UNINITIALIZED_VALUE_instance;
  function UNINITIALIZED_VALUE_getInstance() {
    if (UNINITIALIZED_VALUE_instance == null)
      new UNINITIALIZED_VALUE();
    return UNINITIALIZED_VALUE_instance;
  }
  function _Result___init__impl_(value_0) {
    return value_0;
  }
  function _Result___get_value__impl_(this_0) {
    return this_0;
  }
  function _Result___get_isFailure__impl_(this_0) {
    var tmp = _Result___get_value__impl_(this_0);
    return tmp instanceof Failure;
  }
  function Result__exceptionOrNull_impl(this_0) {
    var tmp0_subject = _Result___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject instanceof Failure) {
      tmp = _Result___get_value__impl_(this_0)._exception;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function Companion_3() {
    Companion_instance_2 = this;
  }
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function Failure(exception) {
    this._exception = exception;
  }
  Failure.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Failure) {
      tmp = equals(this._exception, other._exception);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Failure.prototype.hashCode = function () {
    return hashCode(this._exception);
  };
  Failure.prototype.toString = function () {
    return '' + 'Failure(' + this._exception + ')';
  };
  Failure.$metadata$ = {
    simpleName: 'Failure',
    kind: 'class',
    interfaces: [Serializable]
  };
  function createFailure(exception) {
    return new Failure(exception);
  }
  function throwOnFailure(_this_) {
    var tmp = _Result___get_value__impl_(_this_);
    if (tmp instanceof Failure)
      throw _Result___get_value__impl_(_this_)._exception;
    else {
    }
  }
  function Pair(first, second) {
    this._first = first;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1_0 = function () {
    return this._first;
  };
  Pair.prototype.component2_0 = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    var result = this._first == null ? 0 : hashCode(this._first);
    result = imul(result, 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
    return result;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableListIterator() {
  }
  MutableListIterator.$metadata$ = {
    simpleName: 'MutableListIterator',
    kind: 'interface',
    interfaces: [ListIterator, MutableIterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_28 = function () {
    return this.nextInt_7();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function IntProgressionIterator(first, last, step_0) {
    IntIterator.call(this);
    this._step = step_0;
    this._finalElement = last;
    this._hasNext = this._step > 0 ? first <= last : first >= last;
    this._next_0 = this._hasNext ? first : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_27 = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_7 = function () {
    var value_0 = this._next_0;
    if (value_0 === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_0 = tmp0_this._next_0 + this._step | 0;
    }
    return value_0;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function Companion_4() {
    Companion_instance_3 = this;
  }
  Companion_4.prototype.fromClosedRange = function (rangeStart, rangeEnd, step_0) {
    return new IntProgression(rangeStart, rangeEnd, step_0);
  };
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function IntProgression(start_0, endInclusive, step_0) {
    Companion_getInstance_3();
    if (step_0 === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step_0 === IntCompanionObject_getInstance()._MIN_VALUE)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_0 = start_0;
    this._last = getProgressionLastElement(start_0, endInclusive, step_0);
    this._step_0 = step_0;
  }
  IntProgression.prototype._get_first__0 = function () {
    return this._first_0;
  };
  IntProgression.prototype._get_last__2 = function () {
    return this._last;
  };
  IntProgression.prototype.iterator_46 = function () {
    return new IntProgressionIterator(this._first_0, this._last, this._step_0);
  };
  IntProgression.prototype.isEmpty_40 = function () {
    return this._step_0 > 0 ? this._first_0 > this._last : this._first_0 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_40() ? other.isEmpty_40() : false) ? true : (this._first_0 === other._first_0 ? this._last === other._last : false) ? this._step_0 === other._step_0 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_40() ? -1 : imul(31, imul(31, this._first_0) + this._last | 0) + this._step_0 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_0 > 0 ? '' + this._first_0 + '..' + this._last + ' step ' + this._step_0 : '' + this._first_0 + ' downTo ' + this._last + ' step ' + (-this._step_0 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function Companion_5() {
    Companion_instance_4 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_5.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_5();
    return Companion_instance_4;
  }
  function IntRange(start_0, endInclusive) {
    Companion_getInstance_4();
    IntProgression.call(this, start_0, endInclusive, 1);
  }
  IntRange.prototype.isEmpty_40 = function () {
    return this._get_first__0() > this._get_last__2();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_40() ? other.isEmpty_40() : false) ? true : this._get_first__0() === other._get_first__0() ? this._get_last__2() === other._get_last__2() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_40() ? -1 : imul(31, this._get_first__0()) + this._get_last__2() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__0() + '..' + this._get_last__2();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start_0, end_0, step_0) {
    var tmp;
    if (step_0 > 0) {
      tmp = start_0 >= end_0 ? end_0 : end_0 - differenceModulo(end_0, start_0, step_0) | 0;
    } else if (step_0 < 0) {
      tmp = start_0 <= end_0 ? end_0 : end_0 + differenceModulo(start_0, end_0, -step_0 | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod_0 = a % b;
    return mod_0 >= 0 ? mod_0 : mod_0 + b | 0;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE = -2147483648;
    this._MAX_VALUE = 2147483647;
    this._SIZE_BYTES = 4;
    this._SIZE_BITS = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE__0 = function () {
    return this._MIN_VALUE;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE__0 = function () {
    return this._MAX_VALUE;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES__0 = function () {
    return this._SIZE_BYTES;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS__0 = function () {
    return this._SIZE_BITS;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE__0
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE__0
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES__0
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS__0
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function DoubleCompanionObject_0() {
    DoubleCompanionObject_instance = this;
    this._MIN_VALUE_0 = 4.9E-324;
    this._MAX_VALUE_0 = 1.7976931348623157E308;
    this._POSITIVE_INFINITY = Infinity;
    this._NEGATIVE_INFINITY = -Infinity;
    this._NaN = NaN;
    this._SIZE_BYTES_0 = 8;
    this._SIZE_BITS_0 = 64;
  }
  DoubleCompanionObject_0.prototype._get_MIN_VALUE__0 = function () {
    return this._MIN_VALUE_0;
  };
  DoubleCompanionObject_0.prototype._get_MAX_VALUE__0 = function () {
    return this._MAX_VALUE_0;
  };
  DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY_ = function () {
    return this._POSITIVE_INFINITY;
  };
  DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY_ = function () {
    return this._NEGATIVE_INFINITY;
  };
  DoubleCompanionObject_0.prototype._get_NaN_ = function () {
    return this._NaN;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BYTES__0 = function () {
    return this._SIZE_BYTES_0;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BITS__0 = function () {
    return this._SIZE_BITS_0;
  };
  DoubleCompanionObject_0.$metadata$ = {
    simpleName: 'DoubleCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MIN_VALUE__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MAX_VALUE__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NaN_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BYTES__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BITS__0
  });
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    if (DoubleCompanionObject_instance == null)
      new DoubleCompanionObject_0();
    return DoubleCompanionObject_instance;
  }
  function Comparator() {
  }
  Comparator.$metadata$ = {
    simpleName: 'Comparator',
    kind: 'interface',
    interfaces: []
  };
  function sortWith(_this_, comparator) {
    collectionsSort(_this_, comparator);
  }
  function checkIndexOverflow(index) {
    if (index < 0) {
      throwIndexOverflow();
    }return index;
  }
  function arrayCopy_0(source, destination, destinationOffset, startIndex, endIndex) {
    Companion_getInstance().checkRangeIndexes(startIndex, endIndex, source.length);
    var rangeSize = endIndex - startIndex | 0;
    Companion_getInstance().checkRangeIndexes(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
    if (ArrayBuffer.isView(destination) && ArrayBuffer.isView(source)) {
      var subrange = source.subarray(startIndex, endIndex);
      destination.set(subrange, destinationOffset);
    } else {
      if (!(source === destination) ? true : destinationOffset <= startIndex) {
        var inductionVariable = 0;
        if (inductionVariable < rangeSize)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination[destinationOffset + index | 0] = source[startIndex + index | 0];
          }
           while (inductionVariable < rangeSize);
      } else {
        var inductionVariable_0 = rangeSize - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  function collectionsSort(list, comparator) {
    if (list._get_size__45() <= 1)
      return Unit_getInstance();
    var array = copyToArray_0(list);
    sortArrayWith(array, comparator);
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.set_13(i, array[i]);
        Unit_getInstance();
      }
       while (inductionVariable < last);
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator_0 = collection.iterator_46();
    while (iterator_0.hasNext_27()) {
      array.push(iterator_0.next_28());
    }
    return array;
  }
  function _no_name_provided__4($elements) {
    this._$elements = $elements;
  }
  _no_name_provided__4.prototype.invoke_8 = function (it) {
    return this._$elements.contains_37(it);
  };
  _no_name_provided__4.prototype.invoke_468 = function (p1) {
    return this.invoke_8((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.remove_51 = function (element) {
    this.checkIsMutable_13();
    var iterator_0 = this.iterator_46();
    while (iterator_0.hasNext_27()) {
      if (equals(iterator_0.next_28(), element)) {
        iterator_0.remove_52();
        return true;
      }}
    return false;
  };
  AbstractMutableCollection.prototype.addAll_10 = function (elements) {
    this.checkIsMutable_13();
    var modified = false;
    var tmp0_iterator = elements.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_28();
      if (this.add_37(element))
        modified = true;
    }
    return modified;
  };
  AbstractMutableCollection.prototype.removeAll_7 = function (elements) {
    this.checkIsMutable_13();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll(tmp, _no_name_provided_$factory_3(elements));
  };
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_13 = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function _no_name_provided_$factory_3($elements) {
    var i = new _no_name_provided__4($elements);
    return function (p1) {
      return i.invoke_8(p1);
    };
  }
  function IteratorImpl_0($outer) {
    this._$this_1 = $outer;
    this._index_0 = 0;
    this._last_0 = -1;
  }
  IteratorImpl_0.prototype._set_index__8 = function (_set___) {
    this._index_0 = _set___;
  };
  IteratorImpl_0.prototype._get_index__8 = function () {
    return this._index_0;
  };
  IteratorImpl_0.prototype._set_last__0 = function (_set___) {
    this._last_0 = _set___;
  };
  IteratorImpl_0.prototype._get_last__2 = function () {
    return this._last_0;
  };
  IteratorImpl_0.prototype.hasNext_27 = function () {
    return this._index_0 < this._$this_1._get_size__45();
  };
  IteratorImpl_0.prototype.next_28 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_0;
    tmp0_this._index_0 = tmp1 + 1 | 0;
    tmp._last_0 = tmp1;
    return this._$this_1.get_66(this._last_0);
  };
  IteratorImpl_0.prototype.remove_52 = function () {
    var tmp0_check_0 = !(this._last_0 === -1);
    if (!tmp0_check_0) {
      var message_1 = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }this._$this_1.removeAt_7(this._last_0);
    Unit_getInstance();
    this._index_0 = this._last_0;
    this._last_0 = -1;
  };
  IteratorImpl_0.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ListIteratorImpl_0($outer, index) {
    this._$this_2 = $outer;
    IteratorImpl_0.call(this, $outer);
    Companion_getInstance().checkPositionIndex_0(index, this._$this_2._get_size__45());
    this._set_index__8(index);
  }
  ListIteratorImpl_0.prototype.hasPrevious_8 = function () {
    return this._get_index__8() > 0;
  };
  ListIteratorImpl_0.prototype.nextIndex_7 = function () {
    return this._get_index__8();
  };
  ListIteratorImpl_0.prototype.previous_7 = function () {
    if (!this.hasPrevious_8())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    tmp0_this._set_index__8(tmp0_this._get_index__8() - 1 | 0);
    this._set_last__0(tmp0_this._get_index__8());
    return this._$this_2.get_66(this._get_last__2());
  };
  ListIteratorImpl_0.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function SubList(list, fromIndex, toIndex) {
    AbstractMutableList.call(this);
    this._list = list;
    this._fromIndex = fromIndex;
    this.__size = 0;
    Companion_getInstance().checkRangeIndexes(this._fromIndex, toIndex, this._list._get_size__45());
    this.__size = toIndex - this._fromIndex | 0;
  }
  SubList.prototype.add_39 = function (index, element) {
    Companion_getInstance().checkPositionIndex_0(index, this.__size);
    this._list.add_39(this._fromIndex + index | 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size;
    tmp0_this.__size = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  SubList.prototype.get_66 = function (index) {
    Companion_getInstance().checkElementIndex_0(index, this.__size);
    return this._list.get_66(this._fromIndex + index | 0);
  };
  SubList.prototype.removeAt_7 = function (index) {
    Companion_getInstance().checkElementIndex_0(index, this.__size);
    var result = this._list.removeAt_7(this._fromIndex + index | 0);
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size;
    tmp0_this.__size = tmp1 - 1 | 0;
    Unit_getInstance();
    return result;
  };
  SubList.prototype.set_13 = function (index, element) {
    Companion_getInstance().checkElementIndex_0(index, this.__size);
    return this._list.set_13(this._fromIndex + index | 0, element);
  };
  SubList.prototype._get_size__45 = function () {
    return this.__size;
  };
  SubList.prototype.checkIsMutable_13 = function () {
    return this._list.checkIsMutable_13();
  };
  SubList.$metadata$ = {
    simpleName: 'SubList',
    kind: 'class',
    interfaces: [RandomAccess]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__0 = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__0 = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_37 = function (element) {
    this.checkIsMutable_13();
    this.add_39(this._get_size__45(), element);
    return true;
  };
  AbstractMutableList.prototype.clear_7 = function () {
    this.checkIsMutable_13();
    this.removeRange_1(0, this._get_size__45());
  };
  AbstractMutableList.prototype.iterator_46 = function () {
    return new IteratorImpl_0(this);
  };
  AbstractMutableList.prototype.contains_37 = function (element) {
    return this.indexOf_5(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_5 = function (element) {
    var inductionVariable = 0;
    var last = _get_lastIndex__0(this);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.get_66(index), element)) {
          return index;
        }}
       while (!(index === last));
    return -1;
  };
  AbstractMutableList.prototype.lastIndexOf_9 = function (element) {
    var inductionVariable = _get_lastIndex__0(this);
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (equals(this.get_66(index), element)) {
          return index;
        }}
       while (0 <= inductionVariable);
    return -1;
  };
  AbstractMutableList.prototype.listIterator_12 = function (index) {
    return new ListIteratorImpl_0(this, index);
  };
  AbstractMutableList.prototype.subList_0 = function (fromIndex, toIndex) {
    return new SubList(this, fromIndex, toIndex);
  };
  AbstractMutableList.prototype.removeRange_1 = function (fromIndex, toIndex) {
    var iterator_0 = this.listIterator_12(fromIndex);
    var tmp0_repeat_0 = toIndex - fromIndex | 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        iterator_0.next_28();
        Unit_getInstance();
        iterator_0.remove_52();
      }
       while (inductionVariable < tmp0_repeat_0);
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function _no_name_provided__5($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__5.prototype.hasNext_27 = function () {
    return this._$entryIterator.hasNext_27();
  };
  _no_name_provided__5.prototype.next_28 = function () {
    return this._$entryIterator.next_28()._get_key__28();
  };
  _no_name_provided__5.prototype.remove_52 = function () {
    return this._$entryIterator.remove_52();
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function _no_name_provided__6($entryIterator) {
    this._$entryIterator_0 = $entryIterator;
  }
  _no_name_provided__6.prototype.hasNext_27 = function () {
    return this._$entryIterator_0.hasNext_27();
  };
  _no_name_provided__6.prototype.next_28 = function () {
    return this._$entryIterator_0.next_28()._get_value__13();
  };
  _no_name_provided__6.prototype.remove_52 = function () {
    return this._$entryIterator_0.remove_52();
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key_0, value_0) {
    this._key_0 = key_0;
    this.__value_0 = value_0;
  }
  SimpleEntry.prototype._get_key__28 = function () {
    return this._key_0;
  };
  SimpleEntry.prototype._get_value__13 = function () {
    return this.__value_0;
  };
  SimpleEntry.prototype.setValue_1 = function (newValue) {
    var oldValue = this.__value_0;
    this.__value_0 = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function AbstractEntrySet() {
    AbstractMutableSet.call(this);
  }
  AbstractEntrySet.prototype.contains_37 = function (element) {
    return this.containsEntry_4(element);
  };
  AbstractEntrySet.$metadata$ = {
    simpleName: 'AbstractEntrySet',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__7(this$0) {
    this._this$0_1 = this$0;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__7.prototype.add_6 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__7.prototype.add_37 = function (element) {
    return this.add_6((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__7.prototype.contains_22 = function (element) {
    return this._this$0_1.containsKey_7(element);
  };
  _no_name_provided__7.prototype.contains_37 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_22((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__7.prototype.iterator_46 = function () {
    var entryIterator = this._this$0_1._get_entries__5().iterator_46();
    return new _no_name_provided__5(entryIterator);
  };
  _no_name_provided__7.prototype.remove_43 = function (element) {
    this.checkIsMutable_13();
    if (this._this$0_1.containsKey_7(element)) {
      this._this$0_1.remove_43(element);
      Unit_getInstance();
      return true;
    }return false;
  };
  _no_name_provided__7.prototype.remove_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_43((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__7.prototype._get_size__45 = function () {
    return this._this$0_1._get_size__45();
  };
  _no_name_provided__7.prototype.checkIsMutable_13 = function () {
    return this._this$0_1.checkIsMutable_13();
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__8(this$0) {
    this._this$0_2 = this$0;
    AbstractMutableCollection.call(this);
  }
  _no_name_provided__8.prototype.add_8 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
  };
  _no_name_provided__8.prototype.add_37 = function (element) {
    return this.add_8((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__8.prototype.contains_15 = function (element) {
    return this._this$0_2.containsValue_2(element);
  };
  _no_name_provided__8.prototype.contains_37 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_15((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__8.prototype.iterator_46 = function () {
    var entryIterator = this._this$0_2._get_entries__5().iterator_46();
    return new _no_name_provided__6(entryIterator);
  };
  _no_name_provided__8.prototype._get_size__45 = function () {
    return this._this$0_2._get_size__45();
  };
  _no_name_provided__8.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  _no_name_provided__8.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  _no_name_provided__8.prototype.checkIsMutable_13 = function () {
    return this._this$0_2.checkIsMutable_13();
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype._get_keys__1 = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__7(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.prototype._get_values__1 = function () {
    if (this.__values_0 == null) {
      var tmp = this;
      tmp.__values_0 = new _no_name_provided__8(this);
    }return ensureNotNull(this.__values_0);
  };
  AbstractMutableMap.prototype.remove_43 = function (key_0) {
    this.checkIsMutable_13();
    var iter = this._get_entries__5().iterator_46();
    while (iter.hasNext_27()) {
      var entry = iter.next_28();
      var k = entry._get_key__28();
      if (equals(key_0, k)) {
        var value_0 = entry._get_value__13();
        iter.remove_52();
        return value_0;
      }}
    return null;
  };
  AbstractMutableMap.prototype.checkIsMutable_13 = function () {
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex_0(index, $this._get_size__45());
    return index;
  }
  function insertionRangeCheck($this, index) {
    Companion_getInstance().checkPositionIndex_0(index, $this._get_size__45());
    return index;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype._get_size__45 = function () {
    return this._array.length;
  };
  ArrayList.prototype.get_66 = function (index) {
    var tmp = this._array[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.set_13 = function (index, element) {
    this.checkIsMutable_13();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_apply_0 = this._array[index];
    this._array[index] = element;
    var tmp = tmp0_apply_0;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_37 = function (element) {
    this.checkIsMutable_13();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_39 = function (index, element) {
    this.checkIsMutable_13();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.addAll_10 = function (elements) {
    this.checkIsMutable_13();
    if (elements.isEmpty_40())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__0();
    tmp1_this._set_modCount__0(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.addAll_5 = function (index, elements) {
    this.checkIsMutable_13();
    insertionRangeCheck(this, index);
    Unit_getInstance();
    if (index === this._get_size__45())
      return this.addAll_10(elements);
    if (elements.isEmpty_40())
      return false;
    var tmp0_subject = index;
    if (tmp0_subject === this._get_size__45())
      return this.addAll_10(elements);
    else if (tmp0_subject === 0) {
      var tmp = this;
      var tmp0_plus_0 = copyToArray_0(elements);
      var tmp1_plus_0 = this._array;
      tmp._array = tmp0_plus_0.concat(tmp1_plus_0);
    } else {
      var tmp_0 = this;
      var tmp2_asDynamic_0 = copyOfRange(this._array, 0, index);
      tmp_0._array = tmp2_asDynamic_0.concat(copyToArray_0(elements), copyOfRange(this._array, index, this._get_size__45()));
    }
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__0();
    tmp1_this._set_modCount__0(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.removeAt_7 = function (index) {
    this.checkIsMutable_13();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index === _get_lastIndex__0(this)) {
      var tmp0_asDynamic_0 = this._array;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array;
      tmp = tmp1_asDynamic_0.splice(index, 1)[0];
    }
    return tmp;
  };
  ArrayList.prototype.remove_51 = function (element) {
    this.checkIsMutable_13();
    var inductionVariable = 0;
    var last = this._array.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this._array[index], element)) {
          var tmp0_asDynamic_0 = this._array;
          tmp0_asDynamic_0.splice(index, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this._get_modCount__0();
          tmp1_this._set_modCount__0(tmp2 + 1 | 0);
          Unit_getInstance();
          return true;
        }}
       while (inductionVariable <= last);
    return false;
  };
  ArrayList.prototype.removeRange_1 = function (fromIndex, toIndex) {
    this.checkIsMutable_13();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(fromIndex, toIndex - fromIndex | 0);
  };
  ArrayList.prototype.clear_7 = function () {
    this.checkIsMutable_13();
    var tmp = this;
    tmp._array = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.indexOf_5 = function (element) {
    return indexOf(this._array, element);
  };
  ArrayList.prototype.lastIndexOf_9 = function (element) {
    return lastIndexOf(this._array, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array);
  };
  ArrayList.prototype.toArray_1 = function () {
    return [].slice.call(this._array);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_1();
  };
  ArrayList.prototype.checkIsMutable_13 = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  var _stableSortingIsSupported;
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_4(comparator);
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex_(array), comparator);
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    _stableSortingIsSupported = false;
    var tmp0_unsafeCast_0 = [];
    var array = tmp0_unsafeCast_0;
    var inductionVariable = 0;
    if (inductionVariable < 600)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array.push(index);
      }
       while (inductionVariable < 600);
    var comparison = _no_name_provided_$factory_5();
    array.sort(comparison);
    var inductionVariable_0 = 1;
    var last = array.length;
    if (inductionVariable_0 < last)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_0 - 1 | 0];
        var b = array[index_0];
        if ((a & 3) === (b & 3) ? a >= b : false)
          return false;
      }
       while (inductionVariable_0 < last);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start_0, endInclusive, comparator) {
    var tmp0_arrayOfNulls_0 = array.length;
    var tmp1_unsafeCast_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var buffer = tmp1_unsafeCast_0;
    var result = mergeSort_0(array, buffer, start_0, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start_0;
      if (inductionVariable <= endInclusive)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === endInclusive));
    }}
  function mergeSort_0(array, buffer, start_0, end_0, comparator) {
    if (start_0 === end_0) {
      return array;
    }var median = (start_0 + end_0 | 0) / 2 | 0;
    var left_1 = mergeSort_0(array, buffer, start_0, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end_0, comparator);
    var target = left_1 === buffer ? array : buffer;
    var leftIndex = start_0;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start_0;
    if (inductionVariable <= end_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median ? rightIndex <= end_0 : false) {
          var leftValue = left_1[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            var tmp1 = leftIndex;
            leftIndex = tmp1 + 1 | 0;
            Unit_getInstance();
          } else {
            target[i] = rightValue;
            var tmp2 = rightIndex;
            rightIndex = tmp2 + 1 | 0;
            Unit_getInstance();
          }
        } else if (leftIndex <= median) {
          target[i] = left_1[leftIndex];
          var tmp3 = leftIndex;
          leftIndex = tmp3 + 1 | 0;
          Unit_getInstance();
        } else {
          target[i] = right[rightIndex];
          var tmp4 = rightIndex;
          rightIndex = tmp4 + 1 | 0;
          Unit_getInstance();
          Unit_getInstance();
        }
      }
       while (!(i === end_0));
    return target;
  }
  function _no_name_provided__9($comparator) {
    this._$comparator = $comparator;
  }
  _no_name_provided__9.prototype.invoke_10 = function (a, b) {
    return this._$comparator.compare(a, b);
  };
  _no_name_provided__9.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE();
    return this.invoke_10(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__10() {
  }
  _no_name_provided__10.prototype.invoke_12 = function (a, b) {
    return (a & 3) - (b & 3) | 0;
  };
  _no_name_provided__10.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_12(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_4($comparator) {
    var i = new _no_name_provided__9($comparator);
    return function (p1, p2) {
      return i.invoke_10(p1, p2);
    };
  }
  function _no_name_provided_$factory_5() {
    var i = new _no_name_provided__10();
    return function (p1, p2) {
      return i.invoke_12(p1, p2);
    };
  }
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_1 = function (value1, value2) {
    return equals(value1, value2);
  };
  HashCode.prototype.getHashCode_0 = function (value_0) {
    var tmp0_safe_receiver = value_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function EntrySet($outer) {
    this._$this_3 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet.prototype.add_16 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_37 = function (element) {
    return this.add_16((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.containsEntry_4 = function (element) {
    return this._$this_3.containsEntry_6(element);
  };
  EntrySet.prototype.iterator_46 = function () {
    return this._$this_3._internalMap.iterator_46();
  };
  EntrySet.prototype.remove_23 = function (element) {
    if (this.contains_37(element)) {
      this._$this_3.remove_43(element._get_key__28());
      Unit_getInstance();
      return true;
    }return false;
  };
  EntrySet.prototype.remove_51 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.remove_23((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype._get_size__45 = function () {
    return this._$this_3._get_size__45();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_0($this);
    var tmp0_require_0 = initialCapacity >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = loadFactor >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return HashMap_init_$Init$_1(initialCapacity, loadFactor, Object.create(HashMap.prototype));
  }
  HashMap.prototype.containsKey_7 = function (key_0) {
    return this._internalMap.contains_22(key_0);
  };
  HashMap.prototype.containsValue_2 = function (value_0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._internalMap;
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (this._equality.equals_1(element_2._get_value__13(), value_0)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  HashMap.prototype._get_entries__5 = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet_0();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_48 = function (key_0) {
    return this._internalMap.get_48(key_0);
  };
  HashMap.prototype.put_6 = function (key_0, value_0) {
    return this._internalMap.put_6(key_0, value_0);
  };
  HashMap.prototype.remove_43 = function (key_0) {
    return this._internalMap.remove_43(key_0);
  };
  HashMap.prototype._get_size__45 = function () {
    return this._internalMap._get_size__45();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function HashSet_init_$Init$($this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$();
    return $this;
  }
  function HashSet_init_$Create$() {
    return HashSet_init_$Init$(Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_0(initialCapacity, loadFactor, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_0(initialCapacity, loadFactor);
    return $this;
  }
  function HashSet_init_$Init$_1(initialCapacity, $this) {
    HashSet_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashSet_init_$Create$_0(initialCapacity) {
    return HashSet_init_$Init$_1(initialCapacity, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_2(map, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = map;
    return $this;
  }
  HashSet.prototype._get_map__0 = function () {
    return this._map;
  };
  HashSet.prototype.add_37 = function (element) {
    var old = this._map.put_6(element, this);
    return old == null;
  };
  HashSet.prototype.contains_37 = function (element) {
    return this._map.containsKey_7(element);
  };
  HashSet.prototype.isEmpty_40 = function () {
    return this._map.isEmpty_40();
  };
  HashSet.prototype.iterator_46 = function () {
    return this._map._get_keys__1().iterator_46();
  };
  HashSet.prototype.remove_51 = function (element) {
    return !(this._map.remove_43(element) == null);
  };
  HashSet.prototype._get_size__45 = function () {
    return this._map._get_size__45();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._this$0_3._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key_0) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_0(key_0));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_1(entry._get_key__28(), key_0)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key_0);
      }
    }
  }
  function findEntryInChain(_this_, $this, key_0) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_1(element_2._get_key__28(), key_0)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__11(this$0) {
    this._this$0_3 = this$0;
    this._state_0 = -1;
    this._keys = Object.keys(this._this$0_3._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__11.prototype.hasNext_27 = function () {
    if (this._state_0 === -1)
      this._state_0 = computeNext(this);
    return this._state_0 === 0;
  };
  _no_name_provided__11.prototype.next_28 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state_0 = -1;
    return lastEntry;
  };
  _no_name_provided__11.prototype.remove_52 = function () {
    var tmp0_checkNotNull_0 = this._lastEntry;
    var tmp$ret$0;
    l$ret$1: do {
      if (tmp0_checkNotNull_0 == null) {
        var message_2_1 = 'Required value was null.';
        throw IllegalStateException_init_$Create$(toString_1(message_2_1));
      } else {
        tmp$ret$0 = tmp0_checkNotNull_0;
        break l$ret$1;
      }
    }
     while (false);
    Unit_getInstance();
    this._this$0_3.remove_43(ensureNotNull(this._lastEntry)._get_key__28());
    Unit_getInstance();
    this._lastEntry = null;
    var tmp0_this = this;
    var tmp1 = tmp0_this._itemIndex;
    tmp0_this._itemIndex = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0();
    this._size = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0 = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__45 = function () {
    return this._size;
  };
  InternalHashCodeMap.prototype.put_6 = function (key_0, value_0) {
    var hashCode_1 = this._equality_0.getHashCode_0(key_0);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key_0, value_0);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_1(entry._get_key__28(), key_0)) {
          return entry.setValue_1(value_0);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key_0, value_0)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size;
          tmp0_this._size = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key_0);
          if (!(entry_0 == null)) {
            return entry_0.setValue_1(value_0);
          }chain.push(new SimpleEntry(key_0, value_0));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size;
    tmp2_this._size = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.remove_43 = function (key_0) {
    var hashCode_1 = this._equality_0.getHashCode_0(key_0);
    var tmp0_elvis_lhs = getChainOrEntryOrNull(this, hashCode_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if (this._equality_0.equals_1(entry._get_key__28(), key_0)) {
        jsDeleteProperty(this._backingMap, hashCode_1);
        var tmp1_this = this;
        var tmp2 = tmp1_this._size;
        tmp1_this._size = tmp2 - 1 | 0;
        Unit_getInstance();
        return entry._get_value__13();
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        var inductionVariable = 0;
        var last = chain.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var entry_0 = chain[index];
            if (this._equality_0.equals_1(key_0, entry_0._get_key__28())) {
              if (chain.length === 1) {
                chain.length = 0;
                jsDeleteProperty(this._backingMap, hashCode_1);
              } else {
                chain.splice(index, 1);
              }
              var tmp4_this = this;
              var tmp5 = tmp4_this._size;
              tmp4_this._size = tmp5 - 1 | 0;
              Unit_getInstance();
              return entry_0._get_value__13();
            }}
           while (inductionVariable <= last);
      }
    }
    return null;
  };
  InternalHashCodeMap.prototype.contains_22 = function (key_0) {
    return !(getEntry(this, key_0) == null);
  };
  InternalHashCodeMap.prototype.get_48 = function (key_0) {
    var tmp0_safe_receiver = getEntry(this, key_0);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__13();
  };
  InternalHashCodeMap.prototype.iterator_46 = function () {
    return new _no_name_provided__11(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0 = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  function EntryIterator($outer) {
    this._$this_4 = $outer;
    this._last_1 = null;
    this._next_1 = null;
    this._next_1 = this._$this_4._$this_6._head;
  }
  EntryIterator.prototype.hasNext_27 = function () {
    return !(this._next_1 === null);
  };
  EntryIterator.prototype.next_28 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var current_0 = ensureNotNull(this._next_1);
    this._last_1 = current_0;
    var tmp = this;
    var tmp0_takeIf_0 = current_0._next_2;
    var tmp_0;
    if (!(tmp0_takeIf_0 === this._$this_4._$this_6._head)) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    tmp._next_1 = tmp_0;
    return current_0;
  };
  EntryIterator.prototype.remove_52 = function () {
    var tmp0_check_0 = !(this._last_1 == null);
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }this._$this_4.checkIsMutable_13();
    remove(ensureNotNull(this._last_1), this._$this_4._$this_6);
    this._$this_4._$this_6._map_0.remove_43(ensureNotNull(this._last_1)._get_key__28());
    Unit_getInstance();
    this._last_1 = null;
  };
  EntryIterator.$metadata$ = {
    simpleName: 'EntryIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ChainEntry($outer, key_0, value_0) {
    this._$this_5 = $outer;
    SimpleEntry.call(this, key_0, value_0);
    this._next_2 = null;
    this._prev = null;
  }
  ChainEntry.prototype.setValue_1 = function (newValue) {
    this._$this_5.checkIsMutable_13();
    return SimpleEntry.prototype.setValue_1.call(this, newValue);
  };
  ChainEntry.$metadata$ = {
    simpleName: 'ChainEntry',
    kind: 'class',
    interfaces: []
  };
  function EntrySet_0($outer) {
    this._$this_6 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet_0.prototype.add_16 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet_0.prototype.add_37 = function (element) {
    return this.add_16((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.containsEntry_4 = function (element) {
    return this._$this_6.containsEntry_6(element);
  };
  EntrySet_0.prototype.iterator_46 = function () {
    return new EntryIterator(this);
  };
  EntrySet_0.prototype.remove_23 = function (element) {
    this.checkIsMutable_13();
    if (this.contains_37(element)) {
      this._$this_6.remove_43(element._get_key__28());
      Unit_getInstance();
      return true;
    }return false;
  };
  EntrySet_0.prototype.remove_51 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.remove_23((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype._get_size__45 = function () {
    return this._$this_6._get_size__45();
  };
  EntrySet_0.prototype.checkIsMutable_13 = function () {
    return this._$this_6.checkIsMutable_13();
  };
  EntrySet_0.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function addToEnd(_this_, $this) {
    var tmp0_check_0 = _this_._next_2 == null ? _this_._prev == null : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }var _head = $this._head;
    if (_head == null) {
      $this._head = _this_;
      _this_._next_2 = _this_;
      _this_._prev = _this_;
    } else {
      var tmp1_checkNotNull_0 = _head._prev;
      var tmp$ret$0;
      l$ret$1: do {
        if (tmp1_checkNotNull_0 == null) {
          var message_2_1_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$(toString_1(message_2_1_0));
        } else {
          tmp$ret$0 = tmp1_checkNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      var _tail = tmp$ret$0;
      _this_._prev = _tail;
      _this_._next_2 = _head;
      _head._prev = _this_;
      _tail._next_2 = _this_;
    }
  }
  function remove(_this_, $this) {
    if (_this_._next_2 === _this_) {
      $this._head = null;
    } else {
      if ($this._head === _this_) {
        $this._head = _this_._next_2;
      }ensureNotNull(_this_._next_2)._prev = _this_._prev;
      ensureNotNull(_this_._prev)._next_2 = _this_._next_2;
    }
    _this_._next_2 = null;
    _this_._prev = null;
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(Object.create(LinkedHashMap.prototype));
  }
  LinkedHashMap.prototype.containsKey_7 = function (key_0) {
    return this._map_0.containsKey_7(key_0);
  };
  LinkedHashMap.prototype.containsValue_2 = function (value_0) {
    var tmp0_elvis_lhs = this._head;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node_0 = tmp;
    do {
      if (equals(node_0._get_value__13(), value_0)) {
        return true;
      }node_0 = ensureNotNull(node_0._next_2);
    }
     while (!(node_0 === this._head));
    return false;
  };
  LinkedHashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet_0(this);
  };
  LinkedHashMap.prototype.get_48 = function (key_0) {
    var tmp0_safe_receiver = this._map_0.get_48(key_0);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__13();
  };
  LinkedHashMap.prototype.put_6 = function (key_0, value_0) {
    this.checkIsMutable_13();
    var old = this._map_0.get_48(key_0);
    if (old == null) {
      var newEntry = new ChainEntry(this, key_0, value_0);
      this._map_0.put_6(key_0, newEntry);
      Unit_getInstance();
      addToEnd(newEntry, this);
      return null;
    } else {
      return old.setValue_1(value_0);
    }
  };
  LinkedHashMap.prototype.remove_43 = function (key_0) {
    this.checkIsMutable_13();
    var entry = this._map_0.remove_43(key_0);
    if (!(entry == null)) {
      remove(entry, this);
      return entry._get_value__13();
    }return null;
  };
  LinkedHashMap.prototype._get_size__45 = function () {
    return this._map_0._get_size__45();
  };
  LinkedHashMap.prototype.checkIsMutable_13 = function () {
    if (this._isReadOnly_0)
      throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedHashMap() {
    this._head = null;
    this._isReadOnly_0 = false;
  }
  LinkedHashMap.$metadata$ = {
    simpleName: 'LinkedHashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_2(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(Object.create(LinkedHashSet.prototype));
  }
  LinkedHashSet.prototype.checkIsMutable_13 = function () {
    return this._get_map__0().checkIsMutable_13();
  };
  function LinkedHashSet() {
  }
  LinkedHashSet.$metadata$ = {
    simpleName: 'LinkedHashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  function SafeContinuation_init_$Init$(delegate, $this) {
    SafeContinuation.call($this, delegate, CoroutineSingletons_UNDECIDED_getInstance());
    return $this;
  }
  function SafeContinuation_init_$Create$(delegate) {
    return SafeContinuation_init_$Init$(delegate, Object.create(SafeContinuation.prototype));
  }
  function SafeContinuation(delegate, initialResult) {
    this._delegate = delegate;
    this._result = initialResult;
  }
  SafeContinuation.prototype._get_context__22 = function () {
    return this._delegate._get_context__22();
  };
  SafeContinuation.prototype.resumeWith_15 = function (result) {
    var cur = this._result;
    if (cur === CoroutineSingletons_UNDECIDED_getInstance()) {
      this._result = _Result___get_value__impl_(result);
    } else if (cur === _get_COROUTINE_SUSPENDED_()) {
      this._result = CoroutineSingletons_RESUMED_getInstance();
      this._delegate.resumeWith_15(result);
    } else
      throw IllegalStateException_init_$Create$('Already resumed');
  };
  SafeContinuation.prototype.getOrThrow = function () {
    if (this._result === CoroutineSingletons_UNDECIDED_getInstance()) {
      this._result = _get_COROUTINE_SUSPENDED_();
      return _get_COROUTINE_SUSPENDED_();
    }var result = this._result;
    var tmp;
    if (result === CoroutineSingletons_RESUMED_getInstance()) {
      tmp = _get_COROUTINE_SUSPENDED_();
    } else {
      if (result instanceof Failure) {
        throw result._exception;
      } else {
        {
          tmp = result;
        }
      }
    }
    return tmp;
  };
  SafeContinuation.$metadata$ = {
    simpleName: 'SafeContinuation',
    kind: 'class',
    interfaces: [Continuation]
  };
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function nextDown(_this_) {
    var tmp;
    if (isNaN_0(_this_) ? true : _this_ === -Infinity) {
      tmp = _this_;
    } else if (_this_ === 0.0) {
      tmp = -4.9E-324;
    } else {
      var tmp2_fromBits_0 = DoubleCompanionObject_getInstance();
      var tmp0_plus_0 = toRawBits(_this_);
      var tmp1_plus_0 = _this_ > 0.0 ? -1 : 1;
      var tmp3_fromBits_0 = tmp0_plus_0.plus_53(toLong(tmp1_plus_0));
      tmp = doubleFromBits(tmp3_fromBits_0);
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function rotateLeft(_this_, bitCount) {
    return _this_ << bitCount | _this_ >>> (32 - bitCount | 0);
  }
  function rotateRight(_this_, bitCount) {
    return _this_ << (32 - bitCount | 0) | _this_ >>> bitCount;
  }
  function isInfinite(_this_) {
    return _this_ === Infinity ? true : _this_ === -Infinity;
  }
  function isFinite(_this_) {
    return !isInfinite(_this_) ? !isNaN_0(_this_) : false;
  }
  function countOneBits(_this_) {
    var v = _this_;
    v = (v & 1431655765) + (v >>> 1 & 1431655765) | 0;
    v = (v & 858993459) + (v >>> 2 & 858993459) | 0;
    v = (v & 252645135) + (v >>> 4 & 252645135) | 0;
    v = (v & 16711935) + (v >>> 8 & 16711935) | 0;
    v = (v & 65535) + (v >>> 16) | 0;
    return v;
  }
  var INV_2_26;
  var INV_2_53;
  function doubleFromParts(hi26, low27) {
    return hi26 * INV_2_26 + low27 * INV_2_53;
  }
  function defaultPlatformRandom() {
    var tmp0_unsafeCast_0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp0_unsafeCast_0);
  }
  function INV_2_26$init$() {
    var tmp0_pow_0 = 2.0;
    var tmp1_pow_0 = -26;
    return Math.pow(tmp0_pow_0, tmp1_pow_0);
  }
  function INV_2_53$init$() {
    var tmp0_pow_0 = 2.0;
    var tmp1_pow_0 = -53;
    return Math.pow(tmp0_pow_0, tmp1_pow_0);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KCallable() {
  }
  KCallable.$metadata$ = {
    simpleName: 'KCallable',
    kind: 'interface',
    interfaces: []
  };
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals(this._get_jClass__2(), other._get_jClass__2());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__4();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__4();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__4 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype._get_simpleName__4 = function () {
    var tmp0_error_0 = 'Unknown simpleName for ErrorKClass';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function KProperty1() {
  }
  KProperty1.$metadata$ = {
    simpleName: 'KProperty1',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KMutableProperty1() {
  }
  KMutableProperty1.$metadata$ = {
    simpleName: 'KMutableProperty1',
    kind: 'interface',
    interfaces: [KProperty1, KMutableProperty]
  };
  function KProperty() {
  }
  KProperty.$metadata$ = {
    simpleName: 'KProperty',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KMutableProperty() {
  }
  KMutableProperty.$metadata$ = {
    simpleName: 'KMutableProperty',
    kind: 'interface',
    interfaces: [KProperty]
  };
  var functionClasses;
  function _no_name_provided__12() {
  }
  _no_name_provided__12.prototype.invoke_54 = function (it) {
    return isObject(it);
  };
  _no_name_provided__12.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__13() {
  }
  _no_name_provided__13.prototype.invoke_54 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__13.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__14() {
  }
  _no_name_provided__14.prototype.invoke_54 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__14.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__15() {
  }
  _no_name_provided__15.prototype.invoke_54 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__15.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__16() {
  }
  _no_name_provided__16.prototype.invoke_54 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__16.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17() {
  }
  _no_name_provided__17.prototype.invoke_54 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__17.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__18() {
  }
  _no_name_provided__18.prototype.invoke_54 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__18.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__19() {
  }
  _no_name_provided__19.prototype.invoke_54 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__19.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__20() {
  }
  _no_name_provided__20.prototype.invoke_54 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__20.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__21() {
  }
  _no_name_provided__21.prototype.invoke_54 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__21.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__22() {
  }
  _no_name_provided__22.prototype.invoke_54 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__22.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23() {
  }
  _no_name_provided__23.prototype.invoke_54 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__23.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__24() {
  }
  _no_name_provided__24.prototype.invoke_54 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__24.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_54 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__25.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__26() {
  }
  _no_name_provided__26.prototype.invoke_54 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__26.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__27() {
  }
  _no_name_provided__27.prototype.invoke_54 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__27.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__28() {
  }
  _no_name_provided__28.prototype.invoke_54 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__28.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__29() {
  }
  _no_name_provided__29.prototype.invoke_54 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__29.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__30() {
  }
  _no_name_provided__30.prototype.invoke_54 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__30.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__31($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__31.prototype.invoke_54 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__31.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_6());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_7());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_8());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_9());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_10());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_11());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_12());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_13());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_14());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_15());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_16());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_17());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_18());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_19());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_20());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_21());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_22());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_23());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_24());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_25(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_6() {
    var i = new _no_name_provided__12();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_7() {
    var i = new _no_name_provided__13();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_8() {
    var i = new _no_name_provided__14();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_9() {
    var i = new _no_name_provided__15();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_10() {
    var i = new _no_name_provided__16();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__17();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__18();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__19();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__20();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__21();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__22();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__23();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__24();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__25();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__26();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__27();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_22() {
    var i = new _no_name_provided__28();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_23() {
    var i = new _no_name_provided__29();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_24() {
    var i = new _no_name_provided__30();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function _no_name_provided_$factory_25($arity) {
    var i = new _no_name_provided__31($arity);
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression_0(e) {
    var tmp0_subject = typeof e;
    var tmp;
    switch (tmp0_subject) {
      case 'string':
        tmp = PrimitiveClasses_getInstance()._stringClass;
        break;
      case 'number':
        var tmp_0;
        var tmp0_asDynamic_0 = jsBitwiseOr(e, 0);
        if (tmp0_asDynamic_0 === e) {
          tmp_0 = PrimitiveClasses_getInstance()._intClass;
        } else {
          {
            tmp_0 = PrimitiveClasses_getInstance()._doubleClass;
          }
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance()._booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        tmp = tmp_1.functionClass(e.length);
        break;
      default:var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance()._booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance()._charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance()._byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance()._shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance()._intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance()._longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance()._floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance()._doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass_0(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance()._arrayClass;
                          } else {
                            {
                              var constructor = Object.getPrototypeOf(e).constructor;
                              var tmp_3;
                              if (constructor === Object) {
                                tmp_3 = PrimitiveClasses_getInstance()._anyClass;
                              } else if (constructor === Error) {
                                tmp_3 = PrimitiveClasses_getInstance()._throwableClass;
                              } else {
                                var jsClass_0 = constructor;
                                tmp_3 = getKClass1_0(jsClass_0);
                              }
                              tmp_2 = tmp_3;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    var tmp1_unsafeCast_0 = tmp;
    return tmp1_unsafeCast_0;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$() {
    return StringBuilder_init_$Init$(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__0 = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.append_2 = function (value_0) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value_0;
    return this;
  };
  StringBuilder.prototype.append_3 = function (value_0) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value_0);
    return this;
  };
  StringBuilder.prototype.append_4 = function (value_0) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value_0);
    return this;
  };
  StringBuilder.prototype.append_5 = function (value_0) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    var tmp1_elvis_lhs = value_0;
    tmp._string = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function toDouble(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_also_0 = tmp0_unsafeCast_0;
    if ((isNaN_0(tmp1_also_0) ? !isNaN_1(_this_) : false) ? true : tmp1_also_0 === 0.0 ? isBlank(_this_) : false) {
      numberFormatError(_this_);
    }return tmp1_also_0;
  }
  function isNaN_1(_this_) {
    var tmp0_subject = _this_.toLowerCase();
    switch (tmp0_subject) {
      case 'nan':
      case '+nan':
      case '-nan':
        return true;
      default:return false;
    }
  }
  function isBlank(_this_) {
    var tmp;
    if (charSequenceLength(_this_) === 0) {
      tmp = true;
    } else {
      var tmp_0;
      if (typeof _this_ === 'string') {
        tmp_0 = _this_;
      } else {
        {
          tmp_0 = toString_1(_this_);
        }
      }
      tmp = matches(tmp_0, '^[\\s\\xA0]+$');
    }
    return tmp;
  }
  function matches(_this_, regex) {
    var result = _this_.match(regex);
    return !(result == null) ? !(result.length === 0) : false;
  }
  function addSuppressed(_this_, exception) {
    if (!(_this_ === exception)) {
      var tmp0_unsafeCast_0 = _this_._suppressed;
      var suppressed = tmp0_unsafeCast_0;
      if (suppressed == null) {
        _this_._suppressed = mutableListOf([exception]);
      } else {
        suppressed.add_37(exception);
        Unit_getInstance();
      }
    }}
  var DurationUnit_NANOSECONDS_instance;
  var DurationUnit_MICROSECONDS_instance;
  var DurationUnit_MILLISECONDS_instance;
  var DurationUnit_SECONDS_instance;
  var DurationUnit_MINUTES_instance;
  var DurationUnit_HOURS_instance;
  var DurationUnit_DAYS_instance;
  var DurationUnit_entriesInitialized;
  function DurationUnit_initEntries() {
    if (DurationUnit_entriesInitialized)
      return Unit_getInstance();
    DurationUnit_entriesInitialized = true;
    DurationUnit_NANOSECONDS_instance = new DurationUnit('NANOSECONDS', 0, 1.0);
    DurationUnit_MICROSECONDS_instance = new DurationUnit('MICROSECONDS', 1, 1000.0);
    DurationUnit_MILLISECONDS_instance = new DurationUnit('MILLISECONDS', 2, 1000000.0);
    DurationUnit_SECONDS_instance = new DurationUnit('SECONDS', 3, 1.0E9);
    DurationUnit_MINUTES_instance = new DurationUnit('MINUTES', 4, 6.0E10);
    DurationUnit_HOURS_instance = new DurationUnit('HOURS', 5, 3.6E12);
    DurationUnit_DAYS_instance = new DurationUnit('DAYS', 6, 8.64E13);
  }
  function DurationUnit(name, ordinal, scale) {
    Enum.call(this, name, ordinal);
    this._scale = scale;
  }
  DurationUnit.$metadata$ = {
    simpleName: 'DurationUnit',
    kind: 'class',
    interfaces: []
  };
  function convertDurationUnit(value_0, sourceUnit, targetUnit) {
    var sourceCompareTarget = compareTo(sourceUnit._scale, targetUnit._scale);
    return sourceCompareTarget > 0 ? value_0 * (sourceUnit._scale / targetUnit._scale) : sourceCompareTarget < 0 ? value_0 / (targetUnit._scale / sourceUnit._scale) : value_0;
  }
  function DurationUnit_NANOSECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_NANOSECONDS_instance;
  }
  function DurationUnit_MILLISECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_MILLISECONDS_instance;
  }
  function Char() {
  }
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Companion_6() {
    Companion_instance_5 = this;
  }
  Companion_6.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_6();
    return Companion_instance_5;
  }
  function Enum(name, ordinal) {
    Companion_getInstance_5();
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype._get_name__0 = function () {
    return this._name;
  };
  Enum.prototype.compareTo_2 = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_5 = function (other) {
    return this.compareTo_2(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last = array.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__32(array);
  }
  function intArrayIterator(array) {
    return new _no_name_provided__33(array);
  }
  function _no_name_provided__32($array) {
    this._$array = $array;
    this._index_1 = 0;
  }
  _no_name_provided__32.prototype.hasNext_27 = function () {
    return !(this._index_1 === this._$array.length);
  };
  _no_name_provided__32.prototype.next_28 = function () {
    var tmp;
    if (!(this._index_1 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_1;
      tmp0_this._index_1 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_1);
    }
    return tmp;
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _no_name_provided__33($array) {
    this._$array_0 = $array;
    IntIterator.call(this);
    this._index_2 = 0;
  }
  _no_name_provided__33.prototype.hasNext_27 = function () {
    return !(this._index_2 === this._$array_0.length);
  };
  _no_name_provided__33.prototype.nextInt_7 = function () {
    var tmp;
    if (!(this._index_2 === this._$array_0.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_2;
      tmp0_this._index_2 = tmp1 + 1 | 0;
      tmp = this._$array_0[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_2);
    }
    return tmp;
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var buf;
  var bufFloat64;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function doubleFromBits(value_0) {
    bufInt32[lowIndex] = value_0._low;
    bufInt32[highIndex] = value_0._high;
    return bufFloat64[0];
  }
  function doubleToRawBits(value_0) {
    bufFloat64[0] = value_0;
    return new Long(bufInt32[lowIndex], bufInt32[highIndex]);
  }
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__0();
    }
    return tmp;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_26(), 24, null);
  }
  function _no_name_provided__34() {
  }
  _no_name_provided__34.prototype.invoke_54 = function (it) {
    return toString_1(it);
  };
  _no_name_provided__34.prototype.invoke_468 = function (p1) {
    return this.invoke_54((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_26() {
    var i = new _no_name_provided__34();
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_4());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp0_asDynamic_0 = 1;
        var ia = tmp0_asDynamic_0 / a;
        var tmp_1;
        var tmp1_asDynamic_0 = 1;
        if (ia === tmp1_asDynamic_0 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_5(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last = length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last));
    return hash;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function equals(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp0_asDynamic_0 = 1;
          var tmp_1 = tmp0_asDynamic_0 / obj1;
          var tmp1_asDynamic_0 = 1;
          tmp_0 = tmp_1 === tmp1_asDynamic_0 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function boxIntrinsic(x) {
    var tmp0_error_0 = 'Should be lowered';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function unboxIntrinsic(x) {
    var tmp0_error_0 = 'Should be lowered';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function getContinuation() {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function returnIfSuspended(argument, $cont) {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function lazy(initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function arrayPlusCollection(array, collection) {
    var tmp0_unsafeCast_0 = array.slice();
    var result = tmp0_unsafeCast_0;
    result.length = result.length + collection._get_size__45() | 0;
    if (array.$type$ !== undefined) {
      result.$type$ = array.$type$;
    }var index = array.length;
    var tmp0_iterator = collection.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_28();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index = 0;
    var arr = dst;
    while (index < srcLen ? index < dstLen : false) {
      var tmp = index;
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      arr[tmp] = src[tmp0];
    }
    return dst;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    var tmp0_unsafeCast_0 = source.slice(0, newSize);
    var result = tmp0_unsafeCast_0;
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }var index = source.length;
    if (newSize > index) {
      result.length = newSize;
      while (index < newSize) {
        var tmp0 = index;
        index = tmp0 + 1 | 0;
        result[tmp0] = defaultValue;
      }
    }return result;
  }
  function Companion_7() {
    Companion_instance_6 = this;
    this._MIN_VALUE_1 = new Long(0, -2147483648);
    this._MAX_VALUE_1 = new Long(-1, 2147483647);
    this._SIZE_BYTES_1 = 8;
    this._SIZE_BITS_1 = 64;
  }
  Companion_7.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_7();
    return Companion_instance_6;
  }
  function Long(low, high) {
    Companion_getInstance_6();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_44 = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_5 = function (other) {
    return this.compareTo_44(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_53 = function (other) {
    return add(this, other);
  };
  Long.prototype.minus_27 = function (other) {
    return subtract(this, other);
  };
  Long.prototype.div_28 = function (other) {
    return divide(this, other);
  };
  Long.prototype.inc_4 = function () {
    return this.plus_53(new Long(1, 0));
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_53(new Long(1, 0));
  };
  Long.prototype.shl_0 = function (bitCount) {
    return shiftLeft(this, bitCount);
  };
  Long.prototype.shr_0 = function (bitCount) {
    return shiftRight(this, bitCount);
  };
  Long.prototype.and = function (other) {
    return new Long(this._low & other._low, this._high & other._high);
  };
  Long.prototype.or = function (other) {
    return new Long(this._low | other._low, this._high | other._high);
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_4 = function () {
    return this._low;
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_28(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_28(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_28(negate(other));
      } else {
        tmp = negate(negate(_this_).div_28(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_28(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta_0 = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta_0;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div = _this_.div_28(radixLong);
        var rem = subtract(multiply(div, radixLong), _this_).toInt_4();
        var tmp = toStringImpl(div, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_28(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_4();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value_0) {
    return new Long(value_0, value_0 < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value_0) {
    if (isNaN_0(value_0)) {
      return ZERO;
    } else if (value_0 <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value_0 + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value_0 < 0.0) {
      return negate(fromNumber(-value_0));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value_0 % twoPwr32, 0), jsBitwiseOr(value_0 / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_4();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      {
        tmp = fromNumber(a);
      }
    }
    return tmp;
  }
  function toLong(a) {
    return fromInt(a);
  }
  function numberRangeToNumber(start_0, endInclusive) {
    return new IntRange(start_0, endInclusive);
  }
  var propertyRefClassMetadataCache;
  function getPropertyCallableRef(name, paramCount, type_0, getter, setter) {
    getter.get = getter;
    getter.set = setter;
    getter.callableName = name;
    var tmp0_unsafeCast_0 = getPropertyRefClass(getter, getKPropMetadata(paramCount, setter, type_0));
    return tmp0_unsafeCast_0;
  }
  function getPropertyRefClass(obj, metadata) {
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    return obj;
  }
  function getKPropMetadata(paramCount, setter, type_0) {
    var mdata = propertyRefClassMetadataCache[paramCount][setter == null ? 0 : 1];
    if (mdata.interfaces.length == 0) {
      mdata.interfaces.push(type_0);
    }return mdata;
  }
  function propertyRefClassMetadataCache$init$() {
    var tmp = {kind: 'class', interfaces: []};
    var tmp0_arrayOf_0 = [tmp, {kind: 'class', interfaces: []}];
    var tmp_0 = tmp0_arrayOf_0;
    var tmp_1 = {kind: 'class', interfaces: []};
    var tmp1_arrayOf_0 = [tmp_1, {kind: 'class', interfaces: []}];
    var tmp_2 = tmp1_arrayOf_0;
    var tmp_3 = {kind: 'class', interfaces: []};
    var tmp2_arrayOf_0 = [tmp_3, {kind: 'class', interfaces: []}];
    var tmp3_arrayOf_0 = [tmp_0, tmp_2, tmp2_arrayOf_0];
    return tmp3_arrayOf_0;
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isComparable(value_0) {
    var type_0 = typeof value_0;
    return ((type_0 === 'string' ? true : type_0 === 'boolean') ? true : isNumber(value_0)) ? true : isInterface(value_0, _get_js_(getKClass_0(Comparable)));
  }
  function isCharSequence(value_0) {
    return typeof value_0 === 'string' ? true : isInterface(value_0, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function plus_0(_this_, elements) {
    return arrayPlusCollection(_this_, elements);
  }
  function fill(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function copyOf(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int32Array(newSize));
  }
  function copyOf_0(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return arrayCopyResize(_this_, newSize, null);
  }
  function fill_0(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function fill$default(_this_, element, fromIndex, toIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      fromIndex = 0;
    if (!(($mask0 & 4) === 0))
      toIndex = _this_.length;
    return fill_0(_this_, element, fromIndex, toIndex);
  }
  function copyOfRange(_this_, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    return _this_.slice(fromIndex, toIndex);
  }
  function releaseIntercepted($this) {
    var intercepted_0 = $this._intercepted_;
    if (!(intercepted_0 == null) ? !(intercepted_0 === $this) : false) {
      ensureNotNull($this._get_context__22().get_56(Key_getInstance())).releaseInterceptedContinuation_9(intercepted_0);
    }$this._intercepted_ = CompletedContinuation_getInstance();
  }
  function CoroutineImpl_0(resultContinuation) {
    this._resultContinuation = resultContinuation;
    this._state_1 = 0;
    this._exceptionState = 0;
    this._result_0 = null;
    this._exception_0 = null;
    this._finallyPath = null;
    var tmp = this;
    var tmp0_safe_receiver = this._resultContinuation;
    tmp.__context = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_context__22();
    this._intercepted_ = null;
  }
  CoroutineImpl_0.prototype._get_exception_ = function () {
    return this._exception_0;
  };
  CoroutineImpl_0.prototype._get_context__22 = function () {
    return ensureNotNull(this.__context);
  };
  CoroutineImpl_0.prototype.intercepted_9 = function () {
    var tmp2_elvis_lhs = this._intercepted_;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp0_safe_receiver = this._get_context__22().get_56(Key_getInstance());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptContinuation_9(this);
      var tmp0_also_0 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
      this._intercepted_ = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  };
  CoroutineImpl_0.prototype.resumeWith_25 = function (result) {
    var current_0 = this;
    var tmp;
    if (_Result___get_isFailure__impl_(result)) {
      tmp = null;
    } else {
      var tmp_0 = _Result___get_value__impl_(result);
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    }
    var currentResult = tmp;
    var currentException = Result__exceptionOrNull_impl(result);
    while (true) {
      var tmp0_with_0 = current_0;
      if (currentException == null) {
        tmp0_with_0._result_0 = currentResult;
      } else {
        tmp0_with_0._state_1 = tmp0_with_0._exceptionState;
        tmp0_with_0._exception_0 = currentException;
      }
      try {
        var outcome_2 = tmp0_with_0.doResume_11();
        if (outcome_2 === _get_COROUTINE_SUSPENDED_())
          return Unit_getInstance();
        currentResult = outcome_2;
        currentException = null;
      } catch ($p) {
        currentResult = null;
        currentException = $p;
      }
      releaseIntercepted(tmp0_with_0);
      var completion_4 = ensureNotNull(tmp0_with_0._resultContinuation);
      if (completion_4 instanceof CoroutineImpl_0) {
        current_0 = completion_4;
      } else {
        {
          if (!(currentException == null)) {
            var tmp0_resumeWithException_0_5 = ensureNotNull(currentException);
            var tmp0_failure_0_1_6 = Companion_getInstance_2();
            completion_4.resumeWith_15(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_5)));
          } else {
            var tmp1_resume_0_7 = currentResult;
            var tmp0_success_0_1_8 = Companion_getInstance_2();
            completion_4.resumeWith_15(_Result___init__impl_(tmp1_resume_0_7));
          }
          return Unit_getInstance();
        }
      }
    }
  };
  CoroutineImpl_0.prototype.resumeWith_15 = function (result) {
    return this.resumeWith_25(result);
  };
  CoroutineImpl_0.$metadata$ = {
    simpleName: 'CoroutineImpl',
    kind: 'class',
    interfaces: [Continuation]
  };
  function CompletedContinuation() {
    CompletedContinuation_instance = this;
  }
  CompletedContinuation.prototype._get_context__22 = function () {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_25 = function (result) {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_15 = function (result) {
    return this.resumeWith_25(result);
  };
  CompletedContinuation.prototype.toString = function () {
    return 'This continuation is already complete';
  };
  CompletedContinuation.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'object',
    interfaces: [Continuation]
  };
  var CompletedContinuation_instance;
  function CompletedContinuation_getInstance() {
    if (CompletedContinuation_instance == null)
      new CompletedContinuation();
    return CompletedContinuation_instance;
  }
  function intercepted(_this_) {
    var tmp0_safe_receiver = _this_ instanceof CoroutineImpl_0 ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.intercepted_9();
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function createCoroutineUnintercepted(_this_, receiver, completion) {
    return new _no_name_provided__1_0(_this_, receiver, completion);
  }
  function _no_name_provided__1_0($this_createCoroutineUnintercepted, $receiver, $completion) {
    this._$this_createCoroutineUnintercepted = $this_createCoroutineUnintercepted;
    this._$receiver = $receiver;
    this._$completion = $completion;
    CoroutineImpl_0.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  _no_name_provided__1_0.prototype.doResume_2 = function () {
    if (this._get_exception_() != null)
      throw this._get_exception_();
    return this._$this_createCoroutineUnintercepted(this._$receiver, this._$completion);
  };
  _no_name_provided__1_0.prototype.doResume_11 = function () {
    return this.doResume_2();
  };
  _no_name_provided__1_0.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: []
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Exception.call($this);
    return $this;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function Error_init_$Init$(message, $this) {
    extendThrowable($this, message, void 1);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Init$_0(message, cause, $this) {
    extendThrowable($this, message, cause);
    Error_0.call($this);
    return $this;
  }
  function Error_0() {
    captureStack(this, Error_0);
  }
  Error_0.$metadata$ = {
    simpleName: 'Error',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$(message, cause) {
    var tmp = RuntimeException_init_$Init$_1(message, cause, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$(message) {
    var tmp = IllegalStateException_init_$Init$(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message, cause) {
    var tmp = IllegalStateException_init_$Init$_0(message, cause, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function ConcurrentModificationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$() {
    var tmp = ConcurrentModificationException_init_$Init$(Object.create(ConcurrentModificationException.prototype));
    captureStack(tmp, ConcurrentModificationException_init_$Create$);
    return tmp;
  }
  function ConcurrentModificationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$_0(message) {
    var tmp = ConcurrentModificationException_init_$Init$_0(message, Object.create(ConcurrentModificationException.prototype));
    captureStack(tmp, ConcurrentModificationException_init_$Create$_0);
    return tmp;
  }
  function ConcurrentModificationException() {
    captureStack(this, ConcurrentModificationException);
  }
  ConcurrentModificationException.$metadata$ = {
    simpleName: 'ConcurrentModificationException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function ArithmeticException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$(message) {
    var tmp = ArithmeticException_init_$Init$(message, Object.create(ArithmeticException.prototype));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  ArithmeticException.$metadata$ = {
    simpleName: 'ArithmeticException',
    kind: 'class',
    interfaces: []
  };
  function AssertionError_init_$Init$(message, $this) {
    Error_init_$Init$(message, $this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$(message) {
    var tmp = AssertionError_init_$Init$(message, Object.create(AssertionError.prototype));
    captureStack(tmp, AssertionError_init_$Create$);
    return tmp;
  }
  function AssertionError() {
    captureStack(this, AssertionError);
  }
  AssertionError.$metadata$ = {
    simpleName: 'AssertionError',
    kind: 'class',
    interfaces: []
  };
  function NumberFormatException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$(message) {
    var tmp = NumberFormatException_init_$Init$(message, Object.create(NumberFormatException.prototype));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  NumberFormatException.$metadata$ = {
    simpleName: 'NumberFormatException',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(Object.create(NoWhenBranchMatchedException.prototype));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  NoWhenBranchMatchedException.$metadata$ = {
    simpleName: 'NoWhenBranchMatchedException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack in rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = typeof value_hack;
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    delete obj_hack[property_hack];
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = obj_hack instanceof jsClass_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function toRawBits(_this_) {
    return doubleToRawBits(_this_);
  }
  function None() {
    None_instance = this;
    TraceBase.call(this);
  }
  None.$metadata$ = {
    simpleName: 'None',
    kind: 'object',
    interfaces: []
  };
  var None_instance;
  function None_getInstance() {
    if (None_instance == null)
      new None();
    return None_instance;
  }
  function TraceBase() {
  }
  TraceBase.prototype.atomicfu$Trace$append$1 = function (event) {
  };
  TraceBase.prototype.atomicfu$Trace$append$2 = function (event1, event2) {
  };
  TraceBase.prototype.atomicfu$Trace$append$3 = function (event1, event2, event3) {
  };
  TraceBase.prototype.atomicfu$Trace$append$4 = function (event1, event2, event3, event4) {
  };
  TraceBase.$metadata$ = {
    simpleName: 'TraceBase',
    kind: 'class',
    interfaces: []
  };
  function AtomicRef(value_0) {
    this._value = value_0;
  }
  AtomicRef.prototype._set_value__5 = function (_set___) {
    this._value = _set___;
  };
  AtomicRef.prototype._get_value__13 = function () {
    return this._value;
  };
  AtomicRef.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this._value === expect))
      return false;
    this._value = update;
    return true;
  };
  AtomicRef.prototype.atomicfu$getAndSet = function (value_0) {
    var oldValue = this._value;
    this._value = value_0;
    return oldValue;
  };
  AtomicRef.prototype.toString = function () {
    return toString_0(this._value);
  };
  AtomicRef.$metadata$ = {
    simpleName: 'AtomicRef',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicRef.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicRef.prototype._get_value__13,
    set: AtomicRef.prototype._set_value__5
  });
  function atomic(initial) {
    return atomic_2(initial, None_getInstance());
  }
  function AtomicBoolean(value_0) {
    this._value_0 = value_0;
  }
  AtomicBoolean.prototype._set_value__0 = function (_set___) {
    this._value_0 = _set___;
  };
  AtomicBoolean.prototype._get_value__13 = function () {
    return this._value_0;
  };
  AtomicBoolean.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this._value_0 === expect))
      return false;
    this._value_0 = update;
    return true;
  };
  AtomicBoolean.prototype.atomicfu$getAndSet = function (value_0) {
    var oldValue = this._value_0;
    this._value_0 = value_0;
    return oldValue;
  };
  AtomicBoolean.prototype.toString = function () {
    return this._value_0.toString();
  };
  AtomicBoolean.$metadata$ = {
    simpleName: 'AtomicBoolean',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicBoolean.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicBoolean.prototype._get_value__13,
    set: AtomicBoolean.prototype._set_value__0
  });
  function atomic_0(initial) {
    return atomic_3(initial, None_getInstance());
  }
  function AtomicInt(value_0) {
    this._value_1 = value_0;
  }
  AtomicInt.prototype._set_value__1 = function (_set___) {
    this._value_1 = _set___;
  };
  AtomicInt.prototype._get_value__13 = function () {
    return this._value_1;
  };
  AtomicInt.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this._value_1 === expect))
      return false;
    this._value_1 = update;
    return true;
  };
  AtomicInt.prototype.atomicfu$getAndSet = function (value_0) {
    var oldValue = this._value_1;
    this._value_1 = value_0;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$getAndIncrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_1;
    tmp0_this._value_1 = tmp1 + 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndDecrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_1;
    tmp0_this._value_1 = tmp1 - 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndAdd = function (delta_0) {
    var oldValue = this._value_1;
    var tmp0_this = this;
    tmp0_this._value_1 = tmp0_this._value_1 + delta_0 | 0;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$addAndGet = function (delta_0) {
    var tmp0_this = this;
    tmp0_this._value_1 = tmp0_this._value_1 + delta_0 | 0;
    return this._value_1;
  };
  AtomicInt.prototype.atomicfu$incrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this._value_1 = tmp0_this._value_1 + 1 | 0;
    return tmp0_this._value_1;
  };
  AtomicInt.prototype.atomicfu$decrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this._value_1 = tmp0_this._value_1 - 1 | 0;
    return tmp0_this._value_1;
  };
  AtomicInt.prototype.toString = function () {
    return this._value_1.toString();
  };
  AtomicInt.$metadata$ = {
    simpleName: 'AtomicInt',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicInt.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicInt.prototype._get_value__13,
    set: AtomicInt.prototype._set_value__1
  });
  function atomic_1(initial) {
    return atomic_4(initial, None_getInstance());
  }
  function atomic_2(initial, trace) {
    return new AtomicRef(initial);
  }
  function atomic_3(initial, trace) {
    return new AtomicBoolean(initial);
  }
  function atomic_4(initial, trace) {
    return new AtomicInt(initial);
  }
  function AbstractCoroutine(parentContext, active) {
    JobSupport.call(this, active);
    this._parentContext = parentContext;
    this._context = this._parentContext.plus_25(this);
  }
  AbstractCoroutine.prototype._get_context__22 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_coroutineContext__6 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_isActive__20 = function () {
    return JobSupport.prototype._get_isActive__20.call(this);
  };
  AbstractCoroutine.prototype.initParentJob_4 = function () {
    this.initParentJobInternal_7(this._parentContext.get_56(Key_getInstance_2()));
  };
  AbstractCoroutine.prototype.onStart_4 = function () {
  };
  AbstractCoroutine.prototype.onStartInternal_7 = function () {
    this.onStart_4();
  };
  AbstractCoroutine.prototype.onCompleted_4 = function (value_0) {
  };
  AbstractCoroutine.prototype.onCancelled_4 = function (cause, handled) {
  };
  AbstractCoroutine.prototype.cancellationExceptionMessage_7 = function () {
    return '' + _get_classSimpleName_(this) + ' was cancelled';
  };
  AbstractCoroutine.prototype.onCompletionInternal_7 = function (state) {
    if (state instanceof CompletedExceptionally)
      this.onCancelled_4(state._cause, state._get_handled__0());
    else {
      {
        this.onCompleted_4((state == null ? true : isObject(state)) ? state : THROW_CCE());
      }
    }
  };
  AbstractCoroutine.prototype.resumeWith_15 = function (result) {
    var state = this.makeCompletingOnce_5(toState$default(result, null, 1, null));
    if (state === COMPLETING_WAITING_CHILDREN)
      return Unit_getInstance();
    this.afterResume_4(state);
  };
  AbstractCoroutine.prototype.afterResume_4 = function (state) {
    return this.afterCompletion_7(state);
  };
  AbstractCoroutine.prototype.handleOnCompletionException_7 = function (exception) {
    handleCoroutineException(this._context, exception);
  };
  AbstractCoroutine.prototype.nameString_8 = function () {
    var tmp0_elvis_lhs = _get_coroutineName_(this._context);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return JobSupport.prototype.nameString_8.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '' + '"' + coroutineName + '":' + JobSupport.prototype.nameString_8.call(this);
  };
  AbstractCoroutine.prototype.start_0 = function (start_0, receiver, block) {
    this.initParentJob_4();
    start_0.invoke_59(block, receiver, this);
  };
  AbstractCoroutine.$metadata$ = {
    simpleName: 'AbstractCoroutine',
    kind: 'class',
    interfaces: [Job, Continuation, CoroutineScope]
  };
  function launch(_this_, context, start_0, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start_0._get_isLazy_() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.start_0(start_0, coroutine, block);
    return coroutine;
  }
  function launch$default(_this_, context, start_0, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      context = EmptyCoroutineContext_getInstance();
    if (!(($mask0 & 2) === 0))
      start_0 = CoroutineStart_DEFAULT_getInstance();
    return launch(_this_, context, start_0, block);
  }
  function withContext(context, block, $cont) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0__anonymous__1 = $cont;
      var oldContext_2 = tmp0__anonymous__1._get_context__22();
      var newContext_3 = oldContext_2.plus_25(context);
      checkCompletion(newContext_3);
      if (newContext_3 === oldContext_2) {
        var coroutine_4 = new ScopeCoroutine(newContext_3, tmp0__anonymous__1);
        tmp$ret$0 = startUndispatchedOrReturn(coroutine_4, coroutine_4, block);
        break l$ret$1;
      }if (equals(newContext_3.get_56(Key_getInstance()), oldContext_2.get_56(Key_getInstance()))) {
        var coroutine_5 = new UndispatchedCoroutine(newContext_3, tmp0__anonymous__1);
        var tmp0_withCoroutineContext_0_6 = null;
        tmp$ret$0 = startUndispatchedOrReturn(coroutine_5, coroutine_5, block);
        break l$ret$1;
      }var coroutine_7 = new DispatchedCoroutine(newContext_3, tmp0__anonymous__1);
      coroutine_7.initParentJob_4();
      startCoroutineCancellable$default(block, coroutine_7, coroutine_7, null, 4, null);
      tmp$ret$0 = coroutine_7.getResult_0();
    }
     while (false);
    return tmp$ret$0;
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, active);
  }
  StandaloneCoroutine.prototype.handleJobException_7 = function (exception) {
    handleCoroutineException(this._get_context__22(), exception);
    return true;
  };
  StandaloneCoroutine.$metadata$ = {
    simpleName: 'StandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this._continuation = createCoroutineUnintercepted(block, this, this);
  }
  LazyStandaloneCoroutine.prototype.onStart_4 = function () {
    startCoroutineCancellable_0(this._continuation, this);
  };
  LazyStandaloneCoroutine.$metadata$ = {
    simpleName: 'LazyStandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function trySuspend($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_1;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:var tmp0_error_0_3 = 'Already suspended';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function tryResume($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_1;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:var tmp0_error_0_3 = 'Already resumed';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function DispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
    this.__decision = atomic_1(0);
  }
  DispatchedCoroutine.prototype.afterCompletion_7 = function (state) {
    this.afterResume_4(state);
  };
  DispatchedCoroutine.prototype.afterResume_4 = function (state) {
    if (tryResume(this))
      return Unit_getInstance();
    var tmp = intercepted(this._get_uCont__1());
    var tmp_0 = recoverResult(state, this._get_uCont__1());
    resumeCancellableWith$default(tmp, tmp_0, null, 2, null);
  };
  DispatchedCoroutine.prototype.getResult_0 = function () {
    if (trySuspend(this))
      return _get_COROUTINE_SUSPENDED_();
    var state = unboxState(this._get_state__8());
    if (state instanceof CompletedExceptionally)
      throw state._cause;
    else {
    }
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedCoroutine.$metadata$ = {
    simpleName: 'DispatchedCoroutine',
    kind: 'class',
    interfaces: []
  };
  function CancellableContinuation() {
  }
  CancellableContinuation.prototype.cancel$default_4 = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.cancel_4(cause) : $handler(cause);
  };
  CancellableContinuation.$metadata$ = {
    simpleName: 'CancellableContinuation',
    kind: 'interface',
    interfaces: [Continuation]
  };
  function _set_parentHandle_($this, value_0) {
    $this.__parentHandle._value = value_0;
  }
  function _get_parentHandle_($this) {
    return $this.__parentHandle._value;
  }
  function _get_stateDebugRepresentation_($this) {
    var tmp0_subject = $this._get_state__8();
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
      tmp = 'Active';
    } else {
      if (tmp0_subject instanceof CancelledContinuation) {
        tmp = 'Cancelled';
      } else {
        {
          tmp = 'Completed';
        }
      }
    }
    return tmp;
  }
  function isReusable($this) {
    var tmp;
    var tmp_0 = $this._delegate_0;
    if (tmp_0 instanceof DispatchedContinuation) {
      tmp = $this._delegate_0.isReusable($this);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function setupCancellation($this) {
    if (checkCompleted($this))
      return Unit_getInstance();
    if (!(_get_parentHandle_($this) === null))
      return Unit_getInstance();
    var tmp0_elvis_lhs = $this._delegate_0._get_context__22().get_56(Key_getInstance_2());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent_0 = tmp;
    var tmp0__get_asHandler__0 = new ChildContinuation($this);
    var handle = parent_0.invokeOnCompletion$default_8(true, false, tmp0__get_asHandler__0, 2, null);
    _set_parentHandle_($this, handle);
    if ($this._get_isCompleted__8() ? !isReusable($this) : false) {
      handle.dispose_20();
      _set_parentHandle_($this, NonDisposableHandle_getInstance());
    }}
  function checkCompleted($this) {
    var completed = $this._get_isCompleted__8();
    if (!_get_isReusableMode_($this._get_resumeMode__0()))
      return completed;
    var tmp = $this._delegate_0;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return completed;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    var tmp1_elvis_lhs = dispatched.checkPostponedCancellation($this);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return completed;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var cause = tmp_1;
    if (!completed) {
      $this.cancel_4(cause);
      Unit_getInstance();
    }return true;
  }
  function cancelLater($this, cause) {
    if (!_get_isReusableMode_($this._get_resumeMode__0()))
      return false;
    var tmp = $this._delegate_0;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    return dispatched.postponeCancellation(cause);
  }
  function callCancelHandler($this, handler, cause) {
    var tmp;
    try {
      tmp = invokeIt(handler, cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException($this._get_context__22(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + $this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function trySuspend_0($this) {
    var tmp0_loop_0 = $this.__decision_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_1;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision_0.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:var tmp0_error_0_3 = 'Already suspended';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function tryResume_0($this) {
    var tmp0_loop_0 = $this.__decision_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_1;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision_0.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:var tmp0_error_0_3 = 'Already resumed';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function multipleHandlersError($this, handler, state) {
    var tmp0_error_0 = '' + "It's prohibited to register multiple handlers, tried to register " + handler + ', already has ' + state;
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function makeCancelHandler($this, handler) {
    var tmp;
    if (handler instanceof CancelHandler) {
      tmp = handler;
    } else {
      {
        tmp = new InvokeOnCancel(handler);
      }
    }
    return tmp;
  }
  function dispatchResume($this, mode) {
    if (tryResume_0($this))
      return Unit_getInstance();
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      tmp = proposedUpdate;
    } else {
      if (!_get_isCancellableMode_(resumeMode) ? idempotent == null : false) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (state instanceof CancelHandler) {
            tmp_2 = !(state instanceof BeforeResumeCancelHandler);
          } else {
            {
              tmp_2 = false;
            }
          }
          tmp_1 = tmp_2;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          {
            tmp_0 = !(idempotent == null);
          }
        }
        if (tmp_0) {
          var tmp_3 = state instanceof CancelHandler ? state : null;
          tmp = CompletedContinuation_init_$Create$(proposedUpdate, tmp_3, onCancellation, idempotent, null, 16, null);
        } else {
          {
            tmp = proposedUpdate;
          }
        }
      }
    }
    return tmp;
  }
  function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, resumeMode, onCancellation, null);
          if (!$this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          dispatchResume($this, resumeMode);
          return Unit_getInstance();
        } else {
          if (tmp0_subject_2 instanceof CancelledContinuation) {
            if (tmp1__anonymous__1.makeResumed()) {
              var tmp1_safe_receiver_4 = onCancellation;
              if (tmp1_safe_receiver_4 == null)
                null;
              else {
                $this.callOnCancellation(tmp1_safe_receiver_4, tmp1__anonymous__1._get_cause__20());
                Unit_getInstance();
              }
              Unit_getInstance();
              return Unit_getInstance();
            }} else {
          }
        }
        alreadyResumedError($this, proposedUpdate);
      }
       while (false);
    }
    Unit_getInstance();
  }
  function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      onCancellation = null;
    return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
  }
  function alreadyResumedError($this, proposedUpdate) {
    var tmp0_error_0 = '' + 'Already resumed, but proposed with update ' + proposedUpdate;
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function detachChildIfNonResuable($this) {
    if (!isReusable($this))
      $this.detachChild();
  }
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this._delegate_0 = delegate;
    this._context_0 = this._delegate_0._get_context__22();
    this.__decision_0 = atomic_1(0);
    this.__state = atomic(Active_getInstance());
    this.__parentHandle = atomic(null);
  }
  CancellableContinuationImpl.prototype._get_delegate__1 = function () {
    return this._delegate_0;
  };
  CancellableContinuationImpl.prototype._get_context__22 = function () {
    return this._context_0;
  };
  CancellableContinuationImpl.prototype._get_state__8 = function () {
    return this.__state._value;
  };
  CancellableContinuationImpl.prototype._get_isCompleted__8 = function () {
    var tmp = this._get_state__8();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  CancellableContinuationImpl.prototype.initCancellability = function () {
    setupCancellation(this);
  };
  CancellableContinuationImpl.prototype.takeState_1 = function () {
    return this._get_state__8();
  };
  CancellableContinuationImpl.prototype.cancelCompletedResult_1 = function (takenState, cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
        var tmp0_error_0_3 = 'Not completed';
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      } else {
        if (tmp0_subject_2 instanceof CompletedExceptionally)
          return Unit_getInstance();
        else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp1_check_0_4 = !tmp1__anonymous__1._get_cancelled_();
            if (!tmp1_check_0_4) {
              var message_1_5 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$(toString_1(message_1_5));
            }var tmp = tmp1__anonymous__1;
            var update_6 = tmp.copy$default(null, null, null, null, cause, 15, null);
            if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_6)) {
              tmp1__anonymous__1.invokeHandlers(this, cause);
              return Unit_getInstance();
            }} else {
            {
              if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, CompletedContinuation_init_$Create$(tmp1__anonymous__1, null, null, null, cause, 14, null))) {
                return Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.cancel_4 = function (cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value;
        if (!(!(tmp1__anonymous__1 == null) ? isInterface(tmp1__anonymous__1, NotCompleted) : false))
          return false;
        else {
        }
        var update_2 = new CancelledContinuation(this, cause, tmp1__anonymous__1 instanceof CancelHandler);
        if (!this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_2)) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var tmp0_safe_receiver_3 = tmp1__anonymous__1 instanceof CancelHandler ? tmp1__anonymous__1 : null;
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          this.callCancelHandler(tmp0_safe_receiver_3, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
        detachChildIfNonResuable(this);
        dispatchResume(this, this._get_resumeMode__0());
        return true;
      }
       while (false);
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.parentCancelled_3 = function (cause) {
    if (cancelLater(this, cause))
      return Unit_getInstance();
    this.cancel_4(cause);
    Unit_getInstance();
    detachChildIfNonResuable(this);
  };
  CancellableContinuationImpl.prototype.callCancelHandler = function (handler, cause) {
    var tmp;
    try {
      tmp = handler.invoke(cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException(this._get_context__22(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.callOnCancellation = function (onCancellation, cause) {
    try {
      onCancellation(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineException(this._get_context__22(), new CompletionHandlerException('' + 'Exception in resume onCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
    }
  };
  CancellableContinuationImpl.prototype.getContinuationCancellationCause = function (parent_0) {
    return parent_0.getCancellationException_8();
  };
  CancellableContinuationImpl.prototype.getResult_0 = function () {
    setupCancellation(this);
    if (trySuspend_0(this))
      return _get_COROUTINE_SUSPENDED_();
    var state = this._get_state__8();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state._cause, this);
    else {
    }
    if (_get_isCancellableMode_(this._get_resumeMode__0())) {
      var job = this._get_context__22().get_56(Key_getInstance_2());
      if (!(job == null) ? !job._get_isActive__20() : false) {
        var cause = job.getCancellationException_8();
        this.cancelCompletedResult_1(state, cause);
        throw recoverStackTrace(cause, this);
      }}return this.getSuccessfulResult_1(state);
  };
  CancellableContinuationImpl.prototype.resumeWith_15 = function (result) {
    var tmp = toState(result, this);
    var tmp_0 = this._get_resumeMode__0();
    return resumeImpl$default(this, tmp, tmp_0, null, 8, null);
  };
  CancellableContinuationImpl.prototype.invokeOnCancellation_0 = function (handler) {
    var cancelHandler = makeCancelHandler(this, handler);
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Active) {
        if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, cancelHandler))
          return Unit_getInstance();
      } else {
        if (tmp0_subject_2 instanceof CancelHandler)
          multipleHandlersError(this, handler, tmp1__anonymous__1);
        else {
          if (tmp0_subject_2 instanceof CompletedExceptionally) {
            if (!tmp1__anonymous__1.makeHandled_0())
              multipleHandlersError(this, handler, tmp1__anonymous__1);
            if (tmp1__anonymous__1 instanceof CancelledContinuation) {
              var tmp1_safe_receiver_3 = tmp1__anonymous__1 instanceof CompletedExceptionally ? tmp1__anonymous__1 : null;
              callCancelHandler(this, handler, tmp1_safe_receiver_3 == null ? null : tmp1_safe_receiver_3._cause);
            } else {
            }
            return Unit_getInstance();
          } else {
            if (tmp0_subject_2 instanceof CompletedContinuation_0) {
              if (!(tmp1__anonymous__1._cancelHandler == null))
                multipleHandlersError(this, handler, tmp1__anonymous__1);
              if (cancelHandler instanceof BeforeResumeCancelHandler)
                return Unit_getInstance();
              else {
              }
              if (tmp1__anonymous__1._get_cancelled_()) {
                callCancelHandler(this, handler, tmp1__anonymous__1._cancelCause);
                return Unit_getInstance();
              }var tmp = tmp1__anonymous__1;
              var update_4 = tmp.copy$default(null, cancelHandler, null, null, null, 29, null);
              if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_4))
                return Unit_getInstance();
            } else {
              {
                if (cancelHandler instanceof BeforeResumeCancelHandler)
                  return Unit_getInstance();
                else {
                }
                var update_5 = CompletedContinuation_init_$Create$(tmp1__anonymous__1, cancelHandler, null, null, null, 28, null);
                if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_5))
                  return Unit_getInstance();
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.detachChild = function () {
    var handle = _get_parentHandle_(this);
    var tmp0_safe_receiver = handle;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_20();
      Unit_getInstance();
    }
    Unit_getInstance();
    _set_parentHandle_(this, NonDisposableHandle_getInstance());
  };
  CancellableContinuationImpl.prototype.getSuccessfulResult_1 = function (state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof CompletedContinuation_0) {
      var tmp_0 = state._result_1;
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    } else {
      {
        tmp = (state == null ? true : isObject(state)) ? state : THROW_CCE();
      }
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.getExceptionalResult_1 = function (state) {
    var tmp0_safe_receiver = DispatchedTask.prototype.getExceptionalResult_1.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = recoverStackTrace(tmp0_safe_receiver, this._delegate_0);
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.toString = function () {
    return '' + this.nameString_8() + '(' + toDebugString(this._delegate_0) + '){' + _get_stateDebugRepresentation_(this) + '}@' + _get_hexAddress_(this);
  };
  CancellableContinuationImpl.prototype.nameString_8 = function () {
    return 'CancellableContinuation';
  };
  CancellableContinuationImpl.$metadata$ = {
    simpleName: 'CancellableContinuationImpl',
    kind: 'class',
    interfaces: [CancellableContinuation, CoroutineStackFrame]
  };
  function CancelHandler() {
    CancelHandlerBase.call(this);
  }
  CancelHandler.$metadata$ = {
    simpleName: 'CancelHandler',
    kind: 'class',
    interfaces: [NotCompleted]
  };
  function Active() {
    Active_instance = this;
  }
  Active.prototype.toString = function () {
    return 'Active';
  };
  Active.$metadata$ = {
    simpleName: 'Active',
    kind: 'object',
    interfaces: [NotCompleted]
  };
  var Active_instance;
  function Active_getInstance() {
    if (Active_instance == null)
      new Active();
    return Active_instance;
  }
  function NotCompleted() {
  }
  NotCompleted.$metadata$ = {
    simpleName: 'NotCompleted',
    kind: 'interface',
    interfaces: []
  };
  function CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      cancelHandler = null;
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    if (!(($mask0 & 8) === 0))
      idempotentResume = null;
    if (!(($mask0 & 16) === 0))
      cancelCause = null;
    CompletedContinuation_0.call($this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
    return $this;
  }
  function CompletedContinuation_init_$Create$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker) {
    return CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, Object.create(CompletedContinuation_0.prototype));
  }
  function CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    this._result_1 = result;
    this._cancelHandler = cancelHandler;
    this._onCancellation = onCancellation;
    this._idempotentResume = idempotentResume;
    this._cancelCause = cancelCause;
  }
  CompletedContinuation_0.prototype._get_cancelled_ = function () {
    return !(this._cancelCause == null);
  };
  CompletedContinuation_0.prototype.invokeHandlers = function (cont, cause) {
    var tmp0_safe_receiver = this._cancelHandler;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cont.callCancelHandler(tmp0_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._onCancellation;
    if (tmp1_safe_receiver == null)
      null;
    else {
      cont.callOnCancellation(tmp1_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CompletedContinuation_0.prototype.copy = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.copy$default = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      result = this._result_1;
    if (!(($mask0 & 2) === 0))
      cancelHandler = this._cancelHandler;
    if (!(($mask0 & 4) === 0))
      onCancellation = this._onCancellation;
    if (!(($mask0 & 8) === 0))
      idempotentResume = this._idempotentResume;
    if (!(($mask0 & 16) === 0))
      cancelCause = this._cancelCause;
    return this.copy(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.toString = function () {
    return '' + 'CompletedContinuation(result=' + this._result_1 + ', cancelHandler=' + this._cancelHandler + ', onCancellation=' + this._onCancellation + ', idempotentResume=' + this._idempotentResume + ', cancelCause=' + this._cancelCause + ')';
  };
  CompletedContinuation_0.prototype.hashCode = function () {
    var result = this._result_1 == null ? 0 : hashCode(this._result_1);
    result = imul(result, 31) + (this._cancelHandler == null ? 0 : hashCode(this._cancelHandler)) | 0;
    result = imul(result, 31) + (this._onCancellation == null ? 0 : hashCode(this._onCancellation)) | 0;
    result = imul(result, 31) + (this._idempotentResume == null ? 0 : hashCode(this._idempotentResume)) | 0;
    result = imul(result, 31) + (this._cancelCause == null ? 0 : hashCode(this._cancelCause)) | 0;
    return result;
  };
  CompletedContinuation_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedContinuation_0 ? other : THROW_CCE();
    if (!equals(this._result_1, tmp0_other_with_cast._result_1))
      return false;
    if (!equals(this._cancelHandler, tmp0_other_with_cast._cancelHandler))
      return false;
    if (!equals(this._onCancellation, tmp0_other_with_cast._onCancellation))
      return false;
    if (!equals(this._idempotentResume, tmp0_other_with_cast._idempotentResume))
      return false;
    if (!equals(this._cancelCause, tmp0_other_with_cast._cancelCause))
      return false;
    return true;
  };
  CompletedContinuation_0.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'class',
    interfaces: []
  };
  function BeforeResumeCancelHandler() {
  }
  BeforeResumeCancelHandler.$metadata$ = {
    simpleName: 'BeforeResumeCancelHandler',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCancel(handler) {
    CancelHandler.call(this);
    this._handler = handler;
  }
  InvokeOnCancel.prototype.invoke_136 = function (cause) {
    this._handler(cause);
  };
  InvokeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_136(cause);
  };
  InvokeOnCancel.prototype.toString = function () {
    return '' + 'InvokeOnCancel[' + _get_classSimpleName_(this._handler) + '@' + _get_hexAddress_(this) + ']';
  };
  InvokeOnCancel.$metadata$ = {
    simpleName: 'InvokeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function CompletableJob() {
  }
  CompletableJob.$metadata$ = {
    simpleName: 'CompletableJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      handled = false;
    CompletedExceptionally.call($this, cause, handled);
    return $this;
  }
  function CompletedExceptionally_init_$Create$(cause, handled, $mask0, $marker) {
    return CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, Object.create(CompletedExceptionally.prototype));
  }
  function CompletedExceptionally(cause, handled) {
    this._cause = cause;
    this.__handled = atomic_0(handled);
  }
  CompletedExceptionally.prototype._get_cause__20 = function () {
    return this._cause;
  };
  CompletedExceptionally.prototype._get_handled__0 = function () {
    return this.__handled._value_0;
  };
  CompletedExceptionally.prototype.makeHandled_0 = function () {
    return this.__handled.atomicfu$compareAndSet(false, true);
  };
  CompletedExceptionally.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '[' + this._cause + ']';
  };
  CompletedExceptionally.$metadata$ = {
    simpleName: 'CompletedExceptionally',
    kind: 'class',
    interfaces: []
  };
  function CancelledContinuation(continuation, cause, handled) {
    var tmp0_elvis_lhs = cause;
    CompletedExceptionally.call(this, tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + 'Continuation ' + continuation + ' was cancelled normally') : tmp0_elvis_lhs, handled);
    this.__resumed = atomic_0(false);
  }
  CancelledContinuation.prototype.makeResumed = function () {
    return this.__resumed.atomicfu$compareAndSet(false, true);
  };
  CancelledContinuation.$metadata$ = {
    simpleName: 'CancelledContinuation',
    kind: 'class',
    interfaces: []
  };
  function toState(_this_, caller) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = tmp0__anonymous__2;
    } else {
      var tmp_1 = recoverStackTrace(exception_1, caller);
      tmp = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
    }
    return tmp;
  }
  function toState_0(_this_, onCancellation) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = !(onCancellation == null) ? new CompletedWithCancellation(tmp0__anonymous__2, onCancellation) : tmp0__anonymous__2;
    } else {
      tmp = CompletedExceptionally_init_$Create$(exception_1, false, 2, null);
    }
    return tmp;
  }
  function toState$default(_this_, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancellation = null;
    return toState_0(_this_, onCancellation);
  }
  function CompletedWithCancellation(result, onCancellation) {
    this._result_2 = result;
    this._onCancellation_0 = onCancellation;
  }
  CompletedWithCancellation.prototype.toString = function () {
    return '' + 'CompletedWithCancellation(result=' + this._result_2 + ', onCancellation=' + this._onCancellation_0 + ')';
  };
  CompletedWithCancellation.prototype.hashCode = function () {
    var result = this._result_2 == null ? 0 : hashCode(this._result_2);
    result = imul(result, 31) + hashCode(this._onCancellation_0) | 0;
    return result;
  };
  CompletedWithCancellation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals(this._result_2, tmp0_other_with_cast._result_2))
      return false;
    if (!equals(this._onCancellation_0, tmp0_other_with_cast._onCancellation_0))
      return false;
    return true;
  };
  CompletedWithCancellation.$metadata$ = {
    simpleName: 'CompletedWithCancellation',
    kind: 'class',
    interfaces: []
  };
  function recoverResult(state, uCont) {
    var tmp;
    if (state instanceof CompletedExceptionally) {
      var tmp0_failure_0 = Companion_getInstance_2();
      var tmp1_failure_0 = recoverStackTrace(state._cause, uCont);
      tmp = _Result___init__impl_(createFailure(tmp1_failure_0));
    } else {
      {
        var tmp2_success_0 = Companion_getInstance_2();
        var tmp3_success_0 = (state == null ? true : isObject(state)) ? state : THROW_CCE();
        tmp = _Result___init__impl_(tmp3_success_0);
      }
    }
    return tmp;
  }
  function _no_name_provided__35() {
  }
  _no_name_provided__35.prototype.invoke_57 = function (it) {
    return it instanceof CoroutineDispatcher ? it : null;
  };
  _no_name_provided__35.prototype.invoke_468 = function (p1) {
    return this.invoke_57((!(p1 == null) ? isInterface(p1, Element_0) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Key_1() {
    Key_instance_0 = this;
    var tmp = Key_getInstance();
    AbstractCoroutineContextKey.call(this, tmp, _no_name_provided_$factory_27());
  }
  Key_1.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: []
  };
  var Key_instance_0;
  function Key_getInstance_0() {
    if (Key_instance_0 == null)
      new Key_1();
    return Key_instance_0;
  }
  function CoroutineDispatcher() {
    Key_getInstance_0();
    AbstractCoroutineContextElement.call(this, Key_getInstance());
  }
  CoroutineDispatcher.prototype.isDispatchNeeded_8 = function (context) {
    return true;
  };
  CoroutineDispatcher.prototype.interceptContinuation_9 = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  CoroutineDispatcher.prototype.releaseInterceptedContinuation_9 = function (continuation) {
    var tmp0_safe_receiver = (continuation instanceof DispatchedContinuation ? continuation : THROW_CCE())._get_reusableCancellableContinuation_();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.detachChild();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CoroutineDispatcher.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this);
  };
  CoroutineDispatcher.$metadata$ = {
    simpleName: 'CoroutineDispatcher',
    kind: 'class',
    interfaces: [ContinuationInterceptor]
  };
  function _no_name_provided_$factory_27() {
    var i = new _no_name_provided__35();
    return function (p1) {
      return i.invoke_57(p1);
    };
  }
  function Key_2() {
    Key_instance_1 = this;
  }
  Key_2.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_1;
  function Key_getInstance_1() {
    if (Key_instance_1 == null)
      new Key_2();
    return Key_instance_1;
  }
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.get_56(Key_getInstance_1());
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.handleException__error(context, exception);
        return Unit_getInstance();
      }
      Unit_getInstance();
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineExceptionImpl(context, handlerException(exception, $p));
        return Unit_getInstance();
      } else {
        {
          throw $p;
        }
      }
    }
    handleCoroutineExceptionImpl(context, exception);
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    var tmp0_apply_0 = RuntimeException_init_$Create$('Exception while trying to handle coroutine exception', thrownException);
    return tmp0_apply_0;
  }
  function CoroutineScope() {
  }
  CoroutineScope.$metadata$ = {
    simpleName: 'CoroutineScope',
    kind: 'interface',
    interfaces: []
  };
  function CoroutineScope_0(context) {
    var tmp;
    if (!(context.get_56(Key_getInstance_2()) == null)) {
      tmp = context;
    } else {
      tmp = context.plus_25(Job$default(null, 1, null));
    }
    return new ContextScope(tmp);
  }
  function coroutineScope(block, $cont) {
    var tmp0__anonymous__1 = $cont;
    var coroutine_2 = new ScopeCoroutine(tmp0__anonymous__1._get_context__22(), tmp0__anonymous__1);
    return startUndispatchedOrReturn(coroutine_2, coroutine_2, block);
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_getInstance();
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineStart.prototype.invoke_59 = function (block, receiver, completion) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(CoroutineStart_DEFAULT_getInstance())) {
      tmp = startCoroutineCancellable$default(block, receiver, completion, null, 4, null);
    } else if (tmp0_subject.equals(CoroutineStart_ATOMIC_getInstance())) {
      tmp = startCoroutine(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_UNDISPATCHED_getInstance())) {
      tmp = startCoroutineUndispatched(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_LAZY_getInstance())) {
      tmp = Unit_getInstance();
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CoroutineStart.prototype._get_isLazy_ = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  CoroutineStart.$metadata$ = {
    simpleName: 'CoroutineStart',
    kind: 'class',
    interfaces: []
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  function CopyableThrowable() {
  }
  CopyableThrowable.$metadata$ = {
    simpleName: 'CopyableThrowable',
    kind: 'interface',
    interfaces: []
  };
  function Delay() {
  }
  Delay.$metadata$ = {
    simpleName: 'Delay',
    kind: 'interface',
    interfaces: []
  };
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this._useCount = new Long(0, 0);
    this._shared = false;
    this._unconfinedQueue = null;
  }
  EventLoop.prototype.processUnconfinedEvent_0 = function () {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.removeFirstOrNull_2();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.run_3();
    return true;
  };
  EventLoop.prototype.dispatchUnconfined_0 = function (task) {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new ArrayQueue();
      this._unconfinedQueue = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.addLast_7(task);
  };
  EventLoop.prototype._get_isUnconfinedLoopActive__0 = function () {
    return this._useCount.compareTo_44(delta(this, true)) >= 0;
  };
  EventLoop.prototype._get_isUnconfinedQueueEmpty__0 = function () {
    var tmp0_safe_receiver = this._unconfinedQueue;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_isEmpty__3();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  EventLoop.prototype.incrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.plus_53(delta(this, unconfined));
    if (!unconfined)
      this._shared = true;
  };
  EventLoop.prototype.decrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.minus_27(delta(this, unconfined));
    if (this._useCount.compareTo_44(new Long(0, 0)) > 0)
      return Unit_getInstance();
    if (this._shared) {
      this.shutdown_0();
    }};
  EventLoop.prototype.shutdown_0 = function () {
  };
  EventLoop.$metadata$ = {
    simpleName: 'EventLoop',
    kind: 'class',
    interfaces: []
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this._ref = new CommonThreadLocal();
  }
  ThreadLocalEventLoop.prototype._get_eventLoop_ = function () {
    var tmp0_elvis_lhs = this._ref.get_55();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance()._ref.set_4(tmp0_also_0);
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ThreadLocalEventLoop.$metadata$ = {
    simpleName: 'ThreadLocalEventLoop',
    kind: 'object',
    interfaces: []
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  CompletionHandlerException.$metadata$ = {
    simpleName: 'CompletionHandlerException',
    kind: 'class',
    interfaces: []
  };
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$_0(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  CoroutinesInternalError.$metadata$ = {
    simpleName: 'CoroutinesInternalError',
    kind: 'class',
    interfaces: []
  };
  function DisposableHandle() {
  }
  DisposableHandle.$metadata$ = {
    simpleName: 'DisposableHandle',
    kind: 'interface',
    interfaces: []
  };
  function Key_3() {
    Key_instance_2 = this;
    Key_getInstance_1();
    Unit_getInstance();
  }
  Key_3.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_2;
  function Key_getInstance_2() {
    if (Key_instance_2 == null)
      new Key_3();
    return Key_instance_2;
  }
  function Job() {
  }
  Job.prototype.cancel$default_10 = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.cancel_10(cause) : $handler(cause);
  };
  Job.prototype.invokeOnCompletion$default_8 = function (onCancelling, invokeImmediately, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancelling = false;
    if (!(($mask0 & 2) === 0))
      invokeImmediately = true;
    return $handler == null ? this.invokeOnCompletion_19(onCancelling, invokeImmediately, handler) : $handler(onCancelling, invokeImmediately, handler);
  };
  Job.$metadata$ = {
    simpleName: 'Job',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function ChildJob() {
  }
  ChildJob.$metadata$ = {
    simpleName: 'ChildJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ParentJob() {
  }
  ParentJob.$metadata$ = {
    simpleName: 'ParentJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ChildHandle() {
  }
  ChildHandle.$metadata$ = {
    simpleName: 'ChildHandle',
    kind: 'interface',
    interfaces: [DisposableHandle]
  };
  function NonDisposableHandle() {
    NonDisposableHandle_instance = this;
  }
  NonDisposableHandle.prototype.dispose_20 = function () {
  };
  NonDisposableHandle.prototype.childCancelled_10 = function (cause) {
    return false;
  };
  NonDisposableHandle.prototype.toString = function () {
    return 'NonDisposableHandle';
  };
  NonDisposableHandle.$metadata$ = {
    simpleName: 'NonDisposableHandle',
    kind: 'object',
    interfaces: [DisposableHandle, ChildHandle]
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    if (NonDisposableHandle_instance == null)
      new NonDisposableHandle();
    return NonDisposableHandle_instance;
  }
  function Job_0(parent_0) {
    return new JobImpl(parent_0);
  }
  function Job$default(parent_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent_0 = null;
    return Job_0(parent_0);
  }
  function _get_job_(_this_) {
    var tmp0_elvis_lhs = _this_.get_56(Key_getInstance_2());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + "Current context doesn't contain Job in it: " + _this_;
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function cancel(_this_, message, cause) {
    return _this_.cancel_10(new CancellationException(message, cause));
  }
  function cancel$default(_this_, message, cause, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      cause = null;
    return cancel(_this_, message, cause);
  }
  var COMPLETING_ALREADY;
  var COMPLETING_WAITING_CHILDREN;
  var COMPLETING_RETRY;
  var TOO_LATE_TO_CANCEL;
  var SEALED;
  var EMPTY_NEW;
  var EMPTY_ACTIVE;
  function Empty(isActive) {
    this._isActive = isActive;
  }
  Empty.prototype._get_isActive__20 = function () {
    return this._isActive;
  };
  Empty.prototype._get_list__10 = function () {
    return null;
  };
  Empty.prototype.toString = function () {
    return '' + 'Empty{' + (this._isActive ? 'Active' : 'New') + '}';
  };
  Empty.$metadata$ = {
    simpleName: 'Empty',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function Incomplete() {
  }
  Incomplete.$metadata$ = {
    simpleName: 'Incomplete',
    kind: 'interface',
    interfaces: []
  };
  function NodeList_0() {
    LinkedListHead.call(this);
  }
  NodeList_0.prototype._get_isActive__20 = function () {
    return true;
  };
  NodeList_0.prototype._get_list__10 = function () {
    return this;
  };
  NodeList_0.prototype.getString = function (state) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$();
    tmp0_apply_0_1.append_5('List{');
    Unit_getInstance();
    tmp0_apply_0_1.append_5(state);
    Unit_getInstance();
    tmp0_apply_0_1.append_5('}[');
    Unit_getInstance();
    var first_3 = true;
    var cur_1_4 = this._get__next__1();
    while (!equals(cur_1_4, this)) {
      if (cur_1_4 instanceof JobNode) {
        var tmp0__anonymous__2_5 = cur_1_4;
        if (first_3)
          first_3 = false;
        else {
          tmp0_apply_0_1.append_5(', ');
          Unit_getInstance();
        }
        tmp0_apply_0_1.append_4(tmp0__anonymous__2_5);
        Unit_getInstance();
      } else {
      }
      cur_1_4 = cur_1_4.__next;
    }
    tmp0_apply_0_1.append_5(']');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  NodeList_0.prototype.toString = function () {
    return DEBUG ? this.getString('Active') : anyToString(this);
  };
  NodeList_0.$metadata$ = {
    simpleName: 'NodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function JobNode() {
    CompletionHandlerBase.call(this);
  }
  JobNode.prototype._get_job__5 = function () {
    var tmp = this._job;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  };
  JobNode.prototype._get_isActive__20 = function () {
    return true;
  };
  JobNode.prototype._get_list__10 = function () {
    return null;
  };
  JobNode.prototype.dispose_20 = function () {
    return this._get_job__5().removeNode_7(this);
  };
  JobNode.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '[job@' + _get_hexAddress_(this._get_job__5()) + ']';
  };
  JobNode.$metadata$ = {
    simpleName: 'JobNode',
    kind: 'class',
    interfaces: [DisposableHandle, Incomplete]
  };
  function _set_exceptionsHolder_($this, value_0) {
    $this.__exceptionsHolder._value = value_0;
  }
  function _get_exceptionsHolder_($this) {
    return $this.__exceptionsHolder._value;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$_0(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
    var wasCancelling = false;
    wasCancelling = state._get_isCancelling_();
    var exceptions_2 = state.sealLocked(proposedException);
    var finalCause_3 = getFinalRootCause($this, state, exceptions_2);
    if (!(finalCause_3 == null))
      addSuppressedExceptions($this, finalCause_3, exceptions_2);
    var finalException = finalCause_3;
    var tmp;
    if (finalException == null) {
      tmp = proposedUpdate;
    } else if (finalException === proposedException) {
      tmp = proposedUpdate;
    } else {
      tmp = CompletedExceptionally_init_$Create$(finalException, false, 2, null);
    }
    var finalState = tmp;
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) ? true : $this.handleJobException_7(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).makeHandled_0();
        Unit_getInstance();
      }}if (!wasCancelling)
      $this.onCancelling_7(finalException);
    $this.onCompletionInternal_7(finalState);
    var casSuccess = $this.__state_0.atomicfu$compareAndSet(state, boxIncomplete(finalState));
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.isEmpty_40()) {
      if (state._get_isCancelling_()) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        return new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      }return null;
    }var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1 = exceptions.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (!(element_2 instanceof CancellationException)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var firstNonCancellation = tmp$ret$0;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first = exceptions.get_66(0);
    if (first instanceof TimeoutCancellationException) {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_iterator_1_0 = exceptions.iterator_46();
        while (tmp0_iterator_1_0.hasNext_27()) {
          var element_2_0 = tmp0_iterator_1_0.next_28();
          var tmp;
          if (!(element_2_0 === first)) {
            tmp = element_2_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$2 = element_2_0;
            break l$ret$3;
          } else {
          }
        }
        tmp$ret$2 = null;
      }
       while (false);
      var detailedTimeoutException = tmp$ret$2;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    } else {
    }
    return first;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions._get_size__45() <= 1)
      return Unit_getInstance();
    var seenExceptions = identitySet(exceptions._get_size__45());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var exception = tmp0_iterator.next_28();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) ? !(unwrapped === unwrappedCause) : false) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.add_37(unwrapped);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
      } else {
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update) {
    if (!$this.__state_0.atomicfu$compareAndSet(state, boxIncomplete(update)))
      return false;
    $this.onCancelling_7(null);
    $this.onCompletionInternal_7(update);
    completeStateFinalization($this, state, update);
    return true;
  }
  function completeStateFinalization($this, state, update) {
    var tmp0_safe_receiver = $this._get_parentHandle__7();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_20();
      $this._set_parentHandle__7(NonDisposableHandle_getInstance());
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._cause;
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          $this.handleOnCompletionException_7(new CompletionHandlerException('' + 'Exception in completion handler ' + state + ' for ' + $this, $p));
        } else {
          {
            throw $p;
          }
        }
      }
    } else {
      {
        var tmp2_safe_receiver = state._get_list__10();
        if (tmp2_safe_receiver == null)
          null;
        else {
          notifyCompletion(tmp2_safe_receiver, $this, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.onCancelling_7(cause);
    var exception_1 = null;
    var cur_1 = list._get__next__1();
    while (!equals(cur_1, list)) {
      if (cur_1 instanceof JobCancellingNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_7(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    Unit_getInstance();
    cancelParent($this, cause);
    Unit_getInstance();
  }
  function cancelParent($this, cause) {
    if ($this._get_isScopedCoroutine__7())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent_0 = $this._get_parentHandle__7();
    if (parent_0 === null ? true : parent_0 === NonDisposableHandle_getInstance()) {
      return isCancellation;
    }return parent_0.childCancelled_10(cause) ? true : isCancellation;
  }
  function notifyCompletion(_this_, $this, cause) {
    var exception_1 = null;
    var cur_1 = _this_._get__next__1();
    while (!equals(cur_1, _this_)) {
      if (cur_1 instanceof JobNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_7(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function startInternal($this, state) {
    var tmp0_subject = state;
    if (tmp0_subject instanceof Empty) {
      if (state._isActive)
        return 0;
      if (!$this.__state_0.atomicfu$compareAndSet(state, EMPTY_ACTIVE))
        return -1;
      $this.onStartInternal_7();
      return 1;
    } else {
      if (tmp0_subject instanceof InactiveNodeList) {
        if (!$this.__state_0.atomicfu$compareAndSet(state, state._list_1))
          return -1;
        $this.onStartInternal_7();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_elvis_lhs = handler instanceof JobCancellingNode ? handler : null;
      tmp = tmp0_elvis_lhs == null ? new InvokeOnCancelling(handler) : tmp0_elvis_lhs;
    } else {
      var tmp1_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? new InvokeOnCompletion(handler) : tmp2_elvis_lhs;
    }
    var node_0 = tmp;
    node_0._job = $this;
    return node_0;
  }
  function addLastAtomic($this, expect, list, node_0) {
    var tmp$ret$0;
    l$ret$1: do {
      if (!($this._get_state__8() === expect)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      list.addLast_13(node_0);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList_0();
    var update = state._isActive ? list : new InactiveNodeList(list);
    $this.__state_0.atomicfu$compareAndSet(state, update);
    Unit_getInstance();
  }
  function promoteSingleToNodeList($this, state) {
    state.addOneIfEmpty_6(new NodeList_0());
    Unit_getInstance();
    var list = state.__next;
    $this.__state_0.atomicfu$compareAndSet(state, list);
    Unit_getInstance();
  }
  function cancelMakeCompleting($this, cause) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__8();
      var tmp;
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false)) {
        tmp = true;
      } else {
        {
          var tmp_0;
          if (tmp0__anonymous__1 instanceof Finishing) {
            tmp_0 = tmp0__anonymous__1._get_isCompleting_();
          } else {
            {
              tmp_0 = false;
            }
          }
          tmp = tmp_0;
        }
      }
      if (tmp) {
        return COMPLETING_ALREADY;
      } else {
      }
      var tmp_1 = createCauseException($this, cause);
      var proposedUpdate_2 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
      var finalState_3 = tryMakeCompleting($this, tmp0__anonymous__1, proposedUpdate_2);
      if (!(finalState_3 === COMPLETING_RETRY))
        return finalState_3;
    }
    Unit_getInstance();
  }
  function createCauseException($this, cause) {
    var tmp0_subject = cause;
    var tmp;
    if (tmp0_subject == null ? true : tmp0_subject instanceof Error) {
      var tmp1_elvis_lhs = cause;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        tmp_0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      {
        tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).getChildJobCancellationCause_8();
      }
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = $this._get_state__8();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Finishing) {
          if (tmp0__anonymous__1._get_isSealed_())
            return TOO_LATE_TO_CANCEL;
          var wasCancelling_2_4 = tmp0__anonymous__1._get_isCancelling_();
          if (!(cause == null) ? true : !wasCancelling_2_4) {
            var tmp0_elvis_lhs_4_6 = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs_4_6 == null) {
              var tmp0_also_0_5_7 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_5_7;
              tmp = tmp0_also_0_5_7;
            } else {
              tmp = tmp0_elvis_lhs_4_6;
            }
            var causeException_3_5 = tmp;
            tmp0__anonymous__1.addExceptionLocked(causeException_3_5);
          }var tmp1_takeIf_0_6_8 = tmp0__anonymous__1._get_rootCause_();
          var tmp_0;
          if (!wasCancelling_2_4) {
            tmp_0 = tmp1_takeIf_0_6_8;
          } else {
            {
              tmp_0 = null;
            }
          }
          var notifyRootCause_3 = tmp_0;
          var tmp1_safe_receiver_9 = notifyRootCause_3;
          if (tmp1_safe_receiver_9 == null)
            null;
          else {
            notifyCancelling($this, tmp0__anonymous__1._list_0, tmp1_safe_receiver_9);
            Unit_getInstance();
          }
          Unit_getInstance();
          return COMPLETING_ALREADY;
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var tmp2_elvis_lhs_11 = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs_11 == null) {
              var tmp0_also_0_12 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_12;
              tmp_1 = tmp0_also_0_12;
            } else {
              tmp_1 = tmp2_elvis_lhs_11;
            }
            var causeException_10 = tmp_1;
            if (tmp0__anonymous__1._get_isActive__20()) {
              if (tryMakeCancelling($this, tmp0__anonymous__1, causeException_10))
                return COMPLETING_ALREADY;
            } else {
              var finalState_13 = tryMakeCompleting($this, tmp0__anonymous__1, CompletedExceptionally_init_$Create$(causeException_10, false, 2, null));
              if (finalState_13 === COMPLETING_ALREADY) {
                var tmp1_error_0_14 = '' + 'Cannot happen in ' + tmp0__anonymous__1;
                throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_14));
              } else if (finalState_13 === COMPLETING_RETRY) {
                tmp$ret$0 = Unit_getInstance();
                break l$ret$1;
              } else
                return finalState_13;
            }
          } else {
            return TOO_LATE_TO_CANCEL;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state._get_list__10();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_subject = state;
      var tmp_0;
      if (tmp0_subject instanceof Empty) {
        tmp_0 = new NodeList_0();
      } else {
        if (tmp0_subject instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          {
            var tmp0_error_0 = '' + 'State should have list: ' + state;
            throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
          }
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.__state_0.atomicfu$compareAndSet(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return COMPLETING_ALREADY;
    else {
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      {
        tmp_1 = state instanceof JobNode;
      }
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }return COMPLETING_RETRY;
    } else {
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return COMPLETING_RETRY;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    if (finishing._get_isCompleting_())
      return COMPLETING_ALREADY;
    finishing._set_isCompleting_(true);
    if (!(finishing === state)) {
      if (!$this.__state_0.atomicfu$compareAndSet(state, finishing))
        return COMPLETING_RETRY;
    }var wasCancelling_2 = finishing._get_isCancelling_();
    var tmp0_safe_receiver_3 = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver_3 == null)
      null;
    else {
      finishing.addExceptionLocked(tmp0_safe_receiver_3._cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_takeIf_0_4 = finishing._get_rootCause_();
    var tmp_0;
    if (!wasCancelling_2) {
      tmp_0 = tmp0_takeIf_0_4;
    } else {
      {
        tmp_0 = null;
      }
    }
    notifyRootCause = tmp_0;
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCancelling($this, list, tmp2_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var child = firstChild($this, state);
    if (!(child == null) ? tryWaitForChild($this, finishing, child, proposedUpdate) : false)
      return COMPLETING_WAITING_CHILDREN;
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull_(_this_, $this) {
    var tmp0_safe_receiver = _this_ instanceof CompletedExceptionally ? _this_ : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state._get_list__10();
      tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    while (true) {
      var $this_1 = $this_0;
      var state_1 = state_0;
      var child_1 = child_0;
      var proposedUpdate_1 = proposedUpdate_0;
      var tmp0__get_asHandler__0 = new ChildCompletion($this_1, state_1, child_1, proposedUpdate_1);
      var handle = child_1._childJob.invokeOnCompletion$default_8(false, false, tmp0__get_asHandler__0, 1, null);
      if (!(handle === NonDisposableHandle_getInstance()))
        return true;
      var tmp0_elvis_lhs = nextChild(child_1, $this_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      $this_0 = $this_1;
      state_0 = state_1;
      child_0 = nextChild_0;
      proposedUpdate_0 = proposedUpdate_1;
      continue;
    }
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    var waitChild = nextChild(lastChild, $this);
    if (!(waitChild == null) ? tryWaitForChild($this, state, waitChild, proposedUpdate) : false)
      return Unit_getInstance();
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.afterCompletion_7(finalState);
  }
  function nextChild(_this_, $this) {
    var cur = _this_;
    $l$break: while (true) {
      var tmp0__get_isRemoved__0 = cur;
      if (!tmp0__get_isRemoved__0.__removed) {
        break $l$break;
      }var tmp1__get_prevNode__0 = cur;
      cur = tmp1__get_prevNode__0.__prev;
    }
    while (true) {
      var tmp2__get_nextNode__0 = cur;
      cur = tmp2__get_nextNode__0.__next;
      var tmp3__get_isRemoved__0 = cur;
      if (tmp3__get_isRemoved__0.__removed)
        continue;
      else {
      }
      if (cur instanceof ChildHandleNode)
        return cur;
      else {
      }
      if (cur instanceof NodeList_0)
        return null;
      else {
      }
    }
  }
  function stateString($this, state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_isCancelling_() ? 'Cancelling' : state._get_isCompleting_() ? 'Completing' : 'Active';
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
        tmp = state._get_isActive__20() ? 'Active' : 'New';
      } else {
        if (tmp0_subject instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          {
            tmp = 'Completed';
          }
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this._list_0 = list;
    this.__isCompleting = atomic_0(isCompleting);
    this.__rootCause = atomic(rootCause);
    this.__exceptionsHolder = atomic(null);
  }
  Finishing.prototype._get_list__10 = function () {
    return this._list_0;
  };
  Finishing.prototype._set_isCompleting_ = function (value_0) {
    this.__isCompleting._value_0 = value_0;
  };
  Finishing.prototype._get_isCompleting_ = function () {
    return this.__isCompleting._value_0;
  };
  Finishing.prototype._set_rootCause_ = function (value_0) {
    this.__rootCause._value = value_0;
  };
  Finishing.prototype._get_rootCause_ = function () {
    return this.__rootCause._value;
  };
  Finishing.prototype._get_isSealed_ = function () {
    return _get_exceptionsHolder_(this) === SEALED;
  };
  Finishing.prototype._get_isCancelling_ = function () {
    return !(this._get_rootCause_() == null);
  };
  Finishing.prototype._get_isActive__20 = function () {
    return this._get_rootCause_() == null;
  };
  Finishing.prototype.sealLocked = function (proposedException) {
    var eh = _get_exceptionsHolder_(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        var tmp0_also_0 = allocateList(this);
        tmp0_also_0.add_37(eh);
        Unit_getInstance();
        tmp = tmp0_also_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
          }
        }
      }
    }
    var list = tmp;
    var rootCause = this._get_rootCause_();
    var tmp0_safe_receiver = rootCause;
    if (tmp0_safe_receiver == null)
      null;
    else {
      list.add_39(0, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    if (!(proposedException == null) ? !equals(proposedException, rootCause) : false) {
      list.add_37(proposedException);
      Unit_getInstance();
    }_set_exceptionsHolder_(this, SEALED);
    return list;
  };
  Finishing.prototype.addExceptionLocked = function (exception) {
    var rootCause = this._get_rootCause_();
    if (rootCause == null) {
      this._set_rootCause_(exception);
      return Unit_getInstance();
    }if (exception === rootCause)
      return Unit_getInstance();
    var eh = _get_exceptionsHolder_(this);
    if (eh == null)
      _set_exceptionsHolder_(this, exception);
    else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_getInstance();
        var tmp0_apply_0 = allocateList(this);
        tmp0_apply_0.add_37(eh);
        Unit_getInstance();
        tmp0_apply_0.add_37(exception);
        Unit_getInstance();
        _set_exceptionsHolder_(this, tmp0_apply_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).add_37(exception);
          Unit_getInstance();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
          }
        }
      }
    }
  };
  Finishing.prototype.toString = function () {
    return '' + 'Finishing[cancelling=' + this._get_isCancelling_() + ', completing=' + this._get_isCompleting_() + ', rootCause=' + this._get_rootCause_() + ', exceptions=' + _get_exceptionsHolder_(this) + ', list=' + this._list_0 + ']';
  };
  Finishing.$metadata$ = {
    simpleName: 'Finishing',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildCompletion(parent_0, state, child, proposedUpdate) {
    JobNode.call(this);
    this._parent = parent_0;
    this._state_2 = state;
    this._child = child;
    this._proposedUpdate = proposedUpdate;
  }
  ChildCompletion.prototype.invoke_136 = function (cause) {
    continueCompleting(this._parent, this._state_2, this._child, this._proposedUpdate);
  };
  ChildCompletion.prototype.invoke = function (cause) {
    return this.invoke_136(cause);
  };
  ChildCompletion.$metadata$ = {
    simpleName: 'ChildCompletion',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__36(this$0, resultContinuation) {
    this._this$0_4 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__36.prototype.invoke_61 = function ($this$sequence, $cont) {
    var tmp = this.create($this$sequence, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__36.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state0 = this._this$0_4._get_state__8();
            var tmp_0 = this._state0;
            if (tmp_0 instanceof ChildHandleNode) {
              this._state_1 = 6;
              suspendResult = this._$this$sequence.yield_0(this._state0._childJob, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                var tmp_1 = this._state0;
                if (!(tmp_1 == null) ? isInterface(tmp_1, Incomplete) : false) {
                  this._tmp0_safe_receiver1 = this._state0._get_list__10();
                  if (this._tmp0_safe_receiver1 == null) {
                    this._WHEN_RESULT2 = null;
                    this._state_1 = 5;
                    continue $sm;
                  } else {
                    this._cur_1_23 = this._tmp0_safe_receiver1._get__next__1();
                    this._state_1 = 1;
                    continue $sm;
                  }
                } else {
                  {
                    this._state_1 = 7;
                    continue $sm;
                  }
                }
              }
            }

            break;
          case 1:
            if (!!equals(this._cur_1_23, this._tmp0_safe_receiver1)) {
              this._state_1 = 4;
              continue $sm;
            }
            var tmp_2 = this._cur_1_23;
            if (tmp_2 instanceof ChildHandleNode) {
              var tmp_3 = this;
              tmp_3._tmp0__anonymous__2_34 = this._cur_1_23;
              this._state_1 = 2;
              suspendResult = this._$this$sequence.yield_0(this._tmp0__anonymous__2_34._childJob, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 3;
                continue $sm;
              }
            }

            break;
          case 2:
            suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._cur_1_23 = this._cur_1_23.__next;
            this._state_1 = 1;
            continue $sm;
          case 4:
            this._WHEN_RESULT2 = Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            Unit_getInstance();
            this._state_1 = 7;
            continue $sm;
          case 6:
            suspendResult;
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__36.prototype.create = function ($this$sequence, completion) {
    var i = new _no_name_provided__36(this._this$0_4, completion);
    i._$this$sequence = $this$sequence;
    return i;
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function JobSupport(active) {
    this.__state_0 = atomic(active ? EMPTY_ACTIVE : EMPTY_NEW);
    this.__parentHandle_0 = atomic(null);
  }
  JobSupport.prototype._get_key__28 = function () {
    return Key_getInstance_2();
  };
  JobSupport.prototype._set_parentHandle__7 = function (value_0) {
    this.__parentHandle_0._value = value_0;
  };
  JobSupport.prototype._get_parentHandle__7 = function () {
    return this.__parentHandle_0._value;
  };
  JobSupport.prototype.initParentJobInternal_7 = function (parent_0) {
    if (parent_0 == null) {
      this._set_parentHandle__7(NonDisposableHandle_getInstance());
      return Unit_getInstance();
    }parent_0.start_12();
    Unit_getInstance();
    var handle = parent_0.attachChild_8(this);
    this._set_parentHandle__7(handle);
    if (this._get_isCompleted__8()) {
      handle.dispose_20();
      this._set_parentHandle__7(NonDisposableHandle_getInstance());
    }};
  JobSupport.prototype._get_state__8 = function () {
    var tmp0_loop_0 = this.__state_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value;
      if (!(tmp1__anonymous__1 instanceof OpDescriptor))
        return tmp1__anonymous__1;
      else {
      }
      tmp1__anonymous__1.perform(this);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_isActive__20 = function () {
    var state = this._get_state__8();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state._get_isActive__20();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  JobSupport.prototype._get_isCompleted__8 = function () {
    var tmp = this._get_state__8();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  JobSupport.prototype.start_12 = function () {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__8();
      var tmp0_subject_2 = startInternal(this, tmp0__anonymous__1);
      if (tmp0_subject_2 === 0)
        return false;
      else if (tmp0_subject_2 === 1)
        return true;
    }
    Unit_getInstance();
  };
  JobSupport.prototype.onStartInternal_7 = function () {
  };
  JobSupport.prototype.getCancellationException_8 = function () {
    var state = this._get_state__8();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause_();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toCancellationException_7(tmp0_safe_receiver, '' + _get_classSimpleName_(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var tmp1_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          var tmp_1 = state._cause;
          tmp = this.toCancellationException$default_7(tmp_1, null, 1, null);
        } else {
          {
            tmp = new JobCancellationException('' + _get_classSimpleName_(this) + ' has completed normally', null, this);
          }
        }
      }
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException_7 = function (_this__0, message) {
    var tmp0_elvis_lhs = _this__0 instanceof CancellationException ? _this__0 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_elvis_lhs_1 = message;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, _this__0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException$default_7 = function (_this__0, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = null;
    return this.toCancellationException_7(_this__0, message);
  };
  JobSupport.prototype.invokeOnCompletion_18 = function (handler) {
    return this.invokeOnCompletion_19(false, true, handler);
  };
  JobSupport.prototype.invokeOnCompletion_19 = function (onCancelling, invokeImmediately, handler) {
    var node_0 = makeNode(this, handler, onCancelling);
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__8();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Empty) {
          if (tmp0__anonymous__1._isActive) {
            if (this.__state_0.atomicfu$compareAndSet(tmp0__anonymous__1, node_0))
              return node_0;
          } else
            promoteEmptyToNodeList(this, tmp0__anonymous__1);
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var list_3 = tmp0__anonymous__1._get_list__10();
            if (list_3 == null) {
              promoteSingleToNodeList(this, tmp0__anonymous__1 instanceof JobNode ? tmp0__anonymous__1 : THROW_CCE());
            } else {
              var rootCause_4 = null;
              var handle_5 = NonDisposableHandle_getInstance();
              var tmp;
              if (onCancelling) {
                tmp = tmp0__anonymous__1 instanceof Finishing;
              } else {
                tmp = false;
              }
              if (tmp) {
                rootCause_4 = tmp0__anonymous__1._get_rootCause_();
                var tmp_0;
                if (rootCause_4 == null) {
                  tmp_0 = true;
                } else {
                  var tmp_1;
                  if (handler instanceof ChildHandleNode) {
                    tmp_1 = !tmp0__anonymous__1._get_isCompleting_();
                  } else {
                    {
                      tmp_1 = false;
                    }
                  }
                  tmp_0 = tmp_1;
                }
                if (tmp_0) {
                  if (!addLastAtomic(this, tmp0__anonymous__1, list_3, node_0)) {
                    tmp$ret$0 = Unit_getInstance();
                    break l$ret$1;
                  }if (rootCause_4 == null)
                    return node_0;
                  handle_5 = node_0;
                } else {
                }
              } else {
              }
              if (!(rootCause_4 == null)) {
                if (invokeImmediately)
                  invokeIt(handler, rootCause_4);
                return handle_5;
              } else {
                if (addLastAtomic(this, tmp0__anonymous__1, list_3, node_0))
                  return node_0;
              }
            }
          } else {
            {
              if (invokeImmediately) {
                var tmp1_safe_receiver_6 = tmp0__anonymous__1 instanceof CompletedExceptionally ? tmp0__anonymous__1 : null;
                invokeIt(handler, tmp1_safe_receiver_6 == null ? null : tmp1_safe_receiver_6._cause);
              }return NonDisposableHandle_getInstance();
            }
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.removeNode_7 = function (node_0) {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__8();
      var tmp0_subject_2 = tmp0__anonymous__1;
      if (tmp0_subject_2 instanceof JobNode) {
        if (!(tmp0__anonymous__1 === node_0))
          return Unit_getInstance();
        if (this.__state_0.atomicfu$compareAndSet(tmp0__anonymous__1, EMPTY_ACTIVE))
          return Unit_getInstance();
      } else {
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
          if (!(tmp0__anonymous__1._get_list__10() == null)) {
            node_0.remove_37();
            Unit_getInstance();
          }return Unit_getInstance();
        } else {
          return Unit_getInstance();
        }
      }
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_onCancelComplete__7 = function () {
    return false;
  };
  JobSupport.prototype.cancel_10 = function (cause) {
    var tmp0_elvis_lhs = cause;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_defaultCancellationException_0 = null;
      var tmp1_defaultCancellationException_0 = null;
      var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    this.cancelInternal_7(tmp);
  };
  JobSupport.prototype.cancellationExceptionMessage_7 = function () {
    return 'Job was cancelled';
  };
  JobSupport.prototype.cancelInternal_7 = function (cause) {
    this.cancelImpl_7(cause);
    Unit_getInstance();
  };
  JobSupport.prototype.parentCancelled_9 = function (parentJob) {
    this.cancelImpl_7(parentJob);
    Unit_getInstance();
  };
  JobSupport.prototype.childCancelled_10 = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    else {
    }
    return this.cancelImpl_7(cause) ? this._get_handlesException__7() : false;
  };
  JobSupport.prototype.cancelImpl_7 = function (cause) {
    var finalState = COMPLETING_ALREADY;
    if (this._get_onCancelComplete__7()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === COMPLETING_WAITING_CHILDREN)
        return true;
    }if (finalState === COMPLETING_ALREADY) {
      finalState = makeCancelling(this, cause);
    }var tmp;
    if (finalState === COMPLETING_ALREADY) {
      tmp = true;
    } else if (finalState === COMPLETING_WAITING_CHILDREN) {
      tmp = true;
    } else if (finalState === TOO_LATE_TO_CANCEL) {
      tmp = false;
    } else {
      this.afterCompletion_7(finalState);
      tmp = true;
    }
    return tmp;
  };
  JobSupport.prototype.getChildJobCancellationCause_8 = function () {
    var state = this._get_state__8();
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_rootCause_();
    } else {
      if (tmp0_subject instanceof CompletedExceptionally) {
        tmp = state._cause;
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
          var tmp0_error_0 = '' + 'Cannot be cancelling child in this state: ' + state;
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
        } else {
          {
            tmp = null;
          }
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('' + 'Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  JobSupport.prototype.makeCompletingOnce_5 = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__8();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          throw IllegalStateException_init_$Create$_0('' + 'Job ' + this + ' is already complete or completing, ' + ('' + 'but is being completed with ' + proposedUpdate), _get_exceptionOrNull_(proposedUpdate, this));
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else
          return finalState_2;
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_children__2 = function () {
    return sequence(_no_name_provided_$factory_28(this, null));
  };
  JobSupport.prototype.attachChild_8 = function (child) {
    var tmp0__get_asHandler__0 = new ChildHandleNode(child);
    var tmp = this.invokeOnCompletion$default_8(true, false, tmp0__get_asHandler__0, 2, null);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  JobSupport.prototype.handleOnCompletionException_7 = function (exception) {
    throw exception;
  };
  JobSupport.prototype.onCancelling_7 = function (cause) {
  };
  JobSupport.prototype._get_isScopedCoroutine__7 = function () {
    return false;
  };
  JobSupport.prototype._get_handlesException__7 = function () {
    return true;
  };
  JobSupport.prototype.handleJobException_7 = function (exception) {
    return false;
  };
  JobSupport.prototype.onCompletionInternal_7 = function (state) {
  };
  JobSupport.prototype.afterCompletion_7 = function (state) {
  };
  JobSupport.prototype.toString = function () {
    return '' + this.toDebugString_7() + '@' + _get_hexAddress_(this);
  };
  JobSupport.prototype.toDebugString_7 = function () {
    return '' + this.nameString_8() + '{' + stateString(this, this._get_state__8()) + '}';
  };
  JobSupport.prototype.nameString_8 = function () {
    return _get_classSimpleName_(this);
  };
  JobSupport.$metadata$ = {
    simpleName: 'JobSupport',
    kind: 'class',
    interfaces: [Job, ChildJob, ParentJob, SelectClause0]
  };
  function boxIncomplete(_this_) {
    var tmp;
    if (!(_this_ == null) ? isInterface(_this_, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this_);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function JobCancellingNode() {
    JobNode.call(this);
  }
  JobCancellingNode.$metadata$ = {
    simpleName: 'JobCancellingNode',
    kind: 'class',
    interfaces: []
  };
  function InactiveNodeList(list) {
    this._list_1 = list;
  }
  InactiveNodeList.prototype._get_list__10 = function () {
    return this._list_1;
  };
  InactiveNodeList.prototype._get_isActive__20 = function () {
    return false;
  };
  InactiveNodeList.prototype.toString = function () {
    return DEBUG ? this._list_1.getString('New') : anyToString(this);
  };
  InactiveNodeList.$metadata$ = {
    simpleName: 'InactiveNodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildHandleNode(childJob) {
    JobCancellingNode.call(this);
    this._childJob = childJob;
  }
  ChildHandleNode.prototype.invoke_136 = function (cause) {
    return this._childJob.parentCancelled_9(this._get_job__5());
  };
  ChildHandleNode.prototype.invoke = function (cause) {
    return this.invoke_136(cause);
  };
  ChildHandleNode.prototype.childCancelled_10 = function (cause) {
    return this._get_job__5().childCancelled_10(cause);
  };
  ChildHandleNode.$metadata$ = {
    simpleName: 'ChildHandleNode',
    kind: 'class',
    interfaces: [ChildHandle]
  };
  function InvokeOnCancelling(handler) {
    JobCancellingNode.call(this);
    this._handler_0 = handler;
    this.__invoked = atomic_1(0);
  }
  InvokeOnCancelling.prototype.invoke_136 = function (cause) {
    if (this.__invoked.atomicfu$compareAndSet(0, 1))
      this._handler_0(cause);
  };
  InvokeOnCancelling.prototype.invoke = function (cause) {
    return this.invoke_136(cause);
  };
  InvokeOnCancelling.$metadata$ = {
    simpleName: 'InvokeOnCancelling',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCompletion(handler) {
    JobNode.call(this);
    this._handler_1 = handler;
  }
  InvokeOnCompletion.prototype.invoke_136 = function (cause) {
    return this._handler_1(cause);
  };
  InvokeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_136(cause);
  };
  InvokeOnCompletion.$metadata$ = {
    simpleName: 'InvokeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function unboxState(_this_) {
    var tmp0_safe_receiver = _this_ instanceof IncompleteStateBox ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._state_3;
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function IncompleteStateBox(state) {
    this._state_3 = state;
  }
  IncompleteStateBox.$metadata$ = {
    simpleName: 'IncompleteStateBox',
    kind: 'class',
    interfaces: []
  };
  function ChildContinuation(child) {
    JobCancellingNode.call(this);
    this._child_0 = child;
  }
  ChildContinuation.prototype.invoke_136 = function (cause) {
    this._child_0.parentCancelled_3(this._child_0.getContinuationCancellationCause(this._get_job__5()));
  };
  ChildContinuation.prototype.invoke = function (cause) {
    return this.invoke_136(cause);
  };
  ChildContinuation.$metadata$ = {
    simpleName: 'ChildContinuation',
    kind: 'class',
    interfaces: []
  };
  function handlesException($this) {
    var tmp = $this._get_parentHandle__7();
    var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_job__5();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parentJob = tmp_0;
    while (true) {
      if (parentJob._get_handlesException__7())
        return true;
      var tmp_1 = parentJob._get_parentHandle__7();
      var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._get_job__5();
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      parentJob = tmp_2;
    }
  }
  function JobImpl(parent_0) {
    JobSupport.call(this, true);
    this.initParentJobInternal_7(parent_0);
    this._handlesException = handlesException(this);
  }
  JobImpl.prototype._get_onCancelComplete__7 = function () {
    return true;
  };
  JobImpl.prototype._get_handlesException__7 = function () {
    return this._handlesException;
  };
  JobImpl.$metadata$ = {
    simpleName: 'JobImpl',
    kind: 'class',
    interfaces: [CompletableJob]
  };
  function _no_name_provided_$factory_28(this$0, resultContinuation) {
    var i = new _no_name_provided__36(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_61(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  MainCoroutineDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) : tmp0_elvis_lhs;
  };
  MainCoroutineDispatcher.prototype.toStringInternalImpl_0 = function () {
    var main_0 = Dispatchers_getInstance()._Main;
    if (this === main_0)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main_0._get_immediate__0();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  MainCoroutineDispatcher.$metadata$ = {
    simpleName: 'MainCoroutineDispatcher',
    kind: 'class',
    interfaces: []
  };
  function SupervisorJob(parent_0) {
    return new SupervisorJobImpl(parent_0);
  }
  function SupervisorJob$default(parent_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent_0 = null;
    return SupervisorJob(parent_0);
  }
  function SupervisorJobImpl(parent_0) {
    JobImpl.call(this, parent_0);
  }
  SupervisorJobImpl.prototype.childCancelled_10 = function (cause) {
    return false;
  };
  SupervisorJobImpl.$metadata$ = {
    simpleName: 'SupervisorJobImpl',
    kind: 'class',
    interfaces: []
  };
  function TimeoutCancellationException() {
  }
  TimeoutCancellationException.$metadata$ = {
    simpleName: 'TimeoutCancellationException',
    kind: 'class',
    interfaces: [CopyableThrowable]
  };
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  Unconfined.prototype.isDispatchNeeded_8 = function (context) {
    return false;
  };
  Unconfined.prototype.dispatch_8 = function (context, block) {
    var yieldContext = context.get_56(Key_getInstance_3());
    if (!(yieldContext == null)) {
      yieldContext.dispatcherWasUnconfined__error = true;
      return Unit_getInstance();
    }throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  Unconfined.prototype.toString = function () {
    return 'Dispatchers.Unconfined';
  };
  Unconfined.$metadata$ = {
    simpleName: 'Unconfined',
    kind: 'object',
    interfaces: []
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Key_4() {
    Key_instance_3 = this;
  }
  Key_4.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_3;
  function Key_getInstance_3() {
    if (Key_instance_3 == null)
      new Key_4();
    return Key_instance_3;
  }
  function checkCompletion(_this_) {
    var job = _this_.get_56(Key_getInstance_2());
    if (!(job == null) ? !job._get_isActive__20() : false)
      throw job.getCancellationException_8();
  }
  function Flow() {
  }
  Flow.$metadata$ = {
    simpleName: 'Flow',
    kind: 'interface',
    interfaces: []
  };
  function FlowCollector() {
  }
  FlowCollector.$metadata$ = {
    simpleName: 'FlowCollector',
    kind: 'interface',
    interfaces: []
  };
  function MutableSharedFlow() {
  }
  MutableSharedFlow.$metadata$ = {
    simpleName: 'MutableSharedFlow',
    kind: 'interface',
    interfaces: [SharedFlow, FlowCollector]
  };
  function SharedFlow() {
  }
  SharedFlow.$metadata$ = {
    simpleName: 'SharedFlow',
    kind: 'interface',
    interfaces: [Flow]
  };
  var NONE;
  var PENDING;
  function MutableStateFlow() {
  }
  MutableStateFlow.$metadata$ = {
    simpleName: 'MutableStateFlow',
    kind: 'interface',
    interfaces: [StateFlow, MutableSharedFlow]
  };
  function MutableStateFlow_0(value_0) {
    var tmp0_elvis_lhs = value_0;
    return new StateFlowImpl(tmp0_elvis_lhs == null ? NULL : tmp0_elvis_lhs);
  }
  function StateFlow() {
  }
  StateFlow.$metadata$ = {
    simpleName: 'StateFlow',
    kind: 'interface',
    interfaces: [SharedFlow]
  };
  function updateState($this, expectedState, newState) {
    var curSequence = 0;
    var curSlots = $this._get_slots__0();
    var oldState_2 = $this.__state_1._value;
    if (!(expectedState == null) ? !equals(oldState_2, expectedState) : false)
      return false;
    if (equals(oldState_2, newState))
      return true;
    $this.__state_1._value = newState;
    curSequence = $this._sequence;
    if ((curSequence & 1) === 0) {
      var tmp0_3 = curSequence;
      curSequence = tmp0_3 + 1 | 0;
      Unit_getInstance();
      $this._sequence = curSequence;
    } else {
      $this._sequence = curSequence + 2 | 0;
      return true;
    }
    curSlots = $this._get_slots__0();
    while (true) {
      var tmp0_safe_receiver = curSlots;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp0_iterator_1 = arrayIterator(tmp0_safe_receiver);
        while (tmp0_iterator_1.hasNext_27()) {
          var element_2 = tmp0_iterator_1.next_28();
          var tmp0_safe_receiver_4 = element_2;
          if (tmp0_safe_receiver_4 == null)
            null;
          else {
            tmp0_safe_receiver_4.makePending__error();
            Unit_getInstance();
          }
          Unit_getInstance();
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      if ($this._sequence === curSequence) {
        $this._sequence = curSequence + 1 | 0;
        return true;
      }curSequence = $this._sequence;
      curSlots = $this._get_slots__0();
    }
  }
  function StateFlowImpl(initialState) {
    AbstractSharedFlow.call(this);
    this.__state_1 = atomic(initialState);
    this._sequence = 0;
  }
  StateFlowImpl.prototype._set_value__5 = function (value_0) {
    var tmp0_elvis_lhs = value_0;
    updateState(this, null, tmp0_elvis_lhs == null ? NULL : tmp0_elvis_lhs);
    Unit_getInstance();
  };
  StateFlowImpl.prototype._get_value__13 = function () {
    var tmp0_unbox_0 = NULL;
    var tmp1_unbox_0 = this.__state_1._value;
    var tmp;
    if (tmp1_unbox_0 === tmp0_unbox_0) {
      tmp = (null == null ? true : isObject(null)) ? null : THROW_CCE();
    } else {
      tmp = isObject(tmp1_unbox_0) ? tmp1_unbox_0 : THROW_CCE();
    }
    return tmp;
  };
  StateFlowImpl.prototype.compareAndSet_0 = function (expect, update) {
    var tmp0_elvis_lhs = expect;
    var tmp = tmp0_elvis_lhs == null ? NULL : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = update;
    return updateState(this, tmp, tmp1_elvis_lhs == null ? NULL : tmp1_elvis_lhs);
  };
  StateFlowImpl.$metadata$ = {
    simpleName: 'StateFlowImpl',
    kind: 'class',
    interfaces: [MutableStateFlow, CancellableFlow, FusibleFlow]
  };
  function AbstractSharedFlow() {
    this._slots = null;
    this._nCollectors = 0;
    this._nextIndex = 0;
    this.__subscriptionCount = null;
  }
  AbstractSharedFlow.prototype._get_slots__0 = function () {
    return this._slots;
  };
  AbstractSharedFlow.$metadata$ = {
    simpleName: 'AbstractSharedFlow',
    kind: 'class',
    interfaces: []
  };
  function FusibleFlow() {
  }
  FusibleFlow.$metadata$ = {
    simpleName: 'FusibleFlow',
    kind: 'interface',
    interfaces: [Flow]
  };
  var NULL;
  function CancellableFlow() {
  }
  CancellableFlow.$metadata$ = {
    simpleName: 'CancellableFlow',
    kind: 'interface',
    interfaces: [Flow]
  };
  function ensureCapacity($this) {
    var currentSize = $this._elements.length;
    var newCapacity = currentSize << 1;
    var newElements = fillArrayVal(Array(newCapacity), null);
    var tmp0_copyInto_0 = $this._elements;
    var tmp1_copyInto_0 = $this._head_0;
    var tmp2_copyInto_0 = 0;
    var tmp3_copyInto_0 = tmp0_copyInto_0.length;
    arrayCopy_0(tmp0_copyInto_0, newElements, tmp2_copyInto_0, tmp1_copyInto_0, tmp3_copyInto_0);
    Unit_getInstance();
    var tmp4_copyInto_0 = $this._elements;
    var tmp5_copyInto_0 = $this._elements.length - $this._head_0 | 0;
    var tmp6_copyInto_0 = $this._head_0;
    var tmp7_copyInto_0 = 0;
    arrayCopy_0(tmp4_copyInto_0, newElements, tmp5_copyInto_0, tmp7_copyInto_0, tmp6_copyInto_0);
    Unit_getInstance();
    $this._elements = newElements;
    $this._head_0 = 0;
    $this._tail = currentSize;
  }
  function ArrayQueue() {
    var tmp = this;
    var tmp0_arrayOfNulls_0 = 16;
    tmp._elements = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._head_0 = 0;
    this._tail = 0;
  }
  ArrayQueue.prototype._get_isEmpty__3 = function () {
    return this._head_0 === this._tail;
  };
  ArrayQueue.prototype.addLast_7 = function (element) {
    this._elements[this._tail] = element;
    this._tail = (this._tail + 1 | 0) & (this._elements.length - 1 | 0);
    if (this._tail === this._head_0)
      ensureCapacity(this);
  };
  ArrayQueue.prototype.removeFirstOrNull_2 = function () {
    if (this._head_0 === this._tail)
      return null;
    var element = this._elements[this._head_0];
    this._elements[this._head_0] = null;
    this._head_0 = (this._head_0 + 1 | 0) & (this._elements.length - 1 | 0);
    return isObject(element) ? element : THROW_CCE();
  };
  ArrayQueue.$metadata$ = {
    simpleName: 'ArrayQueue',
    kind: 'class',
    interfaces: []
  };
  function OpDescriptor() {
  }
  OpDescriptor.$metadata$ = {
    simpleName: 'OpDescriptor',
    kind: 'class',
    interfaces: []
  };
  var UNDEFINED;
  var REUSABLE_CLAIMED;
  function resumeCancellableWith(_this_, result, onCancellation) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof DispatchedContinuation) {
      var tmp2_resumeCancellableWith_0 = _this_;
      var state_1 = toState_0(result, onCancellation);
      var tmp_0;
      if (tmp2_resumeCancellableWith_0._dispatcher.isDispatchNeeded_8(tmp2_resumeCancellableWith_0._get_context__22())) {
        tmp2_resumeCancellableWith_0.__state_2 = state_1;
        tmp2_resumeCancellableWith_0._set_resumeMode__0(1);
        tmp_0 = tmp2_resumeCancellableWith_0._dispatcher.dispatch_8(tmp2_resumeCancellableWith_0._get_context__22(), tmp2_resumeCancellableWith_0);
      } else {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_executeUnconfined_0 = 1;
          var tmp1_executeUnconfined_0 = false;
          var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
          if (tmp1_executeUnconfined_0 ? eventLoop_2._get_isUnconfinedQueueEmpty__0() : false) {
            tmp$ret$0 = false;
            break l$ret$1;
          }var tmp_1;
          if (eventLoop_2._get_isUnconfinedLoopActive__0()) {
            tmp2_resumeCancellableWith_0.__state_2 = state_1;
            tmp2_resumeCancellableWith_0._set_resumeMode__0(tmp0_executeUnconfined_0);
            eventLoop_2.dispatchUnconfined_0(tmp2_resumeCancellableWith_0);
            tmp_1 = true;
          } else {
            eventLoop_2.incrementUseCount_0(true);
            try {
              var tmp$ret$2;
              l$ret$3: do {
                var job_1_4 = tmp2_resumeCancellableWith_0._get_context__22().get_56(Key_getInstance_2());
                if (!(job_1_4 == null) ? !job_1_4._get_isActive__20() : false) {
                  var cause_2_5 = job_1_4.getCancellationException_8();
                  tmp2_resumeCancellableWith_0.cancelCompletedResult_1(state_1, cause_2_5);
                  var tmp0_failure_0_1_6 = Companion_getInstance_2();
                  tmp2_resumeCancellableWith_0.resumeWith_15(_Result___init__impl_(createFailure(cause_2_5)));
                  tmp$ret$2 = true;
                  break l$ret$3;
                }tmp$ret$2 = false;
              }
               while (false);
              if (!tmp$ret$2) {
                var tmp0_withContinuationContext_0_7 = tmp2_resumeCancellableWith_0._continuation_0;
                var tmp1_withContinuationContext_0_8 = tmp2_resumeCancellableWith_0._countOrElement;
                tmp2_resumeCancellableWith_0._continuation_0.resumeWith_15(result);
              } else {
              }
              $l$break: while (true) {
                if (!eventLoop_2.processUnconfinedEvent_0())
                  break $l$break;
              }
            } catch ($p) {
              if ($p instanceof Error) {
                tmp2_resumeCancellableWith_0.handleFatalException_1($p, null);
              } else {
                {
                  throw $p;
                }
              }
            }
            finally {
              eventLoop_2.decrementUseCount_0(true);
            }
            tmp_1 = false;
          }
          tmp$ret$0 = tmp_1;
        }
         while (false);
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = _this_.resumeWith_15(result);
      }
    }
    return tmp;
  }
  function resumeCancellableWith$default(_this_, result, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      onCancellation = null;
    return resumeCancellableWith(_this_, result, onCancellation);
  }
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this._dispatcher = dispatcher;
    this._continuation_0 = continuation;
    this.__state_2 = UNDEFINED;
    this._countOrElement = threadContextElements(this._get_context__22());
    this.__reusableCancellableContinuation = atomic(null);
  }
  DispatchedContinuation.prototype._get_context__22 = function () {
    return this._continuation_0._get_context__22();
  };
  DispatchedContinuation.prototype._get_reusableCancellableContinuation_ = function () {
    var tmp = this.__reusableCancellableContinuation._value;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  };
  DispatchedContinuation.prototype.isReusable = function (requester) {
    var tmp0_elvis_lhs = this.__reusableCancellableContinuation._value;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value_0 = tmp;
    if (value_0 instanceof CancellableContinuationImpl)
      return value_0 === requester;
    else {
    }
    return true;
  };
  DispatchedContinuation.prototype.checkPostponedCancellation = function (continuation) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value;
      if (tmp1__anonymous__1 === REUSABLE_CLAIMED) {
        if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(REUSABLE_CLAIMED, continuation))
          return null;
      } else {
        if (tmp1__anonymous__1 === null)
          return null;
        else {
          if (tmp1__anonymous__1 instanceof Error) {
            var tmp0_require_0_2 = this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, null);
            if (!tmp0_require_0_2) {
              var message_2_1_3 = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$(toString_1(message_2_1_3));
            }return tmp1__anonymous__1;
          } else {
            {
              var tmp1_error_0_4 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_4));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.postponeCancellation = function (cause) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (equals(tmp0_subject_2, REUSABLE_CLAIMED)) {
        if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(REUSABLE_CLAIMED, cause))
          return true;
      } else {
        if (tmp0_subject_2 instanceof Error)
          return true;
        else {
          {
            if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, null))
              return false;
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.takeState_1 = function () {
    var state = this.__state_2;
    this.__state_2 = UNDEFINED;
    return state;
  };
  DispatchedContinuation.prototype._get_delegate__1 = function () {
    return this;
  };
  DispatchedContinuation.prototype.resumeWith_15 = function (result) {
    var context = this._continuation_0._get_context__22();
    var state = toState$default(result, null, 1, null);
    if (this._dispatcher.isDispatchNeeded_8(context)) {
      this.__state_2 = state;
      this._set_resumeMode__0(0);
      this._dispatcher.dispatch_8(context, this);
    } else {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_executeUnconfined_0 = 0;
        var tmp1_executeUnconfined_0 = false;
        var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
        if (tmp1_executeUnconfined_0 ? eventLoop_2._get_isUnconfinedQueueEmpty__0() : false) {
          tmp$ret$0 = false;
          break l$ret$1;
        }var tmp;
        if (eventLoop_2._get_isUnconfinedLoopActive__0()) {
          this.__state_2 = state;
          this._set_resumeMode__0(tmp0_executeUnconfined_0);
          eventLoop_2.dispatchUnconfined_0(this);
          tmp = true;
        } else {
          eventLoop_2.incrementUseCount_0(true);
          try {
            var tmp0_withCoroutineContext_0_4 = this._get_context__22();
            var tmp1_withCoroutineContext_0_5 = this._countOrElement;
            this._continuation_0.resumeWith_15(result);
            $l$break: while (true) {
              if (!eventLoop_2.processUnconfinedEvent_0())
                break $l$break;
            }
          } catch ($p) {
            if ($p instanceof Error) {
              this.handleFatalException_1($p, null);
            } else {
              {
                throw $p;
              }
            }
          }
          finally {
            eventLoop_2.decrementUseCount_0(true);
          }
          tmp = false;
        }
        tmp$ret$0 = tmp;
      }
       while (false);
      Unit_getInstance();
    }
  };
  DispatchedContinuation.prototype.cancelCompletedResult_1 = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState._onCancellation_0(cause);
    } else {
    }
  };
  DispatchedContinuation.prototype.toString = function () {
    return '' + 'DispatchedContinuation[' + this._dispatcher + ', ' + toDebugString(this._continuation_0) + ']';
  };
  DispatchedContinuation.$metadata$ = {
    simpleName: 'DispatchedContinuation',
    kind: 'class',
    interfaces: [CoroutineStackFrame, Continuation]
  };
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this._resumeMode = resumeMode;
  }
  DispatchedTask.prototype._set_resumeMode__0 = function (_set___) {
    this._resumeMode = _set___;
  };
  DispatchedTask.prototype._get_resumeMode__0 = function () {
    return this._resumeMode;
  };
  DispatchedTask.prototype.cancelCompletedResult_1 = function (takenState, cause) {
  };
  DispatchedTask.prototype.getSuccessfulResult_1 = function (state) {
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedTask.prototype.getExceptionalResult_1 = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  };
  DispatchedTask.prototype.run_3 = function () {
    var taskContext = _get_taskContext_(this);
    var fatalException = null;
    try {
      var tmp = this._get_delegate__1();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate._continuation_0;
      var tmp0_withContinuationContext_0 = delegate._countOrElement;
      var context_2 = continuation._get_context__22();
      var state_3 = this.takeState_1();
      var exception_4 = this.getExceptionalResult_1(state_3);
      var job_5 = (exception_4 == null ? _get_isCancellableMode_(this._resumeMode) : false) ? context_2.get_56(Key_getInstance_2()) : null;
      if (!(job_5 == null) ? !job_5._get_isActive__20() : false) {
        var cause_6 = job_5.getCancellationException_8();
        this.cancelCompletedResult_1(state_3, cause_6);
        var tmp0_failure_0_7 = Companion_getInstance_2();
        var tmp1_failure_0_8 = recoverStackTrace(cause_6, continuation);
        continuation.resumeWith_15(_Result___init__impl_(createFailure(tmp1_failure_0_8)));
      } else {
        if (!(exception_4 == null)) {
          var tmp0_failure_0_1_9 = Companion_getInstance_2();
          continuation.resumeWith_15(_Result___init__impl_(createFailure(exception_4)));
        } else {
          var tmp2_resume_0_10 = this.getSuccessfulResult_1(state_3);
          var tmp0_success_0_1_11 = Companion_getInstance_2();
          continuation.resumeWith_15(_Result___init__impl_(tmp2_resume_0_10));
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        fatalException = $p;
      } else {
        {
          throw $p;
        }
      }
    }
    finally {
      var tmp_0;
      try {
        var tmp0_success_0_1 = Companion_getInstance_2();
        var tmp1_success_0_2 = Unit_getInstance();
        tmp_0 = _Result___init__impl_(Unit_getInstance());
      } catch ($p_0) {
        var tmp_1;
        if ($p_0 instanceof Error) {
          var tmp2_failure_0_4 = Companion_getInstance_2();
          tmp_1 = _Result___init__impl_(createFailure($p_0));
        } else {
          {
            throw $p_0;
          }
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      this.handleFatalException_1(fatalException, Result__exceptionOrNull_impl(result));
    }
  };
  DispatchedTask.prototype.handleFatalException_1 = function (exception, finallyException) {
    if (exception === null ? finallyException === null : false)
      return Unit_getInstance();
    if (!(exception === null) ? !(finallyException === null) : false) {
    }var tmp0_elvis_lhs = exception;
    var cause = tmp0_elvis_lhs == null ? finallyException : tmp0_elvis_lhs;
    var reason = new CoroutinesInternalError('' + 'Fatal exception in coroutines machinery for ' + this + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this._get_delegate__1()._get_context__22(), reason);
  };
  DispatchedTask.$metadata$ = {
    simpleName: 'DispatchedTask',
    kind: 'class',
    interfaces: []
  };
  function _get_isReusableMode_(_this_) {
    return _this_ === 2;
  }
  function _get_isCancellableMode_(_this_) {
    return _this_ === 1 ? true : _this_ === 2;
  }
  function dispatch(_this_, mode) {
    var delegate = _this_._get_delegate__1();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = _get_isCancellableMode_(mode) === _get_isCancellableMode_(_this_._resumeMode);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var dispatcher = delegate._dispatcher;
      var context = delegate._get_context__22();
      if (dispatcher.isDispatchNeeded_8(context)) {
        dispatcher.dispatch_8(context, _this_);
      } else {
        resumeUnconfined(_this_);
      }
    } else {
      {
        resume(_this_, delegate, undispatched);
      }
    }
  }
  function resumeUnconfined(_this_) {
    var eventLoop = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
    if (eventLoop._get_isUnconfinedLoopActive__0()) {
      eventLoop.dispatchUnconfined_0(_this_);
    } else {
      eventLoop.incrementUseCount_0(true);
      try {
        resume(_this_, _this_._get_delegate__1(), true);
        $l$break: while (true) {
          if (!eventLoop.processUnconfinedEvent_0())
            break $l$break;
        }
      } catch ($p) {
        if ($p instanceof Error) {
          _this_.handleFatalException_1($p, null);
        } else {
          {
            throw $p;
          }
        }
      }
      finally {
        eventLoop.decrementUseCount_0(true);
      }
    }
  }
  function resume(_this_, delegate, undispatched) {
    var state = _this_.takeState_1();
    var exception = _this_.getExceptionalResult_1(state);
    var tmp;
    if (!(exception == null)) {
      var tmp0_failure_0 = Companion_getInstance_2();
      tmp = _Result___init__impl_(createFailure(exception));
    } else {
      var tmp1_success_0 = Companion_getInstance_2();
      var tmp2_success_0 = _this_.getSuccessfulResult_1(state);
      tmp = _Result___init__impl_(tmp2_success_0);
    }
    var result = tmp;
    if (undispatched) {
      var tmp3_resumeUndispatchedWith_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      var tmp0_withContinuationContext_0_1 = tmp3_resumeUndispatchedWith_0._continuation_0;
      var tmp1_withContinuationContext_0_2 = tmp3_resumeUndispatchedWith_0._countOrElement;
      tmp3_resumeUndispatchedWith_0._continuation_0.resumeWith_15(result);
    } else
      delegate.resumeWith_15(result);
  }
  function ContextScope(context) {
    this._coroutineContext = context;
  }
  ContextScope.prototype._get_coroutineContext__6 = function () {
    return this._coroutineContext;
  };
  ContextScope.prototype.toString = function () {
    return '' + 'CoroutineScope(coroutineContext=' + this._coroutineContext + ')';
  };
  ContextScope.$metadata$ = {
    simpleName: 'ContextScope',
    kind: 'class',
    interfaces: [CoroutineScope]
  };
  function ScopeCoroutine(context, uCont) {
    AbstractCoroutine.call(this, context, true);
    this._uCont = uCont;
  }
  ScopeCoroutine.prototype._get_uCont__1 = function () {
    return this._uCont;
  };
  ScopeCoroutine.prototype._get_isScopedCoroutine__7 = function () {
    return true;
  };
  ScopeCoroutine.prototype.afterCompletion_7 = function (state) {
    var tmp = intercepted(this._uCont);
    var tmp_0 = recoverResult(state, this._uCont);
    resumeCancellableWith$default(tmp, tmp_0, null, 2, null);
  };
  ScopeCoroutine.prototype.afterResume_4 = function (state) {
    this._uCont.resumeWith_15(recoverResult(state, this._uCont));
  };
  ScopeCoroutine.$metadata$ = {
    simpleName: 'ScopeCoroutine',
    kind: 'class',
    interfaces: [CoroutineStackFrame]
  };
  function Symbol(symbol) {
    this._symbol = symbol;
  }
  Symbol.prototype.toString = function () {
    return '' + '<' + this._symbol + '>';
  };
  Symbol.$metadata$ = {
    simpleName: 'Symbol',
    kind: 'class',
    interfaces: []
  };
  function startCoroutineCancellable(_this_, receiver, completion, onCancellation) {
    var tmp;
    try {
      var tmp_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
      var tmp0_success_0_3 = Companion_getInstance_2();
      var tmp1_success_0_4 = Unit_getInstance();
      tmp = resumeCancellableWith(tmp_0, _Result___init__impl_(Unit_getInstance()), onCancellation);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var tmp0_failure_0 = Companion_getInstance_2();
        tmp_1 = completion.resumeWith_15(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function startCoroutineCancellable$default(_this_, receiver, completion, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    return startCoroutineCancellable(_this_, receiver, completion, onCancellation);
  }
  function startCoroutineCancellable_0(_this_, fatalCompletion) {
    var tmp;
    try {
      var tmp_0 = intercepted(_this_);
      var tmp0_success_0_4 = Companion_getInstance_2();
      var tmp1_success_0_5 = Unit_getInstance();
      var tmp_1 = _Result___init__impl_(Unit_getInstance());
      tmp = resumeCancellableWith$default(tmp_0, tmp_1, null, 2, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var tmp0_failure_0_2 = Companion_getInstance_2();
        tmp_2 = fatalCompletion.resumeWith_15(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function startUndispatchedOrReturn(_this_, receiver, block) {
    _this_.initParentJob_4();
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      try {
        tmp = block(receiver, _this_);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp_1 = $p;
          tmp_0 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var result_1 = tmp;
      if (result_1 === _get_COROUTINE_SUSPENDED_()) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var state_3 = _this_.makeCompletingOnce_5(result_1);
      if (state_3 === COMPLETING_WAITING_CHILDREN) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var tmp_2;
      if (state_3 instanceof CompletedExceptionally) {
        var tmp_3;
        var tmp0__anonymous__5 = state_3._cause;
        {
          throw recoverStackTrace(state_3._cause, _this_._uCont);
        }
        tmp_2 = tmp_3;
      } else {
        {
          tmp_2 = unboxState(state_3);
        }
      }
      tmp$ret$0 = tmp_2;
    }
     while (false);
    return tmp$ret$0;
  }
  function startCoroutineUndispatched(_this_, receiver, completion) {
    var tmp$ret$0;
    l$ret$1: do {
      var actualCompletion_1 = completion;
      var tmp;
      try {
        var tmp0_withCoroutineContext_0_8 = completion._get_context__22();
        var tmp1_withCoroutineContext_0_9 = null;
        tmp = _this_(receiver, actualCompletion_1);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp0_failure_0_1_4 = Companion_getInstance_2();
          actualCompletion_1.resumeWith_15(_Result___init__impl_(createFailure($p)));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_2 = tmp;
      if (!(value_2 === _get_COROUTINE_SUSPENDED_())) {
        var tmp0_resume_0_5 = (value_2 == null ? true : isObject(value_2)) ? value_2 : THROW_CCE();
        var tmp0_success_0_1_6 = Companion_getInstance_2();
        actualCompletion_1.resumeWith_15(_Result___init__impl_(tmp0_resume_0_5));
      }}
     while (false);
  }
  function SelectClause0() {
  }
  SelectClause0.$metadata$ = {
    simpleName: 'SelectClause0',
    kind: 'interface',
    interfaces: []
  };
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  CompletionHandlerBase.$metadata$ = {
    simpleName: 'CompletionHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function invokeIt(_this_, cause) {
    var tmp0_subject = typeof _this_;
    if (tmp0_subject === 'function')
      _this_(cause);
    else {
      _this_.invoke(cause);
    }
  }
  function CancelHandlerBase() {
  }
  CancelHandlerBase.$metadata$ = {
    simpleName: 'CancelHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function toDebugString(_this_) {
    return toString_1(_this_);
  }
  function newCoroutineContext(_this_, context) {
    var combined = _this_._get_coroutineContext__6().plus_25(context);
    return (!(combined === Dispatchers_getInstance()._Default) ? combined.get_56(Key_getInstance()) == null : false) ? combined.plus_25(Dispatchers_getInstance()._Default) : combined;
  }
  function UndispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
  }
  UndispatchedCoroutine.prototype.afterResume_4 = function (state) {
    return this._get_uCont__1().resumeWith_15(recoverResult(state, this._get_uCont__1()));
  };
  UndispatchedCoroutine.$metadata$ = {
    simpleName: 'UndispatchedCoroutine',
    kind: 'class',
    interfaces: []
  };
  function _get_coroutineName_(_this_) {
    return null;
  }
  function createDefaultDispatcher() {
    var tmp;
    if ((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.product == 'ReactNative' : false) {
      tmp = NodeDispatcher_getInstance();
    } else {
      if (isJsdom()) {
        tmp = NodeDispatcher_getInstance();
      } else {
        var tmp_0;
        var tmp_1;
        if (!(typeof window === 'undefined')) {
          var tmp0_asDynamic_0 = window;
          tmp_1 = tmp0_asDynamic_0 != null;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp1_asDynamic_0 = window;
          tmp_0 = !(typeof tmp1_asDynamic_0.addEventListener === 'undefined');
        } else {
          {
            tmp_0 = false;
          }
        }
        if (tmp_0) {
          tmp = asCoroutineDispatcher(window);
        } else {
          if (typeof process === 'undefined') {
            tmp = SetTimeoutDispatcher_getInstance();
          } else {
            {
              tmp = NodeDispatcher_getInstance();
            }
          }
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return ((((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.userAgent != null : false) ? !(typeof navigator.userAgent === 'undefined') : false) ? !(typeof navigator.userAgent.match === 'undefined') : false) ? navigator.userAgent.match('\\bjsdom\\b') : false;
  }
  function handleCoroutineExceptionImpl(context, exception) {
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([exception]));
    }.call(this));
  }
  var counter;
  var DEBUG;
  function _get_classSimpleName_(_this_) {
    var tmp0_elvis_lhs = getKClassFromExpression_0(_this_)._get_simpleName__4();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function _get_hexAddress_(_this_) {
    var result = _this_.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      _this_.__debug_counter = result;
    }return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this._Default = createDefaultDispatcher();
    this._Main = new JsMainDispatcher(this._Default, false);
    this._Unconfined = Unconfined_getInstance();
  }
  Dispatchers.$metadata$ = {
    simpleName: 'Dispatchers',
    kind: 'object',
    interfaces: []
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this._delegate_1 = delegate;
    this._invokeImmediately = invokeImmediately;
    this._immediate = this._invokeImmediately ? this : new JsMainDispatcher(this._delegate_1, true);
  }
  JsMainDispatcher.prototype._get_immediate__0 = function () {
    return this._immediate;
  };
  JsMainDispatcher.prototype.isDispatchNeeded_8 = function (context) {
    return !this._invokeImmediately;
  };
  JsMainDispatcher.prototype.dispatch_8 = function (context, block) {
    return this._delegate_1.dispatch_8(context, block);
  };
  JsMainDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? this._delegate_1.toString() : tmp0_elvis_lhs;
  };
  JsMainDispatcher.$metadata$ = {
    simpleName: 'JsMainDispatcher',
    kind: 'class',
    interfaces: []
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  UnconfinedEventLoop.prototype.dispatch_8 = function (context, block) {
    unsupported();
  };
  UnconfinedEventLoop.$metadata$ = {
    simpleName: 'UnconfinedEventLoop',
    kind: 'class',
    interfaces: []
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
  }
  function JobCancellationException(message, cause, job) {
    CancellationException.call(this, message, cause);
    this._job_0 = job;
    captureStack(this, JobCancellationException);
  }
  JobCancellationException.prototype.toString = function () {
    return '' + CancellationException.prototype.toString.call(this) + '; job=' + this._job_0;
  };
  JobCancellationException.prototype.equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        {
          tmp_2 = false;
        }
      }
      if (tmp_2) {
        tmp_1 = equals(other._job_0, this._job_0);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = equals(other.cause, this.cause);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  JobCancellationException.prototype.hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this._job_0) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  JobCancellationException.$metadata$ = {
    simpleName: 'JobCancellationException',
    kind: 'class',
    interfaces: []
  };
  function CancellationException_init_$Init$(message, $this) {
    CancellationException.call($this, message, null);
    return $this;
  }
  function CancellationException_init_$Create$(message) {
    var tmp = CancellationException_init_$Init$(message, Object.create(CancellationException.prototype));
    captureStack(tmp, CancellationException_init_$Create$);
    return tmp;
  }
  function CancellationException(message, cause) {
    IllegalStateException_init_$Init$_0(message, cause, this);
    captureStack(this, CancellationException);
  }
  CancellationException.$metadata$ = {
    simpleName: 'CancellationException',
    kind: 'class',
    interfaces: []
  };
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  NodeDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    process.nextTick(this._get_messageQueue__1()._processQueue);
  };
  NodeDispatcher.$metadata$ = {
    simpleName: 'NodeDispatcher',
    kind: 'object',
    interfaces: []
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  SetTimeoutDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    setTimeout(this._get_messageQueue__1()._processQueue, 0);
    Unit_getInstance();
  };
  SetTimeoutDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutDispatcher',
    kind: 'object',
    interfaces: []
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function _no_name_provided__37(this$0) {
    this._this$0_5 = this$0;
  }
  _no_name_provided__37.prototype.invoke_415 = function () {
    this._this$0_5.process_1();
  };
  _no_name_provided__37.prototype.invoke_452 = function () {
    this.invoke_415();
    return Unit_getInstance();
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ScheduledMessageQueue($outer) {
    this._$this_7 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp._processQueue = _no_name_provided_$factory_29(this);
  }
  ScheduledMessageQueue.prototype.schedule_1 = function () {
    this._$this_7.scheduleQueueProcessing_1();
  };
  ScheduledMessageQueue.prototype.reschedule_1 = function () {
    setTimeout(this._processQueue, 0);
    Unit_getInstance();
  };
  ScheduledMessageQueue.$metadata$ = {
    simpleName: 'ScheduledMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this._messageQueue = new ScheduledMessageQueue(this);
  }
  SetTimeoutBasedDispatcher.prototype._get_messageQueue__1 = function () {
    return this._messageQueue;
  };
  SetTimeoutBasedDispatcher.prototype.dispatch_8 = function (context, block) {
    this._messageQueue.enqueue_1(block);
  };
  SetTimeoutBasedDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutBasedDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function MessageQueue() {
    ArrayQueue.call(this);
    this._yieldEvery = 16;
    this._scheduled = false;
  }
  MessageQueue.prototype.enqueue_1 = function (element) {
    this.addLast_7(element);
    if (!this._scheduled) {
      this._scheduled = true;
      this.schedule_1();
    }};
  MessageQueue.prototype.process_1 = function () {
    try {
      var tmp0_repeat_0 = this._yieldEvery;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_repeat_0)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs_5 = this.removeFirstOrNull_2();
          var tmp;
          if (tmp0_elvis_lhs_5 == null) {
            return Unit_getInstance();
          } else {
            tmp = tmp0_elvis_lhs_5;
          }
          var element_4 = tmp;
          element_4.run_3();
        }
         while (inductionVariable < tmp0_repeat_0);
    }finally {
      if (this._get_isEmpty__3()) {
        this._scheduled = false;
      } else {
        this.reschedule_1();
      }
    }
  };
  MessageQueue.$metadata$ = {
    simpleName: 'MessageQueue',
    kind: 'class',
    interfaces: []
  };
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this._window = window_0;
    this._queue = new WindowMessageQueue(this._window);
  }
  WindowDispatcher.prototype.dispatch_8 = function (context, block) {
    return this._queue.enqueue_1(block);
  };
  WindowDispatcher.$metadata$ = {
    simpleName: 'WindowDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function _no_name_provided__38(this$0) {
    this._this$0_6 = this$0;
  }
  _no_name_provided__38.prototype.invoke_68 = function (event) {
    if (event.source == this._this$0_6._window_0 ? event.data == this._this$0_6._messageName : false) {
      event.stopPropagation();
      this._this$0_6.process_1();
    }};
  _no_name_provided__38.prototype.invoke_468 = function (p1) {
    this.invoke_68((p1 == null ? true : p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__39(this$0) {
    this._this$0_7 = this$0;
  }
  _no_name_provided__39.prototype.invoke_70 = function (it) {
    this._this$0_7.process_1();
  };
  _no_name_provided__39.prototype.invoke_468 = function (p1) {
    this.invoke_70(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this._window_0 = window_0;
    this._messageName = 'dispatchCoroutine';
    this._window_0.addEventListener('message', _no_name_provided_$factory_30(this), true);
  }
  WindowMessageQueue.prototype.schedule_1 = function () {
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(_no_name_provided_$factory_31(this));
    Unit_getInstance();
  };
  WindowMessageQueue.prototype.reschedule_1 = function () {
    this._window_0.postMessage(this._messageName, '*');
  };
  WindowMessageQueue.$metadata$ = {
    simpleName: 'WindowMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_29(this$0) {
    var i = new _no_name_provided__37(this$0);
    return function () {
      i.invoke_415();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_30(this$0) {
    var i = new _no_name_provided__38(this$0);
    return function (p1) {
      i.invoke_68(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_31(this$0) {
    var i = new _no_name_provided__39(this$0);
    return function (p1) {
      i.invoke_70(p1);
      return Unit_getInstance();
    };
  }
  function Runnable() {
  }
  Runnable.$metadata$ = {
    simpleName: 'Runnable',
    kind: 'interface',
    interfaces: []
  };
  function SchedulerTask() {
  }
  SchedulerTask.$metadata$ = {
    simpleName: 'SchedulerTask',
    kind: 'class',
    interfaces: [Runnable]
  };
  function _get_taskContext_(_this_) {
    return Unit_getInstance();
  }
  function asCoroutineDispatcher(_this_) {
    var tmp0_elvis_lhs = _this_.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new WindowDispatcher(_this_);
      _this_.coroutineDispatcher = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function identitySet(expectedSize) {
    return HashSet_init_$Create$_0(expectedSize);
  }
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  LinkedListHead.$metadata$ = {
    simpleName: 'LinkedListHead',
    kind: 'class',
    interfaces: []
  };
  function LinkedListNode() {
    this.__next = this;
    this.__prev = this;
    this.__removed = false;
  }
  LinkedListNode.prototype._get__next__1 = function () {
    return this.__next;
  };
  LinkedListNode.prototype.addLast_13 = function (node_0) {
    var prev = this.__prev;
    node_0.__next = this;
    node_0.__prev = prev;
    prev.__next = node_0;
    this.__prev = node_0;
  };
  LinkedListNode.prototype.remove_37 = function () {
    if (this.__removed)
      return false;
    var prev = this.__prev;
    var next = this.__next;
    prev.__next = next;
    next.__prev = prev;
    this.__removed = true;
    return true;
  };
  LinkedListNode.prototype.addOneIfEmpty_6 = function (node_0) {
    if (!(this.__next === this))
      return false;
    this.addLast_13(node_0);
    return true;
  };
  LinkedListNode.$metadata$ = {
    simpleName: 'LinkedListNode',
    kind: 'class',
    interfaces: []
  };
  function unwrap(exception) {
    return exception;
  }
  function CoroutineStackFrame() {
  }
  CoroutineStackFrame.$metadata$ = {
    simpleName: 'CoroutineStackFrame',
    kind: 'interface',
    interfaces: []
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this._value_2 = null;
  }
  CommonThreadLocal.prototype.get_55 = function () {
    var tmp = this._value_2;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  CommonThreadLocal.prototype.set_4 = function (value_0) {
    this._value_2 = value_0;
  };
  CommonThreadLocal.$metadata$ = {
    simpleName: 'CommonThreadLocal',
    kind: 'class',
    interfaces: []
  };
  function ImmutableCollection() {
  }
  ImmutableCollection.$metadata$ = {
    simpleName: 'ImmutableCollection',
    kind: 'interface',
    interfaces: [Collection]
  };
  function PersistentCollection() {
  }
  PersistentCollection.$metadata$ = {
    simpleName: 'PersistentCollection',
    kind: 'interface',
    interfaces: [ImmutableCollection]
  };
  function PersistentList() {
  }
  PersistentList.$metadata$ = {
    simpleName: 'PersistentList',
    kind: 'interface',
    interfaces: [ImmutableList, PersistentCollection]
  };
  function ImmutableList() {
  }
  ImmutableList.$metadata$ = {
    simpleName: 'ImmutableList',
    kind: 'interface',
    interfaces: [List, ImmutableCollection]
  };
  function PersistentMap() {
  }
  PersistentMap.$metadata$ = {
    simpleName: 'PersistentMap',
    kind: 'interface',
    interfaces: [ImmutableMap]
  };
  function ImmutableMap() {
  }
  ImmutableMap.$metadata$ = {
    simpleName: 'ImmutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function PersistentSet() {
  }
  PersistentSet.$metadata$ = {
    simpleName: 'PersistentSet',
    kind: 'interface',
    interfaces: [ImmutableSet, PersistentCollection]
  };
  function ImmutableSet() {
  }
  ImmutableSet.$metadata$ = {
    simpleName: 'ImmutableSet',
    kind: 'interface',
    interfaces: [Set, ImmutableCollection]
  };
  function persistentHashMapOf() {
    return Companion_getInstance_8().emptyOf();
  }
  function persistentSetOf() {
    return Companion_getInstance_10().emptyOf_0();
  }
  function persistentListOf() {
    return persistentVectorOf();
  }
  function AbstractListIterator(index, size_1) {
    this._index_3 = index;
    this._size_0 = size_1;
  }
  AbstractListIterator.prototype._set_index__8 = function (_set___) {
    this._index_3 = _set___;
  };
  AbstractListIterator.prototype._get_index__8 = function () {
    return this._index_3;
  };
  AbstractListIterator.prototype._get_size__45 = function () {
    return this._size_0;
  };
  AbstractListIterator.prototype.hasNext_27 = function () {
    return this._index_3 < this._size_0;
  };
  AbstractListIterator.prototype.hasPrevious_8 = function () {
    return this._index_3 > 0;
  };
  AbstractListIterator.prototype.nextIndex_7 = function () {
    return this._index_3;
  };
  AbstractListIterator.prototype.checkHasNext_0 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
  };
  AbstractListIterator.prototype.checkHasPrevious_0 = function () {
    if (!this.hasPrevious_8())
      throw NoSuchElementException_init_$Create$();
  };
  AbstractListIterator.$metadata$ = {
    simpleName: 'AbstractListIterator',
    kind: 'class',
    interfaces: [ListIterator]
  };
  function AbstractPersistentList() {
    AbstractList.call(this);
  }
  AbstractPersistentList.prototype.remove_51 = function (element) {
    var index = this.indexOf_5(element);
    if (!(index === -1)) {
      return this.removeAt_7(index);
    }return this;
  };
  AbstractPersistentList.prototype.contains_37 = function (element) {
    return !(this.indexOf_5(element) === -1);
  };
  AbstractPersistentList.prototype.containsAll_28 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        if (!this.contains_37(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractPersistentList.prototype.iterator_46 = function () {
    return this.listIterator_11();
  };
  AbstractPersistentList.prototype.listIterator_11 = function () {
    return this.listIterator_12(0);
  };
  AbstractPersistentList.$metadata$ = {
    simpleName: 'AbstractPersistentList',
    kind: 'class',
    interfaces: [PersistentList]
  };
  function BufferIterator(buffer, index, size_1) {
    AbstractListIterator.call(this, index, size_1);
    this._buffer = buffer;
  }
  BufferIterator.prototype.next_28 = function () {
    if (!this.hasNext_27()) {
      throw NoSuchElementException_init_$Create$();
    }var tmp0_this = this;
    var tmp1 = tmp0_this._get_index__8();
    tmp0_this._set_index__8(tmp1 + 1 | 0);
    return this._buffer[tmp1];
  };
  BufferIterator.prototype.previous_7 = function () {
    if (!this.hasPrevious_8()) {
      throw NoSuchElementException_init_$Create$();
    }var tmp0_this = this;
    tmp0_this._set_index__8(tmp0_this._get_index__8() - 1 | 0);
    return this._buffer[tmp0_this._get_index__8()];
  };
  BufferIterator.$metadata$ = {
    simpleName: 'BufferIterator',
    kind: 'class',
    interfaces: []
  };
  function rootSize($this) {
    return rootSize_0($this._size_1);
  }
  function pushFilledTail($this, root, filledTail, newTail) {
    if ($this._size_1 >> 5 > 1 << $this._rootShift) {
      var newRoot = presizedBufferWith(root);
      var newRootShift = $this._rootShift + 5 | 0;
      newRoot = pushTail($this, newRoot, newRootShift, filledTail);
      return new PersistentVector(newRoot, newTail, $this._size_1 + 1 | 0, newRootShift);
    }var newRoot_0 = pushTail($this, root, $this._rootShift, filledTail);
    return new PersistentVector(newRoot_0, newTail, $this._size_1 + 1 | 0, $this._rootShift);
  }
  function pushTail($this, root, shift, tail) {
    var bufferIndex = indexSegment($this._size_1 - 1 | 0, shift);
    var tmp0_safe_receiver = root;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : copyOf_0(tmp0_safe_receiver, 32);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_arrayOfNulls_0 = 32;
      tmp = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newRootNode = tmp;
    if (shift === 5) {
      newRootNode[bufferIndex] = tail;
    } else {
      var tmp_0 = newRootNode[bufferIndex];
      newRootNode[bufferIndex] = pushTail($this, (tmp_0 == null ? true : isArray(tmp_0)) ? tmp_0 : THROW_CCE(), shift - 5 | 0, tail);
    }
    return newRootNode;
  }
  function insertIntoTail($this, root, tailIndex, element) {
    var tailSize = $this._size_1 - rootSize($this) | 0;
    var newTail = copyOf_0($this._tail_0, 32);
    if (tailSize < 32) {
      var tmp0_copyInto_0 = $this._tail_0;
      var tmp1_copyInto_0 = tailIndex + 1 | 0;
      arrayCopy_0(tmp0_copyInto_0, newTail, tmp1_copyInto_0, tailIndex, tailSize);
      Unit_getInstance();
      newTail[tailIndex] = element;
      return new PersistentVector(root, newTail, $this._size_1 + 1 | 0, $this._rootShift);
    }var lastElement = $this._tail_0[31];
    var tmp2_copyInto_0 = $this._tail_0;
    var tmp3_copyInto_0 = tailIndex + 1 | 0;
    var tmp4_copyInto_0 = tailSize - 1 | 0;
    arrayCopy_0(tmp2_copyInto_0, newTail, tmp3_copyInto_0, tailIndex, tmp4_copyInto_0);
    Unit_getInstance();
    newTail[tailIndex] = element;
    return pushFilledTail($this, root, newTail, presizedBufferWith(lastElement));
  }
  function insertIntoRoot($this, root, shift, index, element, elementCarry) {
    var bufferIndex = indexSegment(index, shift);
    if (shift === 0) {
      var tmp;
      if (bufferIndex === 0) {
        var tmp0_arrayOfNulls_0 = 32;
        tmp = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      } else {
        tmp = copyOf_0(root, 32);
      }
      var newRoot = tmp;
      var tmp1_copyInto_0 = bufferIndex + 1 | 0;
      var tmp2_copyInto_0 = 31;
      arrayCopy_0(root, newRoot, tmp1_copyInto_0, bufferIndex, tmp2_copyInto_0);
      Unit_getInstance();
      elementCarry._value_3 = root[31];
      newRoot[bufferIndex] = element;
      return newRoot;
    }var newRoot_0 = copyOf_0(root, 32);
    var lowerLevelShift = shift - 5 | 0;
    var tmp_0 = root[bufferIndex];
    newRoot_0[bufferIndex] = insertIntoRoot($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), lowerLevelShift, index, element, elementCarry);
    var inductionVariable = bufferIndex + 1 | 0;
    var last = 32;
    if (inductionVariable < last)
      $l$break: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (newRoot_0[i] == null)
          break $l$break;
        var tmp_1 = root[i];
        newRoot_0[i] = insertIntoRoot($this, (!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE(), lowerLevelShift, 0, elementCarry._value_3, elementCarry);
      }
       while (inductionVariable < last);
    return newRoot_0;
  }
  function removeFromTailAt($this, root, rootSize_1, shift, index) {
    var tailSize = $this._size_1 - rootSize_1 | 0;
    assert(index < tailSize);
    if (tailSize === 1) {
      return pullLastBufferFromRoot($this, root, rootSize_1, shift);
    }var newTail = copyOf_0($this._tail_0, 32);
    if (index < (tailSize - 1 | 0)) {
      var tmp0_copyInto_0 = $this._tail_0;
      var tmp1_copyInto_0 = index + 1 | 0;
      arrayCopy_0(tmp0_copyInto_0, newTail, index, tmp1_copyInto_0, tailSize);
      Unit_getInstance();
    }newTail[tailSize - 1 | 0] = null;
    return new PersistentVector(root, newTail, (rootSize_1 + tailSize | 0) - 1 | 0, shift);
  }
  function pullLastBufferFromRoot($this, root, rootSize_1, shift) {
    if (shift === 0) {
      var buffer = root.length === 33 ? copyOf_0(root, 32) : root;
      return new SmallPersistentVector(buffer);
    }var tailCarry = new ObjectRef(null);
    var newRoot = ensureNotNull(pullLastBuffer($this, root, shift, rootSize_1 - 1 | 0, tailCarry));
    var tmp = tailCarry._value_3;
    var newTail = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
    if (newRoot[1] == null) {
      var tmp_0 = newRoot[0];
      var lowerLevelRoot = (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE();
      return new PersistentVector(lowerLevelRoot, newTail, rootSize_1, shift - 5 | 0);
    }return new PersistentVector(newRoot, newTail, rootSize_1, shift);
  }
  function pullLastBuffer($this, root, shift, index, tailCarry) {
    var bufferIndex = indexSegment(index, shift);
    var tmp;
    if (shift === 5) {
      tailCarry._value_3 = root[bufferIndex];
      tmp = null;
    } else {
      var tmp_0 = root[bufferIndex];
      tmp = pullLastBuffer($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), shift - 5 | 0, index, tailCarry);
    }
    var newBufferAtIndex = tmp;
    if (newBufferAtIndex == null ? bufferIndex === 0 : false) {
      return null;
    }var newRoot = copyOf_0(root, 32);
    newRoot[bufferIndex] = newBufferAtIndex;
    return newRoot;
  }
  function removeFromRootAt($this, root, shift, index, tailCarry) {
    var bufferIndex = indexSegment(index, shift);
    if (shift === 0) {
      var tmp;
      if (bufferIndex === 0) {
        var tmp0_arrayOfNulls_0 = 32;
        tmp = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      } else {
        tmp = copyOf_0(root, 32);
      }
      var newRoot = tmp;
      var tmp1_copyInto_0 = bufferIndex + 1 | 0;
      var tmp2_copyInto_0 = 32;
      arrayCopy_0(root, newRoot, bufferIndex, tmp1_copyInto_0, tmp2_copyInto_0);
      Unit_getInstance();
      newRoot[31] = tailCarry._value_3;
      tailCarry._value_3 = root[bufferIndex];
      return newRoot;
    }var bufferLastIndex = 31;
    if (root[bufferLastIndex] == null) {
      bufferLastIndex = indexSegment(rootSize($this) - 1 | 0, shift);
    }var newRoot_0 = copyOf_0(root, 32);
    var lowerLevelShift = shift - 5 | 0;
    var inductionVariable = bufferLastIndex;
    var last = bufferIndex + 1 | 0;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp_0 = newRoot_0[i];
        newRoot_0[i] = removeFromRootAt($this, (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : THROW_CCE(), lowerLevelShift, 0, tailCarry);
      }
       while (!(i === last));
    var tmp_1 = newRoot_0[bufferIndex];
    newRoot_0[bufferIndex] = removeFromRootAt($this, (!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE(), lowerLevelShift, index, tailCarry);
    return newRoot_0;
  }
  function bufferFor($this, index) {
    if (rootSize($this) <= index) {
      return $this._tail_0;
    }var buffer = $this._root;
    var shift = $this._rootShift;
    while (shift > 0) {
      var tmp = buffer[indexSegment(index, shift)];
      buffer = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
      shift = shift - 5 | 0;
    }
    return buffer;
  }
  function setInRoot($this, root, shift, index, e) {
    var bufferIndex = indexSegment(index, shift);
    var newRoot = copyOf_0(root, 32);
    if (shift === 0) {
      newRoot[bufferIndex] = e;
    } else {
      var tmp = newRoot[bufferIndex];
      newRoot[bufferIndex] = setInRoot($this, (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE(), shift - 5 | 0, index, e);
    }
    return newRoot;
  }
  function PersistentVector(root, tail, size_1, rootShift) {
    AbstractPersistentList.call(this);
    this._root = root;
    this._tail_0 = tail;
    this._size_1 = size_1;
    this._rootShift = rootShift;
    var tmp0_require_0 = this._size_1 > 32;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Trie-based persistent vector should have at least 33 elements, got ' + this._size_1;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }assert((this._size_1 - rootSize_0(this._size_1) | 0) <= coerceAtMost(this._tail_0.length, 32));
  }
  PersistentVector.prototype._get_size__45 = function () {
    return this._size_1;
  };
  PersistentVector.prototype.add_37 = function (element) {
    var tailSize = this._size_1 - rootSize(this) | 0;
    if (tailSize < 32) {
      var newTail = copyOf_0(this._tail_0, 32);
      newTail[tailSize] = element;
      return new PersistentVector(this._root, newTail, this._size_1 + 1 | 0, this._rootShift);
    }var newTail_0 = presizedBufferWith(element);
    return pushFilledTail(this, this._root, this._tail_0, newTail_0);
  };
  PersistentVector.prototype.add_31 = function (index, element) {
    ListImplementation_getInstance().checkPositionIndex_0(index, this._size_1);
    if (index === this._size_1) {
      return this.add_37(element);
    }var rootSize_1 = rootSize(this);
    if (index >= rootSize_1) {
      return insertIntoTail(this, this._root, index - rootSize_1 | 0, element);
    }var elementCarry = new ObjectRef(null);
    var newRoot = insertIntoRoot(this, this._root, this._rootShift, index, element, elementCarry);
    return insertIntoTail(this, newRoot, 0, elementCarry._value_3);
  };
  PersistentVector.prototype.removeAt_7 = function (index) {
    ListImplementation_getInstance().checkElementIndex_0(index, this._size_1);
    var rootSize_1 = rootSize(this);
    if (index >= rootSize_1) {
      return removeFromTailAt(this, this._root, rootSize_1, this._rootShift, index - rootSize_1 | 0);
    }var newRoot = removeFromRootAt(this, this._root, this._rootShift, index, new ObjectRef(this._tail_0[0]));
    return removeFromTailAt(this, newRoot, rootSize_1, this._rootShift, 0);
  };
  PersistentVector.prototype.listIterator_12 = function (index) {
    ListImplementation_getInstance().checkPositionIndex_0(index, this._size_1);
    var tmp = this._tail_0;
    return new PersistentVectorIterator(this._root, isArray(tmp) ? tmp : THROW_CCE(), index, this._size_1, (this._rootShift / 5 | 0) + 1 | 0);
  };
  PersistentVector.prototype.get_66 = function (index) {
    ListImplementation_getInstance().checkElementIndex_0(index, this._size_1);
    var buffer = bufferFor(this, index);
    var tmp = buffer[index & 31];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  PersistentVector.prototype.set_13 = function (index, element) {
    ListImplementation_getInstance().checkElementIndex_0(index, this._size_1);
    if (rootSize(this) <= index) {
      var newTail = copyOf_0(this._tail_0, 32);
      newTail[index & 31] = element;
      return new PersistentVector(this._root, newTail, this._size_1, this._rootShift);
    }var newRoot = setInRoot(this, this._root, this._rootShift, index, element);
    return new PersistentVector(newRoot, this._tail_0, this._size_1, this._rootShift);
  };
  PersistentVector.$metadata$ = {
    simpleName: 'PersistentVector',
    kind: 'class',
    interfaces: [PersistentList]
  };
  function PersistentVectorIterator(root, tail, index, size_1, trieHeight) {
    AbstractListIterator.call(this, index, size_1);
    this._tail_1 = tail;
    var trieSize = rootSize_0(size_1);
    var trieIndex = coerceAtMost(index, trieSize);
    this._trieIterator = new TrieIterator(root, trieIndex, trieSize, trieHeight);
  }
  PersistentVectorIterator.prototype.next_28 = function () {
    this.checkHasNext_0();
    if (this._trieIterator.hasNext_27()) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._get_index__8();
      tmp0_this._set_index__8(tmp1 + 1 | 0);
      Unit_getInstance();
      return this._trieIterator.next_28();
    }var tmp2_this = this;
    var tmp3 = tmp2_this._get_index__8();
    tmp2_this._set_index__8(tmp3 + 1 | 0);
    return this._tail_1[tmp3 - this._trieIterator._get_size__45() | 0];
  };
  PersistentVectorIterator.prototype.previous_7 = function () {
    this.checkHasPrevious_0();
    if (this._get_index__8() > this._trieIterator._get_size__45()) {
      var tmp0_this = this;
      tmp0_this._set_index__8(tmp0_this._get_index__8() - 1 | 0);
      return this._tail_1[tmp0_this._get_index__8() - this._trieIterator._get_size__45() | 0];
    }var tmp1_this = this;
    var tmp2 = tmp1_this._get_index__8();
    tmp1_this._set_index__8(tmp2 - 1 | 0);
    Unit_getInstance();
    return this._trieIterator.previous_7();
  };
  PersistentVectorIterator.$metadata$ = {
    simpleName: 'PersistentVectorIterator',
    kind: 'class',
    interfaces: []
  };
  function bufferOfSize($this, size_1) {
    return fillArrayVal(Array(size_1), null);
  }
  function Companion_8() {
    Companion_instance_7 = this;
    var tmp = this;
    tmp._EMPTY_0 = new SmallPersistentVector([]);
  }
  Companion_8.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_8();
    return Companion_instance_7;
  }
  function SmallPersistentVector(buffer) {
    Companion_getInstance_7();
    AbstractPersistentList.call(this);
    this._buffer_0 = buffer;
    assert(this._buffer_0.length <= 32);
  }
  SmallPersistentVector.prototype._get_size__45 = function () {
    return this._buffer_0.length;
  };
  SmallPersistentVector.prototype.add_37 = function (element) {
    if (this._get_size__45() < 32) {
      var newBuffer = copyOf_0(this._buffer_0, this._get_size__45() + 1 | 0);
      newBuffer[this._get_size__45()] = element;
      return new SmallPersistentVector(newBuffer);
    }var tail = presizedBufferWith(element);
    return new PersistentVector(this._buffer_0, tail, this._get_size__45() + 1 | 0, 0);
  };
  SmallPersistentVector.prototype.add_31 = function (index, element) {
    ListImplementation_getInstance().checkPositionIndex_0(index, this._get_size__45());
    if (index === this._get_size__45()) {
      return this.add_37(element);
    }if (this._get_size__45() < 32) {
      var newBuffer = bufferOfSize(this, this._get_size__45() + 1 | 0);
      var tmp0_copyInto_0 = this._buffer_0;
      var tmp1_copyInto_0 = 0;
      var tmp2_copyInto_0 = 0;
      arrayCopy_0(tmp0_copyInto_0, newBuffer, tmp1_copyInto_0, tmp2_copyInto_0, index);
      Unit_getInstance();
      var tmp3_copyInto_0 = this._buffer_0;
      var tmp4_copyInto_0 = index + 1 | 0;
      var tmp5_copyInto_0 = this._get_size__45();
      arrayCopy_0(tmp3_copyInto_0, newBuffer, tmp4_copyInto_0, index, tmp5_copyInto_0);
      Unit_getInstance();
      newBuffer[index] = element;
      return new SmallPersistentVector(newBuffer);
    }var tmp6_copyOf_0 = this._buffer_0;
    var root = tmp6_copyOf_0.slice();
    var tmp7_copyInto_0 = this._buffer_0;
    var tmp8_copyInto_0 = index + 1 | 0;
    var tmp9_copyInto_0 = this._get_size__45() - 1 | 0;
    arrayCopy_0(tmp7_copyInto_0, root, tmp8_copyInto_0, index, tmp9_copyInto_0);
    Unit_getInstance();
    root[index] = element;
    var tail = presizedBufferWith(this._buffer_0[31]);
    return new PersistentVector(root, tail, this._get_size__45() + 1 | 0, 0);
  };
  SmallPersistentVector.prototype.removeAt_7 = function (index) {
    ListImplementation_getInstance().checkElementIndex_0(index, this._get_size__45());
    if (this._get_size__45() === 1) {
      return Companion_getInstance_7()._EMPTY_0;
    }var newBuffer = copyOf_0(this._buffer_0, this._get_size__45() - 1 | 0);
    var tmp0_copyInto_0 = this._buffer_0;
    var tmp1_copyInto_0 = index + 1 | 0;
    var tmp2_copyInto_0 = this._get_size__45();
    arrayCopy_0(tmp0_copyInto_0, newBuffer, index, tmp1_copyInto_0, tmp2_copyInto_0);
    Unit_getInstance();
    return new SmallPersistentVector(newBuffer);
  };
  SmallPersistentVector.prototype.indexOf_5 = function (element) {
    return indexOf(this._buffer_0, element);
  };
  SmallPersistentVector.prototype.lastIndexOf_9 = function (element) {
    return lastIndexOf(this._buffer_0, element);
  };
  SmallPersistentVector.prototype.listIterator_12 = function (index) {
    ListImplementation_getInstance().checkPositionIndex_0(index, this._get_size__45());
    var tmp = this._buffer_0;
    return new BufferIterator(isArray(tmp) ? tmp : THROW_CCE(), index, this._get_size__45());
  };
  SmallPersistentVector.prototype.get_66 = function (index) {
    ListImplementation_getInstance().checkElementIndex_0(index, this._get_size__45());
    var tmp = this._buffer_0[index];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  SmallPersistentVector.prototype.set_13 = function (index, element) {
    ListImplementation_getInstance().checkElementIndex_0(index, this._get_size__45());
    var tmp0_copyOf_0 = this._buffer_0;
    var newBuffer = tmp0_copyOf_0.slice();
    newBuffer[index] = element;
    return new SmallPersistentVector(newBuffer);
  };
  SmallPersistentVector.$metadata$ = {
    simpleName: 'SmallPersistentVector',
    kind: 'class',
    interfaces: [ImmutableList]
  };
  function fillPath($this, index, startLevel) {
    var shift = imul($this._height - startLevel | 0, 5);
    var i = startLevel;
    while (i < $this._height) {
      var tmp = $this._path;
      var tmp_0 = i;
      var tmp_1 = $this._path[i - 1 | 0];
      tmp[tmp_0] = ((!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE())[indexSegment(index, shift)];
      shift = shift - 5 | 0;
      i = i + 1 | 0;
    }
  }
  function fillPathIfNeeded($this, indexPredicate) {
    var shift = 0;
    while (indexSegment($this._get_index__8(), shift) === indexPredicate) {
      shift = shift + 5 | 0;
    }
    if (shift > 0) {
      var level = ($this._height - 1 | 0) - (shift / 5 | 0) | 0;
      fillPath($this, $this._get_index__8(), level + 1 | 0);
    }}
  function elementAtCurrentIndex($this) {
    var leafBufferIndex = $this._get_index__8() & 31;
    var tmp = $this._path[$this._height - 1 | 0];
    return ((!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE())[leafBufferIndex];
  }
  function TrieIterator(root, index, size_1, height_1) {
    AbstractListIterator.call(this, index, size_1);
    this._height = height_1;
    var tmp = this;
    var tmp0_arrayOfNulls_0 = this._height;
    tmp._path = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._isInRightEdge = index === size_1;
    this._path[0] = root;
    fillPath(this, index - (this._isInRightEdge ? 1 : 0) | 0, 1);
  }
  TrieIterator.prototype.next_28 = function () {
    if (!this.hasNext_27()) {
      throw NoSuchElementException_init_$Create$();
    }var result = elementAtCurrentIndex(this);
    var tmp0_this = this;
    tmp0_this._set_index__8(tmp0_this._get_index__8() + 1 | 0);
    if (this._get_index__8() === this._get_size__45()) {
      this._isInRightEdge = true;
      return result;
    }fillPathIfNeeded(this, 0);
    return result;
  };
  TrieIterator.prototype.previous_7 = function () {
    if (!this.hasPrevious_8()) {
      throw NoSuchElementException_init_$Create$();
    }var tmp0_this = this;
    tmp0_this._set_index__8(tmp0_this._get_index__8() - 1 | 0);
    if (this._isInRightEdge) {
      this._isInRightEdge = false;
      return elementAtCurrentIndex(this);
    }fillPathIfNeeded(this, 31);
    return elementAtCurrentIndex(this);
  };
  TrieIterator.$metadata$ = {
    simpleName: 'TrieIterator',
    kind: 'class',
    interfaces: []
  };
  function persistentVectorOf() {
    return Companion_getInstance_7()._EMPTY_0;
  }
  function presizedBufferWith(element) {
    var tmp0_arrayOfNulls_0 = 32;
    var buffer = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    buffer[0] = element;
    return buffer;
  }
  function rootSize_0(vectorSize) {
    return (vectorSize - 1 | 0) & -32;
  }
  function indexSegment(index, shift) {
    return index >> shift & 31;
  }
  function ObjectRef(value_0) {
    this._value_3 = value_0;
  }
  ObjectRef.$metadata$ = {
    simpleName: 'ObjectRef',
    kind: 'class',
    interfaces: []
  };
  function createEntries($this) {
    return new PersistentHashMapEntries($this);
  }
  function Companion_9() {
    Companion_instance_8 = this;
    this._EMPTY_1 = new PersistentHashMap(Companion_getInstance_9()._EMPTY_2, 0);
  }
  Companion_9.prototype.emptyOf = function () {
    var tmp = this._EMPTY_1;
    return tmp instanceof PersistentHashMap ? tmp : THROW_CCE();
  };
  Companion_9.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_9();
    return Companion_instance_8;
  }
  function PersistentHashMap(node_0, size_1) {
    Companion_getInstance_8();
    AbstractMap.call(this);
    this._node = node_0;
    this._size_2 = size_1;
  }
  PersistentHashMap.prototype._get_size__45 = function () {
    return this._size_2;
  };
  PersistentHashMap.prototype._get_entries__5 = function () {
    return createEntries(this);
  };
  PersistentHashMap.prototype.containsKey_7 = function (key_0) {
    var tmp0_safe_receiver_2 = key_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    return this._node.containsKey_8(tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1, key_0, 0);
  };
  PersistentHashMap.prototype.get_48 = function (key_0) {
    var tmp0_safe_receiver_2 = key_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    return this._node.get_49(tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1, key_0, 0);
  };
  PersistentHashMap.prototype.put_6 = function (key_0, value_0) {
    var tmp0_safe_receiver_2 = key_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    var tmp0_elvis_lhs = this._node.put_7(tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1, key_0, value_0, 0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newNodeResult = tmp;
    return new PersistentHashMap(newNodeResult._node_0, this._size_2 + newNodeResult._sizeDelta | 0);
  };
  PersistentHashMap.prototype.remove_43 = function (key_0) {
    var tmp0_safe_receiver_2 = key_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    var newNode = this._node.remove_44(tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1, key_0, 0);
    if (this._node === newNode) {
      return this;
    }if (newNode == null) {
      return Companion_getInstance_8().emptyOf();
    }return new PersistentHashMap(newNode, this._size_2 - 1 | 0);
  };
  PersistentHashMap.$metadata$ = {
    simpleName: 'PersistentHashMap',
    kind: 'class',
    interfaces: [PersistentMap]
  };
  function PersistentHashMapEntriesIterator(node_0) {
    var tmp = 0;
    var tmp_0 = 8;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = new TrieNodeEntriesIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBaseIterator.call(this, node_0, tmp_1);
  }
  PersistentHashMapEntriesIterator.$metadata$ = {
    simpleName: 'PersistentHashMapEntriesIterator',
    kind: 'class',
    interfaces: []
  };
  function moveToNextNodeWithData($this, pathIndex) {
    if ($this._path_0[pathIndex].hasNextKey_0()) {
      return pathIndex;
    }if ($this._path_0[pathIndex].hasNextNode_0()) {
      var node_0 = $this._path_0[pathIndex].currentNode_1();
      if (pathIndex === 6) {
        $this._path_0[pathIndex + 1 | 0].reset_3(node_0._buffer_2, node_0._buffer_2.length);
      } else {
        $this._path_0[pathIndex + 1 | 0].reset_3(node_0._buffer_2, imul(2, node_0.entryCount()));
      }
      return moveToNextNodeWithData($this, pathIndex + 1 | 0);
    }return -1;
  }
  function ensureNextEntryIsReady($this) {
    if ($this._path_0[$this._pathLastIndex].hasNextKey_0()) {
      return Unit_getInstance();
    }var inductionVariable = $this._pathLastIndex;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var result = moveToNextNodeWithData($this, i);
        if (result === -1 ? $this._path_0[i].hasNextNode_0() : false) {
          $this._path_0[i].moveToNextNode_0();
          result = moveToNextNodeWithData($this, i);
        }if (!(result === -1)) {
          $this._pathLastIndex = result;
          return Unit_getInstance();
        }if (i > 0) {
          $this._path_0[i - 1 | 0].moveToNextNode_0();
        }$this._path_0[i].reset_3(Companion_getInstance_9()._EMPTY_2._buffer_2, 0);
      }
       while (0 <= inductionVariable);
    $this._hasNext_0 = false;
  }
  function checkHasNext($this) {
    if (!$this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
  }
  function PersistentHashMapBaseIterator(node_0, path) {
    this._path_0 = path;
    this._pathLastIndex = 0;
    this._hasNext_0 = true;
    this._path_0[0].reset_3(node_0._buffer_2, imul(2, node_0.entryCount()));
    this._pathLastIndex = 0;
    ensureNextEntryIsReady(this);
  }
  PersistentHashMapBaseIterator.prototype.hasNext_27 = function () {
    return this._hasNext_0;
  };
  PersistentHashMapBaseIterator.prototype.next_28 = function () {
    checkHasNext(this);
    var result = this._path_0[this._pathLastIndex].next_28();
    ensureNextEntryIsReady(this);
    return result;
  };
  PersistentHashMapBaseIterator.$metadata$ = {
    simpleName: 'PersistentHashMapBaseIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function TrieNodeBaseIterator() {
    this._buffer_1 = Companion_getInstance_9()._EMPTY_2._buffer_2;
    this._dataSize = 0;
    this._index_4 = 0;
  }
  TrieNodeBaseIterator.prototype._get_buffer__0 = function () {
    return this._buffer_1;
  };
  TrieNodeBaseIterator.prototype._set_index__8 = function (_set___) {
    this._index_4 = _set___;
  };
  TrieNodeBaseIterator.prototype._get_index__8 = function () {
    return this._index_4;
  };
  TrieNodeBaseIterator.prototype.reset_2 = function (buffer, dataSize, index) {
    this._buffer_1 = buffer;
    this._dataSize = dataSize;
    this._index_4 = index;
  };
  TrieNodeBaseIterator.prototype.reset_3 = function (buffer, dataSize) {
    this.reset_2(buffer, dataSize, 0);
  };
  TrieNodeBaseIterator.prototype.hasNextKey_0 = function () {
    return this._index_4 < this._dataSize;
  };
  TrieNodeBaseIterator.prototype.hasNextNode_0 = function () {
    assert(this._index_4 >= this._dataSize);
    return this._index_4 < this._buffer_1.length;
  };
  TrieNodeBaseIterator.prototype.currentNode_1 = function () {
    assert(this.hasNextNode_0());
    var tmp = this._buffer_1[this._index_4];
    return tmp instanceof TrieNode ? tmp : THROW_CCE();
  };
  TrieNodeBaseIterator.prototype.moveToNextNode_0 = function () {
    assert(this.hasNextNode_0());
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_4;
    tmp0_this._index_4 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  TrieNodeBaseIterator.prototype.hasNext_27 = function () {
    return this.hasNextKey_0();
  };
  TrieNodeBaseIterator.$metadata$ = {
    simpleName: 'TrieNodeBaseIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function TrieNodeEntriesIterator() {
    TrieNodeBaseIterator.call(this);
  }
  TrieNodeEntriesIterator.prototype.next_28 = function () {
    assert(this.hasNextKey_0());
    var tmp0_this = this;
    tmp0_this._set_index__8(tmp0_this._get_index__8() + 2 | 0);
    var tmp = this._get_buffer__0()[this._get_index__8() - 2 | 0];
    var tmp_0 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
    var tmp_1 = this._get_buffer__0()[this._get_index__8() - 1 | 0];
    return new MapEntry(tmp_0, (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE());
  };
  TrieNodeEntriesIterator.$metadata$ = {
    simpleName: 'TrieNodeEntriesIterator',
    kind: 'class',
    interfaces: []
  };
  function MapEntry(key_0, value_0) {
    this._key_1 = key_0;
    this._value_4 = value_0;
  }
  MapEntry.prototype._get_key__28 = function () {
    return this._key_1;
  };
  MapEntry.prototype._get_value__13 = function () {
    return this._value_4;
  };
  MapEntry.prototype.hashCode = function () {
    var tmp0_hashCode_0 = this._get_key__28();
    var tmp0_safe_receiver_2 = tmp0_hashCode_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    var tmp = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
    var tmp1_hashCode_0 = this._get_value__13();
    var tmp0_safe_receiver_2_0 = tmp1_hashCode_0;
    var tmp1_elvis_lhs_1_0 = tmp0_safe_receiver_2_0 == null ? null : hashCode(tmp0_safe_receiver_2_0);
    return tmp ^ (tmp1_elvis_lhs_1_0 == null ? 0 : tmp1_elvis_lhs_1_0);
  };
  MapEntry.prototype.equals = function (other) {
    var tmp0_safe_receiver = (!(other == null) ? isInterface(other, Entry) : false) ? other : null;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = equals(tmp0_safe_receiver._get_key__28(), this._get_key__28()) ? equals(tmp0_safe_receiver._get_value__13(), this._get_value__13()) : false;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  MapEntry.prototype.toString = function () {
    return toString_0(this._get_key__28()) + '=' + toString_0(this._get_value__13());
  };
  MapEntry.$metadata$ = {
    simpleName: 'MapEntry',
    kind: 'class',
    interfaces: [Entry]
  };
  function PersistentHashMapEntries(map) {
    AbstractSet.call(this);
    this._map_1 = map;
  }
  PersistentHashMapEntries.prototype._get_size__45 = function () {
    return this._map_1._size_2;
  };
  PersistentHashMapEntries.prototype.contains_33 = function (element) {
    var tmp = isObject(element) ? element : THROW_CCE();
    if (!(!(tmp == null) ? isInterface(tmp, Entry) : false))
      return false;
    else {
    }
    var tmp0_safe_receiver = this._map_1.get_48(element._get_key__28());
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = equals(tmp0_safe_receiver, element._get_value__13());
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? element._get_value__13() == null ? this._map_1.containsKey_7(element._get_key__28()) : false : tmp1_elvis_lhs;
  };
  PersistentHashMapEntries.prototype.contains_37 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    else {
    }
    return this.contains_33((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  PersistentHashMapEntries.prototype.iterator_46 = function () {
    return new PersistentHashMapEntriesIterator(this._map_1._node);
  };
  PersistentHashMapEntries.$metadata$ = {
    simpleName: 'PersistentHashMapEntries',
    kind: 'class',
    interfaces: [ImmutableSet]
  };
  function TrieNode_init_$Init$(dataMap, nodeMap, buffer, $this) {
    TrieNode.call($this, dataMap, nodeMap, buffer, null);
    return $this;
  }
  function TrieNode_init_$Create$(dataMap, nodeMap, buffer) {
    return TrieNode_init_$Init$(dataMap, nodeMap, buffer, Object.create(TrieNode.prototype));
  }
  function ModificationResult(node_0, sizeDelta) {
    this._node_0 = node_0;
    this._sizeDelta = sizeDelta;
  }
  ModificationResult.$metadata$ = {
    simpleName: 'ModificationResult',
    kind: 'class',
    interfaces: []
  };
  function asInsertResult($this) {
    return new ModificationResult($this, 1);
  }
  function asUpdateResult($this) {
    return new ModificationResult($this, 0);
  }
  function hasNodeAt($this, positionMask) {
    return !(($this._nodeMap & positionMask) === 0);
  }
  function keyAtIndex($this, keyIndex) {
    var tmp = $this._buffer_2[keyIndex];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  }
  function valueAtKeyIndex($this, keyIndex) {
    var tmp = $this._buffer_2[keyIndex + 1 | 0];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  }
  function insertEntryAt($this, positionMask, key_0, value_0) {
    var keyIndex = $this.entryKeyIndex(positionMask);
    var newBuffer = insertEntryAtIndex($this._buffer_2, keyIndex, key_0, value_0);
    return TrieNode_init_$Create$($this._dataMap | positionMask, $this._nodeMap, newBuffer);
  }
  function updateValueAtIndex($this, keyIndex, value_0) {
    var tmp0_copyOf_0 = $this._buffer_2;
    var newBuffer = tmp0_copyOf_0.slice();
    newBuffer[keyIndex + 1 | 0] = value_0;
    return TrieNode_init_$Create$($this._dataMap, $this._nodeMap, newBuffer);
  }
  function updateNodeAtIndex($this, nodeIndex_1, positionMask, newNode) {
    var newNodeBuffer = newNode._buffer_2;
    if (newNodeBuffer.length === 2 ? newNode._nodeMap === 0 : false) {
      if ($this._buffer_2.length === 1) {
        newNode._dataMap = $this._nodeMap;
        return newNode;
      }var keyIndex = $this.entryKeyIndex(positionMask);
      var newBuffer = replaceNodeWithEntry($this._buffer_2, nodeIndex_1, keyIndex, newNodeBuffer[0], newNodeBuffer[1]);
      return TrieNode_init_$Create$($this._dataMap ^ positionMask, $this._nodeMap ^ positionMask, newBuffer);
    }var newBuffer_0 = copyOf_0($this._buffer_2, $this._buffer_2.length);
    newBuffer_0[nodeIndex_1] = newNode;
    return TrieNode_init_$Create$($this._dataMap, $this._nodeMap, newBuffer_0);
  }
  function removeNodeAtIndex($this, nodeIndex_1, positionMask) {
    if ($this._buffer_2.length === 1)
      return null;
    var newBuffer = removeNodeAtIndex_0($this._buffer_2, nodeIndex_1);
    return TrieNode_init_$Create$($this._dataMap, $this._nodeMap ^ positionMask, newBuffer);
  }
  function bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner) {
    var storedKey = keyAtIndex($this, keyIndex);
    var tmp0_safe_receiver_2 = storedKey;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    var storedKeyHash = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
    var storedValue = valueAtKeyIndex($this, keyIndex);
    var newNode = makeNode_0($this, storedKeyHash, storedKey, storedValue, newKeyHash, newKey, newValue, shift + 5 | 0, owner);
    var nodeIndex_1 = $this.nodeIndex(positionMask) + 1 | 0;
    return replaceEntryWithNode($this._buffer_2, keyIndex, nodeIndex_1, newNode);
  }
  function moveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift) {
    var newBuffer = bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, null);
    return TrieNode_init_$Create$($this._dataMap ^ positionMask, $this._nodeMap | positionMask, newBuffer);
  }
  function makeNode_0($this, keyHash1, key1, value1, keyHash2, key2, value2, shift, owner) {
    if (shift > 30) {
      var tmp0_arrayOf_0 = [key1, value1, key2, value2];
      return new TrieNode(0, 0, tmp0_arrayOf_0, owner);
    }var setBit1 = indexSegment_0(keyHash1, shift);
    var setBit2 = indexSegment_0(keyHash2, shift);
    if (!(setBit1 === setBit2)) {
      var tmp;
      if (setBit1 < setBit2) {
        var tmp1_arrayOf_0 = [key1, value1, key2, value2];
        tmp = tmp1_arrayOf_0;
      } else {
        var tmp2_arrayOf_0 = [key2, value2, key1, value1];
        tmp = tmp2_arrayOf_0;
      }
      var nodeBuffer = tmp;
      return new TrieNode(1 << setBit1 | 1 << setBit2, 0, nodeBuffer, owner);
    }var node_0 = makeNode_0($this, keyHash1, key1, value1, keyHash2, key2, value2, shift + 5 | 0, owner);
    var tmp_0 = 1 << setBit1;
    var tmp3_arrayOf_0 = [node_0];
    return new TrieNode(0, tmp_0, tmp3_arrayOf_0, owner);
  }
  function removeEntryAtIndex($this, keyIndex, positionMask) {
    if ($this._buffer_2.length === 2)
      return null;
    var newBuffer = removeEntryAtIndex_0($this._buffer_2, keyIndex);
    return TrieNode_init_$Create$($this._dataMap ^ positionMask, $this._nodeMap, newBuffer);
  }
  function collisionRemoveEntryAtIndex($this, i) {
    if ($this._buffer_2.length === 2)
      return null;
    var newBuffer = removeEntryAtIndex_0($this._buffer_2, i);
    return TrieNode_init_$Create$(0, 0, newBuffer);
  }
  function collisionContainsKey($this, key_0) {
    var progression = step(until(0, $this._buffer_2.length), 2);
    var inductionVariable = progression._first_0;
    var last = progression._last;
    var step_0 = progression._step_0;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key_0, $this._buffer_2[i]))
          return true;
      }
       while (!(i === last));
    return false;
  }
  function collisionGet($this, key_0) {
    var progression = step(until(0, $this._buffer_2.length), 2);
    var inductionVariable = progression._first_0;
    var last = progression._last;
    var step_0 = progression._step_0;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key_0, keyAtIndex($this, i))) {
          return valueAtKeyIndex($this, i);
        }}
       while (!(i === last));
    return null;
  }
  function collisionPut($this, key_0, value_0) {
    var progression = step(until(0, $this._buffer_2.length), 2);
    var inductionVariable = progression._first_0;
    var last = progression._last;
    var step_0 = progression._step_0;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key_0, keyAtIndex($this, i))) {
          if (value_0 === valueAtKeyIndex($this, i)) {
            return null;
          }var tmp0_copyOf_0 = $this._buffer_2;
          var newBuffer = tmp0_copyOf_0.slice();
          newBuffer[i + 1 | 0] = value_0;
          return asUpdateResult(TrieNode_init_$Create$(0, 0, newBuffer));
        }}
       while (!(i === last));
    var newBuffer_0 = insertEntryAtIndex($this._buffer_2, 0, key_0, value_0);
    return asInsertResult(TrieNode_init_$Create$(0, 0, newBuffer_0));
  }
  function collisionRemove($this, key_0) {
    var progression = step(until(0, $this._buffer_2.length), 2);
    var inductionVariable = progression._first_0;
    var last = progression._last;
    var step_0 = progression._step_0;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key_0, keyAtIndex($this, i))) {
          return collisionRemoveEntryAtIndex($this, i);
        }}
       while (!(i === last));
    return $this;
  }
  function replaceNode($this, targetNode, newNode, nodeIndex_1, positionMask) {
    return newNode == null ? removeNodeAtIndex($this, nodeIndex_1, positionMask) : !(targetNode === newNode) ? updateNodeAtIndex($this, nodeIndex_1, positionMask, newNode) : $this;
  }
  function Companion_10() {
    Companion_instance_9 = this;
    var tmp = this;
    tmp._EMPTY_2 = TrieNode_init_$Create$(0, 0, []);
  }
  Companion_10.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_10();
    return Companion_instance_9;
  }
  function TrieNode(dataMap, nodeMap, buffer, ownedBy) {
    Companion_getInstance_9();
    this._dataMap = dataMap;
    this._nodeMap = nodeMap;
    this._ownedBy = ownedBy;
    this._buffer_2 = buffer;
  }
  TrieNode.prototype.entryCount = function () {
    return countOneBits(this._dataMap);
  };
  TrieNode.prototype.hasEntryAt = function (positionMask) {
    return !((this._dataMap & positionMask) === 0);
  };
  TrieNode.prototype.entryKeyIndex = function (positionMask) {
    return imul(2, countOneBits(this._dataMap & (positionMask - 1 | 0)));
  };
  TrieNode.prototype.nodeIndex = function (positionMask) {
    return (this._buffer_2.length - 1 | 0) - countOneBits(this._nodeMap & (positionMask - 1 | 0)) | 0;
  };
  TrieNode.prototype.nodeAtIndex = function (nodeIndex_1) {
    var tmp = this._buffer_2[nodeIndex_1];
    return tmp instanceof TrieNode ? tmp : THROW_CCE();
  };
  TrieNode.prototype.containsKey_8 = function (keyHash, key_0, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.hasEntryAt(keyPositionMask)) {
      return equals(key_0, keyAtIndex(this, this.entryKeyIndex(keyPositionMask)));
    }if (hasNodeAt(this, keyPositionMask)) {
      var targetNode = this.nodeAtIndex(this.nodeIndex(keyPositionMask));
      if (shift === 30) {
        return collisionContainsKey(targetNode, key_0);
      }return targetNode.containsKey_8(keyHash, key_0, shift + 5 | 0);
    }return false;
  };
  TrieNode.prototype.get_49 = function (keyHash, key_0, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.hasEntryAt(keyPositionMask)) {
      var keyIndex = this.entryKeyIndex(keyPositionMask);
      if (equals(key_0, keyAtIndex(this, keyIndex))) {
        return valueAtKeyIndex(this, keyIndex);
      }return null;
    }if (hasNodeAt(this, keyPositionMask)) {
      var targetNode = this.nodeAtIndex(this.nodeIndex(keyPositionMask));
      if (shift === 30) {
        return collisionGet(targetNode, key_0);
      }return targetNode.get_49(keyHash, key_0, shift + 5 | 0);
    }return null;
  };
  TrieNode.prototype.put_7 = function (keyHash, key_0, value_0, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.hasEntryAt(keyPositionMask)) {
      var keyIndex = this.entryKeyIndex(keyPositionMask);
      if (equals(key_0, keyAtIndex(this, keyIndex))) {
        if (valueAtKeyIndex(this, keyIndex) === value_0)
          return null;
        return asUpdateResult(updateValueAtIndex(this, keyIndex, value_0));
      }return asInsertResult(moveEntryToNode(this, keyIndex, keyPositionMask, keyHash, key_0, value_0, shift));
    }if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex_1 = this.nodeIndex(keyPositionMask);
      var targetNode = this.nodeAtIndex(nodeIndex_1);
      var tmp;
      if (shift === 30) {
        var tmp0_elvis_lhs = collisionPut(targetNode, key_0, value_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } else {
        var tmp1_elvis_lhs = targetNode.put_7(keyHash, key_0, value_0, shift + 5 | 0);
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          return null;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp = tmp_1;
      }
      var putResult = tmp;
      var tmp_2 = putResult;
      var tmp0__anonymous__1 = putResult._node_0;
      tmp_2._node_0 = updateNodeAtIndex(this, nodeIndex_1, keyPositionMask, tmp0__anonymous__1);
      return putResult;
    }return asInsertResult(insertEntryAt(this, keyPositionMask, key_0, value_0));
  };
  TrieNode.prototype.remove_44 = function (keyHash, key_0, shift) {
    var keyPositionMask = 1 << indexSegment_0(keyHash, shift);
    if (this.hasEntryAt(keyPositionMask)) {
      var keyIndex = this.entryKeyIndex(keyPositionMask);
      if (equals(key_0, keyAtIndex(this, keyIndex))) {
        return removeEntryAtIndex(this, keyIndex, keyPositionMask);
      }return this;
    }if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex_1 = this.nodeIndex(keyPositionMask);
      var targetNode = this.nodeAtIndex(nodeIndex_1);
      var tmp;
      if (shift === 30) {
        tmp = collisionRemove(targetNode, key_0);
      } else {
        tmp = targetNode.remove_44(keyHash, key_0, shift + 5 | 0);
      }
      var newNode = tmp;
      return replaceNode(this, targetNode, newNode, nodeIndex_1, keyPositionMask);
    }return this;
  };
  TrieNode.$metadata$ = {
    simpleName: 'TrieNode',
    kind: 'class',
    interfaces: []
  };
  function insertEntryAtIndex(_this_, keyIndex, key_0, value_0) {
    var tmp0_arrayOfNulls_0 = _this_.length + 2 | 0;
    var newBuffer = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var tmp1_copyInto_0 = 0;
    var tmp2_copyInto_0 = 0;
    arrayCopy_0(_this_, newBuffer, tmp1_copyInto_0, tmp2_copyInto_0, keyIndex);
    Unit_getInstance();
    var tmp3_copyInto_0 = keyIndex + 2 | 0;
    var tmp4_copyInto_0 = _this_.length;
    arrayCopy_0(_this_, newBuffer, tmp3_copyInto_0, keyIndex, tmp4_copyInto_0);
    Unit_getInstance();
    newBuffer[keyIndex] = key_0;
    newBuffer[keyIndex + 1 | 0] = value_0;
    return newBuffer;
  }
  function replaceNodeWithEntry(_this_, nodeIndex_1, keyIndex, key_0, value_0) {
    var newBuffer = copyOf_0(_this_, _this_.length + 1 | 0);
    var tmp0_copyInto_0 = nodeIndex_1 + 2 | 0;
    var tmp1_copyInto_0 = nodeIndex_1 + 1 | 0;
    var tmp2_copyInto_0 = _this_.length;
    arrayCopy_0(newBuffer, newBuffer, tmp0_copyInto_0, tmp1_copyInto_0, tmp2_copyInto_0);
    Unit_getInstance();
    var tmp3_copyInto_0 = keyIndex + 2 | 0;
    arrayCopy_0(newBuffer, newBuffer, tmp3_copyInto_0, keyIndex, nodeIndex_1);
    Unit_getInstance();
    newBuffer[keyIndex] = key_0;
    newBuffer[keyIndex + 1 | 0] = value_0;
    return newBuffer;
  }
  function removeNodeAtIndex_0(_this_, nodeIndex_1) {
    var tmp0_arrayOfNulls_0 = _this_.length - 1 | 0;
    var newBuffer = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var tmp1_copyInto_0 = 0;
    var tmp2_copyInto_0 = 0;
    arrayCopy_0(_this_, newBuffer, tmp1_copyInto_0, tmp2_copyInto_0, nodeIndex_1);
    Unit_getInstance();
    var tmp3_copyInto_0 = nodeIndex_1 + 1 | 0;
    var tmp4_copyInto_0 = _this_.length;
    arrayCopy_0(_this_, newBuffer, nodeIndex_1, tmp3_copyInto_0, tmp4_copyInto_0);
    Unit_getInstance();
    return newBuffer;
  }
  function replaceEntryWithNode(_this_, keyIndex, nodeIndex_1, newNode) {
    var newNodeIndex = nodeIndex_1 - 2 | 0;
    var tmp0_arrayOfNulls_0 = (_this_.length - 2 | 0) + 1 | 0;
    var newBuffer = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var tmp1_copyInto_0 = 0;
    var tmp2_copyInto_0 = 0;
    arrayCopy_0(_this_, newBuffer, tmp1_copyInto_0, tmp2_copyInto_0, keyIndex);
    Unit_getInstance();
    var tmp3_copyInto_0 = keyIndex + 2 | 0;
    arrayCopy_0(_this_, newBuffer, keyIndex, tmp3_copyInto_0, nodeIndex_1);
    Unit_getInstance();
    newBuffer[newNodeIndex] = newNode;
    var tmp4_copyInto_0 = newNodeIndex + 1 | 0;
    var tmp5_copyInto_0 = _this_.length;
    arrayCopy_0(_this_, newBuffer, tmp4_copyInto_0, nodeIndex_1, tmp5_copyInto_0);
    Unit_getInstance();
    return newBuffer;
  }
  function indexSegment_0(index, shift) {
    return index >> shift & 31;
  }
  function removeEntryAtIndex_0(_this_, keyIndex) {
    var tmp0_arrayOfNulls_0 = _this_.length - 2 | 0;
    var newBuffer = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var tmp1_copyInto_0 = 0;
    var tmp2_copyInto_0 = 0;
    arrayCopy_0(_this_, newBuffer, tmp1_copyInto_0, tmp2_copyInto_0, keyIndex);
    Unit_getInstance();
    var tmp3_copyInto_0 = keyIndex + 2 | 0;
    var tmp4_copyInto_0 = _this_.length;
    arrayCopy_0(_this_, newBuffer, keyIndex, tmp3_copyInto_0, tmp4_copyInto_0);
    Unit_getInstance();
    return newBuffer;
  }
  function Companion_11() {
    Companion_instance_10 = this;
    this._EMPTY_3 = new PersistentOrderedSet(EndOfChain_getInstance(), EndOfChain_getInstance(), Companion_getInstance_8().emptyOf());
  }
  Companion_11.prototype.emptyOf_0 = function () {
    return this._EMPTY_3;
  };
  Companion_11.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_11();
    return Companion_instance_10;
  }
  function PersistentOrderedSet(firstElement, lastElement, hashMap) {
    Companion_getInstance_10();
    AbstractSet.call(this);
    this._firstElement = firstElement;
    this._lastElement = lastElement;
    this._hashMap = hashMap;
  }
  PersistentOrderedSet.prototype._get_size__45 = function () {
    return this._hashMap._size_2;
  };
  PersistentOrderedSet.prototype.contains_37 = function (element) {
    return this._hashMap.containsKey_7(element);
  };
  PersistentOrderedSet.prototype.add_37 = function (element) {
    if (this._hashMap.containsKey_7(element)) {
      return this;
    }if (this.isEmpty_40()) {
      var newMap = this._hashMap.put_6(element, Links_init_$Create$());
      return new PersistentOrderedSet(element, element, newMap);
    }var tmp = this._lastElement;
    var lastElement = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
    var lastLinks = ensureNotNull(this._hashMap.get_48(lastElement));
    var newMap_0 = this._hashMap.put_6(lastElement, lastLinks.withNext(element)).put_6(element, Links_init_$Create$_0(lastElement));
    return new PersistentOrderedSet(this._firstElement, element, newMap_0);
  };
  PersistentOrderedSet.prototype.remove_51 = function (element) {
    var tmp0_elvis_lhs = this._hashMap.get_48(element);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var links = tmp;
    var newMap = this._hashMap.remove_43(element);
    if (links._get_hasPrevious_()) {
      var tmp0_get_0 = newMap;
      var tmp1_get_0 = links._previous;
      var previousLinks = ensureNotNull((isInterface(tmp0_get_0, Map_0) ? tmp0_get_0 : THROW_CCE()).get_48(tmp1_get_0));
      var tmp_0 = newMap;
      var tmp_1 = links._previous;
      newMap = tmp_0.put_6((tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE(), previousLinks.withNext(links._next_3));
    }if (links._get_hasNext_()) {
      var tmp2_get_0 = newMap;
      var tmp3_get_0 = links._next_3;
      var nextLinks = ensureNotNull((isInterface(tmp2_get_0, Map_0) ? tmp2_get_0 : THROW_CCE()).get_48(tmp3_get_0));
      var tmp_2 = newMap;
      var tmp_3 = links._next_3;
      newMap = tmp_2.put_6((tmp_3 == null ? true : isObject(tmp_3)) ? tmp_3 : THROW_CCE(), nextLinks.withPrevious(links._previous));
    }var newFirstElement = !links._get_hasPrevious_() ? links._next_3 : this._firstElement;
    var newLastElement = !links._get_hasNext_() ? links._previous : this._lastElement;
    return new PersistentOrderedSet(newFirstElement, newLastElement, newMap);
  };
  PersistentOrderedSet.prototype.iterator_46 = function () {
    return new PersistentOrderedSetIterator(this._firstElement, this._hashMap);
  };
  PersistentOrderedSet.$metadata$ = {
    simpleName: 'PersistentOrderedSet',
    kind: 'class',
    interfaces: [PersistentSet]
  };
  function Links_init_$Init$($this) {
    Links.call($this, EndOfChain_getInstance(), EndOfChain_getInstance());
    return $this;
  }
  function Links_init_$Create$() {
    return Links_init_$Init$(Object.create(Links.prototype));
  }
  function Links_init_$Init$_0(previous, $this) {
    Links.call($this, previous, EndOfChain_getInstance());
    return $this;
  }
  function Links_init_$Create$_0(previous) {
    return Links_init_$Init$_0(previous, Object.create(Links.prototype));
  }
  function Links(previous, next) {
    this._previous = previous;
    this._next_3 = next;
  }
  Links.prototype.withNext = function (newNext) {
    return new Links(this._previous, newNext);
  };
  Links.prototype.withPrevious = function (newPrevious) {
    return new Links(newPrevious, this._next_3);
  };
  Links.prototype._get_hasNext_ = function () {
    return !(this._next_3 === EndOfChain_getInstance());
  };
  Links.prototype._get_hasPrevious_ = function () {
    return !(this._previous === EndOfChain_getInstance());
  };
  Links.$metadata$ = {
    simpleName: 'Links',
    kind: 'class',
    interfaces: []
  };
  function checkHasNext_0($this) {
    if (!$this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
  }
  function PersistentOrderedSetIterator(nextElement, map) {
    this._nextElement = nextElement;
    this._map_2 = map;
    this._index_5 = 0;
  }
  PersistentOrderedSetIterator.prototype.hasNext_27 = function () {
    return this._index_5 < this._map_2._get_size__45();
  };
  PersistentOrderedSetIterator.prototype.next_28 = function () {
    checkHasNext_0(this);
    var tmp = this._nextElement;
    var result = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_5;
    tmp0_this._index_5 = tmp1 + 1 | 0;
    Unit_getInstance();
    var tmp_0 = this;
    var tmp0_getOrElse_0 = this._map_2;
    var tmp0_elvis_lhs_1 = tmp0_getOrElse_0.get_48(result);
    var tmp_1;
    if (tmp0_elvis_lhs_1 == null) {
      throw ConcurrentModificationException_init_$Create$_0('' + 'Hash code of an element (' + result + ') has changed after it was added to the persistent set.');
    } else {
      tmp_1 = tmp0_elvis_lhs_1;
    }
    tmp_0._nextElement = tmp_1._next_3;
    return result;
  };
  PersistentOrderedSetIterator.$metadata$ = {
    simpleName: 'PersistentOrderedSetIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function EndOfChain() {
    EndOfChain_instance = this;
  }
  EndOfChain.$metadata$ = {
    simpleName: 'EndOfChain',
    kind: 'object',
    interfaces: []
  };
  var EndOfChain_instance;
  function EndOfChain_getInstance() {
    if (EndOfChain_instance == null)
      new EndOfChain();
    return EndOfChain_instance;
  }
  function ListImplementation() {
    ListImplementation_instance = this;
  }
  ListImplementation.prototype.checkElementIndex_0 = function (index, size_1) {
    if (index < 0 ? true : index >= size_1) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size_1);
    }};
  ListImplementation.prototype.checkPositionIndex_0 = function (index, size_1) {
    if (index < 0 ? true : index > size_1) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size_1);
    }};
  ListImplementation.$metadata$ = {
    simpleName: 'ListImplementation',
    kind: 'object',
    interfaces: []
  };
  var ListImplementation_instance;
  function ListImplementation_getInstance() {
    if (ListImplementation_instance == null)
      new ListImplementation();
    return ListImplementation_instance;
  }
  function assert(condition) {
    if (!condition) {
      throw AssertionError_init_$Create$('Assertion failed');
    }}
  function Applier() {
  }
  Applier.prototype.onBeginChanges_1 = function () {
  };
  Applier.prototype.onEndChanges_1 = function () {
  };
  Applier.$metadata$ = {
    simpleName: 'Applier',
    kind: 'interface',
    interfaces: []
  };
  function AbstractApplier(root) {
    this._root_0 = root;
    var tmp = this;
    tmp._stack = ArrayList_init_$Create$();
    this._current = this._root_0;
    this._$stable = 8;
  }
  AbstractApplier.prototype._set_current_ = function (_set___) {
    this._current = _set___;
  };
  AbstractApplier.prototype._get_current__2 = function () {
    return this._current;
  };
  AbstractApplier.prototype.down_0 = function (node_0) {
    this._stack.add_37(this._get_current__2());
    Unit_getInstance();
    this._set_current_(node_0);
  };
  AbstractApplier.prototype.down_1 = function (node_0) {
    return this.down_0((node_0 == null ? true : isObject(node_0)) ? node_0 : THROW_CCE());
  };
  AbstractApplier.prototype.up_1 = function () {
    var tmp0_isNotEmpty_0 = this._stack;
    var tmp1_check_0 = !tmp0_isNotEmpty_0.isEmpty_40();
    if (!tmp1_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }this._set_current_(this._stack.removeAt_7(this._stack._get_size__45() - 1 | 0));
  };
  AbstractApplier.$metadata$ = {
    simpleName: 'AbstractApplier',
    kind: 'class',
    interfaces: [Applier]
  };
  function FrameAwaiter(onFrame, continuation) {
    this._onFrame = onFrame;
    this._continuation_1 = continuation;
  }
  FrameAwaiter.prototype.resume = function (timeNanos) {
    var tmp;
    try {
      var tmp0_success_0_1 = Companion_getInstance_2();
      var tmp1_success_0_2 = this._onFrame(timeNanos);
      tmp = _Result___init__impl_(tmp1_success_0_2);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var tmp2_failure_0_4 = Companion_getInstance_2();
        tmp_0 = _Result___init__impl_(createFailure($p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    this._continuation_1.resumeWith_15(tmp);
  };
  FrameAwaiter.$metadata$ = {
    simpleName: 'FrameAwaiter',
    kind: 'class',
    interfaces: []
  };
  function fail($this, cause) {
    var tmp0_synchronized_0 = $this._lock;
    if (!($this._failureCause == null))
      return Unit_getInstance();
    $this._failureCause = cause;
    var tmp0_fastForEach_0_2 = $this._awaiters;
    var inductionVariable = 0;
    var last = tmp0_fastForEach_0_2._get_size__45() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_3_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item_4_5 = tmp0_fastForEach_0_2.get_66(index_3_4);
        var tmp0_resumeWithException_0_6_6 = item_4_5._continuation_1;
        var tmp0_failure_0_1_7_7 = Companion_getInstance_2();
        tmp0_resumeWithException_0_6_6.resumeWith_15(_Result___init__impl_(createFailure(cause)));
      }
       while (inductionVariable <= last);
    $this._awaiters.clear_7();
  }
  function _no_name_provided__40(this$0, $awaiter_4) {
    this._this$0_8 = this$0;
    this._$awaiter_4 = $awaiter_4;
  }
  _no_name_provided__40.prototype.invoke_136 = function (it) {
    var tmp0_synchronized_0_12 = this._this$0_8._lock;
    var tmp = this._this$0_8._awaiters;
    var tmp_0;
    if (this._$awaiter_4._v == null) {
      throwUninitializedPropertyAccessException('awaiter');
    } else {
      tmp_0 = this._$awaiter_4._v;
    }
    tmp.remove_51(tmp_0);
    Unit_getInstance();
  };
  _no_name_provided__40.prototype.invoke_468 = function (p1) {
    this.invoke_136((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BroadcastFrameClock(onNewAwaiters) {
    this._onNewAwaiters = onNewAwaiters;
    this._lock = new Object();
    this._failureCause = null;
    var tmp = this;
    tmp._awaiters = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._spareList = ArrayList_init_$Create$();
    this._$stable_0 = 8;
  }
  BroadcastFrameClock.prototype._get_hasAwaiters_ = function () {
    var tmp0_synchronized_0 = this._lock;
    var tmp0_isNotEmpty_0_2 = this._awaiters;
    return !tmp0_isNotEmpty_0_2.isEmpty_40();
  };
  BroadcastFrameClock.prototype.sendFrame = function (timeNanos) {
    var tmp0_synchronized_0 = this._lock;
    var toResume_2 = this._awaiters;
    this._awaiters = this._spareList;
    this._spareList = toResume_2;
    var inductionVariable = 0;
    var last = toResume_2._get_size__45();
    if (inductionVariable < last)
      do {
        var i_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        toResume_2.get_66(i_4).resume(timeNanos);
      }
       while (inductionVariable < last);
    toResume_2.clear_7();
  };
  BroadcastFrameClock.prototype.withFrameNanos_1 = function (onFrame, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability();
    var tmp$ret$0;
    l$ret$1: do {
      var awaiter_4 = {_v: null};
      var tmp0_synchronized_0_6 = this._lock;
      var cause_2_7 = this._failureCause;
      if (!(cause_2_7 == null)) {
        var tmp0_failure_0_1_3_8 = Companion_getInstance_2();
        cancellable_2_2.resumeWith_15(_Result___init__impl_(createFailure(cause_2_7)));
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }awaiter_4._v = new FrameAwaiter(onFrame, cancellable_2_2);
      var tmp0_isNotEmpty_0_5_10 = this._awaiters;
      var hadAwaiters_4_9 = !tmp0_isNotEmpty_0_5_10.isEmpty_40();
      var tmp = this._awaiters;
      var tmp_0;
      if (awaiter_4._v == null) {
        throwUninitializedPropertyAccessException('awaiter');
      } else {
        tmp_0 = awaiter_4._v;
      }
      tmp.add_37(tmp_0);
      Unit_getInstance();
      var hasNewAwaiters_5 = !hadAwaiters_4_9;
      cancellable_2_2.invokeOnCancellation_0(_no_name_provided_$factory_32(this, awaiter_4));
      if (hasNewAwaiters_5 ? !(this._onNewAwaiters == null) : false) {
        try {
          this._onNewAwaiters();
        } catch ($p) {
          if ($p instanceof Error) {
            fail(this, $p);
          } else {
            {
              throw $p;
            }
          }
        }
      }}
     while (false);
    return cancellable_2_2.getResult_0();
  };
  BroadcastFrameClock.$metadata$ = {
    simpleName: 'BroadcastFrameClock',
    kind: 'class',
    interfaces: [MonotonicFrameClock]
  };
  function _no_name_provided_$factory_32(this$0, $awaiter_4) {
    var i = new _no_name_provided__40(this$0, $awaiter_4);
    return function (p1) {
      i.invoke_136(p1);
      return Unit_getInstance();
    };
  }
  function invalidApplier() {
    var tmp0_error_0 = 'Invalid applier';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  var removeCurrentGroupInstance;
  var endGroupInstance;
  var startRootGroup;
  var invocation;
  var provider;
  var compositionLocalMap;
  var providerValues;
  var providerMaps;
  var reference;
  function RememberManager() {
  }
  RememberManager.$metadata$ = {
    simpleName: 'RememberManager',
    kind: 'interface',
    interfaces: []
  };
  function removeCurrentGroup(_this_, rememberManager) {
    var tmp0_iterator_0 = _this_.groupSlots();
    var tmp0_iterator = tmp0_iterator_0;
    while (tmp0_iterator.hasNext_27()) {
      var slot = tmp0_iterator.next_28();
      var tmp1_subject = slot;
      if (!(tmp1_subject == null) ? isInterface(tmp1_subject, RememberObserver) : false) {
        rememberManager.forgetting_0(slot);
      } else {
        if (tmp1_subject instanceof RecomposeScopeImpl) {
          var composition = slot._composition_0;
          if (!(composition == null)) {
            composition._pendingInvalidScopes_0 = true;
            slot._composition_0 = null;
          }} else {
        }
      }
    }
    _this_.removeGroup();
    Unit_getInstance();
  }
  function startRoot($this) {
    $this._reader = $this._slotTable.openReader();
    startGroup($this, 100);
    $this._parentContext_0.startComposing_0();
    $this._parentProvider = $this._parentContext_0.getCompositionLocalScope_0();
    $this._providersInvalidStack.push(asInt($this._providersInvalid));
    $this._providersInvalid = $this.changed_2($this._parentProvider);
    $this._collectParameterInformation = $this._parentContext_0._get_collectingParameterInformation__0();
    var tmp0_safe_receiver = resolveCompositionLocal($this, LocalInspectionTables, $this._parentProvider);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.add_37($this._slotTable);
      Unit_getInstance();
      $this._parentContext_0.recordInspectionTable_0(tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    startGroup($this, $this._parentContext_0._get_compoundHashKey__0());
  }
  function endRoot($this) {
    $this.endGroup_1();
    $this._parentContext_0.doneComposing_0();
    $this.endGroup_1();
    recordEndRoot($this);
    finalizeCompose($this);
    $this._reader.close_7();
  }
  function abortRoot($this) {
    cleanUpCompose($this);
    $this._pendingStack.clear_7();
    $this._nodeIndexStack.clear_7();
    $this._groupNodeCountStack.clear_7();
    $this._entersStack.clear_7();
    $this._providersInvalidStack.clear_7();
    $this._reader.close_7();
    $this._compoundKeyHash = 0;
    $this._childrenComposing = 0;
    $this._nodeExpected = false;
    $this._isComposing = false;
  }
  function startGroup($this, key_0) {
    return start($this, key_0, null, false, null);
  }
  function startGroup_0($this, key_0, dataKey) {
    return start($this, key_0, dataKey, false, null);
  }
  function skipGroup($this) {
    var tmp0_this = $this;
    tmp0_this._groupNodeCount = tmp0_this._groupNodeCount + $this._reader.skipGroup_0() | 0;
  }
  function resolveCompositionLocal($this, key_0, scope) {
    var tmp;
    if (contains_1(scope, key_0)) {
      tmp = getValueOf(scope, key_0);
    } else {
      tmp = key_0._defaultValueHolder._get_value__13();
    }
    return tmp;
  }
  function ensureWriter($this) {
    if ($this._writer._closed) {
      $this._writer = $this._insertTable.openWriter();
      $this._writer.skipToGroupEnd_2();
      $this._hasProvider = false;
    }}
  function startReaderGroup($this, isNode_0, data) {
    if (isNode_0) {
      $this._reader.startNode_2();
    } else {
      if (!(data == null) ? !($this._reader._get_groupAux_() === data) : false) {
        recordSlotTableOperation$default($this, false, _no_name_provided_$factory_42(data), 2, null);
      }$this._reader.startGroup_1();
    }
  }
  function start($this, key_0, objectKey_0, isNode_0, data) {
    validateNodeNotExpected($this);
    updateCompoundKeyWhenWeEnterGroup($this, key_0, objectKey_0);
    if ($this._inserting) {
      $this._reader.beginEmpty();
      var startIndex = $this._writer._currentGroup;
      if (isNode_0)
        $this._writer.startNode_1(Companion_getInstance_11()._Empty);
      else if (!(data == null)) {
        var tmp = $this._writer;
        var tmp0_elvis_lhs = objectKey_0;
        tmp.startData(key_0, tmp0_elvis_lhs == null ? Companion_getInstance_11()._Empty : tmp0_elvis_lhs, data);
      } else {
        var tmp_0 = $this._writer;
        var tmp1_elvis_lhs = objectKey_0;
        tmp_0.startGroup_0(key_0, tmp1_elvis_lhs == null ? Companion_getInstance_11()._Empty : tmp1_elvis_lhs);
      }
      var tmp2_safe_receiver = $this._pending;
      if (tmp2_safe_receiver == null)
        null;
      else {
        var insertKeyInfo_2 = new KeyInfo(key_0, -1, insertedGroupVirtualIndex($this, startIndex), -1, 0);
        tmp2_safe_receiver.registerInsert(insertKeyInfo_2, $this._nodeIndex - tmp2_safe_receiver._startIndex | 0);
        tmp2_safe_receiver.recordUsed_1(insertKeyInfo_2);
      }
      Unit_getInstance();
      enterGroup($this, isNode_0, null);
      return Unit_getInstance();
    }if ($this._pending == null) {
      var slotKey = $this._reader._get_groupKey_();
      if (slotKey === key_0 ? equals(objectKey_0, $this._reader._get_groupObjectKey_()) : false) {
        startReaderGroup($this, isNode_0, data);
      } else {
        $this._pending = new Pending($this._reader.extractKeys(), $this._nodeIndex);
      }
    }var pending = $this._pending;
    var newPending = null;
    if (!(pending == null)) {
      var keyInfo = pending.getNext(key_0, objectKey_0);
      if (!(keyInfo == null)) {
        pending.recordUsed_1(keyInfo);
        Unit_getInstance();
        var location = keyInfo._location_1;
        $this._nodeIndex = pending.nodePositionOf(keyInfo) + pending._startIndex | 0;
        var relativePosition = pending.slotPositionOf(keyInfo);
        var currentRelativePosition = relativePosition - pending._groupIndex | 0;
        pending.registerMoveSlot(relativePosition, pending._groupIndex);
        recordReaderMoving($this, location);
        $this._reader.reposition(location);
        if (currentRelativePosition > 0) {
          recordSlotEditingOperation($this, _no_name_provided_$factory_43(currentRelativePosition));
        }startReaderGroup($this, isNode_0, data);
      } else {
        $this._reader.beginEmpty();
        $this._inserting = true;
        ensureWriter($this);
        $this._writer.beginInsert();
        var startIndex_0 = $this._writer._currentGroup;
        if (isNode_0)
          $this._writer.startNode_1(Companion_getInstance_11()._Empty);
        else if (!(data == null)) {
          var tmp_1 = $this._writer;
          var tmp3_elvis_lhs = objectKey_0;
          tmp_1.startData(key_0, tmp3_elvis_lhs == null ? Companion_getInstance_11()._Empty : tmp3_elvis_lhs, data);
        } else {
          var tmp_2 = $this._writer;
          var tmp4_elvis_lhs = objectKey_0;
          tmp_2.startGroup_0(key_0, tmp4_elvis_lhs == null ? Companion_getInstance_11()._Empty : tmp4_elvis_lhs);
        }
        $this._insertAnchor = $this._writer.anchor_0(startIndex_0);
        var insertKeyInfo = new KeyInfo(key_0, -1, insertedGroupVirtualIndex($this, startIndex_0), -1, 0);
        pending.registerInsert(insertKeyInfo, $this._nodeIndex - pending._startIndex | 0);
        pending.recordUsed_1(insertKeyInfo);
        Unit_getInstance();
        newPending = new Pending(ArrayList_init_$Create$(), isNode_0 ? 0 : $this._nodeIndex);
      }
    }enterGroup($this, isNode_0, newPending);
  }
  function enterGroup($this, isNode_0, newPending) {
    $this._pendingStack.push_0($this._pending);
    Unit_getInstance();
    $this._pending = newPending;
    $this._nodeIndexStack.push($this._nodeIndex);
    if (isNode_0)
      $this._nodeIndex = 0;
    $this._groupNodeCountStack.push($this._groupNodeCount);
    $this._groupNodeCount = 0;
  }
  function exitGroup($this, expectedNodeCount, inserting) {
    var previousPending = $this._pendingStack.pop_0();
    if (!(previousPending == null) ? !inserting : false) {
      var tmp0_this = previousPending;
      var tmp1 = tmp0_this._groupIndex;
      tmp0_this._groupIndex = tmp1 + 1 | 0;
      Unit_getInstance();
    }$this._pending = previousPending;
    $this._nodeIndex = $this._nodeIndexStack.pop_0() + expectedNodeCount | 0;
    $this._groupNodeCount = $this._groupNodeCountStack.pop_0() + expectedNodeCount | 0;
  }
  function end($this, isNode_0) {
    if ($this._inserting) {
      var parent_0 = $this._writer._parent_1;
      updateCompoundKeyWhenWeExitGroup($this, $this._writer.groupKey_1(parent_0), $this._writer.groupObjectKey_1(parent_0));
    } else {
      var parent_1 = $this._reader._parent_2;
      updateCompoundKeyWhenWeExitGroup($this, $this._reader.groupKey_1(parent_1), $this._reader.groupObjectKey_1(parent_1));
    }
    var expectedNodeCount = $this._groupNodeCount;
    var pending = $this._pending;
    if (!(pending == null) ? pending._keyInfos._get_size__45() > 0 : false) {
      var previous = pending._keyInfos;
      var current_0 = pending._get_used_();
      var usedKeys = fastToSet(current_0);
      var placedKeys = LinkedHashSet_init_$Create$();
      var currentIndex = 0;
      var currentEnd = current_0._get_size__45();
      var previousIndex = 0;
      var previousEnd = previous._get_size__45();
      var nodeOffset = 0;
      while (previousIndex < previousEnd) {
        var previousInfo = previous.get_66(previousIndex);
        if (!usedKeys.contains_37(previousInfo)) {
          var deleteOffset = pending.nodePositionOf(previousInfo);
          recordRemoveNode($this, deleteOffset + pending._startIndex | 0, previousInfo._nodes);
          pending.updateNodeCount(previousInfo._location_1, 0);
          Unit_getInstance();
          recordReaderMoving($this, previousInfo._location_1);
          $this._reader.reposition(previousInfo._location_1);
          recordDelete($this);
          $this._reader.skipGroup_0();
          Unit_getInstance();
          removeRange($this._invalidations, previousInfo._location_1, previousInfo._location_1 + $this._reader.groupSize_1(previousInfo._location_1) | 0);
          var tmp0 = previousIndex;
          previousIndex = tmp0 + 1 | 0;
          Unit_getInstance();
          continue;
        }if (placedKeys.contains_37(previousInfo)) {
          var tmp1 = previousIndex;
          previousIndex = tmp1 + 1 | 0;
          Unit_getInstance();
          continue;
        }if (currentIndex < currentEnd) {
          var currentInfo = current_0.get_66(currentIndex);
          if (!(currentInfo === previousInfo)) {
            var nodePosition = pending.nodePositionOf(currentInfo);
            placedKeys.add_37(currentInfo);
            Unit_getInstance();
            if (!(nodePosition === nodeOffset)) {
              var updatedCount = pending.updatedNodeCountOf(currentInfo);
              recordMoveNode($this, nodePosition + pending._startIndex | 0, nodeOffset + pending._startIndex | 0, updatedCount);
              pending.registerMoveNode(nodePosition, nodeOffset, updatedCount);
            }} else {
            var tmp2 = previousIndex;
            previousIndex = tmp2 + 1 | 0;
            Unit_getInstance();
          }
          var tmp3 = currentIndex;
          currentIndex = tmp3 + 1 | 0;
          Unit_getInstance();
          nodeOffset = nodeOffset + pending.updatedNodeCountOf(currentInfo) | 0;
        }}
      realizeMovement($this);
      if (previous._get_size__45() > 0) {
        recordReaderMoving($this, $this._reader._get_groupEnd_());
        $this._reader.skipToGroupEnd_2();
      }}var removeIndex = $this._nodeIndex;
    while (!$this._reader._get_isGroupEnd_()) {
      var startSlot = $this._reader._currentGroup_0;
      recordDelete($this);
      var nodesToRemove = $this._reader.skipGroup_0();
      recordRemoveNode($this, removeIndex, nodesToRemove);
      removeRange($this._invalidations, startSlot, $this._reader._currentGroup_0);
    }
    var inserting = $this._inserting;
    if (inserting) {
      if (isNode_0) {
        registerInsertUpFixup($this);
        expectedNodeCount = 1;
      }$this._reader.endEmpty();
      var parentGroup = $this._writer._parent_1;
      $this._writer.endGroup_0();
      Unit_getInstance();
      if (!$this._reader._get_inEmpty_()) {
        var virtualIndex = insertedGroupVirtualIndex($this, parentGroup);
        $this._writer.endInsert();
        $this._writer.close_7();
        recordInsert($this, $this._insertAnchor);
        $this._inserting = false;
        if (!$this._slotTable._get_isEmpty__3()) {
          updateNodeCount($this, virtualIndex, 0);
          updateNodeCountOverrides($this, virtualIndex, expectedNodeCount);
        }}} else {
      if (isNode_0)
        recordUp($this);
      recordEndGroup($this);
      var parentGroup_0 = $this._reader._parent_2;
      var parentNodeCount = updatedNodeCount($this, parentGroup_0);
      if (!(expectedNodeCount === parentNodeCount)) {
        updateNodeCountOverrides($this, parentGroup_0, expectedNodeCount);
      }if (isNode_0) {
        expectedNodeCount = 1;
      }$this._reader.endGroup_1();
      realizeMovement($this);
    }
    exitGroup($this, expectedNodeCount, inserting);
  }
  function recomposeToGroupEnd($this) {
    var wasComposing = $this._isComposing;
    $this._isComposing = true;
    var recomposed = false;
    var parent_0 = $this._reader._parent_2;
    var end_0 = parent_0 + $this._reader.groupSize_1(parent_0) | 0;
    var recomposeIndex = $this._nodeIndex;
    var recomposeCompoundKey = $this._compoundKeyHash;
    var oldGroupNodeCount = $this._groupNodeCount;
    var oldGroup = parent_0;
    var firstInRange_0 = firstInRange($this._invalidations, $this._reader._currentGroup_0, end_0);
    while (!(firstInRange_0 == null)) {
      var location = firstInRange_0._location;
      removeLocation($this._invalidations, location);
      Unit_getInstance();
      recomposed = true;
      $this._reader.reposition(location);
      var newGroup = $this._reader._currentGroup_0;
      recordUpsAndDowns($this, oldGroup, newGroup, parent_0);
      oldGroup = newGroup;
      $this._nodeIndex = nodeIndexOf($this, location, newGroup, parent_0, recomposeIndex);
      $this._compoundKeyHash = compoundKeyOf($this, $this._reader.parent_1(newGroup), parent_0, recomposeCompoundKey);
      firstInRange_0._scope.compose($this);
      $this._reader.restoreParent(parent_0);
      firstInRange_0 = firstInRange($this._invalidations, $this._reader._currentGroup_0, end_0);
    }
    if (recomposed) {
      recordUpsAndDowns($this, oldGroup, parent_0, parent_0);
      $this._reader.skipToGroupEnd_2();
      var parentGroupNodes = updatedNodeCount($this, parent_0);
      $this._nodeIndex = recomposeIndex + parentGroupNodes | 0;
      $this._groupNodeCount = oldGroupNodeCount + parentGroupNodes | 0;
    } else {
      skipReaderToGroupEnd($this);
    }
    $this._compoundKeyHash = recomposeCompoundKey;
    $this._isComposing = wasComposing;
  }
  function insertedGroupVirtualIndex($this, index) {
    return -2 - index | 0;
  }
  function updateNodeCountOverrides($this, group, newCount) {
    var currentCount = updatedNodeCount($this, group);
    if (!(currentCount === newCount)) {
      var delta_0 = newCount - currentCount | 0;
      var current_0 = group;
      var minPending = $this._pendingStack._get_size__45() - 1 | 0;
      $l$break_0: while (!(current_0 === -1)) {
        var newCurrentNodes = updatedNodeCount($this, current_0) + delta_0 | 0;
        updateNodeCount($this, current_0, newCurrentNodes);
        var inductionVariable = minPending;
        if (0 <= inductionVariable)
          $l$break: do {
            var pendingIndex = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var pending = $this._pendingStack.peek_1(pendingIndex);
            if (!(pending == null) ? pending.updateNodeCount(current_0, newCurrentNodes) : false) {
              minPending = pendingIndex - 1 | 0;
              break $l$break;
            }}
           while (0 <= inductionVariable);
        if (current_0 < 0) {
          current_0 = $this._reader._parent_2;
        } else {
          if ($this._reader.isNode_0(current_0))
            break $l$break_0;
          current_0 = $this._reader.parent_1(current_0);
        }
      }
    }}
  function nodeIndexOf($this, groupLocation, group, recomposeGroup, recomposeIndex) {
    var anchorGroup = $this._reader.parent_1(group);
    $l$break: while (!(anchorGroup === recomposeGroup)) {
      if ($this._reader.isNode_0(anchorGroup))
        break $l$break;
      anchorGroup = $this._reader.parent_1(anchorGroup);
    }
    var index = $this._reader.isNode_0(anchorGroup) ? 0 : recomposeIndex;
    if (anchorGroup === group)
      return index;
    var current_0 = anchorGroup;
    var nodeIndexLimit = index + (updatedNodeCount($this, anchorGroup) - $this._reader.nodeCount(group) | 0) | 0;
    loop: while (index < nodeIndexLimit) {
      if (current_0 === groupLocation)
        break loop;
      var tmp0 = current_0;
      current_0 = tmp0 + 1 | 0;
      Unit_getInstance();
      while (current_0 < groupLocation) {
        var end_0 = current_0 + $this._reader.groupSize_1(current_0) | 0;
        if (groupLocation < end_0)
          continue loop;
        index = index + updatedNodeCount($this, current_0) | 0;
        current_0 = end_0;
      }
      break loop;
    }
    return index;
  }
  function updatedNodeCount($this, group) {
    if (group < 0) {
      var tmp0_safe_receiver = $this._nodeCountVirtualOverrides;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp0_safe_receiver.get_48(group);
      }
      var tmp1_elvis_lhs = tmp;
      return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    }var nodeCounts = $this._nodeCountOverrides;
    if (!(nodeCounts == null)) {
      var override = nodeCounts[group];
      if (override >= 0)
        return override;
    }return $this._reader.nodeCount(group);
  }
  function updateNodeCount($this, group, count) {
    if (!(updatedNodeCount($this, group) === count)) {
      if (group < 0) {
        var tmp0_elvis_lhs = $this._nodeCountVirtualOverrides;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var newCounts_2 = HashMap_init_$Create$();
          $this._nodeCountVirtualOverrides = newCounts_2;
          tmp = newCounts_2;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var virtualCounts = tmp;
        virtualCounts.put_6(group, count);
        Unit_getInstance();
      } else {
        var tmp1_elvis_lhs = $this._nodeCountOverrides;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          var newCounts_2_0 = new Int32Array($this._reader._get_size__45());
          fill$default(newCounts_2_0, -1, 0, 0, 6, null);
          $this._nodeCountOverrides = newCounts_2_0;
          tmp_0 = newCounts_2_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var nodeCounts = tmp_0;
        nodeCounts[group] = count;
      }
    }}
  function clearUpdatedNodeCounts($this) {
    $this._nodeCountOverrides = null;
    $this._nodeCountVirtualOverrides = null;
  }
  function recordUpsAndDowns($this, oldGroup, newGroup, commonRoot) {
    var reader = $this._reader;
    var nearestCommonRoot = nearestCommonRootOf(reader, oldGroup, newGroup, commonRoot);
    var current_0 = oldGroup;
    while (current_0 > 0 ? !(current_0 === nearestCommonRoot) : false) {
      if (reader.isNode_0(current_0))
        recordUp($this);
      current_0 = reader.parent_1(current_0);
    }
    doRecordDownsFor($this, newGroup, nearestCommonRoot);
  }
  function doRecordDownsFor($this, group, nearestCommonRoot) {
    if (group > 0 ? !(group === nearestCommonRoot) : false) {
      doRecordDownsFor($this, $this._reader.parent_1(group), nearestCommonRoot);
      if ($this._reader.isNode_0(group))
        recordDown($this, nodeAt($this._reader, $this, group));
    }}
  function compoundKeyOf($this, group, recomposeGroup, recomposeKey) {
    var tmp;
    if (group === recomposeGroup) {
      tmp = recomposeKey;
    } else {
      var tmp0_rol_0 = compoundKeyOf($this, $this._reader.parent_1(group), recomposeGroup, recomposeKey);
      var tmp1_rol_0 = 3;
      var tmp_0 = rotateLeft(tmp0_rol_0, tmp1_rol_0);
      var tmp_1;
      if ($this._reader.hasObjectKey(group)) {
        var tmp0_safe_receiver = $this._reader.groupObjectKey_1(group);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        tmp_1 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      } else {
        tmp_1 = $this._reader.groupKey_1(group);
      }
      tmp = tmp_0 ^ tmp_1;
    }
    return tmp;
  }
  function skipReaderToGroupEnd($this) {
    $this._groupNodeCount = $this._reader._get_parentNodes_();
    $this._reader.skipToGroupEnd_2();
  }
  function addRecomposeScope($this) {
    if ($this._inserting) {
      var tmp = $this._composition;
      var scope = new RecomposeScopeImpl(tmp instanceof CompositionImpl ? tmp : THROW_CCE());
      $this._invalidateStack.push_0(scope);
      Unit_getInstance();
      $this.updateValue(scope);
      scope.start_13($this._snapshot._get_id__3());
    } else {
      var invalidation = removeLocation($this._invalidations, $this._reader._parent_2);
      var tmp_0 = $this._reader.next_28();
      var scope_0 = tmp_0 instanceof RecomposeScopeImpl ? tmp_0 : THROW_CCE();
      scope_0._requiresRecompose = !(invalidation == null);
      $this._invalidateStack.push_0(scope_0);
      Unit_getInstance();
      scope_0.start_13($this._snapshot._get_id__3());
    }
  }
  function _get_node_(_this_, $this) {
    return _this_.node_1(_this_._parent_2);
  }
  function nodeAt(_this_, $this, index) {
    return _this_.node_1(index);
  }
  function validateNodeExpected($this) {
    var tmp0_check_0 = $this._nodeExpected;
    if (!tmp0_check_0) {
      var message_1 = 'A call to createNode(), emitNode() or useNode() expected was not expected';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }$this._nodeExpected = false;
  }
  function validateNodeNotExpected($this) {
    var tmp0_check_0 = !$this._nodeExpected;
    if (!tmp0_check_0) {
      var message_1 = 'A call to createNode(), emitNode() or useNode() expected';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }}
  function record($this, change) {
    $this._changes.add_37(change);
    Unit_getInstance();
  }
  function recordApplierOperation($this, change) {
    realizeUps($this);
    realizeDowns_0($this);
    record($this, change);
  }
  function recordSlotEditingOperation($this, change) {
    realizeOperationLocation$default($this, false, 2, null);
    recordSlotEditing($this);
    record($this, change);
  }
  function recordSlotTableOperation($this, forParent, change) {
    realizeOperationLocation($this, forParent);
    record($this, change);
  }
  function recordSlotTableOperation$default($this, forParent, change, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      forParent = false;
    return recordSlotTableOperation($this, forParent, change);
  }
  function realizeUps($this) {
    var count = $this._pendingUps;
    if (count > 0) {
      $this._pendingUps = 0;
      record($this, _no_name_provided_$factory_45(count));
    }}
  function realizeDowns($this, nodes) {
    record($this, _no_name_provided_$factory_46(nodes));
  }
  function realizeDowns_0($this) {
    if ($this._downNodes.isNotEmpty_0()) {
      realizeDowns($this, $this._downNodes.toArray_1());
      $this._downNodes.clear_7();
    }}
  function recordDown($this, node_0) {
    $this._downNodes.push_0(node_0);
    Unit_getInstance();
  }
  function recordUp($this) {
    if ($this._downNodes.isNotEmpty_0()) {
      $this._downNodes.pop_0();
      Unit_getInstance();
    } else {
      var tmp0_this = $this;
      var tmp1 = tmp0_this._pendingUps;
      tmp0_this._pendingUps = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function realizeOperationLocation($this, forParent) {
    var location = forParent ? $this._reader._parent_2 : $this._reader._currentGroup_0;
    var distance = location - $this._writersReaderDelta | 0;
    var tmp0_require_0 = distance >= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Tried to seek backward';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }if (distance > 0) {
      record($this, _no_name_provided_$factory_47(distance));
      $this._writersReaderDelta = location;
    }}
  function realizeOperationLocation$default($this, forParent, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      forParent = false;
    return realizeOperationLocation($this, forParent);
  }
  function recordInsert($this, anchor) {
    if ($this._insertFixups.isEmpty_40()) {
      var insertTable = $this._insertTable;
      recordSlotEditingOperation($this, _no_name_provided_$factory_48(insertTable, anchor));
    } else {
      var fixups = toMutableList($this._insertFixups);
      $this._insertFixups.clear_7();
      realizeUps($this);
      realizeDowns_0($this);
      var insertTable_0 = $this._insertTable;
      recordSlotEditingOperation($this, _no_name_provided_$factory_49(insertTable_0, fixups, anchor));
    }
  }
  function recordFixup($this, change) {
    $this._insertFixups.add_37(change);
    Unit_getInstance();
  }
  function recordInsertUpFixup($this, change) {
    $this._insertUpFixups.push_0(change);
    Unit_getInstance();
  }
  function registerInsertUpFixup($this) {
    $this._insertFixups.add_37($this._insertUpFixups.pop_0());
    Unit_getInstance();
  }
  function recordDelete($this) {
    recordSlotEditingOperation($this, removeCurrentGroupInstance);
    var tmp0_this = $this;
    tmp0_this._writersReaderDelta = tmp0_this._writersReaderDelta + $this._reader._get_groupSize_() | 0;
  }
  function recordReaderMoving($this, location) {
    var distance = $this._reader._currentGroup_0 - $this._writersReaderDelta | 0;
    $this._writersReaderDelta = location - distance | 0;
  }
  function recordSlotEditing($this) {
    if (!$this._slotTable._get_isEmpty__3()) {
      var reader = $this._reader;
      var location = reader._parent_2;
      if (!($this._startedGroups.peekOr(-1) === location)) {
        if (!$this._startedGroup) {
          recordSlotTableOperation$default($this, false, startRootGroup, 2, null);
          $this._startedGroup = true;
        }var anchor = reader.anchor_0(location);
        $this._startedGroups.push(location);
        recordSlotTableOperation$default($this, false, _no_name_provided_$factory_50(anchor), 2, null);
      }}}
  function recordEndGroup($this) {
    var location = $this._reader._parent_2;
    var currentStartedGroup = $this._startedGroups.peekOr(-1);
    var tmp0_check_0 = currentStartedGroup <= location;
    if (!tmp0_check_0) {
      var message_1 = 'Missed recording an endGroup';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }if ($this._startedGroups.peekOr(-1) === location) {
      $this._startedGroups.pop_0();
      Unit_getInstance();
      recordSlotTableOperation$default($this, false, endGroupInstance, 2, null);
    }}
  function recordEndRoot($this) {
    if ($this._startedGroup) {
      recordSlotTableOperation$default($this, false, endGroupInstance, 2, null);
      $this._startedGroup = false;
    }}
  function finalizeCompose($this) {
    realizeUps($this);
    var tmp0_check_0 = $this._pendingStack.isEmpty_40();
    if (!tmp0_check_0) {
      var message_1 = 'Start/end imbalance';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var tmp1_check_0 = $this._startedGroups.isEmpty_40();
    if (!tmp1_check_0) {
      var message_1_0 = 'Missed recording an endGroup()';
      throw IllegalStateException_init_$Create$(toString_1(message_1_0));
    }cleanUpCompose($this);
  }
  function cleanUpCompose($this) {
    $this._pending = null;
    $this._nodeIndex = 0;
    $this._groupNodeCount = 0;
    $this._writersReaderDelta = 0;
    $this._compoundKeyHash = 0;
    $this._nodeExpected = false;
    $this._startedGroup = false;
    $this._startedGroups.clear_7();
    $this._invalidateStack.clear_7();
    clearUpdatedNodeCounts($this);
  }
  function recordRemoveNode($this, nodeIndex_1, count) {
    if (count > 0) {
      var tmp0_check_0 = nodeIndex_1 >= 0;
      if (!tmp0_check_0) {
        var message_1 = '' + 'Invalid remove index ' + nodeIndex_1;
        throw IllegalStateException_init_$Create$(toString_1(message_1));
      }if ($this._previousRemove === nodeIndex_1) {
        var tmp0_this = $this;
        tmp0_this._previousCount = tmp0_this._previousCount + count | 0;
      } else {
        realizeMovement($this);
        $this._previousRemove = nodeIndex_1;
        $this._previousCount = count;
      }
    }}
  function recordMoveNode($this, from, to_0, count) {
    if (count > 0) {
      if (($this._previousCount > 0 ? $this._previousMoveFrom === (from - $this._previousCount | 0) : false) ? $this._previousMoveTo === (to_0 - $this._previousCount | 0) : false) {
        var tmp0_this = $this;
        tmp0_this._previousCount = tmp0_this._previousCount + count | 0;
      } else {
        realizeMovement($this);
        $this._previousMoveFrom = from;
        $this._previousMoveTo = to_0;
        $this._previousCount = count;
      }
    }}
  function realizeMovement($this) {
    var count = $this._previousCount;
    $this._previousCount = 0;
    if (count > 0) {
      if ($this._previousRemove >= 0) {
        var removeIndex = $this._previousRemove;
        $this._previousRemove = -1;
        recordApplierOperation($this, _no_name_provided_$factory_51(removeIndex, count));
      } else {
        var from = $this._previousMoveFrom;
        $this._previousMoveFrom = -1;
        var to_0 = $this._previousMoveTo;
        $this._previousMoveTo = -1;
        recordApplierOperation($this, _no_name_provided_$factory_52(from, to_0, count));
      }
    }}
  function updateCompoundKeyWhenWeEnterGroup($this, groupKey, dataKey) {
    if (dataKey == null)
      updateCompoundKeyWhenWeEnterGroupKeyHash($this, groupKey);
    else
      updateCompoundKeyWhenWeEnterGroupKeyHash($this, hashCode(dataKey));
  }
  function updateCompoundKeyWhenWeEnterGroupKeyHash($this, keyHash) {
    var tmp = $this;
    var tmp0_rol_0 = $this._compoundKeyHash;
    var tmp1_rol_0 = 3;
    tmp._compoundKeyHash = rotateLeft(tmp0_rol_0, tmp1_rol_0) ^ keyHash;
  }
  function updateCompoundKeyWhenWeExitGroup($this, groupKey, dataKey) {
    if (dataKey == null)
      updateCompoundKeyWhenWeExitGroupKeyHash($this, groupKey);
    else
      updateCompoundKeyWhenWeExitGroupKeyHash($this, hashCode(dataKey));
  }
  function updateCompoundKeyWhenWeExitGroupKeyHash($this, groupKey) {
    var tmp = $this;
    var tmp0_ror_0 = $this._compoundKeyHash ^ groupKey;
    var tmp1_ror_0 = 3;
    tmp._compoundKeyHash = rotateRight(tmp0_ror_0, tmp1_ror_0);
  }
  function doCompose$composable($this, invalidationsRequested, content) {
    var tmp0_check_0 = !$this._isComposing;
    if (!tmp0_check_0) {
      var message_1 = 'Reentrant composition is not supported';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var tmp$ret$0;
    l$ret$1: do {
      var tmp1_trace_0 = 'Compose:recompose';
      var token_1 = Trace_getInstance().beginSection(tmp1_trace_0);
      try {
        $this._invalidations.clear_7();
        $this._snapshot = currentSnapshot();
        var inductionVariable = 0;
        var last = invalidationsRequested._size_4;
        if (inductionVariable < last)
          do {
            var i_3_4 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0__anonymous__4_5 = invalidationsRequested.get_66(i_3_4);
            var tmp0_safe_receiver_7_8 = tmp0__anonymous__4_5._anchor;
            var tmp1_elvis_lhs_6_7 = tmp0_safe_receiver_7_8 == null ? null : tmp0_safe_receiver_7_8._location_0;
            var tmp;
            if (tmp1_elvis_lhs_6_7 == null) {
              return Unit_getInstance();
            } else {
              tmp = tmp1_elvis_lhs_6_7;
            }
            var location_5_6 = tmp;
            $this._invalidations.add_37(new Invalidation(tmp0__anonymous__4_5, location_5_6));
            Unit_getInstance();
          }
           while (inductionVariable < last);
        var tmp1_sortBy_0_9 = $this._invalidations;
        if (tmp1_sortBy_0_9._get_size__45() > 1) {
          var tmp_0 = _no_name_provided_$factory_53();
          sortWith(tmp1_sortBy_0_9, new sam$kotlin_Comparator$0(tmp_0));
        }$this._nodeIndex = 0;
        var complete_11 = false;
        $this._isComposing = true;
        var tmp_1;
        try {
          startRoot($this);
          if (!(content == null)) {
            startGroup_0($this, 200, invocation);
            invokeComposable$composable($this, content);
            $this.endGroup_1();
          } else {
            $this.skipCurrentGroup_0();
          }
          endRoot($this);
          complete_11 = true;
          tmp_1 = Unit_getInstance();
        }finally {
          $this._isComposing = false;
          if (!complete_11)
            abortRoot($this);
        }
        tmp$ret$0 = tmp_1;
        break l$ret$1;
      }finally {
        Trace_getInstance().endSection(token_1);
      }
    }
     while (false);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this._function = function_0;
  }
  sam$kotlin_Comparator$0.prototype.compare_0 = function (a, b) {
    return this._function(a, b);
  };
  sam$kotlin_Comparator$0.prototype.compare = function (a, b) {
    return this.compare_0(a, b);
  };
  sam$kotlin_Comparator$0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__41($factory, $groupAnchor, $insertIndex) {
    this._$factory = $factory;
    this._$groupAnchor = $groupAnchor;
    this._$insertIndex = $insertIndex;
  }
  _no_name_provided__41.prototype.invoke_115 = function (applier, slots, _anonymous_parameter_2_) {
    var node_0 = this._$factory();
    slots.updateNode_0(this._$groupAnchor, node_0);
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    nodeApplier.insertTopDown_2(this._$insertIndex, node_0);
    applier.down_1(node_0);
  };
  _no_name_provided__41.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__42($groupAnchor, $insertIndex) {
    this._$groupAnchor_0 = $groupAnchor;
    this._$insertIndex_0 = $insertIndex;
  }
  _no_name_provided__42.prototype.invoke_115 = function (applier, slots, _anonymous_parameter_2_) {
    var nodeToInsert = slots.node_0(this._$groupAnchor_0);
    applier.up_1();
    var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
    nodeApplier.insertBottomUp_2(this._$insertIndex_0, nodeToInsert);
  };
  _no_name_provided__42.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__43($block, $value) {
    this._$block_0 = $block;
    this._$value = $value;
  }
  _no_name_provided__43.prototype.invoke_115 = function (applier, _anonymous_parameter_1_, _anonymous_parameter_2_) {
    var tmp = applier._get_current__2();
    this._$block_0((tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE(), this._$value);
  };
  _no_name_provided__43.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__44($value) {
    this._$value_0 = $value;
  }
  _no_name_provided__44.prototype.invoke_115 = function (_anonymous_parameter_0_, _anonymous_parameter_1_, rememberManager) {
    rememberManager.remembering_0(this._$value_0);
  };
  _no_name_provided__44.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__45($value, this$0, $groupSlotIndex) {
    this._$value_1 = $value;
    this._this$0_9 = this$0;
    this._$groupSlotIndex = $groupSlotIndex;
  }
  _no_name_provided__45.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, rememberManager) {
    var tmp = this._$value_1;
    if (!(tmp == null) ? isInterface(tmp, RememberObserver) : false) {
      this._this$0_9._abandonSet.add_37(this._$value_1);
      Unit_getInstance();
      rememberManager.remembering_0(this._$value_1);
    } else {
    }
    var previous = slots.set_10(this._$groupSlotIndex, this._$value_1);
    if (!(previous == null) ? isInterface(previous, RememberObserver) : false)
      rememberManager.forgetting_0(previous);
    else {
      if (previous instanceof RecomposeScopeImpl) {
        var composition = previous._composition_0;
        if (!(composition == null)) {
          previous._composition_0 = null;
          composition._pendingInvalidScopes_0 = true;
        }} else {
      }
    }
  };
  _no_name_provided__45.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__46($effect) {
    this._$effect = $effect;
  }
  _no_name_provided__46.prototype.invoke_115 = function (_anonymous_parameter_0_, _anonymous_parameter_1_, rememberManager) {
    rememberManager.sideEffect_0(this._$effect);
  };
  _no_name_provided__46.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__47($data) {
    this._$data = $data;
  }
  _no_name_provided__47.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, _anonymous_parameter_2_) {
    slots.updateAux(this._$data);
  };
  _no_name_provided__47.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__48($currentRelativePosition) {
    this._$currentRelativePosition = $currentRelativePosition;
  }
  _no_name_provided__48.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, _anonymous_parameter_2_) {
    slots.moveGroup(this._$currentRelativePosition);
  };
  _no_name_provided__48.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__49($tmp2_safe_receiver, this$0) {
    this._$tmp2_safe_receiver = $tmp2_safe_receiver;
    this._this$0_10 = this$0;
  }
  _no_name_provided__49.prototype.invoke_115 = function (_anonymous_parameter_0_, _anonymous_parameter_1_, _anonymous_parameter_2_) {
    this._$tmp2_safe_receiver(this._this$0_10._composition);
  };
  _no_name_provided__49.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__50($count) {
    this._$count = $count;
  }
  _no_name_provided__50.prototype.invoke_115 = function (applier, _anonymous_parameter_1_, _anonymous_parameter_2_) {
    var inductionVariable = 0;
    var last = this._$count;
    if (inductionVariable < last)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        applier.up_1();
      }
       while (inductionVariable < last);
  };
  _no_name_provided__50.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__51($nodes) {
    this._$nodes = $nodes;
  }
  _no_name_provided__51.prototype.invoke_115 = function (applier, _anonymous_parameter_1_, _anonymous_parameter_2_) {
    var inductionVariable = 0;
    var last = this._$nodes.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var nodeApplier = isInterface(applier, Applier) ? applier : THROW_CCE();
        nodeApplier.down_1(this._$nodes[index]);
      }
       while (inductionVariable <= last);
  };
  _no_name_provided__51.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__52($distance) {
    this._$distance = $distance;
  }
  _no_name_provided__52.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, _anonymous_parameter_2_) {
    slots.advanceBy(this._$distance);
  };
  _no_name_provided__52.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__53($insertTable, $anchor) {
    this._$insertTable = $insertTable;
    this._$anchor = $anchor;
  }
  _no_name_provided__53.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, _anonymous_parameter_2_) {
    slots.beginInsert();
    slots.moveFrom(this._$insertTable, this._$anchor.toIndexFor(this._$insertTable));
    Unit_getInstance();
    slots.endInsert();
  };
  _no_name_provided__53.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__54($insertTable, $fixups, $anchor) {
    this._$insertTable_0 = $insertTable;
    this._$fixups = $fixups;
    this._$anchor_0 = $anchor;
  }
  _no_name_provided__54.prototype.invoke_115 = function (applier, slots, rememberManager) {
    var tmp0_let_0 = this._$insertTable_0.openWriter();
    try {
      var inductionVariable = 0;
      var last = this._$fixups._get_size__45() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_3_4 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item_4_5 = this._$fixups.get_66(index_3_4);
          item_4_5(applier, tmp0_let_0, rememberManager);
        }
         while (inductionVariable <= last);
    }finally {
      tmp0_let_0.close_7();
    }
    slots.beginInsert();
    slots.moveFrom(this._$insertTable_0, this._$anchor_0.toIndexFor(this._$insertTable_0));
    Unit_getInstance();
    slots.endInsert();
  };
  _no_name_provided__54.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__55($anchor) {
    this._$anchor_1 = $anchor;
  }
  _no_name_provided__55.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, _anonymous_parameter_2_) {
    slots.ensureStarted_0(this._$anchor_1);
  };
  _no_name_provided__55.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__56($removeIndex, $count) {
    this._$removeIndex = $removeIndex;
    this._$count_0 = $count;
  }
  _no_name_provided__56.prototype.invoke_115 = function (applier, _anonymous_parameter_1_, _anonymous_parameter_2_) {
    applier.remove_54(this._$removeIndex, this._$count_0);
  };
  _no_name_provided__56.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__57($from, $to, $count) {
    this._$from = $from;
    this._$to = $to;
    this._$count_1 = $count;
  }
  _no_name_provided__57.prototype.invoke_115 = function (applier, _anonymous_parameter_1_, _anonymous_parameter_2_) {
    applier.move_2(this._$from, this._$to, this._$count_1);
  };
  _no_name_provided__57.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__58() {
  }
  _no_name_provided__58.prototype.invoke_108 = function (a, b) {
    var tmp = a._location;
    return compareValues(tmp, b._location);
  };
  _no_name_provided__58.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof Invalidation ? p1 : THROW_CCE();
    return this.invoke_108(tmp, p2 instanceof Invalidation ? p2 : THROW_CCE());
  };
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ComposerImpl(applier, parentContext, slotTable, abandonSet, changes, composition) {
    this._applier = applier;
    this._parentContext_0 = parentContext;
    this._slotTable = slotTable;
    this._abandonSet = abandonSet;
    this._changes = changes;
    this._composition = composition;
    this._pendingStack = new Stack();
    this._pending = null;
    this._nodeIndex = 0;
    this._nodeIndexStack = new IntStack();
    this._groupNodeCount = 0;
    this._groupNodeCountStack = new IntStack();
    this._nodeCountOverrides = null;
    this._nodeCountVirtualOverrides = null;
    this._collectParameterInformation = false;
    this._nodeExpected = false;
    var tmp = this;
    tmp._invalidations = ArrayList_init_$Create$();
    this._pendingInvalidScopes = false;
    this._entersStack = new IntStack();
    this._parentProvider = persistentHashMapOf();
    this._providerUpdates = HashMap_init_$Create$();
    this._providersInvalid = false;
    this._providersInvalidStack = new IntStack();
    this._childrenComposing = 0;
    this._snapshot = currentSnapshot();
    this._invalidateStack = new Stack();
    this._isComposing = false;
    this._isDisposed = false;
    var tmp_0 = this;
    var tmp0_also_0 = this._slotTable.openReader();
    tmp0_also_0.close_7();
    tmp_0._reader = tmp0_also_0;
    this._insertTable = new SlotTable();
    var tmp_1 = this;
    var tmp0_also_0_0 = this._insertTable.openWriter();
    tmp0_also_0_0.close_7();
    tmp_1._writer = tmp0_also_0_0;
    this._hasProvider = false;
    var tmp_2 = this;
    var tmp1_read_0 = this._insertTable;
    var tmp0_let_0 = tmp1_read_0.openReader();
    var tmp_3;
    try {
      tmp_3 = tmp0_let_0.anchor_0(0);
    }finally {
      tmp0_let_0.close_7();
    }
    tmp_2._insertAnchor = tmp_3;
    var tmp_4 = this;
    tmp_4._insertFixups = ArrayList_init_$Create$();
    this._inserting = false;
    this._compoundKeyHash = 0;
    this._pendingUps = 0;
    this._downNodes = new Stack();
    this._writersReaderDelta = 0;
    this._startedGroup = false;
    this._startedGroups = new IntStack();
    this._insertUpFixups = new Stack();
    this._previousRemove = -1;
    this._previousMoveFrom = -1;
    this._previousMoveTo = -1;
    this._previousCount = 0;
  }
  ComposerImpl.prototype._get_applier__0 = function () {
    return this._applier;
  };
  ComposerImpl.prototype._get_areChildrenComposing_ = function () {
    return this._childrenComposing > 0;
  };
  ComposerImpl.prototype._get_applyCoroutineContext__0 = function () {
    return this._parentContext_0._get_effectCoroutineContext__0();
  };
  ComposerImpl.prototype.startReplaceableGroup_1 = function (key_0) {
    return start(this, key_0, null, false, null);
  };
  ComposerImpl.prototype.startReplaceableGroup_2 = function (key_0, sourceInformation) {
    return start(this, key_0, null, false, sourceInformation);
  };
  ComposerImpl.prototype.endReplaceableGroup_0 = function () {
    return this.endGroup_1();
  };
  ComposerImpl.prototype.startDefaults_0 = function () {
    return start(this, 0, null, false, null);
  };
  ComposerImpl.prototype.endDefaults_0 = function () {
    this.endGroup_1();
    var scope = this._get_currentRecomposeScope_();
    if (!(scope == null) ? scope._used : false) {
      scope._defaultsInScope = true;
    }};
  ComposerImpl.prototype._get_defaultsInvalid__0 = function () {
    var tmp;
    if (this._providersInvalid) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = this._get_currentRecomposeScope_();
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver._defaultsInvalid) === true;
    }
    return tmp;
  };
  ComposerImpl.prototype._get_inserting__0 = function () {
    return this._inserting;
  };
  ComposerImpl.prototype._get_skipping__0 = function () {
    var tmp;
    if (!this._inserting ? !this._providersInvalid : false) {
      var tmp0_safe_receiver = this._get_currentRecomposeScope_();
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver._requiresRecompose) === false;
    } else {
      tmp = false;
    }
    return tmp;
  };
  ComposerImpl.prototype.endGroup_1 = function () {
    return end(this, false);
  };
  ComposerImpl.prototype.startNode_2 = function () {
    start(this, 125, null, true, null);
    this._nodeExpected = true;
  };
  ComposerImpl.prototype.createNode_0 = function (factory) {
    validateNodeExpected(this);
    var tmp0_check_0 = this._inserting;
    if (!tmp0_check_0) {
      var message_1 = 'createNode() can only be called when inserting';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var insertIndex = this._nodeIndexStack.peek_0();
    var groupAnchor = this._writer.anchor_0(this._writer._parent_1);
    var tmp0_this = this;
    var tmp1 = tmp0_this._groupNodeCount;
    tmp0_this._groupNodeCount = tmp1 + 1 | 0;
    Unit_getInstance();
    recordFixup(this, _no_name_provided_$factory_36(factory, groupAnchor, insertIndex));
    recordInsertUpFixup(this, _no_name_provided_$factory_37(groupAnchor, insertIndex));
  };
  ComposerImpl.prototype.useNode_0 = function () {
    validateNodeExpected(this);
    var tmp0_check_0 = !this._inserting;
    if (!tmp0_check_0) {
      var message_1 = 'useNode() called while inserting';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }recordDown(this, _get_node_(this._reader, this));
  };
  ComposerImpl.prototype.endNode_0 = function () {
    return end(this, true);
  };
  ComposerImpl.prototype.apply_0 = function (value_0, block) {
    var operation = _no_name_provided_$factory_38(block, value_0);
    if (this._inserting)
      recordFixup(this, operation);
    else
      recordApplierOperation(this, operation);
  };
  ComposerImpl.prototype.nextSlot = function () {
    var tmp;
    if (this._inserting) {
      validateNodeNotExpected(this);
      tmp = Companion_getInstance_11()._Empty;
    } else {
      tmp = this._reader.next_28();
    }
    return tmp;
  };
  ComposerImpl.prototype.changed_2 = function (value_0) {
    var tmp;
    if (!equals(this.nextSlot(), value_0)) {
      this.updateValue(value_0);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  ComposerImpl.prototype.changed_4 = function (value_0) {
    var next = this.nextSlot();
    if (!(next == null) ? typeof next === 'number' : false) {
      var nextPrimitive = next;
      if (value_0 === nextPrimitive)
        return false;
    } else {
    }
    this.updateValue(value_0);
    return true;
  };
  ComposerImpl.prototype.changed_3 = function (value_0) {
    var next = this.nextSlot();
    if (!(next == null) ? typeof next === 'number' : false) {
      var nextPrimitive = next;
      if (value_0 === nextPrimitive)
        return false;
    } else {
    }
    this.updateValue(value_0);
    return true;
  };
  ComposerImpl.prototype.updateValue = function (value_0) {
    if (this._inserting) {
      this._writer.update_0(value_0);
      Unit_getInstance();
      if (!(value_0 == null) ? isInterface(value_0, RememberObserver) : false) {
        record(this, _no_name_provided_$factory_39(value_0));
      } else {
      }
    } else {
      var groupSlotIndex = this._reader._get_groupSlotIndex_() - 1 | 0;
      recordSlotTableOperation(this, true, _no_name_provided_$factory_40(value_0, this, groupSlotIndex));
    }
  };
  ComposerImpl.prototype.recordSideEffect_0 = function (effect) {
    record(this, _no_name_provided_$factory_41(effect));
  };
  ComposerImpl.prototype._get_currentRecomposeScope_ = function () {
    var tmp0_let_0 = this._invalidateStack;
    return (this._childrenComposing === 0 ? tmp0_let_0.isNotEmpty_0() : false) ? tmp0_let_0.peek_0() : null;
  };
  ComposerImpl.prototype.tryImminentInvalidation = function (scope) {
    var tmp0_elvis_lhs = scope._anchor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var anchor = tmp;
    var location = anchor.toIndexFor(this._slotTable);
    if (this._isComposing ? location >= this._reader._currentGroup_0 : false) {
      insertIfMissing(this._invalidations, location, scope);
      return true;
    }return false;
  };
  ComposerImpl.prototype.skipCurrentGroup_0 = function () {
    if (this._invalidations.isEmpty_40()) {
      skipGroup(this);
    } else {
      var reader = this._reader;
      var key_0 = reader._get_groupKey_();
      var dataKey = reader._get_groupObjectKey_();
      updateCompoundKeyWhenWeEnterGroup(this, key_0, dataKey);
      startReaderGroup(this, reader._get_isNode_(), null);
      recomposeToGroupEnd(this);
      reader.endGroup_1();
      updateCompoundKeyWhenWeExitGroup(this, key_0, dataKey);
    }
  };
  ComposerImpl.prototype.skipToGroupEnd_2 = function () {
    var tmp0_check_0 = this._groupNodeCount === 0;
    if (!tmp0_check_0) {
      var message_1 = 'No nodes can be emitted before calling skipAndEndGroup';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var tmp0_safe_receiver = this._get_currentRecomposeScope_();
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._used = false;
    if (this._invalidations.isEmpty_40()) {
      skipReaderToGroupEnd(this);
    } else {
      recomposeToGroupEnd(this);
    }
  };
  ComposerImpl.prototype.startRestartGroup_0 = function (key_0, sourceInformation) {
    start(this, key_0, null, false, sourceInformation);
    addRecomposeScope(this);
    return this;
  };
  ComposerImpl.prototype.endRestartGroup_0 = function () {
    var scope = this._invalidateStack.isNotEmpty_0() ? this._invalidateStack.pop_0() : null;
    var tmp0_safe_receiver = scope;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._requiresRecompose = false;
    var tmp1_safe_receiver = scope;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.end(this._snapshot._get_id__3());
    if (tmp2_safe_receiver == null)
      null;
    else {
      record(this, _no_name_provided_$factory_44(tmp2_safe_receiver, this));
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp;
    if (!(scope == null) ? scope._used ? true : this._collectParameterInformation : false) {
      if (scope._anchor == null) {
        var tmp_0 = scope;
        var tmp_1;
        if (this._inserting) {
          tmp_1 = this._writer.anchor_0(this._writer._parent_1);
        } else {
          tmp_1 = this._reader.anchor_0(this._reader._parent_2);
        }
        tmp_0._anchor = tmp_1;
      }scope._defaultsInvalid = false;
      tmp = scope;
    } else {
      tmp = null;
    }
    var result = tmp;
    end(this, false);
    return result;
  };
  ComposerImpl.prototype.recompose = function (invalidationsRequested) {
    var tmp0_check_0 = this._changes.isEmpty_40();
    if (!tmp0_check_0) {
      var message_1 = 'Expected applyChanges() to have been called';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }if (invalidationsRequested.isNotEmpty_0()) {
      doCompose$composable(this, invalidationsRequested, null);
      var tmp1_isNotEmpty_0 = this._changes;
      return !tmp1_isNotEmpty_0.isEmpty_40();
    }return false;
  };
  ComposerImpl.prototype._get_recomposeScope__0 = function () {
    return this._get_currentRecomposeScope_();
  };
  ComposerImpl.prototype.rememberedValue_0 = function () {
    return this.nextSlot();
  };
  ComposerImpl.prototype.updateRememberedValue_0 = function (value_0) {
    return this.updateValue(value_0);
  };
  ComposerImpl.prototype.recordUsed_0 = function (scope) {
    var tmp0_safe_receiver = scope instanceof RecomposeScopeImpl ? scope : null;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._used = true;
  };
  ComposerImpl.prototype.composeContent$composable = function (invalidationsRequested, content) {
    var tmp0_check_0 = this._changes.isEmpty_40();
    if (!tmp0_check_0) {
      var message_1 = 'Expected applyChanges() to have been called';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }doCompose$composable(this, invalidationsRequested, content);
  };
  ComposerImpl.$metadata$ = {
    simpleName: 'ComposerImpl',
    kind: 'class',
    interfaces: [Composer]
  };
  function _no_name_provided__59() {
  }
  _no_name_provided__59.prototype.toString = function () {
    return 'Empty';
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_12() {
    Companion_instance_11 = this;
    var tmp = this;
    tmp._Empty = new _no_name_provided__59();
  }
  Companion_12.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_12();
    return Companion_instance_11;
  }
  function Composer() {
  }
  Composer.prototype.changed_3 = function (value_0) {
    return this.changed_3(value_0);
  };
  Composer.prototype.changed_4 = function (value_0) {
    return this.changed_4(value_0);
  };
  Composer.$metadata$ = {
    simpleName: 'Composer',
    kind: 'interface',
    interfaces: []
  };
  var InvalidationResult_IGNORED_instance;
  var InvalidationResult_SCHEDULED_instance;
  var InvalidationResult_DEFERRED_instance;
  var InvalidationResult_IMMINENT_instance;
  var InvalidationResult_entriesInitialized;
  function InvalidationResult_initEntries() {
    if (InvalidationResult_entriesInitialized)
      return Unit_getInstance();
    InvalidationResult_entriesInitialized = true;
    InvalidationResult_IGNORED_instance = new InvalidationResult('IGNORED', 0);
    InvalidationResult_SCHEDULED_instance = new InvalidationResult('SCHEDULED', 1);
    InvalidationResult_DEFERRED_instance = new InvalidationResult('DEFERRED', 2);
    InvalidationResult_IMMINENT_instance = new InvalidationResult('IMMINENT', 3);
  }
  function InvalidationResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  InvalidationResult.$metadata$ = {
    simpleName: 'InvalidationResult',
    kind: 'class',
    interfaces: []
  };
  function ScopeUpdateScope() {
  }
  ScopeUpdateScope.$metadata$ = {
    simpleName: 'ScopeUpdateScope',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided__60(this$0) {
    this._this$0_11 = this$0;
  }
  _no_name_provided__60.prototype.invoke_452 = function () {
    var tmp0_also_0 = multiMap();
    var inductionVariable = 0;
    var last = this._this$0_11._keyInfos._get_size__45();
    if (inductionVariable < last)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var keyInfo_4 = this._this$0_11._keyInfos.get_66(index_3);
        put(tmp0_also_0, _get_joinedKey_(keyInfo_4), keyInfo_4);
        Unit_getInstance();
      }
       while (inductionVariable < last);
    return tmp0_also_0;
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Pending(keyInfos, startIndex) {
    this._keyInfos = keyInfos;
    this._startIndex = startIndex;
    this._groupIndex = 0;
    var tmp0_require_0 = this._startIndex >= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Invalid start index';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp = this;
    tmp._usedKeys = ArrayList_init_$Create$();
    var tmp_0 = this;
    var runningNodeIndex_2 = 0;
    var result_3 = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = this._keyInfos._get_size__45();
    if (inductionVariable < last)
      do {
        var index_5 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var keyInfo_6 = this._keyInfos.get_66(index_5);
        var tmp0_set_0_7 = keyInfo_6._location_1;
        var tmp1_set_0_8 = new GroupInfo(index_5, runningNodeIndex_2, keyInfo_6._nodes);
        result_3.put_6(tmp0_set_0_7, tmp1_set_0_8);
        Unit_getInstance();
        runningNodeIndex_2 = runningNodeIndex_2 + keyInfo_6._nodes | 0;
      }
       while (inductionVariable < last);
    tmp_0._groupInfos = result_3;
    var tmp_1 = this;
    tmp_1._keyMap$delegate = lazy(_no_name_provided_$factory_54(this));
  }
  Pending.prototype._get_keyMap_ = function () {
    var tmp0_getValue_0 = this._keyMap$delegate;
    var tmp1_getValue_0 = keyMap$factory();
    return tmp0_getValue_0._get_value__13();
  };
  Pending.prototype.getNext = function (key_0, dataKey) {
    var joinedKey = !(dataKey == null) ? new JoinedKey(key_0, dataKey) : key_0;
    return pop(this._get_keyMap_(), joinedKey);
  };
  Pending.prototype.recordUsed_1 = function (keyInfo) {
    return this._usedKeys.add_37(keyInfo);
  };
  Pending.prototype._get_used_ = function () {
    return this._usedKeys;
  };
  Pending.prototype.registerMoveSlot = function (from, to_0) {
    if (from > to_0) {
      var tmp0_forEach_0 = this._groupInfos._get_values__1();
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        var position_4 = element_2._slotIndex;
        if (position_4 === from)
          element_2._slotIndex = to_0;
        else if (to_0 <= position_4 ? position_4 < from : false)
          element_2._slotIndex = position_4 + 1 | 0;
      }
    } else if (to_0 > from) {
      var tmp1_forEach_0 = this._groupInfos._get_values__1();
      var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_46();
      while (tmp0_iterator_1_0.hasNext_27()) {
        var element_2_0 = tmp0_iterator_1_0.next_28();
        var position_4_0 = element_2_0._slotIndex;
        if (position_4_0 === from)
          element_2_0._slotIndex = to_0;
        else if ((from + 1 | 0) <= position_4_0 ? position_4_0 < to_0 : false)
          element_2_0._slotIndex = position_4_0 - 1 | 0;
      }
    }};
  Pending.prototype.registerMoveNode = function (from, to_0, count) {
    if (from > to_0) {
      var tmp0_forEach_0 = this._groupInfos._get_values__1();
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        var position_4 = element_2._nodeIndex_0;
        if (from <= position_4 ? position_4 < (from + count | 0) : false)
          element_2._nodeIndex_0 = to_0 + (position_4 - from | 0) | 0;
        else if (to_0 <= position_4 ? position_4 < from : false)
          element_2._nodeIndex_0 = position_4 + count | 0;
      }
    } else if (to_0 > from) {
      var tmp1_forEach_0 = this._groupInfos._get_values__1();
      var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_46();
      while (tmp0_iterator_1_0.hasNext_27()) {
        var element_2_0 = tmp0_iterator_1_0.next_28();
        var position_4_0 = element_2_0._nodeIndex_0;
        if (from <= position_4_0 ? position_4_0 < (from + count | 0) : false)
          element_2_0._nodeIndex_0 = to_0 + (position_4_0 - from | 0) | 0;
        else if ((from + 1 | 0) <= position_4_0 ? position_4_0 < to_0 : false)
          element_2_0._nodeIndex_0 = position_4_0 - count | 0;
      }
    }};
  Pending.prototype.registerInsert = function (keyInfo, insertIndex) {
    var tmp0_set_0 = this._groupInfos;
    var tmp1_set_0 = keyInfo._location_1;
    var tmp2_set_0 = new GroupInfo(-1, insertIndex, 0);
    tmp0_set_0.put_6(tmp1_set_0, tmp2_set_0);
    Unit_getInstance();
  };
  Pending.prototype.updateNodeCount = function (group, newCount) {
    var groupInfo_0 = this._groupInfos.get_48(group);
    if (!(groupInfo_0 == null)) {
      var index = groupInfo_0._nodeIndex_0;
      var difference = newCount - groupInfo_0._nodeCount | 0;
      groupInfo_0._nodeCount = newCount;
      if (!(difference === 0)) {
        var tmp0_forEach_0 = this._groupInfos._get_values__1();
        var tmp0_iterator_1 = tmp0_forEach_0.iterator_46();
        while (tmp0_iterator_1.hasNext_27()) {
          var element_2 = tmp0_iterator_1.next_28();
          if (element_2._nodeIndex_0 >= index ? !equals(element_2, groupInfo_0) : false) {
            var tmp0_this_4 = element_2;
            tmp0_this_4._nodeIndex_0 = tmp0_this_4._nodeIndex_0 + difference | 0;
          }}
      }return true;
    }return false;
  };
  Pending.prototype.slotPositionOf = function (keyInfo) {
    var tmp0_safe_receiver = this._groupInfos.get_48(keyInfo._location_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._slotIndex;
    return tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
  };
  Pending.prototype.nodePositionOf = function (keyInfo) {
    var tmp0_safe_receiver = this._groupInfos.get_48(keyInfo._location_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._nodeIndex_0;
    return tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
  };
  Pending.prototype.updatedNodeCountOf = function (keyInfo) {
    var tmp0_safe_receiver = this._groupInfos.get_48(keyInfo._location_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._nodeCount;
    return tmp1_elvis_lhs == null ? keyInfo._nodes : tmp1_elvis_lhs;
  };
  Pending.$metadata$ = {
    simpleName: 'Pending',
    kind: 'class',
    interfaces: []
  };
  function Invalidation(scope, location) {
    this._scope = scope;
    this._location = location;
  }
  Invalidation.$metadata$ = {
    simpleName: 'Invalidation',
    kind: 'class',
    interfaces: []
  };
  function asInt(_this_) {
    return _this_ ? 1 : 0;
  }
  function contains_1(_this_, key_0) {
    return _this_.containsKey_7(key_0 instanceof CompositionLocal ? key_0 : THROW_CCE());
  }
  function getValueOf(_this_, key_0) {
    var tmp0_safe_receiver = _this_.get_48(key_0 instanceof CompositionLocal ? key_0 : THROW_CCE());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__13();
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  }
  function removeRange(_this_, start_0, end_0) {
    var tmp0_let_0 = findLocation(_this_, start_0);
    var index = tmp0_let_0 < 0 ? -(tmp0_let_0 + 1 | 0) | 0 : tmp0_let_0;
    $l$break: while (index < _this_._get_size__45()) {
      var validation = _this_.get_66(index);
      if (validation._location < end_0) {
        _this_.removeAt_7(index);
        Unit_getInstance();
      } else
        break $l$break;
    }
  }
  function firstInRange(_this_, start_0, end_0) {
    var tmp0_let_0 = findLocation(_this_, start_0);
    var index = tmp0_let_0 < 0 ? -(tmp0_let_0 + 1 | 0) | 0 : tmp0_let_0;
    if (index < _this_._get_size__45()) {
      var firstInvalidation = _this_.get_66(index);
      if (firstInvalidation._location < end_0)
        return firstInvalidation;
    }return null;
  }
  function removeLocation(_this_, location) {
    var index = findLocation(_this_, location);
    return index >= 0 ? _this_.removeAt_7(index) : null;
  }
  function nearestCommonRootOf(_this_, a, b, common) {
    if (a === b)
      return a;
    if (a === common ? true : b === common)
      return common;
    if (_this_.parent_1(a) === b)
      return b;
    if (_this_.parent_1(b) === a)
      return a;
    if (_this_.parent_1(a) === _this_.parent_1(b))
      return _this_.parent_1(a);
    var currentA = a;
    var currentB = b;
    var aDistance = distanceFrom(_this_, a, common);
    var bDistance = distanceFrom(_this_, b, common);
    var tmp0_repeat_0 = aDistance - bDistance | 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        currentA = _this_.parent_1(currentA);
      }
       while (inductionVariable < tmp0_repeat_0);
    var tmp1_repeat_0 = bDistance - aDistance | 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < tmp1_repeat_0)
      do {
        var index_2_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        currentB = _this_.parent_1(currentB);
      }
       while (inductionVariable_0 < tmp1_repeat_0);
    while (!(currentA === currentB)) {
      currentA = _this_.parent_1(currentA);
      currentB = _this_.parent_1(currentB);
    }
    return currentA;
  }
  function insertIfMissing(_this_, location, scope) {
    var index = findLocation(_this_, location);
    if (index < 0) {
      _this_.add_39(-(index + 1 | 0) | 0, new Invalidation(scope, location));
    }}
  function invokeComposable$composable(composer, composable) {
    var realFn = typeof composable === 'function' ? composable : THROW_CCE();
    realFn(composer, 1);
  }
  function GroupInfo(slotIndex_0, nodeIndex_1, nodeCount_0) {
    this._slotIndex = slotIndex_0;
    this._nodeIndex_0 = nodeIndex_1;
    this._nodeCount = nodeCount_0;
  }
  GroupInfo.$metadata$ = {
    simpleName: 'GroupInfo',
    kind: 'class',
    interfaces: []
  };
  function put(_this_, key_0, value_0) {
    var value_1 = _this_.get_48(key_0);
    var tmp;
    if (value_1 == null) {
      var answer_2 = LinkedHashSet_init_$Create$();
      _this_.put_6(key_0, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    return tmp.add_37(value_0);
  }
  function _get_joinedKey_(_this_) {
    return !(_this_._objectKey == null) ? new JoinedKey(_this_._key_3, _this_._objectKey) : _this_._key_3;
  }
  function multiMap() {
    return HashMap_init_$Create$();
  }
  function pop(_this_, key_0) {
    var tmp0_safe_receiver = _this_.get_48(key_0);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      remove_0(_this_, key_0, tmp1_safe_receiver);
      Unit_getInstance();
      tmp = tmp1_safe_receiver;
    }
    return tmp;
  }
  function findLocation(_this_, location) {
    var low = 0;
    var high = _this_._get_size__45() - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1;
      var midVal = _this_.get_66(mid);
      var cmp = compareTo(midVal._location, location);
      if (cmp < 0)
        low = mid + 1 | 0;
      else if (cmp > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function distanceFrom(_this_, index, root) {
    var count = 0;
    var current_0 = index;
    while (current_0 > 0 ? !(current_0 === root) : false) {
      current_0 = _this_.parent_1(current_0);
      var tmp0 = count;
      count = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    return count;
  }
  function remove_0(_this_, key_0, value_0) {
    var tmp0_safe_receiver = _this_.get_48(key_0);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver.remove_51(value_0);
      Unit_getInstance();
      if (tmp0_safe_receiver.isEmpty_40()) {
        _this_.remove_43(key_0);
        Unit_getInstance();
      }tmp = Unit_getInstance();
    }
    return tmp;
  }
  function _Updater___init__impl_(composer) {
    return composer;
  }
  function _Updater___get_composer__impl_(this_0) {
    return this_0;
  }
  function Updater__set_impl(this_0, value_0, block) {
    var tmp0_with_0 = _Updater___get_composer__impl_(this_0);
    var tmp;
    if (tmp0_with_0._get_inserting__0() ? true : !equals(tmp0_with_0.rememberedValue_0(), value_0)) {
      tmp0_with_0.updateRememberedValue_0(value_0);
      tmp = _Updater___get_composer__impl_(this_0).apply_0(value_0, block);
    }return tmp;
  }
  function _SkippableUpdater___init__impl_(composer) {
    return composer;
  }
  function _SkippableUpdater___get_composer__impl_(this_0) {
    return this_0;
  }
  function SkippableUpdater__toString_impl(this_0) {
    return '' + 'SkippableUpdater(composer=' + this_0 + ')';
  }
  function SkippableUpdater__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function SkippableUpdater__equals_impl(this_0, other) {
    if (!(other instanceof SkippableUpdater))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SkippableUpdater ? other._composer : THROW_CCE();
    if (!equals(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function SkippableUpdater(composer) {
    this._composer = composer;
  }
  SkippableUpdater.prototype.toString = function () {
    return SkippableUpdater__toString_impl(this._composer);
  };
  SkippableUpdater.prototype.hashCode = function () {
    return SkippableUpdater__hashCode_impl(this._composer);
  };
  SkippableUpdater.prototype.equals = function (other) {
    return SkippableUpdater__equals_impl(this._composer, other);
  };
  SkippableUpdater.$metadata$ = {
    simpleName: 'SkippableUpdater',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__61() {
  }
  _no_name_provided__61.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, rememberManager) {
    removeCurrentGroup(slots, rememberManager);
  };
  _no_name_provided__61.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__62() {
  }
  _no_name_provided__62.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, _anonymous_parameter_2_) {
    slots.endGroup_0();
    Unit_getInstance();
  };
  _no_name_provided__62.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__63() {
  }
  _no_name_provided__63.prototype.invoke_115 = function (_anonymous_parameter_0_, slots, _anonymous_parameter_2_) {
    slots.ensureStarted(0);
  };
  _no_name_provided__63.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, Applier) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof SlotWriter ? p2 : THROW_CCE();
    this.invoke_115(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, RememberManager) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function InvalidationResult_IGNORED_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_IGNORED_instance;
  }
  function InvalidationResult_SCHEDULED_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_SCHEDULED_instance;
  }
  function InvalidationResult_DEFERRED_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_DEFERRED_instance;
  }
  function InvalidationResult_IMMINENT_getInstance() {
    InvalidationResult_initEntries();
    return InvalidationResult_IMMINENT_instance;
  }
  function keyMap$factory() {
    return getPropertyCallableRef('keyMap', 1, KProperty1, function (receiver) {
      return receiver._get_keyMap_();
    }, null);
  }
  function _no_name_provided_$factory_33() {
    var i = new _no_name_provided__61();
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_34() {
    var i = new _no_name_provided__62();
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_35() {
    var i = new _no_name_provided__63();
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_36($factory, $groupAnchor, $insertIndex) {
    var i = new _no_name_provided__41($factory, $groupAnchor, $insertIndex);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_37($groupAnchor, $insertIndex) {
    var i = new _no_name_provided__42($groupAnchor, $insertIndex);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_38($block, $value) {
    var i = new _no_name_provided__43($block, $value);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_39($value) {
    var i = new _no_name_provided__44($value);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_40($value, this$0, $groupSlotIndex) {
    var i = new _no_name_provided__45($value, this$0, $groupSlotIndex);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_41($effect) {
    var i = new _no_name_provided__46($effect);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_42($data) {
    var i = new _no_name_provided__47($data);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_43($currentRelativePosition) {
    var i = new _no_name_provided__48($currentRelativePosition);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_44($tmp2_safe_receiver, this$0) {
    var i = new _no_name_provided__49($tmp2_safe_receiver, this$0);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_45($count) {
    var i = new _no_name_provided__50($count);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_46($nodes) {
    var i = new _no_name_provided__51($nodes);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_47($distance) {
    var i = new _no_name_provided__52($distance);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_48($insertTable, $anchor) {
    var i = new _no_name_provided__53($insertTable, $anchor);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_49($insertTable, $fixups, $anchor) {
    var i = new _no_name_provided__54($insertTable, $fixups, $anchor);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_50($anchor) {
    var i = new _no_name_provided__55($anchor);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_51($removeIndex, $count) {
    var i = new _no_name_provided__56($removeIndex, $count);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_52($from, $to, $count) {
    var i = new _no_name_provided__57($from, $to, $count);
    return function (p1, p2, p3) {
      i.invoke_115(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_53() {
    var i = new _no_name_provided__58();
    return function (p1, p2) {
      return i.invoke_108(p1, p2);
    };
  }
  function _no_name_provided_$factory_54(this$0) {
    var i = new _no_name_provided__60(this$0);
    return function () {
      return i.invoke_452();
    };
  }
  function removeCurrentGroupInstance$init$() {
    return _no_name_provided_$factory_33();
  }
  function endGroupInstance$init$() {
    return _no_name_provided_$factory_34();
  }
  function startRootGroup$init$() {
    return _no_name_provided_$factory_35();
  }
  var PendingApplyNoModifications;
  function CompositionImpl_init_$Init$(parent_0, applier, recomposeContext, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      recomposeContext = null;
    CompositionImpl.call($this, parent_0, applier, recomposeContext);
    return $this;
  }
  function CompositionImpl_init_$Create$(parent_0, applier, recomposeContext, $mask0, $marker) {
    return CompositionImpl_init_$Init$(parent_0, applier, recomposeContext, $mask0, $marker, Object.create(CompositionImpl.prototype));
  }
  function _get_areChildrenComposing_($this) {
    return $this._composer_0._get_areChildrenComposing_();
  }
  function drainPendingModificationsForCompositionLocked($this) {
    var toRecord = $this._pendingModifications.getAndSet(PendingApplyNoModifications);
    if (toRecord == null) {
    } else {
      if (equals(toRecord, PendingApplyNoModifications)) {
        var tmp0_error_0 = 'pending composition has not been applied';
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
      } else {
        if (!(toRecord == null) ? isInterface(toRecord, Set) : false) {
          addPendingInvalidationsLocked($this, (!(toRecord == null) ? isInterface(toRecord, Set) : false) ? toRecord : THROW_CCE());
        } else {
          if (!(toRecord == null) ? isArray(toRecord) : false) {
            var indexedObject = (!(toRecord == null) ? isArray(toRecord) : false) ? toRecord : THROW_CCE();
            var inductionVariable = 0;
            var last = indexedObject.length;
            while (inductionVariable < last) {
              var changed = indexedObject[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              addPendingInvalidationsLocked($this, changed);
            }
          } else {
            {
              var tmp1_error_0 = '' + 'corrupt pendingModifications drain: ' + $this._pendingModifications;
              throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
            }
          }
        }
      }
    }
  }
  function drainPendingModificationsLocked($this) {
    var toRecord = $this._pendingModifications.getAndSet(null);
    if (equals(toRecord, PendingApplyNoModifications)) {
    } else {
      if (!(toRecord == null) ? isInterface(toRecord, Set) : false) {
        addPendingInvalidationsLocked($this, (!(toRecord == null) ? isInterface(toRecord, Set) : false) ? toRecord : THROW_CCE());
      } else {
        if (!(toRecord == null) ? isArray(toRecord) : false) {
          var indexedObject = (!(toRecord == null) ? isArray(toRecord) : false) ? toRecord : THROW_CCE();
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var changed = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            addPendingInvalidationsLocked($this, changed);
          }
        } else {
          if (toRecord == null) {
            var tmp0_error_0 = 'calling recordModificationsOf and applyChanges concurrently is not supported';
            throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
          } else {
            {
              var tmp1_error_0 = '' + 'corrupt pendingModifications drain: ' + $this._pendingModifications;
              throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
            }
          }
        }
      }
    }
  }
  function addPendingInvalidationsLocked($this, values) {
    var invalidated = null;
    var tmp0_iterator = values.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var value_0 = tmp0_iterator.next_28();
      if (value_0 instanceof RecomposeScopeImpl) {
        value_0.invalidateForResult();
        Unit_getInstance();
      } else {
        {
          var tmp1_forEachScopeOf_0 = $this._observations;
          var index_1 = find_1(tmp1_forEachScopeOf_0, value_0);
          if (index_1 >= 0) {
            var tmp0_forEach_0 = scopeSetAt(tmp1_forEachScopeOf_0, index_1);
            var inductionVariable = 0;
            var last = tmp0_forEach_0._size_4;
            if (inductionVariable < last)
              do {
                var i_3 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp2__anonymous__2 = tmp0_forEach_0.get_66(i_3);
                if (!$this._observationsProcessed.remove_49(value_0, tmp2__anonymous__2) ? !tmp2__anonymous__2.invalidateForResult().equals(InvalidationResult_IGNORED_getInstance()) : false) {
                  var tmp0_elvis_lhs_3 = invalidated;
                  var tmp;
                  if (tmp0_elvis_lhs_3 == null) {
                    var tmp0_also_0_4 = HashSet_init_$Create$();
                    invalidated = tmp0_also_0_4;
                    tmp = tmp0_also_0_4;
                  } else {
                    tmp = tmp0_elvis_lhs_3;
                  }
                  tmp.add_37(tmp2__anonymous__2);
                  Unit_getInstance();
                }}
               while (inductionVariable < last);
          }}
      }
    }
    var tmp1_safe_receiver = invalidated;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp0_removeValueIf_0_2 = $this._observations;
      var destinationIndex_1_3 = 0;
      var inductionVariable_0 = 0;
      var last_0 = tmp0_removeValueIf_0_2._size_5;
      if (inductionVariable_0 < last_0)
        do {
          var i_3_5 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var valueIndex_4_6 = tmp0_removeValueIf_0_2._valueOrder[i_3_5];
          var set_5_7 = ensureNotNull(tmp0_removeValueIf_0_2._scopeSets[valueIndex_4_6]);
          var destinationIndex_1_8 = 0;
          var inductionVariable_1 = 0;
          var last_1 = set_5_7._size_4;
          if (inductionVariable_1 < last_1)
            do {
              var i_3_10 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var tmp_0 = set_5_7._values_1[i_3_10];
              var item_4_11 = isObject(tmp_0) ? tmp_0 : THROW_CCE();
              if (!tmp1_safe_receiver.contains_37(item_4_11)) {
                if (!(destinationIndex_1_8 === i_3_10)) {
                  set_5_7._values_1[destinationIndex_1_8] = item_4_11;
                }var tmp1_5_12 = destinationIndex_1_8;
                destinationIndex_1_8 = tmp1_5_12 + 1 | 0;
                Unit_getInstance();
              } else {
              }
            }
             while (inductionVariable_1 < last_1);
          var inductionVariable_2 = destinationIndex_1_8;
          var last_2 = set_5_7._size_4;
          if (inductionVariable_2 < last_2)
            do {
              var i_7_14 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              set_5_7._values_1[i_7_14] = null;
            }
             while (inductionVariable_2 < last_2);
          set_5_7._size_4 = destinationIndex_1_8;
          if (set_5_7._size_4 > 0) {
            if (!(destinationIndex_1_3 === i_3_5)) {
              var destinationKeyOrder_6_15 = tmp0_removeValueIf_0_2._valueOrder[destinationIndex_1_3];
              tmp0_removeValueIf_0_2._valueOrder[destinationIndex_1_3] = valueIndex_4_6;
              tmp0_removeValueIf_0_2._valueOrder[i_3_5] = destinationKeyOrder_6_15;
            }var tmp1_7_16 = destinationIndex_1_3;
            destinationIndex_1_3 = tmp1_7_16 + 1 | 0;
            Unit_getInstance();
          }}
         while (inductionVariable_0 < last_0);
      var inductionVariable_3 = destinationIndex_1_3;
      var last_3 = tmp0_removeValueIf_0_2._size_5;
      if (inductionVariable_3 < last_3)
        do {
          var i_9_18 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          tmp0_removeValueIf_0_2._values_2[tmp0_removeValueIf_0_2._valueOrder[i_9_18]] = null;
        }
         while (inductionVariable_3 < last_3);
      tmp0_removeValueIf_0_2._size_5 = destinationIndex_1_3;
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function takeInvalidations($this) {
    var tmp0_also_0 = $this._invalidations_0;
    $this._invalidations_0 = new IdentityArraySet();
    return tmp0_also_0;
  }
  function RememberEventDispatcher(abandoning) {
    this._abandoning = abandoning;
    var tmp = this;
    tmp._remembering = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._forgetting = ArrayList_init_$Create$();
    var tmp_1 = this;
    tmp_1._sideEffects = ArrayList_init_$Create$();
  }
  RememberEventDispatcher.prototype.remembering_0 = function (instance) {
    var tmp0_let_0 = this._forgetting.lastIndexOf_9(instance);
    if (tmp0_let_0 >= 0) {
      this._forgetting.removeAt_7(tmp0_let_0);
      Unit_getInstance();
      this._abandoning.remove_51(instance);
    } else {
      this._remembering.add_37(instance);
    }
    Unit_getInstance();
  };
  RememberEventDispatcher.prototype.forgetting_0 = function (instance) {
    var tmp0_let_0 = this._remembering.lastIndexOf_9(instance);
    if (tmp0_let_0 >= 0) {
      this._remembering.removeAt_7(tmp0_let_0);
      Unit_getInstance();
      this._abandoning.remove_51(instance);
    } else {
      this._forgetting.add_37(instance);
    }
    Unit_getInstance();
  };
  RememberEventDispatcher.prototype.sideEffect_0 = function (effect) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._sideEffects;
    tmp0_plusAssign_0.add_37(effect);
    Unit_getInstance();
  };
  RememberEventDispatcher.prototype.dispatchRememberObservers = function () {
    var tmp0_isNotEmpty_0 = this._forgetting;
    if (!tmp0_isNotEmpty_0.isEmpty_40()) {
      var inductionVariable = this._forgetting._get_size__45() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var instance = this._forgetting.get_66(i);
          if (!this._abandoning.contains_37(instance)) {
            instance.onForgotten_2();
          }}
         while (0 <= inductionVariable);
    } else {
    }
    var tmp1_isNotEmpty_0 = this._remembering;
    if (!tmp1_isNotEmpty_0.isEmpty_40()) {
      var tmp2_fastForEach_0 = this._remembering;
      var inductionVariable_0 = 0;
      var last = tmp2_fastForEach_0._get_size__45() - 1 | 0;
      if (inductionVariable_0 <= last)
        do {
          var index_3 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_4 = tmp2_fastForEach_0.get_66(index_3);
          this._abandoning.remove_51(item_4);
          Unit_getInstance();
          item_4.onRemembered_2();
        }
         while (inductionVariable_0 <= last);
    } else {
    }
  };
  RememberEventDispatcher.prototype.dispatchSideEffects = function () {
    var tmp0_isNotEmpty_0 = this._sideEffects;
    if (!tmp0_isNotEmpty_0.isEmpty_40()) {
      var tmp1_fastForEach_0 = this._sideEffects;
      var inductionVariable = 0;
      var last = tmp1_fastForEach_0._get_size__45() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item_4 = tmp1_fastForEach_0.get_66(index_3);
          item_4();
        }
         while (inductionVariable <= last);
      this._sideEffects.clear_7();
    } else {
    }
  };
  RememberEventDispatcher.prototype.dispatchAbandons = function () {
    var tmp0_isNotEmpty_0 = this._abandoning;
    if (!tmp0_isNotEmpty_0.isEmpty_40()) {
      var iterator_0 = this._abandoning.iterator_46();
      while (iterator_0.hasNext_27()) {
        var instance = iterator_0.next_28();
        iterator_0.remove_52();
        instance.onAbandoned_2();
      }
    } else {
    }
  };
  RememberEventDispatcher.$metadata$ = {
    simpleName: 'RememberEventDispatcher',
    kind: 'class',
    interfaces: [RememberManager]
  };
  function CompositionImpl(parent_0, applier, recomposeContext) {
    this._parent_0 = parent_0;
    this._applier_0 = applier;
    this._pendingModifications = new AtomicReference(null);
    this._lock_0 = new Object();
    this._abandonSet_0 = HashSet_init_$Create$();
    this._slotTable_0 = new SlotTable();
    this._observations = new IdentityScopeMap();
    var tmp = this;
    tmp._changes_0 = ArrayList_init_$Create$();
    this._observationsProcessed = new IdentityScopeMap();
    this._invalidations_0 = new IdentityArraySet();
    this._pendingInvalidScopes_0 = false;
    var tmp_0 = this;
    var tmp0_also_0 = new ComposerImpl(this._applier_0, this._parent_0, this._slotTable_0, this._abandonSet_0, this._changes_0, this);
    this._parent_0.registerComposer_0(tmp0_also_0);
    tmp_0._composer_0 = tmp0_also_0;
    this.__recomposeContext = recomposeContext;
    var tmp_1 = this;
    var tmp_2 = this._parent_0;
    tmp_1._isRoot = tmp_2 instanceof Recomposer;
    this._disposed = false;
    this._composable = ComposableSingletons$CompositionKt_getInstance()._lambda_1;
  }
  CompositionImpl.prototype._get_isComposing__0 = function () {
    return this._composer_0._isComposing;
  };
  CompositionImpl.prototype._get_isDisposed__0 = function () {
    return this._disposed;
  };
  CompositionImpl.prototype.recordModificationsOf_0 = function (values) {
    $l$break: while (true) {
      var old = this._pendingModifications.get_55();
      var tmp0_subject = old;
      var tmp;
      if (tmp0_subject == null ? true : equals(tmp0_subject, PendingApplyNoModifications)) {
        tmp = values;
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Set) : false) {
          var tmp0_arrayOf_0 = [old, values];
          tmp = tmp0_arrayOf_0;
        } else {
          if (!(tmp0_subject == null) ? isArray(tmp0_subject) : false) {
            tmp = plus_0((!(old == null) ? isArray(old) : false) ? old : THROW_CCE(), values);
          } else {
            {
              var tmp1_error_0 = '' + 'corrupt pendingModifications: ' + this._pendingModifications;
              throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
            }
          }
        }
      }
      var new_0 = tmp;
      if (this._pendingModifications.compareAndSet_1(old, new_0)) {
        if (old == null) {
          var tmp2_synchronized_0 = this._lock_0;
          drainPendingModificationsLocked(this);
        }break $l$break;
      }}
  };
  CompositionImpl.prototype.recordReadOf_0 = function (value_0) {
    if (!_get_areChildrenComposing_(this)) {
      var tmp0_safe_receiver = this._composer_0._get_currentRecomposeScope_();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver._used = true;
        this._observations.add_35(value_0, tmp0_safe_receiver);
        Unit_getInstance();
        tmp0_safe_receiver.recordRead(value_0);
        Unit_getInstance();
      }
      Unit_getInstance();
    }};
  CompositionImpl.prototype.recordWriteOf_0 = function (value_0) {
    var tmp0_synchronized_0 = this._lock_0;
    var tmp1_forEachScopeOf_0_2 = this._observations;
    var index_1_3 = find_1(tmp1_forEachScopeOf_0_2, value_0);
    var tmp;
    if (index_1_3 >= 0) {
      var tmp0_forEach_0_4 = scopeSetAt(tmp1_forEachScopeOf_0_2, index_1_3);
      var inductionVariable = 0;
      var last = tmp0_forEach_0_4._size_4;
      var tmp_0;
      if (inductionVariable < last) {
        do {
          var i_3_6 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp2__anonymous__2_7 = tmp0_forEach_0_4.get_66(i_3_6);
          if (tmp2__anonymous__2_7.invalidateForResult().equals(InvalidationResult_IMMINENT_getInstance())) {
            this._observationsProcessed.add_35(value_0, tmp2__anonymous__2_7);
            Unit_getInstance();
          }}
         while (inductionVariable < last);
        tmp_0 = Unit_getInstance();
      }tmp = tmp_0;
    }return tmp;
  };
  CompositionImpl.prototype.recompose_1 = function () {
    var tmp0_synchronized_0 = this._lock_0;
    drainPendingModificationsForCompositionLocked(this);
    var tmp0_also_0_2 = this._composer_0.recompose(takeInvalidations(this));
    if (!tmp0_also_0_2)
      drainPendingModificationsLocked(this);
    return tmp0_also_0_2;
  };
  CompositionImpl.prototype.applyChanges_0 = function () {
    var tmp0_synchronized_0 = this._lock_0;
    var manager_2 = new RememberEventDispatcher(this._abandonSet_0);
    try {
      this._applier_0.onBeginChanges_1();
      var tmp1_write_0_3 = this._slotTable_0;
      var tmp0_let_0_4 = tmp1_write_0_3.openWriter();
      try {
        var applier_3_5 = this._applier_0;
        var tmp0_fastForEach_0_4_6 = this._changes_0;
        var inductionVariable = 0;
        var last = tmp0_fastForEach_0_4_6._get_size__45() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index_3_6_8 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item_4_7_9 = tmp0_fastForEach_0_4_6.get_66(index_3_6_8);
            item_4_7_9(applier_3_5, tmp0_let_0_4, manager_2);
          }
           while (inductionVariable <= last);
        this._changes_0.clear_7();
      }finally {
        tmp0_let_0_4.close_7();
      }
      this._applier_0.onEndChanges_1();
      manager_2.dispatchRememberObservers();
      manager_2.dispatchSideEffects();
      if (this._pendingInvalidScopes_0) {
        this._pendingInvalidScopes_0 = false;
        var tmp2_removeValueIf_0_10 = this._observations;
        var destinationIndex_1_11 = 0;
        var inductionVariable_0 = 0;
        var last_0 = tmp2_removeValueIf_0_10._size_5;
        if (inductionVariable_0 < last_0)
          do {
            var i_3_13 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var valueIndex_4_14 = tmp2_removeValueIf_0_10._valueOrder[i_3_13];
            var set_5_15 = ensureNotNull(tmp2_removeValueIf_0_10._scopeSets[valueIndex_4_14]);
            var destinationIndex_1_16 = 0;
            var inductionVariable_1 = 0;
            var last_1 = set_5_15._size_4;
            if (inductionVariable_1 < last_1)
              do {
                var i_3_18 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var tmp = set_5_15._values_1[i_3_18];
                var item_4_19 = isObject(tmp) ? tmp : THROW_CCE();
                if (!!item_4_19._get_valid__0()) {
                  if (!(destinationIndex_1_16 === i_3_18)) {
                    set_5_15._values_1[destinationIndex_1_16] = item_4_19;
                  }var tmp1_5_20 = destinationIndex_1_16;
                  destinationIndex_1_16 = tmp1_5_20 + 1 | 0;
                  Unit_getInstance();
                } else {
                }
              }
               while (inductionVariable_1 < last_1);
            var inductionVariable_2 = destinationIndex_1_16;
            var last_2 = set_5_15._size_4;
            if (inductionVariable_2 < last_2)
              do {
                var i_7_22 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                set_5_15._values_1[i_7_22] = null;
              }
               while (inductionVariable_2 < last_2);
            set_5_15._size_4 = destinationIndex_1_16;
            if (set_5_15._size_4 > 0) {
              if (!(destinationIndex_1_11 === i_3_13)) {
                var destinationKeyOrder_6_23 = tmp2_removeValueIf_0_10._valueOrder[destinationIndex_1_11];
                tmp2_removeValueIf_0_10._valueOrder[destinationIndex_1_11] = valueIndex_4_14;
                tmp2_removeValueIf_0_10._valueOrder[i_3_13] = destinationKeyOrder_6_23;
              }var tmp1_7_24 = destinationIndex_1_11;
              destinationIndex_1_11 = tmp1_7_24 + 1 | 0;
              Unit_getInstance();
            }}
           while (inductionVariable_0 < last_0);
        var inductionVariable_3 = destinationIndex_1_11;
        var last_3 = tmp2_removeValueIf_0_10._size_5;
        if (inductionVariable_3 < last_3)
          do {
            var i_9_26 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            tmp2_removeValueIf_0_10._values_2[tmp2_removeValueIf_0_10._valueOrder[i_9_26]] = null;
          }
           while (inductionVariable_3 < last_3);
        tmp2_removeValueIf_0_10._size_5 = destinationIndex_1_11;
      }}finally {
      manager_2.dispatchAbandons();
    }
    drainPendingModificationsLocked(this);
  };
  CompositionImpl.prototype.invalidateAll_0 = function () {
    var tmp0_synchronized_0 = this._lock_0;
    var tmp0_forEach_0_2 = this._slotTable_0._slots_1;
    var indexedObject = tmp0_forEach_0_2;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_safe_receiver_4_5 = element_2_4 instanceof RecomposeScopeImpl ? element_2_4 : null;
      if (tmp0_safe_receiver_4_5 == null)
        null;
      else {
        tmp0_safe_receiver_4_5.invalidate_2();
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  CompositionImpl.prototype.invalidate = function (scope) {
    if (scope._defaultsInScope) {
      scope._defaultsInvalid = true;
    }var anchor = scope._anchor;
    if ((anchor == null ? true : !this._slotTable_0.ownsAnchor(anchor)) ? true : !anchor._get_valid__0())
      return InvalidationResult_IGNORED_getInstance();
    var location = anchor.toIndexFor(this._slotTable_0);
    if (location < 0)
      return InvalidationResult_IGNORED_getInstance();
    if (this._get_isComposing__0() ? this._composer_0.tryImminentInvalidation(scope) : false) {
      return InvalidationResult_IMMINENT_getInstance();
    }this._invalidations_0.add_36(scope);
    Unit_getInstance();
    this._parent_0.invalidate_3(this);
    return this._get_isComposing__0() ? InvalidationResult_DEFERRED_getInstance() : InvalidationResult_SCHEDULED_getInstance();
  };
  CompositionImpl.prototype.removeObservation = function (instance, scope) {
    this._observations.remove_49(instance, scope);
    Unit_getInstance();
  };
  CompositionImpl.prototype.$set_composable$$composable = function (set__$) {
    this._composable = set__$;
  };
  CompositionImpl.prototype.setContent$composable_0 = function (content) {
    var tmp0_check_0 = !this._disposed;
    if (!tmp0_check_0) {
      var message_1 = 'The composition is disposed';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }this.$set_composable$$composable(content);
    this._parent_0.composeInitial$composable_0(this, this._composable);
  };
  CompositionImpl.prototype.composeContent$composable_1 = function (content) {
    var tmp0_synchronized_0 = this._lock_0;
    drainPendingModificationsForCompositionLocked(this);
    this._composer_0.composeContent$composable(takeInvalidations(this), content);
  };
  CompositionImpl.$metadata$ = {
    simpleName: 'CompositionImpl',
    kind: 'class',
    interfaces: [ControlledComposition]
  };
  function ControlledComposition() {
  }
  ControlledComposition.$metadata$ = {
    simpleName: 'ControlledComposition',
    kind: 'interface',
    interfaces: [Composition]
  };
  function _no_name_provided__64($boundThis) {
    this._$boundThis = $boundThis;
  }
  _no_name_provided__64.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis.invoke_437(p0, p1);
  };
  _no_name_provided__64.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__64.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__65() {
  }
  _no_name_provided__65.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__65.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__65.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__66($boundThis) {
    this._$boundThis_0 = $boundThis;
  }
  _no_name_provided__66.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_0.invoke_437(p0, p1);
  };
  _no_name_provided__66.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__66.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__67() {
  }
  _no_name_provided__67.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__67.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__67.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ComposableSingletons$CompositionKt() {
    ComposableSingletons$CompositionKt_instance = this;
    var tmp = this;
    tmp._lambda_1 = _no_name_provided_$factory_56(composableLambdaInstance(-985543719, false, 'C:', _no_name_provided_$factory_55()));
    var tmp_0 = this;
    tmp_0._lambda_2 = _no_name_provided_$factory_58(composableLambdaInstance(-985549368, false, 'C:Composition.kt#9igjgp', _no_name_provided_$factory_57()));
  }
  ComposableSingletons$CompositionKt.$metadata$ = {
    simpleName: 'ComposableSingletons$CompositionKt',
    kind: 'object',
    interfaces: []
  };
  var ComposableSingletons$CompositionKt_instance;
  function ComposableSingletons$CompositionKt_getInstance() {
    if (ComposableSingletons$CompositionKt_instance == null)
      new ComposableSingletons$CompositionKt();
    return ComposableSingletons$CompositionKt_instance;
  }
  function Composition() {
  }
  Composition.$metadata$ = {
    simpleName: 'Composition',
    kind: 'interface',
    interfaces: []
  };
  function ControlledComposition_0(applier, parent_0) {
    return CompositionImpl_init_$Create$(parent_0, applier, null, 4, null);
  }
  function _no_name_provided_$factory_55() {
    var i = new _no_name_provided__65();
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_56($boundThis) {
    var i = new _no_name_provided__64($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_57() {
    var i = new _no_name_provided__67();
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_58($boundThis) {
    var i = new _no_name_provided__66($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  var EmptyCompositionLocalMap;
  function CompositionContext() {
    this._$stable_1 = 0;
  }
  CompositionContext.prototype.recordInspectionTable_0 = function (table) {
  };
  CompositionContext.prototype.registerComposer_0 = function (composer) {
  };
  CompositionContext.prototype.getCompositionLocalScope_0 = function () {
    return EmptyCompositionLocalMap;
  };
  CompositionContext.prototype.startComposing_0 = function () {
  };
  CompositionContext.prototype.doneComposing_0 = function () {
  };
  CompositionContext.$metadata$ = {
    simpleName: 'CompositionContext',
    kind: 'class',
    interfaces: []
  };
  function CompositionLocal(defaultFactory) {
    this._defaultValueHolder = new LazyValueHolder(defaultFactory);
  }
  CompositionLocal.$metadata$ = {
    simpleName: 'CompositionLocal',
    kind: 'class',
    interfaces: []
  };
  function ProvidableCompositionLocal(defaultFactory) {
    CompositionLocal.call(this, defaultFactory);
  }
  ProvidableCompositionLocal.$metadata$ = {
    simpleName: 'ProvidableCompositionLocal',
    kind: 'class',
    interfaces: []
  };
  function staticCompositionLocalOf(defaultFactory) {
    return new StaticProvidableCompositionLocal(defaultFactory);
  }
  function StaticProvidableCompositionLocal(defaultFactory) {
    ProvidableCompositionLocal.call(this, defaultFactory);
  }
  StaticProvidableCompositionLocal.$metadata$ = {
    simpleName: 'StaticProvidableCompositionLocal',
    kind: 'class',
    interfaces: []
  };
  var InternalDisposableEffectScope;
  function DisposableEffectScope() {
    this._$stable_2 = 0;
  }
  DisposableEffectScope.$metadata$ = {
    simpleName: 'DisposableEffectScope',
    kind: 'class',
    interfaces: []
  };
  function DisposableEffectResult() {
  }
  DisposableEffectResult.$metadata$ = {
    simpleName: 'DisposableEffectResult',
    kind: 'interface',
    interfaces: []
  };
  function LaunchedEffect$composable(key1, block, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.startReplaceableGroup_2(1763073192, 'C(LaunchedEffect$composable)P(1)336@14101L58:Effects.kt#9igjgp');
    var applyContext = $composer_0._get_applyCoroutineContext__0();
    var tmp0_remember$composable_0 = $composer_0;
    var tmp1_remember$composable_0 = 14 & $changed;
    var $composer_1 = tmp0_remember$composable_0;
    $composer_1.startReplaceableGroup_2(884179945, 'C(remember$composable)P(1):Composables.kt#9igjgp');
    var tmp1_cache_0_3 = $composer_1;
    var tmp2_cache_0_4 = $composer_1.changed_2(key1);
    var tmp0_let_0_5 = tmp1_cache_0_3.rememberedValue_0();
    var tmp;
    if (tmp2_cache_0_4 ? true : tmp0_let_0_5 === Companion_getInstance_11()._Empty) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_return_8 = new LaunchedEffectImpl(applyContext, block);
        tmp$ret$0 = tmp0_return_8;
        break l$ret$1;
      }
       while (false);
      var value_2_2_6 = tmp$ret$0;
      tmp1_cache_0_3.updateRememberedValue_0(value_2_2_6);
      tmp = value_2_2_6;
    } else {
      tmp = tmp0_let_0_5;
    }
    var tmp_0 = tmp;
    var tmp0_2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    $composer_1.endReplaceableGroup_0();
    Unit_getInstance();
    $composer_0.endReplaceableGroup_0();
  }
  function LaunchedEffectImpl(parentCoroutineContext, task) {
    this._task = task;
    this._scope_0 = CoroutineScope_0(parentCoroutineContext);
    this._job_1 = null;
  }
  LaunchedEffectImpl.prototype.onRemembered_2 = function () {
    var tmp0_safe_receiver = this._job_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel$default(tmp0_safe_receiver, 'Old job was still running!', null, 2, null);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp = this;
    tmp._job_1 = launch$default(this._scope_0, null, null, this._task, 3, null);
  };
  LaunchedEffectImpl.prototype.onForgotten_2 = function () {
    var tmp0_safe_receiver = this._job_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_10(null, 1, null);
      Unit_getInstance();
    }
    Unit_getInstance();
    this._job_1 = null;
  };
  LaunchedEffectImpl.prototype.onAbandoned_2 = function () {
    var tmp0_safe_receiver = this._job_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_10(null, 1, null);
      Unit_getInstance();
    }
    Unit_getInstance();
    this._job_1 = null;
  };
  LaunchedEffectImpl.$metadata$ = {
    simpleName: 'LaunchedEffectImpl',
    kind: 'class',
    interfaces: [RememberObserver]
  };
  function DisposableEffect$composable(key1, effect, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.startReplaceableGroup_2(1867059813, 'C(DisposableEffect$composable)P(1)154@6171L47:Effects.kt#9igjgp');
    var tmp0_remember$composable_0 = $composer_0;
    var tmp1_remember$composable_0 = 14 & $changed;
    var $composer_1 = tmp0_remember$composable_0;
    $composer_1.startReplaceableGroup_2(884179945, 'C(remember$composable)P(1):Composables.kt#9igjgp');
    var tmp1_cache_0_3 = $composer_1;
    var tmp2_cache_0_4 = $composer_1.changed_2(key1);
    var tmp0_let_0_5 = tmp1_cache_0_3.rememberedValue_0();
    var tmp;
    if (tmp2_cache_0_4 ? true : tmp0_let_0_5 === Companion_getInstance_11()._Empty) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_return_8 = new DisposableEffectImpl(effect);
        tmp$ret$0 = tmp0_return_8;
        break l$ret$1;
      }
       while (false);
      var value_2_2_6 = tmp$ret$0;
      tmp1_cache_0_3.updateRememberedValue_0(value_2_2_6);
      tmp = value_2_2_6;
    } else {
      tmp = tmp0_let_0_5;
    }
    var tmp_0 = tmp;
    var tmp0_2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    $composer_1.endReplaceableGroup_0();
    Unit_getInstance();
    $composer_0.endReplaceableGroup_0();
  }
  function SideEffect$composable(effect, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.startReplaceableGroup_2(2104625033, 'C(SideEffect$composable):Effects.kt#9igjgp');
    $composer_0.recordSideEffect_0(effect);
    $composer_0.endReplaceableGroup_0();
  }
  function DisposableEffectImpl(effect) {
    this._effect = effect;
    this._onDispose = null;
  }
  DisposableEffectImpl.prototype.onRemembered_2 = function () {
    this._onDispose = this._effect(InternalDisposableEffectScope);
  };
  DisposableEffectImpl.prototype.onForgotten_2 = function () {
    var tmp0_safe_receiver = this._onDispose;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_20();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._onDispose = null;
  };
  DisposableEffectImpl.prototype.onAbandoned_2 = function () {
  };
  DisposableEffectImpl.$metadata$ = {
    simpleName: 'DisposableEffectImpl',
    kind: 'class',
    interfaces: [RememberObserver]
  };
  function JoinedKey(left_1, right) {
    this._left_0 = left_1;
    this._right = right;
  }
  JoinedKey.prototype.toString = function () {
    return '' + 'JoinedKey(left=' + this._left_0 + ', right=' + this._right + ')';
  };
  JoinedKey.prototype.hashCode = function () {
    var result = this._left_0 == null ? 0 : hashCode(this._left_0);
    result = imul(result, 31) + (this._right == null ? 0 : hashCode(this._right)) | 0;
    return result;
  };
  JoinedKey.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JoinedKey))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof JoinedKey ? other : THROW_CCE();
    if (!equals(this._left_0, tmp0_other_with_cast._left_0))
      return false;
    if (!equals(this._right, tmp0_other_with_cast._right))
      return false;
    return true;
  };
  JoinedKey.$metadata$ = {
    simpleName: 'JoinedKey',
    kind: 'class',
    interfaces: []
  };
  function Key_5() {
    Key_instance_4 = this;
  }
  Key_5.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_4;
  function Key_getInstance_4() {
    if (Key_instance_4 == null)
      new Key_5();
    return Key_instance_4;
  }
  function MonotonicFrameClock() {
  }
  MonotonicFrameClock.prototype._get_key__28 = function () {
    return Key_getInstance_4();
  };
  MonotonicFrameClock.$metadata$ = {
    simpleName: 'MonotonicFrameClock',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function _get_monotonicFrameClock_(_this_) {
    var tmp0_elvis_lhs = _this_.get_56(Key_getInstance_4());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = 'A MonotonicFrameClock is not available in this CoroutineContext. Callers should supply an appropriate MonotonicFrameClock using withContext.';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function withFrameNanos(onFrame, $cont) {
    return _get_monotonicFrameClock_($cont._get_context__22()).withFrameNanos_1(onFrame, $cont);
  }
  function OpaqueKey(key_0) {
    this._key_2 = key_0;
  }
  OpaqueKey.prototype.toString = function () {
    return '' + 'OpaqueKey(key=' + this._key_2 + ')';
  };
  OpaqueKey.prototype.hashCode = function () {
    return getStringHashCode(this._key_2);
  };
  OpaqueKey.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OpaqueKey))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof OpaqueKey ? other : THROW_CCE();
    if (!(this._key_2 === tmp0_other_with_cast._key_2))
      return false;
    return true;
  };
  OpaqueKey.$metadata$ = {
    simpleName: 'OpaqueKey',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__68(this$0, $token, $tmp0_safe_receiver) {
    this._this$0_12 = this$0;
    this._$token = $token;
    this._$tmp0_safe_receiver = $tmp0_safe_receiver;
  }
  _no_name_provided__68.prototype.invoke_125 = function (composition) {
    var tmp;
    if (this._this$0_12._currentToken === this._$token ? equals(this._$tmp0_safe_receiver, this._this$0_12._trackedInstances) : false) {
      tmp = composition instanceof CompositionImpl;
    } else {
      tmp = false;
    }
    if (tmp) {
      var destinationIndex_1_7 = 0;
      var inductionVariable = 0;
      var last = this._$tmp0_safe_receiver._size_3;
      if (inductionVariable < last)
        do {
          var i_3_9 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp_0 = this._$tmp0_safe_receiver._keys_0[i_3_9];
          var key_4_10 = isObject(tmp_0) ? tmp_0 : THROW_CCE();
          var value_5_11 = this._$tmp0_safe_receiver._values_0[i_3_9];
          var tmp0_also_0_10_12 = !(value_5_11 === this._$token);
          if (tmp0_also_0_10_12)
            composition.removeObservation(key_4_10, this._this$0_12);
          if (!tmp0_also_0_10_12) {
            if (!(destinationIndex_1_7 === i_3_9)) {
              this._$tmp0_safe_receiver._keys_0[destinationIndex_1_7] = key_4_10;
              this._$tmp0_safe_receiver._values_0[destinationIndex_1_7] = value_5_11;
            }var tmp1_6_13 = destinationIndex_1_7;
            destinationIndex_1_7 = tmp1_6_13 + 1 | 0;
            Unit_getInstance();
          } else {
          }
        }
         while (inductionVariable < last);
      var inductionVariable_0 = destinationIndex_1_7;
      var last_0 = this._$tmp0_safe_receiver._size_3;
      if (inductionVariable_0 < last_0)
        do {
          var i_8_15 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this._$tmp0_safe_receiver._keys_0[i_8_15] = null;
        }
         while (inductionVariable_0 < last_0);
      this._$tmp0_safe_receiver._size_3 = destinationIndex_1_7;
      if (this._$tmp0_safe_receiver._size_3 === 0)
        this._this$0_12._trackedInstances = null;
    } else {
    }
  };
  _no_name_provided__68.prototype.invoke_468 = function (p1) {
    this.invoke_125((!(p1 == null) ? isInterface(p1, Composition) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__68.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RecomposeScopeImpl(composition) {
    this._composition_0 = composition;
    this._anchor = null;
    this._used = false;
    this._defaultsInScope = false;
    this._defaultsInvalid = false;
    this._requiresRecompose = false;
    this._block = null;
    this._currentToken = 0;
    this._trackedInstances = null;
  }
  RecomposeScopeImpl.prototype._get_valid__0 = function () {
    var tmp;
    if (!(this._composition_0 == null)) {
      var tmp0_safe_receiver = this._anchor;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_valid__0();
      tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    } else {
      tmp = false;
    }
    return tmp;
  };
  RecomposeScopeImpl.prototype.compose = function (composer) {
    var tmp0_safe_receiver = this._block;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(composer, 1);
    if (tmp1_elvis_lhs == null) {
      var tmp0_error_0 = 'Invalid restart scope';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      Unit_getInstance();
    }
  };
  RecomposeScopeImpl.prototype.invalidateForResult = function () {
    var tmp0_safe_receiver = this._composition_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.invalidate(this);
    return tmp1_elvis_lhs == null ? InvalidationResult_IGNORED_getInstance() : tmp1_elvis_lhs;
  };
  RecomposeScopeImpl.prototype.invalidate_2 = function () {
    var tmp0_safe_receiver = this._composition_0;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.invalidate(this);
    Unit_getInstance();
  };
  RecomposeScopeImpl.prototype.updateScope_0 = function (block) {
    this._block = block;
  };
  RecomposeScopeImpl.prototype.start_13 = function (token) {
    this._currentToken = token;
  };
  RecomposeScopeImpl.prototype.recordRead = function (instance) {
    var tmp0_elvis_lhs = this._trackedInstances;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new IdentityArrayIntMap();
      this._trackedInstances = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp.add_33(instance, this._currentToken);
  };
  RecomposeScopeImpl.prototype.end = function (token) {
    var tmp0_safe_receiver = this._trackedInstances;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0;
      var tmp_1;
      if (this._used) {
        var tmp$ret$0;
        l$ret$1: do {
          var inductionVariable = 0;
          var last = tmp0_safe_receiver._size_3;
          if (inductionVariable < last)
            do {
              var i_2_3 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp_2 = tmp0_safe_receiver._keys_0[i_2_3];
              var tmp0__anonymous__3_4 = isObject(tmp_2) ? tmp_2 : THROW_CCE();
              var tmp1__anonymous__3_5 = tmp0_safe_receiver._values_0[i_2_3];
              if (!(tmp1__anonymous__3_5 === token)) {
                tmp$ret$0 = true;
                break l$ret$1;
              } else {
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = false;
        }
         while (false);
        tmp_1 = tmp$ret$0;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = _no_name_provided_$factory_59(this, token, tmp0_safe_receiver);
      } else {
        {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  RecomposeScopeImpl.$metadata$ = {
    simpleName: 'RecomposeScopeImpl',
    kind: 'class',
    interfaces: [ScopeUpdateScope, RecomposeScope]
  };
  function RecomposeScope() {
  }
  RecomposeScope.$metadata$ = {
    simpleName: 'RecomposeScope',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_59(this$0, $token, $tmp0_safe_receiver) {
    var i = new _no_name_provided__68(this$0, $token, $tmp0_safe_receiver);
    return function (p1) {
      i.invoke_125(p1);
      return Unit_getInstance();
    };
  }
  var ProduceAnotherFrame;
  var FramePending;
  var State_ShutDown_instance;
  var State_ShuttingDown_instance;
  var State_Inactive_instance;
  var State_InactivePendingWork_instance;
  var State_Idle_instance;
  var State_PendingWork_instance;
  var State_entriesInitialized;
  function State_initEntries() {
    if (State_entriesInitialized)
      return Unit_getInstance();
    State_entriesInitialized = true;
    State_ShutDown_instance = new State('ShutDown', 0);
    State_ShuttingDown_instance = new State('ShuttingDown', 1);
    State_Inactive_instance = new State('Inactive', 2);
    State_InactivePendingWork_instance = new State('InactivePendingWork', 3);
    State_Idle_instance = new State('Idle', 4);
    State_PendingWork_instance = new State('PendingWork', 5);
  }
  function addRunning($this, info) {
    $l$break: while (true) {
      var old = $this.__runningRecomposers._get_value__13();
      var new_0 = old.add_37(info);
      if (old === new_0 ? true : $this.__runningRecomposers.compareAndSet_0(old, new_0))
        break $l$break;
    }
  }
  function removeRunning($this, info) {
    $l$break: while (true) {
      var old = $this.__runningRecomposers._get_value__13();
      var new_0 = old.remove_51(info);
      if (old === new_0 ? true : $this.__runningRecomposers.compareAndSet_0(old, new_0))
        break $l$break;
    }
  }
  function _no_name_provided__69(this$0, $throwable) {
    this._this$0_13 = this$0;
    this._$throwable = $throwable;
  }
  _no_name_provided__69.prototype.invoke_136 = function (runnerJobCause) {
    var tmp0_synchronized_0_4_8 = this._this$0_13._stateLock;
    var tmp = this._this$0_13;
    var tmp0_safe_receiver_2_5_9 = this._$throwable;
    var tmp_0;
    if (tmp0_safe_receiver_2_5_9 == null) {
      tmp_0 = null;
    } else {
      var tmp0_safe_receiver_3_4_7_11 = runnerJobCause;
      var tmp_1;
      if (tmp0_safe_receiver_3_4_7_11 == null) {
        tmp_1 = null;
      } else {
        var tmp_2;
        if (!(tmp0_safe_receiver_3_4_7_11 instanceof CancellationException)) {
          tmp_2 = tmp0_safe_receiver_3_4_7_11;
        } else {
          {
            tmp_2 = null;
          }
        }
        tmp_1 = tmp_2;
      }
      var tmp1_safe_receiver_2_3_6_10 = tmp_1;
      if (tmp1_safe_receiver_2_3_6_10 == null)
        null;
      else {
        addSuppressed(tmp0_safe_receiver_2_5_9, tmp1_safe_receiver_2_3_6_10);
        Unit_getInstance();
      }
      Unit_getInstance();
      tmp_0 = tmp0_safe_receiver_2_5_9;
    }
    tmp._closeCause = tmp_0;
    this._this$0_13.__state_3._set_value__5(State_ShutDown_getInstance());
  };
  _no_name_provided__69.prototype.invoke_468 = function (p1) {
    this.invoke_136((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__69.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__70(this$0, $toRecompose, $toApply) {
    this._this$0_14 = this$0;
    this._$toRecompose = $toRecompose;
    this._$toApply = $toApply;
  }
  _no_name_provided__70.prototype.invoke_129 = function (frameTime) {
    if (this._this$0_14._broadcastFrameClock._get_hasAwaiters_()) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_trace_0 = 'Recomposer:animation';
        var token_1 = Trace_getInstance().beginSection(tmp0_trace_0);
        try {
          this._this$0_14._broadcastFrameClock.sendFrame(frameTime);
          tmp$ret$0 = Companion_getInstance_13().sendApplyNotifications();
          break l$ret$1;
        }finally {
          Trace_getInstance().endSection(token_1);
        }
      }
       while (false);
    }var tmp$ret$2;
    l$ret$3: do {
      var tmp1_trace_0 = 'Recomposer:recompose';
      var token_1_0 = Trace_getInstance().beginSection(tmp1_trace_0);
      try {
        var tmp0_synchronized_0_3 = this._this$0_14._stateLock;
        recordComposerModificationsLocked(this._this$0_14);
        var tmp0_fastForEach_0_2_4 = this._this$0_14._compositionInvalidations;
        var inductionVariable = 0;
        var last = tmp0_fastForEach_0_2_4._get_size__45() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index_3_4_6 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item_4_5_7 = tmp0_fastForEach_0_2_4.get_66(index_3_4_6);
            this._$toRecompose.add_37(item_4_5_7);
            Unit_getInstance();
          }
           while (inductionVariable <= last);
        this._this$0_14._compositionInvalidations.clear_7();
        var modifiedValues_8 = new IdentityArraySet();
        try {
          var inductionVariable_0 = 0;
          var last_0 = this._$toRecompose._get_size__45() - 1 | 0;
          if (inductionVariable_0 <= last_0)
            do {
              var index_3_10 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var item_4_11 = this._$toRecompose.get_66(index_3_10);
              var tmp0_safe_receiver_6_12 = performRecompose(this._this$0_14, item_4_11, modifiedValues_8);
              if (tmp0_safe_receiver_6_12 == null)
                null;
              else {
                this._$toApply.add_37(tmp0_safe_receiver_6_12);
                Unit_getInstance();
              }
              Unit_getInstance();
            }
             while (inductionVariable_0 <= last_0);
          if (!this._$toApply.isEmpty_40()) {
            var tmp0_this_13 = this._this$0_14;
            var tmp1_14 = tmp0_this_13._changeCount;
            tmp0_this_13._changeCount = tmp1_14.inc_4();
            Unit_getInstance();
          } else {
          }
        }finally {
          this._$toRecompose.clear_7();
        }
        try {
          var inductionVariable_1 = 0;
          var last_1 = this._$toApply._get_size__45() - 1 | 0;
          if (inductionVariable_1 <= last_1)
            do {
              var index_3_16 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var item_4_17 = this._$toApply.get_66(index_3_16);
              item_4_17.applyChanges_0();
            }
             while (inductionVariable_1 <= last_1);
        }finally {
          this._$toApply.clear_7();
        }
        var tmp1_synchronized_0_18 = this._this$0_14._stateLock;
        tmp$ret$2 = deriveStateLocked(this._this$0_14);
        break l$ret$3;
      }finally {
        Trace_getInstance().endSection(token_1_0);
      }
    }
     while (false);
    return tmp$ret$2;
  };
  _no_name_provided__70.prototype.invoke_468 = function (p1) {
    return this.invoke_129(p1 instanceof Long ? p1 : THROW_CCE());
  };
  _no_name_provided__70.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__71(this$0) {
    this._this$0_15 = this$0;
  }
  _no_name_provided__71.prototype.invoke_131 = function (changed, _anonymous_parameter_1_) {
    var tmp0_synchronized_0 = this._this$0_15._stateLock;
    var tmp;
    if (this._this$0_15.__state_3._get_value__13().compareTo_2(State_Idle_getInstance()) >= 0) {
      var tmp0_this_2 = this._this$0_15;
      var tmp0_plusAssign_0_3 = tmp0_this_2._snapshotInvalidations;
      tmp0_plusAssign_0_3.add_37(changed);
      Unit_getInstance();
      tmp = deriveStateLocked(this._this$0_15);
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp1_resume_0 = Unit_getInstance();
      var tmp0_success_0_1 = Companion_getInstance_2();
      tmp0_safe_receiver.resumeWith_15(_Result___init__impl_(Unit_getInstance()));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__71.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Set) : false) ? p1 : THROW_CCE();
    this.invoke_131(tmp, p2 instanceof Snapshot ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__71.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__72($block, $parentFrameClock, resultContinuation) {
    this._$block_1 = $block;
    this._$parentFrameClock = $parentFrameClock;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__72.prototype.invoke_441 = function ($this$coroutineScope, $cont) {
    var tmp = this.create_9($this$coroutineScope, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__72.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$block_1(this._$this$coroutineScope, this._$parentFrameClock, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__72.prototype.create_9 = function ($this$coroutineScope, completion) {
    var i = new _no_name_provided__72(this._$block_1, this._$parentFrameClock, completion);
    i._$this$coroutineScope = $this$coroutineScope;
    return i;
  };
  _no_name_provided__72.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function State(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  State.$metadata$ = {
    simpleName: 'State',
    kind: 'class',
    interfaces: []
  };
  function deriveStateLocked($this) {
    if ($this.__state_3._get_value__13().compareTo_2(State_ShuttingDown_getInstance()) <= 0) {
      $this._knownCompositions.clear_7();
      $this._snapshotInvalidations.clear_7();
      $this._compositionInvalidations.clear_7();
      $this._compositionsAwaitingApply.clear_7();
      var tmp0_safe_receiver = $this._workContinuation;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.cancel$default_4(null, 1, null);
      }
      Unit_getInstance();
      $this._workContinuation = null;
      return null;
    }var tmp;
    if ($this._runnerJob == null) {
      $this._snapshotInvalidations.clear_7();
      $this._compositionInvalidations.clear_7();
      tmp = $this._broadcastFrameClock._get_hasAwaiters_() ? State_InactivePendingWork_getInstance() : State_Inactive_getInstance();
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      var tmp0_isNotEmpty_0 = $this._compositionInvalidations;
      if (!tmp0_isNotEmpty_0.isEmpty_40()) {
        tmp_3 = true;
      } else {
        {
          var tmp1_isNotEmpty_0 = $this._snapshotInvalidations;
          tmp_3 = !tmp1_isNotEmpty_0.isEmpty_40();
        }
      }
      if (tmp_3) {
        tmp_2 = true;
      } else {
        {
          var tmp2_isNotEmpty_0 = $this._compositionsAwaitingApply;
          tmp_2 = !tmp2_isNotEmpty_0.isEmpty_40();
        }
      }
      if (tmp_2) {
        tmp_1 = true;
      } else {
        {
          tmp_1 = $this._concurrentCompositionsOutstanding > 0;
        }
      }
      if (tmp_1) {
        tmp_0 = true;
      } else {
        {
          tmp_0 = $this._broadcastFrameClock._get_hasAwaiters_();
        }
      }
      if (tmp_0) {
        tmp = State_PendingWork_getInstance();
      } else {
        {
          tmp = State_Idle_getInstance();
        }
      }
    }
    var newState = tmp;
    $this.__state_3._set_value__5(newState);
    var tmp_4;
    if (newState.equals(State_PendingWork_getInstance())) {
      var tmp3_also_0 = $this._workContinuation;
      $this._workContinuation = null;
      tmp_4 = tmp3_also_0;
    } else {
      tmp_4 = null;
    }
    return tmp_4;
  }
  function _get_shouldKeepRecomposing_($this) {
    var tmp;
    var tmp0_synchronized_0 = $this._stateLock;
    if (!$this._isClosed) {
      tmp = true;
    } else {
      {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp1_any_0 = $this._effectJob._get_children__2();
          var tmp0_iterator_1 = tmp1_any_0.iterator_46();
          while (tmp0_iterator_1.hasNext_27()) {
            var element_2 = tmp0_iterator_1.next_28();
            if (element_2._get_isActive__20()) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        tmp = tmp$ret$0;
      }
    }
    return tmp;
  }
  function RecomposerInfoImpl($outer) {
    this._$this_8 = $outer;
  }
  RecomposerInfoImpl.$metadata$ = {
    simpleName: 'RecomposerInfoImpl',
    kind: 'class',
    interfaces: [RecomposerInfo]
  };
  function recordComposerModificationsLocked($this) {
    var tmp0_isNotEmpty_0 = $this._snapshotInvalidations;
    if (!tmp0_isNotEmpty_0.isEmpty_40()) {
      var tmp1_fastForEach_0 = $this._snapshotInvalidations;
      var inductionVariable = 0;
      var last = tmp1_fastForEach_0._get_size__45() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item_4 = tmp1_fastForEach_0.get_66(index_3);
          var tmp0_fastForEach_0_6 = $this._knownCompositions;
          var inductionVariable_0 = 0;
          var last_0 = tmp0_fastForEach_0_6._get_size__45() - 1 | 0;
          if (inductionVariable_0 <= last_0)
            do {
              var index_3_8 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var item_4_9 = tmp0_fastForEach_0_6.get_66(index_3_8);
              item_4_9.recordModificationsOf_0(item_4);
            }
             while (inductionVariable_0 <= last_0);
        }
         while (inductionVariable <= last);
      $this._snapshotInvalidations.clear_7();
      if (!(deriveStateLocked($this) == null)) {
        var tmp2_error_0 = 'called outside of runRecomposeAndApplyChanges';
        throw IllegalStateException_init_$Create$(toString_1(tmp2_error_0));
      }} else {
    }
  }
  function registerRunnerJob($this, callingJob) {
    var tmp0_synchronized_0 = $this._stateLock;
    var tmp0_safe_receiver_2 = $this._closeCause;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      throw tmp0_safe_receiver_2;
    }
    Unit_getInstance();
    if ($this.__state_3._get_value__13().compareTo_2(State_ShuttingDown_getInstance()) <= 0) {
      var tmp0_error_0_3 = 'Recomposer shut down';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
    }if (!($this._runnerJob == null)) {
      var tmp1_error_0_4 = 'Recomposer already running';
      throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_4));
    }$this._runnerJob = callingJob;
    deriveStateLocked($this);
    Unit_getInstance();
  }
  function _get_hasSchedulingWork_($this) {
    var tmp0_synchronized_0 = $this._stateLock;
    var tmp;
    var tmp_0;
    var tmp0_isNotEmpty_0_2 = $this._snapshotInvalidations;
    if (!tmp0_isNotEmpty_0_2.isEmpty_40()) {
      tmp_0 = true;
    } else {
      {
        var tmp1_isNotEmpty_0_3 = $this._compositionInvalidations;
        tmp_0 = !tmp1_isNotEmpty_0_3.isEmpty_40();
      }
    }
    if (tmp_0) {
      tmp = true;
    } else {
      {
        tmp = $this._broadcastFrameClock._get_hasAwaiters_();
      }
    }
    return tmp;
  }
  function awaitWorkAvailable($this, $cont) {
    var tmp = new $awaitWorkAvailableCOROUTINE$1($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  }
  function recompositionRunner($this, block, $cont) {
    var parentFrameClock = _get_monotonicFrameClock_($cont._get_context__22());
    return withContext($this._broadcastFrameClock, _no_name_provided_$factory_63($this, block, parentFrameClock, null), $cont);
  }
  function performRecompose($this, composition, modifiedValues) {
    if (composition._get_isComposing__0() ? true : composition._get_isDisposed__0())
      return null;
    var tmp;
    var tmp$ret$2;
    l$ret$3: do {
      var snapshot_1 = Companion_getInstance_13().takeMutableSnapshot(readObserverOf($this, composition), writeObserverOf($this, composition, modifiedValues));
      try {
        var tmp$ret$0;
        l$ret$1: do {
          var previous_1 = snapshot_1.makeCurrent_3();
          try {
            var tmp0_safe_receiver_3 = modifiedValues;
            if (tmp0_safe_receiver_3 == null)
              null;
            else {
              var inductionVariable = 0;
              var last = tmp0_safe_receiver_3._size_4;
              if (inductionVariable < last)
                do {
                  var i_3_5 = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var tmp0__anonymous__4_6 = tmp0_safe_receiver_3.get_66(i_3_5);
                  composition.recordWriteOf_0(tmp0__anonymous__4_6);
                }
                 while (inductionVariable < last);
              Unit_getInstance();
            }
            Unit_getInstance();
            tmp$ret$0 = composition.recompose_1();
            break l$ret$1;
          }finally {
            snapshot_1.restoreCurrent_3(previous_1);
          }
        }
         while (false);
        tmp$ret$2 = tmp$ret$0;
        break l$ret$3;
      }finally {
        applyAndCheck($this, snapshot_1);
      }
    }
     while (false);
    if (tmp$ret$2) {
      tmp = composition;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function readObserverOf($this, composition) {
    return _no_name_provided_$factory_64(composition);
  }
  function writeObserverOf($this, composition, modifiedValues) {
    return _no_name_provided_$factory_65(composition, modifiedValues);
  }
  function applyAndCheck($this, snapshot) {
    var applyResult = snapshot.apply_4();
    if (applyResult instanceof Failure_0) {
      var tmp0_error_0 = 'Unsupported concurrent change during composition. A state object was modified by composition as well as being modified outside composition.';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
    }
  }
  function _get_hasFrameWorkLocked_($this) {
    var tmp;
    var tmp0_isNotEmpty_0 = $this._compositionInvalidations;
    if (!tmp0_isNotEmpty_0.isEmpty_40()) {
      tmp = true;
    } else {
      {
        tmp = $this._broadcastFrameClock._get_hasAwaiters_();
      }
    }
    return tmp;
  }
  function Companion_13() {
    Companion_instance_12 = this;
    this.__runningRecomposers = MutableStateFlow_0(persistentSetOf());
  }
  Companion_13.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_13();
    return Companion_instance_12;
  }
  function _no_name_provided__73(this$0) {
    this._this$0_16 = this$0;
  }
  _no_name_provided__73.prototype.invoke_415 = function () {
    var tmp0_synchronized_0 = this._this$0_16._stateLock;
    var tmp0_also_0_2 = deriveStateLocked(this._this$0_16);
    if (this._this$0_16.__state_3._get_value__13().compareTo_2(State_ShuttingDown_getInstance()) <= 0)
      throw new CancellationException('Recomposer shutdown; frame clock awaiter will never resume', this._this$0_16._closeCause);
    var tmp0_safe_receiver = tmp0_also_0_2;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp1_resume_0 = Unit_getInstance();
      var tmp0_success_0_1 = Companion_getInstance_2();
      tmp0_safe_receiver.resumeWith_15(_Result___init__impl_(Unit_getInstance()));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__73.prototype.invoke_452 = function () {
    this.invoke_415();
    return Unit_getInstance();
  };
  _no_name_provided__73.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__74(this$0) {
    this._this$0_17 = this$0;
  }
  _no_name_provided__74.prototype.invoke_136 = function (throwable) {
    var cancellation_3 = new CancellationException('Recomposer effect job completed', throwable);
    var continuationToResume_4 = null;
    var tmp0_synchronized_0_5 = this._this$0_17._stateLock;
    var runnerJob_2_6 = this._this$0_17._runnerJob;
    if (!(runnerJob_2_6 == null)) {
      this._this$0_17.__state_3._set_value__5(State_ShuttingDown_getInstance());
      if (!this._this$0_17._isClosed) {
        runnerJob_2_6.cancel_10(cancellation_3);
      } else if (!(this._this$0_17._workContinuation == null)) {
        continuationToResume_4 = this._this$0_17._workContinuation;
      }this._this$0_17._workContinuation = null;
      runnerJob_2_6.invokeOnCompletion_18(_no_name_provided_$factory_66(this._this$0_17, throwable));
    } else {
      this._this$0_17._closeCause = cancellation_3;
      this._this$0_17.__state_3._set_value__5(State_ShutDown_getInstance());
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_safe_receiver_12 = continuationToResume_4;
    if (tmp0_safe_receiver_12 == null)
      null;
    else {
      var tmp1_resume_0_13 = Unit_getInstance();
      var tmp0_success_0_1_14 = Companion_getInstance_2();
      tmp0_safe_receiver_12.resumeWith_15(_Result___init__impl_(Unit_getInstance()));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__74.prototype.invoke_468 = function (p1) {
    this.invoke_136((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__74.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__75(this$0, resultContinuation) {
    this._this$0_18 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__75.prototype.invoke_138 = function ($this$recompositionRunner, parentFrameClock, $cont) {
    var tmp = this.create_1($this$recompositionRunner, parentFrameClock, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__75.prototype.invoke_462 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    this.invoke_138(tmp, (!(p2 == null) ? isInterface(p2, MonotonicFrameClock) : false) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__75.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            var tmp_0 = this;
            tmp_0._toRecompose0 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1._toApply1 = ArrayList_init_$Create$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!_get_shouldKeepRecomposing_(this._this$0_18)) {
              this._state_1 = 5;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = awaitWorkAvailable(this._this$0_18, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            var tmp_2 = this;
            tmp_2._tmp0_synchronized_02 = this._this$0_18._stateLock;
            var tmp_3;
            if (!_get_hasFrameWorkLocked_(this._this$0_18)) {
              recordComposerModificationsLocked(this._this$0_18);
              tmp_3 = !_get_hasFrameWorkLocked_(this._this$0_18);
            } else {
              tmp_3 = false;
            }

            if (tmp_3) {
              this._state_1 = 1;
              continue $sm;
            } else {
              {
                this._state_1 = 3;
                continue $sm;
              }
            }

            break;
          case 3:
            this._state_1 = 4;
            suspendResult = this._parentFrameClock.withFrameNanos_1(_no_name_provided_$factory_67(this._this$0_18, this._toRecompose0, this._toApply1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 5:
            return Unit_getInstance();
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__75.prototype.create_1 = function ($this$recompositionRunner, parentFrameClock, completion) {
    var i = new _no_name_provided__75(this._this$0_18, completion);
    i._$this$recompositionRunner = $this$recompositionRunner;
    i._parentFrameClock = parentFrameClock;
    return i;
  };
  _no_name_provided__75.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__76(this$0, $block, $parentFrameClock, resultContinuation) {
    this._this$0_19 = this$0;
    this._$block_2 = $block;
    this._$parentFrameClock_0 = $parentFrameClock;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__76.prototype.invoke_441 = function ($this$withContext, $cont) {
    var tmp = this.create_9($this$withContext, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__76.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._callingJob0 = _get_job_(this._$this$withContext._get_coroutineContext__6());
            registerRunnerJob(this._this$0_19, this._callingJob0);
            var tmp_0 = this;
            var tmp_1 = Companion_getInstance_13();
            tmp_0._unregisterApplyObserver1 = tmp_1.registerApplyObserver(_no_name_provided_$factory_68(this._this$0_19));
            addRunning(Companion_getInstance_12(), this._this$0_19._recomposerInfo);
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 4;
            var tmp_2 = this;
            tmp_2._tmp0_synchronized_03 = this._this$0_19._stateLock;
            var tmp_3 = this;
            tmp_3._tmp0_fastForEach_0_24 = this._this$0_19._knownCompositions;
            var inductionVariable = 0;
            var last = this._tmp0_fastForEach_0_24._get_size__45() - 1 | 0;
            if (inductionVariable <= last)
              do {
                var index_3_4 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var item_4_5 = this._tmp0_fastForEach_0_24.get_66(index_3_4);
                item_4_5.invalidateAll_0();
              }
               while (inductionVariable <= last);
            this._state_1 = 2;
            suspendResult = coroutineScope(_no_name_provided_$factory_69(this._$block_2, this._$parentFrameClock_0, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp$ret$02 = suspendResult;
            this._exceptionState = 5;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._unregisterApplyObserver1.dispose_20();
            var tmp1_synchronized_0 = this._this$0_19._stateLock;
            if (this._this$0_19._runnerJob === this._callingJob0) {
              this._this$0_19._runnerJob = null;
            }
            deriveStateLocked(this._this$0_19);
            Unit_getInstance();
            removeRunning(Companion_getInstance_12(), this._this$0_19._recomposerInfo);
            return Unit_getInstance();
          case 4:
            this._exceptionState = 5;
            var t = this._exception_0;
            this._unregisterApplyObserver1.dispose_20();
            var tmp1_synchronized_0_0 = this._this$0_19._stateLock;
            if (this._this$0_19._runnerJob === this._callingJob0) {
              this._this$0_19._runnerJob = null;
            }
            deriveStateLocked(this._this$0_19);
            Unit_getInstance();
            removeRunning(Companion_getInstance_12(), this._this$0_19._recomposerInfo);
            throw t;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__76.prototype.create_9 = function ($this$withContext, completion) {
    var i = new _no_name_provided__76(this._this$0_19, this._$block_2, this._$parentFrameClock_0, completion);
    i._$this$withContext = $this$withContext;
    return i;
  };
  _no_name_provided__76.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__77($composition) {
    this._$composition = $composition;
  }
  _no_name_provided__77.prototype.invoke_195 = function (value_0) {
    this._$composition.recordReadOf_0(value_0);
  };
  _no_name_provided__77.prototype.invoke_468 = function (p1) {
    this.invoke_195(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__77.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__78($composition, $modifiedValues) {
    this._$composition_0 = $composition;
    this._$modifiedValues = $modifiedValues;
  }
  _no_name_provided__78.prototype.invoke_195 = function (value_0) {
    this._$composition_0.recordWriteOf_0(value_0);
    var tmp0_safe_receiver = this._$modifiedValues;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.add_36(value_0);
    Unit_getInstance();
  };
  _no_name_provided__78.prototype.invoke_468 = function (p1) {
    this.invoke_195(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__78.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function State_ShutDown_getInstance() {
    State_initEntries();
    return State_ShutDown_instance;
  }
  function State_ShuttingDown_getInstance() {
    State_initEntries();
    return State_ShuttingDown_instance;
  }
  function State_Inactive_getInstance() {
    State_initEntries();
    return State_Inactive_instance;
  }
  function State_InactivePendingWork_getInstance() {
    State_initEntries();
    return State_InactivePendingWork_instance;
  }
  function State_Idle_getInstance() {
    State_initEntries();
    return State_Idle_instance;
  }
  function State_PendingWork_getInstance() {
    State_initEntries();
    return State_PendingWork_instance;
  }
  function $awaitWorkAvailableCOROUTINE$1(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this_ = _this_;
  }
  $awaitWorkAvailableCOROUTINE$1.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!_get_hasSchedulingWork_(this.__this_)) {
              this._state_1 = 1;
              var tmp_0 = this;
              tmp_0._tmp0__anonymous__1_10 = this;
              this._cancellable_2_21 = new CancellableContinuationImpl(intercepted(this._tmp0__anonymous__1_10), 1);
              this._cancellable_2_21.initCancellability();
              var tmp_1 = this;
              tmp_1._tmp0_synchronized_0_42 = this.__this_._stateLock;
              if (_get_hasSchedulingWork_(this.__this_)) {
                var tmp0_resume_0_2_5 = Unit_getInstance();
                var tmp0_success_0_1_3_6 = Companion_getInstance_2();
                this._cancellable_2_21.resumeWith_15(_Result___init__impl_(Unit_getInstance()));
              } else {
                this.__this_._workContinuation = this._cancellable_2_21;
              }
              suspendResult = this._cancellable_2_21.getResult_0();
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitWorkAvailableCOROUTINE$1.$metadata$ = {
    simpleName: '$awaitWorkAvailableCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function Recomposer(effectCoroutineContext) {
    Companion_getInstance_12();
    CompositionContext.call(this);
    this._changeCount = new Long(0, 0);
    var tmp = this;
    tmp._broadcastFrameClock = new BroadcastFrameClock(_no_name_provided_$factory_60(this));
    var tmp_0 = this;
    var tmp0_apply_0 = Job_0(effectCoroutineContext.get_56(Key_getInstance_2()));
    tmp0_apply_0.invokeOnCompletion_18(_no_name_provided_$factory_61(this));
    Unit_getInstance();
    tmp_0._effectJob = tmp0_apply_0;
    this._effectCoroutineContext = effectCoroutineContext.plus_25(this._broadcastFrameClock).plus_25(this._effectJob);
    this._stateLock = new Object();
    this._runnerJob = null;
    this._closeCause = null;
    var tmp_1 = this;
    tmp_1._knownCompositions = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._snapshotInvalidations = ArrayList_init_$Create$();
    var tmp_3 = this;
    tmp_3._compositionInvalidations = ArrayList_init_$Create$();
    var tmp_4 = this;
    tmp_4._compositionsAwaitingApply = ArrayList_init_$Create$();
    this._workContinuation = null;
    this._concurrentCompositionsOutstanding = 0;
    this._isClosed = false;
    this.__state_3 = MutableStateFlow_0(State_Inactive_getInstance());
    this._recomposerInfo = new RecomposerInfoImpl(this);
    this._$stable_3 = 8;
  }
  Recomposer.prototype._get_effectCoroutineContext__0 = function () {
    return this._effectCoroutineContext;
  };
  Recomposer.prototype.runRecomposeAndApplyChanges = function ($cont) {
    return recompositionRunner(this, _no_name_provided_$factory_62(this, null), $cont);
  };
  Recomposer.prototype._get_compoundHashKey__0 = function () {
    return 1000;
  };
  Recomposer.prototype._get_collectingParameterInformation__0 = function () {
    return false;
  };
  Recomposer.prototype.recordInspectionTable_0 = function (table) {
  };
  Recomposer.prototype.invalidate_3 = function (composition) {
    var tmp0_synchronized_0 = this._stateLock;
    var tmp;
    if (!this._compositionInvalidations.contains_37(composition)) {
      var tmp0_this_2 = this;
      var tmp0_plusAssign_0_3 = tmp0_this_2._compositionInvalidations;
      tmp0_plusAssign_0_3.add_37(composition);
      Unit_getInstance();
      tmp = deriveStateLocked(this);
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp1_resume_0 = Unit_getInstance();
      var tmp0_success_0_1 = Companion_getInstance_2();
      tmp0_safe_receiver.resumeWith_15(_Result___init__impl_(Unit_getInstance()));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Recomposer.prototype.composeInitial$composable_0 = function (composition, content) {
    var composerWasComposing = composition._get_isComposing__0();
    var tmp$ret$2;
    l$ret$3: do {
      var tmp0_composing_0 = null;
      var snapshot_1 = Companion_getInstance_13().takeMutableSnapshot(readObserverOf(this, composition), writeObserverOf(this, composition, tmp0_composing_0));
      try {
        var tmp$ret$0;
        l$ret$1: do {
          var previous_1_2 = snapshot_1.makeCurrent_3();
          try {
            tmp$ret$0 = composition.composeContent$composable_1(content);
            break l$ret$1;
          }finally {
            snapshot_1.restoreCurrent_3(previous_1_2);
          }
        }
         while (false);
        tmp$ret$2 = tmp$ret$0;
        break l$ret$3;
      }finally {
        applyAndCheck(this, snapshot_1);
      }
    }
     while (false);
    if (!composerWasComposing) {
      Companion_getInstance_13().notifyObjectsInitialized_4();
    }composition.applyChanges_0();
    var tmp1_synchronized_0 = this._stateLock;
    if (this.__state_3._get_value__13().compareTo_2(State_ShuttingDown_getInstance()) > 0) {
      if (!this._knownCompositions.contains_37(composition)) {
        var tmp0_this_2 = this;
        var tmp0_plusAssign_0_3 = tmp0_this_2._knownCompositions;
        tmp0_plusAssign_0_3.add_37(composition);
        Unit_getInstance();
      }}if (!composerWasComposing) {
      Companion_getInstance_13().notifyObjectsInitialized_4();
    }};
  Recomposer.$metadata$ = {
    simpleName: 'Recomposer',
    kind: 'class',
    interfaces: []
  };
  function RecomposerInfo() {
  }
  RecomposerInfo.$metadata$ = {
    simpleName: 'RecomposerInfo',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_60(this$0) {
    var i = new _no_name_provided__73(this$0);
    return function () {
      i.invoke_415();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_61(this$0) {
    var i = new _no_name_provided__74(this$0);
    return function (p1) {
      i.invoke_136(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_62(this$0, resultContinuation) {
    var i = new _no_name_provided__75(this$0, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_138(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_63(this$0, $block, $parentFrameClock, resultContinuation) {
    var i = new _no_name_provided__76(this$0, $block, $parentFrameClock, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_441(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_64($composition) {
    var i = new _no_name_provided__77($composition);
    return function (p1) {
      i.invoke_195(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_65($composition, $modifiedValues) {
    var i = new _no_name_provided__78($composition, $modifiedValues);
    return function (p1) {
      i.invoke_195(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_66(this$0, $throwable) {
    var i = new _no_name_provided__69(this$0, $throwable);
    return function (p1) {
      i.invoke_136(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_67(this$0, $toRecompose, $toApply) {
    var i = new _no_name_provided__70(this$0, $toRecompose, $toApply);
    return function (p1) {
      return i.invoke_129(p1);
    };
  }
  function _no_name_provided_$factory_68(this$0) {
    var i = new _no_name_provided__71(this$0);
    return function (p1, p2) {
      i.invoke_131(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_69($block, $parentFrameClock, resultContinuation) {
    var i = new _no_name_provided__72($block, $parentFrameClock, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_441(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function RememberObserver() {
  }
  RememberObserver.$metadata$ = {
    simpleName: 'RememberObserver',
    kind: 'interface',
    interfaces: []
  };
  function startGroup_1($this, key_0, objectKey_0, isNode_0, aux_0) {
    var inserting = $this._insertCount > 0;
    $this._nodeCountStack.push($this._nodeCount_0);
    var tmp = $this;
    var tmp_0;
    if (inserting) {
      insertGroups($this, 1);
      var current_0 = $this._currentGroup;
      var currentAddress = groupIndexToAddress($this, current_0);
      var hasObjectKey_0 = !(objectKey_0 === Companion_getInstance_11()._Empty);
      var hasAux_0 = !isNode_0 ? !(aux_0 === Companion_getInstance_11()._Empty) : false;
      initGroup($this._groups, currentAddress, key_0, isNode_0, hasObjectKey_0, hasAux_0, $this._parent_1, $this._currentSlot);
      $this._currentSlotEnd = $this._currentSlot;
      var dataSlotsNeeded = ((isNode_0 ? 1 : 0) + (hasObjectKey_0 ? 1 : 0) | 0) + (hasAux_0 ? 1 : 0) | 0;
      if (dataSlotsNeeded > 0) {
        insertSlots($this, dataSlotsNeeded, current_0);
        var slots = $this._slots_0;
        var currentSlot = $this._currentSlot;
        if (isNode_0) {
          var tmp0 = currentSlot;
          currentSlot = tmp0 + 1 | 0;
          slots[tmp0] = aux_0;
        }if (hasObjectKey_0) {
          var tmp1 = currentSlot;
          currentSlot = tmp1 + 1 | 0;
          slots[tmp1] = objectKey_0;
        }if (hasAux_0) {
          var tmp2 = currentSlot;
          currentSlot = tmp2 + 1 | 0;
          slots[tmp2] = aux_0;
        }$this._currentSlot = currentSlot;
      }$this._nodeCount_0 = 0;
      var newCurrent = current_0 + 1 | 0;
      $this._parent_1 = current_0;
      $this._currentGroup = newCurrent;
      tmp_0 = newCurrent;
    } else {
      var previousParent = $this._parent_1;
      $this._startStack.push(previousParent);
      saveCurrentGroupEnd($this);
      var currentGroup = $this._currentGroup;
      var currentGroupAddress = groupIndexToAddress($this, currentGroup);
      if (!equals(aux_0, Companion_getInstance_11()._Empty)) {
        if (isNode_0)
          $this.updateNode(aux_0);
        else
          $this.updateAux(aux_0);
      }$this._currentSlot = slotIndex($this._groups, $this, currentGroupAddress);
      $this._currentSlotEnd = dataIndex_0($this._groups, $this, groupIndexToAddress($this, $this._currentGroup + 1 | 0));
      $this._nodeCount_0 = nodeCount($this._groups, currentGroupAddress);
      $this._parent_1 = currentGroup;
      $this._currentGroup = currentGroup + 1 | 0;
      tmp_0 = currentGroup + groupSize($this._groups, currentGroupAddress) | 0;
    }
    tmp._currentGroupEnd = tmp_0;
  }
  function saveCurrentGroupEnd($this) {
    $this._endStack.push((_get_capacity_($this) - $this._groupGapLen | 0) - $this._currentGroupEnd | 0);
  }
  function restoreCurrentGroupEnd($this) {
    var newGroupEnd = (_get_capacity_($this) - $this._groupGapLen | 0) - $this._endStack.pop_0() | 0;
    $this._currentGroupEnd = newGroupEnd;
    return newGroupEnd;
  }
  function fixParentAnchorsFor($this, parent_0, endGroup, firstChild_0) {
    var parentAnchor_0 = parentIndexToAnchor($this, parent_0, $this._groupGapStart);
    var child = firstChild_0;
    while (child < endGroup) {
      updateParentAnchor($this._groups, groupIndexToAddress($this, child), parentAnchor_0);
      var childEnd = child + groupSize($this._groups, groupIndexToAddress($this, child)) | 0;
      fixParentAnchorsFor($this, child, childEnd, child + 1 | 0);
      child = childEnd;
    }
  }
  function moveGroupGapTo($this, index) {
    var gapLen = $this._groupGapLen;
    var gapStart = $this._groupGapStart;
    if (!(gapStart === index)) {
      var tmp0_isNotEmpty_0 = $this._anchors;
      if (!tmp0_isNotEmpty_0.isEmpty_40())
        updateAnchors($this, gapStart, index);
      else {
      }
      if (gapLen > 0) {
        var groups = $this._groups;
        var groupPhysicalAddress = imul(index, 5);
        var groupPhysicalGapLen = imul(gapLen, 5);
        var groupPhysicalGapStart = imul(gapStart, 5);
        if (index < gapStart) {
          var tmp1_copyInto_0 = groupPhysicalAddress + groupPhysicalGapLen | 0;
          var tmp = groups;
          arrayCopy_0(tmp, groups, tmp1_copyInto_0, groupPhysicalAddress, groupPhysicalGapStart);
          Unit_getInstance();
        } else {
          var tmp2_copyInto_0 = groupPhysicalGapStart + groupPhysicalGapLen | 0;
          var tmp3_copyInto_0 = groupPhysicalAddress + groupPhysicalGapLen | 0;
          var tmp_0 = groups;
          arrayCopy_0(tmp_0, groups, groupPhysicalGapStart, tmp2_copyInto_0, tmp3_copyInto_0);
          Unit_getInstance();
        }
      }var groupAddress = index < gapStart ? index + gapLen | 0 : gapStart;
      var capacity = _get_capacity_($this);
      var tmp4_check_0 = groupAddress < capacity;
      if (!tmp4_check_0) {
        var message_2_1 = 'Check failed.';
        throw IllegalStateException_init_$Create$(toString_1(message_2_1));
      }while (groupAddress < capacity) {
        var oldAnchor = parentAnchor($this._groups, groupAddress);
        var oldIndex = parentAnchorToIndex($this, oldAnchor);
        var newAnchor = parentIndexToAnchor($this, oldIndex, index);
        if (!(newAnchor === oldAnchor)) {
          updateParentAnchor($this._groups, groupAddress, newAnchor);
        }var tmp0 = groupAddress;
        groupAddress = tmp0 + 1 | 0;
        Unit_getInstance();
        if (groupAddress === index)
          groupAddress = groupAddress + gapLen | 0;
      }
    }$this._groupGapStart = index;
  }
  function moveSlotGapTo($this, index, group) {
    var gapLen = $this._slotsGapLen;
    var gapStart = $this._slotsGapStart;
    var slotsGapOwner = $this._slotsGapOwner;
    if (!(gapStart === index)) {
      var slots = $this._slots_0;
      if (index < gapStart) {
        var tmp0_copyInto_0 = index + gapLen | 0;
        arrayCopy_0(slots, slots, tmp0_copyInto_0, index, gapStart);
        Unit_getInstance();
      } else {
        var tmp1_copyInto_0 = gapStart + gapLen | 0;
        var tmp2_copyInto_0 = index + gapLen | 0;
        arrayCopy_0(slots, slots, gapStart, tmp1_copyInto_0, tmp2_copyInto_0);
        Unit_getInstance();
      }
      fill(slots, null, index, index + gapLen | 0);
    }var tmp3_min_0 = group + 1 | 0;
    var tmp4_min_0 = $this._get_size__45();
    var newSlotsGapOwner = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp3_min_0, tmp4_min_0]))));
    }.call(this);
    if (!(slotsGapOwner === newSlotsGapOwner)) {
      var slotsSize = $this._slots_0.length - gapLen | 0;
      if (newSlotsGapOwner < slotsGapOwner) {
        var updateAddress = groupIndexToAddress($this, newSlotsGapOwner);
        var stopUpdateAddress = groupIndexToAddress($this, slotsGapOwner);
        var groupGapStart = $this._groupGapStart;
        while (updateAddress < stopUpdateAddress) {
          var anchor = dataAnchor($this._groups, updateAddress);
          var tmp5_check_0 = anchor >= 0;
          if (!tmp5_check_0) {
            var message_1 = 'Unexpected anchor value, expected a positive anchor';
            throw IllegalStateException_init_$Create$(toString_1(message_1));
          }updateDataAnchor($this._groups, updateAddress, -((slotsSize - anchor | 0) + 1 | 0) | 0);
          var tmp0 = updateAddress;
          updateAddress = tmp0 + 1 | 0;
          Unit_getInstance();
          if (updateAddress === groupGapStart)
            updateAddress = updateAddress + $this._groupGapLen | 0;
        }
      } else {
        var updateAddress_0 = groupIndexToAddress($this, slotsGapOwner);
        var stopUpdateAddress_0 = groupIndexToAddress($this, newSlotsGapOwner);
        while (updateAddress_0 < stopUpdateAddress_0) {
          var anchor_0 = dataAnchor($this._groups, updateAddress_0);
          var tmp6_check_0 = anchor_0 < 0;
          if (!tmp6_check_0) {
            var message_1_0 = 'Unexpected anchor value, expected a negative anchor';
            throw IllegalStateException_init_$Create$(toString_1(message_1_0));
          }updateDataAnchor($this._groups, updateAddress_0, (slotsSize + anchor_0 | 0) + 1 | 0);
          var tmp1 = updateAddress_0;
          updateAddress_0 = tmp1 + 1 | 0;
          Unit_getInstance();
          if (updateAddress_0 === $this._groupGapStart)
            updateAddress_0 = updateAddress_0 + $this._groupGapLen | 0;
        }
      }
      $this._slotsGapOwner = newSlotsGapOwner;
    }$this._slotsGapStart = index;
  }
  function insertGroups($this, size_1) {
    if (size_1 > 0) {
      var currentGroup = $this._currentGroup;
      moveGroupGapTo($this, currentGroup);
      var gapStart = $this._groupGapStart;
      var gapLen = $this._groupGapLen;
      var oldCapacity = $this._groups.length / 5 | 0;
      var oldSize = oldCapacity - gapLen | 0;
      if (gapLen < size_1) {
        var groups = $this._groups;
        var tmp0_max_0 = imul(oldCapacity, 2);
        var tmp1_max_0 = oldSize + size_1 | 0;
        var tmp2_max_0 = function () {
          var $externalVarargReceiverTmp = Math;
          return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_max_0, tmp1_max_0]))));
        }.call(this);
        var tmp3_max_0 = 32;
        var newCapacity = function () {
          var $externalVarargReceiverTmp = Math;
          return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp2_max_0, tmp3_max_0]))));
        }.call(this);
        var newGroups = new Int32Array(imul(newCapacity, 5));
        var newGapLen = newCapacity - oldSize | 0;
        var oldGapEndAddress = gapStart + gapLen | 0;
        var newGapEndAddress = gapStart + newGapLen | 0;
        var tmp4_copyInto_0 = 0;
        var tmp5_copyInto_0 = 0;
        var tmp6_copyInto_0 = imul(gapStart, 5);
        var tmp = groups;
        arrayCopy_0(tmp, newGroups, tmp4_copyInto_0, tmp5_copyInto_0, tmp6_copyInto_0);
        Unit_getInstance();
        var tmp7_copyInto_0 = imul(newGapEndAddress, 5);
        var tmp8_copyInto_0 = imul(oldGapEndAddress, 5);
        var tmp9_copyInto_0 = imul(oldCapacity, 5);
        var tmp_0 = groups;
        arrayCopy_0(tmp_0, newGroups, tmp7_copyInto_0, tmp8_copyInto_0, tmp9_copyInto_0);
        Unit_getInstance();
        $this._groups = newGroups;
        gapLen = newGapLen;
      }var currentEnd = $this._currentGroupEnd;
      if (currentEnd >= gapStart)
        $this._currentGroupEnd = currentEnd + size_1 | 0;
      $this._groupGapStart = gapStart + size_1 | 0;
      $this._groupGapLen = gapLen - size_1 | 0;
      var index = oldSize > 0 ? dataIndex($this, currentGroup + size_1 | 0) : 0;
      var anchor = dataIndexToDataAnchor($this, index, $this._slotsGapOwner < gapStart ? 0 : $this._slotsGapStart, $this._slotsGapLen, $this._slots_0.length);
      var inductionVariable = gapStart;
      var last = gapStart + size_1 | 0;
      if (inductionVariable < last)
        do {
          var groupAddress = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          updateDataAnchor($this._groups, groupAddress, anchor);
        }
         while (inductionVariable < last);
      var slotsGapOwner = $this._slotsGapOwner;
      if (slotsGapOwner >= gapStart) {
        $this._slotsGapOwner = slotsGapOwner + size_1 | 0;
      }}}
  function insertSlots($this, size_1, group) {
    if (size_1 > 0) {
      moveSlotGapTo($this, $this._currentSlot, group);
      var gapStart = $this._slotsGapStart;
      var gapLen = $this._slotsGapLen;
      if (gapLen < size_1) {
        var slots = $this._slots_0;
        var oldCapacity = slots.length;
        var oldSize = oldCapacity - gapLen | 0;
        var tmp0_max_0 = imul(oldCapacity, 2);
        var tmp1_max_0 = oldSize + size_1 | 0;
        var tmp2_max_0 = function () {
          var $externalVarargReceiverTmp = Math;
          return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_max_0, tmp1_max_0]))));
        }.call(this);
        var tmp3_max_0 = 32;
        var newCapacity = function () {
          var $externalVarargReceiverTmp = Math;
          return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp2_max_0, tmp3_max_0]))));
        }.call(this);
        var tmp = 0;
        var tmp_0 = newCapacity;
        var tmp_1 = fillArrayVal(Array(tmp_0), null);
        while (tmp < tmp_0) {
          var tmp_2 = tmp;
          tmp_1[tmp_2] = null;
          tmp = tmp + 1 | 0;
        }
        var newData = tmp_1;
        var newGapLen = newCapacity - oldSize | 0;
        var oldGapEndAddress = gapStart + gapLen | 0;
        var newGapEndAddress = gapStart + newGapLen | 0;
        var tmp4_copyInto_0 = 0;
        var tmp5_copyInto_0 = 0;
        arrayCopy_0(slots, newData, tmp4_copyInto_0, tmp5_copyInto_0, gapStart);
        Unit_getInstance();
        arrayCopy_0(slots, newData, newGapEndAddress, oldGapEndAddress, oldCapacity);
        Unit_getInstance();
        $this._slots_0 = newData;
        gapLen = newGapLen;
      }var currentDataEnd = $this._currentSlotEnd;
      if (currentDataEnd >= gapStart)
        $this._currentSlotEnd = currentDataEnd + size_1 | 0;
      $this._slotsGapStart = gapStart + size_1 | 0;
      $this._slotsGapLen = gapLen - size_1 | 0;
    }}
  function removeGroups($this, start_0, len) {
    var tmp;
    if (len > 0) {
      var anchorsRemoved = false;
      var anchors = $this._anchors;
      moveGroupGapTo($this, start_0);
      if (!anchors.isEmpty_40())
        anchorsRemoved = removeAnchors($this, start_0, len);
      else {
      }
      $this._groupGapStart = start_0;
      var previousGapLen = $this._groupGapLen;
      var newGapLen = previousGapLen + len | 0;
      $this._groupGapLen = newGapLen;
      var slotsGapOwner = $this._slotsGapOwner;
      if (slotsGapOwner > start_0) {
        $this._slotsGapOwner = slotsGapOwner - len | 0;
      }if ($this._currentGroupEnd >= $this._groupGapStart) {
        var tmp0_this = $this;
        tmp0_this._currentGroupEnd = tmp0_this._currentGroupEnd - len | 0;
      }tmp = anchorsRemoved;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function removeSlots($this, start_0, len, group) {
    if (len > 0) {
      var gapLen = $this._slotsGapLen;
      var removeEnd = start_0 + len | 0;
      moveSlotGapTo($this, removeEnd, group);
      $this._slotsGapStart = start_0;
      $this._slotsGapLen = gapLen + len | 0;
      fill($this._slots_0, null, start_0, start_0 + len | 0);
      var currentDataEnd = $this._currentSlotEnd;
      if (currentDataEnd >= start_0)
        $this._currentSlotEnd = currentDataEnd - len | 0;
    }}
  function updateNodeOfGroup($this, index, value_0) {
    var address = groupIndexToAddress($this, index);
    var tmp0_check_0 = address < $this._groups.length ? isNode($this._groups, address) : false;
    if (!tmp0_check_0) {
      var message_1 = '' + 'Updating the node of a group at ' + index + ' that was not created with as a node group';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }$this._slots_0[dataIndexToDataAddress($this, nodeIndex($this._groups, $this, address))] = value_0;
  }
  function updateAnchors($this, previousGapStart, newGapStart) {
    var gapLen = $this._groupGapLen;
    var size_1 = _get_capacity_($this) - gapLen | 0;
    if (previousGapStart < newGapStart) {
      var index = locationOf($this._anchors, previousGapStart, size_1);
      $l$break_0: while (index < $this._anchors._get_size__45()) {
        var anchor = $this._anchors.get_66(index);
        var location = anchor._location_0;
        if (location < 0) {
          var newLocation = size_1 + location | 0;
          if (newLocation < newGapStart) {
            anchor._location_0 = size_1 + location | 0;
            var tmp0 = index;
            index = tmp0 + 1 | 0;
            Unit_getInstance();
          } else
            break $l$break_0;
        } else
          break $l$break_0;
      }
    } else {
      var index_0 = locationOf($this._anchors, newGapStart, size_1);
      $l$break_1: while (index_0 < $this._anchors._get_size__45()) {
        var anchor_0 = $this._anchors.get_66(index_0);
        var location_0 = anchor_0._location_0;
        if (location_0 >= 0) {
          anchor_0._location_0 = -(size_1 - location_0 | 0) | 0;
          var tmp1 = index_0;
          index_0 = tmp1 + 1 | 0;
          Unit_getInstance();
        } else
          break $l$break_1;
      }
    }
  }
  function removeAnchors($this, gapStart, size_1) {
    var gapLen = $this._groupGapLen;
    var removeEnd = gapStart + size_1 | 0;
    var groupsSize = _get_capacity_($this) - gapLen | 0;
    var tmp0_let_0 = locationOf($this._anchors, gapStart + size_1 | 0, groupsSize);
    var index = tmp0_let_0 >= $this._anchors._get_size__45() ? tmp0_let_0 - 1 | 0 : tmp0_let_0;
    var removeAnchorEnd = 0;
    var removeAnchorStart = index + 1 | 0;
    $l$break: while (index >= 0) {
      var anchor = $this._anchors.get_66(index);
      var location = $this.anchorIndex_0(anchor);
      if (location >= gapStart) {
        if (location < removeEnd) {
          anchor._location_0 = IntCompanionObject_getInstance()._MIN_VALUE;
          removeAnchorStart = index;
          if (removeAnchorEnd === 0)
            removeAnchorEnd = index + 1 | 0;
        }var tmp0 = index;
        index = tmp0 - 1 | 0;
        Unit_getInstance();
      } else
        break $l$break;
    }
    var tmp1_also_0 = removeAnchorStart < removeAnchorEnd;
    if (tmp1_also_0)
      $this._anchors.subList_0(removeAnchorStart, removeAnchorEnd).clear_7();
    return tmp1_also_0;
  }
  function moveAnchors($this, originalLocation, newLocation, size_1) {
    var end_0 = originalLocation + size_1 | 0;
    var groupsSize = $this._get_size__45();
    var index = locationOf($this._anchors, originalLocation, groupsSize);
    var removedAnchors = ArrayList_init_$Create$();
    if (index >= 0) {
      $l$break: while (index < $this._anchors._get_size__45()) {
        var anchor = $this._anchors.get_66(index);
        var location = $this.anchorIndex_0(anchor);
        if (location >= originalLocation ? location < end_0 : false) {
          removedAnchors.add_37(anchor);
          Unit_getInstance();
          $this._anchors.removeAt_7(index);
          Unit_getInstance();
        } else
          break $l$break;
      }
    }var moveDelta = newLocation - originalLocation | 0;
    var inductionVariable = 0;
    var last = removedAnchors._get_size__45() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item_4 = removedAnchors.get_66(index_3);
        var anchorIndex_6 = $this.anchorIndex_0(item_4);
        var newAnchorIndex_7 = anchorIndex_6 + moveDelta | 0;
        if (newAnchorIndex_7 >= $this._groupGapStart) {
          item_4._location_0 = -(groupsSize - newAnchorIndex_7 | 0) | 0;
        } else {
          item_4._location_0 = newAnchorIndex_7;
        }
        var insertIndex_8 = locationOf($this._anchors, newAnchorIndex_7, groupsSize);
        $this._anchors.add_39(insertIndex_8, item_4);
      }
       while (inductionVariable <= last);
  }
  function _get_capacity_($this) {
    return $this._groups.length / 5 | 0;
  }
  function groupIndexToAddress($this, index) {
    return index < $this._groupGapStart ? index : index + $this._groupGapLen | 0;
  }
  function dataIndexToDataAddress($this, dataIndex_1) {
    return dataIndex_1 < $this._slotsGapStart ? dataIndex_1 : dataIndex_1 + $this._slotsGapLen | 0;
  }
  function parent(_this_, $this, index) {
    return parentAnchorToIndex($this, parentAnchor(_this_, groupIndexToAddress($this, index)));
  }
  function dataIndex($this, index) {
    return dataIndex_0($this._groups, $this, groupIndexToAddress($this, index));
  }
  function dataIndex_0(_this_, $this, address) {
    return address >= _get_capacity_($this) ? $this._slots_0.length - $this._slotsGapLen | 0 : dataAnchorToDataIndex($this, dataAnchor(_this_, address), $this._slotsGapLen, $this._slots_0.length);
  }
  function slotIndex(_this_, $this, address) {
    return address >= _get_capacity_($this) ? $this._slots_0.length - $this._slotsGapLen | 0 : dataAnchorToDataIndex($this, slotAnchor(_this_, address), $this._slotsGapLen, $this._slots_0.length);
  }
  function updateDataIndex(_this_, $this, address, dataIndex_1) {
    updateDataAnchor(_this_, address, dataIndexToDataAnchor($this, dataIndex_1, $this._slotsGapStart, $this._slotsGapLen, $this._slots_0.length));
  }
  function nodeIndex(_this_, $this, address) {
    return dataIndex_0(_this_, $this, address);
  }
  function auxIndex(_this_, $this, address) {
    return dataIndex_0(_this_, $this, address) + countOneBits_0(groupInfo(_this_, address) >> 29) | 0;
  }
  function dataIndexToDataAnchor($this, index, gapStart, gapLen, capacity) {
    return index > gapStart ? -(((capacity - gapLen | 0) - index | 0) + 1 | 0) | 0 : index;
  }
  function dataAnchorToDataIndex($this, anchor, gapLen, capacity) {
    return anchor < 0 ? ((capacity - gapLen | 0) + anchor | 0) + 1 | 0 : anchor;
  }
  function parentIndexToAnchor($this, index, gapStart) {
    return index < gapStart ? index : -(($this._get_size__45() - index | 0) - -2 | 0) | 0;
  }
  function parentAnchorToIndex($this, index) {
    return index > -2 ? index : ($this._get_size__45() + index | 0) - -2 | 0;
  }
  function _no_name_provided__79($start, $end, this$0) {
    this._$start = $start;
    this._$end = $end;
    this._this$0_20 = this$0;
    this._current_0 = this._$start;
  }
  _no_name_provided__79.prototype.hasNext_27 = function () {
    return this._current_0 < this._$end;
  };
  _no_name_provided__79.prototype.next_28 = function () {
    var tmp;
    if (this.hasNext_27()) {
      var tmp_0 = this._this$0_20._slots_0;
      var tmp0_this = this;
      var tmp1 = tmp0_this._current_0;
      tmp0_this._current_0 = tmp1 + 1 | 0;
      tmp = tmp_0[dataIndexToDataAddress(this._this$0_20, tmp1)];
    } else {
      tmp = null;
    }
    return tmp;
  };
  _no_name_provided__79.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function SlotWriter(table) {
    this._table = table;
    this._groups = this._table._groups_0;
    this._slots_0 = this._table._slots_1;
    this._anchors = this._table._anchors_0;
    this._groupGapStart = this._table._groupsSize;
    this._groupGapLen = (this._groups.length / 5 | 0) - this._table._groupsSize | 0;
    this._currentGroupEnd = this._table._groupsSize;
    this._currentSlot = 0;
    this._currentSlotEnd = 0;
    this._slotsGapStart = this._table._slotsSize;
    this._slotsGapLen = this._slots_0.length - this._table._slotsSize | 0;
    this._slotsGapOwner = this._table._groupsSize;
    this._insertCount = 0;
    this._nodeCount_0 = 0;
    this._startStack = new IntStack();
    this._endStack = new IntStack();
    this._nodeCountStack = new IntStack();
    this._currentGroup = 0;
    this._parent_1 = -1;
    this._closed = false;
  }
  SlotWriter.prototype.groupKey_1 = function (index) {
    return key(this._groups, groupIndexToAddress(this, index));
  };
  SlotWriter.prototype.groupObjectKey_1 = function (index) {
    var address = groupIndexToAddress(this, index);
    return hasObjectKey(this._groups, address) ? this._slots_0[objectKeyIndex(this._groups, address)] : null;
  };
  SlotWriter.prototype.groupSize_1 = function (index) {
    return groupSize(this._groups, groupIndexToAddress(this, index));
  };
  SlotWriter.prototype.node_1 = function (index) {
    var address = groupIndexToAddress(this, index);
    return isNode(this._groups, address) ? this._slots_0[dataIndexToDataAddress(this, nodeIndex(this._groups, this, address))] : null;
  };
  SlotWriter.prototype.node_0 = function (anchor) {
    return this.node_1(anchor.toIndexFor_0(this));
  };
  SlotWriter.prototype.parent_1 = function (index) {
    return parent(this._groups, this, index);
  };
  SlotWriter.prototype.close_7 = function () {
    this._closed = true;
    moveGroupGapTo(this, this._get_size__45());
    moveSlotGapTo(this, this._slots_0.length - this._slotsGapLen | 0, this._groupGapStart);
    this._table.close_2(this, this._groups, this._groupGapStart, this._slots_0, this._slotsGapStart, this._anchors);
  };
  SlotWriter.prototype.update_0 = function (value_0) {
    var result = this.skip();
    this.set_9(value_0);
    return result;
  };
  SlotWriter.prototype.updateAux = function (value_0) {
    var address = groupIndexToAddress(this, this._currentGroup);
    var tmp0_check_0 = hasAux(this._groups, address);
    if (!tmp0_check_0) {
      var message_1 = 'Updating the data of a group that was not created with a data slot';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }this._slots_0[dataIndexToDataAddress(this, auxIndex(this._groups, this, address))] = value_0;
  };
  SlotWriter.prototype.updateNode = function (value_0) {
    return updateNodeOfGroup(this, this._currentGroup, value_0);
  };
  SlotWriter.prototype.updateNode_0 = function (anchor, value_0) {
    return updateNodeOfGroup(this, anchor.toIndexFor_0(this), value_0);
  };
  SlotWriter.prototype.set_9 = function (value_0) {
    var tmp0_check_0 = this._currentSlot <= this._currentSlotEnd;
    if (!tmp0_check_0) {
      var message_1 = 'Writing to an invalid slot';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }this._slots_0[dataIndexToDataAddress(this, this._currentSlot - 1 | 0)] = value_0;
  };
  SlotWriter.prototype.set_10 = function (index, value_0) {
    var address = groupIndexToAddress(this, this._currentGroup);
    var slotsStart = slotIndex(this._groups, this, address);
    var slotsEnd = dataIndex_0(this._groups, this, groupIndexToAddress(this, this._currentGroup + 1 | 0));
    var slotsIndex = slotsStart + index | 0;
    var tmp0_check_0 = slotsIndex >= slotsStart ? slotsIndex < slotsEnd : false;
    if (!tmp0_check_0) {
      var message_1 = '' + 'Write to an invalid slot index ' + index + ' for group ' + this._currentGroup;
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var slotAddress = dataIndexToDataAddress(this, slotsIndex);
    var result = this._slots_0[slotAddress];
    this._slots_0[slotAddress] = value_0;
    return result;
  };
  SlotWriter.prototype.skip = function () {
    if (this._insertCount > 0) {
      insertSlots(this, 1, this._parent_1);
    }var tmp = this._slots_0;
    var tmp0_this = this;
    var tmp1 = tmp0_this._currentSlot;
    tmp0_this._currentSlot = tmp1 + 1 | 0;
    return tmp[dataIndexToDataAddress(this, tmp1)];
  };
  SlotWriter.prototype.advanceBy = function (amount) {
    var tmp0_require_0 = amount >= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot seek backwards';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_check_0 = this._insertCount <= 0;
    if (!tmp1_check_0) {
      var message_1_0 = 'Cannot call seek() while inserting';
      throw IllegalStateException_init_$Create$(toString_1(message_1_0));
    }var index = this._currentGroup + amount | 0;
    var tmp2_check_0 = index >= this._parent_1 ? index <= this._currentGroupEnd : false;
    if (!tmp2_check_0) {
      var message_1_1 = '' + 'Cannot seek outside the current group (' + this._parent_1 + '-' + this._currentGroupEnd + ')';
      throw IllegalStateException_init_$Create$(toString_1(message_1_1));
    }this._currentGroup = index;
    var newSlot = dataIndex_0(this._groups, this, groupIndexToAddress(this, index));
    this._currentSlot = newSlot;
    this._currentSlotEnd = newSlot;
  };
  SlotWriter.prototype.skipToGroupEnd_2 = function () {
    var newGroup = this._currentGroupEnd;
    this._currentGroup = newGroup;
    this._currentSlot = dataIndex_0(this._groups, this, groupIndexToAddress(this, newGroup));
  };
  SlotWriter.prototype.beginInsert = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._insertCount;
    tmp0_this._insertCount = tmp1 + 1 | 0;
    if (tmp1 === 0) {
      saveCurrentGroupEnd(this);
    } else {
    }
  };
  SlotWriter.prototype.endInsert = function () {
    var tmp0_check_0 = this._insertCount > 0;
    if (!tmp0_check_0) {
      var message_1 = 'Unbalanced begin/end insert';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var tmp0_this = this;
    tmp0_this._insertCount = tmp0_this._insertCount - 1 | 0;
    if (tmp0_this._insertCount === 0) {
      var tmp1_check_0 = this._nodeCountStack._get_size__45() === this._startStack._get_size__45();
      if (!tmp1_check_0) {
        var message_1_0 = 'startGroup/endGroup mismatch while inserting';
        throw IllegalStateException_init_$Create$(toString_1(message_1_0));
      }restoreCurrentGroupEnd(this);
      Unit_getInstance();
    } else {
    }
  };
  SlotWriter.prototype.startGroup_1 = function () {
    var tmp0_require_0 = this._insertCount === 0;
    if (!tmp0_require_0) {
      var message_1 = 'Key must be supplied when inserting';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }startGroup_1(this, 0, Companion_getInstance_11()._Empty, false, Companion_getInstance_11()._Empty);
  };
  SlotWriter.prototype.startGroup_0 = function (key_0, dataKey) {
    return startGroup_1(this, key_0, dataKey, false, Companion_getInstance_11()._Empty);
  };
  SlotWriter.prototype.startNode_1 = function (key_0) {
    return startGroup_1(this, 125, key_0, true, Companion_getInstance_11()._Empty);
  };
  SlotWriter.prototype.startData = function (key_0, objectKey_0, aux_0) {
    return startGroup_1(this, key_0, objectKey_0, false, aux_0);
  };
  SlotWriter.prototype.endGroup_0 = function () {
    var inserting = this._insertCount > 0;
    var currentGroup = this._currentGroup;
    var currentGroupEnd = this._currentGroupEnd;
    var groupIndex = this._parent_1;
    var groupAddress = groupIndexToAddress(this, groupIndex);
    var newNodes = this._nodeCount_0;
    var newGroupSize = currentGroup - groupIndex | 0;
    var isNode_0 = isNode(this._groups, groupAddress);
    if (inserting) {
      updateGroupSize(this._groups, groupAddress, newGroupSize);
      updateNodeCount_0(this._groups, groupAddress, newNodes);
      this._nodeCount_0 = this._nodeCountStack.pop_0() + (isNode_0 ? 1 : newNodes) | 0;
      this._parent_1 = parent(this._groups, this, groupIndex);
    } else {
      var tmp0_require_0 = currentGroup === currentGroupEnd;
      if (!tmp0_require_0) {
        var message_1 = 'Expected to be at the end of a group';
        throw IllegalArgumentException_init_$Create$(toString_1(message_1));
      }var oldGroupSize = groupSize(this._groups, groupAddress);
      var oldNodes = nodeCount(this._groups, groupAddress);
      updateGroupSize(this._groups, groupAddress, newGroupSize);
      updateNodeCount_0(this._groups, groupAddress, newNodes);
      var newParent = this._startStack.pop_0();
      restoreCurrentGroupEnd(this);
      Unit_getInstance();
      this._parent_1 = newParent;
      var groupParent = parent(this._groups, this, groupIndex);
      this._nodeCount_0 = this._nodeCountStack.pop_0();
      if (groupParent === newParent) {
        var tmp0_this = this;
        tmp0_this._nodeCount_0 = tmp0_this._nodeCount_0 + (isNode_0 ? 0 : newNodes - oldNodes | 0) | 0;
      } else {
        var groupSizeDelta = newGroupSize - oldGroupSize | 0;
        var nodesDelta = isNode_0 ? 0 : newNodes - oldNodes | 0;
        if (!(groupSizeDelta === 0) ? true : !(nodesDelta === 0)) {
          var current_0 = groupParent;
          while ((!(current_0 === 0) ? !(current_0 === newParent) : false) ? !(nodesDelta === 0) ? true : !(groupSizeDelta === 0) : false) {
            var currentAddress = groupIndexToAddress(this, current_0);
            if (!(groupSizeDelta === 0)) {
              var newSize = groupSize(this._groups, currentAddress) + groupSizeDelta | 0;
              updateGroupSize(this._groups, currentAddress, newSize);
            }if (!(nodesDelta === 0)) {
              updateNodeCount_0(this._groups, currentAddress, nodeCount(this._groups, currentAddress) + nodesDelta | 0);
            }if (isNode(this._groups, currentAddress))
              nodesDelta = 0;
            current_0 = parent(this._groups, this, current_0);
          }
        }var tmp1_this = this;
        tmp1_this._nodeCount_0 = tmp1_this._nodeCount_0 + nodesDelta | 0;
      }
    }
    return newNodes;
  };
  SlotWriter.prototype.ensureStarted = function (index) {
    var tmp0_require_0 = this._insertCount <= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot call ensureStarted() while inserting';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var parent_0 = this._parent_1;
    if (!(parent_0 === index)) {
      var tmp1_require_0 = index >= parent_0 ? index < this._currentGroupEnd : false;
      if (!tmp1_require_0) {
        var message_1_0 = '' + 'Started group must be a subgroup of the group at ' + parent_0;
        throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
      }var oldCurrent = this._currentGroup;
      var oldCurrentSlot = this._currentSlot;
      var oldCurrentSlotEnd = this._currentSlotEnd;
      this._currentGroup = index;
      this.startGroup_1();
      this._currentGroup = oldCurrent;
      this._currentSlot = oldCurrentSlot;
      this._currentSlotEnd = oldCurrentSlotEnd;
    }};
  SlotWriter.prototype.ensureStarted_0 = function (anchor) {
    return this.ensureStarted(anchor.toIndexFor_0(this));
  };
  SlotWriter.prototype.skipGroup_0 = function () {
    var groupAddress = groupIndexToAddress(this, this._currentGroup);
    var newGroup = this._currentGroup + groupSize(this._groups, groupAddress) | 0;
    this._currentGroup = newGroup;
    this._currentSlot = dataIndex_0(this._groups, this, groupIndexToAddress(this, newGroup));
    return isNode(this._groups, groupAddress) ? 1 : nodeCount(this._groups, groupAddress);
  };
  SlotWriter.prototype.removeGroup = function () {
    var tmp0_require_0 = this._insertCount === 0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot remove group while inserting';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var oldGroup = this._currentGroup;
    var oldSlot = this._currentSlot;
    var count = this.skipGroup_0();
    var anchorsRemoved = removeGroups(this, oldGroup, this._currentGroup - oldGroup | 0);
    removeSlots(this, oldSlot, this._currentSlot - oldSlot | 0, oldGroup - 1 | 0);
    this._currentGroup = oldGroup;
    this._currentSlot = oldSlot;
    var tmp0_this = this;
    tmp0_this._nodeCount_0 = tmp0_this._nodeCount_0 - count | 0;
    return anchorsRemoved;
  };
  SlotWriter.prototype.groupSlots = function () {
    var start_0 = dataIndex_0(this._groups, this, groupIndexToAddress(this, this._currentGroup));
    var end_0 = dataIndex_0(this._groups, this, groupIndexToAddress(this, this._currentGroup + this.groupSize_1(this._currentGroup) | 0));
    return new _no_name_provided__79(start_0, end_0, this);
  };
  SlotWriter.prototype.moveGroup = function (offset_0) {
    var tmp0_require_0 = this._insertCount === 0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot move a group while inserting';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = offset_0 >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = 'Parameter offset is out of bounds';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }if (offset_0 === 0)
      return Unit_getInstance();
    var current_0 = this._currentGroup;
    var parent_0 = this._parent_1;
    var parentEnd = this._currentGroupEnd;
    var count = offset_0;
    var groupToMove = current_0;
    while (count > 0) {
      groupToMove = groupToMove + groupSize(this._groups, groupIndexToAddress(this, groupToMove)) | 0;
      var tmp2_require_0 = groupToMove <= parentEnd;
      if (!tmp2_require_0) {
        var message_1_1 = 'Parameter offset is out of bounds';
        throw IllegalArgumentException_init_$Create$(toString_1(message_1_1));
      }var tmp0 = count;
      count = tmp0 - 1 | 0;
      Unit_getInstance();
    }
    var moveLen = groupSize(this._groups, groupIndexToAddress(this, groupToMove));
    var currentSlot = this._currentSlot;
    var dataStart = dataIndex_0(this._groups, this, groupIndexToAddress(this, groupToMove));
    var dataEnd = dataIndex_0(this._groups, this, groupIndexToAddress(this, groupToMove + moveLen | 0));
    var moveDataLen = dataEnd - dataStart | 0;
    var tmp3_max_0 = this._currentGroup - 1 | 0;
    var tmp4_max_0 = 0;
    insertSlots(this, moveDataLen, function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp3_max_0, tmp4_max_0]))));
    }.call(this));
    insertGroups(this, moveLen);
    var groups = this._groups;
    var moveLocationAddress = groupIndexToAddress(this, groupToMove + moveLen | 0);
    var moveLocationOffset = imul(moveLocationAddress, 5);
    var currentAddress = groupIndexToAddress(this, current_0);
    var tmp5_copyInto_0 = imul(currentAddress, 5);
    var tmp6_copyInto_0 = moveLocationOffset + imul(moveLen, 5) | 0;
    var tmp = groups;
    arrayCopy_0(tmp, groups, tmp5_copyInto_0, moveLocationOffset, tmp6_copyInto_0);
    Unit_getInstance();
    if (moveDataLen > 0) {
      var slots = this._slots_0;
      var tmp7_copyInto_0 = dataIndexToDataAddress(this, dataStart + moveDataLen | 0);
      var tmp8_copyInto_0 = dataIndexToDataAddress(this, dataEnd + moveDataLen | 0);
      arrayCopy_0(slots, slots, currentSlot, tmp7_copyInto_0, tmp8_copyInto_0);
      Unit_getInstance();
    }var dataMoveDistance = (dataStart + moveDataLen | 0) - currentSlot | 0;
    var slotsGapStart = this._slotsGapStart;
    var slotsGapLen = this._slotsGapLen;
    var slotsCapacity = this._slots_0.length;
    var slotsGapOwner = this._slotsGapOwner;
    var inductionVariable = current_0;
    var last = current_0 + moveLen | 0;
    if (inductionVariable < last)
      do {
        var group = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var groupAddress = groupIndexToAddress(this, group);
        var oldIndex = dataIndex_0(groups, this, groupAddress);
        var newIndex = oldIndex - dataMoveDistance | 0;
        var newAnchor = dataIndexToDataAnchor(this, newIndex, slotsGapOwner < groupAddress ? 0 : slotsGapStart, slotsGapLen, slotsCapacity);
        updateDataIndex(groups, this, groupAddress, newAnchor);
      }
       while (inductionVariable < last);
    moveAnchors(this, groupToMove + moveLen | 0, current_0, moveLen);
    var anchorsRemoved = removeGroups(this, groupToMove + moveLen | 0, moveLen);
    var tmp9_check_0 = !anchorsRemoved;
    if (!tmp9_check_0) {
      var message_1_2 = 'Unexpectedly removed anchors';
      throw IllegalStateException_init_$Create$(toString_1(message_1_2));
    }fixParentAnchorsFor(this, parent_0, this._currentGroupEnd, current_0);
    if (moveDataLen > 0) {
      removeSlots(this, dataStart + moveDataLen | 0, moveDataLen, (groupToMove + moveLen | 0) - 1 | 0);
    }};
  SlotWriter.prototype.moveFrom = function (table, index) {
    var tmp0_require_0 = this._insertCount > 0;
    if (!tmp0_require_0) {
      var message_2_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2_1));
    }if ((index === 0 ? this._currentGroup === 0 : false) ? this._table._groupsSize === 0 : false) {
      var myGroups = this._groups;
      var mySlots = this._slots_0;
      var myAnchors = this._anchors;
      var groups = table._groups_0;
      var groupsSize = table._groupsSize;
      var slots = table._slots_1;
      var slotsSize = table._slotsSize;
      this._groups = groups;
      this._slots_0 = slots;
      this._anchors = table._anchors_0;
      this._groupGapStart = groupsSize;
      this._groupGapLen = (groups.length / 5 | 0) - groupsSize | 0;
      this._slotsGapStart = slotsSize;
      this._slotsGapLen = slots.length - slotsSize | 0;
      this._slotsGapOwner = groupsSize;
      table.setTo(myGroups, 0, mySlots, 0, myAnchors);
      return this._anchors;
    }var tmp1_let_0 = table.openWriter();
    var tmp;
    try {
      var groupsToMove_3 = tmp1_let_0.groupSize_1(index);
      var sourceGroupsEnd_4 = index + groupsToMove_3 | 0;
      var sourceSlotsStart_5 = dataIndex(tmp1_let_0, index);
      var sourceSlotsEnd_6 = dataIndex(tmp1_let_0, sourceGroupsEnd_4);
      var slotsToMove_7 = sourceSlotsEnd_6 - sourceSlotsStart_5 | 0;
      insertGroups(this, groupsToMove_3);
      insertSlots(this, slotsToMove_7, this._currentGroup);
      var groups_8 = this._groups;
      var currentGroup_9 = this._currentGroup;
      var tmp0_copyInto_0_10 = tmp1_let_0._groups;
      var tmp1_copyInto_0_11 = imul(currentGroup_9, 5);
      var tmp2_copyInto_0_12 = imul(index, 5);
      var tmp3_copyInto_0_13 = imul(sourceGroupsEnd_4, 5);
      var tmp_0 = tmp0_copyInto_0_10;
      arrayCopy_0(tmp_0, groups_8, tmp1_copyInto_0_11, tmp2_copyInto_0_12, tmp3_copyInto_0_13);
      Unit_getInstance();
      var slots_14 = this._slots_0;
      var currentSlot_15 = this._currentSlot;
      var tmp4_copyInto_0_16 = tmp1_let_0._slots_0;
      arrayCopy_0(tmp4_copyInto_0_16, slots_14, currentSlot_15, sourceSlotsStart_5, sourceSlotsEnd_6);
      Unit_getInstance();
      updateParentAnchor(groups_8, currentGroup_9, this._parent_1);
      var parentDelta_17 = currentGroup_9 - index | 0;
      var moveEnd_18 = currentGroup_9 + groupsToMove_3 | 0;
      var dataIndexDelta_19 = currentSlot_15 - dataIndex_0(groups_8, this, currentGroup_9) | 0;
      var slotsGapOwner_20 = this._slotsGapOwner;
      var slotsGapLen_21 = this._slotsGapLen;
      var slotsCapacity_22 = slots_14.length;
      var inductionVariable = currentGroup_9;
      if (inductionVariable < moveEnd_18)
        do {
          var groupAddress_24 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(groupAddress_24 === currentGroup_9)) {
            var previousParent_25 = parentAnchor(groups_8, groupAddress_24);
            updateParentAnchor(groups_8, groupAddress_24, previousParent_25 + parentDelta_17 | 0);
          }var newDataIndex_26 = dataIndex_0(groups_8, this, groupAddress_24) + dataIndexDelta_19 | 0;
          var newDataAnchor_27 = dataIndexToDataAnchor(this, newDataIndex_26, slotsGapOwner_20 < groupAddress_24 ? 0 : this._slotsGapStart, slotsGapLen_21, slotsCapacity_22);
          updateDataAnchor(groups_8, groupAddress_24, newDataAnchor_27);
          if (groupAddress_24 === slotsGapOwner_20) {
            var tmp1_28 = slotsGapOwner_20;
            slotsGapOwner_20 = tmp1_28 + 1 | 0;
            Unit_getInstance();
          }}
         while (inductionVariable < moveEnd_18);
      this._slotsGapOwner = slotsGapOwner_20;
      var startAnchors_29 = locationOf(table._anchors_0, index, table._groupsSize);
      var endAnchors_30 = locationOf(table._anchors_0, sourceGroupsEnd_4, table._groupsSize);
      var tmp_1;
      if (startAnchors_29 < endAnchors_30) {
        var sourceAnchors_32 = table._anchors_0;
        var anchors_33 = ArrayList_init_$Create$_0(endAnchors_30 - startAnchors_29 | 0);
        var anchorDelta_34 = currentGroup_9 - index | 0;
        var inductionVariable_0 = startAnchors_29;
        if (inductionVariable_0 < endAnchors_30)
          do {
            var anchorIndex_36 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var sourceAnchor_37 = sourceAnchors_32.get_66(anchorIndex_36);
            var tmp3_this_38 = sourceAnchor_37;
            tmp3_this_38._location_0 = tmp3_this_38._location_0 + anchorDelta_34 | 0;
            anchors_33.add_37(sourceAnchor_37);
            Unit_getInstance();
          }
           while (inductionVariable_0 < endAnchors_30);
        var insertLocation_39 = locationOf(this._anchors, this._currentGroup, this._get_size__45());
        this._table._anchors_0.addAll_5(insertLocation_39, anchors_33);
        Unit_getInstance();
        sourceAnchors_32.subList_0(startAnchors_29, endAnchors_30).clear_7();
        tmp_1 = anchors_33;
      } else {
        tmp_1 = emptyList();
      }
      var anchors_31 = tmp_1;
      var parentGroup_40 = tmp1_let_0.parent_1(index);
      if (parentGroup_40 >= 0) {
        tmp1_let_0.startGroup_1();
        tmp1_let_0.advanceBy(parentGroup_40 - tmp1_let_0._currentGroup | 0);
        tmp1_let_0.startGroup_1();
      }tmp1_let_0.advanceBy(index - tmp1_let_0._currentGroup | 0);
      var anchorsRemoved_41 = tmp1_let_0.removeGroup();
      if (parentGroup_40 >= 0) {
        tmp1_let_0.skipToGroupEnd_2();
        tmp1_let_0.endGroup_0();
        Unit_getInstance();
        tmp1_let_0.skipToGroupEnd_2();
        tmp1_let_0.endGroup_0();
        Unit_getInstance();
      }var tmp5_check_0_42 = !anchorsRemoved_41;
      if (!tmp5_check_0_42) {
        var message_1_43 = 'Unexpectedly removed anchors';
        throw IllegalStateException_init_$Create$(toString_1(message_1_43));
      }var tmp4_this_44 = this;
      tmp4_this_44._nodeCount_0 = tmp4_this_44._nodeCount_0 + nodeCount(groups_8, currentGroup_9) | 0;
      this._currentGroup = currentGroup_9 + groupsToMove_3 | 0;
      this._currentSlot = currentSlot_15 + slotsToMove_7 | 0;
      tmp = anchors_31;
    }finally {
      tmp1_let_0.close_7();
    }
    return tmp;
  };
  SlotWriter.prototype.anchor_0 = function (index) {
    var tmp0_getOrAdd_0 = this._anchors;
    var tmp1_getOrAdd_0 = this._get_size__45();
    var location_1 = search(tmp0_getOrAdd_0, index, tmp1_getOrAdd_0);
    var tmp;
    if (location_1 < 0) {
      var anchor_2 = new Anchor(index <= this._groupGapStart ? index : -(this._get_size__45() - index | 0) | 0);
      tmp0_getOrAdd_0.add_39(-(location_1 + 1 | 0) | 0, anchor_2);
      tmp = anchor_2;
    } else {
      tmp = tmp0_getOrAdd_0.get_66(location_1);
    }
    return tmp;
  };
  SlotWriter.prototype.anchorIndex_0 = function (anchor) {
    var tmp0_let_0 = anchor._location_0;
    return tmp0_let_0 < 0 ? this._get_size__45() + tmp0_let_0 | 0 : tmp0_let_0;
  };
  SlotWriter.prototype.toString = function () {
    return '' + 'SlotWriter(current = ' + this._currentGroup + ' end=' + this._currentGroupEnd + ' size = ' + this._get_size__45() + ' ' + ('' + 'gap=' + this._groupGapStart + '-' + (this._groupGapStart + this._groupGapLen | 0) + ')');
  };
  SlotWriter.prototype._get_size__45 = function () {
    return _get_capacity_(this) - this._groupGapLen | 0;
  };
  SlotWriter.$metadata$ = {
    simpleName: 'SlotWriter',
    kind: 'class',
    interfaces: []
  };
  function SlotTable() {
    this._groups_0 = new Int32Array(0);
    this._groupsSize = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 0;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = null;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._slots_1 = tmp_2;
    this._slotsSize = 0;
    this._readers = 0;
    this._writer_0 = false;
    this._version = 0;
    var tmp_4 = this;
    tmp_4._anchors_0 = ArrayList_init_$Create$();
  }
  SlotTable.prototype._get_isEmpty__3 = function () {
    return this._groupsSize === 0;
  };
  SlotTable.prototype.openReader = function () {
    if (this._writer_0) {
      var tmp0_error_0 = 'Cannot read while a writer is pending';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    }var tmp0_this = this;
    var tmp1 = tmp0_this._readers;
    tmp0_this._readers = tmp1 + 1 | 0;
    Unit_getInstance();
    return new SlotReader(this);
  };
  SlotTable.prototype.openWriter = function () {
    var tmp0_check_0 = !this._writer_0;
    if (!tmp0_check_0) {
      var message_1 = 'Cannot start a writer when another writer is pending';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var tmp1_check_0 = this._readers <= 0;
    if (!tmp1_check_0) {
      var message_1_0 = 'Cannot start a writer when a reader is pending';
      throw IllegalStateException_init_$Create$(toString_1(message_1_0));
    }this._writer_0 = true;
    var tmp0_this = this;
    var tmp1 = tmp0_this._version;
    tmp0_this._version = tmp1 + 1 | 0;
    Unit_getInstance();
    return new SlotWriter(this);
  };
  SlotTable.prototype.anchorIndex_0 = function (anchor) {
    var tmp0_check_0 = !this._writer_0;
    if (!tmp0_check_0) {
      var message_1 = 'Use active SlotWriter to determine anchor location instead';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = anchor._get_valid__0();
    if (!tmp1_require_0) {
      var message_1_0 = 'Anchor refers to a group that was removed';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }return anchor._location_0;
  };
  SlotTable.prototype.ownsAnchor = function (anchor) {
    var tmp;
    if (anchor._get_valid__0()) {
      var tmp0_let_0 = search(this._anchors_0, anchor._location_0, this._groupsSize);
      tmp = tmp0_let_0 >= 0 ? equals(this._anchors_0.get_66(tmp0_let_0), anchor) : false;
    } else {
      tmp = false;
    }
    return tmp;
  };
  SlotTable.prototype.close_1 = function (reader) {
    var tmp0_require_0 = reader._table_0 === this ? this._readers > 0 : false;
    if (!tmp0_require_0) {
      var message_1 = 'Unexpected reader close()';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp0_this = this;
    var tmp1 = tmp0_this._readers;
    tmp0_this._readers = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  SlotTable.prototype.close_2 = function (writer, groups, groupsSize, slots, slotsSize, anchors) {
    var tmp0_require_0 = writer._table === this ? this._writer_0 : false;
    if (!tmp0_require_0) {
      var message_1 = 'Unexpected writer close()';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }this._writer_0 = false;
    this.setTo(groups, groupsSize, slots, slotsSize, anchors);
  };
  SlotTable.prototype.setTo = function (groups, groupsSize, slots, slotsSize, anchors) {
    this._groups_0 = groups;
    this._groupsSize = groupsSize;
    this._slots_1 = slots;
    this._slotsSize = slotsSize;
    this._anchors_0 = anchors;
  };
  SlotTable.prototype.iterator_46 = function () {
    return new GroupIterator(this, 0, this._groupsSize);
  };
  SlotTable.$metadata$ = {
    simpleName: 'SlotTable',
    kind: 'class',
    interfaces: [CompositionData, Iterable]
  };
  function Anchor(loc) {
    this._location_0 = loc;
  }
  Anchor.prototype._get_valid__0 = function () {
    return !(this._location_0 === IntCompanionObject_getInstance()._MIN_VALUE);
  };
  Anchor.prototype.toIndexFor = function (slots) {
    return slots.anchorIndex_0(this);
  };
  Anchor.prototype.toIndexFor_0 = function (writer) {
    return writer.anchorIndex_0(this);
  };
  Anchor.$metadata$ = {
    simpleName: 'Anchor',
    kind: 'class',
    interfaces: []
  };
  function isNode(_this_, address) {
    return !((_this_[imul(address, 5) + 1 | 0] & 1073741824) === 0);
  }
  function key(_this_, address) {
    return _this_[imul(address, 5)];
  }
  function hasObjectKey(_this_, address) {
    return !((_this_[imul(address, 5) + 1 | 0] & 536870912) === 0);
  }
  function objectKeyIndex(_this_, address) {
    var tmp0_let_0 = imul(address, 5);
    return _this_[tmp0_let_0 + 4 | 0] + countOneBits_0(_this_[tmp0_let_0 + 1 | 0] >> 30) | 0;
  }
  function groupSize(_this_, address) {
    return _this_[imul(address, 5) + 3 | 0];
  }
  function hasAux(_this_, address) {
    return !((_this_[imul(address, 5) + 1 | 0] & 268435456) === 0);
  }
  function initGroup(_this_, address, key_0, isNode_0, hasDataKey, hasData, parentAnchor_0, dataAnchor_0) {
    var nodeBit = isNode_0 ? 1073741824 : 0;
    var dataKeyBit = hasDataKey ? 536870912 : 0;
    var dataBit = hasData ? 268435456 : 0;
    var arrayIndex = imul(address, 5);
    _this_[arrayIndex + 0 | 0] = key_0;
    _this_[arrayIndex + 1 | 0] = nodeBit | dataKeyBit | dataBit;
    _this_[arrayIndex + 2 | 0] = parentAnchor_0;
    _this_[arrayIndex + 3 | 0] = 0;
    _this_[arrayIndex + 4 | 0] = dataAnchor_0;
  }
  function nodeCount(_this_, address) {
    return _this_[imul(address, 5) + 1 | 0] & 134217727;
  }
  function updateGroupSize(_this_, address, value_0) {
    var tmp0_require_0 = value_0 >= 0;
    if (!tmp0_require_0) {
      var message_2_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2_1));
    }_this_[imul(address, 5) + 3 | 0] = value_0;
  }
  function updateNodeCount_0(_this_, address, value_0) {
    var tmp0_require_0 = value_0 >= 0 ? value_0 < 134217727 : false;
    if (!tmp0_require_0) {
      var message_2_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2_1));
    }_this_[imul(address, 5) + 1 | 0] = _this_[imul(address, 5) + 1 | 0] & -134217728 | value_0;
  }
  function updateParentAnchor(_this_, address, value_0) {
    _this_[imul(address, 5) + 2 | 0] = value_0;
  }
  function parentAnchor(_this_, address) {
    return _this_[imul(address, 5) + 2 | 0];
  }
  function updateDataAnchor(_this_, address, anchor) {
    _this_[imul(address, 5) + 4 | 0] = anchor;
  }
  function locationOf(_this_, index, effectiveSize) {
    var tmp0_let_0 = search(_this_, index, effectiveSize);
    return tmp0_let_0 >= 0 ? tmp0_let_0 : -(tmp0_let_0 + 1 | 0) | 0;
  }
  function dataAnchor(_this_, address) {
    return _this_[imul(address, 5) + 4 | 0];
  }
  function slotAnchor(_this_, address) {
    var tmp0_let_0 = imul(address, 5);
    return _this_[tmp0_let_0 + 4 | 0] + countOneBits_0(_this_[tmp0_let_0 + 1 | 0] >> 28) | 0;
  }
  function countOneBits_0(value_0) {
    var tmp0_subject = value_0;
    switch (tmp0_subject) {
      case 0:
        return 0;
      case 1:
        return 1;
      case 2:
        return 1;
      case 3:
        return 2;
      case 4:
        return 1;
      case 5:
        return 2;
      case 6:
        return 2;
      default:return 3;
    }
  }
  function groupInfo(_this_, address) {
    return _this_[imul(address, 5) + 1 | 0];
  }
  function node(_this_, $this, index) {
    var tmp;
    if (isNode(_this_, index)) {
      tmp = $this._slots_2[nodeIndex_0(_this_, index)];
    } else {
      tmp = Companion_getInstance_11()._Empty;
    }
    return tmp;
  }
  function aux(_this_, $this, index) {
    var tmp;
    if (hasAux(_this_, index)) {
      tmp = $this._slots_2[auxIndex_0(_this_, index)];
    } else {
      tmp = Companion_getInstance_11()._Empty;
    }
    return tmp;
  }
  function objectKey(_this_, $this, index) {
    var tmp;
    if (hasObjectKey(_this_, index)) {
      tmp = $this._slots_2[objectKeyIndex(_this_, index)];
    } else {
      tmp = null;
    }
    return tmp;
  }
  function SlotReader(table) {
    this._table_0 = table;
    this._groups_1 = this._table_0._groups_0;
    this._groupsSize_0 = this._table_0._groupsSize;
    this._slots_2 = this._table_0._slots_1;
    this._slotsSize_0 = this._table_0._slotsSize;
    this._currentGroup_0 = 0;
    this._currentEnd = this._groupsSize_0;
    this._parent_2 = -1;
    this._emptyCount = 0;
    this._currentSlot_0 = 0;
    this._currentSlotEnd_0 = 0;
  }
  SlotReader.prototype._get_size__45 = function () {
    return this._groupsSize_0;
  };
  SlotReader.prototype.parent_1 = function (index) {
    return parentAnchor(this._groups_1, index);
  };
  SlotReader.prototype._get_isNode_ = function () {
    return isNode(this._groups_1, this._currentGroup_0);
  };
  SlotReader.prototype.isNode_0 = function (index) {
    return isNode(this._groups_1, index);
  };
  SlotReader.prototype.nodeCount = function (index) {
    return nodeCount(this._groups_1, index);
  };
  SlotReader.prototype.node_1 = function (index) {
    return isNode(this._groups_1, index) ? node(this._groups_1, this, index) : null;
  };
  SlotReader.prototype._get_isGroupEnd_ = function () {
    return this._get_inEmpty_() ? true : this._currentGroup_0 === this._currentEnd;
  };
  SlotReader.prototype._get_inEmpty_ = function () {
    return this._emptyCount > 0;
  };
  SlotReader.prototype._get_groupSize_ = function () {
    return groupSize(this._groups_1, this._currentGroup_0);
  };
  SlotReader.prototype.groupSize_1 = function (index) {
    return groupSize(this._groups_1, index);
  };
  SlotReader.prototype._get_groupEnd_ = function () {
    return this._currentEnd;
  };
  SlotReader.prototype._get_groupKey_ = function () {
    var tmp;
    if (this._currentGroup_0 < this._currentEnd) {
      tmp = key(this._groups_1, this._currentGroup_0);
    } else {
      tmp = 0;
    }
    return tmp;
  };
  SlotReader.prototype.groupKey_1 = function (index) {
    return key(this._groups_1, index);
  };
  SlotReader.prototype._get_groupSlotIndex_ = function () {
    return this._currentSlot_0 - slotAnchor(this._groups_1, this._parent_2) | 0;
  };
  SlotReader.prototype.hasObjectKey = function (index) {
    return hasObjectKey(this._groups_1, index);
  };
  SlotReader.prototype._get_groupObjectKey_ = function () {
    return this._currentGroup_0 < this._currentEnd ? objectKey(this._groups_1, this, this._currentGroup_0) : null;
  };
  SlotReader.prototype.groupObjectKey_1 = function (index) {
    return objectKey(this._groups_1, this, index);
  };
  SlotReader.prototype._get_groupAux_ = function () {
    return this._currentGroup_0 < this._currentEnd ? aux(this._groups_1, this, this._currentGroup_0) : 0;
  };
  SlotReader.prototype._get_parentNodes_ = function () {
    return this._parent_2 >= 0 ? nodeCount(this._groups_1, this._parent_2) : 0;
  };
  SlotReader.prototype.next_28 = function () {
    if (this._emptyCount > 0 ? true : this._currentSlot_0 >= this._currentSlotEnd_0)
      return Companion_getInstance_11()._Empty;
    var tmp0_this = this;
    var tmp1 = tmp0_this._currentSlot_0;
    tmp0_this._currentSlot_0 = tmp1 + 1 | 0;
    return this._slots_2[tmp1];
  };
  SlotReader.prototype.beginEmpty = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._emptyCount;
    tmp0_this._emptyCount = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  SlotReader.prototype.endEmpty = function () {
    var tmp0_require_0 = this._emptyCount > 0;
    if (!tmp0_require_0) {
      var message_1 = 'Unbalanced begin/end empty';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp0_this = this;
    var tmp1 = tmp0_this._emptyCount;
    tmp0_this._emptyCount = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  SlotReader.prototype.close_7 = function () {
    return this._table_0.close_1(this);
  };
  SlotReader.prototype.startGroup_1 = function () {
    if (this._emptyCount <= 0) {
      var tmp0_require_0 = parentAnchor(this._groups_1, this._currentGroup_0) === this._parent_2;
      if (!tmp0_require_0) {
        var message_1 = 'Invalid slot table detected';
        throw IllegalArgumentException_init_$Create$(toString_1(message_1));
      }this._parent_2 = this._currentGroup_0;
      this._currentEnd = this._currentGroup_0 + groupSize(this._groups_1, this._currentGroup_0) | 0;
      var tmp0_this = this;
      var tmp1 = tmp0_this._currentGroup_0;
      tmp0_this._currentGroup_0 = tmp1 + 1 | 0;
      var current_0 = tmp1;
      this._currentSlot_0 = slotAnchor(this._groups_1, current_0);
      this._currentSlotEnd_0 = current_0 >= (this._groupsSize_0 - 1 | 0) ? this._slotsSize_0 : dataAnchor(this._groups_1, current_0 + 1 | 0);
    }};
  SlotReader.prototype.startNode_2 = function () {
    if (this._emptyCount <= 0) {
      var tmp0_require_0 = isNode(this._groups_1, this._currentGroup_0);
      if (!tmp0_require_0) {
        var message_1 = 'Expected a node group';
        throw IllegalArgumentException_init_$Create$(toString_1(message_1));
      }this.startGroup_1();
    }};
  SlotReader.prototype.skipGroup_0 = function () {
    var tmp0_require_0 = this._emptyCount === 0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot skip while in an empty region';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var count = isNode(this._groups_1, this._currentGroup_0) ? 1 : nodeCount(this._groups_1, this._currentGroup_0);
    var tmp0_this = this;
    tmp0_this._currentGroup_0 = tmp0_this._currentGroup_0 + groupSize(this._groups_1, this._currentGroup_0) | 0;
    return count;
  };
  SlotReader.prototype.skipToGroupEnd_2 = function () {
    var tmp0_require_0 = this._emptyCount === 0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot skip the enclosing group while in an empty region';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }this._currentGroup_0 = this._currentEnd;
  };
  SlotReader.prototype.reposition = function (index) {
    var tmp0_require_0 = this._emptyCount === 0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot reposition while in an empty region';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }this._currentGroup_0 = index;
    var parent_0 = index < this._groupsSize_0 ? parentAnchor(this._groups_1, index) : -1;
    this._parent_2 = parent_0;
    if (parent_0 < 0)
      this._currentEnd = this._groupsSize_0;
    else
      this._currentEnd = parent_0 + groupSize(this._groups_1, parent_0) | 0;
    this._currentSlot_0 = 0;
    this._currentSlotEnd_0 = 0;
  };
  SlotReader.prototype.restoreParent = function (index) {
    var newCurrentEnd = index + groupSize(this._groups_1, index) | 0;
    var current_0 = this._currentGroup_0;
    var tmp0_require_0 = current_0 >= index ? current_0 <= newCurrentEnd : false;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Index ' + index + ' is not a parent of ' + current_0;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }this._parent_2 = index;
    this._currentEnd = newCurrentEnd;
    this._currentSlot_0 = 0;
    this._currentSlotEnd_0 = 0;
  };
  SlotReader.prototype.endGroup_1 = function () {
    if (this._emptyCount === 0) {
      var tmp0_require_0 = this._currentGroup_0 === this._currentEnd;
      if (!tmp0_require_0) {
        var message_1 = 'endGroup() not called at the end of a group';
        throw IllegalArgumentException_init_$Create$(toString_1(message_1));
      }var parent_0 = parentAnchor(this._groups_1, this._parent_2);
      this._parent_2 = parent_0;
      this._currentEnd = parent_0 < 0 ? this._groupsSize_0 : parent_0 + groupSize(this._groups_1, parent_0) | 0;
    }};
  SlotReader.prototype.extractKeys = function () {
    var result = ArrayList_init_$Create$();
    if (this._emptyCount > 0)
      return result;
    var index = 0;
    var childIndex = this._currentGroup_0;
    while (childIndex < this._currentEnd) {
      var tmp = key(this._groups_1, childIndex);
      var tmp_0 = objectKey(this._groups_1, this, childIndex);
      var tmp_1 = childIndex;
      var tmp_2 = isNode(this._groups_1, childIndex) ? 1 : nodeCount(this._groups_1, childIndex);
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      result.add_37(new KeyInfo(tmp, tmp_0, tmp_1, tmp_2, tmp0));
      Unit_getInstance();
      childIndex = childIndex + groupSize(this._groups_1, childIndex) | 0;
    }
    return result;
  };
  SlotReader.prototype.anchor_0 = function (index) {
    var tmp0_getOrAdd_0 = this._table_0._anchors_0;
    var tmp1_getOrAdd_0 = this._groupsSize_0;
    var location_1 = search(tmp0_getOrAdd_0, index, tmp1_getOrAdd_0);
    var tmp;
    if (location_1 < 0) {
      var anchor_2 = new Anchor(index);
      tmp0_getOrAdd_0.add_39(-(location_1 + 1 | 0) | 0, anchor_2);
      tmp = anchor_2;
    } else {
      tmp = tmp0_getOrAdd_0.get_66(location_1);
    }
    return tmp;
  };
  SlotReader.$metadata$ = {
    simpleName: 'SlotReader',
    kind: 'class',
    interfaces: []
  };
  function search(_this_, location, effectiveSize) {
    var low = 0;
    var high = _this_._get_size__45() - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1;
      var tmp0_let_0 = _this_.get_66(mid)._location_0;
      var midVal = tmp0_let_0 < 0 ? effectiveSize + tmp0_let_0 | 0 : tmp0_let_0;
      var cmp = compareTo(midVal, location);
      if (cmp < 0)
        low = mid + 1 | 0;
      else if (cmp > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function nodeIndex_0(_this_, address) {
    return _this_[imul(address, 5) + 4 | 0];
  }
  function auxIndex_0(_this_, address) {
    var tmp0_let_0 = imul(address, 5);
    return tmp0_let_0 >= _this_.length ? _this_.length : _this_[tmp0_let_0 + 4 | 0] + countOneBits_0(_this_[tmp0_let_0 + 1 | 0] >> 29) | 0;
  }
  function validateRead($this) {
    if (!($this._table_1._version === $this._version_0)) {
      throw ConcurrentModificationException_init_$Create$();
    }}
  function _no_name_provided__80(this$0, $group) {
    this._this$0_21 = this$0;
    this._$group = $group;
  }
  _no_name_provided__80.prototype.iterator_46 = function () {
    validateRead(this._this$0_21);
    return new GroupIterator(this._this$0_21._table_1, this._$group + 1 | 0, this._$group + groupSize(this._this$0_21._table_1._groups_0, this._$group) | 0);
  };
  _no_name_provided__80.$metadata$ = {
    kind: 'class',
    interfaces: [CompositionGroup, Iterable]
  };
  function GroupIterator(table, start_0, end_0) {
    this._table_1 = table;
    this._end = end_0;
    this._index_6 = start_0;
    this._version_0 = this._table_1._version;
    if (this._table_1._writer_0)
      throw ConcurrentModificationException_init_$Create$();
  }
  GroupIterator.prototype.hasNext_27 = function () {
    return this._index_6 < this._end;
  };
  GroupIterator.prototype.next_28 = function () {
    validateRead(this);
    var group = this._index_6;
    var tmp0_this = this;
    tmp0_this._index_6 = tmp0_this._index_6 + groupSize(this._table_1._groups_0, group) | 0;
    return new _no_name_provided__80(this, group);
  };
  GroupIterator.$metadata$ = {
    simpleName: 'GroupIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function KeyInfo(key_0, objectKey_0, location, nodes, index) {
    this._key_3 = key_0;
    this._objectKey = objectKey_0;
    this._location_1 = location;
    this._nodes = nodes;
    this._index_7 = index;
  }
  KeyInfo.$metadata$ = {
    simpleName: 'KeyInfo',
    kind: 'class',
    interfaces: []
  };
  function State_0() {
  }
  State_0.$metadata$ = {
    simpleName: 'State',
    kind: 'interface',
    interfaces: []
  };
  function MutableState() {
  }
  MutableState.$metadata$ = {
    simpleName: 'MutableState',
    kind: 'interface',
    interfaces: [State_0]
  };
  function mutableStateOf(value_0, policy) {
    return createSnapshotMutableState(value_0, policy);
  }
  function mutableStateOf$default(value_0, policy, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      policy = structuralEqualityPolicy();
    return mutableStateOf(value_0, policy);
  }
  function SnapshotMutationPolicy() {
  }
  SnapshotMutationPolicy.prototype.merge = function (previous, current_0, applied) {
    return null;
  };
  SnapshotMutationPolicy.$metadata$ = {
    simpleName: 'SnapshotMutationPolicy',
    kind: 'interface',
    interfaces: []
  };
  function structuralEqualityPolicy() {
    var tmp = StructuralEqualityPolicy_getInstance();
    return isInterface(tmp, SnapshotMutationPolicy) ? tmp : THROW_CCE();
  }
  function StructuralEqualityPolicy() {
    StructuralEqualityPolicy_instance = this;
  }
  StructuralEqualityPolicy.prototype.equivalent_0 = function (a, b) {
    return equals(a, b);
  };
  StructuralEqualityPolicy.prototype.equivalent_1 = function (a, b) {
    var tmp = (a == null ? true : isObject(a)) ? a : THROW_CCE();
    return this.equivalent_0(tmp, (b == null ? true : isObject(b)) ? b : THROW_CCE());
  };
  StructuralEqualityPolicy.prototype.toString = function () {
    return 'StructuralEqualityPolicy';
  };
  StructuralEqualityPolicy.$metadata$ = {
    simpleName: 'StructuralEqualityPolicy',
    kind: 'object',
    interfaces: [SnapshotMutationPolicy]
  };
  var StructuralEqualityPolicy_instance;
  function StructuralEqualityPolicy_getInstance() {
    if (StructuralEqualityPolicy_instance == null)
      new StructuralEqualityPolicy();
    return StructuralEqualityPolicy_instance;
  }
  function StateStateRecord(myValue) {
    StateRecord.call(this);
    this._value_5 = myValue;
  }
  StateStateRecord.prototype.assign_2 = function (value_0) {
    var tmp = this;
    tmp._value_5 = (value_0 instanceof StateStateRecord ? value_0 : THROW_CCE())._value_5;
  };
  StateStateRecord.prototype.create_6 = function () {
    return new StateStateRecord(this._value_5);
  };
  StateStateRecord.$metadata$ = {
    simpleName: 'StateStateRecord',
    kind: 'class',
    interfaces: []
  };
  function SnapshotMutableStateImpl(value_0, policy) {
    this._policy = policy;
    this._next_4 = new StateStateRecord(value_0);
  }
  SnapshotMutableStateImpl.prototype._get_policy_ = function () {
    return this._policy;
  };
  SnapshotMutableStateImpl.prototype._set_value__5 = function (value_0) {
    var tmp0_withCurrent_0 = this._next_4;
    var tmp1__anonymous__1 = current(tmp0_withCurrent_0, Companion_getInstance_13()._get_current__2());
    var tmp;
    if (!this._get_policy_().equivalent_1(tmp1__anonymous__1._value_5, value_0)) {
      var tmp2_overwritable_0_2 = this._next_4;
      var snapshot_1_3 = snapshotInitializer;
      var tmp0_synchronized_0_5 = lock;
      snapshot_1_3 = Companion_getInstance_13()._get_current__2();
      var tmp3__anonymous__4_6 = overwritableRecord(tmp2_overwritable_0_2, this, snapshot_1_3, tmp1__anonymous__1);
      tmp3__anonymous__4_6._value_5 = value_0;
      var tmp1_also_0_4 = Unit_getInstance();
      notifyWrite(snapshot_1_3, this);
      tmp = tmp1_also_0_4;
    }return tmp;
  };
  SnapshotMutableStateImpl.prototype._get_value__13 = function () {
    return readable_0(this._next_4, this)._value_5;
  };
  SnapshotMutableStateImpl.prototype._get_firstStateRecord__1 = function () {
    return this._next_4;
  };
  SnapshotMutableStateImpl.prototype.prependStateRecord_1 = function (value_0) {
    var tmp = this;
    tmp._next_4 = value_0 instanceof StateStateRecord ? value_0 : THROW_CCE();
  };
  SnapshotMutableStateImpl.prototype.mergeRecords_1 = function (previous, current_0, applied) {
    var previousRecord = previous instanceof StateStateRecord ? previous : THROW_CCE();
    var currentRecord = current_0 instanceof StateStateRecord ? current_0 : THROW_CCE();
    var appliedRecord = applied instanceof StateStateRecord ? applied : THROW_CCE();
    var tmp;
    if (this._get_policy_().equivalent_1(currentRecord._value_5, appliedRecord._value_5)) {
      tmp = current_0;
    } else {
      var merged = this._get_policy_().merge(previousRecord._value_5, currentRecord._value_5, appliedRecord._value_5);
      var tmp_0;
      if (!(merged == null)) {
        var tmp0_also_0 = appliedRecord.create_6();
        (tmp0_also_0 instanceof StateStateRecord ? tmp0_also_0 : THROW_CCE())._value_5 = merged;
        tmp_0 = tmp0_also_0;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  SnapshotMutableStateImpl.$metadata$ = {
    simpleName: 'SnapshotMutableStateImpl',
    kind: 'class',
    interfaces: [StateObject, SnapshotMutableState]
  };
  function mutableStateListOf() {
    return new SnapshotStateList();
  }
  function IntStack() {
    this._slots_3 = new Int32Array(10);
    this._tos = 0;
  }
  IntStack.prototype._get_size__45 = function () {
    return this._tos;
  };
  IntStack.prototype.push = function (value_0) {
    if (this._tos >= this._slots_3.length) {
      this._slots_3 = copyOf(this._slots_3, imul(this._slots_3.length, 2));
    }var tmp = this._slots_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._tos;
    tmp0_this._tos = tmp1 + 1 | 0;
    tmp[tmp1] = value_0;
  };
  IntStack.prototype.pop_0 = function () {
    var tmp = this._slots_3;
    var tmp0_this = this;
    tmp0_this._tos = tmp0_this._tos - 1 | 0;
    return tmp[tmp0_this._tos];
  };
  IntStack.prototype.peekOr = function (default_0) {
    return this._tos > 0 ? this.peek_0() : default_0;
  };
  IntStack.prototype.peek_0 = function () {
    return this._slots_3[this._tos - 1 | 0];
  };
  IntStack.prototype.isEmpty_40 = function () {
    return this._tos === 0;
  };
  IntStack.prototype.clear_7 = function () {
    this._tos = 0;
  };
  IntStack.$metadata$ = {
    simpleName: 'IntStack',
    kind: 'class',
    interfaces: []
  };
  function Stack() {
    this._backing = ArrayList_init_$Create$();
  }
  Stack.prototype._get_size__45 = function () {
    return this._backing._get_size__45();
  };
  Stack.prototype.push_0 = function (value_0) {
    return this._backing.add_37(value_0);
  };
  Stack.prototype.pop_0 = function () {
    return this._backing.removeAt_7(this._get_size__45() - 1 | 0);
  };
  Stack.prototype.peek_0 = function () {
    return this._backing.get_66(this._get_size__45() - 1 | 0);
  };
  Stack.prototype.peek_1 = function (index) {
    return this._backing.get_66(index);
  };
  Stack.prototype.isEmpty_40 = function () {
    return this._backing.isEmpty_40();
  };
  Stack.prototype.isNotEmpty_0 = function () {
    return !this.isEmpty_40();
  };
  Stack.prototype.clear_7 = function () {
    return this._backing.clear_7();
  };
  Stack.prototype.toArray_1 = function () {
    var tmp = 0;
    var tmp_0 = this._backing._get_size__45();
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this._backing.get_66(tmp_2);
      tmp = tmp + 1 | 0;
    }
    var tmp_3 = tmp_1;
    return isArray(tmp_3) ? tmp_3 : THROW_CCE();
  };
  Stack.$metadata$ = {
    simpleName: 'Stack',
    kind: 'class',
    interfaces: []
  };
  function _get_current_($this) {
    var tmp0_getValue_0 = $this._current$delegate;
    var tmp1_getValue_0 = current$factory();
    return tmp0_getValue_0._get_value__13();
  }
  function LazyValueHolder(valueProducer) {
    this._current$delegate = lazy(valueProducer);
  }
  LazyValueHolder.prototype._get_value__13 = function () {
    return _get_current_(this);
  };
  LazyValueHolder.$metadata$ = {
    simpleName: 'LazyValueHolder',
    kind: 'class',
    interfaces: [State_0]
  };
  function current$factory() {
    return getPropertyCallableRef('current', 1, KProperty1, function (receiver) {
      return _get_current_(receiver);
    }, null);
  }
  function find($this, key_0) {
    var low = 0;
    var high = $this._size_3 - 1 | 0;
    var valueIdentity = identityHashCode_0(key_0);
    while (low <= high) {
      var mid = (low + high | 0) >>> 1;
      var midVal = $this._keys_0[mid];
      var comparison = identityHashCode_0(midVal) - valueIdentity | 0;
      if (comparison < 0)
        low = mid + 1 | 0;
      else if (comparison > 0)
        high = mid - 1 | 0;
      else if (midVal === key_0)
        return mid;
      else
        return findExactIndex($this, mid, key_0, valueIdentity);
    }
    return -(low + 1 | 0) | 0;
  }
  function findExactIndex($this, midIndex, value_0, valueHash) {
    var inductionVariable = midIndex - 1 | 0;
    if (0 <= inductionVariable)
      $l$break: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var v = $this._keys_0[i];
        if (v === value_0) {
          return i;
        }if (!(identityHashCode_0(v) === valueHash)) {
          break $l$break;
        }}
       while (0 <= inductionVariable);
    var inductionVariable_0 = midIndex + 1 | 0;
    var last = $this._size_3;
    if (inductionVariable_0 < last)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var v_0 = $this._keys_0[i_0];
        if (v_0 === value_0) {
          return i_0;
        }if (!(identityHashCode_0(v_0) === valueHash)) {
          return -(i_0 + 1 | 0) | 0;
        }}
       while (inductionVariable_0 < last);
    return -($this._size_3 + 1 | 0) | 0;
  }
  function IdentityArrayIntMap() {
    this._size_3 = 0;
    var tmp = this;
    var tmp0_arrayOfNulls_0 = 4;
    tmp._keys_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._values_0 = new Int32Array(4);
  }
  IdentityArrayIntMap.prototype.add_33 = function (key_0, value_0) {
    var index;
    if (this._size_3 > 0) {
      index = find(this, key_0);
      if (index >= 0) {
        this._values_0[index] = value_0;
        return Unit_getInstance();
      }} else {
      index = -1;
    }
    var insertIndex = -(index + 1 | 0) | 0;
    if (this._size_3 === this._keys_0.length) {
      var tmp0_arrayOfNulls_0 = imul(this._keys_0.length, 2);
      var newKeys = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      var newValues = new Int32Array(imul(this._keys_0.length, 2));
      var tmp1_copyInto_0 = this._keys_0;
      var tmp2_copyInto_0 = insertIndex + 1 | 0;
      var tmp3_copyInto_0 = this._size_3;
      arrayCopy_0(tmp1_copyInto_0, newKeys, tmp2_copyInto_0, insertIndex, tmp3_copyInto_0);
      Unit_getInstance();
      var tmp4_copyInto_0 = this._values_0;
      var tmp5_copyInto_0 = insertIndex + 1 | 0;
      var tmp6_copyInto_0 = this._size_3;
      var tmp = tmp4_copyInto_0;
      arrayCopy_0(tmp, newValues, tmp5_copyInto_0, insertIndex, tmp6_copyInto_0);
      Unit_getInstance();
      var tmp7_copyInto_0 = this._keys_0;
      var tmp8_copyInto_0 = 0;
      var tmp9_copyInto_0 = 0;
      arrayCopy_0(tmp7_copyInto_0, newKeys, tmp8_copyInto_0, tmp9_copyInto_0, insertIndex);
      Unit_getInstance();
      var tmp10_copyInto_0 = this._values_0;
      var tmp11_copyInto_0 = 0;
      var tmp12_copyInto_0 = 0;
      var tmp_0 = tmp10_copyInto_0;
      arrayCopy_0(tmp_0, newValues, tmp11_copyInto_0, tmp12_copyInto_0, insertIndex);
      Unit_getInstance();
      this._keys_0 = newKeys;
      this._values_0 = newValues;
    } else {
      var tmp13_copyInto_0 = this._keys_0;
      var tmp14_copyInto_0 = this._keys_0;
      var tmp15_copyInto_0 = insertIndex + 1 | 0;
      var tmp16_copyInto_0 = this._size_3;
      arrayCopy_0(tmp13_copyInto_0, tmp14_copyInto_0, tmp15_copyInto_0, insertIndex, tmp16_copyInto_0);
      Unit_getInstance();
      var tmp17_copyInto_0 = this._values_0;
      var tmp18_copyInto_0 = this._values_0;
      var tmp19_copyInto_0 = insertIndex + 1 | 0;
      var tmp20_copyInto_0 = this._size_3;
      var tmp_1 = tmp17_copyInto_0;
      arrayCopy_0(tmp_1, tmp18_copyInto_0, tmp19_copyInto_0, insertIndex, tmp20_copyInto_0);
      Unit_getInstance();
    }
    this._keys_0[insertIndex] = key_0;
    this._values_0[insertIndex] = value_0;
    var tmp0_this = this;
    var tmp1 = tmp0_this._size_3;
    tmp0_this._size_3 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  IdentityArrayIntMap.$metadata$ = {
    simpleName: 'IdentityArrayIntMap',
    kind: 'class',
    interfaces: []
  };
  function find_0($this, value_0) {
    var low = 0;
    var high = $this._size_4 - 1 | 0;
    var valueIdentity = identityHashCode_0(value_0);
    while (low <= high) {
      var mid = (low + high | 0) >>> 1;
      var midVal = $this.get_66(mid);
      var comparison = identityHashCode_0(midVal) - valueIdentity | 0;
      if (comparison < 0)
        low = mid + 1 | 0;
      else if (comparison > 0)
        high = mid - 1 | 0;
      else if (midVal === value_0)
        return mid;
      else
        return findExactIndex_0($this, mid, value_0, valueIdentity);
    }
    return -(low + 1 | 0) | 0;
  }
  function findExactIndex_0($this, midIndex, value_0, valueHash) {
    var inductionVariable = midIndex - 1 | 0;
    if (0 <= inductionVariable)
      $l$break: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var v = $this._values_1[i];
        if (v === value_0) {
          return i;
        }if (!(identityHashCode_0(v) === valueHash)) {
          break $l$break;
        }}
       while (0 <= inductionVariable);
    var inductionVariable_0 = midIndex + 1 | 0;
    var last = $this._size_4;
    if (inductionVariable_0 < last)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var v_0 = $this._values_1[i_0];
        if (v_0 === value_0) {
          return i_0;
        }if (!(identityHashCode_0(v_0) === valueHash)) {
          return -(i_0 + 1 | 0) | 0;
        }}
       while (inductionVariable_0 < last);
    return -($this._size_4 + 1 | 0) | 0;
  }
  function IdentityArraySet() {
    this._size_4 = 0;
    var tmp = this;
    var tmp0_arrayOfNulls_0 = 16;
    tmp._values_1 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  IdentityArraySet.prototype.get_66 = function (index) {
    var tmp = this._values_1[index];
    return isObject(tmp) ? tmp : THROW_CCE();
  };
  IdentityArraySet.prototype.add_36 = function (value_0) {
    var index;
    if (this._size_4 > 0) {
      index = find_0(this, value_0);
      if (index >= 0) {
        return false;
      }} else {
      index = -1;
    }
    var insertIndex = -(index + 1 | 0) | 0;
    if (this._size_4 === this._values_1.length) {
      var tmp0_arrayOfNulls_0 = imul(this._values_1.length, 2);
      var newSorted = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      var tmp1_copyInto_0 = this._values_1;
      var tmp2_copyInto_0 = insertIndex + 1 | 0;
      var tmp3_copyInto_0 = this._size_4;
      arrayCopy_0(tmp1_copyInto_0, newSorted, tmp2_copyInto_0, insertIndex, tmp3_copyInto_0);
      Unit_getInstance();
      var tmp4_copyInto_0 = this._values_1;
      var tmp5_copyInto_0 = 0;
      var tmp6_copyInto_0 = 0;
      arrayCopy_0(tmp4_copyInto_0, newSorted, tmp5_copyInto_0, tmp6_copyInto_0, insertIndex);
      Unit_getInstance();
      this._values_1 = newSorted;
    } else {
      var tmp7_copyInto_0 = this._values_1;
      var tmp8_copyInto_0 = this._values_1;
      var tmp9_copyInto_0 = insertIndex + 1 | 0;
      var tmp10_copyInto_0 = this._size_4;
      arrayCopy_0(tmp7_copyInto_0, tmp8_copyInto_0, tmp9_copyInto_0, insertIndex, tmp10_copyInto_0);
      Unit_getInstance();
    }
    this._values_1[insertIndex] = value_0;
    var tmp0_this = this;
    var tmp1 = tmp0_this._size_4;
    tmp0_this._size_4 = tmp1 + 1 | 0;
    Unit_getInstance();
    return true;
  };
  IdentityArraySet.prototype.isNotEmpty_0 = function () {
    return this._size_4 > 0;
  };
  IdentityArraySet.prototype.remove_50 = function (value_0) {
    var index = find_0(this, value_0);
    if (index >= 0) {
      if (index < (this._size_4 - 1 | 0)) {
        var tmp0_copyInto_0 = this._values_1;
        var tmp1_copyInto_0 = this._values_1;
        var tmp2_copyInto_0 = index + 1 | 0;
        var tmp3_copyInto_0 = this._size_4;
        arrayCopy_0(tmp0_copyInto_0, tmp1_copyInto_0, index, tmp2_copyInto_0, tmp3_copyInto_0);
        Unit_getInstance();
      }var tmp0_this = this;
      var tmp1 = tmp0_this._size_4;
      tmp0_this._size_4 = tmp1 - 1 | 0;
      Unit_getInstance();
      this._values_1[this._size_4] = null;
      return true;
    }return false;
  };
  IdentityArraySet.$metadata$ = {
    simpleName: 'IdentityArraySet',
    kind: 'class',
    interfaces: []
  };
  function scopeSetAt($this, index) {
    return ensureNotNull($this._scopeSets[$this._valueOrder[index]]);
  }
  function getOrCreateIdentitySet($this, value_0) {
    var index;
    if ($this._size_5 > 0) {
      index = find_1($this, value_0);
      if (index >= 0) {
        return scopeSetAt($this, index);
      }} else {
      index = -1;
    }
    var insertIndex = -(index + 1 | 0) | 0;
    if ($this._size_5 < $this._valueOrder.length) {
      var valueIndex = $this._valueOrder[$this._size_5];
      $this._values_2[valueIndex] = value_0;
      var tmp0_elvis_lhs = $this._scopeSets[valueIndex];
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp0_also_0 = new IdentityArraySet();
        $this._scopeSets[valueIndex] = tmp0_also_0;
        tmp = tmp0_also_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var scopeSet = tmp;
      if (insertIndex < $this._size_5) {
        var tmp1_copyInto_0 = $this._valueOrder;
        var tmp2_copyInto_0 = $this._valueOrder;
        var tmp3_copyInto_0 = insertIndex + 1 | 0;
        var tmp4_copyInto_0 = $this._size_5;
        var tmp_0 = tmp1_copyInto_0;
        arrayCopy_0(tmp_0, tmp2_copyInto_0, tmp3_copyInto_0, insertIndex, tmp4_copyInto_0);
        Unit_getInstance();
      }$this._valueOrder[insertIndex] = valueIndex;
      var tmp1_this = $this;
      var tmp2 = tmp1_this._size_5;
      tmp1_this._size_5 = tmp2 + 1 | 0;
      Unit_getInstance();
      return scopeSet;
    }var newSize = imul($this._valueOrder.length, 2);
    var valueIndex_0 = $this._size_5;
    $this._scopeSets = copyOf_0($this._scopeSets, newSize);
    var scopeSet_0 = new IdentityArraySet();
    $this._scopeSets[valueIndex_0] = scopeSet_0;
    $this._values_2 = copyOf_0($this._values_2, newSize);
    $this._values_2[valueIndex_0] = value_0;
    var newKeyOrder = new Int32Array(newSize);
    var inductionVariable = $this._size_5 + 1 | 0;
    if (inductionVariable < newSize)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        newKeyOrder[i] = i;
      }
       while (inductionVariable < newSize);
    if (insertIndex < $this._size_5) {
      var tmp5_copyInto_0 = $this._valueOrder;
      var tmp6_copyInto_0 = insertIndex + 1 | 0;
      var tmp7_copyInto_0 = $this._size_5;
      var tmp_1 = tmp5_copyInto_0;
      arrayCopy_0(tmp_1, newKeyOrder, tmp6_copyInto_0, insertIndex, tmp7_copyInto_0);
      Unit_getInstance();
    }newKeyOrder[insertIndex] = valueIndex_0;
    if (insertIndex > 0) {
      var tmp8_copyInto_0 = $this._valueOrder;
      var tmp9_copyInto_0 = 0;
      var tmp10_copyInto_0 = 0;
      var tmp_2 = tmp8_copyInto_0;
      arrayCopy_0(tmp_2, newKeyOrder, tmp9_copyInto_0, tmp10_copyInto_0, insertIndex);
      Unit_getInstance();
    }$this._valueOrder = newKeyOrder;
    var tmp4_this = $this;
    var tmp5 = tmp4_this._size_5;
    tmp4_this._size_5 = tmp5 + 1 | 0;
    Unit_getInstance();
    return scopeSet_0;
  }
  function find_1($this, value_0) {
    var valueIdentity = identityHashCode_0(value_0);
    var low = 0;
    var high = $this._size_5 - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1;
      var midValue = ensureNotNull($this._values_2[$this._valueOrder[mid]]);
      var midValHash = identityHashCode_0(midValue);
      var comparison = midValHash - valueIdentity | 0;
      if (comparison < 0)
        low = mid + 1 | 0;
      else if (comparison > 0)
        high = mid - 1 | 0;
      else if (value_0 === midValue)
        return mid;
      else
        return findExactIndex_1($this, mid, value_0, valueIdentity);
    }
    return -(low + 1 | 0) | 0;
  }
  function findExactIndex_1($this, midIndex, value_0, valueHash) {
    var inductionVariable = midIndex - 1 | 0;
    if (0 <= inductionVariable)
      $l$break: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var v = ensureNotNull($this._values_2[$this._valueOrder[i]]);
        if (v === value_0) {
          return i;
        }if (!(identityHashCode_0(v) === valueHash)) {
          break $l$break;
        }}
       while (0 <= inductionVariable);
    var inductionVariable_0 = midIndex + 1 | 0;
    var last = $this._size_5;
    if (inductionVariable_0 < last)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var v_0 = ensureNotNull($this._values_2[$this._valueOrder[i_0]]);
        if (v_0 === value_0) {
          return i_0;
        }if (!(identityHashCode_0(v_0) === valueHash)) {
          return -(i_0 + 1 | 0) | 0;
        }}
       while (inductionVariable_0 < last);
    return -($this._size_5 + 1 | 0) | 0;
  }
  function IdentityScopeMap() {
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 50;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = tmp_3;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._valueOrder = tmp_2;
    var tmp_4 = this;
    var tmp0_arrayOfNulls_0 = 50;
    tmp_4._values_2 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var tmp_5 = this;
    var tmp0_arrayOfNulls_0_0 = 50;
    tmp_5._scopeSets = fillArrayVal(Array(tmp0_arrayOfNulls_0_0), null);
    this._size_5 = 0;
  }
  IdentityScopeMap.prototype.add_35 = function (value_0, scope) {
    var valueSet = getOrCreateIdentitySet(this, value_0);
    return valueSet.add_36(scope);
  };
  IdentityScopeMap.prototype.remove_49 = function (value_0, scope) {
    var index = find_1(this, value_0);
    if (index >= 0) {
      var valueOrderIndex = this._valueOrder[index];
      var tmp0_elvis_lhs = this._scopeSets[valueOrderIndex];
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var set = tmp;
      var removed = set.remove_50(scope);
      if (set._size_4 === 0) {
        var startIndex = index + 1 | 0;
        var endIndex = this._size_5;
        if (startIndex < endIndex) {
          var tmp0_copyInto_0 = this._valueOrder;
          var tmp1_copyInto_0 = this._valueOrder;
          var tmp_0 = tmp0_copyInto_0;
          arrayCopy_0(tmp_0, tmp1_copyInto_0, index, startIndex, endIndex);
          Unit_getInstance();
        }this._valueOrder[this._size_5 - 1 | 0] = valueOrderIndex;
        this._values_2[valueOrderIndex] = null;
        var tmp1_this = this;
        var tmp2 = tmp1_this._size_5;
        tmp1_this._size_5 = tmp2 - 1 | 0;
        Unit_getInstance();
      }return removed;
    }return false;
  };
  IdentityScopeMap.$metadata$ = {
    simpleName: 'IdentityScopeMap',
    kind: 'class',
    interfaces: []
  };
  function composableLambdaInstance(key_0, tracked, sourceInformation, block) {
    var tmp0_apply_0 = new ComposableLambdaImpl(key_0, tracked, sourceInformation);
    tmp0_apply_0.update_1(block);
    return tmp0_apply_0;
  }
  function replacableWith(_this_, other) {
    var tmp;
    if (_this_ == null) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (_this_ instanceof RecomposeScopeImpl) {
        tmp_1 = other instanceof RecomposeScopeImpl;
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = (!_this_._get_valid__0() ? true : equals(_this_, other)) ? true : equals(_this_._anchor, other._anchor);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function differentBits(slot) {
    return bitsForSlot(2, slot);
  }
  function sameBits(slot) {
    return bitsForSlot(1, slot);
  }
  function bitsForSlot(bits, slot) {
    var realSlot = slot % 10;
    return bits << (imul(realSlot, 3) + 1 | 0);
  }
  function composableLambda(composer, key_0, tracked, sourceInformation, block) {
    composer.startReplaceableGroup_1(key_0);
    var slot = composer.rememberedValue_0();
    var tmp;
    if (slot === Companion_getInstance_11()._Empty) {
      var value_0 = new ComposableLambdaImpl(key_0, tracked, sourceInformation);
      composer.updateRememberedValue_0(value_0);
      tmp = value_0;
    } else {
      tmp = slot instanceof ComposableLambdaImpl ? slot : THROW_CCE();
    }
    var result = tmp;
    result.update_1(block);
    composer.endReplaceableGroup_0();
    return result;
  }
  var liveLiteralCache;
  var isLiveLiteralsEnabled;
  function fastJoinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return fastJoinTo(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function fastJoinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return fastJoinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function fastToSet(_this_) {
    var tmp0_also_0 = HashSet_init_$Create$_0(_this_._get_size__45());
    var inductionVariable = 0;
    var last = _this_._get_size__45() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item_3_4 = _this_.get_66(index_2_3);
        tmp0_also_0.add_37(item_3_4);
        Unit_getInstance();
      }
       while (inductionVariable <= last);
    return tmp0_also_0;
  }
  function fastJoinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var inductionVariable = 0;
    var last = _this_._get_size__45() - 1 | 0;
    if (inductionVariable <= last)
      $l$break: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = _this_.get_66(index);
        count = count + 1 | 0;
        if (count > 1) {
          buffer.append_3(separator);
          Unit_getInstance();
        } else {
        }
        if (limit < 0 ? true : count <= limit) {
          appendElement_0(buffer, element, transform);
        } else
          break $l$break;
      }
       while (inductionVariable <= last);
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function appendElement_0(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  var emptyLambda;
  var threadSnapshot;
  var lock;
  var openSnapshots;
  var nextSnapshotId;
  var applyObservers;
  var globalWriteObservers;
  var currentGlobalSnapshot;
  var snapshotInitializer;
  function _no_name_provided__81($observer) {
    this._$observer = $observer;
  }
  _no_name_provided__81.prototype.dispose_20 = function () {
    var tmp0_synchronized_0 = lock;
    applyObservers.remove_51(this._$observer);
    Unit_getInstance();
  };
  _no_name_provided__81.$metadata$ = {
    kind: 'class',
    interfaces: [ObserverHandle]
  };
  function _no_name_provided__82($observer) {
    this._$observer_0 = $observer;
  }
  _no_name_provided__82.prototype.dispose_20 = function () {
    var tmp0_synchronized_0 = lock;
    globalWriteObservers.remove_51(this._$observer_0);
    Unit_getInstance();
    advanceGlobalSnapshot_0();
  };
  _no_name_provided__82.$metadata$ = {
    kind: 'class',
    interfaces: [ObserverHandle]
  };
  function Companion_14() {
    Companion_instance_13 = this;
  }
  Companion_14.prototype._get_current__2 = function () {
    return currentSnapshot();
  };
  Companion_14.prototype.takeMutableSnapshot = function (readObserver, writeObserver) {
    var tmp = currentSnapshot();
    var tmp0_safe_receiver = tmp instanceof MutableSnapshot ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.takeNestedMutableSnapshot_2(readObserver, writeObserver);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp0_error_0 = 'Cannot create a mutable snapshot of an read-only snapshot';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  Companion_14.prototype.registerApplyObserver = function (observer) {
    advanceGlobalSnapshot(emptyLambda);
    var tmp0_synchronized_0 = lock;
    applyObservers.add_37(observer);
    Unit_getInstance();
    return new _no_name_provided__81(observer);
  };
  Companion_14.prototype.registerGlobalWriteObserver = function (observer) {
    var tmp0_synchronized_0 = lock;
    globalWriteObservers.add_37(observer);
    Unit_getInstance();
    advanceGlobalSnapshot_0();
    return new _no_name_provided__82(observer);
  };
  Companion_14.prototype.notifyObjectsInitialized_4 = function () {
    return currentSnapshot().notifyObjectsInitialized_4();
  };
  Companion_14.prototype.sendApplyNotifications = function () {
    var tmp0_synchronized_0 = lock;
    var tmp0_safe_receiver_2 = currentGlobalSnapshot.get_55()._get_modified__2();
    var tmp;
    if (tmp0_safe_receiver_2 == null) {
      tmp = null;
    } else {
      tmp = !tmp0_safe_receiver_2.isEmpty_40();
    }
    var changes = tmp === true;
    if (changes)
      advanceGlobalSnapshot_0();
  };
  Companion_14.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_14();
    return Companion_instance_13;
  }
  function Snapshot(id, invalid) {
    Companion_getInstance_13();
    this._invalid = invalid;
    this._id = id;
    this._disposed_0 = false;
    this._$stable_4 = 8;
  }
  Snapshot.prototype._set_invalid__3 = function (_set___) {
    this._invalid = _set___;
  };
  Snapshot.prototype._get_invalid__3 = function () {
    return this._invalid;
  };
  Snapshot.prototype._set_id__3 = function (_set___) {
    this._id = _set___;
  };
  Snapshot.prototype._get_id__3 = function () {
    return this._id;
  };
  Snapshot.prototype.makeCurrent_3 = function () {
    var previous = threadSnapshot.get_55();
    threadSnapshot.set_15(this);
    return previous;
  };
  Snapshot.prototype.restoreCurrent_3 = function (snapshot) {
    threadSnapshot.set_15(snapshot);
  };
  Snapshot.prototype._set_disposed__0 = function (_set___) {
    this._disposed_0 = _set___;
  };
  Snapshot.prototype._get_disposed__3 = function () {
    return this._disposed_0;
  };
  Snapshot.prototype.validateNotDisposed_3 = function () {
    var tmp0_require_0 = !this._disposed_0;
    if (!tmp0_require_0) {
      var message_1 = 'Cannot use a disposed snapshot';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }};
  Snapshot.$metadata$ = {
    simpleName: 'Snapshot',
    kind: 'class',
    interfaces: []
  };
  function ObserverHandle() {
  }
  ObserverHandle.$metadata$ = {
    simpleName: 'ObserverHandle',
    kind: 'interface',
    interfaces: []
  };
  function MutableSnapshot(id, invalid, readObserver, writeObserver) {
    Snapshot.call(this, id, invalid);
    this._readObserver = readObserver;
    this._writeObserver = writeObserver;
    this._modified = null;
    this._previousIds = Companion_getInstance_14()._EMPTY_4;
    this._snapshots = 1;
    this._applied = false;
    this._$stable_5 = 8;
  }
  MutableSnapshot.prototype._get_readObserver__3 = function () {
    return this._readObserver;
  };
  MutableSnapshot.prototype._get_writeObserver__3 = function () {
    return this._writeObserver;
  };
  MutableSnapshot.prototype.takeNestedMutableSnapshot_2 = function (readObserver, writeObserver) {
    this.validateNotDisposed_3();
    this.validateNotApplied_2();
    this.recordPrevious_2(this._get_id__3());
    var tmp0_synchronized_0_9 = lock;
    var tmp0_3_11 = nextSnapshotId;
    nextSnapshotId = tmp0_3_11 + 1 | 0;
    var newId_2_10 = tmp0_3_11;
    openSnapshots = openSnapshots.set_11(newId_2_10);
    var invalid_4_12 = this._get_invalid__3();
    this._set_invalid__3(invalid_4_12.set_11(newId_2_10));
    var tmp0_also_0 = new NestedMutableSnapshot(newId_2_10, invalid_4_12, mergedReadObserver(readObserver, this._get_readObserver__3()), mergedWriteObserver(writeObserver, this._get_writeObserver__3()), this);
    var previousId_2_2 = this._get_id__3();
    var tmp0_synchronized_0_3 = lock;
    var tmp0_4_2_4 = nextSnapshotId;
    nextSnapshotId = tmp0_4_2_4 + 1 | 0;
    this._set_id__3(tmp0_4_2_4);
    openSnapshots = openSnapshots.set_11(this._get_id__3());
    var currentInvalid_5_5 = this._get_invalid__3();
    var inductionVariable = previousId_2_2 + 1 | 0;
    var last = this._get_id__3();
    if (inductionVariable < last)
      do {
        var invalidId_7_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        currentInvalid_5_5 = currentInvalid_5_5.set_11(invalidId_7_7);
      }
       while (inductionVariable < last);
    this._set_invalid__3(currentInvalid_5_5);
    return tmp0_also_0;
  };
  MutableSnapshot.prototype.apply_4 = function () {
    var modified = this._get_modified__2();
    var optimisticMerges_0 = !(modified == null) ? optimisticMerges(currentGlobalSnapshot.get_55(), this, openSnapshots.clear_6(currentGlobalSnapshot.get_55()._get_id__3())) : null;
    var tmp0_synchronized_0 = lock;
    validateOpen(this);
    var tmp;
    if (modified == null ? true : modified._get_size__45() === 0) {
      this.close_7();
      var previousGlobalSnapshot_2 = currentGlobalSnapshot.get_55();
      takeNewGlobalSnapshot(previousGlobalSnapshot_2, emptyLambda);
      var globalModified_3 = previousGlobalSnapshot_2._get_modified__2();
      var tmp_0;
      var tmp_1;
      if (!(globalModified_3 == null)) {
        tmp_1 = !globalModified_3.isEmpty_40();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = to(toMutableList(applyObservers), globalModified_3);
      } else {
        {
          tmp_0 = to(emptyList(), null);
        }
      }
      tmp = tmp_0;
    } else {
      var previousGlobalSnapshot_4 = currentGlobalSnapshot.get_55();
      var result_5 = this.innerApply_2(nextSnapshotId, optimisticMerges_0, openSnapshots.clear_6(previousGlobalSnapshot_4._get_id__3()));
      if (!equals(result_5, Success_getInstance()))
        return result_5;
      this.close_7();
      takeNewGlobalSnapshot(previousGlobalSnapshot_4, emptyLambda);
      var globalModified_6 = previousGlobalSnapshot_4._get_modified__2();
      this._set_modified__2(null);
      previousGlobalSnapshot_4._set_modified__2(null);
      tmp = to(toMutableList(applyObservers), globalModified_6);
    }
    var tmp0_container = tmp;
    var observers = tmp0_container.component1_0();
    var globalModified = tmp0_container.component2_0();
    this._applied = true;
    var tmp_2;
    if (!(globalModified == null)) {
      tmp_2 = !globalModified.isEmpty_40();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var inductionVariable = 0;
      var last = observers._get_size__45() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item_3 = observers.get_66(index_2);
          item_3(globalModified, this);
        }
         while (inductionVariable <= last);
    } else {
    }
    var tmp_3;
    if (!(modified == null)) {
      tmp_3 = !modified.isEmpty_40();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      var inductionVariable_0 = 0;
      var last_0 = observers._get_size__45() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_2_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_3_0 = observers.get_66(index_2_0);
          item_3_0(modified, this);
        }
         while (inductionVariable_0 <= last_0);
    } else {
    }
    return Success_getInstance();
  };
  MutableSnapshot.prototype._get_readOnly__3 = function () {
    return false;
  };
  MutableSnapshot.prototype.nestedActivated_4 = function (snapshot) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._snapshots;
    tmp0_this._snapshots = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  MutableSnapshot.prototype.notifyObjectsInitialized_4 = function () {
    this.advance_2();
  };
  MutableSnapshot.prototype.close_7 = function () {
    var tmp0_synchronized_0 = lock;
    openSnapshots = openSnapshots.clear_6(this._get_id__3()).andNot(this._previousIds);
  };
  MutableSnapshot.prototype.validateNotApplied_2 = function () {
    var tmp0_require_0 = !this._applied;
    if (!tmp0_require_0) {
      var message_1 = 'Unsupported operation on a snapshot that has been applied';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }};
  MutableSnapshot.prototype.innerApply_2 = function (snapshotId, optimisticMerges_0, invalidSnapshots) {
    var mergedRecords = null;
    var start_0 = this._get_invalid__3().set_11(this._get_id__3()).or_0(this._previousIds);
    var modified = ensureNotNull(this._get_modified__2());
    var statesToRemove = null;
    var tmp0_iterator = modified.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var state = tmp0_iterator.next_28();
      var first = state._get_firstStateRecord__1();
      var tmp1_elvis_lhs = readable(first, snapshotId, invalidSnapshots);
      var tmp;
      if (tmp1_elvis_lhs == null) {
        continue;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var current_0 = tmp;
      var tmp2_elvis_lhs = readable(first, this._get_id__3(), start_0);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        continue;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      var previous = tmp_0;
      if (!equals(current_0, previous)) {
        var tmp3_elvis_lhs = readable(first, this._get_id__3(), this._get_invalid__3());
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          readError();
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var applied = tmp_1;
        var tmp4_safe_receiver = optimisticMerges_0;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.get_48(current_0);
        var tmp_2;
        if (tmp5_elvis_lhs == null) {
          tmp_2 = state.mergeRecords_1(previous, current_0, applied);
        } else {
          tmp_2 = tmp5_elvis_lhs;
        }
        var merged = tmp_2;
        var tmp6_subject = merged;
        if (tmp6_subject == null)
          return new Failure_0(this);
        else if (equals(tmp6_subject, applied)) {
        } else if (equals(tmp6_subject, current_0)) {
          var tmp7_elvis_lhs = mergedRecords;
          var tmp_3;
          if (tmp7_elvis_lhs == null) {
            var tmp0_also_0 = ArrayList_init_$Create$();
            mergedRecords = tmp0_also_0;
            tmp_3 = tmp0_also_0;
          } else {
            tmp_3 = tmp7_elvis_lhs;
          }
          tmp_3.add_37(to(state, current_0.create_6()));
          Unit_getInstance();
          var tmp8_elvis_lhs = statesToRemove;
          var tmp_4;
          if (tmp8_elvis_lhs == null) {
            var tmp1_also_0 = ArrayList_init_$Create$();
            statesToRemove = tmp1_also_0;
            tmp_4 = tmp1_also_0;
          } else {
            tmp_4 = tmp8_elvis_lhs;
          }
          tmp_4.add_37(state);
          Unit_getInstance();
        } else {
          var tmp9_elvis_lhs = mergedRecords;
          var tmp_5;
          if (tmp9_elvis_lhs == null) {
            var tmp2_also_0 = ArrayList_init_$Create$();
            mergedRecords = tmp2_also_0;
            tmp_5 = tmp2_also_0;
          } else {
            tmp_5 = tmp9_elvis_lhs;
          }
          tmp_5.add_37(!equals(merged, previous) ? to(state, merged) : to(state, previous.create_6()));
          Unit_getInstance();
        }
      }}
    var tmp10_safe_receiver = mergedRecords;
    if (tmp10_safe_receiver == null)
      null;
    else {
      this.advance_2();
      var inductionVariable = 0;
      var last = tmp10_safe_receiver._get_size__45() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_2_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item_3_4 = tmp10_safe_receiver.get_66(index_2_3);
          var tmp0_container_5_5 = item_3_4;
          var state_6_6 = tmp0_container_5_5.component1_0();
          var stateRecord_7_7 = tmp0_container_5_5.component2_0();
          stateRecord_7_7._snapshotId = this._get_id__3();
          var tmp0_synchronized_0_8_8 = lock;
          stateRecord_7_7._next_5 = state_6_6._get_firstStateRecord__1();
          state_6_6.prependStateRecord_1(stateRecord_7_7);
        }
         while (inductionVariable <= last);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp11_safe_receiver = statesToRemove;
    if (tmp11_safe_receiver == null)
      null;
    else {
      modified.removeAll_7(tmp11_safe_receiver);
    }
    Unit_getInstance();
    return Success_getInstance();
  };
  MutableSnapshot.prototype.advance_2 = function () {
    this.recordPrevious_2(this._get_id__3());
    var tmp0_also_0_1 = Unit_getInstance();
    var previousId_2_2 = this._get_id__3();
    var tmp0_synchronized_0_3_3 = lock;
    var tmp0_2_4_4 = nextSnapshotId;
    nextSnapshotId = tmp0_2_4_4 + 1 | 0;
    this._set_id__3(tmp0_2_4_4);
    openSnapshots = openSnapshots.set_11(this._get_id__3());
    var currentInvalid_5_5 = this._get_invalid__3();
    var inductionVariable = previousId_2_2 + 1 | 0;
    var last = this._get_id__3();
    if (inductionVariable < last)
      do {
        var invalidId_7_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        currentInvalid_5_5 = currentInvalid_5_5.set_11(invalidId_7_7);
      }
       while (inductionVariable < last);
    this._set_invalid__3(currentInvalid_5_5);
    return tmp0_also_0_1;
  };
  MutableSnapshot.prototype.recordPrevious_2 = function (id) {
    var tmp0_synchronized_0 = lock;
    this._previousIds = this._previousIds.set_11(id);
  };
  MutableSnapshot.prototype.recordPreviousList_2 = function (snapshots) {
    var tmp0_synchronized_0 = lock;
    this._previousIds = this._previousIds.or_0(snapshots);
  };
  MutableSnapshot.prototype.recordModified_3 = function (state) {
    var tmp0_elvis_lhs = this._get_modified__2();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = HashSet_init_$Create$();
      this._set_modified__2(tmp0_also_0);
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp.add_37(state);
    Unit_getInstance();
  };
  MutableSnapshot.prototype._set_modified__2 = function (_set___) {
    this._modified = _set___;
  };
  MutableSnapshot.prototype._get_modified__2 = function () {
    return this._modified;
  };
  MutableSnapshot.prototype._get_previousIds__0 = function () {
    return this._previousIds;
  };
  MutableSnapshot.prototype._set_applied__0 = function (_set___) {
    this._applied = _set___;
  };
  MutableSnapshot.$metadata$ = {
    simpleName: 'MutableSnapshot',
    kind: 'class',
    interfaces: []
  };
  function Success() {
    Success_instance = this;
    SnapshotApplyResult.call(this);
    this._$stable_6 = 0;
  }
  Success.$metadata$ = {
    simpleName: 'Success',
    kind: 'object',
    interfaces: []
  };
  var Success_instance;
  function Success_getInstance() {
    if (Success_instance == null)
      new Success();
    return Success_instance;
  }
  function Failure_0(snapshot) {
    SnapshotApplyResult.call(this);
    this._snapshot_0 = snapshot;
    this._$stable_7 = 8;
  }
  Failure_0.$metadata$ = {
    simpleName: 'Failure',
    kind: 'class',
    interfaces: []
  };
  function SnapshotApplyResult() {
    this._$stable_8 = 0;
  }
  SnapshotApplyResult.$metadata$ = {
    simpleName: 'SnapshotApplyResult',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__83($tmp0_safe_receiver_2) {
    this._$tmp0_safe_receiver_2 = $tmp0_safe_receiver_2;
  }
  _no_name_provided__83.prototype.invoke_195 = function (state) {
    var inductionVariable = 0;
    var last = this._$tmp0_safe_receiver_2._get_size__45() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index_2_5_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item_3_6_8 = this._$tmp0_safe_receiver_2.get_66(index_2_5_7);
        item_3_6_8(state);
      }
       while (inductionVariable <= last);
  };
  _no_name_provided__83.prototype.invoke_468 = function (p1) {
    this.invoke_195(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__83.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__84($readObserver, $writeObserver) {
    this._$readObserver = $readObserver;
    this._$writeObserver = $writeObserver;
  }
  _no_name_provided__84.prototype.invoke_157 = function (invalid) {
    var tmp0_synchronized_0 = lock;
    var tmp0_2 = nextSnapshotId;
    nextSnapshotId = tmp0_2 + 1 | 0;
    return new MutableSnapshot(tmp0_2, invalid, this._$readObserver, this._$writeObserver);
  };
  _no_name_provided__84.prototype.invoke_468 = function (p1) {
    return this.invoke_157(p1 instanceof SnapshotIdSet ? p1 : THROW_CCE());
  };
  _no_name_provided__84.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GlobalSnapshot(id, invalid) {
    var tmp0_synchronized_0 = lock;
    var tmp;
    var tmp0_isNotEmpty_0_3 = globalWriteObservers;
    if (!tmp0_isNotEmpty_0_3.isEmpty_40()) {
      tmp = toMutableList(globalWriteObservers);
    } else {
      {
        tmp = null;
      }
    }
    var tmp0_safe_receiver_2 = tmp;
    var tmp_0;
    if (tmp0_safe_receiver_2 == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs_2_4 = firstOrNull(tmp0_safe_receiver_2);
      var tmp_1;
      if (tmp0_elvis_lhs_2_4 == null) {
        tmp_1 = _no_name_provided_$factory_71(tmp0_safe_receiver_2);
      } else {
        tmp_1 = tmp0_elvis_lhs_2_4;
      }
      tmp_0 = tmp_1;
    }
    MutableSnapshot.call(this, id, invalid, null, tmp_0);
  }
  GlobalSnapshot.prototype.takeNestedMutableSnapshot_2 = function (readObserver, writeObserver) {
    return takeNewSnapshot(_no_name_provided_$factory_72(readObserver, writeObserver));
  };
  GlobalSnapshot.prototype.notifyObjectsInitialized_4 = function () {
    advanceGlobalSnapshot_0();
  };
  GlobalSnapshot.prototype.nestedActivated_2 = function (snapshot) {
    unsupported_0();
  };
  GlobalSnapshot.prototype.nestedActivated_4 = function (snapshot) {
    return this.nestedActivated_2(snapshot);
  };
  GlobalSnapshot.prototype.apply_4 = function () {
    var tmp0_error_0 = 'Cannot apply the global snapshot directly. Call Snapshot.advanceGlobalSnapshot';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  GlobalSnapshot.$metadata$ = {
    simpleName: 'GlobalSnapshot',
    kind: 'class',
    interfaces: []
  };
  function StateObject() {
  }
  StateObject.prototype.mergeRecords_1 = function (previous, current_0, applied) {
    return null;
  };
  StateObject.$metadata$ = {
    simpleName: 'StateObject',
    kind: 'interface',
    interfaces: []
  };
  function currentSnapshot() {
    var tmp0_elvis_lhs = threadSnapshot.get_55();
    return tmp0_elvis_lhs == null ? currentGlobalSnapshot.get_55() : tmp0_elvis_lhs;
  }
  function _get_currentSnapshot_($this) {
    var tmp0_elvis_lhs = $this._previousSnapshot;
    return tmp0_elvis_lhs == null ? currentGlobalSnapshot.get_55() : tmp0_elvis_lhs;
  }
  function TransparentObserverMutableSnapshot(previousSnapshot, specifiedReadObserver, specifiedWriteObserver) {
    var tmp = Companion_getInstance_14()._EMPTY_4;
    var tmp0_safe_receiver = previousSnapshot;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_readObserver__3();
    var tmp_0 = mergedReadObserver(specifiedReadObserver, tmp1_elvis_lhs == null ? currentGlobalSnapshot.get_55()._get_readObserver__3() : tmp1_elvis_lhs);
    var tmp2_safe_receiver = previousSnapshot;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._get_writeObserver__3();
    MutableSnapshot.call(this, 0, tmp, tmp_0, mergedWriteObserver(specifiedWriteObserver, tmp3_elvis_lhs == null ? currentGlobalSnapshot.get_55()._get_writeObserver__3() : tmp3_elvis_lhs));
    this._previousSnapshot = previousSnapshot;
    this._specifiedReadObserver = specifiedReadObserver;
    this._specifiedWriteObserver = specifiedWriteObserver;
  }
  TransparentObserverMutableSnapshot.prototype.dispose_20 = function () {
    this._set_disposed__0(true);
  };
  TransparentObserverMutableSnapshot.prototype._set_id__3 = function (value_0) {
    unsupported_0();
  };
  TransparentObserverMutableSnapshot.prototype._get_id__3 = function () {
    return _get_currentSnapshot_(this)._get_id__3();
  };
  TransparentObserverMutableSnapshot.prototype._set_invalid__3 = function (value_0) {
    unsupported_0();
  };
  TransparentObserverMutableSnapshot.prototype._get_invalid__3 = function () {
    return _get_currentSnapshot_(this)._get_invalid__3();
  };
  TransparentObserverMutableSnapshot.prototype._set_modified__2 = function (value_0) {
    unsupported_0();
  };
  TransparentObserverMutableSnapshot.prototype._get_modified__2 = function () {
    return _get_currentSnapshot_(this)._get_modified__2();
  };
  TransparentObserverMutableSnapshot.prototype._get_readOnly__3 = function () {
    return _get_currentSnapshot_(this)._get_readOnly__3();
  };
  TransparentObserverMutableSnapshot.prototype.apply_4 = function () {
    return _get_currentSnapshot_(this).apply_4();
  };
  TransparentObserverMutableSnapshot.prototype.recordModified_3 = function (state) {
    return _get_currentSnapshot_(this).recordModified_3(state);
  };
  TransparentObserverMutableSnapshot.prototype.takeNestedMutableSnapshot_2 = function (readObserver, writeObserver) {
    return _get_currentSnapshot_(this).takeNestedMutableSnapshot_2(mergedReadObserver(readObserver, this._get_readObserver__3()), mergedWriteObserver(writeObserver, this._get_writeObserver__3()));
  };
  TransparentObserverMutableSnapshot.prototype.notifyObjectsInitialized_4 = function () {
    return _get_currentSnapshot_(this).notifyObjectsInitialized_4();
  };
  TransparentObserverMutableSnapshot.prototype.nestedActivated_2 = function (snapshot) {
    unsupported_0();
  };
  TransparentObserverMutableSnapshot.prototype.nestedActivated_4 = function (snapshot) {
    return this.nestedActivated_2(snapshot);
  };
  TransparentObserverMutableSnapshot.$metadata$ = {
    simpleName: 'TransparentObserverMutableSnapshot',
    kind: 'class',
    interfaces: []
  };
  function advanceGlobalSnapshot(block) {
    var previousGlobalSnapshot = currentGlobalSnapshot.get_55();
    var tmp0_synchronized_0_1 = lock;
    var result = takeNewGlobalSnapshot(previousGlobalSnapshot, block);
    var modified = previousGlobalSnapshot._get_modified__2();
    if (!(modified == null)) {
      var tmp0_synchronized_0_1_0 = lock;
      var observers = toMutableList(applyObservers);
      var inductionVariable = 0;
      var last = observers._get_size__45() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item_3 = observers.get_66(index_2);
          item_3(modified, previousGlobalSnapshot);
        }
         while (inductionVariable <= last);
    }var tmp = threadSnapshot.get_55();
    var tmp0_safe_receiver = tmp instanceof TransparentObserverMutableSnapshot ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      threadSnapshot.set_15(new TransparentObserverMutableSnapshot(currentGlobalSnapshot.get_55(), tmp0_safe_receiver._specifiedReadObserver, tmp0_safe_receiver._specifiedWriteObserver));
      tmp0_safe_receiver.dispose_20();
      Unit_getInstance();
    }
    Unit_getInstance();
    return result;
  }
  function advanceGlobalSnapshot_0() {
    return advanceGlobalSnapshot(_no_name_provided_$factory_73());
  }
  function NestedMutableSnapshot(id, invalid, readObserver, writeObserver, parent_0) {
    MutableSnapshot.call(this, id, invalid, readObserver, writeObserver);
    this._parent_3 = parent_0;
    this._parent_3.nestedActivated_4(this);
  }
  NestedMutableSnapshot.prototype.apply_4 = function () {
    if (this._parent_3._applied ? true : this._parent_3._get_disposed__3())
      return new Failure_0(this);
    var modified = this._get_modified__2();
    var id = this._get_id__3();
    var optimisticMerges_0 = !(modified == null) ? optimisticMerges(this._parent_3, this, this._parent_3._get_invalid__3()) : null;
    var tmp0_synchronized_0_1 = lock;
    validateOpen(this);
    if (modified == null ? true : modified._get_size__45() === 0) {
      this.close_7();
    } else {
      var result_3 = this.innerApply_2(this._parent_3._get_id__3(), optimisticMerges_0, this._parent_3._get_invalid__3());
      if (!equals(result_3, Success_getInstance()))
        return result_3;
      var tmp0_elvis_lhs_4 = this._parent_3._get_modified__2();
      var tmp;
      if (tmp0_elvis_lhs_4 == null) {
        var tmp0_also_0_5 = HashSet_init_$Create$();
        this._parent_3._set_modified__2(tmp0_also_0_5);
        tmp = tmp0_also_0_5;
      } else {
        tmp = tmp0_elvis_lhs_4;
      }
      tmp.addAll_10(modified);
      Unit_getInstance();
    }
    if (this._parent_3._get_id__3() < id) {
      this._parent_3.advance_2();
    }this._parent_3._set_invalid__3(this._parent_3._get_invalid__3().clear_6(id).andNot(this._get_previousIds__0()));
    this._parent_3.recordPrevious_2(id);
    this._parent_3.recordPreviousList_2(this._get_previousIds__0());
    this._set_applied__0(true);
    return Success_getInstance();
  };
  NestedMutableSnapshot.$metadata$ = {
    simpleName: 'NestedMutableSnapshot',
    kind: 'class',
    interfaces: []
  };
  function mergedReadObserver(readObserver, parentObserver) {
    var tmp;
    if ((!(readObserver == null) ? !(parentObserver == null) : false) ? !equals(readObserver, parentObserver) : false) {
      tmp = _no_name_provided_$factory_74(readObserver, parentObserver);
    } else {
      var tmp0_elvis_lhs = readObserver;
      tmp = tmp0_elvis_lhs == null ? parentObserver : tmp0_elvis_lhs;
    }
    return tmp;
  }
  function mergedWriteObserver(writeObserver, parentObserver) {
    var tmp;
    if ((!(writeObserver == null) ? !(parentObserver == null) : false) ? !equals(writeObserver, parentObserver) : false) {
      tmp = _no_name_provided_$factory_75(writeObserver, parentObserver);
    } else {
      var tmp0_elvis_lhs = writeObserver;
      tmp = tmp0_elvis_lhs == null ? parentObserver : tmp0_elvis_lhs;
    }
    return tmp;
  }
  function StateRecord() {
    this._snapshotId = currentSnapshot()._get_id__3();
    this._next_5 = null;
    this._$stable_9 = 8;
  }
  StateRecord.$metadata$ = {
    simpleName: 'StateRecord',
    kind: 'class',
    interfaces: []
  };
  function optimisticMerges(currentSnapshot_0, applyingSnapshot, invalidSnapshots) {
    var modified = applyingSnapshot._get_modified__2();
    var id = currentSnapshot_0._get_id__3();
    if (modified == null)
      return null;
    var start_0 = applyingSnapshot._get_invalid__3().set_11(applyingSnapshot._get_id__3()).or_0(applyingSnapshot._previousIds);
    var result = null;
    var tmp0_iterator = modified.iterator_46();
    while (tmp0_iterator.hasNext_27()) {
      var state = tmp0_iterator.next_28();
      var first = state._get_firstStateRecord__1();
      var tmp1_elvis_lhs = readable(first, id, invalidSnapshots);
      var tmp;
      if (tmp1_elvis_lhs == null) {
        continue;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var current_0 = tmp;
      var tmp2_elvis_lhs = readable(first, id, start_0);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        continue;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      var previous = tmp_0;
      if (!equals(current_0, previous)) {
        var tmp3_elvis_lhs = readable(first, applyingSnapshot._get_id__3(), applyingSnapshot._get_invalid__3());
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          readError();
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var applied = tmp_1;
        var merged = state.mergeRecords_1(previous, current_0, applied);
        if (!(merged == null)) {
          var tmp4_elvis_lhs = result;
          var tmp_2;
          if (tmp4_elvis_lhs == null) {
            var tmp0_also_0 = HashMap_init_$Create$();
            result = tmp0_also_0;
            tmp_2 = tmp0_also_0;
          } else {
            tmp_2 = tmp4_elvis_lhs;
          }
          var tmp1_set_0 = tmp_2;
          tmp1_set_0.put_6(current_0, merged);
          Unit_getInstance();
        } else {
          return null;
        }
      }}
    return result;
  }
  function validateOpen(snapshot) {
    if (!openSnapshots.get_66(snapshot._get_id__3())) {
      var tmp0_error_0 = 'Snapshot is not open';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    }}
  function takeNewGlobalSnapshot(previousGlobalSnapshot, block) {
    var result = block(openSnapshots.clear_6(previousGlobalSnapshot._get_id__3()));
    var tmp0_synchronized_0_1 = lock;
    var tmp0_4 = nextSnapshotId;
    nextSnapshotId = tmp0_4 + 1 | 0;
    var globalId_3 = tmp0_4;
    openSnapshots = openSnapshots.clear_6(previousGlobalSnapshot._get_id__3());
    currentGlobalSnapshot.set_14(new GlobalSnapshot(globalId_3, openSnapshots));
    openSnapshots = openSnapshots.set_11(globalId_3);
    return result;
  }
  function readable(r, id, invalid) {
    var current_0 = r;
    var candidate = null;
    while (!(current_0 == null)) {
      if (valid(current_0, id, invalid)) {
        candidate = candidate == null ? current_0 : candidate._snapshotId < current_0._snapshotId ? current_0 : candidate;
      }current_0 = current_0._next_5;
    }
    if (!(candidate == null)) {
      return candidate instanceof StateRecord ? candidate : THROW_CCE();
    }return null;
  }
  function readError() {
    var tmp0_error_0 = 'Reading a state that was created after the snapshot was taken or in a snapshot that has not yet been applied';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function takeNewSnapshot(block) {
    return advanceGlobalSnapshot(_no_name_provided_$factory_76(block));
  }
  function valid(data, snapshot, invalid) {
    return valid_0(snapshot, data._snapshotId, invalid);
  }
  function valid_0(currentSnapshot_0, candidateSnapshot, invalid) {
    return (!(candidateSnapshot === 0) ? candidateSnapshot <= currentSnapshot_0 : false) ? !invalid.get_66(candidateSnapshot) : false;
  }
  function readable_0(_this_, state) {
    return readable_1(_this_, state, currentSnapshot());
  }
  function readable_1(_this_, state, snapshot) {
    var tmp0_safe_receiver = snapshot._get_readObserver__3();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(state);
    Unit_getInstance();
    var tmp1_elvis_lhs = readable(_this_, snapshot._get_id__3(), snapshot._get_invalid__3());
    var tmp;
    if (tmp1_elvis_lhs == null) {
      readError();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function current(r, snapshot) {
    var tmp0_elvis_lhs = readable(r, snapshot._get_id__3(), snapshot._get_invalid__3());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      readError();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function notifyWrite(snapshot, state) {
    var tmp0_safe_receiver = snapshot._get_writeObserver__3();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(state);
    Unit_getInstance();
  }
  function overwritableRecord(_this_, state, snapshot, candidate) {
    if (snapshot._get_readOnly__3()) {
      snapshot.recordModified_3(state);
    }var id = snapshot._get_id__3();
    if (candidate._snapshotId === id)
      return candidate;
    var newData = newOverwritableRecord(_this_, state, snapshot);
    newData._snapshotId = id;
    snapshot.recordModified_3(state);
    return newData;
  }
  function newOverwritableRecord(_this_, state, snapshot) {
    var tmp = used(state, snapshot._get_id__3(), openSnapshots);
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof StateRecord) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp0_safe_receiver._snapshotId = IntCompanionObject_getInstance()._MAX_VALUE;
      tmp_0 = tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      var tmp0_apply_0 = _this_.create_6();
      tmp0_apply_0._snapshotId = IntCompanionObject_getInstance()._MAX_VALUE;
      tmp0_apply_0._next_5 = state._get_firstStateRecord__1();
      state.prependStateRecord_1(tmp0_apply_0 instanceof StateRecord ? tmp0_apply_0 : THROW_CCE());
      var tmp_2 = tmp0_apply_0;
      tmp_1 = tmp_2 instanceof StateRecord ? tmp_2 : THROW_CCE();
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function used(state, id, invalid) {
    var current_0 = state._get_firstStateRecord__1();
    var validRecord = null;
    var lowestOpen = invalid.lowest(id);
    while (!(current_0 == null)) {
      var currentId = current_0._snapshotId;
      if (currentId === 0) {
        return current_0;
      }if (valid(current_0, lowestOpen, invalid)) {
        if (validRecord == null) {
          validRecord = current_0;
        } else {
          return current_0._snapshotId < validRecord._snapshotId ? current_0 : validRecord;
        }
      }current_0 = current_0._next_5;
    }
    return null;
  }
  function writableRecord(_this_, state, snapshot) {
    if (snapshot._get_readOnly__3()) {
      snapshot.recordModified_3(state);
    }var id = snapshot._get_id__3();
    var tmp0_elvis_lhs = readable(_this_, id, snapshot._get_invalid__3());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      readError();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var readData = tmp;
    if (readData._snapshotId === snapshot._get_id__3())
      return readData;
    var newData = newWritableRecord(_this_, state, snapshot);
    snapshot.recordModified_3(state);
    return newData;
  }
  function newWritableRecord(_this_, state, snapshot) {
    var newData = newOverwritableRecord(_this_, state, snapshot);
    newData.assign_2(_this_);
    newData._snapshotId = snapshot._get_id__3();
    return newData;
  }
  function _no_name_provided__85() {
  }
  _no_name_provided__85.prototype.invoke_151 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__85.prototype.invoke_468 = function (p1) {
    this.invoke_151(p1 instanceof SnapshotIdSet ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__85.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__86() {
  }
  _no_name_provided__86.prototype.invoke_151 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__86.prototype.invoke_468 = function (p1) {
    this.invoke_151(p1 instanceof SnapshotIdSet ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__86.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__87($readObserver, $parentObserver) {
    this._$readObserver_0 = $readObserver;
    this._$parentObserver = $parentObserver;
  }
  _no_name_provided__87.prototype.invoke_195 = function (state) {
    this._$readObserver_0(state);
    this._$parentObserver(state);
  };
  _no_name_provided__87.prototype.invoke_468 = function (p1) {
    this.invoke_195(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__87.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__88($writeObserver, $parentObserver) {
    this._$writeObserver_0 = $writeObserver;
    this._$parentObserver_0 = $parentObserver;
  }
  _no_name_provided__88.prototype.invoke_195 = function (state) {
    this._$writeObserver_0(state);
    this._$parentObserver_0(state);
  };
  _no_name_provided__88.prototype.invoke_468 = function (p1) {
    this.invoke_195(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__88.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__89($block) {
    this._$block_3 = $block;
  }
  _no_name_provided__89.prototype.invoke_157 = function (invalid) {
    var result = this._$block_3(invalid);
    var tmp0_synchronized_0_1 = lock;
    openSnapshots = openSnapshots.set_11(result._get_id__3());
    return result;
  };
  _no_name_provided__89.prototype.invoke_468 = function (p1) {
    return this.invoke_157(p1 instanceof SnapshotIdSet ? p1 : THROW_CCE());
  };
  _no_name_provided__89.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_70() {
    var i = new _no_name_provided__85();
    return function (p1) {
      i.invoke_151(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_71($tmp0_safe_receiver_2) {
    var i = new _no_name_provided__83($tmp0_safe_receiver_2);
    return function (p1) {
      i.invoke_195(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_72($readObserver, $writeObserver) {
    var i = new _no_name_provided__84($readObserver, $writeObserver);
    return function (p1) {
      return i.invoke_157(p1);
    };
  }
  function _no_name_provided_$factory_73() {
    var i = new _no_name_provided__86();
    return function (p1) {
      i.invoke_151(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_74($readObserver, $parentObserver) {
    var i = new _no_name_provided__87($readObserver, $parentObserver);
    return function (p1) {
      i.invoke_195(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_75($writeObserver, $parentObserver) {
    var i = new _no_name_provided__88($writeObserver, $parentObserver);
    return function (p1) {
      i.invoke_195(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_76($block) {
    var i = new _no_name_provided__89($block);
    return function (p1) {
      return i.invoke_157(p1);
    };
  }
  function emptyLambda$init$() {
    return _no_name_provided_$factory_70();
  }
  function applyObservers$init$() {
    return ArrayList_init_$Create$();
  }
  function globalWriteObservers$init$() {
    return ArrayList_init_$Create$();
  }
  function currentGlobalSnapshot$init$() {
    var tmp0 = nextSnapshotId;
    nextSnapshotId = tmp0 + 1 | 0;
    var tmp0_also_0 = new GlobalSnapshot(tmp0, Companion_getInstance_14()._EMPTY_4);
    openSnapshots = openSnapshots.set_11(tmp0_also_0._get_id__3());
    return new AtomicReference(tmp0_also_0);
  }
  function Companion_15() {
    Companion_instance_14 = this;
    this._EMPTY_4 = new SnapshotIdSet(new Long(0, 0), new Long(0, 0), 0, null);
  }
  Companion_15.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_15();
    return Companion_instance_14;
  }
  function _no_name_provided__90(this$0, resultContinuation) {
    this._this$0_22 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__90.prototype.invoke_159 = function ($this$sequence, $cont) {
    var tmp = this.create_5($this$sequence, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__90.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 15;
            this._belowBound0 = this._this$0_22._belowBound;
            if (!(this._belowBound0 == null)) {
              this._tmp0_iterator1 = intArrayIterator(this._belowBound0);
              this._state_1 = 1;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            if (!this._tmp0_iterator1.hasNext_27()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._element2 = this._tmp0_iterator1.next_28();
            this._state_1 = 2;
            suspendResult = this._$this$sequence_0.yield_0(this._element2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!this._this$0_22._lowerSet.equals(new Long(0, 0))) {
              this._tmp1_iterator3 = until(0, 64).iterator_46();
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 9;
              continue $sm;
            }

            break;
          case 5:
            if (!this._tmp1_iterator3.hasNext_27()) {
              this._state_1 = 8;
              continue $sm;
            }
            this._index4 = this._tmp1_iterator3.next_28();
            if (!this._this$0_22._lowerSet.and((new Long(1, 0)).shl_0(this._index4)).equals(new Long(0, 0))) {
              this._state_1 = 6;
              suspendResult = this._$this$sequence_0.yield_0(this._index4 + this._this$0_22._lowerBound | 0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 7;
              continue $sm;
            }

            break;
          case 6:
            suspendResult;
            this._state_1 = 7;
            continue $sm;
          case 7:
            this._state_1 = 5;
            continue $sm;
          case 8:
            this._state_1 = 9;
            continue $sm;
          case 9:
            if (!this._this$0_22._upperSet.equals(new Long(0, 0))) {
              this._tmp2_iterator5 = until(0, 64).iterator_46();
              this._state_1 = 10;
              continue $sm;
            } else {
              this._state_1 = 14;
              continue $sm;
            }

            break;
          case 10:
            if (!this._tmp2_iterator5.hasNext_27()) {
              this._state_1 = 13;
              continue $sm;
            }
            this._index6 = this._tmp2_iterator5.next_28();
            if (!this._this$0_22._upperSet.and((new Long(1, 0)).shl_0(this._index6)).equals(new Long(0, 0))) {
              this._state_1 = 11;
              suspendResult = this._$this$sequence_0.yield_0((this._index6 + 64 | 0) + this._this$0_22._lowerBound | 0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 12;
              continue $sm;
            }

            break;
          case 11:
            suspendResult;
            this._state_1 = 12;
            continue $sm;
          case 12:
            this._state_1 = 10;
            continue $sm;
          case 13:
            this._state_1 = 14;
            continue $sm;
          case 14:
            return Unit_getInstance();
          case 15:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 15) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__90.prototype.create_5 = function ($this$sequence, completion) {
    var i = new _no_name_provided__90(this._this$0_22, completion);
    i._$this$sequence_0 = $this$sequence;
    return i;
  };
  _no_name_provided__90.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function SnapshotIdSet(upperSet, lowerSet, lowerBound, belowBound) {
    Companion_getInstance_14();
    this._upperSet = upperSet;
    this._lowerSet = lowerSet;
    this._lowerBound = lowerBound;
    this._belowBound = belowBound;
  }
  SnapshotIdSet.prototype.get_66 = function (bit) {
    var offset_0 = bit - this._lowerBound | 0;
    if (offset_0 >= 0 ? offset_0 < 64 : false) {
      return !(new Long(1, 0)).shl_0(offset_0).and(this._lowerSet).equals(new Long(0, 0));
    } else if (offset_0 >= 64 ? offset_0 < 128 : false) {
      return !(new Long(1, 0)).shl_0(offset_0 - 64 | 0).and(this._upperSet).equals(new Long(0, 0));
    } else if (offset_0 > 0) {
      return false;
    } else {
      var tmp0_safe_receiver = this._belowBound;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = binarySearch(tmp0_safe_receiver, bit) >= 0;
      }
      var tmp1_elvis_lhs = tmp;
      return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    }
  };
  SnapshotIdSet.prototype.set_11 = function (bit) {
    var offset_0 = bit - this._lowerBound | 0;
    if (offset_0 >= 0 ? offset_0 < 64 : false) {
      var mask = (new Long(1, 0)).shl_0(offset_0);
      if (this._lowerSet.and(mask).equals(new Long(0, 0))) {
        return new SnapshotIdSet(this._upperSet, this._lowerSet.or(mask), this._lowerBound, this._belowBound);
      }} else if (offset_0 >= 64 ? offset_0 < 128 : false) {
      var mask_0 = (new Long(1, 0)).shl_0(offset_0 - 64 | 0);
      if (this._upperSet.and(mask_0).equals(new Long(0, 0))) {
        return new SnapshotIdSet(this._upperSet.or(mask_0), this._lowerSet, this._lowerBound, this._belowBound);
      }} else if (offset_0 >= 128) {
      if (!this.get_66(bit)) {
        var newUpperSet = this._upperSet;
        var newLowerSet = this._lowerSet;
        var newLowerBound = this._lowerBound;
        var newBelowBound = null;
        var targetLowerBound = imul((bit + 1 | 0) / 64 | 0, 64);
        $l$break: while (newLowerBound < targetLowerBound) {
          if (!newLowerSet.equals(new Long(0, 0))) {
            if (newBelowBound == null) {
              var tmp0_apply_0 = ArrayList_init_$Create$();
              var tmp0_safe_receiver_2 = this._belowBound;
              if (tmp0_safe_receiver_2 == null)
                null;
              else {
                var indexedObject = tmp0_safe_receiver_2;
                var inductionVariable = 0;
                var last = indexedObject.length;
                while (inductionVariable < last) {
                  var element_2_3_4 = indexedObject[inductionVariable];
                  inductionVariable = inductionVariable + 1 | 0;
                  tmp0_apply_0.add_37(element_2_3_4);
                  Unit_getInstance();
                }
                Unit_getInstance();
              }
              Unit_getInstance();
              newBelowBound = tmp0_apply_0;
            }var tmp1_repeat_0 = 64;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < tmp1_repeat_0)
              do {
                var index_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (!newLowerSet.and((new Long(1, 0)).shl_0(index_2)).equals(new Long(0, 0))) {
                  newBelowBound.add_37(index_2 + newLowerBound | 0);
                  Unit_getInstance();
                }}
               while (inductionVariable_0 < tmp1_repeat_0);
          }if (newUpperSet.equals(new Long(0, 0))) {
            newLowerBound = targetLowerBound;
            newLowerSet = new Long(0, 0);
            break $l$break;
          }newLowerSet = newUpperSet;
          newUpperSet = new Long(0, 0);
          newLowerBound = newLowerBound + 64 | 0;
        }
        var tmp = newUpperSet;
        var tmp_0 = newLowerSet;
        var tmp_1 = newLowerBound;
        var tmp0_safe_receiver = newBelowBound;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toIntArray(tmp0_safe_receiver);
        return (new SnapshotIdSet(tmp, tmp_0, tmp_1, tmp1_elvis_lhs == null ? this._belowBound : tmp1_elvis_lhs)).set_11(bit);
      }} else {
      var tmp2_elvis_lhs = this._belowBound;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        var tmp2_intArrayOf_0 = new Int32Array([bit]);
        return new SnapshotIdSet(this._upperSet, this._lowerSet, this._lowerBound, tmp2_intArrayOf_0);
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var array = tmp_2;
      var location = binarySearch(array, bit);
      if (location < 0) {
        var insertLocation = -(location + 1 | 0) | 0;
        var newSize = array.length + 1 | 0;
        var newBelowBound_0 = new Int32Array(newSize);
        var tmp3_copyInto_0 = 0;
        var tmp4_copyInto_0 = 0;
        var tmp_3 = array;
        arrayCopy_0(tmp_3, newBelowBound_0, tmp3_copyInto_0, tmp4_copyInto_0, insertLocation);
        Unit_getInstance();
        var tmp5_copyInto_0 = insertLocation + 1 | 0;
        var tmp6_copyInto_0 = newSize - 1 | 0;
        var tmp_4 = array;
        arrayCopy_0(tmp_4, newBelowBound_0, tmp5_copyInto_0, insertLocation, tmp6_copyInto_0);
        Unit_getInstance();
        newBelowBound_0[insertLocation] = bit;
        return new SnapshotIdSet(this._upperSet, this._lowerSet, this._lowerBound, newBelowBound_0);
      }}
    return this;
  };
  SnapshotIdSet.prototype.clear_6 = function (bit) {
    var offset_0 = bit - this._lowerBound | 0;
    if (offset_0 >= 0 ? offset_0 < 64 : false) {
      var mask = (new Long(1, 0)).shl_0(offset_0);
      if (!this._lowerSet.and(mask).equals(new Long(0, 0))) {
        return new SnapshotIdSet(this._upperSet, this._lowerSet.and(mask.inv_0()), this._lowerBound, this._belowBound);
      }} else if (offset_0 >= 64 ? offset_0 < 128 : false) {
      var mask_0 = (new Long(1, 0)).shl_0(offset_0 - 64 | 0);
      if (!this._upperSet.and(mask_0).equals(new Long(0, 0))) {
        return new SnapshotIdSet(this._upperSet.and(mask_0.inv_0()), this._lowerSet, this._lowerBound, this._belowBound);
      }} else if (offset_0 < 0) {
      var array = this._belowBound;
      if (!(array == null)) {
        var location = binarySearch(array, bit);
        if (location >= 0) {
          var newSize = array.length - 1 | 0;
          if (newSize === 0) {
            return new SnapshotIdSet(this._upperSet, this._lowerSet, this._lowerBound, null);
          }var newBelowBound = new Int32Array(newSize);
          if (location > 0) {
            var tmp0_copyInto_0 = 0;
            var tmp1_copyInto_0 = 0;
            var tmp = array;
            arrayCopy_0(tmp, newBelowBound, tmp0_copyInto_0, tmp1_copyInto_0, location);
            Unit_getInstance();
          }if (location < newSize) {
            var tmp2_copyInto_0 = location + 1 | 0;
            var tmp3_copyInto_0 = newSize + 1 | 0;
            var tmp_0 = array;
            arrayCopy_0(tmp_0, newBelowBound, location, tmp2_copyInto_0, tmp3_copyInto_0);
            Unit_getInstance();
          }return new SnapshotIdSet(this._upperSet, this._lowerSet, this._lowerBound, newBelowBound);
        }}}return this;
  };
  SnapshotIdSet.prototype.andNot = function (bits) {
    if (bits === Companion_getInstance_14()._EMPTY_4)
      return this;
    if (this === Companion_getInstance_14()._EMPTY_4)
      return Companion_getInstance_14()._EMPTY_4;
    var tmp;
    if (bits._lowerBound === this._lowerBound ? bits._belowBound === this._belowBound : false) {
      tmp = new SnapshotIdSet(this._upperSet.and(bits._upperSet.inv_0()), this._lowerSet.and(bits._lowerSet.inv_0()), this._lowerBound, this._belowBound);
    } else {
      var accumulator_1 = this;
      var tmp0_iterator_2 = bits.iterator_46();
      while (tmp0_iterator_2.hasNext_27()) {
        var element_3 = tmp0_iterator_2.next_28();
        var tmp0__anonymous__4 = accumulator_1;
        accumulator_1 = tmp0__anonymous__4.clear_6(element_3);
      }
      tmp = accumulator_1;
    }
    return tmp;
  };
  SnapshotIdSet.prototype.or_0 = function (bits) {
    if (bits === Companion_getInstance_14()._EMPTY_4)
      return this;
    if (this === Companion_getInstance_14()._EMPTY_4)
      return bits;
    var tmp;
    if (bits._lowerBound === this._lowerBound ? bits._belowBound === this._belowBound : false) {
      tmp = new SnapshotIdSet(this._upperSet.or(bits._upperSet), this._lowerSet.or(bits._lowerSet), this._lowerBound, this._belowBound);
    } else {
      var tmp_0;
      if (this._belowBound == null) {
        var accumulator_1 = bits;
        var tmp0_iterator_2 = this.iterator_46();
        while (tmp0_iterator_2.hasNext_27()) {
          var element_3 = tmp0_iterator_2.next_28();
          var tmp0__anonymous__4 = accumulator_1;
          accumulator_1 = tmp0__anonymous__4.set_11(element_3);
        }
        tmp_0 = accumulator_1;
      } else {
        var accumulator_1_0 = this;
        var tmp0_iterator_2_0 = bits.iterator_46();
        while (tmp0_iterator_2_0.hasNext_27()) {
          var element_3_0 = tmp0_iterator_2_0.next_28();
          var tmp1__anonymous__4 = accumulator_1_0;
          accumulator_1_0 = tmp1__anonymous__4.set_11(element_3_0);
        }
        tmp_0 = accumulator_1_0;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  SnapshotIdSet.prototype.iterator_46 = function () {
    return sequence(_no_name_provided_$factory_77(this, null)).iterator_46();
  };
  SnapshotIdSet.prototype.lowest = function (default_0) {
    var belowBound = this._belowBound;
    if (!(belowBound == null))
      return belowBound[0];
    if (!this._lowerSet.equals(new Long(0, 0)))
      return this._lowerBound + lowestBitOf(this._lowerSet) | 0;
    if (!this._upperSet.equals(new Long(0, 0)))
      return (this._lowerBound + 64 | 0) + lowestBitOf(this._upperSet) | 0;
    return default_0;
  };
  SnapshotIdSet.prototype.toString = function () {
    var tmp = anyToString(this);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this, 10));
    var tmp0_iterator_1_2 = this.iterator_46();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_28();
      tmp0_mapTo_0_1.add_37(item_2_3.toString());
      Unit_getInstance();
    }
    return '' + tmp + ' [' + fastJoinToString$default(tmp0_mapTo_0_1, null, null, null, 0, null, null, 63, null) + ']';
  };
  SnapshotIdSet.$metadata$ = {
    simpleName: 'SnapshotIdSet',
    kind: 'class',
    interfaces: [Iterable]
  };
  function binarySearch(_this_, value_0) {
    var low = 0;
    var high = _this_.length - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1;
      var midVal = _this_[mid];
      if (value_0 > midVal)
        low = mid + 1 | 0;
      else if (value_0 < midVal)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function lowestBitOf(bits) {
    var b = bits;
    var base = 0;
    if (b.and(new Long(-1, 0)).equals(new Long(0, 0))) {
      base = base + 32 | 0;
      b = b.shr_0(32);
    }if (b.and(new Long(65535, 0)).equals(new Long(0, 0))) {
      base = base + 16 | 0;
      b = b.shr_0(16);
    }if (b.and(new Long(255, 0)).equals(new Long(0, 0))) {
      base = base + 8 | 0;
      b = b.shr_0(8);
    }if (b.and(new Long(15, 0)).equals(new Long(0, 0))) {
      base = base + 4 | 0;
      b = b.shr_0(4);
    }if (!b.and(new Long(1, 0)).equals(new Long(0, 0)))
      return base;
    if (!b.and(new Long(2, 0)).equals(new Long(0, 0)))
      return base + 1 | 0;
    if (!b.and(new Long(4, 0)).equals(new Long(0, 0)))
      return base + 2 | 0;
    if (!b.and(new Long(8, 0)).equals(new Long(0, 0)))
      return base + 3 | 0;
    return -1;
  }
  function _no_name_provided_$factory_77(this$0, resultContinuation) {
    var i = new _no_name_provided__90(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_159(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function SnapshotMutableState() {
  }
  SnapshotMutableState.$metadata$ = {
    simpleName: 'SnapshotMutableState',
    kind: 'interface',
    interfaces: [MutableState]
  };
  function StateListStateRecord(list) {
    StateRecord.call(this);
    this._list_2 = list;
    this._modification = 0;
  }
  StateListStateRecord.prototype.assign_2 = function (value_0) {
    var tmp = this;
    tmp._list_2 = (value_0 instanceof StateListStateRecord ? value_0 : THROW_CCE())._list_2;
    this._modification = value_0._modification;
  };
  StateListStateRecord.prototype.create_6 = function () {
    return new StateListStateRecord(this._list_2);
  };
  StateListStateRecord.$metadata$ = {
    simpleName: 'StateListStateRecord',
    kind: 'class',
    interfaces: []
  };
  function SnapshotStateList() {
    this._firstStateRecord = new StateListStateRecord(persistentListOf());
  }
  SnapshotStateList.prototype._get_firstStateRecord__1 = function () {
    return this._firstStateRecord;
  };
  SnapshotStateList.prototype.prependStateRecord_1 = function (value_0) {
    value_0._next_5 = this._firstStateRecord;
    var tmp = this;
    tmp._firstStateRecord = value_0 instanceof StateListStateRecord ? value_0 : THROW_CCE();
  };
  SnapshotStateList.prototype._get_modification_ = function () {
    var tmp = this._firstStateRecord;
    var tmp0_withCurrent_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var tmp1__anonymous__1 = current(tmp0_withCurrent_0, Companion_getInstance_13()._get_current__2());
    return tmp1__anonymous__1._modification;
  };
  SnapshotStateList.prototype._get_readable_ = function () {
    var tmp = this._firstStateRecord;
    return readable_0(tmp instanceof StateListStateRecord ? tmp : THROW_CCE(), this);
  };
  SnapshotStateList.prototype._get_size__45 = function () {
    return this._get_readable_()._list_2._get_size__45();
  };
  SnapshotStateList.prototype.contains_36 = function (element) {
    return this._get_readable_()._list_2.contains_37(element);
  };
  SnapshotStateList.prototype.contains_37 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_36((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  SnapshotStateList.prototype.containsAll_27 = function (elements) {
    return this._get_readable_()._list_2.containsAll_28(elements);
  };
  SnapshotStateList.prototype.containsAll_28 = function (elements) {
    return this.containsAll_27(elements);
  };
  SnapshotStateList.prototype.get_66 = function (index) {
    return this._get_readable_()._list_2.get_66(index);
  };
  SnapshotStateList.prototype.isEmpty_40 = function () {
    return this._get_readable_()._list_2.isEmpty_40();
  };
  SnapshotStateList.prototype.iterator_46 = function () {
    return this.listIterator_11();
  };
  SnapshotStateList.prototype.lastIndexOf_8 = function (element) {
    return this._get_readable_()._list_2.lastIndexOf_9(element);
  };
  SnapshotStateList.prototype.lastIndexOf_9 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return -1;
    else {
    }
    return this.lastIndexOf_8((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  SnapshotStateList.prototype.listIterator_11 = function () {
    return new StateListIterator(this, 0);
  };
  SnapshotStateList.prototype.listIterator_12 = function (index) {
    return new StateListIterator(this, index);
  };
  SnapshotStateList.prototype.add_36 = function (element) {
    var tmp = this._firstStateRecord;
    var tmp0_withCurrent_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var tmp1__anonymous__1_1 = current(tmp0_withCurrent_0, Companion_getInstance_13()._get_current__2());
    var tmp2__anonymous__6 = tmp1__anonymous__1_1._list_2;
    var newList_2_2 = tmp2__anonymous__6.add_37(element);
    var tmp_0;
    if (!(newList_2_2 === tmp1__anonymous__1_1._list_2)) {
      var tmp_1 = this._firstStateRecord;
      var tmp0_writable_0_3 = tmp_1 instanceof StateListStateRecord ? tmp_1 : THROW_CCE();
      var snapshot_1_4 = snapshotInitializer;
      var tmp0_synchronized_0_1_3_6 = lock;
      snapshot_1_4 = Companion_getInstance_13()._get_current__2();
      var tmp1__anonymous__3_1_7 = writableRecord(tmp0_writable_0_3, this, snapshot_1_4);
      tmp1__anonymous__3_1_7._list_2 = newList_2_2;
      var tmp0_this_4_2_8 = tmp1__anonymous__3_1_7;
      var tmp1_5_3_9 = tmp0_this_4_2_8._modification;
      tmp0_this_4_2_8._modification = tmp1_5_3_9 + 1 | 0;
      Unit_getInstance();
      var tmp0_also_0_2_5 = true;
      notifyWrite(snapshot_1_4, this);
      tmp_0 = tmp0_also_0_2_5;
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  };
  SnapshotStateList.prototype.add_37 = function (element) {
    return this.add_36((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  SnapshotStateList.prototype.add_38 = function (index, element) {
    var tmp = this._firstStateRecord;
    var tmp0_withCurrent_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var tmp1__anonymous__1_1 = current(tmp0_withCurrent_0, Companion_getInstance_13()._get_current__2());
    var tmp2__anonymous__6 = tmp1__anonymous__1_1._list_2;
    var newList_2_2 = tmp2__anonymous__6.add_31(index, element);
    var tmp_0;
    if (!(newList_2_2 === tmp1__anonymous__1_1._list_2)) {
      var tmp_1 = this._firstStateRecord;
      var tmp0_writable_0_3 = tmp_1 instanceof StateListStateRecord ? tmp_1 : THROW_CCE();
      var snapshot_1_4 = snapshotInitializer;
      var tmp0_synchronized_0_1_3_6 = lock;
      snapshot_1_4 = Companion_getInstance_13()._get_current__2();
      var tmp1__anonymous__3_1_7 = writableRecord(tmp0_writable_0_3, this, snapshot_1_4);
      tmp1__anonymous__3_1_7._list_2 = newList_2_2;
      var tmp0_this_4_2_8 = tmp1__anonymous__3_1_7;
      var tmp1_5_3_9 = tmp0_this_4_2_8._modification;
      tmp0_this_4_2_8._modification = tmp1_5_3_9 + 1 | 0;
      var tmp0_also_0_2_5 = tmp1_5_3_9;
      notifyWrite(snapshot_1_4, this);
      tmp_0 = Unit_getInstance();
    }return tmp_0;
  };
  SnapshotStateList.prototype.add_39 = function (index, element) {
    return this.add_38(index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  SnapshotStateList.prototype.clear_7 = function () {
    var tmp = this._firstStateRecord;
    var tmp0_writable_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var snapshot_1 = snapshotInitializer;
    var tmp0_synchronized_0_1_3 = lock;
    snapshot_1 = Companion_getInstance_13()._get_current__2();
    var tmp1__anonymous__1 = writableRecord(tmp0_writable_0, this, snapshot_1);
    tmp1__anonymous__1._list_2 = persistentListOf();
    var tmp0_also_0_2 = Unit_getInstance();
    notifyWrite(snapshot_1, this);
    return tmp0_also_0_2;
  };
  SnapshotStateList.prototype.remove_50 = function (element) {
    var tmp = this._firstStateRecord;
    var tmp0_withCurrent_0 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var tmp1__anonymous__1_1 = current(tmp0_withCurrent_0, Companion_getInstance_13()._get_current__2());
    var tmp2__anonymous__6 = tmp1__anonymous__1_1._list_2;
    var newList_2_2 = tmp2__anonymous__6.remove_51(element);
    var tmp_0;
    if (!(newList_2_2 === tmp1__anonymous__1_1._list_2)) {
      var tmp_1 = this._firstStateRecord;
      var tmp0_writable_0_3 = tmp_1 instanceof StateListStateRecord ? tmp_1 : THROW_CCE();
      var snapshot_1_4 = snapshotInitializer;
      var tmp0_synchronized_0_1_3_6 = lock;
      snapshot_1_4 = Companion_getInstance_13()._get_current__2();
      var tmp1__anonymous__3_1_7 = writableRecord(tmp0_writable_0_3, this, snapshot_1_4);
      tmp1__anonymous__3_1_7._list_2 = newList_2_2;
      var tmp0_this_4_2_8 = tmp1__anonymous__3_1_7;
      var tmp1_5_3_9 = tmp0_this_4_2_8._modification;
      tmp0_this_4_2_8._modification = tmp1_5_3_9 + 1 | 0;
      Unit_getInstance();
      var tmp0_also_0_2_5 = true;
      notifyWrite(snapshot_1_4, this);
      tmp_0 = tmp0_also_0_2_5;
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  };
  SnapshotStateList.prototype.remove_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_50((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  SnapshotStateList.prototype.removeAt_7 = function (index) {
    var tmp0_also_0 = this.get_66(index);
    var tmp = this._firstStateRecord;
    var tmp0_withCurrent_0_2 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var tmp1__anonymous__1_1_3 = current(tmp0_withCurrent_0_2, Companion_getInstance_13()._get_current__2());
    var tmp2__anonymous__6_5 = tmp1__anonymous__1_1_3._list_2;
    var newList_2_2_4 = tmp2__anonymous__6_5.removeAt_7(index);
    if (!(newList_2_2_4 === tmp1__anonymous__1_1_3._list_2)) {
      var tmp_0 = this._firstStateRecord;
      var tmp0_writable_0_3_6 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot_1_4_7 = snapshotInitializer;
      var tmp0_synchronized_0_1_3_6_9 = lock;
      snapshot_1_4_7 = Companion_getInstance_13()._get_current__2();
      var tmp1__anonymous__3_1_7_10 = writableRecord(tmp0_writable_0_3_6, this, snapshot_1_4_7);
      tmp1__anonymous__3_1_7_10._list_2 = newList_2_2_4;
      var tmp0_this_4_2_8_11 = tmp1__anonymous__3_1_7_10;
      var tmp1_5_3_9_12 = tmp0_this_4_2_8_11._modification;
      tmp0_this_4_2_8_11._modification = tmp1_5_3_9_12 + 1 | 0;
      var tmp0_also_0_2_5_8 = tmp1_5_3_9_12;
      notifyWrite(snapshot_1_4_7, this);
      Unit_getInstance();
    }return tmp0_also_0;
  };
  SnapshotStateList.prototype.set_12 = function (index, element) {
    var tmp0_also_0 = this.get_66(index);
    var tmp = this._firstStateRecord;
    var tmp0_withCurrent_0_2 = tmp instanceof StateListStateRecord ? tmp : THROW_CCE();
    var tmp1__anonymous__1_1_3 = current(tmp0_withCurrent_0_2, Companion_getInstance_13()._get_current__2());
    var tmp2__anonymous__6_5 = tmp1__anonymous__1_1_3._list_2;
    var newList_2_2_4 = tmp2__anonymous__6_5.set_13(index, element);
    if (!(newList_2_2_4 === tmp1__anonymous__1_1_3._list_2)) {
      var tmp_0 = this._firstStateRecord;
      var tmp0_writable_0_3_6 = tmp_0 instanceof StateListStateRecord ? tmp_0 : THROW_CCE();
      var snapshot_1_4_7 = snapshotInitializer;
      var tmp0_synchronized_0_1_3_6_9 = lock;
      snapshot_1_4_7 = Companion_getInstance_13()._get_current__2();
      var tmp1__anonymous__3_1_7_10 = writableRecord(tmp0_writable_0_3_6, this, snapshot_1_4_7);
      tmp1__anonymous__3_1_7_10._list_2 = newList_2_2_4;
      var tmp0_this_4_2_8_11 = tmp1__anonymous__3_1_7_10;
      var tmp1_5_3_9_12 = tmp0_this_4_2_8_11._modification;
      tmp0_this_4_2_8_11._modification = tmp1_5_3_9_12 + 1 | 0;
      var tmp0_also_0_2_5_8 = tmp1_5_3_9_12;
      notifyWrite(snapshot_1_4_7, this);
      Unit_getInstance();
    }return tmp0_also_0;
  };
  SnapshotStateList.prototype.set_13 = function (index, element) {
    return this.set_12(index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  SnapshotStateList.$metadata$ = {
    simpleName: 'SnapshotStateList',
    kind: 'class',
    interfaces: [MutableList, StateObject]
  };
  function validateModification($this) {
    if (!($this._list_3._get_modification_() === $this._modification_0)) {
      throw ConcurrentModificationException_init_$Create$();
    }}
  function StateListIterator(list, offset_0) {
    this._list_3 = list;
    this._index_8 = offset_0 - 1 | 0;
    this._modification_0 = this._list_3._get_modification_();
  }
  StateListIterator.prototype.hasPrevious_8 = function () {
    return this._index_8 >= 0;
  };
  StateListIterator.prototype.nextIndex_7 = function () {
    return this._index_8 + 1 | 0;
  };
  StateListIterator.prototype.previous_7 = function () {
    validateModification(this);
    validateRange(this._index_8, this._list_3._get_size__45());
    var tmp0_also_0 = this._list_3.get_66(this._index_8);
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2._index_8;
    tmp0_this_2._index_8 = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_also_0;
  };
  StateListIterator.prototype.hasNext_27 = function () {
    return this._index_8 < (this._list_3._get_size__45() - 1 | 0);
  };
  StateListIterator.prototype.next_28 = function () {
    validateModification(this);
    var newIndex = this._index_8 + 1 | 0;
    validateRange(newIndex, this._list_3._get_size__45());
    var tmp0_also_0 = this._list_3.get_66(newIndex);
    this._index_8 = newIndex;
    return tmp0_also_0;
  };
  StateListIterator.prototype.remove_52 = function () {
    validateModification(this);
    this._list_3.removeAt_7(this._index_8);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_8;
    tmp0_this._index_8 = tmp1 - 1 | 0;
    Unit_getInstance();
    this._modification_0 = this._list_3._get_modification_();
  };
  StateListIterator.$metadata$ = {
    simpleName: 'StateListIterator',
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function validateRange(index, size_1) {
    if (!(0 <= index ? index < size_1 : false)) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index (' + index + ') is out of bound of [0, ' + size_1 + ')');
    }}
  function unsupported_0() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function CompositionData() {
  }
  CompositionData.$metadata$ = {
    simpleName: 'CompositionData',
    kind: 'interface',
    interfaces: []
  };
  function CompositionGroup() {
  }
  CompositionGroup.$metadata$ = {
    simpleName: 'CompositionGroup',
    kind: 'interface',
    interfaces: [CompositionData]
  };
  var LocalInspectionTables;
  function _no_name_provided__91() {
  }
  _no_name_provided__91.prototype.invoke_452 = function () {
    return null;
  };
  _no_name_provided__91.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_78() {
    var i = new _no_name_provided__91();
    return function () {
      return i.invoke_452();
    };
  }
  var nextHash;
  var DefaultMonotonicFrameClock;
  function AtomicReference(value_0) {
    this._value_6 = value_0;
    this._$stable_10 = 8;
  }
  AtomicReference.prototype.get_55 = function () {
    return this._value_6;
  };
  AtomicReference.prototype.set_14 = function (value_0) {
    this._value_6 = value_0;
  };
  AtomicReference.prototype.getAndSet = function (value_0) {
    var oldValue = this._value_6;
    this._value_6 = value_0;
    return oldValue;
  };
  AtomicReference.prototype.compareAndSet_1 = function (expect, newValue) {
    var tmp;
    if (equals(expect, this._value_6)) {
      this._value_6 = newValue;
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  AtomicReference.$metadata$ = {
    simpleName: 'AtomicReference',
    kind: 'class',
    interfaces: []
  };
  function identityHashCode_0(instance) {
    if (instance == null) {
      return 0;
    }var hashCode_1 = instance['kotlinIdentityHashcodeValue$'];
    if (hashCode_1 != null) {
      return hashCode_1;
    }var tmp0_subject = typeof instance;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
      case 'function':
        tmp = memoizeIdentityHashCode(instance);
        break;
      default:throw IllegalArgumentException_init_$Create$('' + 'identity hash code for ' + typeof instance + ' is not supported');
    }
    return tmp;
  }
  function SnapshotThreadLocal() {
    this._value_7 = null;
  }
  SnapshotThreadLocal.prototype.get_55 = function () {
    return this._value_7;
  };
  SnapshotThreadLocal.prototype.set_15 = function (value_0) {
    this._value_7 = value_0;
  };
  SnapshotThreadLocal.$metadata$ = {
    simpleName: 'SnapshotThreadLocal',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__92($onFrame, $safe_2_2) {
    this._$onFrame = $onFrame;
    this._$safe_2_2 = $safe_2_2;
  }
  _no_name_provided__92.prototype.invoke_161 = function (it) {
    var duration_5 = toDuration(it, DurationUnit_MILLISECONDS_getInstance());
    var result_6 = this._$onFrame(Duration__toLongNanoseconds_impl(duration_5));
    var tmp0_success_0_1_7 = Companion_getInstance_2();
    this._$safe_2_2.resumeWith_15(_Result___init__impl_(result_6));
  };
  _no_name_provided__92.prototype.invoke_468 = function (p1) {
    this.invoke_161((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__92.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $withFrameNanosCOROUTINE$4(_this_, onFrame, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__0 = _this_;
    this._onFrame_0 = onFrame;
  }
  $withFrameNanosCOROUTINE$4.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this;
            tmp_0._tmp0__anonymous__1_10_0 = this;
            this._safe_2_21 = SafeContinuation_init_$Create$(intercepted(this._tmp0__anonymous__1_10_0));
            var tmp_1 = window;
            tmp_1.requestAnimationFrame(_no_name_provided_$factory_79(this._onFrame_0, this._safe_2_21));
            Unit_getInstance();
            suspendResult = this._safe_2_21.getOrThrow();
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $withFrameNanosCOROUTINE$4.$metadata$ = {
    simpleName: '$withFrameNanosCOROUTINE$4',
    kind: 'class',
    interfaces: []
  };
  function MonotonicClockImpl() {
  }
  MonotonicClockImpl.prototype.withFrameNanos_1 = function (onFrame, $cont) {
    var tmp = new $withFrameNanosCOROUTINE$4(this, onFrame, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  MonotonicClockImpl.$metadata$ = {
    simpleName: 'MonotonicClockImpl',
    kind: 'class',
    interfaces: [MonotonicFrameClock]
  };
  function memoizeIdentityHashCode(instance) {
    var tmp0 = nextHash;
    nextHash = tmp0 + 1 | 0;
    var value_0 = tmp0;
    var descriptor = new Object();
    descriptor.value = value_0;
    descriptor.writable = false;
    descriptor.configurable = false;
    descriptor.enumerable = false;
    Object.defineProperty(instance, 'kotlinIdentityHashcodeValue$', descriptor);
    return value_0;
  }
  function createSnapshotMutableState(value_0, policy) {
    return new SnapshotMutableStateImpl(value_0, policy);
  }
  function _no_name_provided_$factory_79($onFrame, $safe_2_2) {
    var i = new _no_name_provided__92($onFrame, $safe_2_2);
    return function (p1) {
      i.invoke_161(p1);
      return Unit_getInstance();
    };
  }
  function Trace() {
    Trace_instance = this;
  }
  Trace.prototype.beginSection = function (name) {
    return null;
  };
  Trace.prototype.endSection = function (token) {
  };
  Trace.$metadata$ = {
    simpleName: 'Trace',
    kind: 'object',
    interfaces: []
  };
  var Trace_instance;
  function Trace_getInstance() {
    if (Trace_instance == null)
      new Trace();
    return Trace_instance;
  }
  function ComposableLambda() {
  }
  ComposableLambda.$metadata$ = {
    simpleName: 'ComposableLambda',
    kind: 'interface',
    interfaces: []
  };
  function trackWrite($this) {
    if ($this._tracked) {
      var scope = $this._scope_1;
      if (!(scope == null)) {
        scope.invalidate_2();
        $this._scope_1 = null;
      }var scopes = $this._scopes;
      if (!(scopes == null)) {
        var inductionVariable = 0;
        var last = scopes._get_size__45();
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = scopes.get_66(index);
            item.invalidate_2();
          }
           while (inductionVariable < last);
        scopes.clear_7();
      }}}
  function trackRead($this, composer) {
    if ($this._tracked) {
      var scope = composer._get_recomposeScope__0();
      if (!(scope == null)) {
        composer.recordUsed_0(scope);
        var lastScope = $this._scope_1;
        if (replacableWith(lastScope, scope)) {
          $this._scope_1 = scope;
        } else {
          var lastScopes = $this._scopes;
          if (lastScopes == null) {
            var newScopes = ArrayList_init_$Create$();
            $this._scopes = newScopes;
            newScopes.add_37(scope);
            Unit_getInstance();
          } else {
            var inductionVariable = 0;
            var last = lastScopes._get_size__45();
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var scopeAtIndex = lastScopes.get_66(index);
                if (replacableWith(scopeAtIndex, scope)) {
                  lastScopes.set_13(index, scope);
                  Unit_getInstance();
                  return Unit_getInstance();
                }}
               while (inductionVariable < last);
            lastScopes.add_37(scope);
            Unit_getInstance();
          }
        }
      }}}
  function invoke$invoke(receiver, p0, p1) {
    receiver.invoke_437(p0, p1);
    Unit_getInstance();
  }
  function _no_name_provided__93($boundThis) {
    this._$boundThis_1 = $boundThis;
  }
  _no_name_provided__93.prototype.invoke_444 = function (p0, p1) {
    return invoke$invoke(this._$boundThis_1, p0, p1);
  };
  _no_name_provided__93.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__93.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__94(this$0, $p1, $changed) {
    this._this$0_23 = this$0;
    this._$p1 = $p1;
    this._$changed = $changed;
  }
  _no_name_provided__94.prototype.invoke_444 = function (nc, _anonymous_parameter_1_) {
    this._this$0_23.invoke_170(this._$p1, nc, this._$changed | 1);
    Unit_getInstance();
  };
  _no_name_provided__94.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__94.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ComposableLambdaImpl(key_0, tracked, sourceInformation) {
    this._key_4 = key_0;
    this._tracked = tracked;
    this._sourceInformation = sourceInformation;
    this.__block = null;
    this._scope_1 = null;
    this._scopes = null;
  }
  ComposableLambdaImpl.prototype.update_1 = function (block) {
    if (!equals(this.__block, block)) {
      var oldBlockNull = this.__block == null;
      this.__block = block;
      if (!oldBlockNull) {
        trackWrite(this);
      }}};
  ComposableLambdaImpl.prototype.invoke_437 = function (c, changed) {
    var c_0 = c.startRestartGroup_0(this._key_4, this._sourceInformation);
    trackRead(this, c_0);
    var dirty = changed | (c_0.changed_2(this) ? differentBits(0) : sameBits(0));
    var tmp = this.__block;
    var result = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(c_0, dirty);
    var tmp0_safe_receiver = c_0.endRestartGroup_0();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_80(this));
      Unit_getInstance();
    }
    Unit_getInstance();
    return result;
  };
  ComposableLambdaImpl.prototype.invoke_170 = function (p1, c, changed) {
    var c_0 = c.startRestartGroup_0(this._key_4, this._sourceInformation);
    trackRead(this, c_0);
    var dirty = changed | (c_0.changed_2(this) ? differentBits(1) : sameBits(1));
    var tmp = this.__block;
    var result = ((!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE())(p1, c_0, dirty);
    var tmp0_safe_receiver = c_0.endRestartGroup_0();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_81(this, p1, changed));
      Unit_getInstance();
    }
    Unit_getInstance();
    return result;
  };
  ComposableLambdaImpl.$metadata$ = {
    simpleName: 'ComposableLambdaImpl',
    kind: 'class',
    interfaces: [ComposableLambda]
  };
  function _no_name_provided_$factory_80($boundThis) {
    var i = new _no_name_provided__93($boundThis);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_81(this$0, $p1, $changed) {
    var i = new _no_name_provided__94(this$0, $p1, $changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__95() {
  }
  _no_name_provided__95.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__96() {
  }
  _no_name_provided__96.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__97() {
  }
  _no_name_provided__97.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__98() {
  }
  _no_name_provided__98.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__99() {
  }
  _no_name_provided__99.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__100() {
  }
  _no_name_provided__100.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__101() {
  }
  _no_name_provided__101.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__102() {
  }
  _no_name_provided__102.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__103() {
  }
  _no_name_provided__103.$metadata$ = {
    kind: 'class',
    interfaces: [Alignment]
  };
  function _no_name_provided__104() {
  }
  _no_name_provided__104.$metadata$ = {
    kind: 'class',
    interfaces: [Vertical]
  };
  function _no_name_provided__105() {
  }
  _no_name_provided__105.$metadata$ = {
    kind: 'class',
    interfaces: [Vertical]
  };
  function _no_name_provided__106() {
  }
  _no_name_provided__106.$metadata$ = {
    kind: 'class',
    interfaces: [Vertical]
  };
  function _no_name_provided__107() {
  }
  _no_name_provided__107.$metadata$ = {
    kind: 'class',
    interfaces: [Horizontal]
  };
  function _no_name_provided__108() {
  }
  _no_name_provided__108.$metadata$ = {
    kind: 'class',
    interfaces: [Horizontal]
  };
  function _no_name_provided__109() {
  }
  _no_name_provided__109.$metadata$ = {
    kind: 'class',
    interfaces: [Horizontal]
  };
  function Vertical() {
  }
  Vertical.$metadata$ = {
    simpleName: 'Vertical',
    kind: 'interface',
    interfaces: [Alignment]
  };
  function Horizontal() {
  }
  Horizontal.$metadata$ = {
    simpleName: 'Horizontal',
    kind: 'interface',
    interfaces: [Alignment]
  };
  function Companion_16() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp._TopStart = new _no_name_provided__95();
    var tmp_0 = this;
    tmp_0._TopCenter = new _no_name_provided__96();
    var tmp_1 = this;
    tmp_1._TopEnd = new _no_name_provided__97();
    var tmp_2 = this;
    tmp_2._CenterStart = new _no_name_provided__98();
    var tmp_3 = this;
    tmp_3._Center = new _no_name_provided__99();
    var tmp_4 = this;
    tmp_4._CenterEnd = new _no_name_provided__100();
    var tmp_5 = this;
    tmp_5._BoottomStart = new _no_name_provided__101();
    var tmp_6 = this;
    tmp_6._BoottomCenter = new _no_name_provided__102();
    var tmp_7 = this;
    tmp_7._BoottomEnd = new _no_name_provided__103();
    var tmp_8 = this;
    tmp_8._Top = new _no_name_provided__104();
    var tmp_9 = this;
    tmp_9._CenterVertically = new _no_name_provided__105();
    var tmp_10 = this;
    tmp_10._Bottom = new _no_name_provided__106();
    var tmp_11 = this;
    tmp_11._Start = new _no_name_provided__107();
    var tmp_12 = this;
    tmp_12._CenterHorizontally = new _no_name_provided__108();
    var tmp_13 = this;
    tmp_13._End = new _no_name_provided__109();
  }
  Companion_16.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_16();
    return Companion_instance_15;
  }
  function Alignment() {
  }
  Alignment.$metadata$ = {
    simpleName: 'Alignment',
    kind: 'interface',
    interfaces: []
  };
  function Horizontal_0() {
  }
  Horizontal_0.$metadata$ = {
    simpleName: 'Horizontal',
    kind: 'interface',
    interfaces: []
  };
  function Vertical_0() {
  }
  Vertical_0.$metadata$ = {
    simpleName: 'Vertical',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided__110() {
  }
  _no_name_provided__110.$metadata$ = {
    kind: 'class',
    interfaces: [Horizontal_0]
  };
  function _no_name_provided__111() {
  }
  _no_name_provided__111.$metadata$ = {
    kind: 'class',
    interfaces: [Horizontal_0]
  };
  function _no_name_provided__112() {
  }
  _no_name_provided__112.$metadata$ = {
    kind: 'class',
    interfaces: [Vertical_0]
  };
  function _no_name_provided__113() {
  }
  _no_name_provided__113.$metadata$ = {
    kind: 'class',
    interfaces: [Vertical_0]
  };
  function Arrangement() {
    Arrangement_instance = this;
    var tmp = this;
    tmp._End_0 = new _no_name_provided__110();
    var tmp_0 = this;
    tmp_0._Start_0 = new _no_name_provided__111();
    var tmp_1 = this;
    tmp_1._Top_0 = new _no_name_provided__112();
    var tmp_2 = this;
    tmp_2._Bottom_0 = new _no_name_provided__113();
    this._$stable_11 = 0;
  }
  Arrangement.$metadata$ = {
    simpleName: 'Arrangement',
    kind: 'object',
    interfaces: []
  };
  var Arrangement_instance;
  function Arrangement_getInstance() {
    if (Arrangement_instance == null)
      new Arrangement();
    return Arrangement_instance;
  }
  function Companion_17() {
    Companion_instance_16 = this;
    this._Black = new Color(0, 0, 0);
    this._DarkGray = new Color(68, 68, 68);
    this._Gray = new Color(136, 136, 136);
    this._LightGray = new Color(204, 204, 204);
    this._White = new Color(255, 255, 255);
    this._Red = new Color(255, 0, 0);
    this._Green = new Color(0, 255, 0);
    this._Blue = new Color(0, 0, 255);
    this._Yellow = new Color(255, 255, 0);
    this._Cyan = new Color(0, 255, 255);
    this._Magenta = new Color(255, 0, 255);
  }
  Companion_17.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_17();
    return Companion_instance_16;
  }
  function Color(red, green, blue) {
    Companion_getInstance_16();
    this._red = red;
    this._green = green;
    this._blue = blue;
    this._$stable_12 = 0;
  }
  Color.prototype.toString = function () {
    return '' + 'Color(red=' + this._red + ', green=' + this._green + ', blue=' + this._blue + ')';
  };
  Color.prototype.hashCode = function () {
    var result = this._red;
    result = imul(result, 31) + this._green | 0;
    result = imul(result, 31) + this._blue | 0;
    return result;
  };
  Color.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Color))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Color ? other : THROW_CCE();
    if (!(this._red === tmp0_other_with_cast._red))
      return false;
    if (!(this._green === tmp0_other_with_cast._green))
      return false;
    if (!(this._blue === tmp0_other_with_cast._blue))
      return false;
    return true;
  };
  Color.$metadata$ = {
    simpleName: 'Color',
    kind: 'class',
    interfaces: []
  };
  function Element_1() {
    this._$stable_13 = 0;
  }
  Element_1.$metadata$ = {
    simpleName: 'Element',
    kind: 'class',
    interfaces: [Modifier]
  };
  function Companion_18() {
    Companion_instance_17 = this;
    Element_1.call(this);
  }
  Companion_18.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_18();
    return Companion_instance_17;
  }
  function Modifier() {
  }
  Modifier.$metadata$ = {
    simpleName: 'Modifier',
    kind: 'interface',
    interfaces: []
  };
  function Box$composable(modifier, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-2051328844, 'C(Box$composable)P(1)24@870L28:BoxDefault.kt#kxwuio');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 32 : 16);
    if (!(($dirty & 91 ^ 18) === 0) ? true : !$composer_0._get_skipping__0()) {
      if (!(($default & 1) === 0))
        modifier_0._v = Companion_getInstance_17();
      BoxActual$composable(modifier_0._v, content, $composer_0, 14 & $dirty | 112 & $dirty);
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_82(modifier_0, content, $changed, $default));
    }
  }
  function Box$composable$lambda_0($modifier, $content, $$changed, $$default, $composer, $force) {
    return Box$composable($modifier._v, $content, $composer, $$changed | 1, $$default);
  }
  function _no_name_provided__114($modifier, $content, $$changed, $$default) {
    this._$modifier = $modifier;
    this._$content = $content;
    this._$$changed = $$changed;
    this._$$default = $$default;
  }
  _no_name_provided__114.prototype.invoke_444 = function (p0, p1) {
    return Box$composable$lambda_0(this._$modifier, this._$content, this._$$changed, this._$$default, p0, p1);
  };
  _no_name_provided__114.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__114.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_82($modifier, $content, $$changed, $$default) {
    var i = new _no_name_provided__114($modifier, $content, $$changed, $$default);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function Button$composable(modifier, onClick, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-865588382, 'C(Button$composable)P(1,2)26@893L40:ButtonDefault.kt#a1h0r0');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(onClick) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 896) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 256 : 128);
    if (!(($dirty & 731 ^ 146) === 0) ? true : !$composer_0._get_skipping__0()) {
      if (!(($default & 1) === 0))
        modifier_0._v = Companion_getInstance_17();
      ButtonActual$composable(modifier_0._v, onClick, content, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty);
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_83(modifier_0, onClick, content, $changed, $default));
    }
  }
  function Button$composable$lambda_0($modifier, $onClick, $content, $$changed, $$default, $composer, $force) {
    return Button$composable($modifier._v, $onClick, $content, $composer, $$changed | 1, $$default);
  }
  function _no_name_provided__115($modifier, $onClick, $content, $$changed, $$default) {
    this._$modifier_0 = $modifier;
    this._$onClick = $onClick;
    this._$content_0 = $content;
    this._$$changed_0 = $$changed;
    this._$$default_0 = $$default;
  }
  _no_name_provided__115.prototype.invoke_444 = function (p0, p1) {
    return Button$composable$lambda_0(this._$modifier_0, this._$onClick, this._$content_0, this._$$changed_0, this._$$default_0, p0, p1);
  };
  _no_name_provided__115.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__115.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_83($modifier, $onClick, $content, $$changed, $$default) {
    var i = new _no_name_provided__115($modifier, $onClick, $content, $$changed, $$default);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function Column$composable(modifier, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-1909268581, 'C(Column$composable)P(1)24@873L31:ColumnDefault.kt#kxwuio');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 32 : 16);
    if (!(($dirty & 91 ^ 18) === 0) ? true : !$composer_0._get_skipping__0()) {
      if (!(($default & 1) === 0))
        modifier_0._v = Companion_getInstance_17();
      ColumnActual$composable(modifier_0._v, content, $composer_0, 14 & $dirty | 112 & $dirty);
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_84(modifier_0, content, $changed, $default));
    }
  }
  function Column$composable$lambda_0($modifier, $content, $$changed, $$default, $composer, $force) {
    return Column$composable($modifier._v, $content, $composer, $$changed | 1, $$default);
  }
  function _no_name_provided__116($modifier, $content, $$changed, $$default) {
    this._$modifier_1 = $modifier;
    this._$content_1 = $content;
    this._$$changed_1 = $$changed;
    this._$$default_1 = $$default;
  }
  _no_name_provided__116.prototype.invoke_444 = function (p0, p1) {
    return Column$composable$lambda_0(this._$modifier_1, this._$content_1, this._$$changed_1, this._$$default_1, p0, p1);
  };
  _no_name_provided__116.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__116.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_84($modifier, $content, $$changed, $$default) {
    var i = new _no_name_provided__116($modifier, $content, $$changed, $$default);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function Row$composable(modifier, horizontalArrangement, verticalAlignment, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var horizontalArrangement_0 = {_v: horizontalArrangement};
    var verticalAlignment_0 = {_v: verticalAlignment};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(888066676, 'C(Row$composable)P(2,1,3)27@1049L70:RowDefault.kt#kxwuio');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier_0._v) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ((($default & 2) === 0 ? $composer_0.changed_2(horizontalArrangement_0._v) : false) ? 32 : 16);
    if (($changed & 896) === 0)
      $dirty = $dirty | ((($default & 4) === 0 ? $composer_0.changed_2(verticalAlignment_0._v) : false) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 7168) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 2048 : 1024);
    if (!(($dirty & 5851 ^ 1170) === 0) ? true : !$composer_0._get_skipping__0()) {
      if (($changed & 1) === 0 ? true : $composer_0._get_defaultsInvalid__0()) {
        $composer_0.startDefaults_0();
        if (!(($default & 1) === 0))
          modifier_0._v = Companion_getInstance_17();
        if (!(($default & 2) === 0)) {
          horizontalArrangement_0._v = Arrangement_getInstance()._Start_0;
          $dirty = $dirty & -113;
        }if (!(($default & 4) === 0)) {
          verticalAlignment_0._v = Companion_getInstance_15()._Top;
          $dirty = $dirty & -897;
        }$composer_0.endDefaults_0();
      } else {
        $composer_0.skipCurrentGroup_0();
        if (!(($default & 2) === 0))
          $dirty = $dirty & -113;
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      RowActual$composable(modifier_0._v, horizontalArrangement_0._v, verticalAlignment_0._v, content, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 7168 & $dirty);
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_85(modifier_0, horizontalArrangement_0, verticalAlignment_0, content, $changed, $default));
    }
  }
  function Row$composable$lambda_0($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed, $$default, $composer, $force) {
    return Row$composable($modifier._v, $horizontalArrangement._v, $verticalAlignment._v, $content, $composer, $$changed | 1, $$default);
  }
  function _no_name_provided__117($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed, $$default) {
    this._$modifier_2 = $modifier;
    this._$horizontalArrangement = $horizontalArrangement;
    this._$verticalAlignment = $verticalAlignment;
    this._$content_2 = $content;
    this._$$changed_2 = $$changed;
    this._$$default_2 = $$default;
  }
  _no_name_provided__117.prototype.invoke_444 = function (p0, p1) {
    return Row$composable$lambda_0(this._$modifier_2, this._$horizontalArrangement, this._$verticalAlignment, this._$content_2, this._$$changed_2, this._$$default_2, p0, p1);
  };
  _no_name_provided__117.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__117.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_85($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed, $$default) {
    var i = new _no_name_provided__117($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed, $$default);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function Slider$composable(value_0, onValueChange, valueRange, steps, modifier, $composer, $changed, $default) {
    var onValueChange_0 = {_v: onValueChange};
    var valueRange_0 = {_v: valueRange};
    var steps_0 = {_v: steps};
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-1668911471, 'C(Slider$composable)P(3,1,4,2)28@968L109:SliderDefault.kt#a1h0r0');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_4(value_0) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ((($default & 2) === 0 ? $composer_0.changed_2(onValueChange_0._v) : false) ? 32 : 16);
    if (($changed & 896) === 0)
      $dirty = $dirty | ((($default & 4) === 0 ? $composer_0.changed_2(valueRange_0._v) : false) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 7168) === 0)
      $dirty = $dirty | ($composer_0.changed_3(steps_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 57344) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier_0._v) ? 16384 : 8192);
    if (!(($dirty & 46811 ^ 9362) === 0) ? true : !$composer_0._get_skipping__0()) {
      if (($changed & 1) === 0 ? true : $composer_0._get_defaultsInvalid__0()) {
        $composer_0.startDefaults_0();
        if (!(($default & 2) === 0)) {
          onValueChange_0._v = _no_name_provided_$factory_86();
          $dirty = $dirty & -113;
        }if (!(($default & 4) === 0)) {
          valueRange_0._v = rangeTo(0.0, 1.0);
          $dirty = $dirty & -897;
        }if (!(($default & 8) === 0))
          steps_0._v = 0;
        if (!(($default & 16) === 0))
          modifier_0._v = Companion_getInstance_17();
        $composer_0.endDefaults_0();
      } else {
        $composer_0.skipCurrentGroup_0();
        if (!(($default & 2) === 0))
          $dirty = $dirty & -113;
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      SliderActual$composable(value_0, onValueChange_0._v, valueRange_0._v, steps_0._v, modifier_0._v, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 7168 & $dirty | 57344 & $dirty);
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_87(value_0, onValueChange_0, valueRange_0, steps_0, modifier_0, $changed, $default));
    }
  }
  function Slider$composable$lambda_0($value, $onValueChange, $valueRange, $steps, $modifier, $$changed, $$default, $composer, $force) {
    return Slider$composable($value, $onValueChange._v, $valueRange._v, $steps._v, $modifier._v, $composer, $$changed | 1, $$default);
  }
  function _no_name_provided__118() {
  }
  _no_name_provided__118.prototype.invoke_407 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__118.prototype.invoke_468 = function (p1) {
    this.invoke_407((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__118.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__119($value, $onValueChange, $valueRange, $steps, $modifier, $$changed, $$default) {
    this._$value_2 = $value;
    this._$onValueChange = $onValueChange;
    this._$valueRange = $valueRange;
    this._$steps = $steps;
    this._$modifier_3 = $modifier;
    this._$$changed_3 = $$changed;
    this._$$default_3 = $$default;
  }
  _no_name_provided__119.prototype.invoke_444 = function (p0, p1) {
    return Slider$composable$lambda_0(this._$value_2, this._$onValueChange, this._$valueRange, this._$steps, this._$modifier_3, this._$$changed_3, this._$$default_3, p0, p1);
  };
  _no_name_provided__119.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__119.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_86() {
    var i = new _no_name_provided__118();
    return function (p1) {
      i.invoke_407(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_87($value, $onValueChange, $valueRange, $steps, $modifier, $$changed, $$default) {
    var i = new _no_name_provided__119($value, $onValueChange, $valueRange, $steps, $modifier, $$changed, $$default);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function Text$composable(text, modifier, color_0, size_1, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var color_1 = {_v: color_0};
    var size_2 = {_v: size_1};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-35401270, 'C(Text$composable)P(3,1)29@1031L39:TextDefault.kt#a1h0r0');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(text) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 896) === 0)
      $dirty = $dirty | ($composer_0.changed_2(color_1._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 7168) === 0)
      $dirty = $dirty | ($composer_0.changed_2(size_2._v) ? 2048 : 1024);
    if (!(($dirty & 5851 ^ 1170) === 0) ? true : !$composer_0._get_skipping__0()) {
      if (!(($default & 2) === 0))
        modifier_0._v = Companion_getInstance_17();
      if (!(($default & 4) === 0))
        color_1._v = Companion_getInstance_16()._Black;
      if (!(($default & 8) === 0))
        size_2._v = Companion_getInstance_18()._Unspecified;
      TextActual$composable(text, modifier_0._v, color_1._v, size_2._v, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 7168 & $dirty);
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_88(text, modifier_0, color_1, size_2, $changed, $default));
    }
  }
  function Text$composable$lambda_0($text, $modifier, $color, $size, $$changed, $$default, $composer, $force) {
    return Text$composable($text, $modifier._v, $color._v, $size._v, $composer, $$changed | 1, $$default);
  }
  function _no_name_provided__120($text, $modifier, $color, $size, $$changed, $$default) {
    this._$text = $text;
    this._$modifier_4 = $modifier;
    this._$color = $color;
    this._$size = $size;
    this._$$changed_4 = $$changed;
    this._$$default_4 = $$default;
  }
  _no_name_provided__120.prototype.invoke_444 = function (p0, p1) {
    return Text$composable$lambda_0(this._$text, this._$modifier_4, this._$color, this._$size, this._$$changed_4, this._$$default_4, p0, p1);
  };
  _no_name_provided__120.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__120.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_88($text, $modifier, $color, $size, $$changed, $$default) {
    var i = new _no_name_provided__120($text, $modifier, $color, $size, $$changed, $$default);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function CircleShape() {
    CircleShape_instance = this;
    this._$stable_14 = 0;
  }
  CircleShape.$metadata$ = {
    simpleName: 'CircleShape',
    kind: 'object',
    interfaces: [Shape]
  };
  var CircleShape_instance;
  function CircleShape_getInstance() {
    if (CircleShape_instance == null)
      new CircleShape();
    return CircleShape_instance;
  }
  function Shape() {
  }
  Shape.$metadata$ = {
    simpleName: 'Shape',
    kind: 'interface',
    interfaces: []
  };
  function Dp(value_0) {
    this._value_8 = value_0;
    this._$stable_15 = 0;
  }
  Dp.prototype.toString = function () {
    return '' + 'Dp(value=' + this._value_8 + ')';
  };
  Dp.prototype.hashCode = function () {
    return getNumberHashCode(this._value_8);
  };
  Dp.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Dp))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Dp ? other : THROW_CCE();
    if (!equals(this._value_8, tmp0_other_with_cast._value_8))
      return false;
    return true;
  };
  Dp.$metadata$ = {
    simpleName: 'Dp',
    kind: 'class',
    interfaces: []
  };
  function IntSize(width_2, height_1) {
    this._width = width_2;
    this._height_0 = height_1;
    this._$stable_16 = 0;
  }
  IntSize.prototype.toString = function () {
    return '' + 'IntSize(width=' + this._width + ', height=' + this._height_0 + ')';
  };
  IntSize.prototype.hashCode = function () {
    var result = this._width;
    result = imul(result, 31) + this._height_0 | 0;
    return result;
  };
  IntSize.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntSize))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof IntSize ? other : THROW_CCE();
    if (!(this._width === tmp0_other_with_cast._width))
      return false;
    if (!(this._height_0 === tmp0_other_with_cast._height_0))
      return false;
    return true;
  };
  IntSize.$metadata$ = {
    simpleName: 'IntSize',
    kind: 'class',
    interfaces: []
  };
  function Companion_19() {
    Companion_instance_18 = this;
    this._Unspecified = new TextUnit(NaN, TextUnitType_Unspecified_getInstance());
  }
  Companion_19.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_19();
    return Companion_instance_18;
  }
  function TextUnit(value_0, unitType) {
    Companion_getInstance_18();
    this._value_9 = value_0;
    this._unitType = unitType;
    this._$stable_17 = 0;
  }
  TextUnit.prototype.toString = function () {
    return '' + 'TextUnit(value=' + this._value_9 + ', unitType=' + this._unitType + ')';
  };
  TextUnit.prototype.hashCode = function () {
    var result = getNumberHashCode(this._value_9);
    result = imul(result, 31) + this._unitType.hashCode() | 0;
    return result;
  };
  TextUnit.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextUnit))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextUnit ? other : THROW_CCE();
    if (!equals(this._value_9, tmp0_other_with_cast._value_9))
      return false;
    if (!this._unitType.equals(tmp0_other_with_cast._unitType))
      return false;
    return true;
  };
  TextUnit.$metadata$ = {
    simpleName: 'TextUnit',
    kind: 'class',
    interfaces: []
  };
  var TextUnitType_Unspecified_instance;
  var TextUnitType_Em_instance;
  var TextUnitType_Sp_instance;
  var TextUnitType_entriesInitialized;
  function TextUnitType_initEntries() {
    if (TextUnitType_entriesInitialized)
      return Unit_getInstance();
    TextUnitType_entriesInitialized = true;
    TextUnitType_Unspecified_instance = new TextUnitType('Unspecified', 0);
    TextUnitType_Em_instance = new TextUnitType('Em', 1);
    TextUnitType_Sp_instance = new TextUnitType('Sp', 2);
  }
  function TextUnitType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  TextUnitType.$metadata$ = {
    simpleName: 'TextUnitType',
    kind: 'class',
    interfaces: []
  };
  function TextUnitType_Unspecified_getInstance() {
    TextUnitType_initEntries();
    return TextUnitType_Unspecified_instance;
  }
  function TextUnitType_Em_getInstance() {
    TextUnitType_initEntries();
    return TextUnitType_Em_instance;
  }
  function TextUnitType_Sp_getInstance() {
    TextUnitType_initEntries();
    return TextUnitType_Sp_instance;
  }
  function _get_dp_(_this_) {
    return new Dp(_this_);
  }
  function _get_em_(_this_) {
    return new TextUnit(_this_, TextUnitType_Em_getInstance());
  }
  function DomApplier(root) {
    AbstractApplier.call(this, root);
    this._$stable_18 = 0;
  }
  DomApplier.prototype.insertTopDown_1 = function (index, instance) {
  };
  DomApplier.prototype.insertTopDown_2 = function (index, instance) {
    return this.insertTopDown_1(index, instance instanceof DomNodeWrapper ? instance : THROW_CCE());
  };
  DomApplier.prototype.insertBottomUp_1 = function (index, instance) {
    this._get_current__2().insert(index, instance);
  };
  DomApplier.prototype.insertBottomUp_2 = function (index, instance) {
    return this.insertBottomUp_1(index, instance instanceof DomNodeWrapper ? instance : THROW_CCE());
  };
  DomApplier.prototype.remove_54 = function (index, count) {
    this._get_current__2().remove_54(index, count);
  };
  DomApplier.prototype.move_2 = function (from, to_0, count) {
    this._get_current__2().move_2(from, to_0, count);
  };
  DomApplier.$metadata$ = {
    simpleName: 'DomApplier',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__121() {
  }
  _no_name_provided__121.prototype.invoke_185 = function ($this$null, it) {
    $this$null.updateAttrs(it);
  };
  _no_name_provided__121.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof DomNodeWrapper ? p1 : THROW_CCE();
    this.invoke_185(tmp, (!(p2 == null) ? isInterface(p2, Map_0) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__121.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__122() {
  }
  _no_name_provided__122.prototype.invoke_187 = function ($this$null, it) {
    $this$null.updateEventListeners(it);
  };
  _no_name_provided__122.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof DomNodeWrapper ? p1 : THROW_CCE();
    this.invoke_187(tmp, (!(p2 == null) ? isInterface(p2, List) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__122.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__123() {
  }
  _no_name_provided__123.prototype.invoke_189 = function ($this$null, it) {
    $this$null.updateProperties(it);
  };
  _no_name_provided__123.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof DomNodeWrapper ? p1 : THROW_CCE();
    this.invoke_189(tmp, (!(p2 == null) ? isInterface(p2, List) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__123.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__124() {
  }
  _no_name_provided__124.prototype.invoke_191 = function ($this$null, it) {
    $this$null.updateStyleDeclarations(it);
  };
  _no_name_provided__124.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof DomNodeWrapper ? p1 : THROW_CCE();
    this.invoke_191(tmp, (p2 == null ? true : isInterface(p2, StyleHolder)) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__124.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_20() {
    Companion_instance_19 = this;
    var tmp = this;
    tmp._UpdateAttrs = _no_name_provided_$factory_89();
    var tmp_0 = this;
    tmp_0._UpdateListeners = _no_name_provided_$factory_90();
    var tmp_1 = this;
    tmp_1._UpdateProperties = _no_name_provided_$factory_91();
    var tmp_2 = this;
    tmp_2._UpdateStyleDeclarations = _no_name_provided_$factory_92();
  }
  Companion_20.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_20();
    return Companion_instance_19;
  }
  function DomNodeWrapper(node_0) {
    Companion_getInstance_19();
    this._node_1 = node_0;
    this._currentListeners = emptyList();
    this._currentAttrs = emptyMap();
    this._$stable_19 = 8;
  }
  DomNodeWrapper.prototype.updateProperties = function (list) {
    var tmp = this._node_1;
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var htmlElement = tmp_0;
    var tmp0_iterator_1 = list.iterator_46();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_28();
      element_2._first(htmlElement, element_2._second);
    }
  };
  DomNodeWrapper.prototype.updateEventListeners = function (list) {
    var tmp = this._node_1;
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var htmlElement = tmp_0;
    var tmp0_forEach_0 = this._currentListeners;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_46();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_28();
      htmlElement.removeEventListener(element_2._event, element_2);
    }
    this._currentListeners = list;
    var tmp1_forEach_0 = this._currentListeners;
    var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_46();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_28();
      htmlElement.addEventListener(element_2_0._event, element_2_0);
    }
  };
  DomNodeWrapper.prototype.updateAttrs = function (attrs) {
    var tmp = this._node_1;
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var htmlElement = tmp_0;
    var tmp0_forEach_0 = this._currentAttrs;
    var tmp0_iterator_1 = tmp0_forEach_0._get_entries__5().iterator_46();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_28();
      htmlElement.removeAttribute(element_2._get_key__28());
    }
    this._currentAttrs = attrs;
    var tmp1_forEach_0 = this._currentAttrs;
    var tmp0_iterator_1_0 = tmp1_forEach_0._get_entries__5().iterator_46();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_28();
      if (!(element_2_0._get_value__13() == null)) {
        var tmp_1 = element_2_0._get_key__28();
        var tmp0_elvis_lhs_4 = element_2_0._get_value__13();
        htmlElement.setAttribute(tmp_1, tmp0_elvis_lhs_4 == null ? '' : tmp0_elvis_lhs_4);
      }}
  };
  DomNodeWrapper.prototype.updateStyleDeclarations = function (style) {
    var tmp = this._node_1;
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var htmlElement = tmp_0;
    htmlElement.style.cssText = '';
    var tmp1_safe_receiver = style;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_properties__2();
    if (tmp2_safe_receiver == null)
      null;
    else {
      var tmp0_iterator_1 = tmp2_safe_receiver.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        var name_4 = element_2.component1_0();
        var value_5 = element_2.component2_0();
        setProperty(_get_attributeStyleMap_(htmlElement), name_4, value_5);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp3_safe_receiver = style;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver._get_variables__2();
    if (tmp4_safe_receiver == null)
      null;
    else {
      var tmp0_iterator_1_0 = tmp4_safe_receiver.iterator_46();
      while (tmp0_iterator_1_0.hasNext_27()) {
        var element_2_0 = tmp0_iterator_1_0.next_28();
        var name_4_0 = element_2_0.component1_0();
        var value_5_0 = element_2_0.component2_0();
        setVariable(htmlElement.style, name_4_0, value_5_0);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  DomNodeWrapper.prototype.insert = function (index, nodeWrapper) {
    var length = this._node_1.childNodes.length;
    if (index < length) {
      var tmp0_get_0 = this._node_1.childNodes;
      this._node_1.insertBefore(nodeWrapper._node_1, ensureNotNull(tmp0_get_0[index]));
      Unit_getInstance();
    } else {
      this._node_1.appendChild(nodeWrapper._node_1);
      Unit_getInstance();
    }
  };
  DomNodeWrapper.prototype.remove_54 = function (index, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = this._node_1.childNodes;
        this._node_1.removeChild(ensureNotNull(tmp0_get_0_4[index]));
        Unit_getInstance();
      }
       while (inductionVariable < count);
  };
  DomNodeWrapper.prototype.move_2 = function (from, to_0, count) {
    if (from === to_0) {
      return Unit_getInstance();
    }var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var fromIndex = from > to_0 ? from + i | 0 : from;
        var toIndex = from > to_0 ? to_0 + i | 0 : (to_0 + count | 0) - 2 | 0;
        var tmp0_get_0 = this._node_1.childNodes;
        var child = this._node_1.removeChild(ensureNotNull(tmp0_get_0[fromIndex]));
        var tmp1_get_0 = this._node_1.childNodes;
        this._node_1.insertBefore(child, ensureNotNull(tmp1_get_0[toIndex]));
        Unit_getInstance();
      }
       while (inductionVariable < count);
  };
  DomNodeWrapper.$metadata$ = {
    simpleName: 'DomNodeWrapper',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_89() {
    var i = new _no_name_provided__121();
    return function (p1, p2) {
      i.invoke_185(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_90() {
    var i = new _no_name_provided__122();
    return function (p1, p2) {
      i.invoke_187(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_91() {
    var i = new _no_name_provided__123();
    return function (p1, p2) {
      i.invoke_189(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_92() {
    var i = new _no_name_provided__124();
    return function (p1, p2) {
      i.invoke_191(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__125() {
  }
  _no_name_provided__125.prototype.invoke_415 = function () {
    GlobalSnapshotManager_getInstance()._commitPending = false;
    Companion_getInstance_13().sendApplyNotifications();
  };
  _no_name_provided__125.prototype.invoke_452 = function () {
    this.invoke_415();
    return Unit_getInstance();
  };
  _no_name_provided__125.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function synchronize($this) {
    var tmp0_forEach_0 = $this._scheduledCallbacks;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_46();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_28();
      element_2();
    }
    $this._scheduledCallbacks.clear_7();
    $this._isSynchronizeScheduled = false;
  }
  function schedule($this, block) {
    $this._scheduledCallbacks.add_37(block);
    Unit_getInstance();
    if (!$this._isSynchronizeScheduled) {
      $this._isSynchronizeScheduled = true;
      launch$default($this._scheduleScope, null, null, _no_name_provided_$factory_94(null), 3, null);
      Unit_getInstance();
    }}
  function _no_name_provided__126() {
  }
  _no_name_provided__126.prototype.invoke_195 = function (it) {
    if (!GlobalSnapshotManager_getInstance()._commitPending) {
      GlobalSnapshotManager_getInstance()._commitPending = true;
      var tmp = GlobalSnapshotManager_getInstance();
      schedule(tmp, _no_name_provided_$factory_95());
    }};
  _no_name_provided__126.prototype.invoke_468 = function (p1) {
    this.invoke_195(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__126.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__127(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__127.prototype.invoke_441 = function ($this$launch, $cont) {
    var tmp = this.create_9($this$launch, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__127.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          synchronize(GlobalSnapshotManager_getInstance());
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__127.prototype.create_9 = function ($this$launch, completion) {
    var i = new _no_name_provided__127(completion);
    i._$this$launch = $this$launch;
    return i;
  };
  _no_name_provided__127.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function GlobalSnapshotManager() {
    GlobalSnapshotManager_instance = this;
    this._started = false;
    this._commitPending = false;
    this._removeWriteObserver = null;
    var tmp = this;
    var tmp_0 = Dispatchers_getInstance()._Main;
    tmp._scheduleScope = CoroutineScope_0(tmp_0.plus_25(SupervisorJob$default(null, 1, null)));
    var tmp_1 = this;
    tmp_1._globalWriteObserver = _no_name_provided_$factory_93();
    var tmp_2 = this;
    tmp_2._scheduledCallbacks = ArrayList_init_$Create$();
    this._isSynchronizeScheduled = false;
  }
  GlobalSnapshotManager.prototype.ensureStarted_1 = function () {
    if (!this._started) {
      this._started = true;
      this._removeWriteObserver = Companion_getInstance_13().registerGlobalWriteObserver(this._globalWriteObserver);
    }};
  GlobalSnapshotManager.$metadata$ = {
    simpleName: 'GlobalSnapshotManager',
    kind: 'object',
    interfaces: []
  };
  var GlobalSnapshotManager_instance;
  function GlobalSnapshotManager_getInstance() {
    if (GlobalSnapshotManager_instance == null)
      new GlobalSnapshotManager();
    return GlobalSnapshotManager_instance;
  }
  function _no_name_provided_$factory_93() {
    var i = new _no_name_provided__126();
    return function (p1) {
      i.invoke_195(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_94(resultContinuation) {
    var i = new _no_name_provided__127(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_441(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_95() {
    var i = new _no_name_provided__125();
    return function () {
      i.invoke_415();
      return Unit_getInstance();
    };
  }
  function renderComposable$composable(root, content) {
    GlobalSnapshotManager_getInstance().ensureStarted_1();
    var context = DefaultMonotonicFrameClock.plus_25(Dispatchers_getInstance()._Main);
    var recomposer = new Recomposer(context);
    var composition = ControlledComposition_0(new DomApplier(new DomNodeWrapper(root)), recomposer);
    var scope = new _no_name_provided__128();
    composition.setContent$composable_0(_no_name_provided_$factory_97(composableLambdaInstance(-985532760, true, 'C55@2037L14:RenderComposable.kt#jow8zx', _no_name_provided_$factory_96(content, scope))));
    var tmp = CoroutineScope_0(context);
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch$default(tmp, null, tmp_0, _no_name_provided_$factory_98(recomposer, null), 1, null);
    Unit_getInstance();
    return composition;
  }
  function _no_name_provided__128() {
  }
  _no_name_provided__128.$metadata$ = {
    kind: 'class',
    interfaces: [DOMScope]
  };
  function _no_name_provided__129($boundThis) {
    this._$boundThis_2 = $boundThis;
  }
  _no_name_provided__129.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_2.invoke_437(p0, p1);
  };
  _no_name_provided__129.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__129.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__130($content, $scope) {
    this._$content_3 = $content;
    this._$scope = $scope;
  }
  _no_name_provided__130.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      this._$content_3(this._$scope, $composer_0, 0);
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__130.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__130.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__131($recomposer, resultContinuation) {
    this._$recomposer = $recomposer;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__131.prototype.invoke_441 = function ($this$launch, $cont) {
    var tmp = this.create_9($this$launch, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__131.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$recomposer.runRecomposeAndApplyChanges(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__131.prototype.create_9 = function ($this$launch, completion) {
    var i = new _no_name_provided__131(this._$recomposer, completion);
    i._$this$launch_0 = $this$launch;
    return i;
  };
  _no_name_provided__131.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided_$factory_96($content, $scope) {
    var i = new _no_name_provided__130($content, $scope);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_97($boundThis) {
    var i = new _no_name_provided__129($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_98($recomposer, resultContinuation) {
    var i = new _no_name_provided__131($recomposer, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_441(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var setInputValue;
  function type(_this_, value_0) {
    return _this_.attr('type', value_0._typeStr);
  }
  function value(_this_, value_0) {
    _this_.prop(setInputValue, value_0);
    return _this_;
  }
  function _no_name_provided__132() {
  }
  _no_name_provided__132.prototype.invoke_203 = function (e, v) {
    e.value = v;
  };
  _no_name_provided__132.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof HTMLInputElement ? p1 : THROW_CCE();
    this.invoke_203(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__132.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_99() {
    var i = new _no_name_provided__132();
    return function (p1, p2) {
      i.invoke_203(p1, p2);
      return Unit_getInstance();
    };
  }
  function setInputValue$init$() {
    return _no_name_provided_$factory_99();
  }
  var setClassList;
  function Companion_21() {
    Companion_instance_20 = this;
    this._CLASS = 'class';
    this._ID = 'id';
    this._HIDDEN = 'hidden';
    this._TITLE = 'title';
    this._DIR = 'dir';
    this._DRAGGABLE = 'draggable';
    this._CONTENT_EDITABLE = 'contenteditable';
    this._LANG = 'lang';
    this._TAB_INDEX = 'tabindex';
    this._SPELLCHECK = 'spellcheck';
  }
  Companion_21.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_21();
    return Companion_instance_20;
  }
  function AttrsBuilder() {
    Companion_getInstance_20();
    EventsListenerBuilder.call(this);
    var tmp = this;
    tmp._map_3 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    tmp_0._propertyUpdates = ArrayList_init_$Create$();
    this._refEffect = null;
    this._$stable_20 = 8;
  }
  AttrsBuilder.prototype.classes = function (classes) {
    return this.prop(setClassList, classes);
  };
  AttrsBuilder.prototype.attr = function (attr, value_0) {
    var tmp;
    if (value_0 == null) {
      var tmp0_contains_0 = this._map_3;
      tmp = (isInterface(tmp0_contains_0, Map_0) ? tmp0_contains_0 : THROW_CCE()).containsKey_7(attr);
    } else {
      tmp = false;
    }
    if (tmp) {
      this._map_3.remove_43(attr);
      Unit_getInstance();
    } else {
      if (!(value_0 == null)) {
        var tmp1_set_0 = this._map_3;
        tmp1_set_0.put_6(attr, value_0);
        Unit_getInstance();
      } else {
      }
    }
    return this;
  };
  AttrsBuilder.prototype.prop = function (update, value_0) {
    var tmp = to(update, value_0);
    this._propertyUpdates.add_37(tmp instanceof Pair ? tmp : THROW_CCE());
    Unit_getInstance();
  };
  AttrsBuilder.prototype.collect = function () {
    return this._map_3;
  };
  AttrsBuilder.$metadata$ = {
    simpleName: 'AttrsBuilder',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__133() {
  }
  _no_name_provided__133.prototype.invoke_205 = function (e, classList) {
    e.className = '';
    (function () {
      var $externalVarargReceiverTmp = e.classList;
      return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat([].slice.call(classList.slice())));
    }.call(this));
  };
  _no_name_provided__133.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof HTMLElement ? p1 : THROW_CCE();
    this.invoke_205(tmp, (!(p2 == null) ? isArray(p2) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__133.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_100() {
    var i = new _no_name_provided__133();
    return function (p1, p2) {
      i.invoke_205(p1, p2);
      return Unit_getInstance();
    };
  }
  function setClassList$init$() {
    return _no_name_provided_$factory_100();
  }
  function Companion_22() {
    Companion_instance_21 = this;
    this._COPY = 'copy';
    this._CUT = 'cut';
    this._PASTE = 'paste';
    this._CONTEXTMENU = 'contextmenu';
    this._CLICK = 'click';
    this._DBLCLICK = 'dblclick';
    this._FOCUS = 'focus';
    this._BLUR = 'blur';
    this._FOCUSIN = 'focusin';
    this._FOCUSOUT = 'focusout';
    this._KEYDOWN = 'keydown';
    this._KEYUP = 'keyup';
    this._MOUSEDOWN = 'mousedown';
    this._MOUSEUP = 'mouseup';
    this._MOUSEENTER = 'mouseenter';
    this._MOUSELEAVE = 'mouseleave';
    this._MOUSEMOVE = 'mousemove';
    this._MOUSEOUT = 'mouseout';
    this._MOUSEOVER = 'mouseover';
    this._WHEEL = 'wheel';
    this._SCROLL = 'scroll';
    this._SELECT = 'select';
    this._TOUCHCANCEL = 'touchcancel';
    this._TOUCHEND = 'touchend';
    this._TOUCHMOVE = 'touchmove';
    this._TOUCHSTART = 'touchstart';
    this._ANIMATIONCANCEL = 'animationcancel';
    this._ANIMATIONEND = 'animationend';
    this._ANIMATIONITERATION = 'animationiteration';
    this._ANIMATIONSTART = 'animationstart';
    this._BEFOREINPUT = 'beforeinput';
    this._INPUT = 'input';
    this._CHANGE = 'change';
    this._INVALID = 'invalid';
    this._SEARCH = 'search';
    this._DRAG = 'drag';
    this._DROP = 'drop';
    this._DRAGSTART = 'dragstart';
    this._DRAGEND = 'dragend';
    this._DRAGOVER = 'dragover';
    this._DRAGENTER = 'dragenter';
    this._DRAGLEAVE = 'dragleave';
  }
  Companion_22.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_22();
    return Companion_instance_21;
  }
  function EventsListenerBuilder() {
    Companion_getInstance_21();
    var tmp = this;
    tmp._listeners = ArrayList_init_$Create$();
    this._$stable_21 = 8;
  }
  EventsListenerBuilder.prototype.onClick_0 = function (options, listener) {
    this._listeners.add_37(new MouseEventListener('click', options, listener));
    Unit_getInstance();
  };
  EventsListenerBuilder.prototype.onClick$default_0 = function (options, listener, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      options = Companion_getInstance_22()._DEFAULT;
    return this.onClick_0(options, listener);
  };
  EventsListenerBuilder.prototype.onRangeInput_0 = function (options, listener) {
    this._listeners.add_37(new WrappedEventListener('input', options, listener));
    Unit_getInstance();
  };
  EventsListenerBuilder.prototype.onRangeInput$default_0 = function (options, listener, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      options = Companion_getInstance_22()._DEFAULT;
    return this.onRangeInput_0(options, listener);
  };
  EventsListenerBuilder.prototype.asList_0 = function () {
    return this._listeners;
  };
  EventsListenerBuilder.$metadata$ = {
    simpleName: 'EventsListenerBuilder',
    kind: 'class',
    interfaces: []
  };
  function Range_0() {
    Range_instance = this;
    InputType.call(this, 'range');
    this._$stable_22 = 0;
  }
  Range_0.$metadata$ = {
    simpleName: 'Range',
    kind: 'object',
    interfaces: []
  };
  var Range_instance;
  function Range_getInstance() {
    if (Range_instance == null)
      new Range_0();
    return Range_instance;
  }
  function Text_0() {
    Text_instance = this;
    InputType.call(this, 'text');
    this._$stable_23 = 0;
  }
  Text_0.$metadata$ = {
    simpleName: 'Text',
    kind: 'object',
    interfaces: []
  };
  var Text_instance;
  function Text_getInstance() {
    if (Text_instance == null)
      new Text_0();
    return Text_instance;
  }
  function InputType(typeStr) {
    this._typeStr = typeStr;
    this._$stable_24 = 0;
  }
  InputType.$metadata$ = {
    simpleName: 'InputType',
    kind: 'class',
    interfaces: []
  };
  function WrappedEventListener(event, options, listener) {
    this._event = event;
    this._options = options;
    this._listener = listener;
    this._$stable_25 = 0;
  }
  WrappedEventListener.prototype._get_listener__0 = function () {
    return this._listener;
  };
  WrappedEventListener.prototype.handleEvent_1 = function (event) {
    var tmp = new WrappedEventImpl(event);
    this._listener(isInterface(tmp, GenericWrappedEvent) ? tmp : THROW_CCE());
  };
  WrappedEventListener.prototype.handleEvent = function (event) {
    return this.handleEvent_1(event);
  };
  WrappedEventListener.$metadata$ = {
    simpleName: 'WrappedEventListener',
    kind: 'class',
    interfaces: []
  };
  function Companion_23() {
    Companion_instance_22 = this;
    this._DEFAULT = new Options();
  }
  Companion_23.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_23();
    return Companion_instance_22;
  }
  function Options() {
    Companion_getInstance_22();
    this._$stable_26 = 0;
  }
  Options.$metadata$ = {
    simpleName: 'Options',
    kind: 'class',
    interfaces: []
  };
  function MouseEventListener(event, options, listener) {
    WrappedEventListener.call(this, event, options, listener);
  }
  MouseEventListener.prototype.handleEvent_1 = function (event) {
    var tmp = this._get_listener__0();
    tmp(new WrappedMouseEvent(event instanceof MouseEvent ? event : THROW_CCE()));
  };
  MouseEventListener.prototype.handleEvent = function (event) {
    return this.handleEvent_1(event);
  };
  MouseEventListener.$metadata$ = {
    simpleName: 'MouseEventListener',
    kind: 'class',
    interfaces: []
  };
  var cssTypedOMPolyfill;
  function Companion_24() {
    Companion_instance_23 = this;
  }
  Companion_24.prototype.invoke_207 = function (value_0) {
    return value_0;
  };
  Companion_24.prototype.invoke_208 = function (value_0) {
    return value_0;
  };
  Companion_24.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_24();
    return Companion_instance_23;
  }
  function _get_attributeStyleMap_(_this_) {
    var tmp0_unsafeCast_0 = _this_.attributeStyleMap;
    return tmp0_unsafeCast_0;
  }
  function insertRule(_this_, cssRule, index) {
    var tmp;
    if (!(index == null)) {
      var tmp0_unsafeCast_0 = _this_.insertRule(cssRule, index);
      tmp = tmp0_unsafeCast_0;
    } else {
      var tmp1_unsafeCast_0 = _this_.insertRule(cssRule);
      tmp = tmp1_unsafeCast_0;
    }
    return tmp;
  }
  function CSSBuilder() {
  }
  CSSBuilder.$metadata$ = {
    simpleName: 'CSSBuilder',
    kind: 'interface',
    interfaces: [CSSStyleRuleBuilder, GenericStyleSheetBuilder]
  };
  function CSSBuilderImpl(root, self_0, rulesHolder) {
    CSSRuleBuilderImpl.call(this);
    this._root_1 = root;
    this._self = self_0;
    this._$$delegate_0 = rulesHolder;
    this._$stable_27 = 8;
  }
  CSSBuilderImpl.prototype.add_50 = function (cssRule) {
    this._$$delegate_0.add_50(cssRule);
  };
  CSSBuilderImpl.prototype.add_51 = function (selector, style) {
    this._$$delegate_0.add_51(selector, style);
  };
  CSSBuilderImpl.prototype._get_cssRules__4 = function () {
    return this._$$delegate_0._get_cssRules__4();
  };
  CSSBuilderImpl.$metadata$ = {
    simpleName: 'CSSBuilderImpl',
    kind: 'class',
    interfaces: [CSSBuilder, CSSRulesHolder]
  };
  var auto;
  function Companion_25() {
    Companion_instance_24 = this;
  }
  Companion_25.prototype.invoke_209 = function (value_0) {
    return value_0;
  };
  Companion_25.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_25();
    return Companion_instance_24;
  }
  function auto$init$() {
    var tmp0_unsafeCast_0 = new CSSKeywordValue('auto');
    return tmp0_unsafeCast_0;
  }
  function position(_this_, position_0) {
    _this_.property_2('position', Companion_getInstance_23().invoke_207(position_0._value_10));
  }
  var Position_Static_instance;
  var Position_Relative_instance;
  var Position_Absolute_instance;
  var Position_Sticky_instance;
  var Position_Fixed_instance;
  var Position_entriesInitialized;
  function Position_initEntries() {
    if (Position_entriesInitialized)
      return Unit_getInstance();
    Position_entriesInitialized = true;
    Position_Static_instance = new Position('Static', 0, 'static');
    Position_Relative_instance = new Position('Relative', 1, 'relative');
    Position_Absolute_instance = new Position('Absolute', 2, 'absolute');
    Position_Sticky_instance = new Position('Sticky', 3, 'sticky');
    Position_Fixed_instance = new Position('Fixed', 4, 'fixed');
  }
  function Position(name, ordinal, value_0) {
    Enum.call(this, name, ordinal);
    this._value_10 = value_0;
  }
  Position.$metadata$ = {
    simpleName: 'Position',
    kind: 'class',
    interfaces: []
  };
  function top(_this_, value_0) {
    top_0(_this_, Companion_getInstance_24().invoke_209(value_0));
  }
  function left(_this_, value_0) {
    left_0(_this_, Companion_getInstance_24().invoke_209(value_0));
  }
  function borderRadius(_this_, r) {
    _this_.property_2('border-radius', Companion_getInstance_23().invoke_207(toString_1(r)));
  }
  function backgroundColor(_this_, value_0) {
    _this_.property_2('background-color', value_0.styleValue_1());
  }
  function width(_this_, value_0) {
    width_0(_this_, Companion_getInstance_24().invoke_209(value_0));
  }
  function height(_this_, value_0) {
    height_0(_this_, Companion_getInstance_24().invoke_209(value_0));
  }
  function border(_this_, width_2, style, color_0) {
    var tmp0_apply_0 = new CSSBorder();
    var tmp0_safe_receiver_3 = width_2;
    if (tmp0_safe_receiver_3 == null)
      null;
    else {
      tmp0_apply_0.width_0(tmp0_safe_receiver_3);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver_4 = style;
    if (tmp1_safe_receiver_4 == null)
      null;
    else {
      tmp0_apply_0.style_0(tmp1_safe_receiver_4);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp2_safe_receiver_5 = color_0;
    if (tmp2_safe_receiver_5 == null)
      null;
    else {
      tmp0_apply_0.color_0(tmp2_safe_receiver_5);
      Unit_getInstance();
    }
    Unit_getInstance();
    var border_1 = tmp0_apply_0;
    _this_.property_2('border', border_1.styleValue_1());
  }
  var LineStyle_None_instance;
  var LineStyle_Hidden_instance;
  var LineStyle_Dotted_instance;
  var LineStyle_Dashed_instance;
  var LineStyle_Solid_instance;
  var LineStyle_Double_instance;
  var LineStyle_Groove_instance;
  var LineStyle_Ridge_instance;
  var LineStyle_Inset_instance;
  var LineStyle_Outset_instance;
  var LineStyle_entriesInitialized;
  function LineStyle_initEntries() {
    if (LineStyle_entriesInitialized)
      return Unit_getInstance();
    LineStyle_entriesInitialized = true;
    LineStyle_None_instance = new LineStyle('None', 0);
    LineStyle_Hidden_instance = new LineStyle('Hidden', 1);
    LineStyle_Dotted_instance = new LineStyle('Dotted', 2);
    LineStyle_Dashed_instance = new LineStyle('Dashed', 3);
    LineStyle_Solid_instance = new LineStyle('Solid', 4);
    LineStyle_Double_instance = new LineStyle('Double', 5);
    LineStyle_Groove_instance = new LineStyle('Groove', 6);
    LineStyle_Ridge_instance = new LineStyle('Ridge', 7);
    LineStyle_Inset_instance = new LineStyle('Inset', 8);
    LineStyle_Outset_instance = new LineStyle('Outset', 9);
  }
  function LineStyle(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LineStyle.$metadata$ = {
    simpleName: 'LineStyle',
    kind: 'class',
    interfaces: []
  };
  function marginLeft(_this_, value_0) {
    var tmp0_value_0 = toString_1(value_0);
    _this_.property_2('margin-left', Companion_getInstance_23().invoke_207(tmp0_value_0));
  }
  function marginTop(_this_, value_0) {
    var tmp0_value_0 = toString_1(value_0);
    _this_.property_2('margin-top', Companion_getInstance_23().invoke_207(tmp0_value_0));
  }
  function display(_this_, displayStyle) {
    _this_.property_2('display', Companion_getInstance_23().invoke_207(displayStyle._value_11));
  }
  var DisplayStyle_Block_instance;
  var DisplayStyle_Inline_instance;
  var DisplayStyle_InlineBlock_instance;
  var DisplayStyle_Flex_instance;
  var DisplayStyle_LegacyInlineFlex_instance;
  var DisplayStyle_Grid_instance;
  var DisplayStyle_LegacyInlineGrid_instance;
  var DisplayStyle_FlowRoot_instance;
  var DisplayStyle_None_instance;
  var DisplayStyle_Contents_instance;
  var DisplayStyle_Table_instance;
  var DisplayStyle_TableRow_instance;
  var DisplayStyle_ListItem_instance;
  var DisplayStyle_Inherit_instance;
  var DisplayStyle_Initial_instance;
  var DisplayStyle_Unset_instance;
  var DisplayStyle_entriesInitialized;
  function DisplayStyle_initEntries() {
    if (DisplayStyle_entriesInitialized)
      return Unit_getInstance();
    DisplayStyle_entriesInitialized = true;
    DisplayStyle_Block_instance = new DisplayStyle('Block', 0, 'block');
    DisplayStyle_Inline_instance = new DisplayStyle('Inline', 1, 'inline');
    DisplayStyle_InlineBlock_instance = new DisplayStyle('InlineBlock', 2, 'inline-block');
    DisplayStyle_Flex_instance = new DisplayStyle('Flex', 3, 'flex');
    DisplayStyle_LegacyInlineFlex_instance = new DisplayStyle('LegacyInlineFlex', 4, 'inline-flex');
    DisplayStyle_Grid_instance = new DisplayStyle('Grid', 5, 'grid');
    DisplayStyle_LegacyInlineGrid_instance = new DisplayStyle('LegacyInlineGrid', 6, 'inline-grid');
    DisplayStyle_FlowRoot_instance = new DisplayStyle('FlowRoot', 7, 'flow-root');
    DisplayStyle_None_instance = new DisplayStyle('None', 8, 'none');
    DisplayStyle_Contents_instance = new DisplayStyle('Contents', 9, 'contents');
    DisplayStyle_Table_instance = new DisplayStyle('Table', 10, 'table');
    DisplayStyle_TableRow_instance = new DisplayStyle('TableRow', 11, 'table-row');
    DisplayStyle_ListItem_instance = new DisplayStyle('ListItem', 12, 'list-item');
    DisplayStyle_Inherit_instance = new DisplayStyle('Inherit', 13, 'inherit');
    DisplayStyle_Initial_instance = new DisplayStyle('Initial', 14, 'initial');
    DisplayStyle_Unset_instance = new DisplayStyle('Unset', 15, 'unset');
  }
  function DisplayStyle(name, ordinal, value_0) {
    Enum.call(this, name, ordinal);
    this._value_11 = value_0;
  }
  DisplayStyle.$metadata$ = {
    simpleName: 'DisplayStyle',
    kind: 'class',
    interfaces: []
  };
  function flexDirection(_this_, flexDirection_0) {
    _this_.property_2('flex-direction', Companion_getInstance_23().invoke_207(flexDirection_0._value_12));
  }
  var FlexDirection_Row_instance;
  var FlexDirection_RowReverse_instance;
  var FlexDirection_Column_instance;
  var FlexDirection_ColumnReverse_instance;
  var FlexDirection_entriesInitialized;
  function FlexDirection_initEntries() {
    if (FlexDirection_entriesInitialized)
      return Unit_getInstance();
    FlexDirection_entriesInitialized = true;
    FlexDirection_Row_instance = new FlexDirection('Row', 0, 'row');
    FlexDirection_RowReverse_instance = new FlexDirection('RowReverse', 1, 'row-reverse');
    FlexDirection_Column_instance = new FlexDirection('Column', 2, 'column');
    FlexDirection_ColumnReverse_instance = new FlexDirection('ColumnReverse', 3, 'column-reverse');
  }
  function FlexDirection(name, ordinal, value_0) {
    Enum.call(this, name, ordinal);
    this._value_12 = value_0;
  }
  FlexDirection.$metadata$ = {
    simpleName: 'FlexDirection',
    kind: 'class',
    interfaces: []
  };
  function justifyContent(_this_, justifyContent_0) {
    _this_.property_2('justify-content', Companion_getInstance_23().invoke_207(justifyContent_0._value_13));
  }
  var JustifyContent_Center_instance;
  var JustifyContent_Start_instance;
  var JustifyContent_End_instance;
  var JustifyContent_FlexStart_instance;
  var JustifyContent_FlexEnd_instance;
  var JustifyContent_Left_instance;
  var JustifyContent_Right_instance;
  var JustifyContent_Normal_instance;
  var JustifyContent_SpaceBetween_instance;
  var JustifyContent_SpaceAround_instance;
  var JustifyContent_SpaceEvenly_instance;
  var JustifyContent_Stretch_instance;
  var JustifyContent_Inherit_instance;
  var JustifyContent_Initial_instance;
  var JustifyContent_Unset_instance;
  var JustifyContent_SafeCenter_instance;
  var JustifyContent_UnsafeCenter_instance;
  var JustifyContent_entriesInitialized;
  function JustifyContent_initEntries() {
    if (JustifyContent_entriesInitialized)
      return Unit_getInstance();
    JustifyContent_entriesInitialized = true;
    JustifyContent_Center_instance = new JustifyContent('Center', 0, 'center');
    JustifyContent_Start_instance = new JustifyContent('Start', 1, 'start');
    JustifyContent_End_instance = new JustifyContent('End', 2, 'end');
    JustifyContent_FlexStart_instance = new JustifyContent('FlexStart', 3, 'flex-start');
    JustifyContent_FlexEnd_instance = new JustifyContent('FlexEnd', 4, 'flex-end');
    JustifyContent_Left_instance = new JustifyContent('Left', 5, 'left');
    JustifyContent_Right_instance = new JustifyContent('Right', 6, 'right');
    JustifyContent_Normal_instance = new JustifyContent('Normal', 7, 'normal');
    JustifyContent_SpaceBetween_instance = new JustifyContent('SpaceBetween', 8, 'space-between');
    JustifyContent_SpaceAround_instance = new JustifyContent('SpaceAround', 9, 'space-around');
    JustifyContent_SpaceEvenly_instance = new JustifyContent('SpaceEvenly', 10, 'space-evenly');
    JustifyContent_Stretch_instance = new JustifyContent('Stretch', 11, 'stretch');
    JustifyContent_Inherit_instance = new JustifyContent('Inherit', 12, 'inherit');
    JustifyContent_Initial_instance = new JustifyContent('Initial', 13, 'initial');
    JustifyContent_Unset_instance = new JustifyContent('Unset', 14, 'unset');
    JustifyContent_SafeCenter_instance = new JustifyContent('SafeCenter', 15, 'safe center');
    JustifyContent_UnsafeCenter_instance = new JustifyContent('UnsafeCenter', 16, 'unsafe center');
  }
  function JustifyContent(name, ordinal, value_0) {
    Enum.call(this, name, ordinal);
    this._value_13 = value_0;
  }
  JustifyContent.$metadata$ = {
    simpleName: 'JustifyContent',
    kind: 'class',
    interfaces: []
  };
  function alignItems(_this_, alignItems_0) {
    _this_.property_2('align-items', Companion_getInstance_23().invoke_207(alignItems_0._value_14));
  }
  var AlignItems_Normal_instance;
  var AlignItems_Stretch_instance;
  var AlignItems_Center_instance;
  var AlignItems_Start_instance;
  var AlignItems_End_instance;
  var AlignItems_FlexStart_instance;
  var AlignItems_FlexEnd_instance;
  var AlignItems_Baseline_instance;
  var AlignItems_SafeCenter_instance;
  var AlignItems_UnsafeCenter_instance;
  var AlignItems_Inherit_instance;
  var AlignItems_Initial_instance;
  var AlignItems_Unset_instance;
  var AlignItems_entriesInitialized;
  function AlignItems_initEntries() {
    if (AlignItems_entriesInitialized)
      return Unit_getInstance();
    AlignItems_entriesInitialized = true;
    AlignItems_Normal_instance = new AlignItems('Normal', 0, 'normal');
    AlignItems_Stretch_instance = new AlignItems('Stretch', 1, 'stretch');
    AlignItems_Center_instance = new AlignItems('Center', 2, 'center');
    AlignItems_Start_instance = new AlignItems('Start', 3, 'start');
    AlignItems_End_instance = new AlignItems('End', 4, 'end');
    AlignItems_FlexStart_instance = new AlignItems('FlexStart', 5, 'flex-start');
    AlignItems_FlexEnd_instance = new AlignItems('FlexEnd', 6, 'flex-end');
    AlignItems_Baseline_instance = new AlignItems('Baseline', 7, 'baseline');
    AlignItems_SafeCenter_instance = new AlignItems('SafeCenter', 8, 'safe center');
    AlignItems_UnsafeCenter_instance = new AlignItems('UnsafeCenter', 9, 'unsafe center');
    AlignItems_Inherit_instance = new AlignItems('Inherit', 10, 'inherit');
    AlignItems_Initial_instance = new AlignItems('Initial', 11, 'initial');
    AlignItems_Unset_instance = new AlignItems('Unset', 12, 'unset');
  }
  function AlignItems(name, ordinal, value_0) {
    Enum.call(this, name, ordinal);
    this._value_14 = value_0;
  }
  AlignItems.$metadata$ = {
    simpleName: 'AlignItems',
    kind: 'class',
    interfaces: []
  };
  function top_0(_this_, value_0) {
    _this_.property_2('top', value_0);
  }
  function left_0(_this_, value_0) {
    _this_.property_2('left', value_0);
  }
  function width_0(_this_, value_0) {
    _this_.property_2('width', value_0);
  }
  function height_0(_this_, value_0) {
    _this_.property_2('height', value_0);
  }
  function CSSBorder() {
    this._width_0 = null;
    this._style = null;
    this._color = null;
    this._$stable_28 = 8;
  }
  CSSBorder.prototype.width_0 = function (size_1) {
    this._width_0 = Companion_getInstance_23().invoke_208(size_1);
  };
  CSSBorder.prototype.style_0 = function (style) {
    this._style = Companion_getInstance_23().invoke_207(style._get_name__0());
  };
  CSSBorder.prototype.color_0 = function (color_0) {
    this._color = color_0.styleValue_1();
  };
  CSSBorder.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CSSBorder) {
      tmp = toString_1(this.styleValue_1()) === toString_1(other.styleValue_1());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CSSBorder.prototype.styleValue_1 = function () {
    var values = listOfNotNull([this._width_0, this._style, this._color]);
    var tmp = Companion_getInstance_23();
    return tmp.invoke_207(joinToString$default_0(values, ' ', null, null, 0, null, null, 62, null));
  };
  CSSBorder.$metadata$ = {
    simpleName: 'CSSBorder',
    kind: 'class',
    interfaces: [CustomStyleValue]
  };
  function color(_this_, value_0) {
    _this_.property_2('color', value_0.styleValue_1());
  }
  function fontSize(_this_, value_0) {
    _this_.property_2('font-size', Companion_getInstance_23().invoke_208(value_0));
  }
  function Position_Absolute_getInstance() {
    Position_initEntries();
    return Position_Absolute_instance;
  }
  function LineStyle_Solid_getInstance() {
    LineStyle_initEntries();
    return LineStyle_Solid_instance;
  }
  function DisplayStyle_Block_getInstance() {
    DisplayStyle_initEntries();
    return DisplayStyle_Block_instance;
  }
  function DisplayStyle_Flex_getInstance() {
    DisplayStyle_initEntries();
    return DisplayStyle_Flex_instance;
  }
  function FlexDirection_Row_getInstance() {
    FlexDirection_initEntries();
    return FlexDirection_Row_instance;
  }
  function JustifyContent_FlexStart_getInstance() {
    JustifyContent_initEntries();
    return JustifyContent_FlexStart_instance;
  }
  function JustifyContent_FlexEnd_getInstance() {
    JustifyContent_initEntries();
    return JustifyContent_FlexEnd_instance;
  }
  function AlignItems_Center_getInstance() {
    AlignItems_initEntries();
    return AlignItems_Center_instance;
  }
  function AlignItems_FlexStart_getInstance() {
    AlignItems_initEntries();
    return AlignItems_FlexStart_instance;
  }
  function AlignItems_FlexEnd_getInstance() {
    AlignItems_initEntries();
    return AlignItems_FlexEnd_instance;
  }
  function CSSRuleDeclaration() {
    this._$stable_29 = 0;
  }
  CSSRuleDeclaration.$metadata$ = {
    simpleName: 'CSSRuleDeclaration',
    kind: 'class',
    interfaces: []
  };
  function CSSStyleRuleDeclaration(selector, style) {
    CSSRuleDeclaration.call(this);
    this._selector = selector;
    this._style_0 = style;
    this._$stable_30 = 8;
  }
  CSSStyleRuleDeclaration.prototype._get_header__0 = function () {
    return toString_1(this._selector);
  };
  CSSStyleRuleDeclaration.prototype.toString = function () {
    return '' + 'CSSStyleRuleDeclaration(selector=' + this._selector + ', style=' + this._style_0 + ')';
  };
  CSSStyleRuleDeclaration.prototype.hashCode = function () {
    var result = hashCode(this._selector);
    result = imul(result, 31) + hashCode(this._style_0) | 0;
    return result;
  };
  CSSStyleRuleDeclaration.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CSSStyleRuleDeclaration))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CSSStyleRuleDeclaration ? other : THROW_CCE();
    if (!this._selector.equals(tmp0_other_with_cast._selector))
      return false;
    if (!equals(this._style_0, tmp0_other_with_cast._style_0))
      return false;
    return true;
  };
  CSSStyleRuleDeclaration.$metadata$ = {
    simpleName: 'CSSStyleRuleDeclaration',
    kind: 'class',
    interfaces: []
  };
  function CSSGroupingRuleDeclaration() {
  }
  CSSGroupingRuleDeclaration.$metadata$ = {
    simpleName: 'CSSGroupingRuleDeclaration',
    kind: 'class',
    interfaces: []
  };
  function CSSStyleRuleBuilder() {
  }
  CSSStyleRuleBuilder.$metadata$ = {
    simpleName: 'CSSStyleRuleBuilder',
    kind: 'interface',
    interfaces: [StyleBuilder]
  };
  function CSSRuleBuilderImpl() {
    StyleBuilderImpl.call(this);
    this._$stable_31 = 0;
  }
  CSSRuleBuilderImpl.$metadata$ = {
    simpleName: 'CSSRuleBuilderImpl',
    kind: 'class',
    interfaces: [CSSStyleRuleBuilder]
  };
  function _get_px_(_this_) {
    var tmp0_unsafeCast_0 = CSS.px(_this_);
    return tmp0_unsafeCast_0;
  }
  function _get_percent_(_this_) {
    var tmp0_unsafeCast_0 = CSS.percent(_this_);
    return tmp0_unsafeCast_0;
  }
  function _get_em__0(_this_) {
    var tmp0_unsafeCast_0 = CSS.em(_this_);
    return tmp0_unsafeCast_0;
  }
  function RGB(r, g, b) {
    Color_0.call(this);
    this._r = r;
    this._g = g;
    this._b = b;
    this._$stable_32 = 0;
  }
  RGB.prototype.toString = function () {
    return '' + 'rgb(' + this._r + ', ' + this._g + ', ' + this._b + ')';
  };
  RGB.prototype.hashCode = function () {
    var result = hashCode(this._r);
    result = imul(result, 31) + hashCode(this._g) | 0;
    result = imul(result, 31) + hashCode(this._b) | 0;
    return result;
  };
  RGB.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RGB))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RGB ? other : THROW_CCE();
    if (!equals(this._r, tmp0_other_with_cast._r))
      return false;
    if (!equals(this._g, tmp0_other_with_cast._g))
      return false;
    if (!equals(this._b, tmp0_other_with_cast._b))
      return false;
    return true;
  };
  RGB.$metadata$ = {
    simpleName: 'RGB',
    kind: 'class',
    interfaces: []
  };
  function Companion_26() {
    Companion_instance_25 = this;
  }
  Companion_26.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_26();
    return Companion_instance_25;
  }
  function Color_0() {
    Companion_getInstance_25();
    this._$stable_33 = 0;
  }
  Color_0.prototype.styleValue_1 = function () {
    return Companion_getInstance_23().invoke_207(toString_1(this));
  };
  Color_0.$metadata$ = {
    simpleName: 'Color',
    kind: 'class',
    interfaces: [CustomStyleValue]
  };
  function StyleBuilder() {
  }
  StyleBuilder.$metadata$ = {
    simpleName: 'StyleBuilder',
    kind: 'interface',
    interfaces: []
  };
  function CustomStyleValue() {
  }
  CustomStyleValue.$metadata$ = {
    simpleName: 'CustomStyleValue',
    kind: 'interface',
    interfaces: []
  };
  function StyleHolder() {
  }
  StyleHolder.$metadata$ = {
    simpleName: 'StyleHolder',
    kind: 'interface',
    interfaces: []
  };
  function StylePropertyDeclaration(name, value_0) {
    this._name_0 = name;
    this._value_15 = value_0;
    this._$stable_34 = 8;
  }
  StylePropertyDeclaration.prototype.component1_0 = function () {
    return this._name_0;
  };
  StylePropertyDeclaration.prototype.component2_0 = function () {
    return this._value_15;
  };
  StylePropertyDeclaration.prototype.toString = function () {
    return '' + 'StylePropertyDeclaration(name=' + this._name_0 + ', value=' + this._value_15 + ')';
  };
  StylePropertyDeclaration.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_0);
    result = imul(result, 31) + hashCode(this._value_15) | 0;
    return result;
  };
  StylePropertyDeclaration.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StylePropertyDeclaration))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof StylePropertyDeclaration ? other : THROW_CCE();
    if (!(this._name_0 === tmp0_other_with_cast._name_0))
      return false;
    if (!equals(this._value_15, tmp0_other_with_cast._value_15))
      return false;
    return true;
  };
  StylePropertyDeclaration.$metadata$ = {
    simpleName: 'StylePropertyDeclaration',
    kind: 'class',
    interfaces: []
  };
  function StyleBuilderImpl() {
    var tmp = this;
    tmp._properties = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._variables = ArrayList_init_$Create$();
    this._$stable_35 = 0;
  }
  StyleBuilderImpl.prototype._get_properties__2 = function () {
    return this._properties;
  };
  StyleBuilderImpl.prototype._get_variables__2 = function () {
    return this._variables;
  };
  StyleBuilderImpl.prototype.property_2 = function (propertyName, value_0) {
    this._get_properties__2().add_37(new StylePropertyDeclaration(propertyName, value_0));
    Unit_getInstance();
  };
  StyleBuilderImpl.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, StyleHolder) : false) {
      tmp = nativeEquals(this._get_properties__2(), other._get_properties__2()) ? nativeEquals(this._get_variables__2(), other._get_variables__2()) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  StyleBuilderImpl.$metadata$ = {
    simpleName: 'StyleBuilderImpl',
    kind: 'class',
    interfaces: [StyleBuilder, StyleHolder]
  };
  function nativeEquals(_this_, properties) {
    var index = 0;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(_this_, Collection)) {
        tmp = _this_.isEmpty_40();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = _this_.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        var tmp0_5 = index;
        index = tmp0_5 + 1 | 0;
        var otherProp_4 = properties.get_66(tmp0_5);
        if (!(element_2._name_0 === otherProp_4._name_0 ? toString_1(element_2._value_15) === toString_1(otherProp_4._value_15) : false)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function _no_name_provided__134($selector) {
    this._$selector = $selector;
  }
  _no_name_provided__134.prototype.getValue_0 = function (_anonymous_parameter_0_, _anonymous_parameter_1_) {
    return this._$selector._className;
  };
  _no_name_provided__134.prototype.getValue_1 = function (thisRef, property) {
    return this.getValue_0((thisRef == null ? true : isObject(thisRef)) ? thisRef : THROW_CCE(), property);
  };
  _no_name_provided__134.$metadata$ = {
    kind: 'class',
    interfaces: [ReadOnlyProperty]
  };
  function StyleSheet_init_$Init$(rulesHolder, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      rulesHolder = new CSSRulesHolderState();
    StyleSheet_0.call($this, rulesHolder);
    return $this;
  }
  function Companion_27() {
    Companion_instance_26 = this;
    this._counter = 0;
  }
  Companion_27.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_27();
    return Companion_instance_26;
  }
  function CSSHolder(cssBuilder) {
    this._cssBuilder = cssBuilder;
  }
  CSSHolder.prototype.provideDelegate = function (sheet, property) {
    var sheetName = '' + getKClassFromExpression_0(sheet)._get_simpleName__4() + '-';
    var selector = className('' + sheetName + property.callableName);
    var tmp0_container = buildCSS(selector, selector, this._cssBuilder);
    var properties = tmp0_container.component1_0();
    var rules = tmp0_container.component2_0();
    sheet.add_51(selector, properties);
    var tmp0_iterator_1 = rules.iterator_46();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_28();
      sheet.add_50(element_2);
    }
    return new _no_name_provided__134(selector);
  };
  CSSHolder.$metadata$ = {
    simpleName: 'CSSHolder',
    kind: 'class',
    interfaces: []
  };
  function StyleSheet_0(rulesHolder) {
    Companion_getInstance_26();
    this._rulesHolder = rulesHolder;
    var tmp = this;
    tmp._boundClasses = LinkedHashMap_init_$Create$();
    this._$stable_36 = 0;
  }
  StyleSheet_0.prototype.add_50 = function (cssRule) {
    this._rulesHolder.add_50(cssRule);
  };
  StyleSheet_0.prototype.add_51 = function (selector, style) {
    this._rulesHolder.add_51(selector, style);
  };
  StyleSheet_0.prototype._get_cssRules__4 = function () {
    return this._rulesHolder._get_cssRules__4();
  };
  StyleSheet_0.prototype.style_2 = function (cssRule) {
    return new CSSHolder(cssRule);
  };
  StyleSheet_0.$metadata$ = {
    simpleName: 'StyleSheet',
    kind: 'class',
    interfaces: [StyleSheetBuilder, CSSRulesHolder]
  };
  function CSSRulesHolderState() {
    var tmp = this;
    var tmp_0 = emptyList();
    tmp._cssRules$delegate = mutableStateOf$default(tmp_0, null, 2, null);
    this._$stable_37 = 0;
  }
  CSSRulesHolderState.prototype._set_cssRules_ = function (_set___) {
    var tmp0_setValue_0 = this._cssRules$delegate;
    var tmp1_setValue_0 = cssRules$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  CSSRulesHolderState.prototype._get_cssRules__4 = function () {
    var tmp0_getValue_0 = this._cssRules$delegate;
    var tmp1_getValue_0 = cssRules$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  CSSRulesHolderState.prototype.add_50 = function (cssRule) {
    var tmp0_this = this;
    tmp0_this._set_cssRules_(plus(tmp0_this._get_cssRules__4(), cssRule));
  };
  CSSRulesHolderState.$metadata$ = {
    simpleName: 'CSSRulesHolderState',
    kind: 'class',
    interfaces: [CSSRulesHolder]
  };
  function buildCSS(thisClass, thisContext, cssRule) {
    var styleSheet = new StyleSheetBuilderImpl();
    var builder = new CSSBuilderImpl(thisClass, thisContext, styleSheet);
    cssRule(builder);
    return to(builder, styleSheet._get_cssRules__4());
  }
  function cssRules$factory() {
    return getPropertyCallableRef('cssRules', 1, KMutableProperty1, function (receiver) {
      return receiver._get_cssRules__4();
    }, function (receiver_0, value_0) {
      return receiver_0._set_cssRules_(value_0);
    });
  }
  function cssRules$factory_0() {
    return getPropertyCallableRef('cssRules', 1, KMutableProperty1, function (receiver) {
      return receiver._get_cssRules__4();
    }, function (receiver_0, value_0) {
      return receiver_0._set_cssRules_(value_0);
    });
  }
  function CSSRulesHolder() {
  }
  CSSRulesHolder.prototype.add_51 = function (selector, style) {
    this.add_50(new CSSStyleRuleDeclaration(selector, style));
  };
  CSSRulesHolder.$metadata$ = {
    simpleName: 'CSSRulesHolder',
    kind: 'interface',
    interfaces: []
  };
  function StyleSheetBuilder() {
  }
  StyleSheetBuilder.$metadata$ = {
    simpleName: 'StyleSheetBuilder',
    kind: 'interface',
    interfaces: [CSSRulesHolder, GenericStyleSheetBuilder]
  };
  function GenericStyleSheetBuilder() {
  }
  GenericStyleSheetBuilder.$metadata$ = {
    simpleName: 'GenericStyleSheetBuilder',
    kind: 'interface',
    interfaces: [CSSRulesHolder]
  };
  function StyleSheetBuilderImpl() {
    var tmp = this;
    tmp._cssRules = ArrayList_init_$Create$();
    this._$stable_38 = 8;
  }
  StyleSheetBuilderImpl.prototype._get_cssRules__4 = function () {
    return this._cssRules;
  };
  StyleSheetBuilderImpl.prototype.add_50 = function (cssRule) {
    this._get_cssRules__4().add_37(cssRule);
    Unit_getInstance();
  };
  StyleSheetBuilderImpl.$metadata$ = {
    simpleName: 'StyleSheetBuilderImpl',
    kind: 'class',
    interfaces: [StyleSheetBuilder]
  };
  function CSSClass(className_0) {
    CSSSelector.call(this);
    this._className = className_0;
    this._$stable_39 = 0;
  }
  CSSClass.prototype.toString = function () {
    return '' + '.' + this._className;
  };
  CSSClass.prototype.hashCode = function () {
    return getStringHashCode(this._className);
  };
  CSSClass.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CSSClass))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CSSClass ? other : THROW_CCE();
    if (!(this._className === tmp0_other_with_cast._className))
      return false;
    return true;
  };
  CSSClass.$metadata$ = {
    simpleName: 'CSSClass',
    kind: 'class',
    interfaces: []
  };
  function CSSSelector() {
    this._$stable_40 = 0;
  }
  CSSSelector.prototype.equals = function (other) {
    return toString_1(this) === toString_0(other);
  };
  CSSSelector.$metadata$ = {
    simpleName: 'CSSSelector',
    kind: 'class',
    interfaces: []
  };
  function className(className_0) {
    return new CSSClass(className_0);
  }
  function DisposableEffectHolder_init_$Init$(effect, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      effect = null;
    DisposableEffectHolder.call($this, effect);
    return $this;
  }
  function DisposableEffectHolder_init_$Create$(effect, $mask0, $marker) {
    return DisposableEffectHolder_init_$Init$(effect, $mask0, $marker, Object.create(DisposableEffectHolder.prototype));
  }
  function DisposableEffectHolder(effect) {
    this._effect_0 = effect;
    this._$stable_41 = 8;
  }
  DisposableEffectHolder.$metadata$ = {
    simpleName: 'DisposableEffectHolder',
    kind: 'class',
    interfaces: []
  };
  function DOMScope() {
  }
  DOMScope.$metadata$ = {
    simpleName: 'DOMScope',
    kind: 'interface',
    interfaces: []
  };
  function ElementScope() {
  }
  ElementScope.$metadata$ = {
    simpleName: 'ElementScope',
    kind: 'interface',
    interfaces: [DOMScope]
  };
  function DomEffectScope() {
  }
  DomEffectScope.$metadata$ = {
    simpleName: 'DomEffectScope',
    kind: 'interface',
    interfaces: []
  };
  function ElementScopeImpl() {
    ElementScopeBase.call(this);
    this._$stable_42 = 8;
  }
  ElementScopeImpl.prototype._set_element_ = function (_set___) {
    this._element_0 = _set___;
  };
  ElementScopeImpl.prototype._get_element__0 = function () {
    var tmp = this._element_0;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('element');
    }
  };
  ElementScopeImpl.$metadata$ = {
    simpleName: 'ElementScopeImpl',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__135($changed, $effect, $effectHolder, this$0) {
    this._$changed_0 = $changed;
    this._$effect_0 = $effect;
    this._$effectHolder = $effectHolder;
    this._this$0_24 = this$0;
  }
  _no_name_provided__135.prototype.invoke_415 = function () {
    if (this._$changed_0)
      this._$effect_0(this._$effectHolder, this._this$0_24._get_element__0());
  };
  _no_name_provided__135.prototype.invoke_452 = function () {
    this.invoke_415();
    return Unit_getInstance();
  };
  _no_name_provided__135.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ElementScopeBase() {
    this._nextDisposableDomEffectKey = 0;
    this._$stable_43 = 8;
  }
  ElementScopeBase.prototype.DomSideEffect$composable_1 = function (key_0, effect, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.startReplaceableGroup_2(1261205660, 'C(DomSideEffect$composable)P(1)80@2654L69,83@2732L76:ElementScope.kt#mzr94e');
    var changed = $composer_0.changed_2(key_0);
    var tmp0_remember$composable_0 = $composer_0;
    var tmp1_remember$composable_0 = 14 & $changed;
    var $composer_1 = tmp0_remember$composable_0;
    $composer_1.startReplaceableGroup_2(884179945, 'C(remember$composable)P(1):Composables.kt#9igjgp');
    var tmp1_cache_0_3 = $composer_1;
    var tmp2_cache_0_4 = $composer_1.changed_2(key_0);
    var tmp0_let_0_5 = tmp1_cache_0_3.rememberedValue_0();
    var tmp;
    if (tmp2_cache_0_4 ? true : tmp0_let_0_5 === Companion_getInstance_11()._Empty) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_return_8 = new DomDisposableEffectHolder(this);
        tmp$ret$0 = tmp0_return_8;
        break l$ret$1;
      }
       while (false);
      var value_2_2_6 = tmp$ret$0;
      tmp1_cache_0_3.updateRememberedValue_0(value_2_2_6);
      tmp = value_2_2_6;
    } else {
      tmp = tmp0_let_0_5;
    }
    var tmp_0 = tmp;
    var tmp0_2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    $composer_1.endReplaceableGroup_0();
    var effectHolder = tmp0_2;
    SideEffect$composable(_no_name_provided_$factory_101(changed, effect, effectHolder, this), $composer_0, 0);
    $composer_0.endReplaceableGroup_0();
  };
  ElementScopeBase.$metadata$ = {
    simpleName: 'ElementScopeBase',
    kind: 'class',
    interfaces: [ElementScope]
  };
  function DomDisposableEffectHolder(elementScope) {
    this._elementScope = elementScope;
    this._onDispose_0 = null;
  }
  DomDisposableEffectHolder.prototype.onRemembered_2 = function () {
  };
  DomDisposableEffectHolder.prototype.onForgotten_2 = function () {
    var tmp0_safe_receiver = this._onDispose_0;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(this._elementScope._get_element__0());
    Unit_getInstance();
  };
  DomDisposableEffectHolder.prototype.onAbandoned_2 = function () {
  };
  DomDisposableEffectHolder.prototype.onDispose_0 = function (disposeEffect) {
    this._onDispose_0 = disposeEffect;
  };
  DomDisposableEffectHolder.$metadata$ = {
    simpleName: 'DomDisposableEffectHolder',
    kind: 'class',
    interfaces: [RememberObserver, DomEffectScope]
  };
  function _no_name_provided_$factory_101($changed, $effect, $effectHolder, this$0) {
    var i = new _no_name_provided__135($changed, $effect, $effectHolder, this$0);
    return function () {
      i.invoke_415();
      return Unit_getInstance();
    };
  }
  function Text$composable_0(value_0, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-2074694641, 'C(Text$composable)56@2069L207:Elements.kt#mzr94e');
    var $dirty = $changed;
    if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(value_0) ? 4 : 2);
    if (!(($dirty & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_ComposeNode$composable_0 = _no_name_provided_$factory_102();
      var tmp1_ComposeNode$composable_0 = $composer_0;
      var tmp2_ComposeNode$composable_0 = 0;
      var $composer_1 = tmp1_ComposeNode$composable_0;
      $composer_1.startReplaceableGroup_2(-440990794, 'C(ComposeNode$composable):Composables.kt#9igjgp');
      var tmp = $composer_1._get_applier__0();
      if (!(tmp instanceof DomApplier))
        invalidApplier();
      else {
      }
      $composer_1.startNode_2();
      if ($composer_1._get_inserting__0()) {
        var tmp_0 = $composer_1;
        tmp_0.createNode_0(_no_name_provided_$factory_103(tmp0_ComposeNode$composable_0));
      } else {
        $composer_1.useNode_0();
      }
      var tmp3__anonymous__3 = _Updater___init__impl_($composer_1);
      Updater__set_impl(tmp3__anonymous__3, value_0, _no_name_provided_$factory_104());
      $composer_1.endNode_0();
      $composer_1.endReplaceableGroup_0();
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_105(value_0, $changed));
    }
  }
  function _no_name_provided__136($boundThis) {
    this._$boundThis_3 = $boundThis;
  }
  _no_name_provided__136.prototype.invoke_212 = function (p0, p1, p2) {
    return this._$boundThis_3.invoke_170(p0, p1, p2);
  };
  _no_name_provided__136.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_212(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__136.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__137() {
  }
  _no_name_provided__137.prototype.invoke_338 = function ($this$null, $composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 81 ^ 16) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__137.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_338(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__137.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__138($boundThis) {
    this._$boundThis_4 = $boundThis;
  }
  _no_name_provided__138.prototype.invoke_216 = function (p0, p1, p2) {
    return this._$boundThis_4.invoke_170(p0, p1, p2);
  };
  _no_name_provided__138.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_216(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__138.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__139() {
  }
  _no_name_provided__139.prototype.invoke_218 = function ($this$null, $composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 81 ^ 16) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__139.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_218(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__139.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__140($boundThis) {
    this._$boundThis_5 = $boundThis;
  }
  _no_name_provided__140.prototype.invoke_228 = function (p0, p1, p2) {
    return this._$boundThis_5.invoke_170(p0, p1, p2);
  };
  _no_name_provided__140.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_228(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__140.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__141() {
  }
  _no_name_provided__141.prototype.invoke_230 = function ($this$null, $composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 81 ^ 16) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__141.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_230(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__141.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__142($boundThis) {
    this._$boundThis_6 = $boundThis;
  }
  _no_name_provided__142.prototype.invoke_228 = function (p0, p1, p2) {
    return this._$boundThis_6.invoke_170(p0, p1, p2);
  };
  _no_name_provided__142.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_228(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__142.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__143() {
  }
  _no_name_provided__143.prototype.invoke_230 = function ($this$null, $composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 81 ^ 16) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__143.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_230(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__143.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__144($boundThis) {
    this._$boundThis_7 = $boundThis;
  }
  _no_name_provided__144.prototype.invoke_228 = function (p0, p1, p2) {
    return this._$boundThis_7.invoke_170(p0, p1, p2);
  };
  _no_name_provided__144.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_228(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__144.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__145() {
  }
  _no_name_provided__145.prototype.invoke_230 = function ($this$null, $composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 81 ^ 16) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__145.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_230(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__145.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ComposableSingletons$ElementsKt() {
    ComposableSingletons$ElementsKt_instance = this;
    var tmp = this;
    tmp._lambda_1_0 = _no_name_provided_$factory_107(composableLambdaInstance(-985531297, false, 'C:Elements.kt#mzr94e', _no_name_provided_$factory_106()));
    var tmp_0 = this;
    tmp_0._lambda_2_0 = _no_name_provided_$factory_109(composableLambdaInstance(-985541906, false, 'C:Elements.kt#mzr94e', _no_name_provided_$factory_108()));
    var tmp_1 = this;
    tmp_1._lambda_3 = _no_name_provided_$factory_111(composableLambdaInstance(-985545969, false, 'C:Elements.kt#mzr94e', _no_name_provided_$factory_110()));
    var tmp_2 = this;
    tmp_2._lambda_4 = _no_name_provided_$factory_113(composableLambdaInstance(-985546103, false, 'C:Elements.kt#mzr94e', _no_name_provided_$factory_112()));
    var tmp_3 = this;
    tmp_3._lambda_5 = _no_name_provided_$factory_115(composableLambdaInstance(-985545697, false, 'C:Elements.kt#mzr94e', _no_name_provided_$factory_114()));
  }
  ComposableSingletons$ElementsKt.$metadata$ = {
    simpleName: 'ComposableSingletons$ElementsKt',
    kind: 'object',
    interfaces: []
  };
  var ComposableSingletons$ElementsKt_instance;
  function ComposableSingletons$ElementsKt_getInstance() {
    if (ComposableSingletons$ElementsKt_instance == null)
      new ComposableSingletons$ElementsKt();
    return ComposableSingletons$ElementsKt_instance;
  }
  function Text$composable$lambda_0_0($value, $$changed, $composer, $force) {
    return Text$composable_0($value, $composer, $$changed | 1);
  }
  function _no_name_provided__146() {
  }
  _no_name_provided__146.prototype.invoke_452 = function () {
    return new DomNodeWrapper(document.createTextNode(''));
  };
  _no_name_provided__146.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__147($tmp0_ComposeNode$composable_0) {
    this._$tmp0_ComposeNode$composable_0 = $tmp0_ComposeNode$composable_0;
  }
  _no_name_provided__147.prototype.invoke_452 = function () {
    return this._$tmp0_ComposeNode$composable_0();
  };
  _no_name_provided__147.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__148() {
  }
  _no_name_provided__148.prototype.invoke_234 = function ($this$set, value_0) {
    var tmp = $this$set._node_1;
    (tmp instanceof Text ? tmp : THROW_CCE()).data = value_0;
  };
  _no_name_provided__148.prototype.invoke_462 = function (p1, p2) {
    var tmp = p1 instanceof DomNodeWrapper ? p1 : THROW_CCE();
    this.invoke_234(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__148.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__149($value, $$changed) {
    this._$value_3 = $value;
    this._$$changed_5 = $$changed;
  }
  _no_name_provided__149.prototype.invoke_444 = function (p0, p1) {
    return Text$composable$lambda_0_0(this._$value_3, this._$$changed_5, p0, p1);
  };
  _no_name_provided__149.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__149.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_102() {
    var i = new _no_name_provided__146();
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_103($tmp0_ComposeNode$composable_0) {
    var i = new _no_name_provided__147($tmp0_ComposeNode$composable_0);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_104() {
    var i = new _no_name_provided__148();
    return function (p1, p2) {
      i.invoke_234(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_105($value, $$changed) {
    var i = new _no_name_provided__149($value, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_106() {
    var i = new _no_name_provided__137();
    return function (p1, p2, p3) {
      i.invoke_338(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_107($boundThis) {
    var i = new _no_name_provided__136($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_212(p1, p2, p3);
    };
  }
  function _no_name_provided_$factory_108() {
    var i = new _no_name_provided__139();
    return function (p1, p2, p3) {
      i.invoke_218(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_109($boundThis) {
    var i = new _no_name_provided__138($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_216(p1, p2, p3);
    };
  }
  function _no_name_provided_$factory_110() {
    var i = new _no_name_provided__141();
    return function (p1, p2, p3) {
      i.invoke_230(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_111($boundThis) {
    var i = new _no_name_provided__140($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_228(p1, p2, p3);
    };
  }
  function _no_name_provided_$factory_112() {
    var i = new _no_name_provided__143();
    return function (p1, p2, p3) {
      i.invoke_230(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_113($boundThis) {
    var i = new _no_name_provided__142($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_228(p1, p2, p3);
    };
  }
  function _no_name_provided_$factory_114() {
    var i = new _no_name_provided__145();
    return function (p1, p2, p3) {
      i.invoke_230(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_115($boundThis) {
    var i = new _no_name_provided__144($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_228(p1, p2, p3);
    };
  }
  function setProperty(styleMap, name, value_0) {
    (function () {
      var $externalVarargReceiverTmp = styleMap;
      return $externalVarargReceiverTmp.set.apply($externalVarargReceiverTmp, [name].concat([value_0]));
    }.call(this));
  }
  function setVariable(style, name, value_0) {
    style.setProperty('' + '--' + name, toString_1(value_0));
  }
  function setCSSRules(sheet, cssRules) {
    var tmp0_iterator_1 = cssRules.iterator_46();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_28();
      addRule(sheet, element_2);
    }
  }
  function clearCSSRules(sheet) {
    var tmp0_unsafeCast_0_1 = sheet.cssRules;
    var tmp0_repeat_0 = tmp0_unsafeCast_0_1.length;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_deleteRule_0_4 = 0;
        sheet.deleteRule(tmp0_deleteRule_0_4);
      }
       while (inductionVariable < tmp0_repeat_0);
  }
  function addRule(_this_, cssRuleDeclaration) {
    var cssRule = addRule_0(_this_, '' + cssRuleDeclaration._get_header__0() + ' {}');
    fillRule(cssRuleDeclaration, cssRule);
  }
  function addRule_0(_this_, cssRule) {
    var tmp0_unsafeCast_0_1 = _this_.cssRules;
    var cssRuleIndex = insertRule(_this_, cssRule, tmp0_unsafeCast_0_1.length);
    var tmp0_unsafeCast_0_1_0 = _this_.cssRules;
    var tmp0_get_0 = tmp0_unsafeCast_0_1_0;
    var tmp0_unsafeCast_0_1_1 = tmp0_get_0[cssRuleIndex];
    return tmp0_unsafeCast_0_1_1;
  }
  function fillRule(cssRuleDeclaration, cssRule) {
    var tmp0_subject = cssRuleDeclaration;
    if (tmp0_subject instanceof CSSStyleRuleDeclaration) {
      var cssStyleRule = cssRule;
      var tmp0_forEach_0 = cssRuleDeclaration._style_0._get_properties__2();
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_46();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_28();
        var name_4 = element_2.component1_0();
        var value_5 = element_2.component2_0();
        var tmp0_unsafeCast_0_1_6 = cssStyleRule.styleMap;
        setProperty(tmp0_unsafeCast_0_1_6, name_4, value_5);
      }
      var tmp1_forEach_0 = cssRuleDeclaration._style_0._get_variables__2();
      var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_46();
      while (tmp0_iterator_1_0.hasNext_27()) {
        var element_2_0 = tmp0_iterator_1_0.next_28();
        var name_4_0 = element_2_0.component1_0();
        var value_5_0 = element_2_0.component2_0();
        setVariable(cssStyleRule.style, name_4_0, value_5_0);
      }
    } else {
      if (tmp0_subject instanceof CSSGroupingRuleDeclaration) {
        var cssGroupingRule = cssRule;
        var tmp2_forEach_0 = cssRuleDeclaration._rules;
        var tmp0_iterator_1_1 = tmp2_forEach_0.iterator_46();
        while (tmp0_iterator_1_1.hasNext_27()) {
          var element_2_1 = tmp0_iterator_1_1.next_28();
          addRule_1(cssGroupingRule, element_2_1);
        }
      } else {
      }
    }
  }
  function addRule_1(_this_, cssRuleDeclaration) {
    var cssRule = addRule_2(_this_, '' + cssRuleDeclaration._get_header__0() + ' {}');
    fillRule(cssRuleDeclaration, cssRule);
  }
  function addRule_2(_this_, cssRule) {
    var cssRuleIndex = _this_.insertRule(cssRule, _this_.cssRules.length);
    var tmp0_get_0 = _this_.cssRules;
    var tmp0_unsafeCast_0_1 = tmp0_get_0[cssRuleIndex];
    return tmp0_unsafeCast_0_1;
  }
  function WrappedMouseEvent(nativeEvent) {
    this._nativeEvent = nativeEvent;
    this._$stable_44 = 0;
  }
  WrappedMouseEvent.prototype._get_nativeEvent__1 = function () {
    return this._nativeEvent;
  };
  WrappedMouseEvent.$metadata$ = {
    simpleName: 'WrappedMouseEvent',
    kind: 'class',
    interfaces: [GenericWrappedEvent]
  };
  function GenericWrappedEvent() {
  }
  GenericWrappedEvent.$metadata$ = {
    simpleName: 'GenericWrappedEvent',
    kind: 'interface',
    interfaces: []
  };
  function WrappedEvent() {
  }
  WrappedEvent.$metadata$ = {
    simpleName: 'WrappedEvent',
    kind: 'interface',
    interfaces: [GenericWrappedEvent]
  };
  function WrappedEventImpl(nativeEvent) {
    this._nativeEvent_0 = nativeEvent;
    this._$stable_45 = 0;
  }
  WrappedEventImpl.prototype._get_nativeEvent__1 = function () {
    return this._nativeEvent_0;
  };
  WrappedEventImpl.$metadata$ = {
    simpleName: 'WrappedEventImpl',
    kind: 'class',
    interfaces: [WrappedEvent]
  };
  function background(_this_, color_0) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_116(color_0));
    return tmp0_apply_0;
  }
  function asStyleBuilderApplier(_this_, passThroughHandler) {
    var tmp0_let_0 = castOrCreate(_this_);
    var st_2 = _no_name_provided_$factory_117(tmp0_let_0, passThroughHandler);
    return st_2;
  }
  function asStyleBuilderApplier$default(_this_, passThroughHandler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      passThroughHandler = null;
    return asStyleBuilderApplier(_this_, passThroughHandler);
  }
  function asAttributeBuilderApplier(_this_, passThroughHandler) {
    var tmp0_let_0 = castOrCreate(_this_);
    var st_2 = _no_name_provided_$factory_118(tmp0_let_0, passThroughHandler);
    return st_2;
  }
  function asAttributeBuilderApplier$default(_this_, passThroughHandler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      passThroughHandler = null;
    return asAttributeBuilderApplier(_this_, passThroughHandler);
  }
  function _no_name_provided__150($color) {
    this._$color_0 = $color;
  }
  _no_name_provided__150.prototype.invoke_467 = function ($this$add) {
    backgroundColor($this$add, new RGB(this._$color_0._red, this._$color_0._green, this._$color_0._blue));
  };
  _no_name_provided__150.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__150.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__151($tmp0_let_0, $passThroughHandler) {
    this._$tmp0_let_0 = $tmp0_let_0;
    this._$passThroughHandler = $passThroughHandler;
  }
  _no_name_provided__151.prototype.invoke_467 = function ($this$null) {
    var tmp0_forEach_0_4 = this._$tmp0_let_0._styleHandlers;
    var tmp0_iterator_1_5 = tmp0_forEach_0_4.iterator_46();
    while (tmp0_iterator_1_5.hasNext_27()) {
      var element_2_6 = tmp0_iterator_1_5.next_28();
      element_2_6($this$null);
    }
    var tmp0_safe_receiver_7 = this._$passThroughHandler;
    if (tmp0_safe_receiver_7 == null)
      null;
    else
      tmp0_safe_receiver_7($this$null);
    Unit_getInstance();
  };
  _no_name_provided__151.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__151.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__152($tmp0_let_0, $passThroughHandler) {
    this._$tmp0_let_0_0 = $tmp0_let_0;
    this._$passThroughHandler_0 = $passThroughHandler;
  }
  _no_name_provided__152.prototype.invoke_383 = function ($this$null) {
    var tmp0_forEach_0_4 = this._$tmp0_let_0_0._attrHandlers;
    var tmp0_iterator_1_5 = tmp0_forEach_0_4.iterator_46();
    while (tmp0_iterator_1_5.hasNext_27()) {
      var element_2_6 = tmp0_iterator_1_5.next_28();
      element_2_6($this$null);
    }
    var tmp0_safe_receiver_7 = this._$passThroughHandler_0;
    if (tmp0_safe_receiver_7 == null)
      null;
    else
      tmp0_safe_receiver_7($this$null);
    Unit_getInstance();
  };
  _no_name_provided__152.prototype.invoke_468 = function (p1) {
    this.invoke_383(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__152.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_116($color) {
    var i = new _no_name_provided__150($color);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_117($tmp0_let_0, $passThroughHandler) {
    var i = new _no_name_provided__151($tmp0_let_0, $passThroughHandler);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_118($tmp0_let_0, $passThroughHandler) {
    var i = new _no_name_provided__152($tmp0_let_0, $passThroughHandler);
    return function (p1) {
      i.invoke_383(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__153() {
  }
  _no_name_provided__153.prototype.invoke_256 = function ($this$style) {
    display($this$style, DisplayStyle_Block_getInstance());
    left($this$style, _get_px_(0));
  };
  _no_name_provided__153.prototype.invoke_468 = function (p1) {
    this.invoke_256((!(p1 == null) ? isInterface(p1, CSSBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__153.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__154() {
  }
  _no_name_provided__154.prototype.invoke_256 = function ($this$style) {
    display($this$style, DisplayStyle_Flex_getInstance());
    flexDirection($this$style, FlexDirection_Row_getInstance());
  };
  _no_name_provided__154.prototype.invoke_468 = function (p1) {
    this.invoke_256((!(p1 == null) ? isInterface(p1, CSSBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__154.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__155() {
  }
  _no_name_provided__155.prototype.invoke_256 = function ($this$style) {
    justifyContent($this$style, JustifyContent_FlexStart_getInstance());
  };
  _no_name_provided__155.prototype.invoke_468 = function (p1) {
    this.invoke_256((!(p1 == null) ? isInterface(p1, CSSBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__155.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__156() {
  }
  _no_name_provided__156.prototype.invoke_256 = function ($this$style) {
    justifyContent($this$style, JustifyContent_FlexEnd_getInstance());
  };
  _no_name_provided__156.prototype.invoke_468 = function (p1) {
    this.invoke_256((!(p1 == null) ? isInterface(p1, CSSBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__156.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__157() {
  }
  _no_name_provided__157.prototype.invoke_256 = function ($this$style) {
    alignItems($this$style, AlignItems_FlexStart_getInstance());
  };
  _no_name_provided__157.prototype.invoke_468 = function (p1) {
    this.invoke_256((!(p1 == null) ? isInterface(p1, CSSBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__157.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__158() {
  }
  _no_name_provided__158.prototype.invoke_256 = function ($this$style) {
    alignItems($this$style, AlignItems_Center_getInstance());
  };
  _no_name_provided__158.prototype.invoke_468 = function (p1) {
    this.invoke_256((!(p1 == null) ? isInterface(p1, CSSBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__158.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__159() {
  }
  _no_name_provided__159.prototype.invoke_256 = function ($this$style) {
    alignItems($this$style, AlignItems_FlexEnd_getInstance());
  };
  _no_name_provided__159.prototype.invoke_468 = function (p1) {
    this.invoke_256((!(p1 == null) ? isInterface(p1, CSSBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__159.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Styles() {
    Styles_instance = this;
    StyleSheet_init_$Init$(null, 1, null, this);
    this._columnClass = 'compose-web-column';
    var tmp = this;
    tmp._textClass$delegate = this.style_2(_no_name_provided_$factory_119()).provideDelegate(this, textClass$factory());
    var tmp_0 = this;
    tmp_0._rowClass$delegate = this.style_2(_no_name_provided_$factory_120()).provideDelegate(this, rowClass$factory());
    var tmp_1 = this;
    tmp_1._composeWebArrangementHorizontalStart$delegate = this.style_2(_no_name_provided_$factory_121()).provideDelegate(this, composeWebArrangementHorizontalStart$factory());
    var tmp_2 = this;
    tmp_2._composeWebArrangementHorizontalEnd$delegate = this.style_2(_no_name_provided_$factory_122()).provideDelegate(this, composeWebArrangementHorizontalEnd$factory());
    var tmp_3 = this;
    tmp_3._composeWebAlignmentVerticalTop$delegate = this.style_2(_no_name_provided_$factory_123()).provideDelegate(this, composeWebAlignmentVerticalTop$factory());
    var tmp_4 = this;
    tmp_4._composeWebAlignmentVerticalCenter$delegate = this.style_2(_no_name_provided_$factory_124()).provideDelegate(this, composeWebAlignmentVerticalCenter$factory());
    var tmp_5 = this;
    tmp_5._composeWebAlignmentVerticalBottom$delegate = this.style_2(_no_name_provided_$factory_125()).provideDelegate(this, composeWebAlignmentVerticalBottom$factory());
    this._$stable_46 = 0;
  }
  Styles.prototype._get_textClass_ = function () {
    return this._textClass$delegate.getValue_1(this, textClass$factory_0());
  };
  Styles.prototype._get_rowClass_ = function () {
    return this._rowClass$delegate.getValue_1(this, rowClass$factory_0());
  };
  Styles.prototype._get_composeWebArrangementHorizontalStart_ = function () {
    return this._composeWebArrangementHorizontalStart$delegate.getValue_1(this, composeWebArrangementHorizontalStart$factory_0());
  };
  Styles.prototype._get_composeWebArrangementHorizontalEnd_ = function () {
    return this._composeWebArrangementHorizontalEnd$delegate.getValue_1(this, composeWebArrangementHorizontalEnd$factory_0());
  };
  Styles.prototype._get_composeWebAlignmentVerticalTop_ = function () {
    return this._composeWebAlignmentVerticalTop$delegate.getValue_1(this, composeWebAlignmentVerticalTop$factory_0());
  };
  Styles.prototype._get_composeWebAlignmentVerticalCenter_ = function () {
    return this._composeWebAlignmentVerticalCenter$delegate.getValue_1(this, composeWebAlignmentVerticalCenter$factory_0());
  };
  Styles.prototype._get_composeWebAlignmentVerticalBottom_ = function () {
    return this._composeWebAlignmentVerticalBottom$delegate.getValue_1(this, composeWebAlignmentVerticalBottom$factory_0());
  };
  Styles.$metadata$ = {
    simpleName: 'Styles',
    kind: 'object',
    interfaces: []
  };
  var Styles_instance;
  function Styles_getInstance() {
    if (Styles_instance == null)
      new Styles();
    return Styles_instance;
  }
  function textClass$factory() {
    return getPropertyCallableRef('textClass', 1, KProperty1, function (receiver) {
      return receiver._get_textClass_();
    }, null);
  }
  function rowClass$factory() {
    return getPropertyCallableRef('rowClass', 1, KProperty1, function (receiver) {
      return receiver._get_rowClass_();
    }, null);
  }
  function composeWebArrangementHorizontalStart$factory() {
    return getPropertyCallableRef('composeWebArrangementHorizontalStart', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebArrangementHorizontalStart_();
    }, null);
  }
  function composeWebArrangementHorizontalEnd$factory() {
    return getPropertyCallableRef('composeWebArrangementHorizontalEnd', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebArrangementHorizontalEnd_();
    }, null);
  }
  function composeWebAlignmentVerticalTop$factory() {
    return getPropertyCallableRef('composeWebAlignmentVerticalTop', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebAlignmentVerticalTop_();
    }, null);
  }
  function composeWebAlignmentVerticalCenter$factory() {
    return getPropertyCallableRef('composeWebAlignmentVerticalCenter', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebAlignmentVerticalCenter_();
    }, null);
  }
  function composeWebAlignmentVerticalBottom$factory() {
    return getPropertyCallableRef('composeWebAlignmentVerticalBottom', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebAlignmentVerticalBottom_();
    }, null);
  }
  function textClass$factory_0() {
    return getPropertyCallableRef('textClass', 1, KProperty1, function (receiver) {
      return receiver._get_textClass_();
    }, null);
  }
  function rowClass$factory_0() {
    return getPropertyCallableRef('rowClass', 1, KProperty1, function (receiver) {
      return receiver._get_rowClass_();
    }, null);
  }
  function composeWebArrangementHorizontalStart$factory_0() {
    return getPropertyCallableRef('composeWebArrangementHorizontalStart', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebArrangementHorizontalStart_();
    }, null);
  }
  function composeWebArrangementHorizontalEnd$factory_0() {
    return getPropertyCallableRef('composeWebArrangementHorizontalEnd', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebArrangementHorizontalEnd_();
    }, null);
  }
  function composeWebAlignmentVerticalTop$factory_0() {
    return getPropertyCallableRef('composeWebAlignmentVerticalTop', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebAlignmentVerticalTop_();
    }, null);
  }
  function composeWebAlignmentVerticalCenter$factory_0() {
    return getPropertyCallableRef('composeWebAlignmentVerticalCenter', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebAlignmentVerticalCenter_();
    }, null);
  }
  function composeWebAlignmentVerticalBottom$factory_0() {
    return getPropertyCallableRef('composeWebAlignmentVerticalBottom', 1, KProperty1, function (receiver) {
      return receiver._get_composeWebAlignmentVerticalBottom_();
    }, null);
  }
  function _no_name_provided_$factory_119() {
    var i = new _no_name_provided__153();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_120() {
    var i = new _no_name_provided__154();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_121() {
    var i = new _no_name_provided__155();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_122() {
    var i = new _no_name_provided__156();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_123() {
    var i = new _no_name_provided__157();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_124() {
    var i = new _no_name_provided__158();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_125() {
    var i = new _no_name_provided__159();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function ActualModifier() {
    var tmp = this;
    tmp._styleHandlers = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._attrHandlers = ArrayList_init_$Create$();
    this._$stable_47 = 0;
  }
  ActualModifier.prototype.add_52 = function (builder) {
    this._styleHandlers.add_37(builder);
    Unit_getInstance();
  };
  ActualModifier.prototype.addAttributeBuilder = function (builder) {
    this._attrHandlers.add_37(builder);
    Unit_getInstance();
  };
  ActualModifier.$metadata$ = {
    simpleName: 'ActualModifier',
    kind: 'class',
    interfaces: [Modifier]
  };
  function castOrCreate(_this_) {
    var tmp0_elvis_lhs = _this_ instanceof ActualModifier ? _this_ : null;
    return tmp0_elvis_lhs == null ? new ActualModifier() : tmp0_elvis_lhs;
  }
  function BoxActual$composable(modifier, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(326055002, 'C(BoxActual$composable)P(1)26@1033L139:box.kt#kxwuio');
    var $dirty = $changed;
    if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 32 : 16);
    if (!(($dirty & 91 ^ 18) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_style = asStyleBuilderApplier$default(modifier, null, 1, null);
      var tmp1_attrs = asAttributeBuilderApplier$default(modifier, null, 1, null);
      var tmp0_Div$composable_0 = $composer_0;
      var tmp1_Div$composable_0 = 0;
      var tmp2_Div$composable_0 = 0;
      var attrs_1 = tmp1_attrs;
      var style_2 = tmp0_style;
      var $composer_3 = tmp0_Div$composable_0;
      $composer_3.startReplaceableGroup_2(1874023935, 'C(Div$composable)P(!1,2)70@2500L124:Elements.kt#mzr94e');
      if (!((tmp2_Div$composable_0 & 1) === 0)) {
        attrs_1 = _no_name_provided_$factory_126();
      }if (!((tmp2_Div$composable_0 & 2) === 0)) {
        style_2 = _no_name_provided_$factory_127();
      }var tmp0_TagElement$composable_0_6 = 'div';
      var tmp1_TagElement$composable_0_7 = attrs_1;
      var tmp2_TagElement$composable_0_8 = style_2;
      var tmp3_TagElement$composable_0_9 = $composer_3;
      var tmp4_TagElement$composable_0_10 = 6 | 112 & tmp1_Div$composable_0 << 3 | 896 & tmp1_Div$composable_0 << 3 | 7168 & tmp1_Div$composable_0 << 3;
      var $composer_1_11 = tmp3_TagElement$composable_0_9;
      $composer_1_11.startReplaceableGroup_2(-1134585235, 'C(TagElement$composable)P(3)76@2833L45,77@2899L37,79@2942L1040,107@3988L100:Base.kt#mzr94e');
      var tmp0_remember$composable_0_3_13 = $composer_1_11;
      var tmp1_remember$composable_0_4_14 = 0;
      var $composer_1_5_15 = tmp0_remember$composable_0_3_13;
      $composer_1_5_15.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_7_17 = $composer_1_5_15;
      var tmp2_cache_0_4_8_18 = false;
      var tmp0_let_0_5_9_19 = tmp1_cache_0_3_7_17.rememberedValue_0();
      var tmp;
      if (tmp2_cache_0_4_8_18 ? true : tmp0_let_0_5_9_19 === Companion_getInstance_11()._Empty) {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_return_8_11_21 = new ElementScopeImpl();
          tmp$ret$0 = tmp0_return_8_11_21;
          break l$ret$1;
        }
         while (false);
        var value_2_2_6_10_20 = tmp$ret$0;
        tmp1_cache_0_3_7_17.updateRememberedValue_0(value_2_2_6_10_20);
        tmp = value_2_2_6_10_20;
      } else {
        tmp = tmp0_let_0_5_9_19;
      }
      var tmp_0 = tmp;
      var tmp0_2_6_16 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      $composer_1_5_15.endReplaceableGroup_0();
      var scope_2_12 = tmp0_2_6_16;
      var tmp2_remember$composable_0_13_23 = $composer_1_11;
      var tmp3_remember$composable_0_14_24 = 0;
      var $composer_1_15_25 = tmp2_remember$composable_0_13_23;
      $composer_1_15_25.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_17_27 = $composer_1_15_25;
      var tmp2_cache_0_4_18_28 = false;
      var tmp0_let_0_5_19_29 = tmp1_cache_0_3_17_27.rememberedValue_0();
      var tmp_1;
      if (tmp2_cache_0_4_18_28 ? true : tmp0_let_0_5_19_29 === Companion_getInstance_11()._Empty) {
        var tmp$ret$2;
        l$ret$3: do {
          var tmp0_return_8_21_31 = DisposableEffectHolder_init_$Create$(null, 1, null);
          tmp$ret$2 = tmp0_return_8_21_31;
          break l$ret$3;
        }
         while (false);
        var value_2_2_6_20_30 = tmp$ret$2;
        tmp1_cache_0_3_17_27.updateRememberedValue_0(value_2_2_6_20_30);
        tmp_1 = value_2_2_6_20_30;
      } else {
        tmp_1 = tmp0_let_0_5_19_29;
      }
      var tmp_2 = tmp_1;
      var tmp0_2_16_26 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
      $composer_1_15_25.endReplaceableGroup_0();
      var refEffect_12_22 = tmp0_2_16_26;
      var tmp6_ComposeDomNode$composable_0_22_32 = _no_name_provided_$factory_128(tmp0_TagElement$composable_0_6, scope_2_12);
      var tmp_3 = $composer_1_11;
      var tmp7_ComposeDomNode$composable_0_26_36 = _no_name_provided_$factory_130(composableLambda(tmp_3, -819893738, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_129(tmp1_TagElement$composable_0_7, refEffect_12_22)));
      var tmp_4 = $composer_1_11;
      var tmp8_ComposeDomNode$composable_0_35_45 = _no_name_provided_$factory_132(composableLambda(tmp_4, -819894225, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_131(tmp2_TagElement$composable_0_8)));
      var tmp9_ComposeDomNode$composable_0_42_52 = $composer_1_11;
      var tmp10_ComposeDomNode$composable_0_43_53 = 64 | 57344 & tmp4_TagElement$composable_0_10 << 3;
      var $composer_1_44_54 = tmp9_ComposeDomNode$composable_0_42_52;
      var tmp_5 = $composer_1_44_54._get_applier__0();
      if (!(tmp_5 instanceof DomApplier)) {
        var tmp4_error_0_45_55 = 'Invalid applier';
        throw IllegalStateException_init_$Create$(toString_1(tmp4_error_0_45_55));
      } else {
      }
      $composer_1_44_54.startNode_2();
      if ($composer_1_44_54._get_inserting__0()) {
        $composer_1_44_54.createNode_0(tmp6_ComposeDomNode$composable_0_22_32);
      } else {
        $composer_1_44_54.useNode_0();
      }
      var tmp5_apply_0_47_57 = _SkippableUpdater___init__impl_($composer_1_44_54);
      tmp7_ComposeDomNode$composable_0_26_36(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 3);
      tmp8_ComposeDomNode$composable_0_35_45(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 6);
      var tmp0_group_2_46_56 = tmp5_apply_0_47_57;
      Unit_getInstance();
      $composer_1_44_54.startReplaceableGroup_1(2058660585);
      var tmp3__anonymous__66 = $composer_1_44_54;
      var tmp4__anonymous__66 = 8 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 14 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 9;
      var $composer_67 = tmp3__anonymous__66;
      $composer_67.startReplaceableGroup_2(703602752, 'C30@1157L9:box.kt#kxwuio');
      if (!((tmp4__anonymous__66 & 81 ^ 16) === 0) ? true : !$composer_67._get_skipping__0()) {
        content($composer_67, 14 & $dirty >> 3);
      } else
        $composer_67.skipToGroupEnd_2();
      $composer_67.endReplaceableGroup_0();
      $composer_1_44_54.endReplaceableGroup_0();
      $composer_1_44_54.endNode_0();
      DisposableEffect$composable(null, _no_name_provided_$factory_133(refEffect_12_22, scope_2_12), $composer_1_11, 6);
      $composer_1_11.endReplaceableGroup_0();
      $composer_3.endReplaceableGroup_0();
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_134(modifier, content, $changed));
    }
  }
  function BoxActual$composable$lambda_0($modifier, $content, $$changed, $composer, $force) {
    return BoxActual$composable($modifier, $content, $composer, $$changed | 1);
  }
  function _no_name_provided__160() {
  }
  _no_name_provided__160.prototype.invoke_317 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__160.prototype.invoke_468 = function (p1) {
    this.invoke_317(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__160.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__161() {
  }
  _no_name_provided__161.prototype.invoke_467 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__161.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__161.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__162($tmp0_TagElement$composable_0_6, $scope_2_12) {
    this._$tmp0_TagElement$composable_0_6 = $tmp0_TagElement$composable_0_6;
    this._$scope_2_12 = $scope_2_12;
  }
  _no_name_provided__162.prototype.invoke_452 = function () {
    var tmp0_also_0_24_34 = new DomNodeWrapper(document.createElement(this._$tmp0_TagElement$composable_0_6));
    var tmp0_unsafeCast_0_2_25_35 = tmp0_also_0_24_34._node_1;
    this._$scope_2_12._set_element_(tmp0_unsafeCast_0_2_25_35);
    return tmp0_also_0_24_34;
  };
  _no_name_provided__162.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__163($boundThis) {
    this._$boundThis_8 = $boundThis;
  }
  _no_name_provided__163.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_8.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__163.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__163.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__164($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    this._$tmp1_TagElement$composable_0_7 = $tmp1_TagElement$composable_0_7;
    this._$refEffect_12_22 = $refEffect_12_22;
  }
  _no_name_provided__164.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_28_38 = $composer;
    var $dirty_29_39 = $changed;
    if (($changed & 14) === 0)
      $dirty_29_39 = $dirty_29_39 | ($composer_28_38.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_29_39 & 91 ^ 18) === 0) ? true : !$composer_28_38._get_skipping__0()) {
      var tmp0_also_0_31_41 = new AttrsBuilder();
      this._$tmp1_TagElement$composable_0_7(tmp0_also_0_31_41);
      var attrsApplied_30_40 = tmp0_also_0_31_41;
      this._$refEffect_12_22._effect_0 = attrsApplied_30_40._refEffect;
      var attrsCollected_32_42 = attrsApplied_30_40.collect();
      var events_33_43 = attrsApplied_30_40.asList_0();
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_34_44 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsCollected_32_42, Companion_getInstance_19()._UpdateAttrs);
      Updater__set_impl(tmp1__anonymous__1_34_44, events_33_43, Companion_getInstance_19()._UpdateListeners);
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsApplied_30_40._propertyUpdates, Companion_getInstance_19()._UpdateProperties);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_28_38.skipToGroupEnd_2();
  };
  _no_name_provided__164.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__164.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__165($boundThis) {
    this._$boundThis_9 = $boundThis;
  }
  _no_name_provided__165.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_9.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__165.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__165.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__166($tmp2_TagElement$composable_0_8) {
    this._$tmp2_TagElement$composable_0_8 = $tmp2_TagElement$composable_0_8;
  }
  _no_name_provided__166.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_37_47 = $composer;
    var $dirty_38_48 = $changed;
    if (($changed & 14) === 0)
      $dirty_38_48 = $dirty_38_48 | ($composer_37_47.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_38_48 & 91 ^ 18) === 0) ? true : !$composer_37_47._get_skipping__0()) {
      var tmp0_apply_0_40_50 = new StyleBuilderImpl();
      this._$tmp2_TagElement$composable_0_8(tmp0_apply_0_40_50);
      var style_39_49 = tmp0_apply_0_40_50;
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_41_51 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_41_51, style_39_49, Companion_getInstance_19()._UpdateStyleDeclarations);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_37_47.skipToGroupEnd_2();
  };
  _no_name_provided__166.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__166.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_51_61() {
  }
  _no_name_provided__1_51_61.prototype.dispose_2_52_62_3 = function () {
    Unit_getInstance();
  };
  _no_name_provided__1_51_61.prototype.dispose_20 = function () {
    return this.dispose_2_52_62_3();
  };
  _no_name_provided__1_51_61.$metadata$ = {
    simpleName: '<no name provided>_1_51_61',
    kind: 'class',
    interfaces: [DisposableEffectResult]
  };
  function _no_name_provided__167($refEffect_12_22, $scope_2_12) {
    this._$refEffect_12_22_0 = $refEffect_12_22;
    this._$scope_2_12_0 = $scope_2_12;
  }
  _no_name_provided__167.prototype.invoke_463 = function ($this$DisposableEffect) {
    var tmp0_safe_receiver_50_60 = this._$refEffect_12_22_0._effect_0;
    var tmp1_elvis_lhs_49_59 = tmp0_safe_receiver_50_60 == null ? null : tmp0_safe_receiver_50_60($this$DisposableEffect, this._$scope_2_12_0._get_element__0());
    var tmp;
    if (tmp1_elvis_lhs_49_59 == null) {
      tmp = new _no_name_provided__1_51_61();
    } else {
      tmp = tmp1_elvis_lhs_49_59;
    }
    return tmp;
  };
  _no_name_provided__167.prototype.invoke_468 = function (p1) {
    return this.invoke_463(p1 instanceof DisposableEffectScope ? p1 : THROW_CCE());
  };
  _no_name_provided__167.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__168($modifier, $content, $$changed) {
    this._$modifier_5 = $modifier;
    this._$content_4 = $content;
    this._$$changed_6 = $$changed;
  }
  _no_name_provided__168.prototype.invoke_444 = function (p0, p1) {
    return BoxActual$composable$lambda_0(this._$modifier_5, this._$content_4, this._$$changed_6, p0, p1);
  };
  _no_name_provided__168.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__168.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_126() {
    var i = new _no_name_provided__160();
    return function (p1) {
      i.invoke_317(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_127() {
    var i = new _no_name_provided__161();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_128($tmp0_TagElement$composable_0_6, $scope_2_12) {
    var i = new _no_name_provided__162($tmp0_TagElement$composable_0_6, $scope_2_12);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_129($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    var i = new _no_name_provided__164($tmp1_TagElement$composable_0_7, $refEffect_12_22);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_130($boundThis) {
    var i = new _no_name_provided__163($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_131($tmp2_TagElement$composable_0_8) {
    var i = new _no_name_provided__166($tmp2_TagElement$composable_0_8);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_132($boundThis) {
    var i = new _no_name_provided__165($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_133($refEffect_12_22, $scope_2_12) {
    var i = new _no_name_provided__167($refEffect_12_22, $scope_2_12);
    return function (p1) {
      return i.invoke_463(p1);
    };
  }
  function _no_name_provided_$factory_134($modifier, $content, $$changed) {
    var i = new _no_name_provided__168($modifier, $content, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function ButtonActual$composable(modifier, onClick, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-1231026816, 'C(ButtonActual$composable)P(1,2)28@990L151:button.kt#a1h0r0');
    var $dirty = $changed;
    if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(onClick) ? 32 : 16);
    if (($changed & 896) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 256 : 128);
    if (!(($dirty & 731 ^ 146) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_style = asStyleBuilderApplier$default(modifier, null, 1, null);
      var tmp0_Button$composable_0 = _no_name_provided_$factory_135(onClick);
      var tmp1_Button$composable_0 = $composer_0;
      var tmp2_Button$composable_0 = 0;
      var tmp3_Button$composable_0 = 0;
      var attrs_1 = tmp0_Button$composable_0;
      var style_2 = tmp0_style;
      var $composer_3 = tmp1_Button$composable_0;
      $composer_3.startReplaceableGroup_2(-2122545728, 'C(Button$composable)P(!1,2)121@3824L79:Elements.kt#mzr94e');
      if (!((tmp3_Button$composable_0 & 1) === 0)) {
        attrs_1 = _no_name_provided_$factory_136();
      }if (!((tmp3_Button$composable_0 & 2) === 0)) {
        style_2 = _no_name_provided_$factory_137();
      }var tmp0_TagElement$composable_0_6 = 'button';
      var tmp1_TagElement$composable_0_7 = attrs_1;
      var tmp2_TagElement$composable_0_8 = style_2;
      var tmp3_TagElement$composable_0_9 = $composer_3;
      var tmp4_TagElement$composable_0_10 = 6 | 112 & tmp2_Button$composable_0 << 3 | 896 & tmp2_Button$composable_0 << 3 | 7168 & tmp2_Button$composable_0 << 3;
      var $composer_1_11 = tmp3_TagElement$composable_0_9;
      $composer_1_11.startReplaceableGroup_2(-1134585235, 'C(TagElement$composable)P(3)76@2833L45,77@2899L37,79@2942L1040,107@3988L100:Base.kt#mzr94e');
      var tmp0_remember$composable_0_3_13 = $composer_1_11;
      var tmp1_remember$composable_0_4_14 = 0;
      var $composer_1_5_15 = tmp0_remember$composable_0_3_13;
      $composer_1_5_15.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_7_17 = $composer_1_5_15;
      var tmp2_cache_0_4_8_18 = false;
      var tmp0_let_0_5_9_19 = tmp1_cache_0_3_7_17.rememberedValue_0();
      var tmp;
      if (tmp2_cache_0_4_8_18 ? true : tmp0_let_0_5_9_19 === Companion_getInstance_11()._Empty) {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_return_8_11_21 = new ElementScopeImpl();
          tmp$ret$0 = tmp0_return_8_11_21;
          break l$ret$1;
        }
         while (false);
        var value_2_2_6_10_20 = tmp$ret$0;
        tmp1_cache_0_3_7_17.updateRememberedValue_0(value_2_2_6_10_20);
        tmp = value_2_2_6_10_20;
      } else {
        tmp = tmp0_let_0_5_9_19;
      }
      var tmp_0 = tmp;
      var tmp0_2_6_16 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      $composer_1_5_15.endReplaceableGroup_0();
      var scope_2_12 = tmp0_2_6_16;
      var tmp2_remember$composable_0_13_23 = $composer_1_11;
      var tmp3_remember$composable_0_14_24 = 0;
      var $composer_1_15_25 = tmp2_remember$composable_0_13_23;
      $composer_1_15_25.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_17_27 = $composer_1_15_25;
      var tmp2_cache_0_4_18_28 = false;
      var tmp0_let_0_5_19_29 = tmp1_cache_0_3_17_27.rememberedValue_0();
      var tmp_1;
      if (tmp2_cache_0_4_18_28 ? true : tmp0_let_0_5_19_29 === Companion_getInstance_11()._Empty) {
        var tmp$ret$2;
        l$ret$3: do {
          var tmp0_return_8_21_31 = DisposableEffectHolder_init_$Create$(null, 1, null);
          tmp$ret$2 = tmp0_return_8_21_31;
          break l$ret$3;
        }
         while (false);
        var value_2_2_6_20_30 = tmp$ret$2;
        tmp1_cache_0_3_17_27.updateRememberedValue_0(value_2_2_6_20_30);
        tmp_1 = value_2_2_6_20_30;
      } else {
        tmp_1 = tmp0_let_0_5_19_29;
      }
      var tmp_2 = tmp_1;
      var tmp0_2_16_26 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
      $composer_1_15_25.endReplaceableGroup_0();
      var refEffect_12_22 = tmp0_2_16_26;
      var tmp6_ComposeDomNode$composable_0_22_32 = _no_name_provided_$factory_138(tmp0_TagElement$composable_0_6, scope_2_12);
      var tmp_3 = $composer_1_11;
      var tmp7_ComposeDomNode$composable_0_26_36 = _no_name_provided_$factory_140(composableLambda(tmp_3, -819893738, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_139(tmp1_TagElement$composable_0_7, refEffect_12_22)));
      var tmp_4 = $composer_1_11;
      var tmp8_ComposeDomNode$composable_0_35_45 = _no_name_provided_$factory_142(composableLambda(tmp_4, -819894225, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_141(tmp2_TagElement$composable_0_8)));
      var tmp9_ComposeDomNode$composable_0_42_52 = $composer_1_11;
      var tmp10_ComposeDomNode$composable_0_43_53 = 64 | 57344 & tmp4_TagElement$composable_0_10 << 3;
      var $composer_1_44_54 = tmp9_ComposeDomNode$composable_0_42_52;
      var tmp_5 = $composer_1_44_54._get_applier__0();
      if (!(tmp_5 instanceof DomApplier)) {
        var tmp4_error_0_45_55 = 'Invalid applier';
        throw IllegalStateException_init_$Create$(toString_1(tmp4_error_0_45_55));
      } else {
      }
      $composer_1_44_54.startNode_2();
      if ($composer_1_44_54._get_inserting__0()) {
        $composer_1_44_54.createNode_0(tmp6_ComposeDomNode$composable_0_22_32);
      } else {
        $composer_1_44_54.useNode_0();
      }
      var tmp5_apply_0_47_57 = _SkippableUpdater___init__impl_($composer_1_44_54);
      tmp7_ComposeDomNode$composable_0_26_36(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 3);
      tmp8_ComposeDomNode$composable_0_35_45(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 6);
      var tmp0_group_2_46_56 = tmp5_apply_0_47_57;
      Unit_getInstance();
      $composer_1_44_54.startReplaceableGroup_1(2058660585);
      var tmp4__anonymous__66 = $composer_1_44_54;
      var tmp5__anonymous__66 = 8 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 14 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 9;
      var $composer_67 = tmp4__anonymous__66;
      $composer_67.startReplaceableGroup_2(1549235992, 'C34@1126L9:button.kt#a1h0r0');
      if (!((tmp5__anonymous__66 & 81 ^ 16) === 0) ? true : !$composer_67._get_skipping__0()) {
        content($composer_67, 14 & $dirty >> 6);
      } else
        $composer_67.skipToGroupEnd_2();
      $composer_67.endReplaceableGroup_0();
      $composer_1_44_54.endReplaceableGroup_0();
      $composer_1_44_54.endNode_0();
      DisposableEffect$composable(null, _no_name_provided_$factory_143(refEffect_12_22, scope_2_12), $composer_1_11, 6);
      $composer_1_11.endReplaceableGroup_0();
      $composer_3.endReplaceableGroup_0();
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_144(modifier, onClick, content, $changed));
    }
  }
  function ButtonActual$composable$lambda_0($modifier, $onClick, $content, $$changed, $composer, $force) {
    return ButtonActual$composable($modifier, $onClick, $content, $composer, $$changed | 1);
  }
  function _no_name_provided__169($onClick) {
    this._$onClick_0 = $onClick;
  }
  _no_name_provided__169.prototype.invoke_381 = function (it) {
    this._$onClick_0();
  };
  _no_name_provided__169.prototype.invoke_468 = function (p1) {
    this.invoke_381(p1 instanceof WrappedMouseEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__169.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__170($onClick) {
    this._$onClick_1 = $onClick;
  }
  _no_name_provided__170.prototype.invoke_279 = function ($this$Button) {
    $this$Button.onClick$default_0(null, _no_name_provided_$factory_145(this._$onClick_1), 1, null);
  };
  _no_name_provided__170.prototype.invoke_468 = function (p1) {
    this.invoke_279(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__170.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__171() {
  }
  _no_name_provided__171.prototype.invoke_279 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__171.prototype.invoke_468 = function (p1) {
    this.invoke_279(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__171.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__172() {
  }
  _no_name_provided__172.prototype.invoke_467 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__172.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__172.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__173($tmp0_TagElement$composable_0_6, $scope_2_12) {
    this._$tmp0_TagElement$composable_0_6_0 = $tmp0_TagElement$composable_0_6;
    this._$scope_2_12_1 = $scope_2_12;
  }
  _no_name_provided__173.prototype.invoke_452 = function () {
    var tmp0_also_0_24_34 = new DomNodeWrapper(document.createElement(this._$tmp0_TagElement$composable_0_6_0));
    var tmp0_unsafeCast_0_2_25_35 = tmp0_also_0_24_34._node_1;
    this._$scope_2_12_1._set_element_(tmp0_unsafeCast_0_2_25_35);
    return tmp0_also_0_24_34;
  };
  _no_name_provided__173.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__174($boundThis) {
    this._$boundThis_10 = $boundThis;
  }
  _no_name_provided__174.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_10.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__174.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__174.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__175($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    this._$tmp1_TagElement$composable_0_7_0 = $tmp1_TagElement$composable_0_7;
    this._$refEffect_12_22_1 = $refEffect_12_22;
  }
  _no_name_provided__175.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_28_38 = $composer;
    var $dirty_29_39 = $changed;
    if (($changed & 14) === 0)
      $dirty_29_39 = $dirty_29_39 | ($composer_28_38.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_29_39 & 91 ^ 18) === 0) ? true : !$composer_28_38._get_skipping__0()) {
      var tmp0_also_0_31_41 = new AttrsBuilder();
      this._$tmp1_TagElement$composable_0_7_0(tmp0_also_0_31_41);
      var attrsApplied_30_40 = tmp0_also_0_31_41;
      this._$refEffect_12_22_1._effect_0 = attrsApplied_30_40._refEffect;
      var attrsCollected_32_42 = attrsApplied_30_40.collect();
      var events_33_43 = attrsApplied_30_40.asList_0();
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_34_44 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsCollected_32_42, Companion_getInstance_19()._UpdateAttrs);
      Updater__set_impl(tmp1__anonymous__1_34_44, events_33_43, Companion_getInstance_19()._UpdateListeners);
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsApplied_30_40._propertyUpdates, Companion_getInstance_19()._UpdateProperties);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_28_38.skipToGroupEnd_2();
  };
  _no_name_provided__175.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__175.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__176($boundThis) {
    this._$boundThis_11 = $boundThis;
  }
  _no_name_provided__176.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_11.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__176.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__176.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__177($tmp2_TagElement$composable_0_8) {
    this._$tmp2_TagElement$composable_0_8_0 = $tmp2_TagElement$composable_0_8;
  }
  _no_name_provided__177.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_37_47 = $composer;
    var $dirty_38_48 = $changed;
    if (($changed & 14) === 0)
      $dirty_38_48 = $dirty_38_48 | ($composer_37_47.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_38_48 & 91 ^ 18) === 0) ? true : !$composer_37_47._get_skipping__0()) {
      var tmp0_apply_0_40_50 = new StyleBuilderImpl();
      this._$tmp2_TagElement$composable_0_8_0(tmp0_apply_0_40_50);
      var style_39_49 = tmp0_apply_0_40_50;
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_41_51 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_41_51, style_39_49, Companion_getInstance_19()._UpdateStyleDeclarations);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_37_47.skipToGroupEnd_2();
  };
  _no_name_provided__177.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__177.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_51_61_0() {
  }
  _no_name_provided__1_51_61_0.prototype.dispose_2_52_62_3 = function () {
    Unit_getInstance();
  };
  _no_name_provided__1_51_61_0.prototype.dispose_20 = function () {
    return this.dispose_2_52_62_3();
  };
  _no_name_provided__1_51_61_0.$metadata$ = {
    simpleName: '<no name provided>_1_51_61',
    kind: 'class',
    interfaces: [DisposableEffectResult]
  };
  function _no_name_provided__178($refEffect_12_22, $scope_2_12) {
    this._$refEffect_12_22_2 = $refEffect_12_22;
    this._$scope_2_12_2 = $scope_2_12;
  }
  _no_name_provided__178.prototype.invoke_463 = function ($this$DisposableEffect) {
    var tmp0_safe_receiver_50_60 = this._$refEffect_12_22_2._effect_0;
    var tmp1_elvis_lhs_49_59 = tmp0_safe_receiver_50_60 == null ? null : tmp0_safe_receiver_50_60($this$DisposableEffect, this._$scope_2_12_2._get_element__0());
    var tmp;
    if (tmp1_elvis_lhs_49_59 == null) {
      tmp = new _no_name_provided__1_51_61_0();
    } else {
      tmp = tmp1_elvis_lhs_49_59;
    }
    return tmp;
  };
  _no_name_provided__178.prototype.invoke_468 = function (p1) {
    return this.invoke_463(p1 instanceof DisposableEffectScope ? p1 : THROW_CCE());
  };
  _no_name_provided__178.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__179($modifier, $onClick, $content, $$changed) {
    this._$modifier_6 = $modifier;
    this._$onClick_2 = $onClick;
    this._$content_5 = $content;
    this._$$changed_7 = $$changed;
  }
  _no_name_provided__179.prototype.invoke_444 = function (p0, p1) {
    return ButtonActual$composable$lambda_0(this._$modifier_6, this._$onClick_2, this._$content_5, this._$$changed_7, p0, p1);
  };
  _no_name_provided__179.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__179.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_135($onClick) {
    var i = new _no_name_provided__170($onClick);
    return function (p1) {
      i.invoke_279(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_136() {
    var i = new _no_name_provided__171();
    return function (p1) {
      i.invoke_279(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_137() {
    var i = new _no_name_provided__172();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_138($tmp0_TagElement$composable_0_6, $scope_2_12) {
    var i = new _no_name_provided__173($tmp0_TagElement$composable_0_6, $scope_2_12);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_139($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    var i = new _no_name_provided__175($tmp1_TagElement$composable_0_7, $refEffect_12_22);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_140($boundThis) {
    var i = new _no_name_provided__174($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_141($tmp2_TagElement$composable_0_8) {
    var i = new _no_name_provided__177($tmp2_TagElement$composable_0_8);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_142($boundThis) {
    var i = new _no_name_provided__176($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_143($refEffect_12_22, $scope_2_12) {
    var i = new _no_name_provided__178($refEffect_12_22, $scope_2_12);
    return function (p1) {
      return i.invoke_463(p1);
    };
  }
  function _no_name_provided_$factory_144($modifier, $onClick, $content, $$changed) {
    var i = new _no_name_provided__179($modifier, $onClick, $content, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_145($onClick) {
    var i = new _no_name_provided__169($onClick);
    return function (p1) {
      i.invoke_381(p1);
      return Unit_getInstance();
    };
  }
  function ColumnActual$composable(modifier, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(1170134507, 'C(ColumnActual$composable)P(1)26@1014L154:column.kt#kxwuio');
    var $dirty = $changed;
    if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 32 : 16);
    if (!(($dirty & 91 ^ 18) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_Div$composable_0 = _no_name_provided_$factory_146();
      var tmp1_Div$composable_0 = asStyleBuilderApplier$default(modifier, null, 1, null);
      var tmp2_Div$composable_0 = $composer_0;
      var tmp3_Div$composable_0 = 0;
      var tmp4_Div$composable_0 = 0;
      var attrs_1 = tmp0_Div$composable_0;
      var style_2 = tmp1_Div$composable_0;
      var $composer_3 = tmp2_Div$composable_0;
      $composer_3.startReplaceableGroup_2(1874023935, 'C(Div$composable)P(!1,2)70@2500L124:Elements.kt#mzr94e');
      if (!((tmp4_Div$composable_0 & 1) === 0)) {
        attrs_1 = _no_name_provided_$factory_147();
      }if (!((tmp4_Div$composable_0 & 2) === 0)) {
        style_2 = _no_name_provided_$factory_148();
      }var tmp0_TagElement$composable_0_6 = 'div';
      var tmp1_TagElement$composable_0_7 = attrs_1;
      var tmp2_TagElement$composable_0_8 = style_2;
      var tmp3_TagElement$composable_0_9 = $composer_3;
      var tmp4_TagElement$composable_0_10 = 6 | 112 & tmp3_Div$composable_0 << 3 | 896 & tmp3_Div$composable_0 << 3 | 7168 & tmp3_Div$composable_0 << 3;
      var $composer_1_11 = tmp3_TagElement$composable_0_9;
      $composer_1_11.startReplaceableGroup_2(-1134585235, 'C(TagElement$composable)P(3)76@2833L45,77@2899L37,79@2942L1040,107@3988L100:Base.kt#mzr94e');
      var tmp0_remember$composable_0_3_13 = $composer_1_11;
      var tmp1_remember$composable_0_4_14 = 0;
      var $composer_1_5_15 = tmp0_remember$composable_0_3_13;
      $composer_1_5_15.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_7_17 = $composer_1_5_15;
      var tmp2_cache_0_4_8_18 = false;
      var tmp0_let_0_5_9_19 = tmp1_cache_0_3_7_17.rememberedValue_0();
      var tmp;
      if (tmp2_cache_0_4_8_18 ? true : tmp0_let_0_5_9_19 === Companion_getInstance_11()._Empty) {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_return_8_11_21 = new ElementScopeImpl();
          tmp$ret$0 = tmp0_return_8_11_21;
          break l$ret$1;
        }
         while (false);
        var value_2_2_6_10_20 = tmp$ret$0;
        tmp1_cache_0_3_7_17.updateRememberedValue_0(value_2_2_6_10_20);
        tmp = value_2_2_6_10_20;
      } else {
        tmp = tmp0_let_0_5_9_19;
      }
      var tmp_0 = tmp;
      var tmp0_2_6_16 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      $composer_1_5_15.endReplaceableGroup_0();
      var scope_2_12 = tmp0_2_6_16;
      var tmp2_remember$composable_0_13_23 = $composer_1_11;
      var tmp3_remember$composable_0_14_24 = 0;
      var $composer_1_15_25 = tmp2_remember$composable_0_13_23;
      $composer_1_15_25.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_17_27 = $composer_1_15_25;
      var tmp2_cache_0_4_18_28 = false;
      var tmp0_let_0_5_19_29 = tmp1_cache_0_3_17_27.rememberedValue_0();
      var tmp_1;
      if (tmp2_cache_0_4_18_28 ? true : tmp0_let_0_5_19_29 === Companion_getInstance_11()._Empty) {
        var tmp$ret$2;
        l$ret$3: do {
          var tmp0_return_8_21_31 = DisposableEffectHolder_init_$Create$(null, 1, null);
          tmp$ret$2 = tmp0_return_8_21_31;
          break l$ret$3;
        }
         while (false);
        var value_2_2_6_20_30 = tmp$ret$2;
        tmp1_cache_0_3_17_27.updateRememberedValue_0(value_2_2_6_20_30);
        tmp_1 = value_2_2_6_20_30;
      } else {
        tmp_1 = tmp0_let_0_5_19_29;
      }
      var tmp_2 = tmp_1;
      var tmp0_2_16_26 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
      $composer_1_15_25.endReplaceableGroup_0();
      var refEffect_12_22 = tmp0_2_16_26;
      var tmp6_ComposeDomNode$composable_0_22_32 = _no_name_provided_$factory_149(tmp0_TagElement$composable_0_6, scope_2_12);
      var tmp_3 = $composer_1_11;
      var tmp7_ComposeDomNode$composable_0_26_36 = _no_name_provided_$factory_151(composableLambda(tmp_3, -819893738, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_150(tmp1_TagElement$composable_0_7, refEffect_12_22)));
      var tmp_4 = $composer_1_11;
      var tmp8_ComposeDomNode$composable_0_35_45 = _no_name_provided_$factory_153(composableLambda(tmp_4, -819894225, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_152(tmp2_TagElement$composable_0_8)));
      var tmp9_ComposeDomNode$composable_0_42_52 = $composer_1_11;
      var tmp10_ComposeDomNode$composable_0_43_53 = 64 | 57344 & tmp4_TagElement$composable_0_10 << 3;
      var $composer_1_44_54 = tmp9_ComposeDomNode$composable_0_42_52;
      var tmp_5 = $composer_1_44_54._get_applier__0();
      if (!(tmp_5 instanceof DomApplier)) {
        var tmp4_error_0_45_55 = 'Invalid applier';
        throw IllegalStateException_init_$Create$(toString_1(tmp4_error_0_45_55));
      } else {
      }
      $composer_1_44_54.startNode_2();
      if ($composer_1_44_54._get_inserting__0()) {
        $composer_1_44_54.createNode_0(tmp6_ComposeDomNode$composable_0_22_32);
      } else {
        $composer_1_44_54.useNode_0();
      }
      var tmp5_apply_0_47_57 = _SkippableUpdater___init__impl_($composer_1_44_54);
      tmp7_ComposeDomNode$composable_0_26_36(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 3);
      tmp8_ComposeDomNode$composable_0_35_45(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 6);
      var tmp0_group_2_46_56 = tmp5_apply_0_47_57;
      Unit_getInstance();
      $composer_1_44_54.startReplaceableGroup_1(2058660585);
      var tmp5__anonymous__66 = $composer_1_44_54;
      var tmp6__anonymous__66 = 8 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 14 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 9;
      var $composer_67 = tmp5__anonymous__66;
      $composer_67.startReplaceableGroup_2(1548713827, 'C32@1153L9:column.kt#kxwuio');
      if (!((tmp6__anonymous__66 & 81 ^ 16) === 0) ? true : !$composer_67._get_skipping__0()) {
        content($composer_67, 14 & $dirty >> 3);
      } else
        $composer_67.skipToGroupEnd_2();
      $composer_67.endReplaceableGroup_0();
      $composer_1_44_54.endReplaceableGroup_0();
      $composer_1_44_54.endNode_0();
      DisposableEffect$composable(null, _no_name_provided_$factory_154(refEffect_12_22, scope_2_12), $composer_1_11, 6);
      $composer_1_11.endReplaceableGroup_0();
      $composer_3.endReplaceableGroup_0();
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_155(modifier, content, $changed));
    }
  }
  function ColumnActual$composable$lambda_0($modifier, $content, $$changed, $composer, $force) {
    return ColumnActual$composable($modifier, $content, $composer, $$changed | 1);
  }
  function _no_name_provided__180() {
  }
  _no_name_provided__180.prototype.invoke_317 = function ($this$Div) {
    $this$Div.classes([Styles_getInstance()._columnClass]);
  };
  _no_name_provided__180.prototype.invoke_468 = function (p1) {
    this.invoke_317(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__180.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__181() {
  }
  _no_name_provided__181.prototype.invoke_317 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__181.prototype.invoke_468 = function (p1) {
    this.invoke_317(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__181.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__182() {
  }
  _no_name_provided__182.prototype.invoke_467 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__182.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__182.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__183($tmp0_TagElement$composable_0_6, $scope_2_12) {
    this._$tmp0_TagElement$composable_0_6_1 = $tmp0_TagElement$composable_0_6;
    this._$scope_2_12_3 = $scope_2_12;
  }
  _no_name_provided__183.prototype.invoke_452 = function () {
    var tmp0_also_0_24_34 = new DomNodeWrapper(document.createElement(this._$tmp0_TagElement$composable_0_6_1));
    var tmp0_unsafeCast_0_2_25_35 = tmp0_also_0_24_34._node_1;
    this._$scope_2_12_3._set_element_(tmp0_unsafeCast_0_2_25_35);
    return tmp0_also_0_24_34;
  };
  _no_name_provided__183.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__184($boundThis) {
    this._$boundThis_12 = $boundThis;
  }
  _no_name_provided__184.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_12.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__184.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__184.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__185($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    this._$tmp1_TagElement$composable_0_7_1 = $tmp1_TagElement$composable_0_7;
    this._$refEffect_12_22_3 = $refEffect_12_22;
  }
  _no_name_provided__185.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_28_38 = $composer;
    var $dirty_29_39 = $changed;
    if (($changed & 14) === 0)
      $dirty_29_39 = $dirty_29_39 | ($composer_28_38.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_29_39 & 91 ^ 18) === 0) ? true : !$composer_28_38._get_skipping__0()) {
      var tmp0_also_0_31_41 = new AttrsBuilder();
      this._$tmp1_TagElement$composable_0_7_1(tmp0_also_0_31_41);
      var attrsApplied_30_40 = tmp0_also_0_31_41;
      this._$refEffect_12_22_3._effect_0 = attrsApplied_30_40._refEffect;
      var attrsCollected_32_42 = attrsApplied_30_40.collect();
      var events_33_43 = attrsApplied_30_40.asList_0();
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_34_44 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsCollected_32_42, Companion_getInstance_19()._UpdateAttrs);
      Updater__set_impl(tmp1__anonymous__1_34_44, events_33_43, Companion_getInstance_19()._UpdateListeners);
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsApplied_30_40._propertyUpdates, Companion_getInstance_19()._UpdateProperties);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_28_38.skipToGroupEnd_2();
  };
  _no_name_provided__185.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__185.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__186($boundThis) {
    this._$boundThis_13 = $boundThis;
  }
  _no_name_provided__186.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_13.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__186.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__186.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__187($tmp2_TagElement$composable_0_8) {
    this._$tmp2_TagElement$composable_0_8_1 = $tmp2_TagElement$composable_0_8;
  }
  _no_name_provided__187.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_37_47 = $composer;
    var $dirty_38_48 = $changed;
    if (($changed & 14) === 0)
      $dirty_38_48 = $dirty_38_48 | ($composer_37_47.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_38_48 & 91 ^ 18) === 0) ? true : !$composer_37_47._get_skipping__0()) {
      var tmp0_apply_0_40_50 = new StyleBuilderImpl();
      this._$tmp2_TagElement$composable_0_8_1(tmp0_apply_0_40_50);
      var style_39_49 = tmp0_apply_0_40_50;
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_41_51 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_41_51, style_39_49, Companion_getInstance_19()._UpdateStyleDeclarations);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_37_47.skipToGroupEnd_2();
  };
  _no_name_provided__187.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__187.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_51_61_1() {
  }
  _no_name_provided__1_51_61_1.prototype.dispose_2_52_62_3 = function () {
    Unit_getInstance();
  };
  _no_name_provided__1_51_61_1.prototype.dispose_20 = function () {
    return this.dispose_2_52_62_3();
  };
  _no_name_provided__1_51_61_1.$metadata$ = {
    simpleName: '<no name provided>_1_51_61',
    kind: 'class',
    interfaces: [DisposableEffectResult]
  };
  function _no_name_provided__188($refEffect_12_22, $scope_2_12) {
    this._$refEffect_12_22_4 = $refEffect_12_22;
    this._$scope_2_12_4 = $scope_2_12;
  }
  _no_name_provided__188.prototype.invoke_463 = function ($this$DisposableEffect) {
    var tmp0_safe_receiver_50_60 = this._$refEffect_12_22_4._effect_0;
    var tmp1_elvis_lhs_49_59 = tmp0_safe_receiver_50_60 == null ? null : tmp0_safe_receiver_50_60($this$DisposableEffect, this._$scope_2_12_4._get_element__0());
    var tmp;
    if (tmp1_elvis_lhs_49_59 == null) {
      tmp = new _no_name_provided__1_51_61_1();
    } else {
      tmp = tmp1_elvis_lhs_49_59;
    }
    return tmp;
  };
  _no_name_provided__188.prototype.invoke_468 = function (p1) {
    return this.invoke_463(p1 instanceof DisposableEffectScope ? p1 : THROW_CCE());
  };
  _no_name_provided__188.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__189($modifier, $content, $$changed) {
    this._$modifier_7 = $modifier;
    this._$content_6 = $content;
    this._$$changed_8 = $$changed;
  }
  _no_name_provided__189.prototype.invoke_444 = function (p0, p1) {
    return ColumnActual$composable$lambda_0(this._$modifier_7, this._$content_6, this._$$changed_8, p0, p1);
  };
  _no_name_provided__189.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__189.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_146() {
    var i = new _no_name_provided__180();
    return function (p1) {
      i.invoke_317(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_147() {
    var i = new _no_name_provided__181();
    return function (p1) {
      i.invoke_317(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_148() {
    var i = new _no_name_provided__182();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_149($tmp0_TagElement$composable_0_6, $scope_2_12) {
    var i = new _no_name_provided__183($tmp0_TagElement$composable_0_6, $scope_2_12);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_150($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    var i = new _no_name_provided__185($tmp1_TagElement$composable_0_7, $refEffect_12_22);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_151($boundThis) {
    var i = new _no_name_provided__184($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_152($tmp2_TagElement$composable_0_8) {
    var i = new _no_name_provided__187($tmp2_TagElement$composable_0_8);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_153($boundThis) {
    var i = new _no_name_provided__186($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_154($refEffect_12_22, $scope_2_12) {
    var i = new _no_name_provided__188($refEffect_12_22, $scope_2_12);
    return function (p1) {
      return i.invoke_463(p1);
    };
  }
  function _no_name_provided_$factory_155($modifier, $content, $$changed) {
    var i = new _no_name_provided__189($modifier, $content, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function RowActual$composable(modifier, horizontalArrangement, verticalAlignment, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(257174652, 'C(RowActual$composable)P(2,1,3)43@1604L339:row.kt#kxwuio');
    var $dirty = $changed;
    if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(horizontalArrangement) ? 32 : 16);
    if (($changed & 896) === 0)
      $dirty = $dirty | ($composer_0.changed_2(verticalAlignment) ? 256 : 128);
    if (($changed & 7168) === 0)
      $dirty = $dirty | ($composer_0.changed_2(content) ? 2048 : 1024);
    if (!(($dirty & 5851 ^ 1170) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_Div$composable_0 = _no_name_provided_$factory_156(horizontalArrangement, verticalAlignment);
      var tmp1_Div$composable_0 = asStyleBuilderApplier$default(modifier, null, 1, null);
      var tmp2_Div$composable_0 = $composer_0;
      var tmp3_Div$composable_0 = 0;
      var tmp4_Div$composable_0 = 0;
      var attrs_1 = tmp0_Div$composable_0;
      var style_2 = tmp1_Div$composable_0;
      var $composer_3 = tmp2_Div$composable_0;
      $composer_3.startReplaceableGroup_2(1874023935, 'C(Div$composable)P(!1,2)70@2500L124:Elements.kt#mzr94e');
      if (!((tmp4_Div$composable_0 & 1) === 0)) {
        attrs_1 = _no_name_provided_$factory_157();
      }if (!((tmp4_Div$composable_0 & 2) === 0)) {
        style_2 = _no_name_provided_$factory_158();
      }var tmp0_TagElement$composable_0_6 = 'div';
      var tmp1_TagElement$composable_0_7 = attrs_1;
      var tmp2_TagElement$composable_0_8 = style_2;
      var tmp3_TagElement$composable_0_9 = $composer_3;
      var tmp4_TagElement$composable_0_10 = 6 | 112 & tmp3_Div$composable_0 << 3 | 896 & tmp3_Div$composable_0 << 3 | 7168 & tmp3_Div$composable_0 << 3;
      var $composer_1_11 = tmp3_TagElement$composable_0_9;
      $composer_1_11.startReplaceableGroup_2(-1134585235, 'C(TagElement$composable)P(3)76@2833L45,77@2899L37,79@2942L1040,107@3988L100:Base.kt#mzr94e');
      var tmp0_remember$composable_0_3_13 = $composer_1_11;
      var tmp1_remember$composable_0_4_14 = 0;
      var $composer_1_5_15 = tmp0_remember$composable_0_3_13;
      $composer_1_5_15.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_7_17 = $composer_1_5_15;
      var tmp2_cache_0_4_8_18 = false;
      var tmp0_let_0_5_9_19 = tmp1_cache_0_3_7_17.rememberedValue_0();
      var tmp;
      if (tmp2_cache_0_4_8_18 ? true : tmp0_let_0_5_9_19 === Companion_getInstance_11()._Empty) {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_return_8_11_21 = new ElementScopeImpl();
          tmp$ret$0 = tmp0_return_8_11_21;
          break l$ret$1;
        }
         while (false);
        var value_2_2_6_10_20 = tmp$ret$0;
        tmp1_cache_0_3_7_17.updateRememberedValue_0(value_2_2_6_10_20);
        tmp = value_2_2_6_10_20;
      } else {
        tmp = tmp0_let_0_5_9_19;
      }
      var tmp_0 = tmp;
      var tmp0_2_6_16 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      $composer_1_5_15.endReplaceableGroup_0();
      var scope_2_12 = tmp0_2_6_16;
      var tmp2_remember$composable_0_13_23 = $composer_1_11;
      var tmp3_remember$composable_0_14_24 = 0;
      var $composer_1_15_25 = tmp2_remember$composable_0_13_23;
      $composer_1_15_25.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_17_27 = $composer_1_15_25;
      var tmp2_cache_0_4_18_28 = false;
      var tmp0_let_0_5_19_29 = tmp1_cache_0_3_17_27.rememberedValue_0();
      var tmp_1;
      if (tmp2_cache_0_4_18_28 ? true : tmp0_let_0_5_19_29 === Companion_getInstance_11()._Empty) {
        var tmp$ret$2;
        l$ret$3: do {
          var tmp0_return_8_21_31 = DisposableEffectHolder_init_$Create$(null, 1, null);
          tmp$ret$2 = tmp0_return_8_21_31;
          break l$ret$3;
        }
         while (false);
        var value_2_2_6_20_30 = tmp$ret$2;
        tmp1_cache_0_3_17_27.updateRememberedValue_0(value_2_2_6_20_30);
        tmp_1 = value_2_2_6_20_30;
      } else {
        tmp_1 = tmp0_let_0_5_19_29;
      }
      var tmp_2 = tmp_1;
      var tmp0_2_16_26 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
      $composer_1_15_25.endReplaceableGroup_0();
      var refEffect_12_22 = tmp0_2_16_26;
      var tmp6_ComposeDomNode$composable_0_22_32 = _no_name_provided_$factory_159(tmp0_TagElement$composable_0_6, scope_2_12);
      var tmp_3 = $composer_1_11;
      var tmp7_ComposeDomNode$composable_0_26_36 = _no_name_provided_$factory_161(composableLambda(tmp_3, -819893738, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_160(tmp1_TagElement$composable_0_7, refEffect_12_22)));
      var tmp_4 = $composer_1_11;
      var tmp8_ComposeDomNode$composable_0_35_45 = _no_name_provided_$factory_163(composableLambda(tmp_4, -819894225, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_162(tmp2_TagElement$composable_0_8)));
      var tmp9_ComposeDomNode$composable_0_42_52 = $composer_1_11;
      var tmp10_ComposeDomNode$composable_0_43_53 = 64 | 57344 & tmp4_TagElement$composable_0_10 << 3;
      var $composer_1_44_54 = tmp9_ComposeDomNode$composable_0_42_52;
      var tmp_5 = $composer_1_44_54._get_applier__0();
      if (!(tmp_5 instanceof DomApplier)) {
        var tmp4_error_0_45_55 = 'Invalid applier';
        throw IllegalStateException_init_$Create$(toString_1(tmp4_error_0_45_55));
      } else {
      }
      $composer_1_44_54.startNode_2();
      if ($composer_1_44_54._get_inserting__0()) {
        $composer_1_44_54.createNode_0(tmp6_ComposeDomNode$composable_0_22_32);
      } else {
        $composer_1_44_54.useNode_0();
      }
      var tmp5_apply_0_47_57 = _SkippableUpdater___init__impl_($composer_1_44_54);
      tmp7_ComposeDomNode$composable_0_26_36(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 3);
      tmp8_ComposeDomNode$composable_0_35_45(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 6);
      var tmp0_group_2_46_56 = tmp5_apply_0_47_57;
      Unit_getInstance();
      $composer_1_44_54.startReplaceableGroup_1(2058660585);
      var tmp5__anonymous__66 = $composer_1_44_54;
      var tmp6__anonymous__66 = 8 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 14 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 9;
      var $composer_67 = tmp5__anonymous__66;
      $composer_67.startReplaceableGroup_2(-226288878, 'C55@1928L9:row.kt#kxwuio');
      if (!((tmp6__anonymous__66 & 81 ^ 16) === 0) ? true : !$composer_67._get_skipping__0()) {
        content($composer_67, 14 & $dirty >> 9);
      } else
        $composer_67.skipToGroupEnd_2();
      $composer_67.endReplaceableGroup_0();
      $composer_1_44_54.endReplaceableGroup_0();
      $composer_1_44_54.endNode_0();
      DisposableEffect$composable(null, _no_name_provided_$factory_164(refEffect_12_22, scope_2_12), $composer_1_11, 6);
      $composer_1_11.endReplaceableGroup_0();
      $composer_3.endReplaceableGroup_0();
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_165(modifier, horizontalArrangement, verticalAlignment, content, $changed));
    }
  }
  function asClassName(_this_) {
    var tmp0_subject = _this_;
    return equals(tmp0_subject, Arrangement_getInstance()._End_0) ? Styles_getInstance()._get_composeWebArrangementHorizontalEnd_() : Styles_getInstance()._get_composeWebArrangementHorizontalStart_();
  }
  function asClassName_0(_this_) {
    var tmp0_subject = _this_;
    return equals(tmp0_subject, Companion_getInstance_15()._Top) ? Styles_getInstance()._get_composeWebAlignmentVerticalTop_() : equals(tmp0_subject, Companion_getInstance_15()._CenterVertically) ? Styles_getInstance()._get_composeWebAlignmentVerticalCenter_() : Styles_getInstance()._get_composeWebAlignmentVerticalBottom_();
  }
  function RowActual$composable$lambda_0($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed, $composer, $force) {
    return RowActual$composable($modifier, $horizontalArrangement, $verticalAlignment, $content, $composer, $$changed | 1);
  }
  function _no_name_provided__190($horizontalArrangement, $verticalAlignment) {
    this._$horizontalArrangement_0 = $horizontalArrangement;
    this._$verticalAlignment_0 = $verticalAlignment;
  }
  _no_name_provided__190.prototype.invoke_317 = function ($this$Div) {
    var tmp0_arrayOf_0 = [Styles_getInstance()._get_rowClass_(), asClassName(this._$horizontalArrangement_0), asClassName_0(this._$verticalAlignment_0)];
    $this$Div.classes(tmp0_arrayOf_0.slice());
  };
  _no_name_provided__190.prototype.invoke_468 = function (p1) {
    this.invoke_317(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__190.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__191() {
  }
  _no_name_provided__191.prototype.invoke_317 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__191.prototype.invoke_468 = function (p1) {
    this.invoke_317(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__191.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__192() {
  }
  _no_name_provided__192.prototype.invoke_467 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__192.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__192.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__193($tmp0_TagElement$composable_0_6, $scope_2_12) {
    this._$tmp0_TagElement$composable_0_6_2 = $tmp0_TagElement$composable_0_6;
    this._$scope_2_12_5 = $scope_2_12;
  }
  _no_name_provided__193.prototype.invoke_452 = function () {
    var tmp0_also_0_24_34 = new DomNodeWrapper(document.createElement(this._$tmp0_TagElement$composable_0_6_2));
    var tmp0_unsafeCast_0_2_25_35 = tmp0_also_0_24_34._node_1;
    this._$scope_2_12_5._set_element_(tmp0_unsafeCast_0_2_25_35);
    return tmp0_also_0_24_34;
  };
  _no_name_provided__193.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__194($boundThis) {
    this._$boundThis_14 = $boundThis;
  }
  _no_name_provided__194.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_14.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__194.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__194.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__195($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    this._$tmp1_TagElement$composable_0_7_2 = $tmp1_TagElement$composable_0_7;
    this._$refEffect_12_22_5 = $refEffect_12_22;
  }
  _no_name_provided__195.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_28_38 = $composer;
    var $dirty_29_39 = $changed;
    if (($changed & 14) === 0)
      $dirty_29_39 = $dirty_29_39 | ($composer_28_38.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_29_39 & 91 ^ 18) === 0) ? true : !$composer_28_38._get_skipping__0()) {
      var tmp0_also_0_31_41 = new AttrsBuilder();
      this._$tmp1_TagElement$composable_0_7_2(tmp0_also_0_31_41);
      var attrsApplied_30_40 = tmp0_also_0_31_41;
      this._$refEffect_12_22_5._effect_0 = attrsApplied_30_40._refEffect;
      var attrsCollected_32_42 = attrsApplied_30_40.collect();
      var events_33_43 = attrsApplied_30_40.asList_0();
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_34_44 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsCollected_32_42, Companion_getInstance_19()._UpdateAttrs);
      Updater__set_impl(tmp1__anonymous__1_34_44, events_33_43, Companion_getInstance_19()._UpdateListeners);
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsApplied_30_40._propertyUpdates, Companion_getInstance_19()._UpdateProperties);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_28_38.skipToGroupEnd_2();
  };
  _no_name_provided__195.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__195.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__196($boundThis) {
    this._$boundThis_15 = $boundThis;
  }
  _no_name_provided__196.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_15.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__196.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__196.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__197($tmp2_TagElement$composable_0_8) {
    this._$tmp2_TagElement$composable_0_8_2 = $tmp2_TagElement$composable_0_8;
  }
  _no_name_provided__197.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_37_47 = $composer;
    var $dirty_38_48 = $changed;
    if (($changed & 14) === 0)
      $dirty_38_48 = $dirty_38_48 | ($composer_37_47.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_38_48 & 91 ^ 18) === 0) ? true : !$composer_37_47._get_skipping__0()) {
      var tmp0_apply_0_40_50 = new StyleBuilderImpl();
      this._$tmp2_TagElement$composable_0_8_2(tmp0_apply_0_40_50);
      var style_39_49 = tmp0_apply_0_40_50;
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_41_51 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_41_51, style_39_49, Companion_getInstance_19()._UpdateStyleDeclarations);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_37_47.skipToGroupEnd_2();
  };
  _no_name_provided__197.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__197.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_51_61_2() {
  }
  _no_name_provided__1_51_61_2.prototype.dispose_2_52_62_3 = function () {
    Unit_getInstance();
  };
  _no_name_provided__1_51_61_2.prototype.dispose_20 = function () {
    return this.dispose_2_52_62_3();
  };
  _no_name_provided__1_51_61_2.$metadata$ = {
    simpleName: '<no name provided>_1_51_61',
    kind: 'class',
    interfaces: [DisposableEffectResult]
  };
  function _no_name_provided__198($refEffect_12_22, $scope_2_12) {
    this._$refEffect_12_22_6 = $refEffect_12_22;
    this._$scope_2_12_6 = $scope_2_12;
  }
  _no_name_provided__198.prototype.invoke_463 = function ($this$DisposableEffect) {
    var tmp0_safe_receiver_50_60 = this._$refEffect_12_22_6._effect_0;
    var tmp1_elvis_lhs_49_59 = tmp0_safe_receiver_50_60 == null ? null : tmp0_safe_receiver_50_60($this$DisposableEffect, this._$scope_2_12_6._get_element__0());
    var tmp;
    if (tmp1_elvis_lhs_49_59 == null) {
      tmp = new _no_name_provided__1_51_61_2();
    } else {
      tmp = tmp1_elvis_lhs_49_59;
    }
    return tmp;
  };
  _no_name_provided__198.prototype.invoke_468 = function (p1) {
    return this.invoke_463(p1 instanceof DisposableEffectScope ? p1 : THROW_CCE());
  };
  _no_name_provided__198.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__199($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed) {
    this._$modifier_8 = $modifier;
    this._$horizontalArrangement_1 = $horizontalArrangement;
    this._$verticalAlignment_1 = $verticalAlignment;
    this._$content_7 = $content;
    this._$$changed_9 = $$changed;
  }
  _no_name_provided__199.prototype.invoke_444 = function (p0, p1) {
    return RowActual$composable$lambda_0(this._$modifier_8, this._$horizontalArrangement_1, this._$verticalAlignment_1, this._$content_7, this._$$changed_9, p0, p1);
  };
  _no_name_provided__199.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__199.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_156($horizontalArrangement, $verticalAlignment) {
    var i = new _no_name_provided__190($horizontalArrangement, $verticalAlignment);
    return function (p1) {
      i.invoke_317(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_157() {
    var i = new _no_name_provided__191();
    return function (p1) {
      i.invoke_317(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_158() {
    var i = new _no_name_provided__192();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_159($tmp0_TagElement$composable_0_6, $scope_2_12) {
    var i = new _no_name_provided__193($tmp0_TagElement$composable_0_6, $scope_2_12);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_160($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    var i = new _no_name_provided__195($tmp1_TagElement$composable_0_7, $refEffect_12_22);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_161($boundThis) {
    var i = new _no_name_provided__194($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_162($tmp2_TagElement$composable_0_8) {
    var i = new _no_name_provided__197($tmp2_TagElement$composable_0_8);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_163($boundThis) {
    var i = new _no_name_provided__196($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_164($refEffect_12_22, $scope_2_12) {
    var i = new _no_name_provided__198($refEffect_12_22, $scope_2_12);
    return function (p1) {
      return i.invoke_463(p1);
    };
  }
  function _no_name_provided_$factory_165($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed) {
    var i = new _no_name_provided__199($modifier, $horizontalArrangement, $verticalAlignment, $content, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function SliderActual$composable(value_0, onValueChange, valueRange, steps, modifier, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(1879370082, 'C(SliderActual$composable)P(3,1,4,2)33@1159L428:slider.kt#a1h0r0');
    var $dirty = $changed;
    if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_4(value_0) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(onValueChange) ? 32 : 16);
    if (($changed & 896) === 0)
      $dirty = $dirty | ($composer_0.changed_2(valueRange) ? 256 : 128);
    if (($changed & 7168) === 0)
      $dirty = $dirty | ($composer_0.changed_3(steps) ? 2048 : 1024);
    if (!(($dirty & 5851 ^ 1170) === 0) ? true : !$composer_0._get_skipping__0()) {
      var stepCount = steps === 0 ? 100 : steps;
      var step_0 = (valueRange._get_endInclusive__0() - valueRange._get_start__0()) / stepCount;
      var tmp0_Input$composable_0 = Range_getInstance();
      var tmp1_Input$composable_0 = value_0.toString();
      var tmp2_Input$composable_0 = _no_name_provided_$factory_166(valueRange, step_0, onValueChange);
      var tmp3_Input$composable_0 = null;
      var tmp4_Input$composable_0 = _no_name_provided_$factory_167();
      var tmp5_Input$composable_0 = $composer_0;
      var tmp6_Input$composable_0 = 6;
      var tmp7_Input$composable_0 = 8;
      var type_1 = {_v: tmp0_Input$composable_0};
      var value_2 = {_v: tmp1_Input$composable_0};
      var attrs_3 = {_v: tmp2_Input$composable_0};
      var style_4 = Unit_getInstance();
      var content_5 = tmp4_Input$composable_0;
      var $composer_6 = tmp5_Input$composable_0;
      $composer_6.startReplaceableGroup_2(411643346, 'C(Input$composable)P(3,4!1,2)104@3367L229:Elements.kt#mzr94e');
      if (!((tmp7_Input$composable_0 & 1) === 0))
        type_1._v = Text_getInstance();
      if (!((tmp7_Input$composable_0 & 2) === 0))
        value_2._v = '';
      if (!((tmp7_Input$composable_0 & 4) === 0)) {
        attrs_3._v = _no_name_provided_$factory_168();
      }if (!((tmp7_Input$composable_0 & 8) === 0)) {
        style_4 = _no_name_provided_$factory_169();
      }if (!((tmp7_Input$composable_0 & 16) === 0))
        content_5 = ComposableSingletons$ElementsKt_getInstance()._lambda_1_0;
      var tmp0_TagElement$composable_0_9 = 'input';
      var tmp1_TagElement$composable_0_10 = style_4;
      var tmp2_TagElement$composable_0_11 = content_5;
      var tmp3_TagElement$composable_0_12 = $composer_6;
      var tmp4_TagElement$composable_0_13 = 6 | 896 & tmp6_Input$composable_0 >> 3 | 7168 & tmp6_Input$composable_0 >> 3;
      var $composer_1_14 = tmp3_TagElement$composable_0_12;
      $composer_1_14.startReplaceableGroup_2(-1134585235, 'C(TagElement$composable)P(3)76@2833L45,77@2899L37,79@2942L1040,107@3988L100:Base.kt#mzr94e');
      var tmp0_remember$composable_0_3_16 = $composer_1_14;
      var tmp1_remember$composable_0_4_17 = 0;
      var $composer_1_5_18 = tmp0_remember$composable_0_3_16;
      $composer_1_5_18.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_7_20 = $composer_1_5_18;
      var tmp2_cache_0_4_8_21 = false;
      var tmp0_let_0_5_9_22 = tmp1_cache_0_3_7_20.rememberedValue_0();
      var tmp;
      if (tmp2_cache_0_4_8_21 ? true : tmp0_let_0_5_9_22 === Companion_getInstance_11()._Empty) {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_return_8_11_24 = new ElementScopeImpl();
          tmp$ret$0 = tmp0_return_8_11_24;
          break l$ret$1;
        }
         while (false);
        var value_2_2_6_10_23 = tmp$ret$0;
        tmp1_cache_0_3_7_20.updateRememberedValue_0(value_2_2_6_10_23);
        tmp = value_2_2_6_10_23;
      } else {
        tmp = tmp0_let_0_5_9_22;
      }
      var tmp_0 = tmp;
      var tmp0_2_6_19 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      $composer_1_5_18.endReplaceableGroup_0();
      var scope_2_15 = tmp0_2_6_19;
      var tmp2_remember$composable_0_13_26 = $composer_1_14;
      var tmp3_remember$composable_0_14_27 = 0;
      var $composer_1_15_28 = tmp2_remember$composable_0_13_26;
      $composer_1_15_28.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_17_30 = $composer_1_15_28;
      var tmp2_cache_0_4_18_31 = false;
      var tmp0_let_0_5_19_32 = tmp1_cache_0_3_17_30.rememberedValue_0();
      var tmp_1;
      if (tmp2_cache_0_4_18_31 ? true : tmp0_let_0_5_19_32 === Companion_getInstance_11()._Empty) {
        var tmp$ret$2;
        l$ret$3: do {
          var tmp0_return_8_21_34 = DisposableEffectHolder_init_$Create$(null, 1, null);
          tmp$ret$2 = tmp0_return_8_21_34;
          break l$ret$3;
        }
         while (false);
        var value_2_2_6_20_33 = tmp$ret$2;
        tmp1_cache_0_3_17_30.updateRememberedValue_0(value_2_2_6_20_33);
        tmp_1 = value_2_2_6_20_33;
      } else {
        tmp_1 = tmp0_let_0_5_19_32;
      }
      var tmp_2 = tmp_1;
      var tmp0_2_16_29 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
      $composer_1_15_28.endReplaceableGroup_0();
      var refEffect_12_25 = tmp0_2_16_29;
      var tmp6_ComposeDomNode$composable_0_22_35 = _no_name_provided_$factory_170(tmp0_TagElement$composable_0_9, scope_2_15);
      var tmp_3 = $composer_1_14;
      var tmp7_ComposeDomNode$composable_0_26_39 = _no_name_provided_$factory_172(composableLambda(tmp_3, -819893738, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_171(type_1, value_2, attrs_3, refEffect_12_25)));
      var tmp_4 = $composer_1_14;
      var tmp8_ComposeDomNode$composable_0_35_48 = _no_name_provided_$factory_174(composableLambda(tmp_4, -819894225, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_173(tmp1_TagElement$composable_0_10)));
      var tmp9_ComposeDomNode$composable_0_42_55 = $composer_1_14;
      var tmp10_ComposeDomNode$composable_0_43_56 = 64 | 57344 & tmp4_TagElement$composable_0_13 << 3;
      var $composer_1_44_57 = tmp9_ComposeDomNode$composable_0_42_55;
      var tmp_5 = $composer_1_44_57._get_applier__0();
      if (!(tmp_5 instanceof DomApplier)) {
        var tmp4_error_0_45_58 = 'Invalid applier';
        throw IllegalStateException_init_$Create$(toString_1(tmp4_error_0_45_58));
      } else {
      }
      $composer_1_44_57.startNode_2();
      if ($composer_1_44_57._get_inserting__0()) {
        $composer_1_44_57.createNode_0(tmp6_ComposeDomNode$composable_0_22_35);
      } else {
        $composer_1_44_57.useNode_0();
      }
      var tmp5_apply_0_47_60 = _SkippableUpdater___init__impl_($composer_1_44_57);
      tmp7_ComposeDomNode$composable_0_26_39(new SkippableUpdater(tmp5_apply_0_47_60), $composer_1_44_57, 112 & tmp10_ComposeDomNode$composable_0_43_56 >> 3);
      tmp8_ComposeDomNode$composable_0_35_48(new SkippableUpdater(tmp5_apply_0_47_60), $composer_1_44_57, 112 & tmp10_ComposeDomNode$composable_0_43_56 >> 6);
      var tmp0_group_2_46_59 = tmp5_apply_0_47_60;
      Unit_getInstance();
      $composer_1_44_57.startReplaceableGroup_1(2058660585);
      tmp2_TagElement$composable_0_11(scope_2_15, $composer_1_44_57, 8 & tmp10_ComposeDomNode$composable_0_43_56 >> 3 | 14 & tmp10_ComposeDomNode$composable_0_43_56 >> 3 | 112 & tmp10_ComposeDomNode$composable_0_43_56 >> 9);
      $composer_1_44_57.endReplaceableGroup_0();
      $composer_1_44_57.endNode_0();
      DisposableEffect$composable(null, _no_name_provided_$factory_175(refEffect_12_25, scope_2_15), $composer_1_14, 6);
      $composer_1_14.endReplaceableGroup_0();
      $composer_6.endReplaceableGroup_0();
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_176(value_0, onValueChange, valueRange, steps, modifier, $changed));
    }
  }
  function SliderActual$composable$lambda_0($value, $onValueChange, $valueRange, $steps, $modifier, $$changed, $composer, $force) {
    return SliderActual$composable($value, $onValueChange, $valueRange, $steps, $modifier, $composer, $$changed | 1);
  }
  function _no_name_provided__200($onValueChange) {
    this._$onValueChange_0 = $onValueChange;
  }
  _no_name_provided__200.prototype.invoke_334 = function (it) {
    var tmp0_asDynamic_0 = it._get_nativeEvent__1().target;
    var value_0 = tmp0_asDynamic_0.value;
    var tmp0_unsafeCast_0_1 = toDouble(value_0);
    this._$onValueChange_0(tmp0_unsafeCast_0_1);
  };
  _no_name_provided__200.prototype.invoke_468 = function (p1) {
    this.invoke_334((!(p1 == null) ? isInterface(p1, GenericWrappedEvent) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__200.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__201($valueRange, $step, $onValueChange) {
    this._$valueRange_0 = $valueRange;
    this._$step = $step;
    this._$onValueChange_1 = $onValueChange;
  }
  _no_name_provided__201.prototype.invoke_340 = function ($this$Input) {
    $this$Input.attr('min', this._$valueRange_0._get_start__0().toString());
    Unit_getInstance();
    $this$Input.attr('max', this._$valueRange_0._get_endInclusive__0().toString());
    Unit_getInstance();
    $this$Input.attr('step', this._$step.toString());
    Unit_getInstance();
    $this$Input.onRangeInput$default_0(null, _no_name_provided_$factory_177(this._$onValueChange_1), 1, null);
  };
  _no_name_provided__201.prototype.invoke_468 = function (p1) {
    this.invoke_340(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__201.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__202() {
  }
  _no_name_provided__202.prototype.invoke_338 = function ($this$Input, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.startReplaceableGroup_2(-86839725, 'C:slider.kt#a1h0r0');
    if (!(($changed & 81 ^ 16) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
    $composer_0.endReplaceableGroup_0();
  };
  _no_name_provided__202.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, ElementScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_338(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__202.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__203() {
  }
  _no_name_provided__203.prototype.invoke_340 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__203.prototype.invoke_468 = function (p1) {
    this.invoke_340(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__203.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__204() {
  }
  _no_name_provided__204.prototype.invoke_467 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__204.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__204.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__205($tmp0_TagElement$composable_0_9, $scope_2_15) {
    this._$tmp0_TagElement$composable_0_9 = $tmp0_TagElement$composable_0_9;
    this._$scope_2_15 = $scope_2_15;
  }
  _no_name_provided__205.prototype.invoke_452 = function () {
    var tmp0_also_0_24_37 = new DomNodeWrapper(document.createElement(this._$tmp0_TagElement$composable_0_9));
    var tmp0_unsafeCast_0_2_25_38 = tmp0_also_0_24_37._node_1;
    this._$scope_2_15._set_element_(tmp0_unsafeCast_0_2_25_38);
    return tmp0_also_0_24_37;
  };
  _no_name_provided__205.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__206($boundThis) {
    this._$boundThis_16 = $boundThis;
  }
  _no_name_provided__206.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_16.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__206.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__206.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__207($type_1, $value_2, $attrs_3, $refEffect_12_25) {
    this._$type_1 = $type_1;
    this._$value_2_0 = $value_2;
    this._$attrs_3 = $attrs_3;
    this._$refEffect_12_25 = $refEffect_12_25;
  }
  _no_name_provided__207.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_28_41 = $composer;
    var $dirty_29_42 = $changed;
    if (($changed & 14) === 0)
      $dirty_29_42 = $dirty_29_42 | ($composer_28_41.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_29_42 & 91 ^ 18) === 0) ? true : !$composer_28_41._get_skipping__0()) {
      var tmp0_also_0_31_44 = new AttrsBuilder();
      type(tmp0_also_0_31_44, this._$type_1._v);
      Unit_getInstance();
      value(tmp0_also_0_31_44, this._$value_2_0._v);
      Unit_getInstance();
      this._$attrs_3._v(tmp0_also_0_31_44);
      var attrsApplied_30_43 = tmp0_also_0_31_44;
      this._$refEffect_12_25._effect_0 = attrsApplied_30_43._refEffect;
      var attrsCollected_32_45 = attrsApplied_30_43.collect();
      var events_33_46 = attrsApplied_30_43.asList_0();
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_34_47 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_34_47, attrsCollected_32_45, Companion_getInstance_19()._UpdateAttrs);
      Updater__set_impl(tmp1__anonymous__1_34_47, events_33_46, Companion_getInstance_19()._UpdateListeners);
      Updater__set_impl(tmp1__anonymous__1_34_47, attrsApplied_30_43._propertyUpdates, Companion_getInstance_19()._UpdateProperties);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_28_41.skipToGroupEnd_2();
  };
  _no_name_provided__207.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__207.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__208($boundThis) {
    this._$boundThis_17 = $boundThis;
  }
  _no_name_provided__208.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_17.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__208.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__208.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__209($tmp1_TagElement$composable_0_10) {
    this._$tmp1_TagElement$composable_0_10 = $tmp1_TagElement$composable_0_10;
  }
  _no_name_provided__209.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_37_50 = $composer;
    var $dirty_38_51 = $changed;
    if (($changed & 14) === 0)
      $dirty_38_51 = $dirty_38_51 | ($composer_37_50.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_38_51 & 91 ^ 18) === 0) ? true : !$composer_37_50._get_skipping__0()) {
      var tmp0_apply_0_40_53 = new StyleBuilderImpl();
      this._$tmp1_TagElement$composable_0_10(tmp0_apply_0_40_53);
      var style_39_52 = tmp0_apply_0_40_53;
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_41_54 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_41_54, style_39_52, Companion_getInstance_19()._UpdateStyleDeclarations);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_37_50.skipToGroupEnd_2();
  };
  _no_name_provided__209.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__209.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_51_64() {
  }
  _no_name_provided__1_51_64.prototype.dispose_2_52_65 = function () {
    Unit_getInstance();
  };
  _no_name_provided__1_51_64.prototype.dispose_20 = function () {
    return this.dispose_2_52_65();
  };
  _no_name_provided__1_51_64.$metadata$ = {
    simpleName: '<no name provided>_1_51_64',
    kind: 'class',
    interfaces: [DisposableEffectResult]
  };
  function _no_name_provided__210($refEffect_12_25, $scope_2_15) {
    this._$refEffect_12_25_0 = $refEffect_12_25;
    this._$scope_2_15_0 = $scope_2_15;
  }
  _no_name_provided__210.prototype.invoke_463 = function ($this$DisposableEffect) {
    var tmp0_safe_receiver_50_63 = this._$refEffect_12_25_0._effect_0;
    var tmp1_elvis_lhs_49_62 = tmp0_safe_receiver_50_63 == null ? null : tmp0_safe_receiver_50_63($this$DisposableEffect, this._$scope_2_15_0._get_element__0());
    var tmp;
    if (tmp1_elvis_lhs_49_62 == null) {
      tmp = new _no_name_provided__1_51_64();
    } else {
      tmp = tmp1_elvis_lhs_49_62;
    }
    return tmp;
  };
  _no_name_provided__210.prototype.invoke_468 = function (p1) {
    return this.invoke_463(p1 instanceof DisposableEffectScope ? p1 : THROW_CCE());
  };
  _no_name_provided__210.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__211($value, $onValueChange, $valueRange, $steps, $modifier, $$changed) {
    this._$value_4 = $value;
    this._$onValueChange_2 = $onValueChange;
    this._$valueRange_1 = $valueRange;
    this._$steps_0 = $steps;
    this._$modifier_9 = $modifier;
    this._$$changed_10 = $$changed;
  }
  _no_name_provided__211.prototype.invoke_444 = function (p0, p1) {
    return SliderActual$composable$lambda_0(this._$value_4, this._$onValueChange_2, this._$valueRange_1, this._$steps_0, this._$modifier_9, this._$$changed_10, p0, p1);
  };
  _no_name_provided__211.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__211.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_166($valueRange, $step, $onValueChange) {
    var i = new _no_name_provided__201($valueRange, $step, $onValueChange);
    return function (p1) {
      i.invoke_340(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_167() {
    var i = new _no_name_provided__202();
    return function (p1, p2, p3) {
      i.invoke_338(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_168() {
    var i = new _no_name_provided__203();
    return function (p1) {
      i.invoke_340(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_169() {
    var i = new _no_name_provided__204();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_170($tmp0_TagElement$composable_0_9, $scope_2_15) {
    var i = new _no_name_provided__205($tmp0_TagElement$composable_0_9, $scope_2_15);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_171($type_1, $value_2, $attrs_3, $refEffect_12_25) {
    var i = new _no_name_provided__207($type_1, $value_2, $attrs_3, $refEffect_12_25);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_172($boundThis) {
    var i = new _no_name_provided__206($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_173($tmp1_TagElement$composable_0_10) {
    var i = new _no_name_provided__209($tmp1_TagElement$composable_0_10);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_174($boundThis) {
    var i = new _no_name_provided__208($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_175($refEffect_12_25, $scope_2_15) {
    var i = new _no_name_provided__210($refEffect_12_25, $scope_2_15);
    return function (p1) {
      return i.invoke_463(p1);
    };
  }
  function _no_name_provided_$factory_176($value, $onValueChange, $valueRange, $steps, $modifier, $$changed) {
    var i = new _no_name_provided__211($value, $onValueChange, $valueRange, $steps, $modifier, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_177($onValueChange) {
    var i = new _no_name_provided__200($onValueChange);
    return function (p1) {
      i.invoke_334(p1);
      return Unit_getInstance();
    };
  }
  function TextActual$composable(text, modifier, color_0, size_1, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-506985152, 'C(TextActual$composable)P(3,1)41@1554L237,40@1499L433:text.kt#a1h0r0');
    var $dirty = $changed;
    if (($changed & 14) === 0)
      $dirty = $dirty | ($composer_0.changed_2(text) ? 4 : 2);
    if (($changed & 112) === 0)
      $dirty = $dirty | ($composer_0.changed_2(modifier) ? 32 : 16);
    if (($changed & 896) === 0)
      $dirty = $dirty | ($composer_0.changed_2(color_0) ? 256 : 128);
    if (($changed & 7168) === 0)
      $dirty = $dirty | ($composer_0.changed_2(size_1) ? 2048 : 1024);
    if (!(($dirty & 5851 ^ 1170) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_remember$composable_0 = _no_name_provided_$factory_178(color_0, size_1);
      var tmp1_remember$composable_0 = $composer_0;
      var tmp2_remember$composable_0 = 14 & $dirty >> 6 | 112 & $dirty >> 6;
      var $composer_1 = tmp1_remember$composable_0;
      $composer_1.startReplaceableGroup_2(884180357, 'C(remember$composable)P(1,2):Composables.kt#9igjgp');
      var tmp1_cache_0_3 = $composer_1;
      var tmp2_cache_0_4 = !!($composer_1.changed_2(color_0) | $composer_1.changed_2(size_1));
      var tmp0_let_0_5 = tmp1_cache_0_3.rememberedValue_0();
      var tmp;
      if (tmp2_cache_0_4 ? true : tmp0_let_0_5 === Companion_getInstance_11()._Empty) {
        var value_2_2_6 = tmp0_remember$composable_0();
        tmp1_cache_0_3.updateRememberedValue_0(value_2_2_6);
        tmp = value_2_2_6;
      } else {
        tmp = tmp0_let_0_5;
      }
      var tmp_0 = tmp;
      var tmp0_2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      $composer_1.endReplaceableGroup_0();
      var tmp0_style = asStyleBuilderApplier(modifier, tmp0_2);
      var tmp1_attrs = asAttributeBuilderApplier(modifier, _no_name_provided_$factory_179());
      var tmp3_Span$composable_0 = $composer_0;
      var tmp4_Span$composable_0 = 0;
      var tmp5_Span$composable_0 = 0;
      var attrs_1 = tmp1_attrs;
      var style_2 = tmp0_style;
      var $composer_3 = tmp3_Span$composable_0;
      $composer_3.startReplaceableGroup_2(-1657590157, 'C(Span$composable)P(!1,2)205@7300L77:Elements.kt#mzr94e');
      if (!((tmp5_Span$composable_0 & 1) === 0)) {
        attrs_1 = _no_name_provided_$factory_180();
      }if (!((tmp5_Span$composable_0 & 2) === 0)) {
        style_2 = _no_name_provided_$factory_181();
      }var tmp0_TagElement$composable_0_6 = 'span';
      var tmp1_TagElement$composable_0_7 = attrs_1;
      var tmp2_TagElement$composable_0_8 = style_2;
      var tmp3_TagElement$composable_0_9 = $composer_3;
      var tmp4_TagElement$composable_0_10 = 6 | 112 & tmp4_Span$composable_0 << 3 | 896 & tmp4_Span$composable_0 << 3 | 7168 & tmp4_Span$composable_0 << 3;
      var $composer_1_11 = tmp3_TagElement$composable_0_9;
      $composer_1_11.startReplaceableGroup_2(-1134585235, 'C(TagElement$composable)P(3)76@2833L45,77@2899L37,79@2942L1040,107@3988L100:Base.kt#mzr94e');
      var tmp0_remember$composable_0_3_13 = $composer_1_11;
      var tmp1_remember$composable_0_4_14 = 0;
      var $composer_1_5_15 = tmp0_remember$composable_0_3_13;
      $composer_1_5_15.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_7_17 = $composer_1_5_15;
      var tmp2_cache_0_4_8_18 = false;
      var tmp0_let_0_5_9_19 = tmp1_cache_0_3_7_17.rememberedValue_0();
      var tmp_1;
      if (tmp2_cache_0_4_8_18 ? true : tmp0_let_0_5_9_19 === Companion_getInstance_11()._Empty) {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_return_8_11_21 = new ElementScopeImpl();
          tmp$ret$0 = tmp0_return_8_11_21;
          break l$ret$1;
        }
         while (false);
        var value_2_2_6_10_20 = tmp$ret$0;
        tmp1_cache_0_3_7_17.updateRememberedValue_0(value_2_2_6_10_20);
        tmp_1 = value_2_2_6_10_20;
      } else {
        tmp_1 = tmp0_let_0_5_9_19;
      }
      var tmp_2 = tmp_1;
      var tmp0_2_6_16 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
      $composer_1_5_15.endReplaceableGroup_0();
      var scope_2_12 = tmp0_2_6_16;
      var tmp2_remember$composable_0_13_23 = $composer_1_11;
      var tmp3_remember$composable_0_14_24 = 0;
      var $composer_1_15_25 = tmp2_remember$composable_0_13_23;
      $composer_1_15_25.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_17_27 = $composer_1_15_25;
      var tmp2_cache_0_4_18_28 = false;
      var tmp0_let_0_5_19_29 = tmp1_cache_0_3_17_27.rememberedValue_0();
      var tmp_3;
      if (tmp2_cache_0_4_18_28 ? true : tmp0_let_0_5_19_29 === Companion_getInstance_11()._Empty) {
        var tmp$ret$2;
        l$ret$3: do {
          var tmp0_return_8_21_31 = DisposableEffectHolder_init_$Create$(null, 1, null);
          tmp$ret$2 = tmp0_return_8_21_31;
          break l$ret$3;
        }
         while (false);
        var value_2_2_6_20_30 = tmp$ret$2;
        tmp1_cache_0_3_17_27.updateRememberedValue_0(value_2_2_6_20_30);
        tmp_3 = value_2_2_6_20_30;
      } else {
        tmp_3 = tmp0_let_0_5_19_29;
      }
      var tmp_4 = tmp_3;
      var tmp0_2_16_26 = (tmp_4 == null ? true : isObject(tmp_4)) ? tmp_4 : THROW_CCE();
      $composer_1_15_25.endReplaceableGroup_0();
      var refEffect_12_22 = tmp0_2_16_26;
      var tmp6_ComposeDomNode$composable_0_22_32 = _no_name_provided_$factory_182(tmp0_TagElement$composable_0_6, scope_2_12);
      var tmp_5 = $composer_1_11;
      var tmp7_ComposeDomNode$composable_0_26_36 = _no_name_provided_$factory_184(composableLambda(tmp_5, -819893738, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_183(tmp1_TagElement$composable_0_7, refEffect_12_22)));
      var tmp_6 = $composer_1_11;
      var tmp8_ComposeDomNode$composable_0_35_45 = _no_name_provided_$factory_186(composableLambda(tmp_6, -819894225, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_185(tmp2_TagElement$composable_0_8)));
      var tmp9_ComposeDomNode$composable_0_42_52 = $composer_1_11;
      var tmp10_ComposeDomNode$composable_0_43_53 = 64 | 57344 & tmp4_TagElement$composable_0_10 << 3;
      var $composer_1_44_54 = tmp9_ComposeDomNode$composable_0_42_52;
      var tmp_7 = $composer_1_44_54._get_applier__0();
      if (!(tmp_7 instanceof DomApplier)) {
        var tmp4_error_0_45_55 = 'Invalid applier';
        throw IllegalStateException_init_$Create$(toString_1(tmp4_error_0_45_55));
      } else {
      }
      $composer_1_44_54.startNode_2();
      if ($composer_1_44_54._get_inserting__0()) {
        $composer_1_44_54.createNode_0(tmp6_ComposeDomNode$composable_0_22_32);
      } else {
        $composer_1_44_54.useNode_0();
      }
      var tmp5_apply_0_47_57 = _SkippableUpdater___init__impl_($composer_1_44_54);
      tmp7_ComposeDomNode$composable_0_26_36(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 3);
      tmp8_ComposeDomNode$composable_0_35_45(new SkippableUpdater(tmp5_apply_0_47_57), $composer_1_44_54, 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 6);
      var tmp0_group_2_46_56 = tmp5_apply_0_47_57;
      Unit_getInstance();
      $composer_1_44_54.startReplaceableGroup_1(2058660585);
      var tmp6__anonymous__66 = $composer_1_44_54;
      var tmp7__anonymous__66 = 8 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 14 & tmp10_ComposeDomNode$composable_0_43_53 >> 3 | 112 & tmp10_ComposeDomNode$composable_0_43_53 >> 9;
      var $composer_67 = tmp6__anonymous__66;
      $composer_67.startReplaceableGroup_2(-1138641051, 'C52@1912L14:text.kt#a1h0r0');
      if (!((tmp7__anonymous__66 & 81 ^ 16) === 0) ? true : !$composer_67._get_skipping__0()) {
        Text$composable_0(text, $composer_67, 14 & $dirty);
      } else
        $composer_67.skipToGroupEnd_2();
      $composer_67.endReplaceableGroup_0();
      $composer_1_44_54.endReplaceableGroup_0();
      $composer_1_44_54.endNode_0();
      DisposableEffect$composable(null, _no_name_provided_$factory_187(refEffect_12_22, scope_2_12), $composer_1_11, 6);
      $composer_1_11.endReplaceableGroup_0();
      $composer_3.endReplaceableGroup_0();
    } else
      $composer_0.skipToGroupEnd_2();
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_188(text, modifier, color_0, size_1, $changed));
    }
  }
  function TextActual$composable$lambda_0($color, $size) {
    return _no_name_provided_$factory_189($color, $size);
  }
  function TextActual$composable$lambda_1($text, $modifier, $color, $size, $$changed, $composer, $force) {
    return TextActual$composable($text, $modifier, $color, $size, $composer, $$changed | 1);
  }
  function _no_name_provided__212($color, $size) {
    this._$color_1 = $color;
    this._$size_0 = $size;
  }
  _no_name_provided__212.prototype.invoke_452 = function () {
    return TextActual$composable$lambda_0(this._$color_1, this._$size_0);
  };
  _no_name_provided__212.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__213() {
  }
  _no_name_provided__213.prototype.invoke_383 = function ($this$asAttributeBuilderApplier) {
    $this$asAttributeBuilderApplier.classes([Styles_getInstance()._get_textClass_()]);
  };
  _no_name_provided__213.prototype.invoke_468 = function (p1) {
    this.invoke_383(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__213.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__214() {
  }
  _no_name_provided__214.prototype.invoke_360 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__214.prototype.invoke_468 = function (p1) {
    this.invoke_360(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__214.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__215() {
  }
  _no_name_provided__215.prototype.invoke_467 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__215.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__215.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__216($tmp0_TagElement$composable_0_6, $scope_2_12) {
    this._$tmp0_TagElement$composable_0_6_3 = $tmp0_TagElement$composable_0_6;
    this._$scope_2_12_7 = $scope_2_12;
  }
  _no_name_provided__216.prototype.invoke_452 = function () {
    var tmp0_also_0_24_34 = new DomNodeWrapper(document.createElement(this._$tmp0_TagElement$composable_0_6_3));
    var tmp0_unsafeCast_0_2_25_35 = tmp0_also_0_24_34._node_1;
    this._$scope_2_12_7._set_element_(tmp0_unsafeCast_0_2_25_35);
    return tmp0_also_0_24_34;
  };
  _no_name_provided__216.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__217($boundThis) {
    this._$boundThis_18 = $boundThis;
  }
  _no_name_provided__217.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_18.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__217.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__217.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__218($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    this._$tmp1_TagElement$composable_0_7_3 = $tmp1_TagElement$composable_0_7;
    this._$refEffect_12_22_7 = $refEffect_12_22;
  }
  _no_name_provided__218.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_28_38 = $composer;
    var $dirty_29_39 = $changed;
    if (($changed & 14) === 0)
      $dirty_29_39 = $dirty_29_39 | ($composer_28_38.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_29_39 & 91 ^ 18) === 0) ? true : !$composer_28_38._get_skipping__0()) {
      var tmp0_also_0_31_41 = new AttrsBuilder();
      this._$tmp1_TagElement$composable_0_7_3(tmp0_also_0_31_41);
      var attrsApplied_30_40 = tmp0_also_0_31_41;
      this._$refEffect_12_22_7._effect_0 = attrsApplied_30_40._refEffect;
      var attrsCollected_32_42 = attrsApplied_30_40.collect();
      var events_33_43 = attrsApplied_30_40.asList_0();
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_34_44 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsCollected_32_42, Companion_getInstance_19()._UpdateAttrs);
      Updater__set_impl(tmp1__anonymous__1_34_44, events_33_43, Companion_getInstance_19()._UpdateListeners);
      Updater__set_impl(tmp1__anonymous__1_34_44, attrsApplied_30_40._propertyUpdates, Companion_getInstance_19()._UpdateProperties);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_28_38.skipToGroupEnd_2();
  };
  _no_name_provided__218.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__218.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__219($boundThis) {
    this._$boundThis_19 = $boundThis;
  }
  _no_name_provided__219.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_19.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__219.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__219.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__220($tmp2_TagElement$composable_0_8) {
    this._$tmp2_TagElement$composable_0_8_3 = $tmp2_TagElement$composable_0_8;
  }
  _no_name_provided__220.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_37_47 = $composer;
    var $dirty_38_48 = $changed;
    if (($changed & 14) === 0)
      $dirty_38_48 = $dirty_38_48 | ($composer_37_47.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_38_48 & 91 ^ 18) === 0) ? true : !$composer_37_47._get_skipping__0()) {
      var tmp0_apply_0_40_50 = new StyleBuilderImpl();
      this._$tmp2_TagElement$composable_0_8_3(tmp0_apply_0_40_50);
      var style_39_49 = tmp0_apply_0_40_50;
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__1_41_51 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__1_41_51, style_39_49, Companion_getInstance_19()._UpdateStyleDeclarations);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_37_47.skipToGroupEnd_2();
  };
  _no_name_provided__220.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__220.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_51_61_3() {
  }
  _no_name_provided__1_51_61_3.prototype.dispose_2_52_62_3 = function () {
    Unit_getInstance();
  };
  _no_name_provided__1_51_61_3.prototype.dispose_20 = function () {
    return this.dispose_2_52_62_3();
  };
  _no_name_provided__1_51_61_3.$metadata$ = {
    simpleName: '<no name provided>_1_51_61',
    kind: 'class',
    interfaces: [DisposableEffectResult]
  };
  function _no_name_provided__221($refEffect_12_22, $scope_2_12) {
    this._$refEffect_12_22_8 = $refEffect_12_22;
    this._$scope_2_12_8 = $scope_2_12;
  }
  _no_name_provided__221.prototype.invoke_463 = function ($this$DisposableEffect) {
    var tmp0_safe_receiver_50_60 = this._$refEffect_12_22_8._effect_0;
    var tmp1_elvis_lhs_49_59 = tmp0_safe_receiver_50_60 == null ? null : tmp0_safe_receiver_50_60($this$DisposableEffect, this._$scope_2_12_8._get_element__0());
    var tmp;
    if (tmp1_elvis_lhs_49_59 == null) {
      tmp = new _no_name_provided__1_51_61_3();
    } else {
      tmp = tmp1_elvis_lhs_49_59;
    }
    return tmp;
  };
  _no_name_provided__221.prototype.invoke_468 = function (p1) {
    return this.invoke_463(p1 instanceof DisposableEffectScope ? p1 : THROW_CCE());
  };
  _no_name_provided__221.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__222($text, $modifier, $color, $size, $$changed) {
    this._$text_0 = $text;
    this._$modifier_10 = $modifier;
    this._$color_2 = $color;
    this._$size_1 = $size;
    this._$$changed_11 = $$changed;
  }
  _no_name_provided__222.prototype.invoke_444 = function (p0, p1) {
    return TextActual$composable$lambda_1(this._$text_0, this._$modifier_10, this._$color_2, this._$size_1, this._$$changed_11, p0, p1);
  };
  _no_name_provided__222.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__222.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__223($color, $size) {
    this._$color_3 = $color;
    this._$size_2 = $size;
  }
  _no_name_provided__223.prototype.invoke_467 = function ($this$asStyleBuilderApplier) {
    color($this$asStyleBuilderApplier, new RGB(this._$color_3._red, this._$color_3._green, this._$color_3._blue));
    var tmp0_subject = this._$size_2._unitType;
    if (tmp0_subject.equals(TextUnitType_Em_getInstance()))
      fontSize($this$asStyleBuilderApplier, _get_em__0(this._$size_2._value_9));
    else if (tmp0_subject.equals(TextUnitType_Sp_getInstance()))
      fontSize($this$asStyleBuilderApplier, _get_px_(this._$size_2._value_9));
  };
  _no_name_provided__223.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__223.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_178($color, $size) {
    var i = new _no_name_provided__212($color, $size);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_179() {
    var i = new _no_name_provided__213();
    return function (p1) {
      i.invoke_383(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_180() {
    var i = new _no_name_provided__214();
    return function (p1) {
      i.invoke_360(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_181() {
    var i = new _no_name_provided__215();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_182($tmp0_TagElement$composable_0_6, $scope_2_12) {
    var i = new _no_name_provided__216($tmp0_TagElement$composable_0_6, $scope_2_12);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_183($tmp1_TagElement$composable_0_7, $refEffect_12_22) {
    var i = new _no_name_provided__218($tmp1_TagElement$composable_0_7, $refEffect_12_22);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_184($boundThis) {
    var i = new _no_name_provided__217($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_185($tmp2_TagElement$composable_0_8) {
    var i = new _no_name_provided__220($tmp2_TagElement$composable_0_8);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_186($boundThis) {
    var i = new _no_name_provided__219($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_187($refEffect_12_22, $scope_2_12) {
    var i = new _no_name_provided__221($refEffect_12_22, $scope_2_12);
    return function (p1) {
      return i.invoke_463(p1);
    };
  }
  function _no_name_provided_$factory_188($text, $modifier, $color, $size, $$changed) {
    var i = new _no_name_provided__222($text, $modifier, $color, $size, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_189($color, $size) {
    var i = new _no_name_provided__223($color, $size);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function border_0(_this_, size_1, color_0) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_190(size_1, color_0));
    return tmp0_apply_0;
  }
  function _no_name_provided__224($size, $color) {
    this._$size_3 = $size;
    this._$color_4 = $color;
  }
  _no_name_provided__224.prototype.invoke_467 = function ($this$add) {
    border($this$add, _get_px_(this._$size_3._value_8), LineStyle_Solid_getInstance(), new RGB(this._$color_4._red, this._$color_4._green, this._$color_4._blue));
  };
  _no_name_provided__224.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__224.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_190($size, $color) {
    var i = new _no_name_provided__224($size, $color);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function clickable(_this_, onClick) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.addAttributeBuilder(_no_name_provided_$factory_191(onClick));
    return tmp0_apply_0;
  }
  function _no_name_provided__225($onClick) {
    this._$onClick_3 = $onClick;
  }
  _no_name_provided__225.prototype.invoke_381 = function (it) {
    this._$onClick_3();
  };
  _no_name_provided__225.prototype.invoke_468 = function (p1) {
    this.invoke_381(p1 instanceof WrappedMouseEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__225.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__226($onClick) {
    this._$onClick_4 = $onClick;
  }
  _no_name_provided__226.prototype.invoke_383 = function ($this$addAttributeBuilder) {
    $this$addAttributeBuilder.onClick$default_0(null, _no_name_provided_$factory_192(this._$onClick_4), 1, null);
  };
  _no_name_provided__226.prototype.invoke_468 = function (p1) {
    this.invoke_383(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__226.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_191($onClick) {
    var i = new _no_name_provided__226($onClick);
    return function (p1) {
      i.invoke_383(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_192($onClick) {
    var i = new _no_name_provided__225($onClick);
    return function (p1) {
      i.invoke_381(p1);
      return Unit_getInstance();
    };
  }
  function clip(_this_, shape) {
    var tmp0_apply_0 = castOrCreate(_this_);
    var tmp0_subject_2 = shape;
    if (equals(tmp0_subject_2, CircleShape_getInstance())) {
      tmp0_apply_0.add_52(_no_name_provided_$factory_193());
    }return tmp0_apply_0;
  }
  function _no_name_provided__227() {
  }
  _no_name_provided__227.prototype.invoke_467 = function ($this$add) {
    borderRadius($this$add, _get_percent_(50));
  };
  _no_name_provided__227.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__227.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_193() {
    var i = new _no_name_provided__227();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function fillMaxHeight(_this_, fraction) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_194(fraction));
    return tmp0_apply_0;
  }
  function _no_name_provided__228($fraction) {
    this._$fraction = $fraction;
  }
  _no_name_provided__228.prototype.invoke_467 = function ($this$add) {
    height($this$add, _get_percent_(100 * this._$fraction));
  };
  _no_name_provided__228.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__228.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_194($fraction) {
    var i = new _no_name_provided__228($fraction);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function fillMaxWidth(_this_) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_195());
    return tmp0_apply_0;
  }
  function _no_name_provided__229() {
  }
  _no_name_provided__229.prototype.invoke_467 = function ($this$add) {
    width($this$add, _get_percent_(100));
  };
  _no_name_provided__229.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__229.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_195() {
    var i = new _no_name_provided__229();
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function offset(_this_, x, y) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_196(x, y));
    return tmp0_apply_0;
  }
  function _no_name_provided__230($x, $y) {
    this._$x = $x;
    this._$y = $y;
  }
  _no_name_provided__230.prototype.invoke_467 = function ($this$add) {
    marginLeft($this$add, _get_px_(this._$x._value_8));
    marginTop($this$add, _get_px_(this._$y._value_8));
  };
  _no_name_provided__230.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__230.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_196($x, $y) {
    var i = new _no_name_provided__230($x, $y);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function onSizeChanged(_this_, onSizeChanged_0) {
    return _this_;
  }
  function size_0(_this_, width_2, height_1) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_197(width_2, height_1));
    return tmp0_apply_0;
  }
  function _no_name_provided__231($width, $height) {
    this._$width = $width;
    this._$height = $height;
  }
  _no_name_provided__231.prototype.invoke_467 = function ($this$add) {
    width($this$add, _get_px_(this._$width._value_8));
    height($this$add, _get_px_(this._$height._value_8));
  };
  _no_name_provided__231.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__231.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_197($width, $height) {
    var i = new _no_name_provided__231($width, $height);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function width_1(_this_, size_1) {
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_198(size_1));
    return tmp0_apply_0;
  }
  function _no_name_provided__232($size) {
    this._$size_4 = $size;
  }
  _no_name_provided__232.prototype.invoke_467 = function ($this$add) {
    width($this$add, _get_px_(this._$size_4._value_8));
  };
  _no_name_provided__232.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__232.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_198($size) {
    var i = new _no_name_provided__232($size);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  function random_0(_this_) {
    var tmp0_random_0 = numberRangeToNumber(0, 255);
    var tmp = random(tmp0_random_0, Default_getInstance());
    var tmp1_random_0 = numberRangeToNumber(0, 255);
    var tmp_0 = random(tmp1_random_0, Default_getInstance());
    var tmp2_random_0 = numberRangeToNumber(0, 255);
    return new Color(tmp, tmp_0, random(tmp2_random_0, Default_getInstance()));
  }
  function Game() {
    this._previousTime = new Long(-1, 2147483647);
    this._startTime = new Long(0, 0);
    var tmp = this;
    var tmp_0 = new IntSize(0, 0);
    tmp._size$delegate = mutableStateOf$default(tmp_0, null, 2, null);
    this._pieces = mutableStateListOf();
    var tmp_1 = this;
    var tmp_2 = new Long(0, 0);
    tmp_1._elapsed$delegate = mutableStateOf$default(tmp_2, null, 2, null);
    var tmp_3 = this;
    tmp_3._score$delegate = mutableStateOf$default(0, null, 2, null);
    var tmp_4 = this;
    tmp_4._clicked$delegate = mutableStateOf$default(0, null, 2, null);
    var tmp_5 = this;
    tmp_5._started$delegate = mutableStateOf$default(false, null, 2, null);
    var tmp_6 = this;
    tmp_6._paused$delegate = mutableStateOf$default(false, null, 2, null);
    var tmp_7 = this;
    tmp_7._finished$delegate = mutableStateOf$default(false, null, 2, null);
    var tmp_8 = this;
    tmp_8._numBlocks$delegate = mutableStateOf$default(5, null, 2, null);
    this._$stable_48 = 8;
  }
  Game.prototype._set_size__0 = function (_set___) {
    var tmp0_setValue_0 = this._size$delegate;
    var tmp1_setValue_0 = size$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_size__45 = function () {
    var tmp0_getValue_0 = this._size$delegate;
    var tmp1_getValue_0 = size$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype._set_width__0 = function (newWidth) {
    this._set_size__0(new IntSize(newWidth, this._get_height__0()));
  };
  Game.prototype._get_width__0 = function () {
    return this._get_size__45()._width;
  };
  Game.prototype._set_height__0 = function (newHeight) {
    this._set_size__0(new IntSize(this._get_width__0(), newHeight));
  };
  Game.prototype._get_height__0 = function () {
    return this._get_size__45()._height_0;
  };
  Game.prototype._set_elapsed__0 = function (_set___) {
    var tmp0_setValue_0 = this._elapsed$delegate;
    var tmp1_setValue_0 = elapsed$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_elapsed__0 = function () {
    var tmp0_getValue_0 = this._elapsed$delegate;
    var tmp1_getValue_0 = elapsed$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype._set_score__0 = function (_set___) {
    var tmp0_setValue_0 = this._score$delegate;
    var tmp1_setValue_0 = score$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_score__0 = function () {
    var tmp0_getValue_0 = this._score$delegate;
    var tmp1_getValue_0 = score$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype._set_clicked__0 = function (_set___) {
    var tmp0_setValue_0 = this._clicked$delegate;
    var tmp1_setValue_0 = clicked$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_clicked__0 = function () {
    var tmp0_getValue_0 = this._clicked$delegate;
    var tmp1_getValue_0 = clicked$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype._set_started__0 = function (_set___) {
    var tmp0_setValue_0 = this._started$delegate;
    var tmp1_setValue_0 = started$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_started__0 = function () {
    var tmp0_getValue_0 = this._started$delegate;
    var tmp1_getValue_0 = started$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype._set_paused__0 = function (_set___) {
    var tmp0_setValue_0 = this._paused$delegate;
    var tmp1_setValue_0 = paused$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_paused__0 = function () {
    var tmp0_getValue_0 = this._paused$delegate;
    var tmp1_getValue_0 = paused$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype._set_finished__0 = function (_set___) {
    var tmp0_setValue_0 = this._finished$delegate;
    var tmp1_setValue_0 = finished$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_finished__0 = function () {
    var tmp0_getValue_0 = this._finished$delegate;
    var tmp1_getValue_0 = finished$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype._set_numBlocks__0 = function (_set___) {
    var tmp0_setValue_0 = this._numBlocks$delegate;
    var tmp1_setValue_0 = numBlocks$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  Game.prototype._get_numBlocks__0 = function () {
    var tmp0_getValue_0 = this._numBlocks$delegate;
    var tmp1_getValue_0 = numBlocks$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  Game.prototype.isInBoundaries_0 = function (pieceData) {
    return pieceData._get_position_() < this._get_size__45()._height_0;
  };
  Game.prototype.togglePause_0 = function () {
    this._set_paused__0(!this._get_paused__0());
    this._previousTime = new Long(-1, 2147483647);
  };
  Game.prototype.start_15 = function () {
    this._previousTime = this.now_1();
    this._startTime = this._previousTime;
    this._set_clicked__0(0);
    this._set_started__0(true);
    this._set_finished__0(false);
    this._set_paused__0(false);
    this._pieces.clear_7();
    var tmp0_repeat_0 = this._get_numBlocks__0();
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this._pieces;
        var tmp0_also_0_4 = new PieceData(this, index_2 * 1.5 + 5.0, random_0(Companion_getInstance_16()));
        tmp0_also_0_4._set_position_(Default_getInstance().nextDouble_4(0.0, 100.0));
        tmp.add_36(tmp0_also_0_4);
        Unit_getInstance();
      }
       while (inductionVariable < tmp0_repeat_0);
  };
  Game.prototype.update_4 = function (nanos) {
    var dt = coerceAtLeast(nanos.minus_27(this._previousTime), new Long(0, 0));
    this._previousTime = nanos;
    this._set_elapsed__0(nanos.minus_27(this._startTime));
    var tmp0_forEach_0 = this._pieces;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_46();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_28();
      element_2.update_4(dt);
    }
  };
  Game.$metadata$ = {
    simpleName: 'Game',
    kind: 'class',
    interfaces: []
  };
  function size$factory() {
    return getPropertyCallableRef('size', 1, KMutableProperty1, function (receiver) {
      return receiver._get_size__45();
    }, function (receiver_0, value_0) {
      return receiver_0._set_size__0(value_0);
    });
  }
  function size$factory_0() {
    return getPropertyCallableRef('size', 1, KMutableProperty1, function (receiver) {
      return receiver._get_size__45();
    }, function (receiver_0, value_0) {
      return receiver_0._set_size__0(value_0);
    });
  }
  function elapsed$factory() {
    return getPropertyCallableRef('elapsed', 1, KMutableProperty1, function (receiver) {
      return receiver._get_elapsed__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_elapsed__0(value_0);
    });
  }
  function elapsed$factory_0() {
    return getPropertyCallableRef('elapsed', 1, KMutableProperty1, function (receiver) {
      return receiver._get_elapsed__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_elapsed__0(value_0);
    });
  }
  function score$factory() {
    return getPropertyCallableRef('score', 1, KMutableProperty1, function (receiver) {
      return receiver._get_score__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_score__0(value_0);
    });
  }
  function score$factory_0() {
    return getPropertyCallableRef('score', 1, KMutableProperty1, function (receiver) {
      return receiver._get_score__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_score__0(value_0);
    });
  }
  function clicked$factory() {
    return getPropertyCallableRef('clicked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_clicked__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_clicked__0(value_0);
    });
  }
  function clicked$factory_0() {
    return getPropertyCallableRef('clicked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_clicked__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_clicked__0(value_0);
    });
  }
  function started$factory() {
    return getPropertyCallableRef('started', 1, KMutableProperty1, function (receiver) {
      return receiver._get_started__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_started__0(value_0);
    });
  }
  function started$factory_0() {
    return getPropertyCallableRef('started', 1, KMutableProperty1, function (receiver) {
      return receiver._get_started__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_started__0(value_0);
    });
  }
  function paused$factory() {
    return getPropertyCallableRef('paused', 1, KMutableProperty1, function (receiver) {
      return receiver._get_paused__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_paused__0(value_0);
    });
  }
  function paused$factory_0() {
    return getPropertyCallableRef('paused', 1, KMutableProperty1, function (receiver) {
      return receiver._get_paused__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_paused__0(value_0);
    });
  }
  function finished$factory() {
    return getPropertyCallableRef('finished', 1, KMutableProperty1, function (receiver) {
      return receiver._get_finished__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_finished__0(value_0);
    });
  }
  function finished$factory_0() {
    return getPropertyCallableRef('finished', 1, KMutableProperty1, function (receiver) {
      return receiver._get_finished__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_finished__0(value_0);
    });
  }
  function numBlocks$factory() {
    return getPropertyCallableRef('numBlocks', 1, KMutableProperty1, function (receiver) {
      return receiver._get_numBlocks__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_numBlocks__0(value_0);
    });
  }
  function numBlocks$factory_0() {
    return getPropertyCallableRef('numBlocks', 1, KMutableProperty1, function (receiver) {
      return receiver._get_numBlocks__0();
    }, function (receiver_0, value_0) {
      return receiver_0._set_numBlocks__0(value_0);
    });
  }
  function _no_name_provided__233($boundThis) {
    this._$boundThis_20 = $boundThis;
  }
  _no_name_provided__233.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_20.invoke_437(p0, p1);
  };
  _no_name_provided__233.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__233.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__234() {
  }
  _no_name_provided__234.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      Unit_getInstance();
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__234.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__234.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ComposableSingletons$PieceKt() {
    ComposableSingletons$PieceKt_instance = this;
    var tmp = this;
    tmp._lambda_1_1 = _no_name_provided_$factory_200(composableLambdaInstance(-985533142, false, null, _no_name_provided_$factory_199()));
  }
  ComposableSingletons$PieceKt.$metadata$ = {
    simpleName: 'ComposableSingletons$PieceKt',
    kind: 'object',
    interfaces: []
  };
  var ComposableSingletons$PieceKt_instance;
  function ComposableSingletons$PieceKt_getInstance() {
    if (ComposableSingletons$PieceKt_instance == null)
      new ComposableSingletons$PieceKt();
    return ComposableSingletons$PieceKt_instance;
  }
  function Piece$composable(index, piece, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-1065027375, 'C(Piece$composable)');
    var boxSize = _get_dp_(40);
    var tmp = background(size_0(position$composable(Companion_getInstance_17(), new Dp(boxSize._value_8 * index * 5 / 3), new Dp(piece._get_position_()), $composer_0, 6), boxSize, boxSize), piece._get_picked_() ? Companion_getInstance_16()._Gray : piece._color_0);
    Box$composable(clip(clickable(tmp, _no_name_provided_$factory_201(piece)), CircleShape_getInstance()), ComposableSingletons$PieceKt_getInstance()._lambda_1_1, $composer_0, 0, 0);
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_202(index, piece, $changed));
    }
  }
  function Piece$composable$lambda_0($index, $piece, $$changed, $composer, $force) {
    return Piece$composable($index, $piece, $composer, $$changed | 1);
  }
  function _no_name_provided__235($piece) {
    this._$piece = $piece;
  }
  _no_name_provided__235.prototype.invoke_415 = function () {
    this._$piece.pick();
  };
  _no_name_provided__235.prototype.invoke_452 = function () {
    this.invoke_415();
    return Unit_getInstance();
  };
  _no_name_provided__235.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__236($index, $piece, $$changed) {
    this._$index = $index;
    this._$piece_0 = $piece;
    this._$$changed_12 = $$changed;
  }
  _no_name_provided__236.prototype.invoke_444 = function (p0, p1) {
    return Piece$composable$lambda_0(this._$index, this._$piece_0, this._$$changed_12, p0, p1);
  };
  _no_name_provided__236.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__236.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_199() {
    var i = new _no_name_provided__234();
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_200($boundThis) {
    var i = new _no_name_provided__233($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_201($piece) {
    var i = new _no_name_provided__235($piece);
    return function () {
      i.invoke_415();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_202($index, $piece, $$changed) {
    var i = new _no_name_provided__236($index, $piece, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function pickPiece(_this_, $this, piece) {
    var tmp0_this = _this_;
    tmp0_this._set_score__0(tmp0_this._get_score__0() + numberToInt(piece._velocity) | 0);
    var tmp1_this = _this_;
    var tmp2 = tmp1_this._get_clicked__0();
    tmp1_this._set_clicked__0(tmp2 + 1 | 0);
    Unit_getInstance();
    if (_this_._get_clicked__0() === _this_._get_numBlocks__0()) {
      _this_._set_finished__0(true);
    }}
  function PieceData(game, velocity, color_0) {
    this._game = game;
    this._velocity = velocity;
    this._color_0 = color_0;
    var tmp = this;
    tmp._picked$delegate = mutableStateOf$default(false, null, 2, null);
    var tmp_0 = this;
    tmp_0._position$delegate = mutableStateOf$default(0.0, null, 2, null);
    this._$stable_49 = 8;
  }
  PieceData.prototype._set_picked_ = function (_set___) {
    var tmp0_setValue_0 = this._picked$delegate;
    var tmp1_setValue_0 = picked$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  PieceData.prototype._get_picked_ = function () {
    var tmp0_getValue_0 = this._picked$delegate;
    var tmp1_getValue_0 = picked$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  PieceData.prototype._set_position_ = function (_set___) {
    var tmp0_setValue_0 = this._position$delegate;
    var tmp1_setValue_0 = position$factory();
    return tmp0_setValue_0._set_value__5(_set___);
  };
  PieceData.prototype._get_position_ = function () {
    var tmp0_getValue_0 = this._position$delegate;
    var tmp1_getValue_0 = position$factory_0();
    return tmp0_getValue_0._get_value__13();
  };
  PieceData.prototype.update_4 = function (dt) {
    if (this._get_picked_())
      return Unit_getInstance();
    var tmp0_div_0 = 1.0E8;
    var delta_0 = dt.toDouble_4() / tmp0_div_0 * this._velocity;
    this._set_position_(this._game.isInBoundaries_0(this) ? this._get_position_() + delta_0 : 0.0);
  };
  PieceData.prototype.pick = function () {
    if (!this._get_picked_() ? !this._game._get_paused__0() : false) {
      this._set_picked_(true);
      pickPiece(this._game, this, this);
    }};
  PieceData.prototype.toString = function () {
    return '' + 'PieceData(game=' + this._game + ', velocity=' + this._velocity + ', color=' + this._color_0 + ')';
  };
  PieceData.prototype.hashCode = function () {
    var result = hashCode(this._game);
    result = imul(result, 31) + getNumberHashCode(this._velocity) | 0;
    result = imul(result, 31) + this._color_0.hashCode() | 0;
    return result;
  };
  PieceData.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PieceData))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PieceData ? other : THROW_CCE();
    if (!equals(this._game, tmp0_other_with_cast._game))
      return false;
    if (!equals(this._velocity, tmp0_other_with_cast._velocity))
      return false;
    if (!this._color_0.equals(tmp0_other_with_cast._color_0))
      return false;
    return true;
  };
  PieceData.$metadata$ = {
    simpleName: 'PieceData',
    kind: 'class',
    interfaces: []
  };
  function picked$factory() {
    return getPropertyCallableRef('picked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_picked_();
    }, function (receiver_0, value_0) {
      return receiver_0._set_picked_(value_0);
    });
  }
  function picked$factory_0() {
    return getPropertyCallableRef('picked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_picked_();
    }, function (receiver_0, value_0) {
      return receiver_0._set_picked_(value_0);
    });
  }
  function position$factory() {
    return getPropertyCallableRef('position', 1, KMutableProperty1, function (receiver) {
      return receiver._get_position_();
    }, function (receiver_0, value_0) {
      return receiver_0._set_position_(value_0);
    });
  }
  function position$factory_0() {
    return getPropertyCallableRef('position', 1, KMutableProperty1, function (receiver) {
      return receiver._get_position_();
    }, function (receiver_0, value_0) {
      return receiver_0._set_position_(value_0);
    });
  }
  function fallingBalls$composable(game, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.startRestartGroup_0(-1453890616, 'C(fallingBalls$composable)');
    var tmp = fillMaxHeight(fillMaxWidth(Companion_getInstance_17()), 1.0);
    var tmp_0 = $composer_0;
    Column$composable(tmp, _no_name_provided_$factory_204(composableLambda(tmp_0, -819895389, true, null, _no_name_provided_$factory_203(game))), $composer_0, 0, 0);
    var tmp0_safe_receiver = $composer_0.endRestartGroup_0();
    if (tmp0_safe_receiver === null)
      null;
    else {
      tmp0_safe_receiver.updateScope_0(_no_name_provided_$factory_205(game, $changed));
    }
  }
  function fallingBalls$composable$lambda_0($game, $$changed, $composer, $force) {
    return fallingBalls$composable($game, $composer, $$changed | 1);
  }
  function _no_name_provided__237($boundThis) {
    this._$boundThis_21 = $boundThis;
  }
  _no_name_provided__237.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_21.invoke_437(p0, p1);
  };
  _no_name_provided__237.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__237.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__238($game) {
    this._$game = $game;
  }
  _no_name_provided__238.prototype.invoke_407 = function (it) {
    this._$game._set_numBlocks__0(coerceAtLeast_0(numberToInt(it * 20.0), 1));
  };
  _no_name_provided__238.prototype.invoke_468 = function (p1) {
    this.invoke_407((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__238.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__239($game) {
    this._$game_0 = $game;
  }
  _no_name_provided__239.prototype.invoke_415 = function () {
    this._$game_0._set_started__0(!this._$game_0._get_started__0());
    if (this._$game_0._get_started__0()) {
      this._$game_0.start_15();
    }};
  _no_name_provided__239.prototype.invoke_452 = function () {
    this.invoke_415();
    return Unit_getInstance();
  };
  _no_name_provided__239.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__240($boundThis) {
    this._$boundThis_22 = $boundThis;
  }
  _no_name_provided__240.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_22.invoke_437(p0, p1);
  };
  _no_name_provided__240.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__240.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__241($game) {
    this._$game_1 = $game;
  }
  _no_name_provided__241.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp = this._$game_1._get_started__0() ? 'Stop' : 'Start';
      Text$composable(tmp, Unit_getInstance(), Unit_getInstance(), _get_em_(2.0), $composer_0, 0, 6);
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__241.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__241.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__242($game) {
    this._$game_2 = $game;
  }
  _no_name_provided__242.prototype.invoke_415 = function () {
    this._$game_2.togglePause_0();
  };
  _no_name_provided__242.prototype.invoke_452 = function () {
    this.invoke_415();
    return Unit_getInstance();
  };
  _no_name_provided__242.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__243($boundThis) {
    this._$boundThis_23 = $boundThis;
  }
  _no_name_provided__243.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_23.invoke_437(p0, p1);
  };
  _no_name_provided__243.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__243.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__244($game) {
    this._$game_3 = $game;
  }
  _no_name_provided__244.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp = this._$game_3._get_paused__0() ? 'Resume' : 'Pause';
      Text$composable(tmp, Unit_getInstance(), Unit_getInstance(), _get_em_(2.0), $composer_0, 0, 6);
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__244.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__244.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__245($game) {
    this._$game_4 = $game;
  }
  _no_name_provided__245.prototype.invoke_421 = function (it) {
    if ((this._$game_4._get_started__0() ? !this._$game_4._get_paused__0() : false) ? !this._$game_4._get_finished__0() : false)
      this._$game_4.update_4(it);
  };
  _no_name_provided__245.prototype.invoke_468 = function (p1) {
    this.invoke_421(p1 instanceof Long ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__245.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__246($boundThis) {
    this._$boundThis_24 = $boundThis;
  }
  _no_name_provided__246.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_24.invoke_437(p0, p1);
  };
  _no_name_provided__246.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__246.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__247($game) {
    this._$game_5 = $game;
  }
  _no_name_provided__247.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_text = '' + 'Catch balls!' + (this._$game_5._get_finished__0() ? ' Game over!' : '');
      var tmp1_size = _get_em_(1.8);
      var tmp2_color = new Color(218, 120, 91);
      Text$composable(tmp0_text, Unit_getInstance(), tmp2_color, tmp1_size, $composer_0, 0, 2);
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__247.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__247.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__248($boundThis) {
    this._$boundThis_25 = $boundThis;
  }
  _no_name_provided__248.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_25.invoke_437(p0, p1);
  };
  _no_name_provided__248.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__248.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__249($game) {
    this._$game_6 = $game;
  }
  _no_name_provided__249.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp = this._$game_6._get_score__0();
      var tmp0_div_0 = this._$game_6._get_elapsed__0();
      var tmp1_div_0 = 1000000;
      var tmp_0 = '' + 'Score: ' + tmp + ' Time: ' + tmp0_div_0.div_28(toLong(tmp1_div_0)) + ' Blocks: ' + this._$game_6._get_numBlocks__0();
      Text$composable(tmp_0, Unit_getInstance(), Unit_getInstance(), _get_em_(1.8), $composer_0, 0, 6);
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__249.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__249.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__250($boundThis) {
    this._$boundThis_26 = $boundThis;
  }
  _no_name_provided__250.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_26.invoke_437(p0, p1);
  };
  _no_name_provided__250.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__250.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__251($game) {
    this._$game_7 = $game;
  }
  _no_name_provided__251.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      if (!this._$game_7._get_started__0()) {
        $composer_0.startReplaceableGroup_1(-96178018);
        var tmp = this._$game_7._get_numBlocks__0() / 20.0;
        var tmp_0 = _no_name_provided_$factory_216(this._$game_7);
        Slider$composable(tmp, tmp_0, Unit_getInstance(), 0, width_1(Companion_getInstance_17(), _get_dp_(100)), $composer_0, 0, 12);
        $composer_0.endReplaceableGroup_0();
      } else {
        $composer_0.startReplaceableGroup_1(-96177763);
        $composer_0.endReplaceableGroup_0();
      }
      var tmp_1 = background(border_0(Companion_getInstance_17(), _get_dp_(2), new Color(255, 215, 0)), Companion_getInstance_16()._Yellow);
      var tmp_2 = _no_name_provided_$factory_217(this._$game_7);
      var tmp_3 = $composer_0;
      Button$composable(tmp_1, tmp_2, _no_name_provided_$factory_219(composableLambda(tmp_3, -819892288, true, null, _no_name_provided_$factory_218(this._$game_7))), $composer_0, 0, 0);
      if (this._$game_7._get_started__0()) {
        $composer_0.startReplaceableGroup_1(-96177288);
        var tmp_4 = background(border_0(offset(Companion_getInstance_17(), _get_dp_(10), _get_dp_(0)), _get_dp_(2), new Color(255, 215, 0)), Companion_getInstance_16()._Yellow);
        var tmp_5 = _no_name_provided_$factory_220(this._$game_7);
        var tmp_6 = $composer_0;
        Button$composable(tmp_4, tmp_5, _no_name_provided_$factory_222(composableLambda(tmp_6, -819892860, true, null, _no_name_provided_$factory_221(this._$game_7))), $composer_0, 0, 0);
        $composer_0.endReplaceableGroup_0();
      } else {
        $composer_0.startReplaceableGroup_1(-96176852);
        $composer_0.endReplaceableGroup_0();
      }
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__251.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__251.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__252($game) {
    this._$game_8 = $game;
  }
  _no_name_provided__252.prototype.invoke_435 = function (it) {
    this._$game_8._set_size__0(it);
  };
  _no_name_provided__252.prototype.invoke_468 = function (p1) {
    this.invoke_435(p1 instanceof IntSize ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__252.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__253($boundThis) {
    this._$boundThis_27 = $boundThis;
  }
  _no_name_provided__253.prototype.invoke_437 = function (p0, p1) {
    return this._$boundThis_27.invoke_437(p0, p1);
  };
  _no_name_provided__253.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    return this.invoke_437(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__253.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__254($game) {
    this._$game_9 = $game;
  }
  _no_name_provided__254.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_forEachIndexed_0 = this._$game_9._pieces;
      var index_1 = 0;
      var tmp0_iterator_2 = tmp0_forEachIndexed_0.iterator_46();
      while (tmp0_iterator_2.hasNext_27()) {
        var item_3 = tmp0_iterator_2.next_28();
        var tmp1_4 = index_1;
        index_1 = tmp1_4 + 1 | 0;
        var tmp1__anonymous__5 = checkIndexOverflow(tmp1_4);
        Piece$composable(tmp1__anonymous__5, item_3, $composer_0, 64);
      }
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__254.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__254.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__255($game, resultContinuation) {
    this._$game_10 = $game;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__255.prototype.invoke_441 = function ($this$LaunchedEffect, $cont) {
    var tmp = this.create_9($this$LaunchedEffect, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_11();
  };
  _no_name_provided__255.prototype.doResume_11 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this._state_1 = 4;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = withFrameNanos(_no_name_provided_$factory_223(this._$game_10), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            throw this._exception_0;
          case 4:
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__255.prototype.create_9 = function ($this$LaunchedEffect, completion) {
    var i = new _no_name_provided__255(this._$game_10, completion);
    i._$this$LaunchedEffect = $this$LaunchedEffect;
    return i;
  };
  _no_name_provided__255.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__256($game) {
    this._$game_11 = $game;
  }
  _no_name_provided__256.prototype.invoke_442 = function ($composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 11 ^ 2) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp = $composer_0;
      Box$composable(Unit_getInstance(), _no_name_provided_$factory_207(composableLambda(tmp, -819895373, true, null, _no_name_provided_$factory_206(this._$game_11))), $composer_0, 0, 1);
      var tmp_0 = $composer_0;
      Box$composable(Unit_getInstance(), _no_name_provided_$factory_209(composableLambda(tmp_0, -819896192, true, null, _no_name_provided_$factory_208(this._$game_11))), $composer_0, 0, 1);
      var tmp_1 = $composer_0;
      Row$composable(Unit_getInstance(), Unit_getInstance(), Unit_getInstance(), _no_name_provided_$factory_211(composableLambda(tmp_1, -819896251, true, null, _no_name_provided_$factory_210(this._$game_11))), $composer_0, 0, 7);
      if (this._$game_11._get_started__0()) {
        $composer_0.startReplaceableGroup_1(-821590863);
        var tmp_2 = size_0(fillMaxHeight(fillMaxWidth(Companion_getInstance_17()), 1.0), _get_dp_(this._$game_11._get_width__0()), _get_dp_(this._$game_11._get_height__0()));
        var tmp_3 = onSizeChanged(tmp_2, _no_name_provided_$factory_212(this._$game_11));
        var tmp_4 = $composer_0;
        Box$composable(tmp_3, _no_name_provided_$factory_214(composableLambda(tmp_4, -819893682, true, null, _no_name_provided_$factory_213(this._$game_11))), $composer_0, 0, 0);
        $composer_0.endReplaceableGroup_0();
      } else {
        $composer_0.startReplaceableGroup_1(-821590431);
        $composer_0.endReplaceableGroup_0();
      }
      LaunchedEffect$composable(Unit_getInstance(), _no_name_provided_$factory_215(this._$game_11, null), $composer_0, 6);
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__256.prototype.invoke_462 = function (p1, p2) {
    var tmp = (p1 == null ? true : isInterface(p1, Composer)) ? p1 : THROW_CCE();
    this.invoke_442(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__256.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__257($game, $$changed) {
    this._$game_12 = $game;
    this._$$changed_13 = $$changed;
  }
  _no_name_provided__257.prototype.invoke_444 = function (p0, p1) {
    return fallingBalls$composable$lambda_0(this._$game_12, this._$$changed_13, p0, p1);
  };
  _no_name_provided__257.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, Composer) : false) ? p1 : THROW_CCE();
    this.invoke_444(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__257.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_203($game) {
    var i = new _no_name_provided__256($game);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_204($boundThis) {
    var i = new _no_name_provided__237($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_205($game, $$changed) {
    var i = new _no_name_provided__257($game, $$changed);
    return function (p1, p2) {
      i.invoke_444(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_206($game) {
    var i = new _no_name_provided__247($game);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_207($boundThis) {
    var i = new _no_name_provided__246($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_208($game) {
    var i = new _no_name_provided__249($game);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_209($boundThis) {
    var i = new _no_name_provided__248($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_210($game) {
    var i = new _no_name_provided__251($game);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_211($boundThis) {
    var i = new _no_name_provided__250($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_212($game) {
    var i = new _no_name_provided__252($game);
    return function (p1) {
      i.invoke_435(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_213($game) {
    var i = new _no_name_provided__254($game);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_214($boundThis) {
    var i = new _no_name_provided__253($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_215($game, resultContinuation) {
    var i = new _no_name_provided__255($game, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_441(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_216($game) {
    var i = new _no_name_provided__238($game);
    return function (p1) {
      i.invoke_407(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_217($game) {
    var i = new _no_name_provided__239($game);
    return function () {
      i.invoke_415();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_218($game) {
    var i = new _no_name_provided__241($game);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_219($boundThis) {
    var i = new _no_name_provided__240($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_220($game) {
    var i = new _no_name_provided__242($game);
    return function () {
      i.invoke_415();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_221($game) {
    var i = new _no_name_provided__244($game);
    return function (p1, p2) {
      i.invoke_442(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_222($boundThis) {
    var i = new _no_name_provided__243($boundThis);
    return function (p1, p2) {
      return i.invoke_437(p1, p2);
    };
  }
  function _no_name_provided_$factory_223($game) {
    var i = new _no_name_provided__245($game);
    return function (p1) {
      i.invoke_421(p1);
      return Unit_getInstance();
    };
  }
  function JsGame() {
    Game.call(this);
    this._$stable_50 = 0;
  }
  JsGame.prototype.now_1 = function () {
    return numberToLong(window.performance.now());
  };
  JsGame.$metadata$ = {
    simpleName: 'JsGame',
    kind: 'class',
    interfaces: []
  };
  function main() {
    var tmp = document.getElementById('root');
    var root = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    renderComposable$composable(root, _no_name_provided_$factory_225(composableLambdaInstance(-985533662, true, null, _no_name_provided_$factory_224(root))));
    Unit_getInstance();
  }
  function _no_name_provided__258($boundThis) {
    this._$boundThis_28 = $boundThis;
  }
  _no_name_provided__258.prototype.invoke_446 = function (p0, p1, p2) {
    return this._$boundThis_28.invoke_170(p0, p1, p2);
  };
  _no_name_provided__258.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, DOMScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_446(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__258.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__259($tmp0_safe_receiver_10_33_65) {
    this._$tmp0_safe_receiver_10_33_65 = $tmp0_safe_receiver_10_33_65;
  }
  _no_name_provided__259.prototype.invoke_448 = function (it) {
    clearCSSRules(this._$tmp0_safe_receiver_10_33_65);
  };
  _no_name_provided__259.prototype.invoke_468 = function (p1) {
    this.invoke_448(p1 instanceof HTMLElement ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__259.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_70() {
  }
  _no_name_provided__1_70.prototype.dispose_2_71 = function () {
    Unit_getInstance();
  };
  _no_name_provided__1_70.prototype.dispose_20 = function () {
    return this.dispose_2_71();
  };
  _no_name_provided__1_70.$metadata$ = {
    simpleName: '<no name provided>_1_70',
    kind: 'class',
    interfaces: [DisposableEffectResult]
  };
  function _no_name_provided__260() {
  }
  _no_name_provided__260.prototype.invoke_450 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__260.prototype.invoke_468 = function (p1) {
    this.invoke_450(p1 instanceof AttrsBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__260.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__261($tmp11_TagElement$composable_0_10, $scope_2_14) {
    this._$tmp11_TagElement$composable_0_10 = $tmp11_TagElement$composable_0_10;
    this._$scope_2_14 = $scope_2_14;
  }
  _no_name_provided__261.prototype.invoke_452 = function () {
    var tmp0_also_0_36 = new DomNodeWrapper(document.createElement(this._$tmp11_TagElement$composable_0_10));
    var tmp0_unsafeCast_0_2_37 = tmp0_also_0_36._node_1;
    this._$scope_2_14._set_element_(tmp0_unsafeCast_0_2_37);
    return tmp0_also_0_36;
  };
  _no_name_provided__261.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__262($boundThis) {
    this._$boundThis_29 = $boundThis;
  }
  _no_name_provided__262.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_29.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__262.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__262.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__263($applyAttrs_1_7, $refEffect_5_24) {
    this._$applyAttrs_1_7 = $applyAttrs_1_7;
    this._$refEffect_5_24 = $refEffect_5_24;
  }
  _no_name_provided__263.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_11_40 = $composer;
    var $dirty_12_41 = $changed;
    if (($changed & 14) === 0)
      $dirty_12_41 = $dirty_12_41 | ($composer_11_40.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_12_41 & 91 ^ 18) === 0) ? true : !$composer_11_40._get_skipping__0()) {
      var tmp0_also_0_43 = new AttrsBuilder();
      this._$applyAttrs_1_7._v(tmp0_also_0_43);
      var attrsApplied_13_42 = tmp0_also_0_43;
      this._$refEffect_5_24._effect_0 = attrsApplied_13_42._refEffect;
      var attrsCollected_15_44 = attrsApplied_13_42.collect();
      var events_16_45 = attrsApplied_13_42.asList_0();
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__17_1_46 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__17_1_46, attrsCollected_15_44, Companion_getInstance_19()._UpdateAttrs);
      Updater__set_impl(tmp1__anonymous__17_1_46, events_16_45, Companion_getInstance_19()._UpdateListeners);
      Updater__set_impl(tmp1__anonymous__17_1_46, attrsApplied_13_42._propertyUpdates, Companion_getInstance_19()._UpdateProperties);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_11_40.skipToGroupEnd_2();
  };
  _no_name_provided__263.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__263.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__264($boundThis) {
    this._$boundThis_30 = $boundThis;
  }
  _no_name_provided__264.prototype.invoke_457 = function (p0, p1, p2) {
    return this._$boundThis_30.invoke_170(new SkippableUpdater(p0), p1, p2);
  };
  _no_name_provided__264.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? isInterface(p2, Composer) : false) ? p2 : THROW_CCE();
    return this.invoke_457(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__264.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__265() {
  }
  _no_name_provided__265.prototype.invoke_459 = function ($this$ComposeDomNode, $composer, $changed) {
    var $composer_19_49 = $composer;
    var $dirty_20_50 = $changed;
    if (($changed & 14) === 0)
      $dirty_20_50 = $dirty_20_50 | ($composer_19_49.changed_2(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode)) ? 4 : 2);
    if (!(($dirty_20_50 & 91 ^ 18) === 0) ? true : !$composer_19_49._get_skipping__0()) {
      var tmp0_apply_0_52 = new StyleBuilderImpl();
      var tmp$ret$0;
      l$ret$1: do {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }
       while (false);
      var style_21_51 = tmp0_apply_0_52;
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).startReplaceableGroup_1(509942095);
      var tmp1__anonymous__22_1_53 = _Updater___init__impl_(_SkippableUpdater___get_composer__impl_($this$ComposeDomNode));
      Updater__set_impl(tmp1__anonymous__22_1_53, style_21_51, Companion_getInstance_19()._UpdateStyleDeclarations);
      _SkippableUpdater___get_composer__impl_($this$ComposeDomNode).endReplaceableGroup_0();
    } else
      $composer_19_49.skipToGroupEnd_2();
  };
  _no_name_provided__265.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = p1 instanceof SkippableUpdater ? p1._composer : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_459(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__265.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__266($tmp17_Style$composable_0_3) {
    this._$tmp17_Style$composable_0_3 = $tmp17_Style$composable_0_3;
  }
  _no_name_provided__266.prototype.invoke_461 = function ($this$DomSideEffect, style) {
    var tmp0_safe_receiver_10_33_65 = style.sheet;
    if (tmp0_safe_receiver_10_33_65 == null)
      null;
    else {
      setCSSRules(tmp0_safe_receiver_10_33_65, this._$tmp17_Style$composable_0_3);
      $this$DomSideEffect.onDispose_0(_no_name_provided_$factory_234(tmp0_safe_receiver_10_33_65));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__266.prototype.invoke_462 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, DomEffectScope) : false) ? p1 : THROW_CCE();
    this.invoke_461(tmp, p2 instanceof HTMLStyleElement ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__266.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__267($refEffect_5_24, $scope_2_14) {
    this._$refEffect_5_24_0 = $refEffect_5_24;
    this._$scope_2_14_0 = $scope_2_14;
  }
  _no_name_provided__267.prototype.invoke_463 = function ($this$DisposableEffect) {
    var tmp0_safe_receiver_25_69 = this._$refEffect_5_24_0._effect_0;
    var tmp1_elvis_lhs_24_68 = tmp0_safe_receiver_25_69 == null ? null : tmp0_safe_receiver_25_69($this$DisposableEffect, this._$scope_2_14_0._get_element__0());
    var tmp;
    if (tmp1_elvis_lhs_24_68 == null) {
      tmp = new _no_name_provided__1_70();
    } else {
      tmp = tmp1_elvis_lhs_24_68;
    }
    return tmp;
  };
  _no_name_provided__267.prototype.invoke_468 = function (p1) {
    return this.invoke_463(p1 instanceof DisposableEffectScope ? p1 : THROW_CCE());
  };
  _no_name_provided__267.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__268($root) {
    this._$root = $root;
  }
  _no_name_provided__268.prototype.invoke_465 = function ($this$renderComposable, $composer, $changed) {
    var $composer_0 = $composer;
    if (!(($changed & 81 ^ 16) === 0) ? true : !$composer_0._get_skipping__0()) {
      var tmp0_Style$composable_0 = Styles_getInstance();
      var tmp1_Style$composable_0 = $composer_0;
      var tmp2_Style$composable_0 = 8;
      var $composer_1 = tmp1_Style$composable_0;
      $composer_1.startReplaceableGroup_2(-992065845, 'C(Style$composable)131@4451L37:StyleSheet.kt#ey5h4o');
      var tmp16_Style$composable_0_2 = null;
      var tmp17_Style$composable_0_3 = tmp0_Style$composable_0._get_cssRules__4();
      var tmp18_Style$composable_0_4 = $composer_1;
      var tmp19_Style$composable_0_5 = 0;
      var tmp20_Style$composable_0_6 = 1;
      var applyAttrs_1_7 = {_v: Unit_getInstance()};
      var $composer_2_8 = tmp18_Style$composable_0_4;
      $composer_2_8.startReplaceableGroup_2(-959164933, 'C(Style$composable)67@2388L403:Style.kt#mzr94e');
      if (!((tmp20_Style$composable_0_6 & 1) === 0)) {
        applyAttrs_1_7._v = _no_name_provided_$factory_226();
      }var tmp11_TagElement$composable_0_10 = 'style';
      var tmp12_TagElement$composable_0_11 = $composer_2_8;
      var tmp13_TagElement$composable_0_12 = 6;
      var $composer_1_13 = tmp12_TagElement$composable_0_11;
      $composer_1_13.startReplaceableGroup_2(-1134585235, 'C(TagElement$composable)P(3)76@2833L45,77@2899L37,79@2942L1040,107@3988L100:Base.kt#mzr94e');
      var tmp0_remember$composable_0_15 = $composer_1_13;
      var tmp1_remember$composable_0_16 = 0;
      var $composer_1_17 = tmp0_remember$composable_0_15;
      $composer_1_17.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_19 = $composer_1_17;
      var tmp2_cache_0_4_20 = false;
      var tmp0_let_0_5_21 = tmp1_cache_0_3_19.rememberedValue_0();
      var tmp;
      if (tmp2_cache_0_4_20 ? true : tmp0_let_0_5_21 === Companion_getInstance_11()._Empty) {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_return_4_8_23 = new ElementScopeImpl();
          tmp$ret$0 = tmp0_return_4_8_23;
          break l$ret$1;
        }
         while (false);
        var value_2_2_6_22 = tmp$ret$0;
        tmp1_cache_0_3_19.updateRememberedValue_0(value_2_2_6_22);
        tmp = value_2_2_6_22;
      } else {
        tmp = tmp0_let_0_5_21;
      }
      var tmp_0 = tmp;
      var tmp0_2_18 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      $composer_1_17.endReplaceableGroup_0();
      var scope_2_14 = tmp0_2_18;
      var tmp2_remember$composable_0_25 = $composer_1_13;
      var tmp3_remember$composable_0_26 = 0;
      var $composer_1_27 = tmp2_remember$composable_0_25;
      $composer_1_27.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3_29 = $composer_1_27;
      var tmp2_cache_0_4_30 = false;
      var tmp0_let_0_5_31 = tmp1_cache_0_3_29.rememberedValue_0();
      var tmp_1;
      if (tmp2_cache_0_4_30 ? true : tmp0_let_0_5_31 === Companion_getInstance_11()._Empty) {
        var tmp$ret$2;
        l$ret$3: do {
          var tmp0_return_7_8_33 = DisposableEffectHolder_init_$Create$(null, 1, null);
          tmp$ret$2 = tmp0_return_7_8_33;
          break l$ret$3;
        }
         while (false);
        var value_2_2_6_32 = tmp$ret$2;
        tmp1_cache_0_3_29.updateRememberedValue_0(value_2_2_6_32);
        tmp_1 = value_2_2_6_32;
      } else {
        tmp_1 = tmp0_let_0_5_31;
      }
      var tmp_2 = tmp_1;
      var tmp0_2_28 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
      $composer_1_27.endReplaceableGroup_0();
      var refEffect_5_24 = tmp0_2_28;
      var tmp6_ComposeDomNode$composable_0_34 = _no_name_provided_$factory_227(tmp11_TagElement$composable_0_10, scope_2_14);
      var tmp_3 = $composer_1_13;
      var tmp7_ComposeDomNode$composable_0_38 = _no_name_provided_$factory_229(composableLambda(tmp_3, -819893738, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_228(applyAttrs_1_7, refEffect_5_24)));
      var tmp_4 = $composer_1_13;
      var tmp8_ComposeDomNode$composable_0_47 = _no_name_provided_$factory_231(composableLambda(tmp_4, -819894225, true, 'C:Base.kt#mzr94e', _no_name_provided_$factory_230()));
      var tmp9_ComposeDomNode$composable_0_54 = $composer_1_13;
      var tmp10_ComposeDomNode$composable_0_55 = 64 | 57344 & tmp13_TagElement$composable_0_12 << 3;
      var $composer_1_56 = tmp9_ComposeDomNode$composable_0_54;
      var tmp_5 = $composer_1_56._get_applier__0();
      if (!(tmp_5 instanceof DomApplier)) {
        var tmp4_error_0_57 = 'Invalid applier';
        throw IllegalStateException_init_$Create$(toString_1(tmp4_error_0_57));
      } else {
      }
      $composer_1_56.startNode_2();
      if ($composer_1_56._get_inserting__0()) {
        $composer_1_56.createNode_0(tmp6_ComposeDomNode$composable_0_34);
      } else {
        $composer_1_56.useNode_0();
      }
      var tmp5_apply_0_59 = _SkippableUpdater___init__impl_($composer_1_56);
      tmp7_ComposeDomNode$composable_0_38(new SkippableUpdater(tmp5_apply_0_59), $composer_1_56, 112 & tmp10_ComposeDomNode$composable_0_55 >> 3);
      tmp8_ComposeDomNode$composable_0_47(new SkippableUpdater(tmp5_apply_0_59), $composer_1_56, 112 & tmp10_ComposeDomNode$composable_0_55 >> 6);
      var tmp0_group_2_58 = tmp5_apply_0_59;
      Unit_getInstance();
      $composer_1_56.startReplaceableGroup_1(2058660585);
      var tmp14__anonymous__6_29_60 = $composer_1_56;
      var tmp15__anonymous__6_29_61 = 8 & tmp10_ComposeDomNode$composable_0_55 >> 3 | 14 & tmp10_ComposeDomNode$composable_0_55 >> 3 | 112 & tmp10_ComposeDomNode$composable_0_55 >> 9;
      var $composer_7_30_62 = tmp14__anonymous__6_29_60;
      $composer_7_30_62.startReplaceableGroup_2(-1124549824, 'C74@2555L230:Style.kt#mzr94e');
      var $dirty_8_31_63 = tmp15__anonymous__6_29_61;
      if ((tmp15__anonymous__6_29_61 & 14) === 0)
        $dirty_8_31_63 = $dirty_8_31_63 | ($composer_7_30_62.changed_2(scope_2_14) ? 4 : 2);
      if (!(($dirty_8_31_63 & 91 ^ 18) === 0) ? true : !$composer_7_30_62._get_skipping__0()) {
        scope_2_14.DomSideEffect$composable_1(tmp17_Style$composable_0_3, _no_name_provided_$factory_232(tmp17_Style$composable_0_3), $composer_7_30_62, 14 & tmp19_Style$composable_0_5 >> 3 | 896 & $dirty_8_31_63 << 6);
      } else
        $composer_7_30_62.skipToGroupEnd_2();
      $composer_7_30_62.endReplaceableGroup_0();
      $composer_1_56.endReplaceableGroup_0();
      $composer_1_56.endNode_0();
      DisposableEffect$composable(null, _no_name_provided_$factory_233(refEffect_5_24, scope_2_14), $composer_1_13, 6);
      $composer_1_13.endReplaceableGroup_0();
      $composer_2_8.endReplaceableGroup_0();
      $composer_1.endReplaceableGroup_0();
      var tmp3_remember$composable_0 = $composer_0;
      var tmp4_remember$composable_0 = 0;
      var $composer_1_0 = tmp3_remember$composable_0;
      $composer_1_0.startReplaceableGroup_2(884179600, 'C(remember$composable):Composables.kt#9igjgp');
      var tmp1_cache_0_3 = $composer_1_0;
      var tmp2_cache_0_4 = false;
      var tmp0_let_0_5 = tmp1_cache_0_3.rememberedValue_0();
      var tmp_6;
      if (tmp2_cache_0_4 ? true : tmp0_let_0_5 === Companion_getInstance_11()._Empty) {
        var tmp$ret$4;
        l$ret$5: do {
          var tmp0_apply_0_9 = new JsGame();
          tmp0_apply_0_9._set_width__0(this._$root.offsetWidth);
          tmp0_apply_0_9._set_height__0(this._$root.offsetHeight);
          var tmp0_return_8 = tmp0_apply_0_9;
          tmp$ret$4 = tmp0_return_8;
          break l$ret$5;
        }
         while (false);
        var value_2_2_6 = tmp$ret$4;
        tmp1_cache_0_3.updateRememberedValue_0(value_2_2_6);
        tmp_6 = value_2_2_6;
      } else {
        tmp_6 = tmp0_let_0_5;
      }
      var tmp_7 = tmp_6;
      var tmp0_2 = (tmp_7 == null ? true : isObject(tmp_7)) ? tmp_7 : THROW_CCE();
      $composer_1_0.endReplaceableGroup_0();
      var game = tmp0_2;
      fallingBalls$composable(game, $composer_0, 0);
    } else
      $composer_0.skipToGroupEnd_2();
  };
  _no_name_provided__268.prototype.invoke_466 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? isInterface(p1, DOMScope) : false) ? p1 : THROW_CCE();
    var tmp_0 = (p2 == null ? true : isInterface(p2, Composer)) ? p2 : THROW_CCE();
    this.invoke_465(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__268.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_224($root) {
    var i = new _no_name_provided__268($root);
    return function (p1, p2, p3) {
      i.invoke_465(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_225($boundThis) {
    var i = new _no_name_provided__258($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_446(p1, p2, p3);
    };
  }
  function _no_name_provided_$factory_226() {
    var i = new _no_name_provided__260();
    return function (p1) {
      i.invoke_450(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_227($tmp11_TagElement$composable_0_10, $scope_2_14) {
    var i = new _no_name_provided__261($tmp11_TagElement$composable_0_10, $scope_2_14);
    return function () {
      return i.invoke_452();
    };
  }
  function _no_name_provided_$factory_228($applyAttrs_1_7, $refEffect_5_24) {
    var i = new _no_name_provided__263($applyAttrs_1_7, $refEffect_5_24);
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_229($boundThis) {
    var i = new _no_name_provided__262($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_230() {
    var i = new _no_name_provided__265();
    return function (p1, p2, p3) {
      i.invoke_459(p1._composer, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_231($boundThis) {
    var i = new _no_name_provided__264($boundThis);
    return function (p1, p2, p3) {
      return i.invoke_457(p1._composer, p2, p3);
    };
  }
  function _no_name_provided_$factory_232($tmp17_Style$composable_0_3) {
    var i = new _no_name_provided__266($tmp17_Style$composable_0_3);
    return function (p1, p2) {
      i.invoke_461(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_233($refEffect_5_24, $scope_2_14) {
    var i = new _no_name_provided__267($refEffect_5_24, $scope_2_14);
    return function (p1) {
      return i.invoke_463(p1);
    };
  }
  function _no_name_provided_$factory_234($tmp0_safe_receiver_10_33_65) {
    var i = new _no_name_provided__259($tmp0_safe_receiver_10_33_65);
    return function (p1) {
      i.invoke_448(p1);
      return Unit_getInstance();
    };
  }
  function position$composable(_this_, width_2, height_1, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.startReplaceableGroup_2(-954142852, 'C(position$composable)P(1)');
    var tmp0_apply_0 = castOrCreate(_this_);
    tmp0_apply_0.add_52(_no_name_provided_$factory_235(height_1, width_2));
    var tmp0 = tmp0_apply_0;
    $composer_0.endReplaceableGroup_0();
    return tmp0;
  }
  function _no_name_provided__269($height, $width) {
    this._$height_0 = $height;
    this._$width_0 = $width;
  }
  _no_name_provided__269.prototype.invoke_467 = function ($this$add) {
    position($this$add, Position_Absolute_getInstance());
    top($this$add, _get_px_(this._$height_0._value_8));
    left($this$add, _get_px_(this._$width_0._value_8));
  };
  _no_name_provided__269.prototype.invoke_468 = function (p1) {
    this.invoke_467((!(p1 == null) ? isInterface(p1, StyleBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__269.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_235($height, $width) {
    var i = new _no_name_provided__269($height, $width);
    return function (p1) {
      i.invoke_467(p1);
      return Unit_getInstance();
    };
  }
  AbstractMap.prototype._get_entries__5 = Map_0.prototype._get_entries__5;
  CombinedContext.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  AbstractCoroutineContextElement.prototype.get_56 = Element_0.prototype.get_56;
  AbstractCoroutineContextElement.prototype.fold_24 = Element_0.prototype.fold_24;
  AbstractCoroutineContextElement.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  AbstractCoroutineContextElement.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  IntIterator.prototype.hasNext_27 = Iterator.prototype.hasNext_27;
  AbstractMutableList.prototype.get_66 = List.prototype.get_66;
  AbstractMutableMap.prototype._get_entries__5 = MutableMap.prototype._get_entries__5;
  InternalHashCodeMap.prototype.createJsMap_0 = InternalMap.prototype.createJsMap_0;
  KClassImpl.prototype._get_simpleName__4 = KClass.prototype._get_simpleName__4;
  JobSupport.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  JobSupport.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  JobSupport.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  JobSupport.prototype.get_56 = Element_0.prototype.get_56;
  JobSupport.prototype.fold_24 = Element_0.prototype.fold_24;
  JobSupport.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  AbstractCoroutine.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  AbstractCoroutine.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  AbstractCoroutine.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  AbstractCoroutine.prototype.get_56 = Element_0.prototype.get_56;
  AbstractCoroutine.prototype.fold_24 = Element_0.prototype.fold_24;
  AbstractCoroutine.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  StandaloneCoroutine.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  StandaloneCoroutine.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  StandaloneCoroutine.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  StandaloneCoroutine.prototype.get_56 = Element_0.prototype.get_56;
  StandaloneCoroutine.prototype.fold_24 = Element_0.prototype.fold_24;
  StandaloneCoroutine.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  LazyStandaloneCoroutine.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  LazyStandaloneCoroutine.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  LazyStandaloneCoroutine.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  LazyStandaloneCoroutine.prototype.get_56 = Element_0.prototype.get_56;
  LazyStandaloneCoroutine.prototype.fold_24 = Element_0.prototype.fold_24;
  LazyStandaloneCoroutine.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  ScopeCoroutine.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  ScopeCoroutine.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  ScopeCoroutine.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  ScopeCoroutine.prototype.get_56 = Element_0.prototype.get_56;
  ScopeCoroutine.prototype.fold_24 = Element_0.prototype.fold_24;
  ScopeCoroutine.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  DispatchedCoroutine.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  DispatchedCoroutine.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  DispatchedCoroutine.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  DispatchedCoroutine.prototype.get_56 = Element_0.prototype.get_56;
  DispatchedCoroutine.prototype.fold_24 = Element_0.prototype.fold_24;
  DispatchedCoroutine.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  SchedulerTask.prototype.run_3 = Runnable.prototype.run_3;
  CancellableContinuationImpl.prototype.cancel$default_4 = CancellableContinuation.prototype.cancel$default_4;
  CoroutineDispatcher.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  CoroutineDispatcher.prototype.fold_24 = Element_0.prototype.fold_24;
  CoroutineDispatcher.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  CoroutineDispatcher.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  EventLoop.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  EventLoop.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  EventLoop.prototype.fold_24 = Element_0.prototype.fold_24;
  EventLoop.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  JobImpl.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  JobImpl.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  JobImpl.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  JobImpl.prototype.get_56 = Element_0.prototype.get_56;
  JobImpl.prototype.fold_24 = Element_0.prototype.fold_24;
  JobImpl.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  MainCoroutineDispatcher.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  MainCoroutineDispatcher.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  MainCoroutineDispatcher.prototype.fold_24 = Element_0.prototype.fold_24;
  MainCoroutineDispatcher.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  SupervisorJobImpl.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  SupervisorJobImpl.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  SupervisorJobImpl.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  SupervisorJobImpl.prototype.get_56 = Element_0.prototype.get_56;
  SupervisorJobImpl.prototype.fold_24 = Element_0.prototype.fold_24;
  SupervisorJobImpl.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  Unconfined.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  Unconfined.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  Unconfined.prototype.fold_24 = Element_0.prototype.fold_24;
  Unconfined.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  UndispatchedCoroutine.prototype.invokeOnCompletion$default_8 = Job.prototype.invokeOnCompletion$default_8;
  UndispatchedCoroutine.prototype.cancel$default_10 = Job.prototype.cancel$default_10;
  UndispatchedCoroutine.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  UndispatchedCoroutine.prototype.get_56 = Element_0.prototype.get_56;
  UndispatchedCoroutine.prototype.fold_24 = Element_0.prototype.fold_24;
  UndispatchedCoroutine.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  JsMainDispatcher.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  JsMainDispatcher.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  JsMainDispatcher.prototype.fold_24 = Element_0.prototype.fold_24;
  JsMainDispatcher.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  UnconfinedEventLoop.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  UnconfinedEventLoop.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  UnconfinedEventLoop.prototype.fold_24 = Element_0.prototype.fold_24;
  UnconfinedEventLoop.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  SetTimeoutBasedDispatcher.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  SetTimeoutBasedDispatcher.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  SetTimeoutBasedDispatcher.prototype.fold_24 = Element_0.prototype.fold_24;
  SetTimeoutBasedDispatcher.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  NodeDispatcher.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  NodeDispatcher.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  NodeDispatcher.prototype.fold_24 = Element_0.prototype.fold_24;
  NodeDispatcher.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  SetTimeoutDispatcher.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  SetTimeoutDispatcher.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  SetTimeoutDispatcher.prototype.fold_24 = Element_0.prototype.fold_24;
  SetTimeoutDispatcher.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  WindowDispatcher.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  WindowDispatcher.prototype.get_56 = ContinuationInterceptor.prototype.get_56;
  WindowDispatcher.prototype.fold_24 = Element_0.prototype.fold_24;
  WindowDispatcher.prototype.minusKey_25 = ContinuationInterceptor.prototype.minusKey_25;
  AbstractListIterator.prototype.next_28 = ListIterator.prototype.next_28;
  AbstractListIterator.prototype.previous_7 = ListIterator.prototype.previous_7;
  AbstractPersistentList.prototype.add_37 = PersistentList.prototype.add_37;
  AbstractPersistentList.prototype.add_31 = PersistentList.prototype.add_31;
  AbstractPersistentList.prototype.set_13 = PersistentList.prototype.set_13;
  AbstractPersistentList.prototype.removeAt_7 = PersistentList.prototype.removeAt_7;
  TrieNodeBaseIterator.prototype.next_28 = Iterator.prototype.next_28;
  AbstractApplier.prototype.onBeginChanges_1 = Applier.prototype.onBeginChanges_1;
  AbstractApplier.prototype.onEndChanges_1 = Applier.prototype.onEndChanges_1;
  AbstractApplier.prototype.insertTopDown_2 = Applier.prototype.insertTopDown_2;
  AbstractApplier.prototype.insertBottomUp_2 = Applier.prototype.insertBottomUp_2;
  AbstractApplier.prototype.remove_54 = Applier.prototype.remove_54;
  AbstractApplier.prototype.move_2 = Applier.prototype.move_2;
  BroadcastFrameClock.prototype._get_key__28 = MonotonicFrameClock.prototype._get_key__28;
  BroadcastFrameClock.prototype.get_56 = Element_0.prototype.get_56;
  BroadcastFrameClock.prototype.fold_24 = Element_0.prototype.fold_24;
  BroadcastFrameClock.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  BroadcastFrameClock.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  StructuralEqualityPolicy.prototype.merge = SnapshotMutationPolicy.prototype.merge;
  SnapshotStateList.prototype.mergeRecords_1 = StateObject.prototype.mergeRecords_1;
  MonotonicClockImpl.prototype._get_key__28 = MonotonicFrameClock.prototype._get_key__28;
  MonotonicClockImpl.prototype.get_56 = Element_0.prototype.get_56;
  MonotonicClockImpl.prototype.fold_24 = Element_0.prototype.fold_24;
  MonotonicClockImpl.prototype.minusKey_25 = Element_0.prototype.minusKey_25;
  MonotonicClockImpl.prototype.plus_25 = CoroutineContext.prototype.plus_25;
  DomApplier.prototype.onBeginChanges_1 = Applier.prototype.onBeginChanges_1;
  DomApplier.prototype.onEndChanges_1 = Applier.prototype.onEndChanges_1;
  CSSRulesHolderState.prototype.add_51 = CSSRulesHolder.prototype.add_51;
  StyleSheetBuilderImpl.prototype.add_51 = CSSRulesHolder.prototype.add_51;
  _stableSortingIsSupported = null;
  INV_2_26 = INV_2_26$init$();
  INV_2_53 = INV_2_53$init$();
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  propertyRefClassMetadataCache = propertyRefClassMetadataCache$init$();
  COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
  COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
  COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
  TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
  SEALED = new Symbol('SEALED');
  EMPTY_NEW = new Empty(false);
  EMPTY_ACTIVE = new Empty(true);
  NONE = new Symbol('NONE');
  PENDING = new Symbol('PENDING');
  NULL = new Symbol('NULL');
  UNDEFINED = new Symbol('UNDEFINED');
  REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  counter = 0;
  DEBUG = false;
  removeCurrentGroupInstance = removeCurrentGroupInstance$init$();
  endGroupInstance = endGroupInstance$init$();
  startRootGroup = startRootGroup$init$();
  invocation = new OpaqueKey('provider');
  provider = new OpaqueKey('provider');
  compositionLocalMap = new OpaqueKey('compositionLocalMap');
  providerValues = new OpaqueKey('providerValues');
  providerMaps = new OpaqueKey('providers');
  reference = new OpaqueKey('reference');
  PendingApplyNoModifications = new Object();
  EmptyCompositionLocalMap = persistentHashMapOf();
  InternalDisposableEffectScope = new DisposableEffectScope();
  ProduceAnotherFrame = new Object();
  FramePending = new Object();
  liveLiteralCache = HashMap_init_$Create$();
  isLiveLiteralsEnabled = false;
  emptyLambda = emptyLambda$init$();
  threadSnapshot = new SnapshotThreadLocal();
  lock = new Object();
  openSnapshots = Companion_getInstance_14()._EMPTY_4;
  nextSnapshotId = 1;
  applyObservers = applyObservers$init$();
  globalWriteObservers = globalWriteObservers$init$();
  currentGlobalSnapshot = currentGlobalSnapshot$init$();
  snapshotInitializer = currentGlobalSnapshot.get_55();
  LocalInspectionTables = staticCompositionLocalOf(_no_name_provided_$factory_78());
  nextHash = 1;
  DefaultMonotonicFrameClock = new MonotonicClockImpl();
  setInputValue = setInputValue$init$();
  setClassList = setClassList$init$();
  cssTypedOMPolyfill = CSSTypedOMPolyfill.default(window);
  auto = auto$init$();
  main();
  return _;
}));
